// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  DeleteAdminAccessGrantsByIdData,
  DeleteAdminAccessGrantsByIdErrors,
  DeleteAdminAccessGrantsByIdResponses,
  DeleteAdminAgentDeploymentsByIdData,
  DeleteAdminAgentDeploymentsByIdErrors,
  DeleteAdminAgentDeploymentsByIdResponses,
  DeleteAdminAgentsByIdData,
  DeleteAdminAgentsByIdErrors,
  DeleteAdminAgentsByIdResponses,
  DeleteAdminAgentsByIdTrainingExamplesByExampleIdData,
  DeleteAdminAgentsByIdTrainingExamplesByExampleIdErrors,
  DeleteAdminAgentsByIdTrainingExamplesByExampleIdResponses,
  DeleteAdminAgentSoulsByIdData,
  DeleteAdminAgentSoulsByIdErrors,
  DeleteAdminAgentSoulsByIdResponses,
  DeleteAdminAgentVersionsByIdData,
  DeleteAdminAgentVersionsByIdErrors,
  DeleteAdminAgentVersionsByIdResponses,
  DeleteAdminAiConversationsByIdData,
  DeleteAdminAiConversationsByIdErrors,
  DeleteAdminAiConversationsByIdResponses,
  DeleteAdminAiGraphNodesByIdData,
  DeleteAdminAiGraphNodesByIdErrors,
  DeleteAdminAiGraphNodesByIdResponses,
  DeleteAdminAiMessagesByIdData,
  DeleteAdminAiMessagesByIdErrors,
  DeleteAdminAiMessagesByIdResponses,
  DeleteAdminApiKeysByIdData,
  DeleteAdminApiKeysByIdErrors,
  DeleteAdminApiKeysByIdResponses,
  DeleteAdminApplicationsByApplicationIdEmailTemplatesBySlugData,
  DeleteAdminApplicationsByApplicationIdEmailTemplatesBySlugErrors,
  DeleteAdminApplicationsByApplicationIdEmailTemplatesBySlugResponses,
  DeleteAdminApplicationsByIdData,
  DeleteAdminApplicationsByIdErrors,
  DeleteAdminApplicationsByIdResponses,
  DeleteAdminBrandIdentitiesByIdData,
  DeleteAdminBrandIdentitiesByIdErrors,
  DeleteAdminBrandIdentitiesByIdResponses,
  DeleteAdminBucketsByIdData,
  DeleteAdminBucketsByIdErrors,
  DeleteAdminBucketsByIdResponses,
  DeleteAdminCampaignsSequencesByIdData,
  DeleteAdminCampaignsSequencesByIdErrors,
  DeleteAdminCampaignsSequencesByIdResponses,
  DeleteAdminCampaignsSequenceStepsByIdData,
  DeleteAdminCampaignsSequenceStepsByIdErrors,
  DeleteAdminCampaignsSequenceStepsByIdResponses,
  DeleteAdminCaseDocumentLinksByIdData,
  DeleteAdminCaseDocumentLinksByIdErrors,
  DeleteAdminCaseDocumentLinksByIdResponses,
  DeleteAdminCaseEntityLinksByIdData,
  DeleteAdminCaseEntityLinksByIdErrors,
  DeleteAdminCaseEntityLinksByIdResponses,
  DeleteAdminCasesByIdData,
  DeleteAdminCasesByIdErrors,
  DeleteAdminCasesByIdResponses,
  DeleteAdminCaseTypesByIdData,
  DeleteAdminCaseTypesByIdErrors,
  DeleteAdminCaseTypesByIdResponses,
  DeleteAdminCatalogOptionTypesByIdData,
  DeleteAdminCatalogOptionTypesByIdErrors,
  DeleteAdminCatalogOptionTypesByIdResponses,
  DeleteAdminCatalogOptionValuesByIdData,
  DeleteAdminCatalogOptionValuesByIdErrors,
  DeleteAdminCatalogOptionValuesByIdResponses,
  DeleteAdminCatalogPriceListEntriesByIdData,
  DeleteAdminCatalogPriceListEntriesByIdErrors,
  DeleteAdminCatalogPriceListEntriesByIdResponses,
  DeleteAdminCatalogPriceListsByIdData,
  DeleteAdminCatalogPriceListsByIdErrors,
  DeleteAdminCatalogPriceListsByIdResponses,
  DeleteAdminCatalogProductClassificationsByIdData,
  DeleteAdminCatalogProductClassificationsByIdErrors,
  DeleteAdminCatalogProductClassificationsByIdResponses,
  DeleteAdminCatalogProductsByIdData,
  DeleteAdminCatalogProductsByIdErrors,
  DeleteAdminCatalogProductsByIdResponses,
  DeleteAdminCatalogProductVariantsByIdData,
  DeleteAdminCatalogProductVariantsByIdErrors,
  DeleteAdminCatalogProductVariantsByIdResponses,
  DeleteAdminCatalogTaxonomiesByIdData,
  DeleteAdminCatalogTaxonomiesByIdErrors,
  DeleteAdminCatalogTaxonomiesByIdResponses,
  DeleteAdminCatalogTaxonomyNodesByIdData,
  DeleteAdminCatalogTaxonomyNodesByIdErrors,
  DeleteAdminCatalogTaxonomyNodesByIdResponses,
  DeleteAdminCatalogVariantOptionValuesByIdData,
  DeleteAdminCatalogVariantOptionValuesByIdErrors,
  DeleteAdminCatalogVariantOptionValuesByIdResponses,
  DeleteAdminCatalogViewOverridesByIdData,
  DeleteAdminCatalogViewOverridesByIdErrors,
  DeleteAdminCatalogViewOverridesByIdResponses,
  DeleteAdminCatalogViewRulesByIdData,
  DeleteAdminCatalogViewRulesByIdErrors,
  DeleteAdminCatalogViewRulesByIdResponses,
  DeleteAdminCatalogViewsByIdData,
  DeleteAdminCatalogViewsByIdErrors,
  DeleteAdminCatalogViewsByIdResponses,
  DeleteAdminCdeScopeReportsByIdData,
  DeleteAdminCdeScopeReportsByIdErrors,
  DeleteAdminCdeScopeReportsByIdResponses,
  DeleteAdminClaimedDomainsByIdData,
  DeleteAdminClaimedDomainsByIdErrors,
  DeleteAdminClaimedDomainsByIdResponses,
  DeleteAdminClinicalClientGoalsByIdPermanentData,
  DeleteAdminClinicalClientGoalsByIdPermanentErrors,
  DeleteAdminClinicalClientGoalsByIdPermanentResponses,
  DeleteAdminClinicalClientMedicationsByIdPermanentData,
  DeleteAdminClinicalClientMedicationsByIdPermanentErrors,
  DeleteAdminClinicalClientMedicationsByIdPermanentResponses,
  DeleteAdminClinicalClientResourceAssignmentsByIdPermanentData,
  DeleteAdminClinicalClientResourceAssignmentsByIdPermanentErrors,
  DeleteAdminClinicalClientResourceAssignmentsByIdPermanentResponses,
  DeleteAdminClinicalClientSupplementsByIdPermanentData,
  DeleteAdminClinicalClientSupplementsByIdPermanentErrors,
  DeleteAdminClinicalClientSupplementsByIdPermanentResponses,
  DeleteAdminClinicalDocumentsByIdData,
  DeleteAdminClinicalDocumentsByIdErrors,
  DeleteAdminClinicalDocumentsByIdResponses,
  DeleteAdminClinicalGoalAssociationsByIdData,
  DeleteAdminClinicalGoalAssociationsByIdErrors,
  DeleteAdminClinicalGoalAssociationsByIdResponses,
  DeleteAdminClinicalGoalTemplateCollectionMembershipsByIdData,
  DeleteAdminClinicalGoalTemplateCollectionMembershipsByIdErrors,
  DeleteAdminClinicalGoalTemplateCollectionMembershipsByIdResponses,
  DeleteAdminClinicalGoalTemplateCollectionsByIdData,
  DeleteAdminClinicalGoalTemplateCollectionsByIdErrors,
  DeleteAdminClinicalGoalTemplateCollectionsByIdResponses,
  DeleteAdminClinicalGoalTemplatesByIdPermanentData,
  DeleteAdminClinicalGoalTemplatesByIdPermanentErrors,
  DeleteAdminClinicalGoalTemplatesByIdPermanentResponses,
  DeleteAdminClinicalGoalTemplatesCatalogByIdPermanentData,
  DeleteAdminClinicalGoalTemplatesCatalogByIdPermanentErrors,
  DeleteAdminClinicalGoalTemplatesCatalogByIdPermanentResponses,
  DeleteAdminClinicalHealthMetricsByIdPermanentData,
  DeleteAdminClinicalHealthMetricsByIdPermanentErrors,
  DeleteAdminClinicalHealthMetricsByIdPermanentResponses,
  DeleteAdminClinicalInsuranceAuthorizationsByIdData,
  DeleteAdminClinicalInsuranceAuthorizationsByIdErrors,
  DeleteAdminClinicalInsuranceAuthorizationsByIdResponses,
  DeleteAdminClinicalIntakeTargetsByIdPermanentData,
  DeleteAdminClinicalIntakeTargetsByIdPermanentErrors,
  DeleteAdminClinicalIntakeTargetsByIdPermanentResponses,
  DeleteAdminClinicalMealPlansByIdPermanentData,
  DeleteAdminClinicalMealPlansByIdPermanentErrors,
  DeleteAdminClinicalMealPlansByIdPermanentResponses,
  DeleteAdminClinicalNotesByIdPermanentData,
  DeleteAdminClinicalNotesByIdPermanentErrors,
  DeleteAdminClinicalNotesByIdPermanentResponses,
  DeleteAdminClinicalNoteTemplatesByIdPermanentData,
  DeleteAdminClinicalNoteTemplatesByIdPermanentErrors,
  DeleteAdminClinicalNoteTemplatesByIdPermanentResponses,
  DeleteAdminClinicalNoteTemplatesCatalogByIdPermanentData,
  DeleteAdminClinicalNoteTemplatesCatalogByIdPermanentErrors,
  DeleteAdminClinicalNoteTemplatesCatalogByIdPermanentResponses,
  DeleteAdminClinicalPatientInsuranceByIdData,
  DeleteAdminClinicalPatientInsuranceByIdErrors,
  DeleteAdminClinicalPatientInsuranceByIdResponses,
  DeleteAdminClinicalPatientsByIdData,
  DeleteAdminClinicalPatientsByIdErrors,
  DeleteAdminClinicalPatientsByIdResponses,
  DeleteAdminClinicalPracticeResourcesByIdPermanentData,
  DeleteAdminClinicalPracticeResourcesByIdPermanentErrors,
  DeleteAdminClinicalPracticeResourcesByIdPermanentResponses,
  DeleteAdminClinicalPracticeResourcesCatalogByIdPermanentData,
  DeleteAdminClinicalPracticeResourcesCatalogByIdPermanentErrors,
  DeleteAdminClinicalPracticeResourcesCatalogByIdPermanentResponses,
  DeleteAdminClinicalPracticeToolsByIdPermanentData,
  DeleteAdminClinicalPracticeToolsByIdPermanentErrors,
  DeleteAdminClinicalPracticeToolsByIdPermanentResponses,
  DeleteAdminClinicalPracticeToolsCatalogByIdPermanentData,
  DeleteAdminClinicalPracticeToolsCatalogByIdPermanentErrors,
  DeleteAdminClinicalPracticeToolsCatalogByIdPermanentResponses,
  DeleteAdminClinicalSessionsByIdData,
  DeleteAdminClinicalSessionsByIdErrors,
  DeleteAdminClinicalSessionsByIdResponses,
  DeleteAdminClinicalSupplementTemplateCollectionMembershipsByIdData,
  DeleteAdminClinicalSupplementTemplateCollectionMembershipsByIdErrors,
  DeleteAdminClinicalSupplementTemplateCollectionMembershipsByIdResponses,
  DeleteAdminClinicalSupplementTemplateCollectionsByIdData,
  DeleteAdminClinicalSupplementTemplateCollectionsByIdErrors,
  DeleteAdminClinicalSupplementTemplateCollectionsByIdResponses,
  DeleteAdminClinicalSupplementTemplatesByIdPermanentData,
  DeleteAdminClinicalSupplementTemplatesByIdPermanentErrors,
  DeleteAdminClinicalSupplementTemplatesByIdPermanentResponses,
  DeleteAdminClinicalSupplementTemplatesCatalogByIdPermanentData,
  DeleteAdminClinicalSupplementTemplatesCatalogByIdPermanentErrors,
  DeleteAdminClinicalSupplementTemplatesCatalogByIdPermanentResponses,
  DeleteAdminComplianceRequirementsByIdData,
  DeleteAdminComplianceRequirementsByIdErrors,
  DeleteAdminComplianceRequirementsByIdResponses,
  DeleteAdminCompositeOperationsByIdData,
  DeleteAdminCompositeOperationsByIdErrors,
  DeleteAdminCompositeOperationsByIdResponses,
  DeleteAdminConnectorsByIdData,
  DeleteAdminConnectorsByIdErrors,
  DeleteAdminConnectorsByIdResponses,
  DeleteAdminConnectorsOauthAppConfigsByIdData,
  DeleteAdminConnectorsOauthAppConfigsByIdErrors,
  DeleteAdminConnectorsOauthAppConfigsByIdResponses,
  DeleteAdminContractsByIdData,
  DeleteAdminContractsByIdErrors,
  DeleteAdminContractsByIdResponses,
  DeleteAdminCrawlerBrowserSessionsByIdData,
  DeleteAdminCrawlerBrowserSessionsByIdErrors,
  DeleteAdminCrawlerBrowserSessionsByIdResponses,
  DeleteAdminCrawlerJobsByIdData,
  DeleteAdminCrawlerJobsByIdErrors,
  DeleteAdminCrawlerJobsByIdResponses,
  DeleteAdminCrawlerNewsMonitorsByIdData,
  DeleteAdminCrawlerNewsMonitorsByIdErrors,
  DeleteAdminCrawlerNewsMonitorsByIdResponses,
  DeleteAdminCrawlerSchedulesByIdData,
  DeleteAdminCrawlerSchedulesByIdErrors,
  DeleteAdminCrawlerSchedulesByIdResponses,
  DeleteAdminCrawlerSiteConfigsByIdData,
  DeleteAdminCrawlerSiteConfigsByIdErrors,
  DeleteAdminCrawlerSiteConfigsByIdResponses,
  DeleteAdminCreditPackagesByIdData,
  DeleteAdminCreditPackagesByIdErrors,
  DeleteAdminCreditPackagesByIdResponses,
  DeleteAdminCrmActivitiesByIdData,
  DeleteAdminCrmActivitiesByIdErrors,
  DeleteAdminCrmActivitiesByIdResponses,
  DeleteAdminCrmAddressesByIdData,
  DeleteAdminCrmAddressesByIdErrors,
  DeleteAdminCrmAddressesByIdResponses,
  DeleteAdminCrmCompaniesByIdData,
  DeleteAdminCrmCompaniesByIdErrors,
  DeleteAdminCrmCompaniesByIdResponses,
  DeleteAdminCrmContactsByIdData,
  DeleteAdminCrmContactsByIdErrors,
  DeleteAdminCrmContactsByIdResponses,
  DeleteAdminCrmCustomEntitiesByIdData,
  DeleteAdminCrmCustomEntitiesByIdErrors,
  DeleteAdminCrmCustomEntitiesByIdResponses,
  DeleteAdminCrmDealProductsByIdData,
  DeleteAdminCrmDealProductsByIdErrors,
  DeleteAdminCrmDealProductsByIdResponses,
  DeleteAdminCrmDealsByIdData,
  DeleteAdminCrmDealsByIdErrors,
  DeleteAdminCrmDealsByIdResponses,
  DeleteAdminCrmEmailAddressesByIdData,
  DeleteAdminCrmEmailAddressesByIdErrors,
  DeleteAdminCrmEmailAddressesByIdResponses,
  DeleteAdminCrmFieldDefinitionsByIdData,
  DeleteAdminCrmFieldDefinitionsByIdErrors,
  DeleteAdminCrmFieldDefinitionsByIdResponses,
  DeleteAdminCrmPhoneNumbersByIdData,
  DeleteAdminCrmPhoneNumbersByIdErrors,
  DeleteAdminCrmPhoneNumbersByIdResponses,
  DeleteAdminCrmPipelinesByIdData,
  DeleteAdminCrmPipelinesByIdErrors,
  DeleteAdminCrmPipelinesByIdResponses,
  DeleteAdminCrmPipelineStagesByIdData,
  DeleteAdminCrmPipelineStagesByIdErrors,
  DeleteAdminCrmPipelineStagesByIdResponses,
  DeleteAdminCrmRelationshipsByIdData,
  DeleteAdminCrmRelationshipsByIdErrors,
  DeleteAdminCrmRelationshipsByIdResponses,
  DeleteAdminCrmRelationshipTypesByIdData,
  DeleteAdminCrmRelationshipTypesByIdErrors,
  DeleteAdminCrmRelationshipTypesByIdResponses,
  DeleteAdminCrmSocialProfilesByIdData,
  DeleteAdminCrmSocialProfilesByIdErrors,
  DeleteAdminCrmSocialProfilesByIdResponses,
  DeleteAdminCrmSyncConfigsByIdData,
  DeleteAdminCrmSyncConfigsByIdErrors,
  DeleteAdminCrmSyncConfigsByIdResponses,
  DeleteAdminCrmWebsitesByIdData,
  DeleteAdminCrmWebsitesByIdErrors,
  DeleteAdminCrmWebsitesByIdResponses,
  DeleteAdminCustomersByIdData,
  DeleteAdminCustomersByIdErrors,
  DeleteAdminCustomersByIdResponses,
  DeleteAdminDataTransferRecordsByIdData,
  DeleteAdminDataTransferRecordsByIdErrors,
  DeleteAdminDataTransferRecordsByIdResponses,
  DeleteAdminEmailInboundAddressesByIdData,
  DeleteAdminEmailInboundAddressesByIdErrors,
  DeleteAdminEmailInboundAddressesByIdResponses,
  DeleteAdminEmailInclusionsByIdData,
  DeleteAdminEmailInclusionsByIdErrors,
  DeleteAdminEmailInclusionsByIdResponses,
  DeleteAdminEmailMarketingCampaignsByIdData,
  DeleteAdminEmailMarketingCampaignsByIdErrors,
  DeleteAdminEmailMarketingCampaignsByIdResponses,
  DeleteAdminEmailMarketingSenderProfilesByIdData,
  DeleteAdminEmailMarketingSenderProfilesByIdErrors,
  DeleteAdminEmailMarketingSenderProfilesByIdResponses,
  DeleteAdminEmailMarketingTemplatesByIdData,
  DeleteAdminEmailMarketingTemplatesByIdErrors,
  DeleteAdminEmailMarketingTemplatesByIdResponses,
  DeleteAdminEmailOutboundEmailsByIdData,
  DeleteAdminEmailOutboundEmailsByIdErrors,
  DeleteAdminEmailOutboundEmailsByIdResponses,
  DeleteAdminEmailRecipientsByIdData,
  DeleteAdminEmailRecipientsByIdErrors,
  DeleteAdminEmailRecipientsByIdResponses,
  DeleteAdminExtractionBatchesByIdData,
  DeleteAdminExtractionBatchesByIdErrors,
  DeleteAdminExtractionBatchesByIdResponses,
  DeleteAdminExtractionDocumentsByIdData,
  DeleteAdminExtractionDocumentsByIdErrors,
  DeleteAdminExtractionDocumentsByIdResponses,
  DeleteAdminExtractionResultsByIdData,
  DeleteAdminExtractionResultsByIdErrors,
  DeleteAdminExtractionResultsByIdResponses,
  DeleteAdminExtractionShadowComparisonsByIdData,
  DeleteAdminExtractionShadowComparisonsByIdErrors,
  DeleteAdminExtractionShadowComparisonsByIdResponses,
  DeleteAdminExtractionWorkflowsByIdData,
  DeleteAdminExtractionWorkflowsByIdErrors,
  DeleteAdminExtractionWorkflowsByIdResponses,
  DeleteAdminFeatureDefinitionsByIdData,
  DeleteAdminFeatureDefinitionsByIdErrors,
  DeleteAdminFeatureDefinitionsByIdResponses,
  DeleteAdminFieldTemplatesByIdData,
  DeleteAdminFieldTemplatesByIdErrors,
  DeleteAdminFieldTemplatesByIdResponses,
  DeleteAdminFormDeploymentsByIdData,
  DeleteAdminFormDeploymentsByIdErrors,
  DeleteAdminFormDeploymentsByIdResponses,
  DeleteAdminFormVersionsByIdData,
  DeleteAdminFormVersionsByIdErrors,
  DeleteAdminFormVersionsByIdResponses,
  DeleteAdminInvoicesByIdData,
  DeleteAdminInvoicesByIdErrors,
  DeleteAdminInvoicesByIdResponses,
  DeleteAdminInvoicesContactsByIdData,
  DeleteAdminInvoicesContactsByIdErrors,
  DeleteAdminInvoicesContactsByIdResponses,
  DeleteAdminInvoicesLinesByIdData,
  DeleteAdminInvoicesLinesByIdErrors,
  DeleteAdminInvoicesLinesByIdResponses,
  DeleteAdminInvoicesPaymentsByIdData,
  DeleteAdminInvoicesPaymentsByIdErrors,
  DeleteAdminInvoicesPaymentsByIdResponses,
  DeleteAdminInvoicesRecurringSchedulesByIdData,
  DeleteAdminInvoicesRecurringSchedulesByIdErrors,
  DeleteAdminInvoicesRecurringSchedulesByIdResponses,
  DeleteAdminInvoicesRulesByIdData,
  DeleteAdminInvoicesRulesByIdErrors,
  DeleteAdminInvoicesRulesByIdResponses,
  DeleteAdminInvoicesTemplatesByIdData,
  DeleteAdminInvoicesTemplatesByIdErrors,
  DeleteAdminInvoicesTemplatesByIdResponses,
  DeleteAdminIsvCrmEntityTypesByIdData,
  DeleteAdminIsvCrmEntityTypesByIdErrors,
  DeleteAdminIsvCrmEntityTypesByIdResponses,
  DeleteAdminLegalDocumentsByIdData,
  DeleteAdminLegalDocumentsByIdErrors,
  DeleteAdminLegalDocumentsByIdResponses,
  DeleteAdminMeetingsByIdData,
  DeleteAdminMeetingsByIdErrors,
  DeleteAdminMeetingsByIdResponses,
  DeleteAdminMessagesByIdData,
  DeleteAdminMessagesByIdErrors,
  DeleteAdminMessagesByIdResponses,
  DeleteAdminNotificationMethodsByIdData,
  DeleteAdminNotificationMethodsByIdErrors,
  DeleteAdminNotificationMethodsByIdResponses,
  DeleteAdminNotificationPreferencesByIdData,
  DeleteAdminNotificationPreferencesByIdErrors,
  DeleteAdminNotificationPreferencesByIdResponses,
  DeleteAdminPaymentMethodsByIdData,
  DeleteAdminPaymentMethodsByIdErrors,
  DeleteAdminPaymentMethodsByIdResponses,
  DeleteAdminPipelineNodesByIdData,
  DeleteAdminPipelineNodesByIdErrors,
  DeleteAdminPipelineNodesByIdResponses,
  DeleteAdminPipelinesByIdData,
  DeleteAdminPipelinesByIdErrors,
  DeleteAdminPipelinesByIdResponses,
  DeleteAdminPlanFeatureAllocationsByIdData,
  DeleteAdminPlanFeatureAllocationsByIdErrors,
  DeleteAdminPlanFeatureAllocationsByIdResponses,
  DeleteAdminPlansByIdData,
  DeleteAdminPlansByIdErrors,
  DeleteAdminPlansByIdResponses,
  DeleteAdminPlatformPricingConfigsByIdData,
  DeleteAdminPlatformPricingConfigsByIdErrors,
  DeleteAdminPlatformPricingConfigsByIdResponses,
  DeleteAdminPlatformTonesByIdData,
  DeleteAdminPlatformTonesByIdErrors,
  DeleteAdminPlatformTonesByIdResponses,
  DeleteAdminPortalInvitationsByIdData,
  DeleteAdminPortalInvitationsByIdErrors,
  DeleteAdminPortalInvitationsByIdResponses,
  DeleteAdminPostProcessingHooksByIdData,
  DeleteAdminPostProcessingHooksByIdErrors,
  DeleteAdminPostProcessingHooksByIdResponses,
  DeleteAdminPreferencesByKeyData,
  DeleteAdminPreferencesByKeyErrors,
  DeleteAdminPreferencesByKeyResponses,
  DeleteAdminProcessingActivitiesByIdData,
  DeleteAdminProcessingActivitiesByIdErrors,
  DeleteAdminProcessingActivitiesByIdResponses,
  DeleteAdminQuoteRequestsByIdData,
  DeleteAdminQuoteRequestsByIdErrors,
  DeleteAdminQuoteRequestsByIdResponses,
  DeleteAdminRecipesByIdData,
  DeleteAdminRecipesByIdErrors,
  DeleteAdminRecipesByIdResponses,
  DeleteAdminRecipesCollectionRecipesByIdData,
  DeleteAdminRecipesCollectionRecipesByIdErrors,
  DeleteAdminRecipesCollectionRecipesByIdResponses,
  DeleteAdminRecipesCollectionsByIdData,
  DeleteAdminRecipesCollectionsByIdErrors,
  DeleteAdminRecipesCollectionsByIdResponses,
  DeleteAdminRecipesFavoritesByIdData,
  DeleteAdminRecipesFavoritesByIdErrors,
  DeleteAdminRecipesFavoritesByIdResponses,
  DeleteAdminRecipesFoodItemsByIdData,
  DeleteAdminRecipesFoodItemsByIdErrors,
  DeleteAdminRecipesFoodItemsByIdResponses,
  DeleteAdminRecipesIngredientsByIdData,
  DeleteAdminRecipesIngredientsByIdErrors,
  DeleteAdminRecipesIngredientsByIdResponses,
  DeleteAdminRecipesMealSchedulesByIdData,
  DeleteAdminRecipesMealSchedulesByIdErrors,
  DeleteAdminRecipesMealSchedulesByIdResponses,
  DeleteAdminRecipesRecipeTagsByIdData,
  DeleteAdminRecipesRecipeTagsByIdErrors,
  DeleteAdminRecipesRecipeTagsByIdResponses,
  DeleteAdminRecipesScheduledMealsByIdData,
  DeleteAdminRecipesScheduledMealsByIdErrors,
  DeleteAdminRecipesScheduledMealsByIdResponses,
  DeleteAdminRecipesShoppingListItemsByIdData,
  DeleteAdminRecipesShoppingListItemsByIdErrors,
  DeleteAdminRecipesShoppingListItemsByIdResponses,
  DeleteAdminRecipesShoppingListsByIdData,
  DeleteAdminRecipesShoppingListsByIdErrors,
  DeleteAdminRecipesShoppingListsByIdResponses,
  DeleteAdminRecipesTagsByIdData,
  DeleteAdminRecipesTagsByIdErrors,
  DeleteAdminRecipesTagsByIdResponses,
  DeleteAdminRetentionPoliciesByIdData,
  DeleteAdminRetentionPoliciesByIdErrors,
  DeleteAdminRetentionPoliciesByIdResponses,
  DeleteAdminReviewQueueMembershipsByIdData,
  DeleteAdminReviewQueueMembershipsByIdErrors,
  DeleteAdminReviewQueueMembershipsByIdResponses,
  DeleteAdminReviewQueuesByIdData,
  DeleteAdminReviewQueuesByIdErrors,
  DeleteAdminReviewQueuesByIdResponses,
  DeleteAdminRiskAssessmentsByIdData,
  DeleteAdminRiskAssessmentsByIdErrors,
  DeleteAdminRiskAssessmentsByIdResponses,
  DeleteAdminRolesByIdData,
  DeleteAdminRolesByIdErrors,
  DeleteAdminRolesByIdResponses,
  DeleteAdminSchedulingAvailabilityRulesByIdData,
  DeleteAdminSchedulingAvailabilityRulesByIdErrors,
  DeleteAdminSchedulingAvailabilityRulesByIdResponses,
  DeleteAdminSchedulingCalendarSyncsByIdData,
  DeleteAdminSchedulingCalendarSyncsByIdErrors,
  DeleteAdminSchedulingCalendarSyncsByIdResponses,
  DeleteAdminSchedulingParticipantsByIdData,
  DeleteAdminSchedulingParticipantsByIdErrors,
  DeleteAdminSchedulingParticipantsByIdResponses,
  DeleteAdminSearchSavedByIdData,
  DeleteAdminSearchSavedByIdErrors,
  DeleteAdminSearchSavedByIdResponses,
  DeleteAdminSocialAccountsByIdData,
  DeleteAdminSocialAccountsByIdErrors,
  DeleteAdminSocialAccountsByIdResponses,
  DeleteAdminSocialCampaignsByIdData,
  DeleteAdminSocialCampaignsByIdErrors,
  DeleteAdminSocialCampaignsByIdResponses,
  DeleteAdminSocialPostsByIdData,
  DeleteAdminSocialPostsByIdErrors,
  DeleteAdminSocialPostsByIdResponses,
  DeleteAdminSocialTrendingHistoryByIdData,
  DeleteAdminSocialTrendingHistoryByIdErrors,
  DeleteAdminSocialTrendingHistoryByIdResponses,
  DeleteAdminSocialTrendingWatchesByIdData,
  DeleteAdminSocialTrendingWatchesByIdErrors,
  DeleteAdminSocialTrendingWatchesByIdResponses,
  DeleteAdminSupportCannedResponsesByIdData,
  DeleteAdminSupportCannedResponsesByIdErrors,
  DeleteAdminSupportCannedResponsesByIdResponses,
  DeleteAdminSupportQueueMembersByIdData,
  DeleteAdminSupportQueueMembersByIdErrors,
  DeleteAdminSupportQueueMembersByIdResponses,
  DeleteAdminSupportQueuesByIdData,
  DeleteAdminSupportQueuesByIdErrors,
  DeleteAdminSupportQueuesByIdResponses,
  DeleteAdminSupportRoutingRulesByIdData,
  DeleteAdminSupportRoutingRulesByIdErrors,
  DeleteAdminSupportRoutingRulesByIdResponses,
  DeleteAdminSupportSlaPoliciesByIdData,
  DeleteAdminSupportSlaPoliciesByIdErrors,
  DeleteAdminSupportSlaPoliciesByIdResponses,
  DeleteAdminSupportSyncConfigsByIdData,
  DeleteAdminSupportSyncConfigsByIdErrors,
  DeleteAdminSupportSyncConfigsByIdResponses,
  DeleteAdminSupportTagsByIdData,
  DeleteAdminSupportTagsByIdErrors,
  DeleteAdminSupportTagsByIdResponses,
  DeleteAdminSupportTicketsByIdData,
  DeleteAdminSupportTicketsByIdErrors,
  DeleteAdminSupportTicketsByIdResponses,
  DeleteAdminSystemMessagesByIdData,
  DeleteAdminSystemMessagesByIdErrors,
  DeleteAdminSystemMessagesByIdResponses,
  DeleteAdminTenantPricingOverridesByIdData,
  DeleteAdminTenantPricingOverridesByIdErrors,
  DeleteAdminTenantPricingOverridesByIdResponses,
  DeleteAdminTenantsByIdData,
  DeleteAdminTenantsByIdErrors,
  DeleteAdminTenantsByIdResponses,
  DeleteAdminThreadsByIdData,
  DeleteAdminThreadsByIdErrors,
  DeleteAdminThreadsByIdResponses,
  DeleteAdminTrainingExamplesByIdData,
  DeleteAdminTrainingExamplesByIdErrors,
  DeleteAdminTrainingExamplesByIdResponses,
  DeleteAdminTrainingSessionsByIdData,
  DeleteAdminTrainingSessionsByIdErrors,
  DeleteAdminTrainingSessionsByIdResponses,
  DeleteAdminUserProfilesByIdData,
  DeleteAdminUserProfilesByIdErrors,
  DeleteAdminUserProfilesByIdResponses,
  DeleteAdminUsersByIdData,
  DeleteAdminUsersByIdErrors,
  DeleteAdminUsersByIdResponses,
  DeleteAdminVoiceSessionsByIdData,
  DeleteAdminVoiceSessionsByIdErrors,
  DeleteAdminVoiceSessionsByIdResponses,
  DeleteAdminVoiceTranscriptionJobsByIdData,
  DeleteAdminVoiceTranscriptionJobsByIdErrors,
  DeleteAdminVoiceTranscriptionJobsByIdResponses,
  DeleteAdminVoiceTranscriptionResultsByIdData,
  DeleteAdminVoiceTranscriptionResultsByIdErrors,
  DeleteAdminVoiceTranscriptionResultsByIdResponses,
  DeleteAdminWebhookConfigsByIdData,
  DeleteAdminWebhookConfigsByIdErrors,
  DeleteAdminWebhookConfigsByIdResponses,
  DeleteAdminWorkspaceAgentConfigsByIdData,
  DeleteAdminWorkspaceAgentConfigsByIdErrors,
  DeleteAdminWorkspaceAgentConfigsByIdResponses,
  DeleteAdminWorkspaceFormConfigsByIdData,
  DeleteAdminWorkspaceFormConfigsByIdErrors,
  DeleteAdminWorkspaceFormConfigsByIdResponses,
  DeleteAdminWorkspacePreferencesByIdData,
  DeleteAdminWorkspacePreferencesByIdErrors,
  DeleteAdminWorkspacePreferencesByIdResponses,
  DeleteAdminWorkspacesByIdData,
  DeleteAdminWorkspacesByIdErrors,
  DeleteAdminWorkspacesByIdResponses,
  GetAdminAccessGrantsByIdData,
  GetAdminAccessGrantsByIdErrors,
  GetAdminAccessGrantsByIdResponses,
  GetAdminAccessGrantsData,
  GetAdminAccessGrantsErrors,
  GetAdminAccessGrantsResponses,
  GetAdminAccessLogsByIdData,
  GetAdminAccessLogsByIdErrors,
  GetAdminAccessLogsByIdResponses,
  GetAdminAccessLogsData,
  GetAdminAccessLogsErrors,
  GetAdminAccessLogsResponses,
  GetAdminAccountsByIdData,
  GetAdminAccountsByIdErrors,
  GetAdminAccountsByIdResponses,
  GetAdminAccountsByTenantByTenantIdData,
  GetAdminAccountsByTenantByTenantIdErrors,
  GetAdminAccountsByTenantByTenantIdResponses,
  GetAdminAccountsData,
  GetAdminAccountsErrors,
  GetAdminAccountsResponses,
  GetAdminAgentDeploymentsByIdData,
  GetAdminAgentDeploymentsByIdErrors,
  GetAdminAgentDeploymentsByIdResponses,
  GetAdminAgentDeploymentsData,
  GetAdminAgentDeploymentsErrors,
  GetAdminAgentDeploymentsResponses,
  GetAdminAgentExecutionsByIdData,
  GetAdminAgentExecutionsByIdErrors,
  GetAdminAgentExecutionsByIdResponses,
  GetAdminAgentExecutionsData,
  GetAdminAgentExecutionsErrors,
  GetAdminAgentExecutionsResponses,
  GetAdminAgentsByIdData,
  GetAdminAgentsByIdErrors,
  GetAdminAgentsByIdResponses,
  GetAdminAgentsByIdSchemaVersionsData,
  GetAdminAgentsByIdSchemaVersionsErrors,
  GetAdminAgentsByIdSchemaVersionsResponses,
  GetAdminAgentsByIdStatsData,
  GetAdminAgentsByIdStatsErrors,
  GetAdminAgentsByIdStatsResponses,
  GetAdminAgentsByIdTrainingExamplesData,
  GetAdminAgentsByIdTrainingExamplesErrors,
  GetAdminAgentsByIdTrainingExamplesResponses,
  GetAdminAgentsByIdTrainingStatsData,
  GetAdminAgentsByIdTrainingStatsErrors,
  GetAdminAgentsByIdTrainingStatsResponses,
  GetAdminAgentsByIdUsageData,
  GetAdminAgentsByIdUsageErrors,
  GetAdminAgentsByIdUsageResponses,
  GetAdminAgentsBySlugBySlugData,
  GetAdminAgentsBySlugBySlugErrors,
  GetAdminAgentsBySlugBySlugResponses,
  GetAdminAgentsData,
  GetAdminAgentsErrors,
  GetAdminAgentSoulsByIdData,
  GetAdminAgentSoulsByIdErrors,
  GetAdminAgentSoulsByIdResponses,
  GetAdminAgentSoulsData,
  GetAdminAgentSoulsErrors,
  GetAdminAgentSoulsResponses,
  GetAdminAgentsResponses,
  GetAdminAgentsUsageData,
  GetAdminAgentsUsageErrors,
  GetAdminAgentsUsageResponses,
  GetAdminAgentToolsData,
  GetAdminAgentToolsErrors,
  GetAdminAgentToolsResponses,
  GetAdminAgentVersionRevisionsByIdData,
  GetAdminAgentVersionRevisionsByIdErrors,
  GetAdminAgentVersionRevisionsByIdResponses,
  GetAdminAgentVersionRevisionsData,
  GetAdminAgentVersionRevisionsErrors,
  GetAdminAgentVersionRevisionsResponses,
  GetAdminAgentVersionsByIdData,
  GetAdminAgentVersionsByIdErrors,
  GetAdminAgentVersionsByIdMetricsData,
  GetAdminAgentVersionsByIdMetricsErrors,
  GetAdminAgentVersionsByIdMetricsResponses,
  GetAdminAgentVersionsByIdResponses,
  GetAdminAgentVersionsByIdRevisionsData,
  GetAdminAgentVersionsByIdRevisionsErrors,
  GetAdminAgentVersionsByIdRevisionsResponses,
  GetAdminAgentVersionsData,
  GetAdminAgentVersionsErrors,
  GetAdminAgentVersionsResponses,
  GetAdminAiChunksDocumentByDocumentIdData,
  GetAdminAiChunksDocumentByDocumentIdErrors,
  GetAdminAiChunksDocumentByDocumentIdResponses,
  GetAdminAiConversationsByIdData,
  GetAdminAiConversationsByIdErrors,
  GetAdminAiConversationsByIdResponses,
  GetAdminAiConversationsData,
  GetAdminAiConversationsErrors,
  GetAdminAiConversationsResponses,
  GetAdminAiGraphNodesByNodeIdRelationshipsData,
  GetAdminAiGraphNodesByNodeIdRelationshipsErrors,
  GetAdminAiGraphNodesByNodeIdRelationshipsResponses,
  GetAdminAiGraphNodesData,
  GetAdminAiGraphNodesErrors,
  GetAdminAiGraphNodesLabelByLabelData,
  GetAdminAiGraphNodesLabelByLabelErrors,
  GetAdminAiGraphNodesLabelByLabelResponses,
  GetAdminAiGraphNodesResponses,
  GetAdminAiGraphNodesSemanticData,
  GetAdminAiGraphNodesSemanticErrors,
  GetAdminAiGraphNodesSemanticResponses,
  GetAdminAiMessagesByIdData,
  GetAdminAiMessagesByIdErrors,
  GetAdminAiMessagesByIdResponses,
  GetAdminAiMessagesData,
  GetAdminAiMessagesErrors,
  GetAdminAiMessagesResponses,
  GetAdminAmendmentRequestsByIdData,
  GetAdminAmendmentRequestsByIdErrors,
  GetAdminAmendmentRequestsByIdResponses,
  GetAdminAmendmentRequestsData,
  GetAdminAmendmentRequestsErrors,
  GetAdminAmendmentRequestsResponses,
  GetAdminApiKeysActiveData,
  GetAdminApiKeysActiveErrors,
  GetAdminApiKeysActiveResponses,
  GetAdminApiKeysByIdData,
  GetAdminApiKeysByIdErrors,
  GetAdminApiKeysByIdResponses,
  GetAdminApiKeysData,
  GetAdminApiKeysErrors,
  GetAdminApiKeysResponses,
  GetAdminApiKeysStatsData,
  GetAdminApiKeysStatsErrors,
  GetAdminApiKeysStatsResponses,
  GetAdminApplicationsByApplicationIdEmailTemplatesBySlugData,
  GetAdminApplicationsByApplicationIdEmailTemplatesBySlugErrors,
  GetAdminApplicationsByApplicationIdEmailTemplatesBySlugResponses,
  GetAdminApplicationsByApplicationIdEmailTemplatesData,
  GetAdminApplicationsByApplicationIdEmailTemplatesErrors,
  GetAdminApplicationsByApplicationIdEmailTemplatesResponses,
  GetAdminApplicationsByIdData,
  GetAdminApplicationsByIdErrors,
  GetAdminApplicationsByIdResponses,
  GetAdminApplicationsBySlugBySlugData,
  GetAdminApplicationsBySlugBySlugErrors,
  GetAdminApplicationsBySlugBySlugResponses,
  GetAdminApplicationsCurrentData,
  GetAdminApplicationsCurrentErrors,
  GetAdminApplicationsCurrentResponses,
  GetAdminApplicationsData,
  GetAdminApplicationsErrors,
  GetAdminApplicationsMeData,
  GetAdminApplicationsMeErrors,
  GetAdminApplicationsMeResponses,
  GetAdminApplicationsResponses,
  GetAdminAuditChainEntriesByIdData,
  GetAdminAuditChainEntriesByIdErrors,
  GetAdminAuditChainEntriesByIdResponses,
  GetAdminAuditChainEntriesData,
  GetAdminAuditChainEntriesErrors,
  GetAdminAuditChainEntriesResponses,
  GetAdminAuditLogsActivityData,
  GetAdminAuditLogsActivityErrors,
  GetAdminAuditLogsActivityResponses,
  GetAdminAuditLogsCountByActionData,
  GetAdminAuditLogsCountByActionErrors,
  GetAdminAuditLogsCountByActionResponses,
  GetAdminAuditLogsData,
  GetAdminAuditLogsErrors,
  GetAdminAuditLogsResponses,
  GetAdminBalancesByIdData,
  GetAdminBalancesByIdErrors,
  GetAdminBalancesByIdResponses,
  GetAdminBalancesData,
  GetAdminBalancesErrors,
  GetAdminBalancesResponses,
  GetAdminBrandIdentitiesByIdData,
  GetAdminBrandIdentitiesByIdErrors,
  GetAdminBrandIdentitiesByIdResponses,
  GetAdminBrandIdentitiesByTenantByTenantIdData,
  GetAdminBrandIdentitiesByTenantByTenantIdErrors,
  GetAdminBrandIdentitiesByTenantByTenantIdResponses,
  GetAdminBrandIdentitiesByWorkspaceByWorkspaceIdData,
  GetAdminBrandIdentitiesByWorkspaceByWorkspaceIdErrors,
  GetAdminBrandIdentitiesByWorkspaceByWorkspaceIdResponses,
  GetAdminBrandIdentitiesData,
  GetAdminBrandIdentitiesDefaultTenantByTenantIdData,
  GetAdminBrandIdentitiesDefaultTenantByTenantIdErrors,
  GetAdminBrandIdentitiesDefaultTenantByTenantIdResponses,
  GetAdminBrandIdentitiesDefaultWorkspaceByWorkspaceIdData,
  GetAdminBrandIdentitiesDefaultWorkspaceByWorkspaceIdErrors,
  GetAdminBrandIdentitiesDefaultWorkspaceByWorkspaceIdResponses,
  GetAdminBrandIdentitiesErrors,
  GetAdminBrandIdentitiesResponses,
  GetAdminBreachIncidentsByIdData,
  GetAdminBreachIncidentsByIdErrors,
  GetAdminBreachIncidentsByIdResponses,
  GetAdminBreachIncidentsData,
  GetAdminBreachIncidentsErrors,
  GetAdminBreachIncidentsResponses,
  GetAdminBreachNotificationArtifactsByIdData,
  GetAdminBreachNotificationArtifactsByIdErrors,
  GetAdminBreachNotificationArtifactsByIdResponses,
  GetAdminBreachNotificationArtifactsData,
  GetAdminBreachNotificationArtifactsErrors,
  GetAdminBreachNotificationArtifactsResponses,
  GetAdminBreachNotificationsByIdData,
  GetAdminBreachNotificationsByIdErrors,
  GetAdminBreachNotificationsByIdResponses,
  GetAdminBreachNotificationsData,
  GetAdminBreachNotificationsErrors,
  GetAdminBreachNotificationsResponses,
  GetAdminBucketsAllData,
  GetAdminBucketsAllErrors,
  GetAdminBucketsAllResponses,
  GetAdminBucketsByIdData,
  GetAdminBucketsByIdErrors,
  GetAdminBucketsByIdResponses,
  GetAdminBucketsByIdStatsData,
  GetAdminBucketsByIdStatsErrors,
  GetAdminBucketsByIdStatsResponses,
  GetAdminBucketsData,
  GetAdminBucketsErrors,
  GetAdminBucketsResponses,
  GetAdminBusinessAssociateAgreementsByIdData,
  GetAdminBusinessAssociateAgreementsByIdErrors,
  GetAdminBusinessAssociateAgreementsByIdResponses,
  GetAdminBusinessAssociateAgreementsData,
  GetAdminBusinessAssociateAgreementsErrors,
  GetAdminBusinessAssociateAgreementsResponses,
  GetAdminCampaignsRecipientsByIdData,
  GetAdminCampaignsRecipientsByIdErrors,
  GetAdminCampaignsRecipientsByIdResponses,
  GetAdminCampaignsRecipientsCampaignByCampaignIdData,
  GetAdminCampaignsRecipientsCampaignByCampaignIdErrors,
  GetAdminCampaignsRecipientsCampaignByCampaignIdResponses,
  GetAdminCampaignsSequencesByIdData,
  GetAdminCampaignsSequencesByIdErrors,
  GetAdminCampaignsSequencesByIdResponses,
  GetAdminCampaignsSequenceStepsByIdData,
  GetAdminCampaignsSequenceStepsByIdErrors,
  GetAdminCampaignsSequenceStepsByIdResponses,
  GetAdminCampaignsSequenceStepsSequenceBySequenceIdData,
  GetAdminCampaignsSequenceStepsSequenceBySequenceIdErrors,
  GetAdminCampaignsSequenceStepsSequenceBySequenceIdResponses,
  GetAdminCampaignsSequencesWorkspaceByWorkspaceIdData,
  GetAdminCampaignsSequencesWorkspaceByWorkspaceIdErrors,
  GetAdminCampaignsSequencesWorkspaceByWorkspaceIdResponses,
  GetAdminCaseDocumentLinksByIdData,
  GetAdminCaseDocumentLinksByIdErrors,
  GetAdminCaseDocumentLinksByIdResponses,
  GetAdminCaseDocumentLinksData,
  GetAdminCaseDocumentLinksErrors,
  GetAdminCaseDocumentLinksResponses,
  GetAdminCaseEntityLinksByIdData,
  GetAdminCaseEntityLinksByIdErrors,
  GetAdminCaseEntityLinksByIdResponses,
  GetAdminCaseEntityLinksData,
  GetAdminCaseEntityLinksErrors,
  GetAdminCaseEntityLinksResponses,
  GetAdminCasePipelineLinksByIdData,
  GetAdminCasePipelineLinksByIdErrors,
  GetAdminCasePipelineLinksByIdResponses,
  GetAdminCasePipelineLinksData,
  GetAdminCasePipelineLinksErrors,
  GetAdminCasePipelineLinksResponses,
  GetAdminCasesAttentionData,
  GetAdminCasesAttentionErrors,
  GetAdminCasesAttentionResponses,
  GetAdminCasesAttentionSummaryData,
  GetAdminCasesAttentionSummaryErrors,
  GetAdminCasesAttentionSummaryResponses,
  GetAdminCasesByIdData,
  GetAdminCasesByIdErrors,
  GetAdminCasesByIdResponses,
  GetAdminCasesData,
  GetAdminCasesErrors,
  GetAdminCasesResponses,
  GetAdminCaseTypesByIdData,
  GetAdminCaseTypesByIdErrors,
  GetAdminCaseTypesByIdResponses,
  GetAdminCaseTypesData,
  GetAdminCaseTypesErrors,
  GetAdminCaseTypesResponses,
  GetAdminCatalogClassificationSuggestionsByIdData,
  GetAdminCatalogClassificationSuggestionsByIdErrors,
  GetAdminCatalogClassificationSuggestionsByIdResponses,
  GetAdminCatalogClassificationSuggestionsWorkspaceByWorkspaceIdPendingData,
  GetAdminCatalogClassificationSuggestionsWorkspaceByWorkspaceIdPendingErrors,
  GetAdminCatalogClassificationSuggestionsWorkspaceByWorkspaceIdPendingResponses,
  GetAdminCatalogOptionTypesApplicationByApplicationIdData,
  GetAdminCatalogOptionTypesApplicationByApplicationIdErrors,
  GetAdminCatalogOptionTypesApplicationByApplicationIdResponses,
  GetAdminCatalogOptionTypesByIdData,
  GetAdminCatalogOptionTypesByIdErrors,
  GetAdminCatalogOptionTypesByIdResponses,
  GetAdminCatalogOptionValuesByIdData,
  GetAdminCatalogOptionValuesByIdErrors,
  GetAdminCatalogOptionValuesByIdResponses,
  GetAdminCatalogOptionValuesOptionTypeByOptionTypeIdData,
  GetAdminCatalogOptionValuesOptionTypeByOptionTypeIdErrors,
  GetAdminCatalogOptionValuesOptionTypeByOptionTypeIdResponses,
  GetAdminCatalogPriceListEntriesPriceListByPriceListIdData,
  GetAdminCatalogPriceListEntriesPriceListByPriceListIdErrors,
  GetAdminCatalogPriceListEntriesPriceListByPriceListIdResponses,
  GetAdminCatalogPriceListsApplicationByApplicationIdData,
  GetAdminCatalogPriceListsApplicationByApplicationIdErrors,
  GetAdminCatalogPriceListsApplicationByApplicationIdResponses,
  GetAdminCatalogPriceListsByIdData,
  GetAdminCatalogPriceListsByIdErrors,
  GetAdminCatalogPriceListsByIdResponses,
  GetAdminCatalogPriceSuggestionsByIdData,
  GetAdminCatalogPriceSuggestionsByIdErrors,
  GetAdminCatalogPriceSuggestionsByIdResponses,
  GetAdminCatalogPriceSuggestionsWorkspaceByWorkspaceIdData,
  GetAdminCatalogPriceSuggestionsWorkspaceByWorkspaceIdErrors,
  GetAdminCatalogPriceSuggestionsWorkspaceByWorkspaceIdResponses,
  GetAdminCatalogProductsByIdData,
  GetAdminCatalogProductsByIdErrors,
  GetAdminCatalogProductsByIdResponses,
  GetAdminCatalogProductsWorkspaceByWorkspaceIdData,
  GetAdminCatalogProductsWorkspaceByWorkspaceIdErrors,
  GetAdminCatalogProductsWorkspaceByWorkspaceIdResponses,
  GetAdminCatalogProductVariantsByIdData,
  GetAdminCatalogProductVariantsByIdErrors,
  GetAdminCatalogProductVariantsByIdResponses,
  GetAdminCatalogProductVariantsProductByProductIdData,
  GetAdminCatalogProductVariantsProductByProductIdErrors,
  GetAdminCatalogProductVariantsProductByProductIdResponses,
  GetAdminCatalogStockLocationsByIdData,
  GetAdminCatalogStockLocationsByIdErrors,
  GetAdminCatalogStockLocationsByIdResponses,
  GetAdminCatalogStockLocationsWorkspaceByWorkspaceIdData,
  GetAdminCatalogStockLocationsWorkspaceByWorkspaceIdErrors,
  GetAdminCatalogStockLocationsWorkspaceByWorkspaceIdResponses,
  GetAdminCatalogStockMovementsByIdData,
  GetAdminCatalogStockMovementsByIdErrors,
  GetAdminCatalogStockMovementsByIdResponses,
  GetAdminCatalogStockMovementsTransactionByTransactionIdData,
  GetAdminCatalogStockMovementsTransactionByTransactionIdErrors,
  GetAdminCatalogStockMovementsTransactionByTransactionIdResponses,
  GetAdminCatalogStockRecordsByIdData,
  GetAdminCatalogStockRecordsByIdErrors,
  GetAdminCatalogStockRecordsByIdResponses,
  GetAdminCatalogStockRecordsLocationByStockLocationIdData,
  GetAdminCatalogStockRecordsLocationByStockLocationIdErrors,
  GetAdminCatalogStockRecordsLocationByStockLocationIdResponses,
  GetAdminCatalogTaxonomiesApplicationByApplicationIdData,
  GetAdminCatalogTaxonomiesApplicationByApplicationIdErrors,
  GetAdminCatalogTaxonomiesApplicationByApplicationIdResponses,
  GetAdminCatalogTaxonomiesByIdData,
  GetAdminCatalogTaxonomiesByIdErrors,
  GetAdminCatalogTaxonomiesByIdResponses,
  GetAdminCatalogTaxonomyNodesByIdData,
  GetAdminCatalogTaxonomyNodesByIdErrors,
  GetAdminCatalogTaxonomyNodesByIdResponses,
  GetAdminCatalogTaxonomyNodesTaxonomyByTaxonomyIdData,
  GetAdminCatalogTaxonomyNodesTaxonomyByTaxonomyIdErrors,
  GetAdminCatalogTaxonomyNodesTaxonomyByTaxonomyIdResponses,
  GetAdminCatalogViewsByIdData,
  GetAdminCatalogViewsByIdErrors,
  GetAdminCatalogViewsByIdResponses,
  GetAdminCatalogViewsWorkspaceByWorkspaceIdData,
  GetAdminCatalogViewsWorkspaceByWorkspaceIdErrors,
  GetAdminCatalogViewsWorkspaceByWorkspaceIdResponses,
  GetAdminCdeScopeReportsByIdData,
  GetAdminCdeScopeReportsByIdErrors,
  GetAdminCdeScopeReportsByIdResponses,
  GetAdminCdeScopeReportsData,
  GetAdminCdeScopeReportsErrors,
  GetAdminCdeScopeReportsResponses,
  GetAdminClaimedDomainsByIdData,
  GetAdminClaimedDomainsByIdErrors,
  GetAdminClaimedDomainsByIdResponses,
  GetAdminClaimedDomainsData,
  GetAdminClaimedDomainsErrors,
  GetAdminClaimedDomainsResponses,
  GetAdminClinicalClientGoalsArchivedData,
  GetAdminClinicalClientGoalsArchivedErrors,
  GetAdminClinicalClientGoalsArchivedResponses,
  GetAdminClinicalClientGoalsByIdData,
  GetAdminClinicalClientGoalsByIdErrors,
  GetAdminClinicalClientGoalsByIdResponses,
  GetAdminClinicalClientGoalsData,
  GetAdminClinicalClientGoalsErrors,
  GetAdminClinicalClientGoalsResponses,
  GetAdminClinicalClientMedicationsArchivedData,
  GetAdminClinicalClientMedicationsArchivedErrors,
  GetAdminClinicalClientMedicationsArchivedResponses,
  GetAdminClinicalClientMedicationsByIdData,
  GetAdminClinicalClientMedicationsByIdErrors,
  GetAdminClinicalClientMedicationsByIdResponses,
  GetAdminClinicalClientMedicationsData,
  GetAdminClinicalClientMedicationsErrors,
  GetAdminClinicalClientMedicationsResponses,
  GetAdminClinicalClientResourceAssignmentsArchivedData,
  GetAdminClinicalClientResourceAssignmentsArchivedErrors,
  GetAdminClinicalClientResourceAssignmentsArchivedResponses,
  GetAdminClinicalClientResourceAssignmentsByIdData,
  GetAdminClinicalClientResourceAssignmentsByIdErrors,
  GetAdminClinicalClientResourceAssignmentsByIdResponses,
  GetAdminClinicalClientResourceAssignmentsData,
  GetAdminClinicalClientResourceAssignmentsErrors,
  GetAdminClinicalClientResourceAssignmentsResponses,
  GetAdminClinicalClientSupplementsArchivedData,
  GetAdminClinicalClientSupplementsArchivedErrors,
  GetAdminClinicalClientSupplementsArchivedResponses,
  GetAdminClinicalClientSupplementsByIdData,
  GetAdminClinicalClientSupplementsByIdErrors,
  GetAdminClinicalClientSupplementsByIdResponses,
  GetAdminClinicalClientSupplementsData,
  GetAdminClinicalClientSupplementsErrors,
  GetAdminClinicalClientSupplementsResponses,
  GetAdminClinicalDeliveriesByIdData,
  GetAdminClinicalDeliveriesByIdErrors,
  GetAdminClinicalDeliveriesByIdResponses,
  GetAdminClinicalDeliveriesBySessionData,
  GetAdminClinicalDeliveriesBySessionErrors,
  GetAdminClinicalDeliveriesBySessionResponses,
  GetAdminClinicalDeliveriesData,
  GetAdminClinicalDeliveriesErrors,
  GetAdminClinicalDeliveriesResponses,
  GetAdminClinicalDocumentsByIdData,
  GetAdminClinicalDocumentsByIdErrors,
  GetAdminClinicalDocumentsByIdResponses,
  GetAdminClinicalDocumentsData,
  GetAdminClinicalDocumentsErrors,
  GetAdminClinicalDocumentsPatientsByIdDocumentsData,
  GetAdminClinicalDocumentsPatientsByIdDocumentsErrors,
  GetAdminClinicalDocumentsPatientsByIdDocumentsResponses,
  GetAdminClinicalDocumentsResponses,
  GetAdminClinicalGoalAssociationsByIdData,
  GetAdminClinicalGoalAssociationsByIdErrors,
  GetAdminClinicalGoalAssociationsByIdResponses,
  GetAdminClinicalGoalAssociationsData,
  GetAdminClinicalGoalAssociationsErrors,
  GetAdminClinicalGoalAssociationsResponses,
  GetAdminClinicalGoalTemplateCollectionMembershipsByIdData,
  GetAdminClinicalGoalTemplateCollectionMembershipsByIdErrors,
  GetAdminClinicalGoalTemplateCollectionMembershipsByIdResponses,
  GetAdminClinicalGoalTemplateCollectionMembershipsCollectionByCollectionIdData,
  GetAdminClinicalGoalTemplateCollectionMembershipsCollectionByCollectionIdErrors,
  GetAdminClinicalGoalTemplateCollectionMembershipsCollectionByCollectionIdResponses,
  GetAdminClinicalGoalTemplateCollectionsByIdData,
  GetAdminClinicalGoalTemplateCollectionsByIdErrors,
  GetAdminClinicalGoalTemplateCollectionsByIdResponses,
  GetAdminClinicalGoalTemplateCollectionsData,
  GetAdminClinicalGoalTemplateCollectionsErrors,
  GetAdminClinicalGoalTemplateCollectionsResponses,
  GetAdminClinicalGoalTemplatesArchivedData,
  GetAdminClinicalGoalTemplatesArchivedErrors,
  GetAdminClinicalGoalTemplatesArchivedResponses,
  GetAdminClinicalGoalTemplatesByIdData,
  GetAdminClinicalGoalTemplatesByIdErrors,
  GetAdminClinicalGoalTemplatesByIdResponses,
  GetAdminClinicalGoalTemplatesCatalogArchivedData,
  GetAdminClinicalGoalTemplatesCatalogArchivedErrors,
  GetAdminClinicalGoalTemplatesCatalogArchivedResponses,
  GetAdminClinicalGoalTemplatesCatalogByIdData,
  GetAdminClinicalGoalTemplatesCatalogByIdErrors,
  GetAdminClinicalGoalTemplatesCatalogByIdResponses,
  GetAdminClinicalGoalTemplatesCatalogData,
  GetAdminClinicalGoalTemplatesCatalogErrors,
  GetAdminClinicalGoalTemplatesCatalogResponses,
  GetAdminClinicalGoalTemplatesCategoriesCatalogData,
  GetAdminClinicalGoalTemplatesCategoriesCatalogErrors,
  GetAdminClinicalGoalTemplatesCategoriesCatalogResponses,
  GetAdminClinicalGoalTemplatesCategoriesData,
  GetAdminClinicalGoalTemplatesCategoriesErrors,
  GetAdminClinicalGoalTemplatesCategoriesResponses,
  GetAdminClinicalGoalTemplatesData,
  GetAdminClinicalGoalTemplatesErrors,
  GetAdminClinicalGoalTemplatesMineData,
  GetAdminClinicalGoalTemplatesMineErrors,
  GetAdminClinicalGoalTemplatesMineResponses,
  GetAdminClinicalGoalTemplatesResponses,
  GetAdminClinicalHealthMetricsArchivedData,
  GetAdminClinicalHealthMetricsArchivedErrors,
  GetAdminClinicalHealthMetricsArchivedResponses,
  GetAdminClinicalHealthMetricsByIdData,
  GetAdminClinicalHealthMetricsByIdErrors,
  GetAdminClinicalHealthMetricsByIdResponses,
  GetAdminClinicalHealthMetricsBySessionData,
  GetAdminClinicalHealthMetricsBySessionErrors,
  GetAdminClinicalHealthMetricsBySessionResponses,
  GetAdminClinicalHealthMetricsByTypeData,
  GetAdminClinicalHealthMetricsByTypeErrors,
  GetAdminClinicalHealthMetricsByTypeResponses,
  GetAdminClinicalHealthMetricsData,
  GetAdminClinicalHealthMetricsErrors,
  GetAdminClinicalHealthMetricsResponses,
  GetAdminClinicalInsuranceAuthorizationsByIdData,
  GetAdminClinicalInsuranceAuthorizationsByIdErrors,
  GetAdminClinicalInsuranceAuthorizationsByIdResponses,
  GetAdminClinicalInsuranceAuthorizationsByWorkspaceData,
  GetAdminClinicalInsuranceAuthorizationsByWorkspaceErrors,
  GetAdminClinicalInsuranceAuthorizationsByWorkspaceResponses,
  GetAdminClinicalInsuranceAuthorizationsData,
  GetAdminClinicalInsuranceAuthorizationsErrors,
  GetAdminClinicalInsuranceAuthorizationsExpiringData,
  GetAdminClinicalInsuranceAuthorizationsExpiringErrors,
  GetAdminClinicalInsuranceAuthorizationsExpiringResponses,
  GetAdminClinicalInsuranceAuthorizationsResponses,
  GetAdminClinicalIntakeTargetsActiveByPatientIdData,
  GetAdminClinicalIntakeTargetsActiveByPatientIdErrors,
  GetAdminClinicalIntakeTargetsActiveByPatientIdResponses,
  GetAdminClinicalIntakeTargetsArchivedData,
  GetAdminClinicalIntakeTargetsArchivedErrors,
  GetAdminClinicalIntakeTargetsArchivedResponses,
  GetAdminClinicalIntakeTargetsByIdData,
  GetAdminClinicalIntakeTargetsByIdErrors,
  GetAdminClinicalIntakeTargetsByIdResponses,
  GetAdminClinicalIntakeTargetsByWorkspaceData,
  GetAdminClinicalIntakeTargetsByWorkspaceErrors,
  GetAdminClinicalIntakeTargetsByWorkspaceResponses,
  GetAdminClinicalIntakeTargetsData,
  GetAdminClinicalIntakeTargetsErrors,
  GetAdminClinicalIntakeTargetsResponses,
  GetAdminClinicalMealPlansArchivedData,
  GetAdminClinicalMealPlansArchivedErrors,
  GetAdminClinicalMealPlansArchivedResponses,
  GetAdminClinicalMealPlansByIdData,
  GetAdminClinicalMealPlansByIdErrors,
  GetAdminClinicalMealPlansByIdResponses,
  GetAdminClinicalMealPlansByMealScheduleData,
  GetAdminClinicalMealPlansByMealScheduleErrors,
  GetAdminClinicalMealPlansByMealScheduleResponses,
  GetAdminClinicalMealPlansByPatientData,
  GetAdminClinicalMealPlansByPatientErrors,
  GetAdminClinicalMealPlansByPatientResponses,
  GetAdminClinicalMealPlansByWorkspaceData,
  GetAdminClinicalMealPlansByWorkspaceErrors,
  GetAdminClinicalMealPlansByWorkspaceResponses,
  GetAdminClinicalMealPlansData,
  GetAdminClinicalMealPlansErrors,
  GetAdminClinicalMealPlansResponses,
  GetAdminClinicalNotesArchivedData,
  GetAdminClinicalNotesArchivedErrors,
  GetAdminClinicalNotesArchivedResponses,
  GetAdminClinicalNotesByIdData,
  GetAdminClinicalNotesByIdErrors,
  GetAdminClinicalNotesByIdResponses,
  GetAdminClinicalNotesByNoteIdVersionsByIdData,
  GetAdminClinicalNotesByNoteIdVersionsByIdErrors,
  GetAdminClinicalNotesByNoteIdVersionsByIdResponses,
  GetAdminClinicalNotesByNoteIdVersionsData,
  GetAdminClinicalNotesByNoteIdVersionsErrors,
  GetAdminClinicalNotesByNoteIdVersionsResponses,
  GetAdminClinicalNotesByPatientData,
  GetAdminClinicalNotesByPatientErrors,
  GetAdminClinicalNotesByPatientResponses,
  GetAdminClinicalNotesByWorkspaceData,
  GetAdminClinicalNotesByWorkspaceErrors,
  GetAdminClinicalNotesByWorkspaceResponses,
  GetAdminClinicalNotesData,
  GetAdminClinicalNotesErrors,
  GetAdminClinicalNotesResponses,
  GetAdminClinicalNoteTemplatesArchivedData,
  GetAdminClinicalNoteTemplatesArchivedErrors,
  GetAdminClinicalNoteTemplatesArchivedResponses,
  GetAdminClinicalNoteTemplatesByIdData,
  GetAdminClinicalNoteTemplatesByIdErrors,
  GetAdminClinicalNoteTemplatesByIdResponses,
  GetAdminClinicalNoteTemplatesCatalogArchivedData,
  GetAdminClinicalNoteTemplatesCatalogArchivedErrors,
  GetAdminClinicalNoteTemplatesCatalogArchivedResponses,
  GetAdminClinicalNoteTemplatesCatalogByIdData,
  GetAdminClinicalNoteTemplatesCatalogByIdErrors,
  GetAdminClinicalNoteTemplatesCatalogByIdResponses,
  GetAdminClinicalNoteTemplatesCatalogData,
  GetAdminClinicalNoteTemplatesCatalogErrors,
  GetAdminClinicalNoteTemplatesCatalogResponses,
  GetAdminClinicalNoteTemplatesData,
  GetAdminClinicalNoteTemplatesErrors,
  GetAdminClinicalNoteTemplatesMineData,
  GetAdminClinicalNoteTemplatesMineErrors,
  GetAdminClinicalNoteTemplatesMineResponses,
  GetAdminClinicalNoteTemplatesResponses,
  GetAdminClinicalPatientInsuranceByIdData,
  GetAdminClinicalPatientInsuranceByIdErrors,
  GetAdminClinicalPatientInsuranceByIdResponses,
  GetAdminClinicalPatientInsuranceByWorkspaceData,
  GetAdminClinicalPatientInsuranceByWorkspaceErrors,
  GetAdminClinicalPatientInsuranceByWorkspaceResponses,
  GetAdminClinicalPatientInsuranceData,
  GetAdminClinicalPatientInsuranceErrors,
  GetAdminClinicalPatientInsuranceResponses,
  GetAdminClinicalPatientsByIdData,
  GetAdminClinicalPatientsByIdErrors,
  GetAdminClinicalPatientsByIdGoalsData,
  GetAdminClinicalPatientsByIdGoalsErrors,
  GetAdminClinicalPatientsByIdGoalsResponses,
  GetAdminClinicalPatientsByIdHealthMetricsData,
  GetAdminClinicalPatientsByIdHealthMetricsErrors,
  GetAdminClinicalPatientsByIdHealthMetricsResponses,
  GetAdminClinicalPatientsByIdInsuranceRecordsData,
  GetAdminClinicalPatientsByIdInsuranceRecordsErrors,
  GetAdminClinicalPatientsByIdInsuranceRecordsResponses,
  GetAdminClinicalPatientsByIdMedicationsData,
  GetAdminClinicalPatientsByIdMedicationsErrors,
  GetAdminClinicalPatientsByIdMedicationsResponses,
  GetAdminClinicalPatientsByIdResourceAssignmentsData,
  GetAdminClinicalPatientsByIdResourceAssignmentsErrors,
  GetAdminClinicalPatientsByIdResourceAssignmentsResponses,
  GetAdminClinicalPatientsByIdResponses,
  GetAdminClinicalPatientsByIdSupplementsData,
  GetAdminClinicalPatientsByIdSupplementsErrors,
  GetAdminClinicalPatientsByIdSupplementsResponses,
  GetAdminClinicalPatientsData,
  GetAdminClinicalPatientsErrors,
  GetAdminClinicalPatientsResponses,
  GetAdminClinicalPracticeResourcesArchivedData,
  GetAdminClinicalPracticeResourcesArchivedErrors,
  GetAdminClinicalPracticeResourcesArchivedResponses,
  GetAdminClinicalPracticeResourcesByIdData,
  GetAdminClinicalPracticeResourcesByIdErrors,
  GetAdminClinicalPracticeResourcesByIdResponses,
  GetAdminClinicalPracticeResourcesCatalogArchivedData,
  GetAdminClinicalPracticeResourcesCatalogArchivedErrors,
  GetAdminClinicalPracticeResourcesCatalogArchivedResponses,
  GetAdminClinicalPracticeResourcesCatalogByIdData,
  GetAdminClinicalPracticeResourcesCatalogByIdErrors,
  GetAdminClinicalPracticeResourcesCatalogByIdResponses,
  GetAdminClinicalPracticeResourcesCatalogData,
  GetAdminClinicalPracticeResourcesCatalogErrors,
  GetAdminClinicalPracticeResourcesCatalogResponses,
  GetAdminClinicalPracticeResourcesCategoriesCatalogData,
  GetAdminClinicalPracticeResourcesCategoriesCatalogErrors,
  GetAdminClinicalPracticeResourcesCategoriesCatalogResponses,
  GetAdminClinicalPracticeResourcesCategoriesData,
  GetAdminClinicalPracticeResourcesCategoriesErrors,
  GetAdminClinicalPracticeResourcesCategoriesResponses,
  GetAdminClinicalPracticeResourcesData,
  GetAdminClinicalPracticeResourcesErrors,
  GetAdminClinicalPracticeResourcesResponses,
  GetAdminClinicalPracticeToolsArchivedData,
  GetAdminClinicalPracticeToolsArchivedErrors,
  GetAdminClinicalPracticeToolsArchivedResponses,
  GetAdminClinicalPracticeToolsByIdData,
  GetAdminClinicalPracticeToolsByIdErrors,
  GetAdminClinicalPracticeToolsByIdResponses,
  GetAdminClinicalPracticeToolsCatalogArchivedData,
  GetAdminClinicalPracticeToolsCatalogArchivedErrors,
  GetAdminClinicalPracticeToolsCatalogArchivedResponses,
  GetAdminClinicalPracticeToolsCatalogByIdData,
  GetAdminClinicalPracticeToolsCatalogByIdErrors,
  GetAdminClinicalPracticeToolsCatalogByIdResponses,
  GetAdminClinicalPracticeToolsCatalogData,
  GetAdminClinicalPracticeToolsCatalogErrors,
  GetAdminClinicalPracticeToolsCatalogResponses,
  GetAdminClinicalPracticeToolsCategoriesCatalogData,
  GetAdminClinicalPracticeToolsCategoriesCatalogErrors,
  GetAdminClinicalPracticeToolsCategoriesCatalogResponses,
  GetAdminClinicalPracticeToolsCategoriesData,
  GetAdminClinicalPracticeToolsCategoriesErrors,
  GetAdminClinicalPracticeToolsCategoriesResponses,
  GetAdminClinicalPracticeToolsData,
  GetAdminClinicalPracticeToolsErrors,
  GetAdminClinicalPracticeToolsResponses,
  GetAdminClinicalSessionsByIdData,
  GetAdminClinicalSessionsByIdErrors,
  GetAdminClinicalSessionsByIdMealPlansData,
  GetAdminClinicalSessionsByIdMealPlansErrors,
  GetAdminClinicalSessionsByIdMealPlansResponses,
  GetAdminClinicalSessionsByIdResponses,
  GetAdminClinicalSessionsByIdSessionNotesData,
  GetAdminClinicalSessionsByIdSessionNotesErrors,
  GetAdminClinicalSessionsByIdSessionNotesResponses,
  GetAdminClinicalSessionsByPatientData,
  GetAdminClinicalSessionsByPatientErrors,
  GetAdminClinicalSessionsByPatientResponses,
  GetAdminClinicalSessionsData,
  GetAdminClinicalSessionsErrors,
  GetAdminClinicalSessionsResponses,
  GetAdminClinicalSupplementRecCacheByIdData,
  GetAdminClinicalSupplementRecCacheByIdErrors,
  GetAdminClinicalSupplementRecCacheByIdResponses,
  GetAdminClinicalSupplementRecCacheData,
  GetAdminClinicalSupplementRecCacheErrors,
  GetAdminClinicalSupplementRecCacheResponses,
  GetAdminClinicalSupplementTemplateCollectionMembershipsByIdData,
  GetAdminClinicalSupplementTemplateCollectionMembershipsByIdErrors,
  GetAdminClinicalSupplementTemplateCollectionMembershipsByIdResponses,
  GetAdminClinicalSupplementTemplateCollectionMembershipsCollectionByCollectionIdData,
  GetAdminClinicalSupplementTemplateCollectionMembershipsCollectionByCollectionIdErrors,
  GetAdminClinicalSupplementTemplateCollectionMembershipsCollectionByCollectionIdResponses,
  GetAdminClinicalSupplementTemplateCollectionsByIdData,
  GetAdminClinicalSupplementTemplateCollectionsByIdErrors,
  GetAdminClinicalSupplementTemplateCollectionsByIdResponses,
  GetAdminClinicalSupplementTemplateCollectionsData,
  GetAdminClinicalSupplementTemplateCollectionsErrors,
  GetAdminClinicalSupplementTemplateCollectionsResponses,
  GetAdminClinicalSupplementTemplatesArchivedData,
  GetAdminClinicalSupplementTemplatesArchivedErrors,
  GetAdminClinicalSupplementTemplatesArchivedResponses,
  GetAdminClinicalSupplementTemplatesByIdData,
  GetAdminClinicalSupplementTemplatesByIdErrors,
  GetAdminClinicalSupplementTemplatesByIdResponses,
  GetAdminClinicalSupplementTemplatesCatalogArchivedData,
  GetAdminClinicalSupplementTemplatesCatalogArchivedErrors,
  GetAdminClinicalSupplementTemplatesCatalogArchivedResponses,
  GetAdminClinicalSupplementTemplatesCatalogByIdData,
  GetAdminClinicalSupplementTemplatesCatalogByIdErrors,
  GetAdminClinicalSupplementTemplatesCatalogByIdResponses,
  GetAdminClinicalSupplementTemplatesCatalogData,
  GetAdminClinicalSupplementTemplatesCatalogErrors,
  GetAdminClinicalSupplementTemplatesCatalogResponses,
  GetAdminClinicalSupplementTemplatesData,
  GetAdminClinicalSupplementTemplatesErrors,
  GetAdminClinicalSupplementTemplatesMineData,
  GetAdminClinicalSupplementTemplatesMineErrors,
  GetAdminClinicalSupplementTemplatesMineResponses,
  GetAdminClinicalSupplementTemplatesResponses,
  GetAdminComplianceDocumentTemplatesByIdData,
  GetAdminComplianceDocumentTemplatesByIdErrors,
  GetAdminComplianceDocumentTemplatesByIdResponses,
  GetAdminComplianceDocumentTemplatesData,
  GetAdminComplianceDocumentTemplatesErrors,
  GetAdminComplianceDocumentTemplatesResponses,
  GetAdminComplianceOfficerDesignationsByIdData,
  GetAdminComplianceOfficerDesignationsByIdErrors,
  GetAdminComplianceOfficerDesignationsByIdResponses,
  GetAdminComplianceOfficerDesignationsData,
  GetAdminComplianceOfficerDesignationsErrors,
  GetAdminComplianceOfficerDesignationsResponses,
  GetAdminCompliancePostureData,
  GetAdminCompliancePostureErrors,
  GetAdminCompliancePostureResponses,
  GetAdminComplianceRequirementCompletionsByIdData,
  GetAdminComplianceRequirementCompletionsByIdErrors,
  GetAdminComplianceRequirementCompletionsByIdResponses,
  GetAdminComplianceRequirementCompletionsData,
  GetAdminComplianceRequirementCompletionsErrors,
  GetAdminComplianceRequirementCompletionsResponses,
  GetAdminComplianceRequirementsByIdData,
  GetAdminComplianceRequirementsByIdErrors,
  GetAdminComplianceRequirementsByIdResponses,
  GetAdminComplianceRequirementsData,
  GetAdminComplianceRequirementsErrors,
  GetAdminComplianceRequirementsResponses,
  GetAdminCompositeOperationsByIdData,
  GetAdminCompositeOperationsByIdErrors,
  GetAdminCompositeOperationsByIdResponses,
  GetAdminCompositeOperationsData,
  GetAdminCompositeOperationsErrors,
  GetAdminCompositeOperationsResponses,
  GetAdminConfigsData,
  GetAdminConfigsErrors,
  GetAdminConfigsResponses,
  GetAdminConnectorsByIdData,
  GetAdminConnectorsByIdErrors,
  GetAdminConnectorsByIdHealthieStatusData,
  GetAdminConnectorsByIdHealthieStatusErrors,
  GetAdminConnectorsByIdHealthieStatusResponses,
  GetAdminConnectorsByIdResponses,
  GetAdminConnectorsCredentialsByIdData,
  GetAdminConnectorsCredentialsByIdErrors,
  GetAdminConnectorsCredentialsByIdResponses,
  GetAdminConnectorsCredentialsData,
  GetAdminConnectorsCredentialsErrors,
  GetAdminConnectorsCredentialsResponses,
  GetAdminConnectorsOauthAppConfigsByIdData,
  GetAdminConnectorsOauthAppConfigsByIdErrors,
  GetAdminConnectorsOauthAppConfigsByIdResponses,
  GetAdminConnectorsOauthAppConfigsData,
  GetAdminConnectorsOauthAppConfigsErrors,
  GetAdminConnectorsOauthAppConfigsResponses,
  GetAdminConnectorsSyncLogsByIdData,
  GetAdminConnectorsSyncLogsByIdErrors,
  GetAdminConnectorsSyncLogsByIdResponses,
  GetAdminConnectorsSyncLogsData,
  GetAdminConnectorsSyncLogsErrors,
  GetAdminConnectorsSyncLogsResponses,
  GetAdminConnectorsWorkspaceByWorkspaceIdData,
  GetAdminConnectorsWorkspaceByWorkspaceIdErrors,
  GetAdminConnectorsWorkspaceByWorkspaceIdResponses,
  GetAdminConsentRecordsActiveData,
  GetAdminConsentRecordsActiveErrors,
  GetAdminConsentRecordsActiveResponses,
  GetAdminConsentRecordsByIdData,
  GetAdminConsentRecordsByIdErrors,
  GetAdminConsentRecordsByIdResponses,
  GetAdminConsentRecordsData,
  GetAdminConsentRecordsErrors,
  GetAdminConsentRecordsResponses,
  GetAdminContractClausesByIdData,
  GetAdminContractClausesByIdErrors,
  GetAdminContractClausesByIdResponses,
  GetAdminContractClausesData,
  GetAdminContractClausesErrors,
  GetAdminContractClausesResponses,
  GetAdminContractRenewalAlertsByIdData,
  GetAdminContractRenewalAlertsByIdErrors,
  GetAdminContractRenewalAlertsByIdResponses,
  GetAdminContractRenewalAlertsData,
  GetAdminContractRenewalAlertsErrors,
  GetAdminContractRenewalAlertsResponses,
  GetAdminContractsByIdData,
  GetAdminContractsByIdErrors,
  GetAdminContractsByIdResponses,
  GetAdminContractsData,
  GetAdminContractsErrors,
  GetAdminContractsResponses,
  GetAdminCrawlerBrowserSessionsByIdData,
  GetAdminCrawlerBrowserSessionsByIdErrors,
  GetAdminCrawlerBrowserSessionsByIdResponses,
  GetAdminCrawlerBrowserSessionsData,
  GetAdminCrawlerBrowserSessionsErrors,
  GetAdminCrawlerBrowserSessionsResponses,
  GetAdminCrawlerJobsByIdData,
  GetAdminCrawlerJobsByIdErrors,
  GetAdminCrawlerJobsByIdResponses,
  GetAdminCrawlerJobsData,
  GetAdminCrawlerJobsErrors,
  GetAdminCrawlerJobsResponses,
  GetAdminCrawlerNewsMonitorsByIdData,
  GetAdminCrawlerNewsMonitorsByIdErrors,
  GetAdminCrawlerNewsMonitorsByIdResponses,
  GetAdminCrawlerNewsMonitorsData,
  GetAdminCrawlerNewsMonitorsErrors,
  GetAdminCrawlerNewsMonitorsResponses,
  GetAdminCrawlerNewsSummariesByIdData,
  GetAdminCrawlerNewsSummariesByIdErrors,
  GetAdminCrawlerNewsSummariesByIdResponses,
  GetAdminCrawlerNewsSummariesData,
  GetAdminCrawlerNewsSummariesErrors,
  GetAdminCrawlerNewsSummariesResponses,
  GetAdminCrawlerResultsByIdData,
  GetAdminCrawlerResultsByIdErrors,
  GetAdminCrawlerResultsByIdResponses,
  GetAdminCrawlerResultsData,
  GetAdminCrawlerResultsErrors,
  GetAdminCrawlerResultsResponses,
  GetAdminCrawlerSchedulesByIdData,
  GetAdminCrawlerSchedulesByIdErrors,
  GetAdminCrawlerSchedulesByIdResponses,
  GetAdminCrawlerSchedulesData,
  GetAdminCrawlerSchedulesErrors,
  GetAdminCrawlerSchedulesResponses,
  GetAdminCrawlerSiteConfigsByIdData,
  GetAdminCrawlerSiteConfigsByIdErrors,
  GetAdminCrawlerSiteConfigsByIdResponses,
  GetAdminCrawlerSiteConfigsData,
  GetAdminCrawlerSiteConfigsErrors,
  GetAdminCrawlerSiteConfigsResponses,
  GetAdminCreditPackagesByIdData,
  GetAdminCreditPackagesByIdErrors,
  GetAdminCreditPackagesByIdResponses,
  GetAdminCreditPackagesData,
  GetAdminCreditPackagesErrors,
  GetAdminCreditPackagesResponses,
  GetAdminCreditPackagesSlugBySlugData,
  GetAdminCreditPackagesSlugBySlugErrors,
  GetAdminCreditPackagesSlugBySlugResponses,
  GetAdminCrmActivitiesByIdData,
  GetAdminCrmActivitiesByIdErrors,
  GetAdminCrmActivitiesByIdResponses,
  GetAdminCrmActivitiesWorkspaceByWorkspaceIdData,
  GetAdminCrmActivitiesWorkspaceByWorkspaceIdErrors,
  GetAdminCrmActivitiesWorkspaceByWorkspaceIdResponses,
  GetAdminCrmAddressesByIdData,
  GetAdminCrmAddressesByIdErrors,
  GetAdminCrmAddressesByIdResponses,
  GetAdminCrmAddressesEntityByEntityTypeByEntityIdData,
  GetAdminCrmAddressesEntityByEntityTypeByEntityIdErrors,
  GetAdminCrmAddressesEntityByEntityTypeByEntityIdResponses,
  GetAdminCrmCompaniesByIdData,
  GetAdminCrmCompaniesByIdErrors,
  GetAdminCrmCompaniesByIdResponses,
  GetAdminCrmCompaniesWorkspaceByWorkspaceIdData,
  GetAdminCrmCompaniesWorkspaceByWorkspaceIdErrors,
  GetAdminCrmCompaniesWorkspaceByWorkspaceIdResponses,
  GetAdminCrmContactsByIdData,
  GetAdminCrmContactsByIdErrors,
  GetAdminCrmContactsByIdResponses,
  GetAdminCrmContactsWorkspaceByWorkspaceIdArchivedData,
  GetAdminCrmContactsWorkspaceByWorkspaceIdArchivedErrors,
  GetAdminCrmContactsWorkspaceByWorkspaceIdArchivedResponses,
  GetAdminCrmContactsWorkspaceByWorkspaceIdData,
  GetAdminCrmContactsWorkspaceByWorkspaceIdErrors,
  GetAdminCrmContactsWorkspaceByWorkspaceIdResponses,
  GetAdminCrmCustomEntitiesByEntityIdVersionsByIdData,
  GetAdminCrmCustomEntitiesByEntityIdVersionsByIdErrors,
  GetAdminCrmCustomEntitiesByEntityIdVersionsByIdResponses,
  GetAdminCrmCustomEntitiesByEntityIdVersionsData,
  GetAdminCrmCustomEntitiesByEntityIdVersionsErrors,
  GetAdminCrmCustomEntitiesByEntityIdVersionsResponses,
  GetAdminCrmCustomEntitiesByIdData,
  GetAdminCrmCustomEntitiesByIdErrors,
  GetAdminCrmCustomEntitiesByIdResponses,
  GetAdminCrmCustomEntitiesWorkspaceByWorkspaceIdData,
  GetAdminCrmCustomEntitiesWorkspaceByWorkspaceIdErrors,
  GetAdminCrmCustomEntitiesWorkspaceByWorkspaceIdResponses,
  GetAdminCrmDealProductsByIdData,
  GetAdminCrmDealProductsByIdErrors,
  GetAdminCrmDealProductsByIdResponses,
  GetAdminCrmDealProductsData,
  GetAdminCrmDealProductsErrors,
  GetAdminCrmDealProductsResponses,
  GetAdminCrmDealsByIdData,
  GetAdminCrmDealsByIdErrors,
  GetAdminCrmDealsByIdResponses,
  GetAdminCrmDealsWorkspaceByWorkspaceIdData,
  GetAdminCrmDealsWorkspaceByWorkspaceIdErrors,
  GetAdminCrmDealsWorkspaceByWorkspaceIdResponses,
  GetAdminCrmEmailAddressesByIdData,
  GetAdminCrmEmailAddressesByIdErrors,
  GetAdminCrmEmailAddressesByIdResponses,
  GetAdminCrmEmailAddressesEntityByEntityTypeByEntityIdData,
  GetAdminCrmEmailAddressesEntityByEntityTypeByEntityIdErrors,
  GetAdminCrmEmailAddressesEntityByEntityTypeByEntityIdResponses,
  GetAdminCrmExportsByIdData,
  GetAdminCrmExportsByIdErrors,
  GetAdminCrmExportsByIdResponses,
  GetAdminCrmExportsWorkspaceByWorkspaceIdData,
  GetAdminCrmExportsWorkspaceByWorkspaceIdErrors,
  GetAdminCrmExportsWorkspaceByWorkspaceIdResponses,
  GetAdminCrmFieldDefinitionsByIdData,
  GetAdminCrmFieldDefinitionsByIdErrors,
  GetAdminCrmFieldDefinitionsByIdResponses,
  GetAdminCrmFieldDefinitionsEntityTypeByEntityTypeData,
  GetAdminCrmFieldDefinitionsEntityTypeByEntityTypeErrors,
  GetAdminCrmFieldDefinitionsEntityTypeByEntityTypeResponses,
  GetAdminCrmPhoneNumbersByIdData,
  GetAdminCrmPhoneNumbersByIdErrors,
  GetAdminCrmPhoneNumbersByIdResponses,
  GetAdminCrmPhoneNumbersEntityByEntityTypeByEntityIdData,
  GetAdminCrmPhoneNumbersEntityByEntityTypeByEntityIdErrors,
  GetAdminCrmPhoneNumbersEntityByEntityTypeByEntityIdResponses,
  GetAdminCrmPipelinesByIdData,
  GetAdminCrmPipelinesByIdErrors,
  GetAdminCrmPipelinesByIdResponses,
  GetAdminCrmPipelineStagesByIdData,
  GetAdminCrmPipelineStagesByIdErrors,
  GetAdminCrmPipelineStagesByIdResponses,
  GetAdminCrmPipelineStagesPipelineByPipelineIdData,
  GetAdminCrmPipelineStagesPipelineByPipelineIdErrors,
  GetAdminCrmPipelineStagesPipelineByPipelineIdResponses,
  GetAdminCrmPipelinesWorkspaceByWorkspaceIdData,
  GetAdminCrmPipelinesWorkspaceByWorkspaceIdErrors,
  GetAdminCrmPipelinesWorkspaceByWorkspaceIdResponses,
  GetAdminCrmRelationshipsByIdData,
  GetAdminCrmRelationshipsByIdErrors,
  GetAdminCrmRelationshipsByIdResponses,
  GetAdminCrmRelationshipsWorkspaceByWorkspaceIdData,
  GetAdminCrmRelationshipsWorkspaceByWorkspaceIdErrors,
  GetAdminCrmRelationshipsWorkspaceByWorkspaceIdResponses,
  GetAdminCrmRelationshipTypesByIdData,
  GetAdminCrmRelationshipTypesByIdErrors,
  GetAdminCrmRelationshipTypesByIdResponses,
  GetAdminCrmRelationshipTypesData,
  GetAdminCrmRelationshipTypesErrors,
  GetAdminCrmRelationshipTypesResponses,
  GetAdminCrmSocialProfilesByIdData,
  GetAdminCrmSocialProfilesByIdErrors,
  GetAdminCrmSocialProfilesByIdResponses,
  GetAdminCrmSocialProfilesEntityByEntityTypeByEntityIdData,
  GetAdminCrmSocialProfilesEntityByEntityTypeByEntityIdErrors,
  GetAdminCrmSocialProfilesEntityByEntityTypeByEntityIdResponses,
  GetAdminCrmSyncConfigsWorkspaceByWorkspaceIdData,
  GetAdminCrmSyncConfigsWorkspaceByWorkspaceIdErrors,
  GetAdminCrmSyncConfigsWorkspaceByWorkspaceIdResponses,
  GetAdminCrmWebsitesByIdData,
  GetAdminCrmWebsitesByIdErrors,
  GetAdminCrmWebsitesByIdResponses,
  GetAdminCrmWebsitesEntityByEntityTypeByEntityIdData,
  GetAdminCrmWebsitesEntityByEntityTypeByEntityIdErrors,
  GetAdminCrmWebsitesEntityByEntityTypeByEntityIdResponses,
  GetAdminCustomersByIdData,
  GetAdminCustomersByIdErrors,
  GetAdminCustomersByIdResponses,
  GetAdminDataSubjectRequestsByIdData,
  GetAdminDataSubjectRequestsByIdErrors,
  GetAdminDataSubjectRequestsByIdResponses,
  GetAdminDataSubjectRequestsData,
  GetAdminDataSubjectRequestsErrors,
  GetAdminDataSubjectRequestsResponses,
  GetAdminDataTransferRecordsByIdData,
  GetAdminDataTransferRecordsByIdErrors,
  GetAdminDataTransferRecordsByIdResponses,
  GetAdminDataTransferRecordsData,
  GetAdminDataTransferRecordsErrors,
  GetAdminDataTransferRecordsResponses,
  GetAdminDisclosureLogsByIdData,
  GetAdminDisclosureLogsByIdErrors,
  GetAdminDisclosureLogsByIdResponses,
  GetAdminDisclosureLogsBySubjectData,
  GetAdminDisclosureLogsBySubjectErrors,
  GetAdminDisclosureLogsBySubjectResponses,
  GetAdminDisclosureLogsData,
  GetAdminDisclosureLogsErrors,
  GetAdminDisclosureLogsResponses,
  GetAdminDocumentsStatsData,
  GetAdminDocumentsStatsErrors,
  GetAdminDocumentsStatsResponses,
  GetAdminEmailInboundAddressesByIdData,
  GetAdminEmailInboundAddressesByIdErrors,
  GetAdminEmailInboundAddressesByIdResponses,
  GetAdminEmailInboundAddressesWorkspaceByWorkspaceIdData,
  GetAdminEmailInboundAddressesWorkspaceByWorkspaceIdErrors,
  GetAdminEmailInboundAddressesWorkspaceByWorkspaceIdResponses,
  GetAdminEmailInboundReceivedAddressByInboundAddressIdData,
  GetAdminEmailInboundReceivedAddressByInboundAddressIdErrors,
  GetAdminEmailInboundReceivedAddressByInboundAddressIdResponses,
  GetAdminEmailInboundReceivedByIdData,
  GetAdminEmailInboundReceivedByIdErrors,
  GetAdminEmailInboundReceivedByIdResponses,
  GetAdminEmailInboundReceivedWorkspaceByWorkspaceIdData,
  GetAdminEmailInboundReceivedWorkspaceByWorkspaceIdErrors,
  GetAdminEmailInboundReceivedWorkspaceByWorkspaceIdResponses,
  GetAdminEmailInclusionsByIdData,
  GetAdminEmailInclusionsByIdErrors,
  GetAdminEmailInclusionsByIdResponses,
  GetAdminEmailInclusionsEmailByOutboundEmailIdData,
  GetAdminEmailInclusionsEmailByOutboundEmailIdErrors,
  GetAdminEmailInclusionsEmailByOutboundEmailIdResponses,
  GetAdminEmailMarketingCampaignsByIdData,
  GetAdminEmailMarketingCampaignsByIdErrors,
  GetAdminEmailMarketingCampaignsByIdResponses,
  GetAdminEmailMarketingCampaignsWorkspaceByWorkspaceIdData,
  GetAdminEmailMarketingCampaignsWorkspaceByWorkspaceIdErrors,
  GetAdminEmailMarketingCampaignsWorkspaceByWorkspaceIdResponses,
  GetAdminEmailMarketingGeneratedEmailsByIdData,
  GetAdminEmailMarketingGeneratedEmailsByIdErrors,
  GetAdminEmailMarketingGeneratedEmailsByIdResponses,
  GetAdminEmailMarketingGeneratedEmailsCampaignByCampaignIdData,
  GetAdminEmailMarketingGeneratedEmailsCampaignByCampaignIdErrors,
  GetAdminEmailMarketingGeneratedEmailsCampaignByCampaignIdResponses,
  GetAdminEmailMarketingSenderProfilesByIdData,
  GetAdminEmailMarketingSenderProfilesByIdErrors,
  GetAdminEmailMarketingSenderProfilesByIdResponses,
  GetAdminEmailMarketingSenderProfilesWorkspaceByWorkspaceIdData,
  GetAdminEmailMarketingSenderProfilesWorkspaceByWorkspaceIdErrors,
  GetAdminEmailMarketingSenderProfilesWorkspaceByWorkspaceIdResponses,
  GetAdminEmailMarketingTemplatesByIdData,
  GetAdminEmailMarketingTemplatesByIdErrors,
  GetAdminEmailMarketingTemplatesByIdResponses,
  GetAdminEmailMarketingTemplatesWorkspaceByWorkspaceIdData,
  GetAdminEmailMarketingTemplatesWorkspaceByWorkspaceIdErrors,
  GetAdminEmailMarketingTemplatesWorkspaceByWorkspaceIdResponses,
  GetAdminEmailMarketingUnsubscribersByIdData,
  GetAdminEmailMarketingUnsubscribersByIdErrors,
  GetAdminEmailMarketingUnsubscribersByIdResponses,
  GetAdminEmailMarketingUnsubscribersWorkspaceByWorkspaceIdData,
  GetAdminEmailMarketingUnsubscribersWorkspaceByWorkspaceIdErrors,
  GetAdminEmailMarketingUnsubscribersWorkspaceByWorkspaceIdResponses,
  GetAdminEmailOutboundEmailsByIdData,
  GetAdminEmailOutboundEmailsByIdErrors,
  GetAdminEmailOutboundEmailsByIdResponses,
  GetAdminEmailOutboundEmailsWorkspaceByWorkspaceIdContactByContactRefIdData,
  GetAdminEmailOutboundEmailsWorkspaceByWorkspaceIdContactByContactRefIdErrors,
  GetAdminEmailOutboundEmailsWorkspaceByWorkspaceIdContactByContactRefIdResponses,
  GetAdminEmailOutboundEmailsWorkspaceByWorkspaceIdData,
  GetAdminEmailOutboundEmailsWorkspaceByWorkspaceIdErrors,
  GetAdminEmailOutboundEmailsWorkspaceByWorkspaceIdResponses,
  GetAdminEmailRecipientsByIdData,
  GetAdminEmailRecipientsByIdErrors,
  GetAdminEmailRecipientsByIdResponses,
  GetAdminEmailRecipientsEmailByOutboundEmailIdData,
  GetAdminEmailRecipientsEmailByOutboundEmailIdErrors,
  GetAdminEmailRecipientsEmailByOutboundEmailIdResponses,
  GetAdminEmailSendLimitsByIdData,
  GetAdminEmailSendLimitsByIdErrors,
  GetAdminEmailSendLimitsByIdResponses,
  GetAdminEmailSendLimitsWorkspaceByWorkspaceIdData,
  GetAdminEmailSendLimitsWorkspaceByWorkspaceIdErrors,
  GetAdminEmailSendLimitsWorkspaceByWorkspaceIdResponses,
  GetAdminEmailTemplateVersionsByTemplateIdVersionsByVersionNumberData,
  GetAdminEmailTemplateVersionsByTemplateIdVersionsByVersionNumberErrors,
  GetAdminEmailTemplateVersionsByTemplateIdVersionsByVersionNumberResponses,
  GetAdminEmailTemplateVersionsTemplateByTemplateIdData,
  GetAdminEmailTemplateVersionsTemplateByTemplateIdErrors,
  GetAdminEmailTemplateVersionsTemplateByTemplateIdResponses,
  GetAdminEmailTrackingEventsByIdData,
  GetAdminEmailTrackingEventsByIdErrors,
  GetAdminEmailTrackingEventsByIdResponses,
  GetAdminEmailTrackingEventsWorkspaceByWorkspaceIdData,
  GetAdminEmailTrackingEventsWorkspaceByWorkspaceIdErrors,
  GetAdminEmailTrackingEventsWorkspaceByWorkspaceIdResponses,
  GetAdminEphiAssetsByIdData,
  GetAdminEphiAssetsByIdErrors,
  GetAdminEphiAssetsByIdResponses,
  GetAdminEphiAssetsData,
  GetAdminEphiAssetsErrors,
  GetAdminEphiAssetsResponses,
  GetAdminEphiDataFlowsByIdData,
  GetAdminEphiDataFlowsByIdErrors,
  GetAdminEphiDataFlowsByIdResponses,
  GetAdminEphiDataFlowsData,
  GetAdminEphiDataFlowsErrors,
  GetAdminEphiDataFlowsResponses,
  GetAdminExtractionAgentsByIdData,
  GetAdminExtractionAgentsByIdErrors,
  GetAdminExtractionAgentsByIdResponses,
  GetAdminExtractionAgentsData,
  GetAdminExtractionAgentsErrors,
  GetAdminExtractionAgentsResponses,
  GetAdminExtractionAnalysesByIdData,
  GetAdminExtractionAnalysesByIdErrors,
  GetAdminExtractionAnalysesByIdResponses,
  GetAdminExtractionAnalysesByResultByExtractionResultIdData,
  GetAdminExtractionAnalysesByResultByExtractionResultIdErrors,
  GetAdminExtractionAnalysesByResultByExtractionResultIdResponses,
  GetAdminExtractionAnalysesData,
  GetAdminExtractionAnalysesErrors,
  GetAdminExtractionAnalysesResponses,
  GetAdminExtractionBatchesByIdData,
  GetAdminExtractionBatchesByIdErrors,
  GetAdminExtractionBatchesByIdResponses,
  GetAdminExtractionBatchesByIdUploadUrlsData,
  GetAdminExtractionBatchesByIdUploadUrlsErrors,
  GetAdminExtractionBatchesByIdUploadUrlsResponses,
  GetAdminExtractionBatchesWorkspaceByWorkspaceIdData,
  GetAdminExtractionBatchesWorkspaceByWorkspaceIdErrors,
  GetAdminExtractionBatchesWorkspaceByWorkspaceIdResponses,
  GetAdminExtractionChunkEntityLinksByIdData,
  GetAdminExtractionChunkEntityLinksByIdErrors,
  GetAdminExtractionChunkEntityLinksByIdResponses,
  GetAdminExtractionChunkEntityLinksChunkByDocumentChunkIdData,
  GetAdminExtractionChunkEntityLinksChunkByDocumentChunkIdErrors,
  GetAdminExtractionChunkEntityLinksChunkByDocumentChunkIdResponses,
  GetAdminExtractionChunkEntityLinksData,
  GetAdminExtractionChunkEntityLinksDocumentByDocumentIdData,
  GetAdminExtractionChunkEntityLinksDocumentByDocumentIdErrors,
  GetAdminExtractionChunkEntityLinksDocumentByDocumentIdResponses,
  GetAdminExtractionChunkEntityLinksEntityByGraphNodeIdData,
  GetAdminExtractionChunkEntityLinksEntityByGraphNodeIdErrors,
  GetAdminExtractionChunkEntityLinksEntityByGraphNodeIdResponses,
  GetAdminExtractionChunkEntityLinksErrors,
  GetAdminExtractionChunkEntityLinksResponses,
  GetAdminExtractionConfigEnumsByIdData,
  GetAdminExtractionConfigEnumsByIdErrors,
  GetAdminExtractionConfigEnumsByIdResponses,
  GetAdminExtractionConfigEnumsData,
  GetAdminExtractionConfigEnumsErrors,
  GetAdminExtractionConfigEnumsResponses,
  GetAdminExtractionDocumentsByIdData,
  GetAdminExtractionDocumentsByIdErrors,
  GetAdminExtractionDocumentsByIdResponses,
  GetAdminExtractionDocumentsByIdStatusData,
  GetAdminExtractionDocumentsByIdStatusErrors,
  GetAdminExtractionDocumentsByIdStatusResponses,
  GetAdminExtractionDocumentsByIdViewData,
  GetAdminExtractionDocumentsByIdViewErrors,
  GetAdminExtractionDocumentsByIdViewResponses,
  GetAdminExtractionDocumentsData,
  GetAdminExtractionDocumentsErrors,
  GetAdminExtractionDocumentsResponses,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdByStatusByStatusData,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdByStatusByStatusErrors,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdByStatusByStatusResponses,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdData,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdErrors,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdExcludedData,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdExcludedErrors,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdExcludedResponses,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdResponses,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdReviewQueueData,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdReviewQueueErrors,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdReviewQueueResponses,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdTrainedData,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdTrainedErrors,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdTrainedResponses,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdTrashedData,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdTrashedErrors,
  GetAdminExtractionDocumentsWorkspaceByWorkspaceIdTrashedResponses,
  GetAdminExtractionDocumentsWorkspaceThroughputData,
  GetAdminExtractionDocumentsWorkspaceThroughputErrors,
  GetAdminExtractionDocumentsWorkspaceThroughputResponses,
  GetAdminExtractionResultsByIdData,
  GetAdminExtractionResultsByIdErrors,
  GetAdminExtractionResultsByIdResponses,
  GetAdminExtractionResultsData,
  GetAdminExtractionResultsDocumentByDocumentIdData,
  GetAdminExtractionResultsDocumentByDocumentIdErrors,
  GetAdminExtractionResultsDocumentByDocumentIdHistoryData,
  GetAdminExtractionResultsDocumentByDocumentIdHistoryErrors,
  GetAdminExtractionResultsDocumentByDocumentIdHistoryResponses,
  GetAdminExtractionResultsDocumentByDocumentIdPartialData,
  GetAdminExtractionResultsDocumentByDocumentIdPartialErrors,
  GetAdminExtractionResultsDocumentByDocumentIdPartialResponses,
  GetAdminExtractionResultsDocumentByDocumentIdResponses,
  GetAdminExtractionResultsErrors,
  GetAdminExtractionResultsResponses,
  GetAdminExtractionResultsWorkspaceByWorkspaceIdData,
  GetAdminExtractionResultsWorkspaceByWorkspaceIdErrors,
  GetAdminExtractionResultsWorkspaceByWorkspaceIdResponses,
  GetAdminExtractionSchemaDiscoveriesByIdData,
  GetAdminExtractionSchemaDiscoveriesByIdErrors,
  GetAdminExtractionSchemaDiscoveriesByIdResponses,
  GetAdminExtractionShadowComparisonsAnalysisData,
  GetAdminExtractionShadowComparisonsAnalysisErrors,
  GetAdminExtractionShadowComparisonsAnalysisResponses,
  GetAdminExtractionShadowComparisonsByIdData,
  GetAdminExtractionShadowComparisonsByIdErrors,
  GetAdminExtractionShadowComparisonsByIdResponses,
  GetAdminExtractionShadowComparisonsData,
  GetAdminExtractionShadowComparisonsErrors,
  GetAdminExtractionShadowComparisonsResponses,
  GetAdminExtractionWorkflowsByIdData,
  GetAdminExtractionWorkflowsByIdErrors,
  GetAdminExtractionWorkflowsByIdResponses,
  GetAdminExtractionWorkflowsData,
  GetAdminExtractionWorkflowsErrors,
  GetAdminExtractionWorkflowsResponses,
  GetAdminFeatureDefinitionsByApplicationByApplicationIdData,
  GetAdminFeatureDefinitionsByApplicationByApplicationIdErrors,
  GetAdminFeatureDefinitionsByApplicationByApplicationIdResponses,
  GetAdminFeatureDefinitionsByIdData,
  GetAdminFeatureDefinitionsByIdErrors,
  GetAdminFeatureDefinitionsByIdResponses,
  GetAdminFeatureDefinitionsData,
  GetAdminFeatureDefinitionsErrors,
  GetAdminFeatureDefinitionsResponses,
  GetAdminFeatureUsagesByIdData,
  GetAdminFeatureUsagesByIdErrors,
  GetAdminFeatureUsagesByIdResponses,
  GetAdminFeatureUsagesByTenantByTenantIdData,
  GetAdminFeatureUsagesByTenantByTenantIdErrors,
  GetAdminFeatureUsagesByTenantByTenantIdResponses,
  GetAdminFeatureUsagesData,
  GetAdminFeatureUsagesErrors,
  GetAdminFeatureUsagesResponses,
  GetAdminFieldTemplatesByIdData,
  GetAdminFieldTemplatesByIdErrors,
  GetAdminFieldTemplatesByIdResponses,
  GetAdminFieldTemplatesData,
  GetAdminFieldTemplatesErrors,
  GetAdminFieldTemplatesResponses,
  GetAdminFormDeploymentsByIdData,
  GetAdminFormDeploymentsByIdErrors,
  GetAdminFormDeploymentsByIdResponses,
  GetAdminFormDeploymentsData,
  GetAdminFormDeploymentsErrors,
  GetAdminFormDeploymentsResponses,
  GetAdminFormGenerationsByIdData,
  GetAdminFormGenerationsByIdErrors,
  GetAdminFormGenerationsByIdResponses,
  GetAdminFormGenerationsData,
  GetAdminFormGenerationsErrors,
  GetAdminFormGenerationsResponses,
  GetAdminFormVersionsByIdData,
  GetAdminFormVersionsByIdErrors,
  GetAdminFormVersionsByIdProtectionClassData,
  GetAdminFormVersionsByIdProtectionClassErrors,
  GetAdminFormVersionsByIdProtectionClassResponses,
  GetAdminFormVersionsByIdResponses,
  GetAdminFormVersionsData,
  GetAdminFormVersionsErrors,
  GetAdminFormVersionsResponses,
  GetAdminImpactAssessmentsByIdData,
  GetAdminImpactAssessmentsByIdErrors,
  GetAdminImpactAssessmentsByIdResponses,
  GetAdminImpactAssessmentsData,
  GetAdminImpactAssessmentsErrors,
  GetAdminImpactAssessmentsResponses,
  GetAdminInvitationsConsumeByTokenData,
  GetAdminInvitationsConsumeByTokenErrors,
  GetAdminInvitationsConsumeByTokenResponses,
  GetAdminInvitationsData,
  GetAdminInvitationsErrors,
  GetAdminInvitationsMeData,
  GetAdminInvitationsMeErrors,
  GetAdminInvitationsMeResponses,
  GetAdminInvitationsResponses,
  GetAdminInvoicesActivitiesByIdData,
  GetAdminInvoicesActivitiesByIdErrors,
  GetAdminInvoicesActivitiesByIdResponses,
  GetAdminInvoicesByIdData,
  GetAdminInvoicesByIdErrors,
  GetAdminInvoicesByIdResponses,
  GetAdminInvoicesContactsByIdData,
  GetAdminInvoicesContactsByIdErrors,
  GetAdminInvoicesContactsByIdResponses,
  GetAdminInvoicesContactsWorkspaceByWorkspaceIdData,
  GetAdminInvoicesContactsWorkspaceByWorkspaceIdErrors,
  GetAdminInvoicesContactsWorkspaceByWorkspaceIdResponses,
  GetAdminInvoicesLinesByIdData,
  GetAdminInvoicesLinesByIdErrors,
  GetAdminInvoicesLinesByIdResponses,
  GetAdminInvoicesPaymentsByIdData,
  GetAdminInvoicesPaymentsByIdErrors,
  GetAdminInvoicesPaymentsByIdResponses,
  GetAdminInvoicesRecurringSchedulesByIdData,
  GetAdminInvoicesRecurringSchedulesByIdErrors,
  GetAdminInvoicesRecurringSchedulesByIdResponses,
  GetAdminInvoicesRulesByIdData,
  GetAdminInvoicesRulesByIdErrors,
  GetAdminInvoicesRulesByIdResponses,
  GetAdminInvoicesTemplatesByIdData,
  GetAdminInvoicesTemplatesByIdErrors,
  GetAdminInvoicesTemplatesByIdResponses,
  GetAdminInvoicesWorkspaceByWorkspaceIdData,
  GetAdminInvoicesWorkspaceByWorkspaceIdErrors,
  GetAdminInvoicesWorkspaceByWorkspaceIdResponses,
  GetAdminIsvCrmChannelCaptureConfigByIdData,
  GetAdminIsvCrmChannelCaptureConfigByIdErrors,
  GetAdminIsvCrmChannelCaptureConfigByIdResponses,
  GetAdminIsvCrmEntityTypesApplicationByApplicationIdData,
  GetAdminIsvCrmEntityTypesApplicationByApplicationIdErrors,
  GetAdminIsvCrmEntityTypesApplicationByApplicationIdResponses,
  GetAdminIsvCrmEntityTypesByIdData,
  GetAdminIsvCrmEntityTypesByIdErrors,
  GetAdminIsvCrmEntityTypesByIdResponses,
  GetAdminIsvPricingOverridesByIdData,
  GetAdminIsvPricingOverridesByIdErrors,
  GetAdminIsvPricingOverridesByIdResponses,
  GetAdminIsvPricingOverridesData,
  GetAdminIsvPricingOverridesErrors,
  GetAdminIsvPricingOverridesResponses,
  GetAdminIsvRevenueByIdData,
  GetAdminIsvRevenueByIdErrors,
  GetAdminIsvRevenueByIdResponses,
  GetAdminIsvRevenueData,
  GetAdminIsvRevenueErrors,
  GetAdminIsvRevenueResponses,
  GetAdminLedgerByAccountByAccountIdData,
  GetAdminLedgerByAccountByAccountIdErrors,
  GetAdminLedgerByAccountByAccountIdResponses,
  GetAdminLedgerByIdData,
  GetAdminLedgerByIdErrors,
  GetAdminLedgerByIdResponses,
  GetAdminLedgerData,
  GetAdminLedgerErrors,
  GetAdminLedgerResponses,
  GetAdminLegalAcceptancesByIdData,
  GetAdminLegalAcceptancesByIdErrors,
  GetAdminLegalAcceptancesByIdResponses,
  GetAdminLegalAcceptancesData,
  GetAdminLegalAcceptancesErrors,
  GetAdminLegalAcceptancesLatestData,
  GetAdminLegalAcceptancesLatestErrors,
  GetAdminLegalAcceptancesLatestResponses,
  GetAdminLegalAcceptancesResponses,
  GetAdminLegalDocumentsByIdData,
  GetAdminLegalDocumentsByIdErrors,
  GetAdminLegalDocumentsByIdResponses,
  GetAdminLegalDocumentsByLocaleData,
  GetAdminLegalDocumentsByLocaleErrors,
  GetAdminLegalDocumentsByLocaleResponses,
  GetAdminLegalDocumentsData,
  GetAdminLegalDocumentsErrors,
  GetAdminLegalDocumentsForApplicationData,
  GetAdminLegalDocumentsForApplicationErrors,
  GetAdminLegalDocumentsForApplicationResponses,
  GetAdminLegalDocumentsResponses,
  GetAdminLlmAnalyticsByIdData,
  GetAdminLlmAnalyticsByIdErrors,
  GetAdminLlmAnalyticsByIdResponses,
  GetAdminLlmAnalyticsCostsData,
  GetAdminLlmAnalyticsCostsErrors,
  GetAdminLlmAnalyticsCostsResponses,
  GetAdminLlmAnalyticsData,
  GetAdminLlmAnalyticsErrors,
  GetAdminLlmAnalyticsPlatformData,
  GetAdminLlmAnalyticsPlatformErrors,
  GetAdminLlmAnalyticsPlatformResponses,
  GetAdminLlmAnalyticsResponses,
  GetAdminLlmAnalyticsSummaryData,
  GetAdminLlmAnalyticsSummaryErrors,
  GetAdminLlmAnalyticsSummaryResponses,
  GetAdminLlmAnalyticsUsageData,
  GetAdminLlmAnalyticsUsageErrors,
  GetAdminLlmAnalyticsUsageResponses,
  GetAdminLlmAnalyticsWorkspaceData,
  GetAdminLlmAnalyticsWorkspaceErrors,
  GetAdminLlmAnalyticsWorkspaceResponses,
  GetAdminMeetingActionItemsByIdData,
  GetAdminMeetingActionItemsByIdErrors,
  GetAdminMeetingActionItemsByIdResponses,
  GetAdminMeetingActionItemsData,
  GetAdminMeetingActionItemsErrors,
  GetAdminMeetingActionItemsResponses,
  GetAdminMeetingsByIdData,
  GetAdminMeetingsByIdErrors,
  GetAdminMeetingsByIdResponses,
  GetAdminMeetingsData,
  GetAdminMeetingsErrors,
  GetAdminMeetingsResponses,
  GetAdminMeetingTranscriptsByIdData,
  GetAdminMeetingTranscriptsByIdErrors,
  GetAdminMeetingTranscriptsByIdResponses,
  GetAdminMeetingTranscriptsData,
  GetAdminMeetingTranscriptsErrors,
  GetAdminMeetingTranscriptsResponses,
  GetAdminMessageFeedbackData,
  GetAdminMessageFeedbackErrors,
  GetAdminMessageFeedbackResponses,
  GetAdminMessagesByIdData,
  GetAdminMessagesByIdErrors,
  GetAdminMessagesByIdResponses,
  GetAdminMessagesData,
  GetAdminMessagesErrors,
  GetAdminMessagesResponses,
  GetAdminMessagesSearchData,
  GetAdminMessagesSearchErrors,
  GetAdminMessagesSearchResponses,
  GetAdminMessagesSemanticSearchData,
  GetAdminMessagesSemanticSearchErrors,
  GetAdminMessagesSemanticSearchResponses,
  GetAdminNotificationLogsByIdData,
  GetAdminNotificationLogsByIdErrors,
  GetAdminNotificationLogsByIdResponses,
  GetAdminNotificationLogsData,
  GetAdminNotificationLogsErrors,
  GetAdminNotificationLogsResponses,
  GetAdminNotificationLogsStatsData,
  GetAdminNotificationLogsStatsErrors,
  GetAdminNotificationLogsStatsResponses,
  GetAdminNotificationMethodsByIdData,
  GetAdminNotificationMethodsByIdErrors,
  GetAdminNotificationMethodsByIdResponses,
  GetAdminNotificationMethodsData,
  GetAdminNotificationMethodsErrors,
  GetAdminNotificationMethodsResponses,
  GetAdminNotificationPreferencesByIdData,
  GetAdminNotificationPreferencesByIdErrors,
  GetAdminNotificationPreferencesByIdResponses,
  GetAdminNotificationPreferencesData,
  GetAdminNotificationPreferencesErrors,
  GetAdminNotificationPreferencesResponses,
  GetAdminOwnershipTransfersData,
  GetAdminOwnershipTransfersErrors,
  GetAdminOwnershipTransfersResponses,
  GetAdminPaymentMethodsByIdData,
  GetAdminPaymentMethodsByIdErrors,
  GetAdminPaymentMethodsByIdResponses,
  GetAdminPaymentMethodsData,
  GetAdminPaymentMethodsErrors,
  GetAdminPaymentMethodsResponses,
  GetAdminPermissionsByIdData,
  GetAdminPermissionsByIdErrors,
  GetAdminPermissionsByIdResponses,
  GetAdminPermissionsData,
  GetAdminPermissionsErrors,
  GetAdminPermissionsMetaData,
  GetAdminPermissionsMetaErrors,
  GetAdminPermissionsMetaResponses,
  GetAdminPermissionsPresetsByIdData,
  GetAdminPermissionsPresetsByIdErrors,
  GetAdminPermissionsPresetsByIdResponses,
  GetAdminPermissionsPresetsData,
  GetAdminPermissionsPresetsErrors,
  GetAdminPermissionsPresetsResponses,
  GetAdminPermissionsResponses,
  GetAdminPipelineExecutionsByIdData,
  GetAdminPipelineExecutionsByIdErrors,
  GetAdminPipelineExecutionsByIdResponses,
  GetAdminPipelineExecutionsByPipelineByPipelineIdData,
  GetAdminPipelineExecutionsByPipelineByPipelineIdErrors,
  GetAdminPipelineExecutionsByPipelineByPipelineIdResponses,
  GetAdminPipelineExecutionsData,
  GetAdminPipelineExecutionsErrors,
  GetAdminPipelineExecutionsResponses,
  GetAdminPipelineNodeExecutionsByExecutionByPipelineExecutionIdData,
  GetAdminPipelineNodeExecutionsByExecutionByPipelineExecutionIdErrors,
  GetAdminPipelineNodeExecutionsByExecutionByPipelineExecutionIdResponses,
  GetAdminPipelineNodeExecutionsByIdData,
  GetAdminPipelineNodeExecutionsByIdErrors,
  GetAdminPipelineNodeExecutionsByIdResponses,
  GetAdminPipelineNodesByIdData,
  GetAdminPipelineNodesByIdErrors,
  GetAdminPipelineNodesByIdResponses,
  GetAdminPipelineNodesByPipelineByPipelineIdData,
  GetAdminPipelineNodesByPipelineByPipelineIdErrors,
  GetAdminPipelineNodesByPipelineByPipelineIdResponses,
  GetAdminPipelineNodesData,
  GetAdminPipelineNodesErrors,
  GetAdminPipelineNodesResponses,
  GetAdminPipelinesByIdData,
  GetAdminPipelinesByIdErrors,
  GetAdminPipelinesByIdResponses,
  GetAdminPipelinesBySlugBySlugData,
  GetAdminPipelinesBySlugBySlugErrors,
  GetAdminPipelinesBySlugBySlugResponses,
  GetAdminPipelinesByWorkflowTypeData,
  GetAdminPipelinesByWorkflowTypeErrors,
  GetAdminPipelinesByWorkflowTypeResponses,
  GetAdminPipelinesData,
  GetAdminPipelinesErrors,
  GetAdminPipelinesResponses,
  GetAdminPlanBundlesCanEnableData,
  GetAdminPlanBundlesCanEnableErrors,
  GetAdminPlanBundlesCanEnableResponses,
  GetAdminPlanBundlesTemplatesData,
  GetAdminPlanBundlesTemplatesErrors,
  GetAdminPlanBundlesTemplatesResponses,
  GetAdminPlanFeatureAllocationsByIdData,
  GetAdminPlanFeatureAllocationsByIdErrors,
  GetAdminPlanFeatureAllocationsByIdResponses,
  GetAdminPlanFeatureAllocationsByPlanByPlanIdData,
  GetAdminPlanFeatureAllocationsByPlanByPlanIdErrors,
  GetAdminPlanFeatureAllocationsByPlanByPlanIdResponses,
  GetAdminPlanFeatureAllocationsData,
  GetAdminPlanFeatureAllocationsErrors,
  GetAdminPlanFeatureAllocationsResponses,
  GetAdminPlansByIdData,
  GetAdminPlansByIdErrors,
  GetAdminPlansByIdResponses,
  GetAdminPlansData,
  GetAdminPlansErrors,
  GetAdminPlansResponses,
  GetAdminPlansSlugBySlugData,
  GetAdminPlansSlugBySlugErrors,
  GetAdminPlansSlugBySlugResponses,
  GetAdminPlatformPricingConfigsByIdData,
  GetAdminPlatformPricingConfigsByIdErrors,
  GetAdminPlatformPricingConfigsByIdResponses,
  GetAdminPlatformPricingConfigsData,
  GetAdminPlatformPricingConfigsErrors,
  GetAdminPlatformPricingConfigsResponses,
  GetAdminPlatformTonesByBrandByBrandIdentityIdData,
  GetAdminPlatformTonesByBrandByBrandIdentityIdErrors,
  GetAdminPlatformTonesByBrandByBrandIdentityIdResponses,
  GetAdminPlatformTonesByIdData,
  GetAdminPlatformTonesByIdErrors,
  GetAdminPlatformTonesByIdResponses,
  GetAdminPlatformTonesData,
  GetAdminPlatformTonesErrors,
  GetAdminPlatformTonesResponses,
  GetAdminPolicyReviewSchedulesByIdData,
  GetAdminPolicyReviewSchedulesByIdErrors,
  GetAdminPolicyReviewSchedulesByIdResponses,
  GetAdminPolicyReviewSchedulesData,
  GetAdminPolicyReviewSchedulesErrors,
  GetAdminPolicyReviewSchedulesResponses,
  GetAdminPortalChangeRequestsData,
  GetAdminPortalChangeRequestsErrors,
  GetAdminPortalChangeRequestsResponses,
  GetAdminPortalInvitationsData,
  GetAdminPortalInvitationsErrors,
  GetAdminPortalInvitationsResponses,
  GetAdminPostProcessingHooksByIdData,
  GetAdminPostProcessingHooksByIdErrors,
  GetAdminPostProcessingHooksByIdResponses,
  GetAdminPostProcessingHooksData,
  GetAdminPostProcessingHooksErrors,
  GetAdminPostProcessingHooksResponses,
  GetAdminPreferencesByKeyData,
  GetAdminPreferencesByKeyErrors,
  GetAdminPreferencesByKeyResponses,
  GetAdminPreferencesData,
  GetAdminPreferencesErrors,
  GetAdminPreferencesResponses,
  GetAdminPricingStrategiesByIdData,
  GetAdminPricingStrategiesByIdErrors,
  GetAdminPricingStrategiesByIdResponses,
  GetAdminPricingStrategiesData,
  GetAdminPricingStrategiesErrors,
  GetAdminPricingStrategiesResponses,
  GetAdminProcessingActivitiesByIdData,
  GetAdminProcessingActivitiesByIdErrors,
  GetAdminProcessingActivitiesByIdResponses,
  GetAdminProcessingActivitiesData,
  GetAdminProcessingActivitiesErrors,
  GetAdminProcessingActivitiesResponses,
  GetAdminQuoteRequestsByIdData,
  GetAdminQuoteRequestsByIdErrors,
  GetAdminQuoteRequestsByIdResponses,
  GetAdminQuoteRequestsWorkspaceByWorkspaceIdData,
  GetAdminQuoteRequestsWorkspaceByWorkspaceIdErrors,
  GetAdminQuoteRequestsWorkspaceByWorkspaceIdResponses,
  GetAdminRecipesByIdData,
  GetAdminRecipesByIdErrors,
  GetAdminRecipesByIdResponses,
  GetAdminRecipesCollectionRecipesByIdData,
  GetAdminRecipesCollectionRecipesByIdErrors,
  GetAdminRecipesCollectionRecipesByIdResponses,
  GetAdminRecipesCollectionRecipesCollectionByCollectionIdData,
  GetAdminRecipesCollectionRecipesCollectionByCollectionIdErrors,
  GetAdminRecipesCollectionRecipesCollectionByCollectionIdResponses,
  GetAdminRecipesCollectionsByIdData,
  GetAdminRecipesCollectionsByIdErrors,
  GetAdminRecipesCollectionsByIdResponses,
  GetAdminRecipesCollectionsWorkspaceByWorkspaceIdData,
  GetAdminRecipesCollectionsWorkspaceByWorkspaceIdErrors,
  GetAdminRecipesCollectionsWorkspaceByWorkspaceIdResponses,
  GetAdminRecipesEnrichmentJobsByIdData,
  GetAdminRecipesEnrichmentJobsByIdErrors,
  GetAdminRecipesEnrichmentJobsByIdResponses,
  GetAdminRecipesEnrichmentJobsRecipeByRecipeIdData,
  GetAdminRecipesEnrichmentJobsRecipeByRecipeIdErrors,
  GetAdminRecipesEnrichmentJobsRecipeByRecipeIdResponses,
  GetAdminRecipesFavoritesByIdData,
  GetAdminRecipesFavoritesByIdErrors,
  GetAdminRecipesFavoritesByIdResponses,
  GetAdminRecipesFavoritesRecipeByRecipeIdData,
  GetAdminRecipesFavoritesRecipeByRecipeIdErrors,
  GetAdminRecipesFavoritesRecipeByRecipeIdResponses,
  GetAdminRecipesFavoritesWorkspaceByWorkspaceIdData,
  GetAdminRecipesFavoritesWorkspaceByWorkspaceIdErrors,
  GetAdminRecipesFavoritesWorkspaceByWorkspaceIdResponses,
  GetAdminRecipesFoodItemsApplicationByApplicationIdData,
  GetAdminRecipesFoodItemsApplicationByApplicationIdErrors,
  GetAdminRecipesFoodItemsApplicationByApplicationIdResponses,
  GetAdminRecipesFoodItemsByIdData,
  GetAdminRecipesFoodItemsByIdErrors,
  GetAdminRecipesFoodItemsByIdResponses,
  GetAdminRecipesIngredientsByIdData,
  GetAdminRecipesIngredientsByIdErrors,
  GetAdminRecipesIngredientsByIdResponses,
  GetAdminRecipesIngredientsRecipeByRecipeIdData,
  GetAdminRecipesIngredientsRecipeByRecipeIdErrors,
  GetAdminRecipesIngredientsRecipeByRecipeIdResponses,
  GetAdminRecipesMealSchedulesByIdData,
  GetAdminRecipesMealSchedulesByIdErrors,
  GetAdminRecipesMealSchedulesByIdResponses,
  GetAdminRecipesMealSchedulesWorkspaceByWorkspaceIdData,
  GetAdminRecipesMealSchedulesWorkspaceByWorkspaceIdErrors,
  GetAdminRecipesMealSchedulesWorkspaceByWorkspaceIdResponses,
  GetAdminRecipesNutritionSummariesByIdData,
  GetAdminRecipesNutritionSummariesByIdErrors,
  GetAdminRecipesNutritionSummariesByIdResponses,
  GetAdminRecipesNutritionSummariesMealScheduleByMealScheduleIdData,
  GetAdminRecipesNutritionSummariesMealScheduleByMealScheduleIdErrors,
  GetAdminRecipesNutritionSummariesMealScheduleByMealScheduleIdResponses,
  GetAdminRecipesRecipeNutritionsByIdData,
  GetAdminRecipesRecipeNutritionsByIdErrors,
  GetAdminRecipesRecipeNutritionsByIdResponses,
  GetAdminRecipesRecipeNutritionsRecipeByRecipeIdData,
  GetAdminRecipesRecipeNutritionsRecipeByRecipeIdErrors,
  GetAdminRecipesRecipeNutritionsRecipeByRecipeIdResponses,
  GetAdminRecipesRecipeTagsByIdData,
  GetAdminRecipesRecipeTagsByIdErrors,
  GetAdminRecipesRecipeTagsByIdResponses,
  GetAdminRecipesRecipeTagsRecipeByRecipeIdData,
  GetAdminRecipesRecipeTagsRecipeByRecipeIdErrors,
  GetAdminRecipesRecipeTagsRecipeByRecipeIdResponses,
  GetAdminRecipesScheduledMealsByIdData,
  GetAdminRecipesScheduledMealsByIdErrors,
  GetAdminRecipesScheduledMealsByIdResponses,
  GetAdminRecipesScheduledMealsMealScheduleByMealScheduleIdData,
  GetAdminRecipesScheduledMealsMealScheduleByMealScheduleIdErrors,
  GetAdminRecipesScheduledMealsMealScheduleByMealScheduleIdResponses,
  GetAdminRecipesShoppingListItemsByIdData,
  GetAdminRecipesShoppingListItemsByIdErrors,
  GetAdminRecipesShoppingListItemsByIdResponses,
  GetAdminRecipesShoppingListItemsShoppingListByShoppingListIdData,
  GetAdminRecipesShoppingListItemsShoppingListByShoppingListIdErrors,
  GetAdminRecipesShoppingListItemsShoppingListByShoppingListIdResponses,
  GetAdminRecipesShoppingListsByIdData,
  GetAdminRecipesShoppingListsByIdErrors,
  GetAdminRecipesShoppingListsByIdResponses,
  GetAdminRecipesShoppingListsWorkspaceByWorkspaceIdData,
  GetAdminRecipesShoppingListsWorkspaceByWorkspaceIdErrors,
  GetAdminRecipesShoppingListsWorkspaceByWorkspaceIdResponses,
  GetAdminRecipesTagsApplicationByApplicationIdData,
  GetAdminRecipesTagsApplicationByApplicationIdErrors,
  GetAdminRecipesTagsApplicationByApplicationIdResponses,
  GetAdminRecipesTagsByIdData,
  GetAdminRecipesTagsByIdErrors,
  GetAdminRecipesTagsByIdResponses,
  GetAdminRecipesWorkspaceByWorkspaceIdContactByContactIdData,
  GetAdminRecipesWorkspaceByWorkspaceIdContactByContactIdErrors,
  GetAdminRecipesWorkspaceByWorkspaceIdContactByContactIdResponses,
  GetAdminRecipesWorkspaceByWorkspaceIdData,
  GetAdminRecipesWorkspaceByWorkspaceIdErrors,
  GetAdminRecipesWorkspaceByWorkspaceIdPublishedData,
  GetAdminRecipesWorkspaceByWorkspaceIdPublishedErrors,
  GetAdminRecipesWorkspaceByWorkspaceIdPublishedResponses,
  GetAdminRecipesWorkspaceByWorkspaceIdResponses,
  GetAdminRetentionPoliciesByIdData,
  GetAdminRetentionPoliciesByIdErrors,
  GetAdminRetentionPoliciesByIdResponses,
  GetAdminRetentionPoliciesData,
  GetAdminRetentionPoliciesErrors,
  GetAdminRetentionPoliciesResponses,
  GetAdminReviewQueueMembershipsByIdData,
  GetAdminReviewQueueMembershipsByIdErrors,
  GetAdminReviewQueueMembershipsByIdResponses,
  GetAdminReviewQueueMembershipsData,
  GetAdminReviewQueueMembershipsErrors,
  GetAdminReviewQueueMembershipsResponses,
  GetAdminReviewQueuesByIdData,
  GetAdminReviewQueuesByIdErrors,
  GetAdminReviewQueuesByIdResponses,
  GetAdminReviewQueuesData,
  GetAdminReviewQueuesErrors,
  GetAdminReviewQueuesResponses,
  GetAdminReviewQueuesSummariesData,
  GetAdminReviewQueuesSummariesErrors,
  GetAdminReviewQueuesSummariesResponses,
  GetAdminReviewsByIdData,
  GetAdminReviewsByIdErrors,
  GetAdminReviewsByIdResponses,
  GetAdminReviewsData,
  GetAdminReviewsErrors,
  GetAdminReviewsResponses,
  GetAdminRiskAssessmentsByIdData,
  GetAdminRiskAssessmentsByIdErrors,
  GetAdminRiskAssessmentsByIdResponses,
  GetAdminRiskAssessmentsData,
  GetAdminRiskAssessmentsErrors,
  GetAdminRiskAssessmentsResponses,
  GetAdminRolesByIdData,
  GetAdminRolesByIdErrors,
  GetAdminRolesByIdResponses,
  GetAdminRolesData,
  GetAdminRolesErrors,
  GetAdminRolesResponses,
  GetAdminScanResultsByIdData,
  GetAdminScanResultsByIdErrors,
  GetAdminScanResultsByIdResponses,
  GetAdminScanResultsData,
  GetAdminScanResultsErrors,
  GetAdminScanResultsResponses,
  GetAdminSchedulingAvailabilityRulesByEventTypeData,
  GetAdminSchedulingAvailabilityRulesByEventTypeErrors,
  GetAdminSchedulingAvailabilityRulesByEventTypeResponses,
  GetAdminSchedulingAvailabilityRulesByIdData,
  GetAdminSchedulingAvailabilityRulesByIdErrors,
  GetAdminSchedulingAvailabilityRulesByIdResponses,
  GetAdminSchedulingAvailabilityRulesByUserData,
  GetAdminSchedulingAvailabilityRulesByUserErrors,
  GetAdminSchedulingAvailabilityRulesByUserResponses,
  GetAdminSchedulingAvailabilityRulesData,
  GetAdminSchedulingAvailabilityRulesErrors,
  GetAdminSchedulingAvailabilityRulesResponses,
  GetAdminSchedulingBookingsByBookerData,
  GetAdminSchedulingBookingsByBookerErrors,
  GetAdminSchedulingBookingsByBookerResponses,
  GetAdminSchedulingBookingsByIdData,
  GetAdminSchedulingBookingsByIdErrors,
  GetAdminSchedulingBookingsByIdResponses,
  GetAdminSchedulingBookingsData,
  GetAdminSchedulingBookingsErrors,
  GetAdminSchedulingBookingsResponses,
  GetAdminSchedulingCalendarSyncsByIdData,
  GetAdminSchedulingCalendarSyncsByIdErrors,
  GetAdminSchedulingCalendarSyncsByIdResponses,
  GetAdminSchedulingCalendarSyncsData,
  GetAdminSchedulingCalendarSyncsErrors,
  GetAdminSchedulingCalendarSyncsResponses,
  GetAdminSchedulingEventsByDateRangeData,
  GetAdminSchedulingEventsByDateRangeErrors,
  GetAdminSchedulingEventsByDateRangeResponses,
  GetAdminSchedulingEventsByIdData,
  GetAdminSchedulingEventsByIdErrors,
  GetAdminSchedulingEventsByIdResponses,
  GetAdminSchedulingEventsByParticipantData,
  GetAdminSchedulingEventsByParticipantErrors,
  GetAdminSchedulingEventsByParticipantResponses,
  GetAdminSchedulingEventsData,
  GetAdminSchedulingEventsErrors,
  GetAdminSchedulingEventsResponses,
  GetAdminSchedulingEventTypesByIdData,
  GetAdminSchedulingEventTypesByIdErrors,
  GetAdminSchedulingEventTypesByIdResponses,
  GetAdminSchedulingEventTypesBySlugData,
  GetAdminSchedulingEventTypesBySlugErrors,
  GetAdminSchedulingEventTypesBySlugResponses,
  GetAdminSchedulingEventTypesData,
  GetAdminSchedulingEventTypesErrors,
  GetAdminSchedulingEventTypesResponses,
  GetAdminSchedulingLocationsByIdData,
  GetAdminSchedulingLocationsByIdErrors,
  GetAdminSchedulingLocationsByIdResponses,
  GetAdminSchedulingLocationsByTypeData,
  GetAdminSchedulingLocationsByTypeErrors,
  GetAdminSchedulingLocationsByTypeResponses,
  GetAdminSchedulingLocationsData,
  GetAdminSchedulingLocationsErrors,
  GetAdminSchedulingLocationsResponses,
  GetAdminSchedulingParticipantsByIdData,
  GetAdminSchedulingParticipantsByIdErrors,
  GetAdminSchedulingParticipantsByIdResponses,
  GetAdminSchedulingParticipantsData,
  GetAdminSchedulingParticipantsErrors,
  GetAdminSchedulingParticipantsResponses,
  GetAdminSchedulingRemindersByIdData,
  GetAdminSchedulingRemindersByIdErrors,
  GetAdminSchedulingRemindersByIdResponses,
  GetAdminSchedulingRemindersData,
  GetAdminSchedulingRemindersErrors,
  GetAdminSchedulingRemindersResponses,
  GetAdminSearchAnalyticsData,
  GetAdminSearchAnalyticsErrors,
  GetAdminSearchAnalyticsResponses,
  GetAdminSearchAnalyticsSummaryData,
  GetAdminSearchAnalyticsSummaryErrors,
  GetAdminSearchAnalyticsSummaryResponses,
  GetAdminSearchData,
  GetAdminSearchErrors,
  GetAdminSearchHealthData,
  GetAdminSearchHealthErrors,
  GetAdminSearchHealthResponses,
  GetAdminSearchIndexesData,
  GetAdminSearchIndexesErrors,
  GetAdminSearchIndexesResponses,
  GetAdminSearchResponses,
  GetAdminSearchSavedData,
  GetAdminSearchSavedErrors,
  GetAdminSearchSavedResponses,
  GetAdminSearchSemanticData,
  GetAdminSearchSemanticErrors,
  GetAdminSearchSemanticResponses,
  GetAdminSearchStatsData,
  GetAdminSearchStatsErrors,
  GetAdminSearchStatsResponses,
  GetAdminSearchStatusData,
  GetAdminSearchStatusErrors,
  GetAdminSearchStatusResponses,
  GetAdminSearchSuggestData,
  GetAdminSearchSuggestErrors,
  GetAdminSearchSuggestResponses,
  GetAdminSettlementsByIdData,
  GetAdminSettlementsByIdErrors,
  GetAdminSettlementsByIdResponses,
  GetAdminSettlementsData,
  GetAdminSettlementsErrors,
  GetAdminSettlementsResponses,
  GetAdminSettlementStatementsByIdData,
  GetAdminSettlementStatementsByIdErrors,
  GetAdminSettlementStatementsByIdResponses,
  GetAdminSettlementStatementsData,
  GetAdminSettlementStatementsErrors,
  GetAdminSettlementStatementsResponses,
  GetAdminSocialAccountsByIdData,
  GetAdminSocialAccountsByIdErrors,
  GetAdminSocialAccountsByIdResponses,
  GetAdminSocialAccountsPlatformByPlatformData,
  GetAdminSocialAccountsPlatformByPlatformErrors,
  GetAdminSocialAccountsPlatformByPlatformResponses,
  GetAdminSocialAccountsWorkspaceByWorkspaceIdData,
  GetAdminSocialAccountsWorkspaceByWorkspaceIdErrors,
  GetAdminSocialAccountsWorkspaceByWorkspaceIdResponses,
  GetAdminSocialCampaignsByIdData,
  GetAdminSocialCampaignsByIdErrors,
  GetAdminSocialCampaignsByIdResponses,
  GetAdminSocialCampaignsData,
  GetAdminSocialCampaignsErrors,
  GetAdminSocialCampaignsResponses,
  GetAdminSocialMetricsAccountBySocialAccountIdData,
  GetAdminSocialMetricsAccountBySocialAccountIdErrors,
  GetAdminSocialMetricsAccountBySocialAccountIdResponses,
  GetAdminSocialMetricsByIdData,
  GetAdminSocialMetricsByIdErrors,
  GetAdminSocialMetricsByIdResponses,
  GetAdminSocialMetricsCampaignBySocialCampaignIdData,
  GetAdminSocialMetricsCampaignBySocialCampaignIdErrors,
  GetAdminSocialMetricsCampaignBySocialCampaignIdResponses,
  GetAdminSocialMetricsPostBySocialPostIdData,
  GetAdminSocialMetricsPostBySocialPostIdErrors,
  GetAdminSocialMetricsPostBySocialPostIdLatestData,
  GetAdminSocialMetricsPostBySocialPostIdLatestErrors,
  GetAdminSocialMetricsPostBySocialPostIdLatestResponses,
  GetAdminSocialMetricsPostBySocialPostIdResponses,
  GetAdminSocialPostsAccountBySocialAccountIdData,
  GetAdminSocialPostsAccountBySocialAccountIdErrors,
  GetAdminSocialPostsAccountBySocialAccountIdResponses,
  GetAdminSocialPostsByIdData,
  GetAdminSocialPostsByIdErrors,
  GetAdminSocialPostsByIdResponses,
  GetAdminSocialPostsCampaignBySocialCampaignIdData,
  GetAdminSocialPostsCampaignBySocialCampaignIdErrors,
  GetAdminSocialPostsCampaignBySocialCampaignIdResponses,
  GetAdminSocialPostsScheduledData,
  GetAdminSocialPostsScheduledErrors,
  GetAdminSocialPostsScheduledResponses,
  GetAdminSocialPostsWorkspaceByWorkspaceIdData,
  GetAdminSocialPostsWorkspaceByWorkspaceIdErrors,
  GetAdminSocialPostsWorkspaceByWorkspaceIdResponses,
  GetAdminSocialTrendingHistoryByIdData,
  GetAdminSocialTrendingHistoryByIdErrors,
  GetAdminSocialTrendingHistoryByIdResponses,
  GetAdminSocialTrendingHistoryRangeData,
  GetAdminSocialTrendingHistoryRangeErrors,
  GetAdminSocialTrendingHistoryRangeResponses,
  GetAdminSocialTrendingHistoryWorkspaceByWorkspaceIdData,
  GetAdminSocialTrendingHistoryWorkspaceByWorkspaceIdErrors,
  GetAdminSocialTrendingHistoryWorkspaceByWorkspaceIdResponses,
  GetAdminSocialTrendingItemsByIdData,
  GetAdminSocialTrendingItemsByIdErrors,
  GetAdminSocialTrendingItemsByIdResponses,
  GetAdminSocialTrendingItemsSnapshotBySnapshotIdData,
  GetAdminSocialTrendingItemsSnapshotBySnapshotIdErrors,
  GetAdminSocialTrendingItemsSnapshotBySnapshotIdResponses,
  GetAdminSocialTrendingWatchesByIdData,
  GetAdminSocialTrendingWatchesByIdErrors,
  GetAdminSocialTrendingWatchesByIdResponses,
  GetAdminSocialTrendingWatchesWorkspaceByWorkspaceIdData,
  GetAdminSocialTrendingWatchesWorkspaceByWorkspaceIdErrors,
  GetAdminSocialTrendingWatchesWorkspaceByWorkspaceIdResponses,
  GetAdminStorageFilesByChecksumData,
  GetAdminStorageFilesByChecksumErrors,
  GetAdminStorageFilesByChecksumResponses,
  GetAdminStorageFilesByIdData,
  GetAdminStorageFilesByIdErrors,
  GetAdminStorageFilesByIdResponses,
  GetAdminStorageFilesChildrenData,
  GetAdminStorageFilesChildrenErrors,
  GetAdminStorageFilesChildrenResponses,
  GetAdminStorageFilesData,
  GetAdminStorageFilesErrors,
  GetAdminStorageFilesResponses,
  GetAdminStorageRecommendationsData,
  GetAdminStorageRecommendationsErrors,
  GetAdminStorageRecommendationsPendingData,
  GetAdminStorageRecommendationsPendingErrors,
  GetAdminStorageRecommendationsPendingResponses,
  GetAdminStorageRecommendationsResponses,
  GetAdminStorageStatsData,
  GetAdminStorageStatsErrors,
  GetAdminStorageStatsResponses,
  GetAdminStorageStatsTenantByTenantIdData,
  GetAdminStorageStatsTenantByTenantIdErrors,
  GetAdminStorageStatsTenantByTenantIdResponses,
  GetAdminSubscriptionsByIdData,
  GetAdminSubscriptionsByIdErrors,
  GetAdminSubscriptionsByIdResponses,
  GetAdminSubscriptionsByTenantByTenantIdData,
  GetAdminSubscriptionsByTenantByTenantIdErrors,
  GetAdminSubscriptionsByTenantByTenantIdResponses,
  GetAdminSubscriptionsCapabilityRevokedData,
  GetAdminSubscriptionsCapabilityRevokedErrors,
  GetAdminSubscriptionsCapabilityRevokedResponses,
  GetAdminSubscriptionsData,
  GetAdminSubscriptionsErrors,
  GetAdminSubscriptionsResponses,
  GetAdminSupportAiConfigsWorkspaceByWorkspaceIdData,
  GetAdminSupportAiConfigsWorkspaceByWorkspaceIdErrors,
  GetAdminSupportAiConfigsWorkspaceByWorkspaceIdResponses,
  GetAdminSupportCannedResponsesWorkspaceByWorkspaceIdData,
  GetAdminSupportCannedResponsesWorkspaceByWorkspaceIdErrors,
  GetAdminSupportCannedResponsesWorkspaceByWorkspaceIdResponses,
  GetAdminSupportChannelCaptureConfigsWorkspaceByWorkspaceIdData,
  GetAdminSupportChannelCaptureConfigsWorkspaceByWorkspaceIdErrors,
  GetAdminSupportChannelCaptureConfigsWorkspaceByWorkspaceIdResponses,
  GetAdminSupportQueueMembersApplicationByApplicationIdData,
  GetAdminSupportQueueMembersApplicationByApplicationIdErrors,
  GetAdminSupportQueueMembersApplicationByApplicationIdResponses,
  GetAdminSupportQueueMembersQueueByQueueIdData,
  GetAdminSupportQueueMembersQueueByQueueIdErrors,
  GetAdminSupportQueueMembersQueueByQueueIdResponses,
  GetAdminSupportQueuesApplicationByApplicationIdData,
  GetAdminSupportQueuesApplicationByApplicationIdErrors,
  GetAdminSupportQueuesApplicationByApplicationIdResponses,
  GetAdminSupportQueuesByIdData,
  GetAdminSupportQueuesByIdErrors,
  GetAdminSupportQueuesByIdResponses,
  GetAdminSupportRoutingRulesApplicationByApplicationIdData,
  GetAdminSupportRoutingRulesApplicationByApplicationIdErrors,
  GetAdminSupportRoutingRulesApplicationByApplicationIdResponses,
  GetAdminSupportRoutingRulesByIdData,
  GetAdminSupportRoutingRulesByIdErrors,
  GetAdminSupportRoutingRulesByIdResponses,
  GetAdminSupportSlaPoliciesApplicationByApplicationIdData,
  GetAdminSupportSlaPoliciesApplicationByApplicationIdErrors,
  GetAdminSupportSlaPoliciesApplicationByApplicationIdResponses,
  GetAdminSupportSlaPoliciesByIdData,
  GetAdminSupportSlaPoliciesByIdErrors,
  GetAdminSupportSlaPoliciesByIdResponses,
  GetAdminSupportSyncConfigsWorkspaceByWorkspaceIdData,
  GetAdminSupportSyncConfigsWorkspaceByWorkspaceIdErrors,
  GetAdminSupportSyncConfigsWorkspaceByWorkspaceIdResponses,
  GetAdminSupportTagsWorkspaceByWorkspaceIdData,
  GetAdminSupportTagsWorkspaceByWorkspaceIdErrors,
  GetAdminSupportTagsWorkspaceByWorkspaceIdResponses,
  GetAdminSupportTicketAttachmentsMessageByTicketMessageIdData,
  GetAdminSupportTicketAttachmentsMessageByTicketMessageIdErrors,
  GetAdminSupportTicketAttachmentsMessageByTicketMessageIdResponses,
  GetAdminSupportTicketMessagesTicketByTicketIdData,
  GetAdminSupportTicketMessagesTicketByTicketIdErrors,
  GetAdminSupportTicketMessagesTicketByTicketIdResponses,
  GetAdminSupportTicketsByIdData,
  GetAdminSupportTicketsByIdErrors,
  GetAdminSupportTicketsByIdResponses,
  GetAdminSupportTicketsWorkspaceByWorkspaceIdData,
  GetAdminSupportTicketsWorkspaceByWorkspaceIdErrors,
  GetAdminSupportTicketsWorkspaceByWorkspaceIdResponses,
  GetAdminSysAiConfigByIdData,
  GetAdminSysAiConfigByIdErrors,
  GetAdminSysAiConfigByIdResponses,
  GetAdminSysAiConfigData,
  GetAdminSysAiConfigErrors,
  GetAdminSysAiConfigResponses,
  GetAdminSysSemanticCacheStatsData,
  GetAdminSysSemanticCacheStatsErrors,
  GetAdminSysSemanticCacheStatsResponses,
  GetAdminSystemMessagesByIdData,
  GetAdminSystemMessagesByIdErrors,
  GetAdminSystemMessagesByIdResponses,
  GetAdminSystemMessagesData,
  GetAdminSystemMessagesErrors,
  GetAdminSystemMessagesResponses,
  GetAdminTenantPricingOverridesByIdData,
  GetAdminTenantPricingOverridesByIdErrors,
  GetAdminTenantPricingOverridesByIdResponses,
  GetAdminTenantPricingOverridesData,
  GetAdminTenantPricingOverridesErrors,
  GetAdminTenantPricingOverridesResponses,
  GetAdminTenantsByIdData,
  GetAdminTenantsByIdErrors,
  GetAdminTenantsByIdResponses,
  GetAdminTenantsByTenantIdDocumentStatsData,
  GetAdminTenantsByTenantIdDocumentStatsErrors,
  GetAdminTenantsByTenantIdDocumentStatsResponses,
  GetAdminTenantsByTenantIdStatsData,
  GetAdminTenantsByTenantIdStatsErrors,
  GetAdminTenantsByTenantIdStatsResponses,
  GetAdminTenantsByTenantIdWorkspaceStatsData,
  GetAdminTenantsByTenantIdWorkspaceStatsErrors,
  GetAdminTenantsByTenantIdWorkspaceStatsResponses,
  GetAdminTenantsData,
  GetAdminTenantsErrors,
  GetAdminTenantsResponses,
  GetAdminThreadsByIdData,
  GetAdminThreadsByIdErrors,
  GetAdminThreadsByIdMessagesData,
  GetAdminThreadsByIdMessagesErrors,
  GetAdminThreadsByIdMessagesResponses,
  GetAdminThreadsByIdResponses,
  GetAdminThreadsData,
  GetAdminThreadsErrors,
  GetAdminThreadsMineData,
  GetAdminThreadsMineErrors,
  GetAdminThreadsMineResponses,
  GetAdminThreadsResponses,
  GetAdminThreadsSearchData,
  GetAdminThreadsSearchErrors,
  GetAdminThreadsSearchResponses,
  GetAdminThreadsStatsData,
  GetAdminThreadsStatsErrors,
  GetAdminThreadsStatsResponses,
  GetAdminThreadsWorkspaceStatsData,
  GetAdminThreadsWorkspaceStatsErrors,
  GetAdminThreadsWorkspaceStatsResponses,
  GetAdminTrainingExamplesByIdData,
  GetAdminTrainingExamplesByIdErrors,
  GetAdminTrainingExamplesByIdResponses,
  GetAdminTrainingExamplesData,
  GetAdminTrainingExamplesErrors,
  GetAdminTrainingExamplesResponses,
  GetAdminTrainingSessionsAgentsByAgentIdSessionsData,
  GetAdminTrainingSessionsAgentsByAgentIdSessionsErrors,
  GetAdminTrainingSessionsAgentsByAgentIdSessionsResponses,
  GetAdminTrainingSessionsByIdData,
  GetAdminTrainingSessionsByIdErrors,
  GetAdminTrainingSessionsByIdResponses,
  GetAdminTrainingSessionsData,
  GetAdminTrainingSessionsErrors,
  GetAdminTrainingSessionsResponses,
  GetAdminTransactionsByIdData,
  GetAdminTransactionsByIdErrors,
  GetAdminTransactionsByIdResponses,
  GetAdminTransactionsData,
  GetAdminTransactionsErrors,
  GetAdminTransactionsResponses,
  GetAdminTransfersByIdData,
  GetAdminTransfersByIdErrors,
  GetAdminTransfersByIdResponses,
  GetAdminTransfersData,
  GetAdminTransfersErrors,
  GetAdminTransfersResponses,
  GetAdminUsageEventsByIdData,
  GetAdminUsageEventsByIdErrors,
  GetAdminUsageEventsByIdResponses,
  GetAdminUsageEventsByUserData,
  GetAdminUsageEventsByUserErrors,
  GetAdminUsageEventsByUserResponses,
  GetAdminUsageEventsData,
  GetAdminUsageEventsErrors,
  GetAdminUsageEventsResponses,
  GetAdminUsageEventsSummaryData,
  GetAdminUsageEventsSummaryErrors,
  GetAdminUsageEventsSummaryResponses,
  GetAdminUserProfilesByIdData,
  GetAdminUserProfilesByIdErrors,
  GetAdminUserProfilesByIdResponses,
  GetAdminUserProfilesData,
  GetAdminUserProfilesErrors,
  GetAdminUserProfilesMeData,
  GetAdminUserProfilesMeErrors,
  GetAdminUserProfilesMeResponses,
  GetAdminUserProfilesResponses,
  GetAdminUsersByEmailData,
  GetAdminUsersByEmailErrors,
  GetAdminUsersByEmailResponses,
  GetAdminUsersByIdData,
  GetAdminUsersByIdErrors,
  GetAdminUsersByIdResponses,
  GetAdminUsersData,
  GetAdminUsersErrors,
  GetAdminUsersMeActivityData,
  GetAdminUsersMeActivityErrors,
  GetAdminUsersMeActivityResponses,
  GetAdminUsersMeDashboardData,
  GetAdminUsersMeDashboardErrors,
  GetAdminUsersMeDashboardResponses,
  GetAdminUsersMeData,
  GetAdminUsersMeErrors,
  GetAdminUsersMeResponses,
  GetAdminUsersMeStatsData,
  GetAdminUsersMeStatsErrors,
  GetAdminUsersMeStatsResponses,
  GetAdminUsersMeTenantsData,
  GetAdminUsersMeTenantsErrors,
  GetAdminUsersMeTenantsResponses,
  GetAdminUsersResponses,
  GetAdminVoiceRecordingsByIdData,
  GetAdminVoiceRecordingsByIdErrors,
  GetAdminVoiceRecordingsByIdResponses,
  GetAdminVoiceRecordingsData,
  GetAdminVoiceRecordingsErrors,
  GetAdminVoiceRecordingsResponses,
  GetAdminVoiceRecordingsSessionBySessionIdData,
  GetAdminVoiceRecordingsSessionBySessionIdErrors,
  GetAdminVoiceRecordingsSessionBySessionIdResponses,
  GetAdminVoiceSessionsByIdData,
  GetAdminVoiceSessionsByIdErrors,
  GetAdminVoiceSessionsByIdResponses,
  GetAdminVoiceSessionsData,
  GetAdminVoiceSessionsErrors,
  GetAdminVoiceSessionsMineData,
  GetAdminVoiceSessionsMineErrors,
  GetAdminVoiceSessionsMineResponses,
  GetAdminVoiceSessionsResponses,
  GetAdminVoiceSessionsWorkspaceByWorkspaceIdData,
  GetAdminVoiceSessionsWorkspaceByWorkspaceIdErrors,
  GetAdminVoiceSessionsWorkspaceByWorkspaceIdResponses,
  GetAdminVoiceTranscriptionJobsByIdData,
  GetAdminVoiceTranscriptionJobsByIdErrors,
  GetAdminVoiceTranscriptionJobsByIdResponses,
  GetAdminVoiceTranscriptionJobsData,
  GetAdminVoiceTranscriptionJobsErrors,
  GetAdminVoiceTranscriptionJobsMineData,
  GetAdminVoiceTranscriptionJobsMineErrors,
  GetAdminVoiceTranscriptionJobsMineResponses,
  GetAdminVoiceTranscriptionJobsResponses,
  GetAdminVoiceTranscriptionJobsWorkspaceByWorkspaceIdData,
  GetAdminVoiceTranscriptionJobsWorkspaceByWorkspaceIdErrors,
  GetAdminVoiceTranscriptionJobsWorkspaceByWorkspaceIdResponses,
  GetAdminVoiceTranscriptionResultsByIdData,
  GetAdminVoiceTranscriptionResultsByIdErrors,
  GetAdminVoiceTranscriptionResultsByIdResponses,
  GetAdminVoiceTranscriptionResultsData,
  GetAdminVoiceTranscriptionResultsErrors,
  GetAdminVoiceTranscriptionResultsResponses,
  GetAdminVoiceTranscriptionResultsSessionBySessionIdData,
  GetAdminVoiceTranscriptionResultsSessionBySessionIdErrors,
  GetAdminVoiceTranscriptionResultsSessionBySessionIdResponses,
  GetAdminWalletData,
  GetAdminWalletErrors,
  GetAdminWalletFeaturesData,
  GetAdminWalletFeaturesErrors,
  GetAdminWalletFeaturesResponses,
  GetAdminWalletForecastData,
  GetAdminWalletForecastErrors,
  GetAdminWalletForecastResponses,
  GetAdminWalletInvoicesByIdData,
  GetAdminWalletInvoicesByIdErrors,
  GetAdminWalletInvoicesByIdResponses,
  GetAdminWalletInvoicesData,
  GetAdminWalletInvoicesErrors,
  GetAdminWalletInvoicesResponses,
  GetAdminWalletPlanPreviewData,
  GetAdminWalletPlanPreviewErrors,
  GetAdminWalletPlanPreviewResponses,
  GetAdminWalletResponses,
  GetAdminWalletSeatsData,
  GetAdminWalletSeatsErrors,
  GetAdminWalletSeatsResponses,
  GetAdminWalletStorageBreakdownData,
  GetAdminWalletStorageBreakdownErrors,
  GetAdminWalletStorageBreakdownResponses,
  GetAdminWalletUsageBreakdownData,
  GetAdminWalletUsageBreakdownErrors,
  GetAdminWalletUsageBreakdownResponses,
  GetAdminWalletUsageData,
  GetAdminWalletUsageErrors,
  GetAdminWalletUsageResponses,
  GetAdminWebhookConfigsByIdData,
  GetAdminWebhookConfigsByIdErrors,
  GetAdminWebhookConfigsByIdEventsData,
  GetAdminWebhookConfigsByIdEventsErrors,
  GetAdminWebhookConfigsByIdEventsResponses,
  GetAdminWebhookConfigsByIdResponses,
  GetAdminWebhookConfigsData,
  GetAdminWebhookConfigsErrors,
  GetAdminWebhookConfigsResponses,
  GetAdminWebhookConfigsStatsData,
  GetAdminWebhookConfigsStatsErrors,
  GetAdminWebhookConfigsStatsResponses,
  GetAdminWebhookDeliveriesByIdData,
  GetAdminWebhookDeliveriesByIdErrors,
  GetAdminWebhookDeliveriesByIdResponses,
  GetAdminWebhookDeliveriesData,
  GetAdminWebhookDeliveriesErrors,
  GetAdminWebhookDeliveriesResponses,
  GetAdminWebhookDeliveriesStatsData,
  GetAdminWebhookDeliveriesStatsErrors,
  GetAdminWebhookDeliveriesStatsResponses,
  GetAdminWholesaleAgreementsByIdData,
  GetAdminWholesaleAgreementsByIdErrors,
  GetAdminWholesaleAgreementsByIdResponses,
  GetAdminWholesaleAgreementsByIdSignupGrantStatusData,
  GetAdminWholesaleAgreementsByIdSignupGrantStatusErrors,
  GetAdminWholesaleAgreementsByIdSignupGrantStatusResponses,
  GetAdminWholesaleAgreementsData,
  GetAdminWholesaleAgreementsErrors,
  GetAdminWholesaleAgreementsResponses,
  GetAdminWorkspaceAgentConfigsByIdData,
  GetAdminWorkspaceAgentConfigsByIdErrors,
  GetAdminWorkspaceAgentConfigsByIdResponses,
  GetAdminWorkspaceAgentConfigsData,
  GetAdminWorkspaceAgentConfigsErrors,
  GetAdminWorkspaceAgentConfigsResponses,
  GetAdminWorkspaceFormConfigsByIdData,
  GetAdminWorkspaceFormConfigsByIdErrors,
  GetAdminWorkspaceFormConfigsByIdResponses,
  GetAdminWorkspaceFormConfigsData,
  GetAdminWorkspaceFormConfigsErrors,
  GetAdminWorkspaceFormConfigsResponses,
  GetAdminWorkspacePreferencesByKeyData,
  GetAdminWorkspacePreferencesByKeyErrors,
  GetAdminWorkspacePreferencesByKeyResponses,
  GetAdminWorkspacePreferencesData,
  GetAdminWorkspacePreferencesErrors,
  GetAdminWorkspacePreferencesResponses,
  GetAdminWorkspacesAnalyticsBatchData,
  GetAdminWorkspacesAnalyticsBatchErrors,
  GetAdminWorkspacesAnalyticsBatchResponses,
  GetAdminWorkspacesByIdData,
  GetAdminWorkspacesByIdErrors,
  GetAdminWorkspacesByIdResponses,
  GetAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMappingData,
  GetAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMappingErrors,
  GetAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMappingResponses,
  GetAdminWorkspacesByWorkspaceIdExtractionExportsByIdData,
  GetAdminWorkspacesByWorkspaceIdExtractionExportsByIdErrors,
  GetAdminWorkspacesByWorkspaceIdExtractionExportsByIdResponses,
  GetAdminWorkspacesByWorkspaceIdExtractionExportsData,
  GetAdminWorkspacesByWorkspaceIdExtractionExportsErrors,
  GetAdminWorkspacesByWorkspaceIdExtractionExportsResponses,
  GetAdminWorkspacesByWorkspaceIdTrainingAnalyticsData,
  GetAdminWorkspacesByWorkspaceIdTrainingAnalyticsErrors,
  GetAdminWorkspacesByWorkspaceIdTrainingAnalyticsResponses,
  GetAdminWorkspacesData,
  GetAdminWorkspacesErrors,
  GetAdminWorkspacesMineData,
  GetAdminWorkspacesMineErrors,
  GetAdminWorkspacesMineResponses,
  GetAdminWorkspacesResponses,
  GetAdminWorkspacesSharedData,
  GetAdminWorkspacesSharedErrors,
  GetAdminWorkspacesSharedResponses,
  PatchAdminAccessGrantsByIdData,
  PatchAdminAccessGrantsByIdErrors,
  PatchAdminAccessGrantsByIdResponses,
  PatchAdminAccountsByIdCreditData,
  PatchAdminAccountsByIdCreditErrors,
  PatchAdminAccountsByIdCreditResponses,
  PatchAdminAccountsByIdDebitData,
  PatchAdminAccountsByIdDebitErrors,
  PatchAdminAccountsByIdDebitResponses,
  PatchAdminAgentDeploymentsByIdAcceptUpdateData,
  PatchAdminAgentDeploymentsByIdAcceptUpdateErrors,
  PatchAdminAgentDeploymentsByIdAcceptUpdateResponses,
  PatchAdminAgentDeploymentsByIdData,
  PatchAdminAgentDeploymentsByIdErrors,
  PatchAdminAgentDeploymentsByIdResponses,
  PatchAdminAgentExecutionsByIdCancelData,
  PatchAdminAgentExecutionsByIdCancelErrors,
  PatchAdminAgentExecutionsByIdCancelResponses,
  PatchAdminAgentExecutionsByIdResumeData,
  PatchAdminAgentExecutionsByIdResumeErrors,
  PatchAdminAgentExecutionsByIdResumeResponses,
  PatchAdminAgentsByIdData,
  PatchAdminAgentsByIdErrors,
  PatchAdminAgentsByIdResponses,
  PatchAdminAgentsByIdSchemaVersionsByVersionIdData,
  PatchAdminAgentsByIdSchemaVersionsByVersionIdErrors,
  PatchAdminAgentsByIdSchemaVersionsByVersionIdResponses,
  PatchAdminAgentSoulsByIdData,
  PatchAdminAgentSoulsByIdErrors,
  PatchAdminAgentSoulsByIdResponses,
  PatchAdminAgentVersionsByIdData,
  PatchAdminAgentVersionsByIdErrors,
  PatchAdminAgentVersionsByIdResponses,
  PatchAdminAiConversationsByIdData,
  PatchAdminAiConversationsByIdErrors,
  PatchAdminAiConversationsByIdResponses,
  PatchAdminAmendmentRequestsByIdApplyData,
  PatchAdminAmendmentRequestsByIdApplyErrors,
  PatchAdminAmendmentRequestsByIdApplyResponses,
  PatchAdminAmendmentRequestsByIdApproveData,
  PatchAdminAmendmentRequestsByIdApproveErrors,
  PatchAdminAmendmentRequestsByIdApproveResponses,
  PatchAdminAmendmentRequestsByIdDenyData,
  PatchAdminAmendmentRequestsByIdDenyErrors,
  PatchAdminAmendmentRequestsByIdDenyResponses,
  PatchAdminAmendmentRequestsByIdReviewData,
  PatchAdminAmendmentRequestsByIdReviewErrors,
  PatchAdminAmendmentRequestsByIdReviewResponses,
  PatchAdminApiKeysByIdData,
  PatchAdminApiKeysByIdErrors,
  PatchAdminApiKeysByIdResetPeriodData,
  PatchAdminApiKeysByIdResetPeriodErrors,
  PatchAdminApiKeysByIdResetPeriodResponses,
  PatchAdminApiKeysByIdResponses,
  PatchAdminApiKeysByIdRevokeData,
  PatchAdminApiKeysByIdRevokeErrors,
  PatchAdminApiKeysByIdRevokeResponses,
  PatchAdminApiKeysByIdRotateData,
  PatchAdminApiKeysByIdRotateErrors,
  PatchAdminApiKeysByIdRotateResponses,
  PatchAdminApiKeysByIdSetBudgetData,
  PatchAdminApiKeysByIdSetBudgetErrors,
  PatchAdminApiKeysByIdSetBudgetResponses,
  PatchAdminApplicationsByApplicationIdEmailTemplatesBySlugData,
  PatchAdminApplicationsByApplicationIdEmailTemplatesBySlugErrors,
  PatchAdminApplicationsByApplicationIdEmailTemplatesBySlugResponses,
  PatchAdminApplicationsByIdAllocateCreditsData,
  PatchAdminApplicationsByIdAllocateCreditsErrors,
  PatchAdminApplicationsByIdAllocateCreditsResponses,
  PatchAdminApplicationsByIdComplianceTagsData,
  PatchAdminApplicationsByIdComplianceTagsErrors,
  PatchAdminApplicationsByIdComplianceTagsResponses,
  PatchAdminApplicationsByIdData,
  PatchAdminApplicationsByIdErrors,
  PatchAdminApplicationsByIdGrantCreditsData,
  PatchAdminApplicationsByIdGrantCreditsErrors,
  PatchAdminApplicationsByIdGrantCreditsResponses,
  PatchAdminApplicationsByIdResponses,
  PatchAdminBrandIdentitiesByIdData,
  PatchAdminBrandIdentitiesByIdErrors,
  PatchAdminBrandIdentitiesByIdResponses,
  PatchAdminBrandIdentitiesByIdSetDefaultData,
  PatchAdminBrandIdentitiesByIdSetDefaultErrors,
  PatchAdminBrandIdentitiesByIdSetDefaultResponses,
  PatchAdminBrandIdentitiesByIdUnsetDefaultData,
  PatchAdminBrandIdentitiesByIdUnsetDefaultErrors,
  PatchAdminBrandIdentitiesByIdUnsetDefaultResponses,
  PatchAdminBreachIncidentsByIdStatusData,
  PatchAdminBreachIncidentsByIdStatusErrors,
  PatchAdminBreachIncidentsByIdStatusResponses,
  PatchAdminBreachNotificationArtifactsByIdData,
  PatchAdminBreachNotificationArtifactsByIdErrors,
  PatchAdminBreachNotificationArtifactsByIdResponses,
  PatchAdminBreachNotificationArtifactsByIdSendData,
  PatchAdminBreachNotificationArtifactsByIdSendErrors,
  PatchAdminBreachNotificationArtifactsByIdSendResponses,
  PatchAdminBucketsByIdData,
  PatchAdminBucketsByIdErrors,
  PatchAdminBucketsByIdResponses,
  PatchAdminBusinessAssociateAgreementsByIdData,
  PatchAdminBusinessAssociateAgreementsByIdErrors,
  PatchAdminBusinessAssociateAgreementsByIdResponses,
  PatchAdminBusinessAssociateAgreementsByIdSignData,
  PatchAdminBusinessAssociateAgreementsByIdSignErrors,
  PatchAdminBusinessAssociateAgreementsByIdSignResponses,
  PatchAdminBusinessAssociateAgreementsByIdTerminateData,
  PatchAdminBusinessAssociateAgreementsByIdTerminateErrors,
  PatchAdminBusinessAssociateAgreementsByIdTerminateResponses,
  PatchAdminCampaignsSequencesByIdActivateData,
  PatchAdminCampaignsSequencesByIdActivateErrors,
  PatchAdminCampaignsSequencesByIdActivateResponses,
  PatchAdminCampaignsSequencesByIdCompleteData,
  PatchAdminCampaignsSequencesByIdCompleteErrors,
  PatchAdminCampaignsSequencesByIdCompleteResponses,
  PatchAdminCampaignsSequencesByIdData,
  PatchAdminCampaignsSequencesByIdErrors,
  PatchAdminCampaignsSequencesByIdPauseData,
  PatchAdminCampaignsSequencesByIdPauseErrors,
  PatchAdminCampaignsSequencesByIdPauseResponses,
  PatchAdminCampaignsSequencesByIdResponses,
  PatchAdminCampaignsSequencesByIdResumeData,
  PatchAdminCampaignsSequencesByIdResumeErrors,
  PatchAdminCampaignsSequencesByIdResumeResponses,
  PatchAdminCampaignsSequenceStepsByIdData,
  PatchAdminCampaignsSequenceStepsByIdErrors,
  PatchAdminCampaignsSequenceStepsByIdResponses,
  PatchAdminCasesByIdAssignOwnerData,
  PatchAdminCasesByIdAssignOwnerErrors,
  PatchAdminCasesByIdAssignOwnerResponses,
  PatchAdminCasesByIdCloseData,
  PatchAdminCasesByIdCloseErrors,
  PatchAdminCasesByIdCloseResponses,
  PatchAdminCasesByIdData,
  PatchAdminCasesByIdDecideData,
  PatchAdminCasesByIdDecideErrors,
  PatchAdminCasesByIdDecideResponses,
  PatchAdminCasesByIdErrors,
  PatchAdminCasesByIdReopenData,
  PatchAdminCasesByIdReopenErrors,
  PatchAdminCasesByIdReopenResponses,
  PatchAdminCasesByIdResponses,
  PatchAdminCasesByIdTransitionStateData,
  PatchAdminCasesByIdTransitionStateErrors,
  PatchAdminCasesByIdTransitionStateResponses,
  PatchAdminCaseTypesByIdActivateData,
  PatchAdminCaseTypesByIdActivateErrors,
  PatchAdminCaseTypesByIdActivateResponses,
  PatchAdminCaseTypesByIdData,
  PatchAdminCaseTypesByIdDeactivateData,
  PatchAdminCaseTypesByIdDeactivateErrors,
  PatchAdminCaseTypesByIdDeactivateResponses,
  PatchAdminCaseTypesByIdErrors,
  PatchAdminCaseTypesByIdResponses,
  PatchAdminCatalogClassificationSuggestionsByIdAcceptData,
  PatchAdminCatalogClassificationSuggestionsByIdAcceptErrors,
  PatchAdminCatalogClassificationSuggestionsByIdAcceptResponses,
  PatchAdminCatalogClassificationSuggestionsByIdRejectData,
  PatchAdminCatalogClassificationSuggestionsByIdRejectErrors,
  PatchAdminCatalogClassificationSuggestionsByIdRejectResponses,
  PatchAdminCatalogOptionTypesByIdData,
  PatchAdminCatalogOptionTypesByIdErrors,
  PatchAdminCatalogOptionTypesByIdResponses,
  PatchAdminCatalogOptionValuesByIdData,
  PatchAdminCatalogOptionValuesByIdErrors,
  PatchAdminCatalogOptionValuesByIdResponses,
  PatchAdminCatalogPriceListEntriesByIdData,
  PatchAdminCatalogPriceListEntriesByIdErrors,
  PatchAdminCatalogPriceListEntriesByIdResponses,
  PatchAdminCatalogPriceListsByIdData,
  PatchAdminCatalogPriceListsByIdErrors,
  PatchAdminCatalogPriceListsByIdResponses,
  PatchAdminCatalogPriceSuggestionsByIdAcceptData,
  PatchAdminCatalogPriceSuggestionsByIdAcceptErrors,
  PatchAdminCatalogPriceSuggestionsByIdAcceptResponses,
  PatchAdminCatalogPriceSuggestionsByIdRejectData,
  PatchAdminCatalogPriceSuggestionsByIdRejectErrors,
  PatchAdminCatalogPriceSuggestionsByIdRejectResponses,
  PatchAdminCatalogProductsByIdData,
  PatchAdminCatalogProductsByIdErrors,
  PatchAdminCatalogProductsByIdResponses,
  PatchAdminCatalogProductVariantsByIdData,
  PatchAdminCatalogProductVariantsByIdErrors,
  PatchAdminCatalogProductVariantsByIdResponses,
  PatchAdminCatalogStockLocationsByIdData,
  PatchAdminCatalogStockLocationsByIdErrors,
  PatchAdminCatalogStockLocationsByIdResponses,
  PatchAdminCatalogTaxonomiesByIdData,
  PatchAdminCatalogTaxonomiesByIdErrors,
  PatchAdminCatalogTaxonomiesByIdResponses,
  PatchAdminCatalogTaxonomyNodesByIdData,
  PatchAdminCatalogTaxonomyNodesByIdErrors,
  PatchAdminCatalogTaxonomyNodesByIdResponses,
  PatchAdminCatalogViewOverridesByIdData,
  PatchAdminCatalogViewOverridesByIdErrors,
  PatchAdminCatalogViewOverridesByIdResponses,
  PatchAdminCatalogViewsByIdData,
  PatchAdminCatalogViewsByIdErrors,
  PatchAdminCatalogViewsByIdResponses,
  PatchAdminClaimedDomainsByIdData,
  PatchAdminClaimedDomainsByIdErrors,
  PatchAdminClaimedDomainsByIdResponses,
  PatchAdminClaimedDomainsByIdRevokeData,
  PatchAdminClaimedDomainsByIdRevokeErrors,
  PatchAdminClaimedDomainsByIdRevokeResponses,
  PatchAdminClaimedDomainsByIdVerifyData,
  PatchAdminClaimedDomainsByIdVerifyErrors,
  PatchAdminClaimedDomainsByIdVerifyResponses,
  PatchAdminClinicalClientGoalsByIdApproveData,
  PatchAdminClinicalClientGoalsByIdApproveErrors,
  PatchAdminClinicalClientGoalsByIdApproveResponses,
  PatchAdminClinicalClientGoalsByIdArchiveData,
  PatchAdminClinicalClientGoalsByIdArchiveErrors,
  PatchAdminClinicalClientGoalsByIdArchiveResponses,
  PatchAdminClinicalClientGoalsByIdData,
  PatchAdminClinicalClientGoalsByIdErrors,
  PatchAdminClinicalClientGoalsByIdRejectData,
  PatchAdminClinicalClientGoalsByIdRejectErrors,
  PatchAdminClinicalClientGoalsByIdRejectResponses,
  PatchAdminClinicalClientGoalsByIdResponses,
  PatchAdminClinicalClientGoalsByIdRestoreData,
  PatchAdminClinicalClientGoalsByIdRestoreErrors,
  PatchAdminClinicalClientGoalsByIdRestoreResponses,
  PatchAdminClinicalClientMedicationsByIdArchiveData,
  PatchAdminClinicalClientMedicationsByIdArchiveErrors,
  PatchAdminClinicalClientMedicationsByIdArchiveResponses,
  PatchAdminClinicalClientMedicationsByIdData,
  PatchAdminClinicalClientMedicationsByIdErrors,
  PatchAdminClinicalClientMedicationsByIdResponses,
  PatchAdminClinicalClientMedicationsByIdRestoreData,
  PatchAdminClinicalClientMedicationsByIdRestoreErrors,
  PatchAdminClinicalClientMedicationsByIdRestoreResponses,
  PatchAdminClinicalClientResourceAssignmentsByIdArchiveData,
  PatchAdminClinicalClientResourceAssignmentsByIdArchiveErrors,
  PatchAdminClinicalClientResourceAssignmentsByIdArchiveResponses,
  PatchAdminClinicalClientResourceAssignmentsByIdData,
  PatchAdminClinicalClientResourceAssignmentsByIdErrors,
  PatchAdminClinicalClientResourceAssignmentsByIdResponses,
  PatchAdminClinicalClientResourceAssignmentsByIdRestoreData,
  PatchAdminClinicalClientResourceAssignmentsByIdRestoreErrors,
  PatchAdminClinicalClientResourceAssignmentsByIdRestoreResponses,
  PatchAdminClinicalClientSupplementsByIdArchiveData,
  PatchAdminClinicalClientSupplementsByIdArchiveErrors,
  PatchAdminClinicalClientSupplementsByIdArchiveResponses,
  PatchAdminClinicalClientSupplementsByIdData,
  PatchAdminClinicalClientSupplementsByIdErrors,
  PatchAdminClinicalClientSupplementsByIdResponses,
  PatchAdminClinicalClientSupplementsByIdRestoreData,
  PatchAdminClinicalClientSupplementsByIdRestoreErrors,
  PatchAdminClinicalClientSupplementsByIdRestoreResponses,
  PatchAdminClinicalDeliveriesByIdData,
  PatchAdminClinicalDeliveriesByIdErrors,
  PatchAdminClinicalDeliveriesByIdResponses,
  PatchAdminClinicalDocumentsByIdData,
  PatchAdminClinicalDocumentsByIdErrors,
  PatchAdminClinicalDocumentsByIdResponses,
  PatchAdminClinicalDocumentsByIdTransitionStatusData,
  PatchAdminClinicalDocumentsByIdTransitionStatusErrors,
  PatchAdminClinicalDocumentsByIdTransitionStatusResponses,
  PatchAdminClinicalGoalTemplateCollectionMembershipsByIdData,
  PatchAdminClinicalGoalTemplateCollectionMembershipsByIdErrors,
  PatchAdminClinicalGoalTemplateCollectionMembershipsByIdResponses,
  PatchAdminClinicalGoalTemplateCollectionsByIdData,
  PatchAdminClinicalGoalTemplateCollectionsByIdErrors,
  PatchAdminClinicalGoalTemplateCollectionsByIdResponses,
  PatchAdminClinicalGoalTemplatesByIdArchiveData,
  PatchAdminClinicalGoalTemplatesByIdArchiveErrors,
  PatchAdminClinicalGoalTemplatesByIdArchiveResponses,
  PatchAdminClinicalGoalTemplatesByIdData,
  PatchAdminClinicalGoalTemplatesByIdErrors,
  PatchAdminClinicalGoalTemplatesByIdResponses,
  PatchAdminClinicalGoalTemplatesByIdRestoreData,
  PatchAdminClinicalGoalTemplatesByIdRestoreErrors,
  PatchAdminClinicalGoalTemplatesByIdRestoreResponses,
  PatchAdminClinicalGoalTemplatesCatalogByIdArchiveData,
  PatchAdminClinicalGoalTemplatesCatalogByIdArchiveErrors,
  PatchAdminClinicalGoalTemplatesCatalogByIdArchiveResponses,
  PatchAdminClinicalGoalTemplatesCatalogByIdData,
  PatchAdminClinicalGoalTemplatesCatalogByIdErrors,
  PatchAdminClinicalGoalTemplatesCatalogByIdResponses,
  PatchAdminClinicalGoalTemplatesCatalogByIdRestoreData,
  PatchAdminClinicalGoalTemplatesCatalogByIdRestoreErrors,
  PatchAdminClinicalGoalTemplatesCatalogByIdRestoreResponses,
  PatchAdminClinicalHealthMetricsByIdArchiveData,
  PatchAdminClinicalHealthMetricsByIdArchiveErrors,
  PatchAdminClinicalHealthMetricsByIdArchiveResponses,
  PatchAdminClinicalHealthMetricsByIdData,
  PatchAdminClinicalHealthMetricsByIdErrors,
  PatchAdminClinicalHealthMetricsByIdResponses,
  PatchAdminClinicalHealthMetricsByIdRestoreData,
  PatchAdminClinicalHealthMetricsByIdRestoreErrors,
  PatchAdminClinicalHealthMetricsByIdRestoreResponses,
  PatchAdminClinicalInsuranceAuthorizationsByIdData,
  PatchAdminClinicalInsuranceAuthorizationsByIdErrors,
  PatchAdminClinicalInsuranceAuthorizationsByIdIncrementData,
  PatchAdminClinicalInsuranceAuthorizationsByIdIncrementErrors,
  PatchAdminClinicalInsuranceAuthorizationsByIdIncrementResponses,
  PatchAdminClinicalInsuranceAuthorizationsByIdResponses,
  PatchAdminClinicalIntakeTargetsByIdArchiveData,
  PatchAdminClinicalIntakeTargetsByIdArchiveErrors,
  PatchAdminClinicalIntakeTargetsByIdArchiveResponses,
  PatchAdminClinicalIntakeTargetsByIdData,
  PatchAdminClinicalIntakeTargetsByIdErrors,
  PatchAdminClinicalIntakeTargetsByIdResponses,
  PatchAdminClinicalIntakeTargetsByIdRestoreData,
  PatchAdminClinicalIntakeTargetsByIdRestoreErrors,
  PatchAdminClinicalIntakeTargetsByIdRestoreResponses,
  PatchAdminClinicalMealPlansByIdApproveData,
  PatchAdminClinicalMealPlansByIdApproveErrors,
  PatchAdminClinicalMealPlansByIdApproveResponses,
  PatchAdminClinicalMealPlansByIdArchiveData,
  PatchAdminClinicalMealPlansByIdArchiveErrors,
  PatchAdminClinicalMealPlansByIdArchiveResponses,
  PatchAdminClinicalMealPlansByIdData,
  PatchAdminClinicalMealPlansByIdErrors,
  PatchAdminClinicalMealPlansByIdResponses,
  PatchAdminClinicalMealPlansByIdRestoreData,
  PatchAdminClinicalMealPlansByIdRestoreErrors,
  PatchAdminClinicalMealPlansByIdRestoreResponses,
  PatchAdminClinicalNotesByIdApproveData,
  PatchAdminClinicalNotesByIdApproveErrors,
  PatchAdminClinicalNotesByIdApproveResponses,
  PatchAdminClinicalNotesByIdArchiveData,
  PatchAdminClinicalNotesByIdArchiveErrors,
  PatchAdminClinicalNotesByIdArchiveResponses,
  PatchAdminClinicalNotesByIdData,
  PatchAdminClinicalNotesByIdErrors,
  PatchAdminClinicalNotesByIdRejectData,
  PatchAdminClinicalNotesByIdRejectErrors,
  PatchAdminClinicalNotesByIdRejectResponses,
  PatchAdminClinicalNotesByIdResponses,
  PatchAdminClinicalNotesByIdRestoreData,
  PatchAdminClinicalNotesByIdRestoreErrors,
  PatchAdminClinicalNotesByIdRestoreResponses,
  PatchAdminClinicalNoteTemplatesByIdArchiveData,
  PatchAdminClinicalNoteTemplatesByIdArchiveErrors,
  PatchAdminClinicalNoteTemplatesByIdArchiveResponses,
  PatchAdminClinicalNoteTemplatesByIdData,
  PatchAdminClinicalNoteTemplatesByIdErrors,
  PatchAdminClinicalNoteTemplatesByIdResponses,
  PatchAdminClinicalNoteTemplatesByIdRestoreData,
  PatchAdminClinicalNoteTemplatesByIdRestoreErrors,
  PatchAdminClinicalNoteTemplatesByIdRestoreResponses,
  PatchAdminClinicalNoteTemplatesCatalogByIdArchiveData,
  PatchAdminClinicalNoteTemplatesCatalogByIdArchiveErrors,
  PatchAdminClinicalNoteTemplatesCatalogByIdArchiveResponses,
  PatchAdminClinicalNoteTemplatesCatalogByIdData,
  PatchAdminClinicalNoteTemplatesCatalogByIdErrors,
  PatchAdminClinicalNoteTemplatesCatalogByIdResponses,
  PatchAdminClinicalNoteTemplatesCatalogByIdRestoreData,
  PatchAdminClinicalNoteTemplatesCatalogByIdRestoreErrors,
  PatchAdminClinicalNoteTemplatesCatalogByIdRestoreResponses,
  PatchAdminClinicalPatientInsuranceByIdData,
  PatchAdminClinicalPatientInsuranceByIdErrors,
  PatchAdminClinicalPatientInsuranceByIdResponses,
  PatchAdminClinicalPatientsByIdData,
  PatchAdminClinicalPatientsByIdErrors,
  PatchAdminClinicalPatientsByIdResponses,
  PatchAdminClinicalPracticeResourcesByIdArchiveData,
  PatchAdminClinicalPracticeResourcesByIdArchiveErrors,
  PatchAdminClinicalPracticeResourcesByIdArchiveResponses,
  PatchAdminClinicalPracticeResourcesByIdData,
  PatchAdminClinicalPracticeResourcesByIdErrors,
  PatchAdminClinicalPracticeResourcesByIdResponses,
  PatchAdminClinicalPracticeResourcesByIdRestoreData,
  PatchAdminClinicalPracticeResourcesByIdRestoreErrors,
  PatchAdminClinicalPracticeResourcesByIdRestoreResponses,
  PatchAdminClinicalPracticeResourcesCatalogByIdArchiveData,
  PatchAdminClinicalPracticeResourcesCatalogByIdArchiveErrors,
  PatchAdminClinicalPracticeResourcesCatalogByIdArchiveResponses,
  PatchAdminClinicalPracticeResourcesCatalogByIdData,
  PatchAdminClinicalPracticeResourcesCatalogByIdErrors,
  PatchAdminClinicalPracticeResourcesCatalogByIdResponses,
  PatchAdminClinicalPracticeResourcesCatalogByIdRestoreData,
  PatchAdminClinicalPracticeResourcesCatalogByIdRestoreErrors,
  PatchAdminClinicalPracticeResourcesCatalogByIdRestoreResponses,
  PatchAdminClinicalPracticeToolsByIdArchiveData,
  PatchAdminClinicalPracticeToolsByIdArchiveErrors,
  PatchAdminClinicalPracticeToolsByIdArchiveResponses,
  PatchAdminClinicalPracticeToolsByIdData,
  PatchAdminClinicalPracticeToolsByIdErrors,
  PatchAdminClinicalPracticeToolsByIdResponses,
  PatchAdminClinicalPracticeToolsByIdRestoreData,
  PatchAdminClinicalPracticeToolsByIdRestoreErrors,
  PatchAdminClinicalPracticeToolsByIdRestoreResponses,
  PatchAdminClinicalPracticeToolsCatalogByIdArchiveData,
  PatchAdminClinicalPracticeToolsCatalogByIdArchiveErrors,
  PatchAdminClinicalPracticeToolsCatalogByIdArchiveResponses,
  PatchAdminClinicalPracticeToolsCatalogByIdData,
  PatchAdminClinicalPracticeToolsCatalogByIdErrors,
  PatchAdminClinicalPracticeToolsCatalogByIdResponses,
  PatchAdminClinicalPracticeToolsCatalogByIdRestoreData,
  PatchAdminClinicalPracticeToolsCatalogByIdRestoreErrors,
  PatchAdminClinicalPracticeToolsCatalogByIdRestoreResponses,
  PatchAdminClinicalSessionsByIdData,
  PatchAdminClinicalSessionsByIdErrors,
  PatchAdminClinicalSessionsByIdResponses,
  PatchAdminClinicalSupplementRecCacheByIdData,
  PatchAdminClinicalSupplementRecCacheByIdErrors,
  PatchAdminClinicalSupplementRecCacheByIdResponses,
  PatchAdminClinicalSupplementTemplateCollectionMembershipsByIdData,
  PatchAdminClinicalSupplementTemplateCollectionMembershipsByIdErrors,
  PatchAdminClinicalSupplementTemplateCollectionMembershipsByIdResponses,
  PatchAdminClinicalSupplementTemplateCollectionsByIdData,
  PatchAdminClinicalSupplementTemplateCollectionsByIdErrors,
  PatchAdminClinicalSupplementTemplateCollectionsByIdResponses,
  PatchAdminClinicalSupplementTemplatesByIdArchiveData,
  PatchAdminClinicalSupplementTemplatesByIdArchiveErrors,
  PatchAdminClinicalSupplementTemplatesByIdArchiveResponses,
  PatchAdminClinicalSupplementTemplatesByIdData,
  PatchAdminClinicalSupplementTemplatesByIdErrors,
  PatchAdminClinicalSupplementTemplatesByIdResponses,
  PatchAdminClinicalSupplementTemplatesByIdRestoreData,
  PatchAdminClinicalSupplementTemplatesByIdRestoreErrors,
  PatchAdminClinicalSupplementTemplatesByIdRestoreResponses,
  PatchAdminClinicalSupplementTemplatesCatalogByIdArchiveData,
  PatchAdminClinicalSupplementTemplatesCatalogByIdArchiveErrors,
  PatchAdminClinicalSupplementTemplatesCatalogByIdArchiveResponses,
  PatchAdminClinicalSupplementTemplatesCatalogByIdData,
  PatchAdminClinicalSupplementTemplatesCatalogByIdErrors,
  PatchAdminClinicalSupplementTemplatesCatalogByIdResponses,
  PatchAdminClinicalSupplementTemplatesCatalogByIdRestoreData,
  PatchAdminClinicalSupplementTemplatesCatalogByIdRestoreErrors,
  PatchAdminClinicalSupplementTemplatesCatalogByIdRestoreResponses,
  PatchAdminComplianceDocumentTemplatesByIdData,
  PatchAdminComplianceDocumentTemplatesByIdErrors,
  PatchAdminComplianceDocumentTemplatesByIdResponses,
  PatchAdminComplianceOfficerDesignationsByIdRevokeData,
  PatchAdminComplianceOfficerDesignationsByIdRevokeErrors,
  PatchAdminComplianceOfficerDesignationsByIdRevokeResponses,
  PatchAdminComplianceRequirementsByIdData,
  PatchAdminComplianceRequirementsByIdErrors,
  PatchAdminComplianceRequirementsByIdResponses,
  PatchAdminCompositeOperationsByIdData,
  PatchAdminCompositeOperationsByIdErrors,
  PatchAdminCompositeOperationsByIdResponses,
  PatchAdminConfigsByKeyData,
  PatchAdminConfigsByKeyErrors,
  PatchAdminConfigsByKeyResponses,
  PatchAdminConnectorsByIdData,
  PatchAdminConnectorsByIdErrors,
  PatchAdminConnectorsByIdResponses,
  PatchAdminConnectorsOauthAppConfigsByIdData,
  PatchAdminConnectorsOauthAppConfigsByIdErrors,
  PatchAdminConnectorsOauthAppConfigsByIdResponses,
  PatchAdminConsentRecordsByIdWithdrawData,
  PatchAdminConsentRecordsByIdWithdrawErrors,
  PatchAdminConsentRecordsByIdWithdrawResponses,
  PatchAdminContractsByIdData,
  PatchAdminContractsByIdErrors,
  PatchAdminContractsByIdResponses,
  PatchAdminCrawlerBrowserSessionsByIdRefreshData,
  PatchAdminCrawlerBrowserSessionsByIdRefreshErrors,
  PatchAdminCrawlerBrowserSessionsByIdRefreshResponses,
  PatchAdminCrawlerJobsByIdCancelData,
  PatchAdminCrawlerJobsByIdCancelErrors,
  PatchAdminCrawlerJobsByIdCancelResponses,
  PatchAdminCrawlerNewsMonitorsByIdArchiveData,
  PatchAdminCrawlerNewsMonitorsByIdArchiveErrors,
  PatchAdminCrawlerNewsMonitorsByIdArchiveResponses,
  PatchAdminCrawlerNewsMonitorsByIdData,
  PatchAdminCrawlerNewsMonitorsByIdErrors,
  PatchAdminCrawlerNewsMonitorsByIdPauseData,
  PatchAdminCrawlerNewsMonitorsByIdPauseErrors,
  PatchAdminCrawlerNewsMonitorsByIdPauseResponses,
  PatchAdminCrawlerNewsMonitorsByIdResponses,
  PatchAdminCrawlerNewsMonitorsByIdResumeData,
  PatchAdminCrawlerNewsMonitorsByIdResumeErrors,
  PatchAdminCrawlerNewsMonitorsByIdResumeResponses,
  PatchAdminCrawlerSchedulesByIdData,
  PatchAdminCrawlerSchedulesByIdDisableData,
  PatchAdminCrawlerSchedulesByIdDisableErrors,
  PatchAdminCrawlerSchedulesByIdDisableResponses,
  PatchAdminCrawlerSchedulesByIdEnableData,
  PatchAdminCrawlerSchedulesByIdEnableErrors,
  PatchAdminCrawlerSchedulesByIdEnableResponses,
  PatchAdminCrawlerSchedulesByIdErrors,
  PatchAdminCrawlerSchedulesByIdResponses,
  PatchAdminCrawlerSchedulesByIdTriggerData,
  PatchAdminCrawlerSchedulesByIdTriggerErrors,
  PatchAdminCrawlerSchedulesByIdTriggerResponses,
  PatchAdminCrawlerSiteConfigsByIdData,
  PatchAdminCrawlerSiteConfigsByIdErrors,
  PatchAdminCrawlerSiteConfigsByIdResponses,
  PatchAdminCreditPackagesByIdData,
  PatchAdminCreditPackagesByIdErrors,
  PatchAdminCreditPackagesByIdResponses,
  PatchAdminCrmActivitiesByIdData,
  PatchAdminCrmActivitiesByIdErrors,
  PatchAdminCrmActivitiesByIdResponses,
  PatchAdminCrmAddressesByIdData,
  PatchAdminCrmAddressesByIdErrors,
  PatchAdminCrmAddressesByIdResponses,
  PatchAdminCrmAddressesByIdSetPrimaryData,
  PatchAdminCrmAddressesByIdSetPrimaryErrors,
  PatchAdminCrmAddressesByIdSetPrimaryResponses,
  PatchAdminCrmCompaniesByIdData,
  PatchAdminCrmCompaniesByIdErrors,
  PatchAdminCrmCompaniesByIdResponses,
  PatchAdminCrmContactsByIdArchiveData,
  PatchAdminCrmContactsByIdArchiveErrors,
  PatchAdminCrmContactsByIdArchiveResponses,
  PatchAdminCrmContactsByIdData,
  PatchAdminCrmContactsByIdErrors,
  PatchAdminCrmContactsByIdResponses,
  PatchAdminCrmCustomEntitiesByIdData,
  PatchAdminCrmCustomEntitiesByIdErrors,
  PatchAdminCrmCustomEntitiesByIdResponses,
  PatchAdminCrmDealsByIdData,
  PatchAdminCrmDealsByIdErrors,
  PatchAdminCrmDealsByIdMoveStageData,
  PatchAdminCrmDealsByIdMoveStageErrors,
  PatchAdminCrmDealsByIdMoveStageResponses,
  PatchAdminCrmDealsByIdResponses,
  PatchAdminCrmEmailAddressesByIdData,
  PatchAdminCrmEmailAddressesByIdErrors,
  PatchAdminCrmEmailAddressesByIdResponses,
  PatchAdminCrmEmailAddressesByIdSetPrimaryData,
  PatchAdminCrmEmailAddressesByIdSetPrimaryErrors,
  PatchAdminCrmEmailAddressesByIdSetPrimaryResponses,
  PatchAdminCrmExportsByIdRefreshUrlData,
  PatchAdminCrmExportsByIdRefreshUrlErrors,
  PatchAdminCrmExportsByIdRefreshUrlResponses,
  PatchAdminCrmFieldDefinitionsByIdData,
  PatchAdminCrmFieldDefinitionsByIdErrors,
  PatchAdminCrmFieldDefinitionsByIdResponses,
  PatchAdminCrmPhoneNumbersByIdData,
  PatchAdminCrmPhoneNumbersByIdErrors,
  PatchAdminCrmPhoneNumbersByIdResponses,
  PatchAdminCrmPhoneNumbersByIdSetPrimaryData,
  PatchAdminCrmPhoneNumbersByIdSetPrimaryErrors,
  PatchAdminCrmPhoneNumbersByIdSetPrimaryResponses,
  PatchAdminCrmPipelinesByIdData,
  PatchAdminCrmPipelinesByIdErrors,
  PatchAdminCrmPipelinesByIdResponses,
  PatchAdminCrmPipelineStagesByIdData,
  PatchAdminCrmPipelineStagesByIdErrors,
  PatchAdminCrmPipelineStagesByIdResponses,
  PatchAdminCrmRelationshipTypesByIdData,
  PatchAdminCrmRelationshipTypesByIdErrors,
  PatchAdminCrmRelationshipTypesByIdResponses,
  PatchAdminCrmSocialProfilesByIdData,
  PatchAdminCrmSocialProfilesByIdErrors,
  PatchAdminCrmSocialProfilesByIdResponses,
  PatchAdminCrmSyncConfigsByIdData,
  PatchAdminCrmSyncConfigsByIdErrors,
  PatchAdminCrmSyncConfigsByIdResponses,
  PatchAdminCrmWebsitesByIdData,
  PatchAdminCrmWebsitesByIdErrors,
  PatchAdminCrmWebsitesByIdResponses,
  PatchAdminCrmWebsitesByIdSetPrimaryData,
  PatchAdminCrmWebsitesByIdSetPrimaryErrors,
  PatchAdminCrmWebsitesByIdSetPrimaryResponses,
  PatchAdminCustomersByIdData,
  PatchAdminCustomersByIdErrors,
  PatchAdminCustomersByIdResponses,
  PatchAdminDataSubjectRequestsByIdStatusData,
  PatchAdminDataSubjectRequestsByIdStatusErrors,
  PatchAdminDataSubjectRequestsByIdStatusResponses,
  PatchAdminEmailInboundAddressesByIdData,
  PatchAdminEmailInboundAddressesByIdDisableData,
  PatchAdminEmailInboundAddressesByIdDisableErrors,
  PatchAdminEmailInboundAddressesByIdDisableResponses,
  PatchAdminEmailInboundAddressesByIdEnableData,
  PatchAdminEmailInboundAddressesByIdEnableErrors,
  PatchAdminEmailInboundAddressesByIdEnableResponses,
  PatchAdminEmailInboundAddressesByIdErrors,
  PatchAdminEmailInboundAddressesByIdResponses,
  PatchAdminEmailInboundAddressesByIdRotateTokenData,
  PatchAdminEmailInboundAddressesByIdRotateTokenErrors,
  PatchAdminEmailInboundAddressesByIdRotateTokenResponses,
  PatchAdminEmailInclusionsByIdData,
  PatchAdminEmailInclusionsByIdErrors,
  PatchAdminEmailInclusionsByIdResponses,
  PatchAdminEmailMarketingCampaignsByIdData,
  PatchAdminEmailMarketingCampaignsByIdErrors,
  PatchAdminEmailMarketingCampaignsByIdResponses,
  PatchAdminEmailMarketingGeneratedEmailsByIdApproveData,
  PatchAdminEmailMarketingGeneratedEmailsByIdApproveErrors,
  PatchAdminEmailMarketingGeneratedEmailsByIdApproveResponses,
  PatchAdminEmailMarketingGeneratedEmailsByIdData,
  PatchAdminEmailMarketingGeneratedEmailsByIdErrors,
  PatchAdminEmailMarketingGeneratedEmailsByIdRejectData,
  PatchAdminEmailMarketingGeneratedEmailsByIdRejectErrors,
  PatchAdminEmailMarketingGeneratedEmailsByIdRejectResponses,
  PatchAdminEmailMarketingGeneratedEmailsByIdResponses,
  PatchAdminEmailMarketingGeneratedEmailsByIdScheduleData,
  PatchAdminEmailMarketingGeneratedEmailsByIdScheduleErrors,
  PatchAdminEmailMarketingGeneratedEmailsByIdScheduleResponses,
  PatchAdminEmailMarketingSenderProfilesByIdData,
  PatchAdminEmailMarketingSenderProfilesByIdErrors,
  PatchAdminEmailMarketingSenderProfilesByIdResponses,
  PatchAdminEmailMarketingSenderProfilesByIdSetDefaultData,
  PatchAdminEmailMarketingSenderProfilesByIdSetDefaultErrors,
  PatchAdminEmailMarketingSenderProfilesByIdSetDefaultResponses,
  PatchAdminEmailMarketingSenderProfilesByIdValidateDnsData,
  PatchAdminEmailMarketingSenderProfilesByIdValidateDnsErrors,
  PatchAdminEmailMarketingSenderProfilesByIdValidateDnsResponses,
  PatchAdminEmailMarketingTemplatesByIdArchiveData,
  PatchAdminEmailMarketingTemplatesByIdArchiveErrors,
  PatchAdminEmailMarketingTemplatesByIdArchiveResponses,
  PatchAdminEmailMarketingTemplatesByIdData,
  PatchAdminEmailMarketingTemplatesByIdErrors,
  PatchAdminEmailMarketingTemplatesByIdPreviewData,
  PatchAdminEmailMarketingTemplatesByIdPreviewErrors,
  PatchAdminEmailMarketingTemplatesByIdPreviewResponses,
  PatchAdminEmailMarketingTemplatesByIdPublishData,
  PatchAdminEmailMarketingTemplatesByIdPublishErrors,
  PatchAdminEmailMarketingTemplatesByIdPublishResponses,
  PatchAdminEmailMarketingTemplatesByIdResponses,
  PatchAdminEmailMarketingTemplatesByIdRestoreData,
  PatchAdminEmailMarketingTemplatesByIdRestoreErrors,
  PatchAdminEmailMarketingTemplatesByIdRestoreResponses,
  PatchAdminEmailMarketingTemplatesByIdRollbackData,
  PatchAdminEmailMarketingTemplatesByIdRollbackErrors,
  PatchAdminEmailMarketingTemplatesByIdRollbackResponses,
  PatchAdminEmailMarketingTemplatesByIdUnpublishData,
  PatchAdminEmailMarketingTemplatesByIdUnpublishErrors,
  PatchAdminEmailMarketingTemplatesByIdUnpublishResponses,
  PatchAdminEmailOutboundEmailsByIdCancelScheduleData,
  PatchAdminEmailOutboundEmailsByIdCancelScheduleErrors,
  PatchAdminEmailOutboundEmailsByIdCancelScheduleResponses,
  PatchAdminEmailOutboundEmailsByIdData,
  PatchAdminEmailOutboundEmailsByIdErrors,
  PatchAdminEmailOutboundEmailsByIdResponses,
  PatchAdminEmailOutboundEmailsByIdScheduleData,
  PatchAdminEmailOutboundEmailsByIdScheduleErrors,
  PatchAdminEmailOutboundEmailsByIdScheduleResponses,
  PatchAdminEmailOutboundEmailsByIdSendData,
  PatchAdminEmailOutboundEmailsByIdSendErrors,
  PatchAdminEmailOutboundEmailsByIdSendResponses,
  PatchAdminEphiAssetsByIdData,
  PatchAdminEphiAssetsByIdErrors,
  PatchAdminEphiAssetsByIdResponses,
  PatchAdminEphiDataFlowsByIdData,
  PatchAdminEphiDataFlowsByIdErrors,
  PatchAdminEphiDataFlowsByIdResponses,
  PatchAdminExtractionConfigEnumsByIdData,
  PatchAdminExtractionConfigEnumsByIdErrors,
  PatchAdminExtractionConfigEnumsByIdResponses,
  PatchAdminExtractionDocumentsByIdCancelData,
  PatchAdminExtractionDocumentsByIdCancelErrors,
  PatchAdminExtractionDocumentsByIdCancelResponses,
  PatchAdminExtractionDocumentsByIdDismissData,
  PatchAdminExtractionDocumentsByIdDismissErrors,
  PatchAdminExtractionDocumentsByIdDismissResponses,
  PatchAdminExtractionDocumentsByIdDismissTrainingData,
  PatchAdminExtractionDocumentsByIdDismissTrainingErrors,
  PatchAdminExtractionDocumentsByIdDismissTrainingResponses,
  PatchAdminExtractionDocumentsByIdExcludeData,
  PatchAdminExtractionDocumentsByIdExcludeErrors,
  PatchAdminExtractionDocumentsByIdExcludeResponses,
  PatchAdminExtractionDocumentsByIdFinishUploadData,
  PatchAdminExtractionDocumentsByIdFinishUploadErrors,
  PatchAdminExtractionDocumentsByIdFinishUploadResponses,
  PatchAdminExtractionDocumentsByIdIncludeData,
  PatchAdminExtractionDocumentsByIdIncludeErrors,
  PatchAdminExtractionDocumentsByIdIncludeResponses,
  PatchAdminExtractionDocumentsByIdMarkTrainedData,
  PatchAdminExtractionDocumentsByIdMarkTrainedErrors,
  PatchAdminExtractionDocumentsByIdMarkTrainedResponses,
  PatchAdminExtractionDocumentsByIdReprocessData,
  PatchAdminExtractionDocumentsByIdReprocessErrors,
  PatchAdminExtractionDocumentsByIdReprocessResponses,
  PatchAdminExtractionDocumentsByIdRestoreData,
  PatchAdminExtractionDocumentsByIdRestoreErrors,
  PatchAdminExtractionDocumentsByIdRestoreResponses,
  PatchAdminExtractionDocumentsByIdStatusData,
  PatchAdminExtractionDocumentsByIdStatusErrors,
  PatchAdminExtractionDocumentsByIdStatusResponses,
  PatchAdminExtractionDocumentsByIdVerificationData,
  PatchAdminExtractionDocumentsByIdVerificationErrors,
  PatchAdminExtractionDocumentsByIdVerificationResponses,
  PatchAdminExtractionResultsByIdData,
  PatchAdminExtractionResultsByIdErrors,
  PatchAdminExtractionResultsByIdRegenerateData,
  PatchAdminExtractionResultsByIdRegenerateErrors,
  PatchAdminExtractionResultsByIdRegenerateResponses,
  PatchAdminExtractionResultsByIdResponses,
  PatchAdminExtractionResultsByIdSaveCorrectionsData,
  PatchAdminExtractionResultsByIdSaveCorrectionsErrors,
  PatchAdminExtractionResultsByIdSaveCorrectionsResponses,
  PatchAdminExtractionWorkflowsByIdData,
  PatchAdminExtractionWorkflowsByIdErrors,
  PatchAdminExtractionWorkflowsByIdResponses,
  PatchAdminFeatureDefinitionsByIdData,
  PatchAdminFeatureDefinitionsByIdErrors,
  PatchAdminFeatureDefinitionsByIdResponses,
  PatchAdminFormDeploymentsByIdAcceptUpdateData,
  PatchAdminFormDeploymentsByIdAcceptUpdateErrors,
  PatchAdminFormDeploymentsByIdAcceptUpdateResponses,
  PatchAdminFormDeploymentsByIdData,
  PatchAdminFormDeploymentsByIdErrors,
  PatchAdminFormDeploymentsByIdResponses,
  PatchAdminFormGenerationsByIdCancelData,
  PatchAdminFormGenerationsByIdCancelErrors,
  PatchAdminFormGenerationsByIdCancelResponses,
  PatchAdminFormVersionsByIdClassifyFieldData,
  PatchAdminFormVersionsByIdClassifyFieldErrors,
  PatchAdminFormVersionsByIdClassifyFieldResponses,
  PatchAdminFormVersionsByIdData,
  PatchAdminFormVersionsByIdErrors,
  PatchAdminFormVersionsByIdResponses,
  PatchAdminImpactAssessmentsByIdApproveData,
  PatchAdminImpactAssessmentsByIdApproveErrors,
  PatchAdminImpactAssessmentsByIdApproveResponses,
  PatchAdminImpactAssessmentsByIdData,
  PatchAdminImpactAssessmentsByIdErrors,
  PatchAdminImpactAssessmentsByIdResponses,
  PatchAdminInvitationsByIdAcceptByIdData,
  PatchAdminInvitationsByIdAcceptByIdErrors,
  PatchAdminInvitationsByIdAcceptByIdResponses,
  PatchAdminInvitationsByIdAcceptByUserData,
  PatchAdminInvitationsByIdAcceptByUserErrors,
  PatchAdminInvitationsByIdAcceptByUserResponses,
  PatchAdminInvitationsByIdAcceptData,
  PatchAdminInvitationsByIdAcceptErrors,
  PatchAdminInvitationsByIdAcceptResponses,
  PatchAdminInvitationsByIdDeclineData,
  PatchAdminInvitationsByIdDeclineErrors,
  PatchAdminInvitationsByIdDeclineResponses,
  PatchAdminInvitationsByIdResendData,
  PatchAdminInvitationsByIdResendErrors,
  PatchAdminInvitationsByIdResendResponses,
  PatchAdminInvitationsByIdRevokeData,
  PatchAdminInvitationsByIdRevokeErrors,
  PatchAdminInvitationsByIdRevokeResponses,
  PatchAdminInvoicesByIdApplyAiSuggestionsData,
  PatchAdminInvoicesByIdApplyAiSuggestionsErrors,
  PatchAdminInvoicesByIdApplyAiSuggestionsResponses,
  PatchAdminInvoicesByIdApproveData,
  PatchAdminInvoicesByIdApproveErrors,
  PatchAdminInvoicesByIdApproveResponses,
  PatchAdminInvoicesByIdData,
  PatchAdminInvoicesByIdDisputeData,
  PatchAdminInvoicesByIdDisputeErrors,
  PatchAdminInvoicesByIdDisputeResponses,
  PatchAdminInvoicesByIdErrors,
  PatchAdminInvoicesByIdMarkOverdueData,
  PatchAdminInvoicesByIdMarkOverdueErrors,
  PatchAdminInvoicesByIdMarkOverdueResponses,
  PatchAdminInvoicesByIdMarkPaidData,
  PatchAdminInvoicesByIdMarkPaidErrors,
  PatchAdminInvoicesByIdMarkPaidResponses,
  PatchAdminInvoicesByIdMarkViewedData,
  PatchAdminInvoicesByIdMarkViewedErrors,
  PatchAdminInvoicesByIdMarkViewedResponses,
  PatchAdminInvoicesByIdResolveDisputeData,
  PatchAdminInvoicesByIdResolveDisputeErrors,
  PatchAdminInvoicesByIdResolveDisputeResponses,
  PatchAdminInvoicesByIdResponses,
  PatchAdminInvoicesByIdSchedulePaymentData,
  PatchAdminInvoicesByIdSchedulePaymentErrors,
  PatchAdminInvoicesByIdSchedulePaymentResponses,
  PatchAdminInvoicesByIdSendData,
  PatchAdminInvoicesByIdSendErrors,
  PatchAdminInvoicesByIdSendResponses,
  PatchAdminInvoicesByIdSubmitForApprovalData,
  PatchAdminInvoicesByIdSubmitForApprovalErrors,
  PatchAdminInvoicesByIdSubmitForApprovalResponses,
  PatchAdminInvoicesByIdVoidData,
  PatchAdminInvoicesByIdVoidErrors,
  PatchAdminInvoicesByIdVoidResponses,
  PatchAdminInvoicesContactsByIdData,
  PatchAdminInvoicesContactsByIdErrors,
  PatchAdminInvoicesContactsByIdResponses,
  PatchAdminInvoicesLinesByIdData,
  PatchAdminInvoicesLinesByIdErrors,
  PatchAdminInvoicesLinesByIdResponses,
  PatchAdminInvoicesRecurringSchedulesByIdData,
  PatchAdminInvoicesRecurringSchedulesByIdErrors,
  PatchAdminInvoicesRecurringSchedulesByIdPauseData,
  PatchAdminInvoicesRecurringSchedulesByIdPauseErrors,
  PatchAdminInvoicesRecurringSchedulesByIdPauseResponses,
  PatchAdminInvoicesRecurringSchedulesByIdResponses,
  PatchAdminInvoicesRecurringSchedulesByIdResumeData,
  PatchAdminInvoicesRecurringSchedulesByIdResumeErrors,
  PatchAdminInvoicesRecurringSchedulesByIdResumeResponses,
  PatchAdminInvoicesRulesByIdData,
  PatchAdminInvoicesRulesByIdDeactivateData,
  PatchAdminInvoicesRulesByIdDeactivateErrors,
  PatchAdminInvoicesRulesByIdDeactivateResponses,
  PatchAdminInvoicesRulesByIdErrors,
  PatchAdminInvoicesRulesByIdResponses,
  PatchAdminInvoicesTemplatesByIdData,
  PatchAdminInvoicesTemplatesByIdErrors,
  PatchAdminInvoicesTemplatesByIdResponses,
  PatchAdminIsvCrmChannelCaptureConfigByIdData,
  PatchAdminIsvCrmChannelCaptureConfigByIdErrors,
  PatchAdminIsvCrmChannelCaptureConfigByIdResponses,
  PatchAdminIsvCrmEntityTypesByIdData,
  PatchAdminIsvCrmEntityTypesByIdErrors,
  PatchAdminIsvCrmEntityTypesByIdResponses,
  PatchAdminIsvPricingOverridesByIdData,
  PatchAdminIsvPricingOverridesByIdErrors,
  PatchAdminIsvPricingOverridesByIdResponses,
  PatchAdminLegalDocumentsByIdData,
  PatchAdminLegalDocumentsByIdErrors,
  PatchAdminLegalDocumentsByIdPublishData,
  PatchAdminLegalDocumentsByIdPublishErrors,
  PatchAdminLegalDocumentsByIdPublishResponses,
  PatchAdminLegalDocumentsByIdResponses,
  PatchAdminLegalDocumentsByIdUnpublishData,
  PatchAdminLegalDocumentsByIdUnpublishErrors,
  PatchAdminLegalDocumentsByIdUnpublishResponses,
  PatchAdminMeetingsByIdData,
  PatchAdminMeetingsByIdErrors,
  PatchAdminMeetingsByIdResponses,
  PatchAdminMessagesByIdData,
  PatchAdminMessagesByIdErrors,
  PatchAdminMessagesByIdResponses,
  PatchAdminNotificationMethodsByIdData,
  PatchAdminNotificationMethodsByIdErrors,
  PatchAdminNotificationMethodsByIdResponses,
  PatchAdminNotificationMethodsByIdSendVerificationData,
  PatchAdminNotificationMethodsByIdSendVerificationErrors,
  PatchAdminNotificationMethodsByIdSendVerificationResponses,
  PatchAdminNotificationMethodsByIdSetPrimaryData,
  PatchAdminNotificationMethodsByIdSetPrimaryErrors,
  PatchAdminNotificationMethodsByIdSetPrimaryResponses,
  PatchAdminNotificationMethodsByIdVerifyData,
  PatchAdminNotificationMethodsByIdVerifyErrors,
  PatchAdminNotificationMethodsByIdVerifyResponses,
  PatchAdminNotificationPreferencesByIdData,
  PatchAdminNotificationPreferencesByIdErrors,
  PatchAdminNotificationPreferencesByIdResponses,
  PatchAdminPaymentMethodsByIdData,
  PatchAdminPaymentMethodsByIdDefaultData,
  PatchAdminPaymentMethodsByIdDefaultErrors,
  PatchAdminPaymentMethodsByIdDefaultResponses,
  PatchAdminPaymentMethodsByIdErrors,
  PatchAdminPaymentMethodsByIdResponses,
  PatchAdminPipelineExecutionsByIdApproveData,
  PatchAdminPipelineExecutionsByIdApproveErrors,
  PatchAdminPipelineExecutionsByIdApproveResponses,
  PatchAdminPipelineExecutionsByIdCheckpointData,
  PatchAdminPipelineExecutionsByIdCheckpointErrors,
  PatchAdminPipelineExecutionsByIdCheckpointResponses,
  PatchAdminPipelineExecutionsByIdNoteData,
  PatchAdminPipelineExecutionsByIdNoteErrors,
  PatchAdminPipelineExecutionsByIdNoteResponses,
  PatchAdminPipelineExecutionsByIdRefineData,
  PatchAdminPipelineExecutionsByIdRefineErrors,
  PatchAdminPipelineExecutionsByIdRefineResponses,
  PatchAdminPipelineExecutionsByIdRejectData,
  PatchAdminPipelineExecutionsByIdRejectErrors,
  PatchAdminPipelineExecutionsByIdRejectResponses,
  PatchAdminPipelineNodesByIdData,
  PatchAdminPipelineNodesByIdErrors,
  PatchAdminPipelineNodesByIdResponses,
  PatchAdminPipelinesByIdData,
  PatchAdminPipelinesByIdErrors,
  PatchAdminPipelinesByIdResponses,
  PatchAdminPlanFeatureAllocationsByIdData,
  PatchAdminPlanFeatureAllocationsByIdErrors,
  PatchAdminPlanFeatureAllocationsByIdResponses,
  PatchAdminPlansByIdArchiveData,
  PatchAdminPlansByIdArchiveErrors,
  PatchAdminPlansByIdArchiveResponses,
  PatchAdminPlansByIdData,
  PatchAdminPlansByIdDeprecateData,
  PatchAdminPlansByIdDeprecateErrors,
  PatchAdminPlansByIdDeprecateResponses,
  PatchAdminPlansByIdErrors,
  PatchAdminPlansByIdResponses,
  PatchAdminPlansByIdScheduleSunsetData,
  PatchAdminPlansByIdScheduleSunsetErrors,
  PatchAdminPlansByIdScheduleSunsetResponses,
  PatchAdminPlatformPricingConfigsByIdData,
  PatchAdminPlatformPricingConfigsByIdErrors,
  PatchAdminPlatformPricingConfigsByIdResponses,
  PatchAdminPlatformTonesByIdData,
  PatchAdminPlatformTonesByIdErrors,
  PatchAdminPlatformTonesByIdResponses,
  PatchAdminPolicyReviewSchedulesByIdCompleteReviewData,
  PatchAdminPolicyReviewSchedulesByIdCompleteReviewErrors,
  PatchAdminPolicyReviewSchedulesByIdCompleteReviewResponses,
  PatchAdminPolicyReviewSchedulesByIdMarkDueData,
  PatchAdminPolicyReviewSchedulesByIdMarkDueErrors,
  PatchAdminPolicyReviewSchedulesByIdMarkDueResponses,
  PatchAdminPolicyReviewSchedulesByIdMarkOverdueData,
  PatchAdminPolicyReviewSchedulesByIdMarkOverdueErrors,
  PatchAdminPolicyReviewSchedulesByIdMarkOverdueResponses,
  PatchAdminPortalChangeRequestsByIdApproveData,
  PatchAdminPortalChangeRequestsByIdApproveErrors,
  PatchAdminPortalChangeRequestsByIdApproveResponses,
  PatchAdminPortalChangeRequestsByIdRejectData,
  PatchAdminPortalChangeRequestsByIdRejectErrors,
  PatchAdminPortalChangeRequestsByIdRejectResponses,
  PatchAdminPostProcessingHooksByIdData,
  PatchAdminPostProcessingHooksByIdErrors,
  PatchAdminPostProcessingHooksByIdResponses,
  PatchAdminPricingStrategiesByIdData,
  PatchAdminPricingStrategiesByIdErrors,
  PatchAdminPricingStrategiesByIdResponses,
  PatchAdminQuoteRequestsByIdData,
  PatchAdminQuoteRequestsByIdErrors,
  PatchAdminQuoteRequestsByIdResponses,
  PatchAdminRecipesByIdArchiveData,
  PatchAdminRecipesByIdArchiveErrors,
  PatchAdminRecipesByIdArchiveResponses,
  PatchAdminRecipesByIdData,
  PatchAdminRecipesByIdErrors,
  PatchAdminRecipesByIdReEnrichData,
  PatchAdminRecipesByIdReEnrichErrors,
  PatchAdminRecipesByIdReEnrichResponses,
  PatchAdminRecipesByIdResponses,
  PatchAdminRecipesByIdRestoreData,
  PatchAdminRecipesByIdRestoreErrors,
  PatchAdminRecipesByIdRestoreResponses,
  PatchAdminRecipesCollectionRecipesByIdData,
  PatchAdminRecipesCollectionRecipesByIdErrors,
  PatchAdminRecipesCollectionRecipesByIdResponses,
  PatchAdminRecipesCollectionsByIdData,
  PatchAdminRecipesCollectionsByIdErrors,
  PatchAdminRecipesCollectionsByIdResponses,
  PatchAdminRecipesFavoritesByIdData,
  PatchAdminRecipesFavoritesByIdErrors,
  PatchAdminRecipesFavoritesByIdResponses,
  PatchAdminRecipesFoodItemsByIdData,
  PatchAdminRecipesFoodItemsByIdErrors,
  PatchAdminRecipesFoodItemsByIdResponses,
  PatchAdminRecipesIngredientsByIdData,
  PatchAdminRecipesIngredientsByIdErrors,
  PatchAdminRecipesIngredientsByIdResponses,
  PatchAdminRecipesMealSchedulesByIdData,
  PatchAdminRecipesMealSchedulesByIdErrors,
  PatchAdminRecipesMealSchedulesByIdResponses,
  PatchAdminRecipesRecipeNutritionsByIdData,
  PatchAdminRecipesRecipeNutritionsByIdErrors,
  PatchAdminRecipesRecipeNutritionsByIdResponses,
  PatchAdminRecipesScheduledMealsByIdData,
  PatchAdminRecipesScheduledMealsByIdErrors,
  PatchAdminRecipesScheduledMealsByIdResponses,
  PatchAdminRecipesShoppingListItemsByIdData,
  PatchAdminRecipesShoppingListItemsByIdErrors,
  PatchAdminRecipesShoppingListItemsByIdResponses,
  PatchAdminRecipesShoppingListsByIdData,
  PatchAdminRecipesShoppingListsByIdErrors,
  PatchAdminRecipesShoppingListsByIdResponses,
  PatchAdminRecipesTagsByIdData,
  PatchAdminRecipesTagsByIdErrors,
  PatchAdminRecipesTagsByIdResponses,
  PatchAdminRetentionPoliciesByIdData,
  PatchAdminRetentionPoliciesByIdErrors,
  PatchAdminRetentionPoliciesByIdResponses,
  PatchAdminReviewQueuesByIdData,
  PatchAdminReviewQueuesByIdErrors,
  PatchAdminReviewQueuesByIdResponses,
  PatchAdminReviewsByIdApproveData,
  PatchAdminReviewsByIdApproveErrors,
  PatchAdminReviewsByIdApproveResponses,
  PatchAdminReviewsByIdAssignData,
  PatchAdminReviewsByIdAssignErrors,
  PatchAdminReviewsByIdAssignResponses,
  PatchAdminReviewsByIdClaimData,
  PatchAdminReviewsByIdClaimErrors,
  PatchAdminReviewsByIdClaimResponses,
  PatchAdminReviewsByIdCorrectData,
  PatchAdminReviewsByIdCorrectErrors,
  PatchAdminReviewsByIdCorrectResponses,
  PatchAdminReviewsByIdEscalateData,
  PatchAdminReviewsByIdEscalateErrors,
  PatchAdminReviewsByIdEscalateResponses,
  PatchAdminReviewsByIdRejectData,
  PatchAdminReviewsByIdRejectErrors,
  PatchAdminReviewsByIdRejectResponses,
  PatchAdminReviewsByIdUnclaimData,
  PatchAdminReviewsByIdUnclaimErrors,
  PatchAdminReviewsByIdUnclaimResponses,
  PatchAdminRiskAssessmentsByIdStatusData,
  PatchAdminRiskAssessmentsByIdStatusErrors,
  PatchAdminRiskAssessmentsByIdStatusResponses,
  PatchAdminRolesByIdData,
  PatchAdminRolesByIdErrors,
  PatchAdminRolesByIdResponses,
  PatchAdminSchedulingAvailabilityRulesByIdData,
  PatchAdminSchedulingAvailabilityRulesByIdErrors,
  PatchAdminSchedulingAvailabilityRulesByIdResponses,
  PatchAdminSchedulingBookingsByIdCancelData,
  PatchAdminSchedulingBookingsByIdCancelErrors,
  PatchAdminSchedulingBookingsByIdCancelResponses,
  PatchAdminSchedulingBookingsByIdConfirmData,
  PatchAdminSchedulingBookingsByIdConfirmErrors,
  PatchAdminSchedulingBookingsByIdConfirmResponses,
  PatchAdminSchedulingBookingsByIdMarkNoShowData,
  PatchAdminSchedulingBookingsByIdMarkNoShowErrors,
  PatchAdminSchedulingBookingsByIdMarkNoShowResponses,
  PatchAdminSchedulingBookingsByIdRescheduleData,
  PatchAdminSchedulingBookingsByIdRescheduleErrors,
  PatchAdminSchedulingBookingsByIdRescheduleResponses,
  PatchAdminSchedulingCalendarSyncsByIdData,
  PatchAdminSchedulingCalendarSyncsByIdErrors,
  PatchAdminSchedulingCalendarSyncsByIdPauseData,
  PatchAdminSchedulingCalendarSyncsByIdPauseErrors,
  PatchAdminSchedulingCalendarSyncsByIdPauseResponses,
  PatchAdminSchedulingCalendarSyncsByIdResponses,
  PatchAdminSchedulingCalendarSyncsByIdResumeData,
  PatchAdminSchedulingCalendarSyncsByIdResumeErrors,
  PatchAdminSchedulingCalendarSyncsByIdResumeResponses,
  PatchAdminSchedulingEventsByIdCancelData,
  PatchAdminSchedulingEventsByIdCancelErrors,
  PatchAdminSchedulingEventsByIdCancelResponses,
  PatchAdminSchedulingEventsByIdCompleteData,
  PatchAdminSchedulingEventsByIdCompleteErrors,
  PatchAdminSchedulingEventsByIdCompleteResponses,
  PatchAdminSchedulingEventsByIdData,
  PatchAdminSchedulingEventsByIdErrors,
  PatchAdminSchedulingEventsByIdRescheduleData,
  PatchAdminSchedulingEventsByIdRescheduleErrors,
  PatchAdminSchedulingEventsByIdRescheduleResponses,
  PatchAdminSchedulingEventsByIdResponses,
  PatchAdminSchedulingEventTypesByIdArchiveData,
  PatchAdminSchedulingEventTypesByIdArchiveErrors,
  PatchAdminSchedulingEventTypesByIdArchiveResponses,
  PatchAdminSchedulingEventTypesByIdData,
  PatchAdminSchedulingEventTypesByIdErrors,
  PatchAdminSchedulingEventTypesByIdResponses,
  PatchAdminSchedulingLocationsByIdData,
  PatchAdminSchedulingLocationsByIdDeactivateData,
  PatchAdminSchedulingLocationsByIdDeactivateErrors,
  PatchAdminSchedulingLocationsByIdDeactivateResponses,
  PatchAdminSchedulingLocationsByIdErrors,
  PatchAdminSchedulingLocationsByIdResponses,
  PatchAdminSchedulingParticipantsByIdData,
  PatchAdminSchedulingParticipantsByIdErrors,
  PatchAdminSchedulingParticipantsByIdRespondData,
  PatchAdminSchedulingParticipantsByIdRespondErrors,
  PatchAdminSchedulingParticipantsByIdRespondResponses,
  PatchAdminSchedulingParticipantsByIdResponses,
  PatchAdminSchedulingRemindersByIdCancelData,
  PatchAdminSchedulingRemindersByIdCancelErrors,
  PatchAdminSchedulingRemindersByIdCancelResponses,
  PatchAdminSearchSavedByIdData,
  PatchAdminSearchSavedByIdErrors,
  PatchAdminSearchSavedByIdResponses,
  PatchAdminSettlementsByIdData,
  PatchAdminSettlementsByIdErrors,
  PatchAdminSettlementsByIdMarkCalculatedData,
  PatchAdminSettlementsByIdMarkCalculatedErrors,
  PatchAdminSettlementsByIdMarkCalculatedResponses,
  PatchAdminSettlementsByIdMarkFailedData,
  PatchAdminSettlementsByIdMarkFailedErrors,
  PatchAdminSettlementsByIdMarkFailedResponses,
  PatchAdminSettlementsByIdMarkHeldData,
  PatchAdminSettlementsByIdMarkHeldErrors,
  PatchAdminSettlementsByIdMarkHeldResponses,
  PatchAdminSettlementsByIdMarkPaidData,
  PatchAdminSettlementsByIdMarkPaidErrors,
  PatchAdminSettlementsByIdMarkPaidResponses,
  PatchAdminSettlementsByIdReleaseData,
  PatchAdminSettlementsByIdReleaseErrors,
  PatchAdminSettlementsByIdReleaseResponses,
  PatchAdminSettlementsByIdResponses,
  PatchAdminSettlementStatementsByIdMarkDisputedData,
  PatchAdminSettlementStatementsByIdMarkDisputedErrors,
  PatchAdminSettlementStatementsByIdMarkDisputedResponses,
  PatchAdminSettlementStatementsByIdMarkPaidData,
  PatchAdminSettlementStatementsByIdMarkPaidErrors,
  PatchAdminSettlementStatementsByIdMarkPaidResponses,
  PatchAdminSettlementStatementsByIdMarkReconciledData,
  PatchAdminSettlementStatementsByIdMarkReconciledErrors,
  PatchAdminSettlementStatementsByIdMarkReconciledResponses,
  PatchAdminSocialAccountsByIdData,
  PatchAdminSocialAccountsByIdDeactivateData,
  PatchAdminSocialAccountsByIdDeactivateErrors,
  PatchAdminSocialAccountsByIdDeactivateResponses,
  PatchAdminSocialAccountsByIdDisablePostingData,
  PatchAdminSocialAccountsByIdDisablePostingErrors,
  PatchAdminSocialAccountsByIdDisablePostingResponses,
  PatchAdminSocialAccountsByIdEnablePostingData,
  PatchAdminSocialAccountsByIdEnablePostingErrors,
  PatchAdminSocialAccountsByIdEnablePostingResponses,
  PatchAdminSocialAccountsByIdErrors,
  PatchAdminSocialAccountsByIdResponses,
  PatchAdminSocialCampaignsByIdCancelData,
  PatchAdminSocialCampaignsByIdCancelErrors,
  PatchAdminSocialCampaignsByIdCancelResponses,
  PatchAdminSocialCampaignsByIdData,
  PatchAdminSocialCampaignsByIdErrors,
  PatchAdminSocialCampaignsByIdResponses,
  PatchAdminSocialCampaignsByIdScheduleData,
  PatchAdminSocialCampaignsByIdScheduleErrors,
  PatchAdminSocialCampaignsByIdScheduleResponses,
  PatchAdminSocialPostsByIdCancelData,
  PatchAdminSocialPostsByIdCancelErrors,
  PatchAdminSocialPostsByIdCancelResponses,
  PatchAdminSocialPostsByIdData,
  PatchAdminSocialPostsByIdErrors,
  PatchAdminSocialPostsByIdPublishData,
  PatchAdminSocialPostsByIdPublishErrors,
  PatchAdminSocialPostsByIdPublishResponses,
  PatchAdminSocialPostsByIdResponses,
  PatchAdminSocialPostsByIdRetryData,
  PatchAdminSocialPostsByIdRetryErrors,
  PatchAdminSocialPostsByIdRetryResponses,
  PatchAdminSocialPostsByIdScheduleData,
  PatchAdminSocialPostsByIdScheduleErrors,
  PatchAdminSocialPostsByIdScheduleResponses,
  PatchAdminSocialPostsByIdSeoData,
  PatchAdminSocialPostsByIdSeoErrors,
  PatchAdminSocialPostsByIdSeoResponses,
  PatchAdminSocialTrendingWatchesByIdData,
  PatchAdminSocialTrendingWatchesByIdErrors,
  PatchAdminSocialTrendingWatchesByIdMarkTriggeredData,
  PatchAdminSocialTrendingWatchesByIdMarkTriggeredErrors,
  PatchAdminSocialTrendingWatchesByIdMarkTriggeredResponses,
  PatchAdminSocialTrendingWatchesByIdResponses,
  PatchAdminStorageFilesByIdArchiveData,
  PatchAdminStorageFilesByIdArchiveErrors,
  PatchAdminStorageFilesByIdArchiveResponses,
  PatchAdminStorageFilesByIdConfirmUploadData,
  PatchAdminStorageFilesByIdConfirmUploadErrors,
  PatchAdminStorageFilesByIdConfirmUploadResponses,
  PatchAdminStorageFilesByIdData,
  PatchAdminStorageFilesByIdErrors,
  PatchAdminStorageFilesByIdResponses,
  PatchAdminStorageFilesByIdRestoreData,
  PatchAdminStorageFilesByIdRestoreErrors,
  PatchAdminStorageFilesByIdRestoreResponses,
  PatchAdminStorageFilesByIdSoftDeleteData,
  PatchAdminStorageFilesByIdSoftDeleteErrors,
  PatchAdminStorageFilesByIdSoftDeleteResponses,
  PatchAdminStorageFilesByIdTagData,
  PatchAdminStorageFilesByIdTagErrors,
  PatchAdminStorageFilesByIdTagResponses,
  PatchAdminStorageFilesByIdUpdateMetadataData,
  PatchAdminStorageFilesByIdUpdateMetadataErrors,
  PatchAdminStorageFilesByIdUpdateMetadataResponses,
  PatchAdminStorageRecommendationsByIdAcceptData,
  PatchAdminStorageRecommendationsByIdAcceptErrors,
  PatchAdminStorageRecommendationsByIdAcceptResponses,
  PatchAdminStorageRecommendationsByIdDismissData,
  PatchAdminStorageRecommendationsByIdDismissErrors,
  PatchAdminStorageRecommendationsByIdDismissResponses,
  PatchAdminSubscriptionsByIdCancelData,
  PatchAdminSubscriptionsByIdCancelErrors,
  PatchAdminSubscriptionsByIdCancelResponses,
  PatchAdminSubscriptionsByIdData,
  PatchAdminSubscriptionsByIdErrors,
  PatchAdminSubscriptionsByIdResponses,
  PatchAdminSubscriptionsByIdSetRateLimitOverridesData,
  PatchAdminSubscriptionsByIdSetRateLimitOverridesErrors,
  PatchAdminSubscriptionsByIdSetRateLimitOverridesResponses,
  PatchAdminSupportCannedResponsesByIdData,
  PatchAdminSupportCannedResponsesByIdErrors,
  PatchAdminSupportCannedResponsesByIdResponses,
  PatchAdminSupportQueueMembersByIdData,
  PatchAdminSupportQueueMembersByIdErrors,
  PatchAdminSupportQueueMembersByIdResponses,
  PatchAdminSupportQueuesByIdData,
  PatchAdminSupportQueuesByIdErrors,
  PatchAdminSupportQueuesByIdResponses,
  PatchAdminSupportRoutingRulesByIdData,
  PatchAdminSupportRoutingRulesByIdErrors,
  PatchAdminSupportRoutingRulesByIdResponses,
  PatchAdminSupportSlaPoliciesByIdData,
  PatchAdminSupportSlaPoliciesByIdErrors,
  PatchAdminSupportSlaPoliciesByIdResponses,
  PatchAdminSupportSyncConfigsByIdData,
  PatchAdminSupportSyncConfigsByIdErrors,
  PatchAdminSupportSyncConfigsByIdResponses,
  PatchAdminSupportTicketsByIdAssignData,
  PatchAdminSupportTicketsByIdAssignErrors,
  PatchAdminSupportTicketsByIdAssignResponses,
  PatchAdminSupportTicketsByIdCloseData,
  PatchAdminSupportTicketsByIdCloseErrors,
  PatchAdminSupportTicketsByIdCloseResponses,
  PatchAdminSupportTicketsByIdData,
  PatchAdminSupportTicketsByIdErrors,
  PatchAdminSupportTicketsByIdMergeData,
  PatchAdminSupportTicketsByIdMergeErrors,
  PatchAdminSupportTicketsByIdMergeResponses,
  PatchAdminSupportTicketsByIdReopenData,
  PatchAdminSupportTicketsByIdReopenErrors,
  PatchAdminSupportTicketsByIdReopenResponses,
  PatchAdminSupportTicketsByIdResolveData,
  PatchAdminSupportTicketsByIdResolveErrors,
  PatchAdminSupportTicketsByIdResolveResponses,
  PatchAdminSupportTicketsByIdResponses,
  PatchAdminSysAiConfigByIdData,
  PatchAdminSysAiConfigByIdErrors,
  PatchAdminSysAiConfigByIdResponses,
  PatchAdminSystemMessagesByIdData,
  PatchAdminSystemMessagesByIdErrors,
  PatchAdminSystemMessagesByIdPublishData,
  PatchAdminSystemMessagesByIdPublishErrors,
  PatchAdminSystemMessagesByIdPublishResponses,
  PatchAdminSystemMessagesByIdResponses,
  PatchAdminSystemMessagesByIdUnpublishData,
  PatchAdminSystemMessagesByIdUnpublishErrors,
  PatchAdminSystemMessagesByIdUnpublishResponses,
  PatchAdminTenantPricingOverridesByIdData,
  PatchAdminTenantPricingOverridesByIdErrors,
  PatchAdminTenantPricingOverridesByIdResponses,
  PatchAdminTenantsByIdArchiveData,
  PatchAdminTenantsByIdArchiveErrors,
  PatchAdminTenantsByIdArchiveResponses,
  PatchAdminTenantsByIdAutoTopUpData,
  PatchAdminTenantsByIdAutoTopUpErrors,
  PatchAdminTenantsByIdAutoTopUpResponses,
  PatchAdminTenantsByIdBrandingData,
  PatchAdminTenantsByIdBrandingErrors,
  PatchAdminTenantsByIdBrandingResponses,
  PatchAdminTenantsByIdCancelData,
  PatchAdminTenantsByIdCancelErrors,
  PatchAdminTenantsByIdCancelResponses,
  PatchAdminTenantsByIdConvertToOrgData,
  PatchAdminTenantsByIdConvertToOrgErrors,
  PatchAdminTenantsByIdConvertToOrgResponses,
  PatchAdminTenantsByIdData,
  PatchAdminTenantsByIdDeactivateData,
  PatchAdminTenantsByIdDeactivateErrors,
  PatchAdminTenantsByIdDeactivateResponses,
  PatchAdminTenantsByIdErrors,
  PatchAdminTenantsByIdReactivateData,
  PatchAdminTenantsByIdReactivateErrors,
  PatchAdminTenantsByIdReactivateResponses,
  PatchAdminTenantsByIdResponses,
  PatchAdminTenantsByIdSuspendData,
  PatchAdminTenantsByIdSuspendErrors,
  PatchAdminTenantsByIdSuspendResponses,
  PatchAdminTenantsByIdTransferOwnershipData,
  PatchAdminTenantsByIdTransferOwnershipErrors,
  PatchAdminTenantsByIdTransferOwnershipResponses,
  PatchAdminTenantsByIdUnsuspendData,
  PatchAdminTenantsByIdUnsuspendErrors,
  PatchAdminTenantsByIdUnsuspendResponses,
  PatchAdminThreadsByIdArchiveData,
  PatchAdminThreadsByIdArchiveErrors,
  PatchAdminThreadsByIdArchiveResponses,
  PatchAdminThreadsByIdData,
  PatchAdminThreadsByIdErrors,
  PatchAdminThreadsByIdMetadataData,
  PatchAdminThreadsByIdMetadataErrors,
  PatchAdminThreadsByIdMetadataResponses,
  PatchAdminThreadsByIdResponses,
  PatchAdminThreadsByIdUnarchiveData,
  PatchAdminThreadsByIdUnarchiveErrors,
  PatchAdminThreadsByIdUnarchiveResponses,
  PatchAdminTrainingExamplesByIdData,
  PatchAdminTrainingExamplesByIdErrors,
  PatchAdminTrainingExamplesByIdResponses,
  PatchAdminTrainingSessionsByIdRevertData,
  PatchAdminTrainingSessionsByIdRevertErrors,
  PatchAdminTrainingSessionsByIdRevertResponses,
  PatchAdminUserProfilesByIdAcceptLegalDocumentData,
  PatchAdminUserProfilesByIdAcceptLegalDocumentErrors,
  PatchAdminUserProfilesByIdAcceptLegalDocumentResponses,
  PatchAdminUserProfilesByIdData,
  PatchAdminUserProfilesByIdDismissAnnouncementData,
  PatchAdminUserProfilesByIdDismissAnnouncementErrors,
  PatchAdminUserProfilesByIdDismissAnnouncementResponses,
  PatchAdminUserProfilesByIdDismissWelcomeData,
  PatchAdminUserProfilesByIdDismissWelcomeErrors,
  PatchAdminUserProfilesByIdDismissWelcomeResponses,
  PatchAdminUserProfilesByIdErrors,
  PatchAdminUserProfilesByIdResponses,
  PatchAdminUsersAuthOauthLinkData,
  PatchAdminUsersAuthOauthLinkErrors,
  PatchAdminUsersAuthOauthLinkResponses,
  PatchAdminUsersAuthOauthUnlinkData,
  PatchAdminUsersAuthOauthUnlinkErrors,
  PatchAdminUsersAuthOauthUnlinkResponses,
  PatchAdminUsersAuthPasswordChangeData,
  PatchAdminUsersAuthPasswordChangeErrors,
  PatchAdminUsersAuthPasswordChangeResponses,
  PatchAdminUsersAuthSessionsRevokeAllData,
  PatchAdminUsersAuthSessionsRevokeAllErrors,
  PatchAdminUsersAuthSessionsRevokeAllResponses,
  PatchAdminUsersByIdAdminData,
  PatchAdminUsersByIdAdminEmailData,
  PatchAdminUsersByIdAdminEmailErrors,
  PatchAdminUsersByIdAdminEmailResponses,
  PatchAdminUsersByIdAdminErrors,
  PatchAdminUsersByIdAdminResponses,
  PatchAdminUsersByIdConfirmEmailData,
  PatchAdminUsersByIdConfirmEmailErrors,
  PatchAdminUsersByIdConfirmEmailResponses,
  PatchAdminUsersByIdData,
  PatchAdminUsersByIdErrors,
  PatchAdminUsersByIdResetPasswordData,
  PatchAdminUsersByIdResetPasswordErrors,
  PatchAdminUsersByIdResetPasswordResponses,
  PatchAdminUsersByIdResponses,
  PatchAdminVoiceSessionsByIdFinalizeData,
  PatchAdminVoiceSessionsByIdFinalizeErrors,
  PatchAdminVoiceSessionsByIdFinalizeResponses,
  PatchAdminVoiceSessionsByIdStopData,
  PatchAdminVoiceSessionsByIdStopErrors,
  PatchAdminVoiceSessionsByIdStopResponses,
  PatchAdminVoiceTranscriptionResultsByIdData,
  PatchAdminVoiceTranscriptionResultsByIdErrors,
  PatchAdminVoiceTranscriptionResultsByIdResponses,
  PatchAdminWalletAddonsByAddonSlugCancelData,
  PatchAdminWalletAddonsByAddonSlugCancelErrors,
  PatchAdminWalletAddonsByAddonSlugCancelResponses,
  PatchAdminWalletAddonsData,
  PatchAdminWalletAddonsErrors,
  PatchAdminWalletAddonsResponses,
  PatchAdminWalletAutoTopUpData,
  PatchAdminWalletAutoTopUpErrors,
  PatchAdminWalletAutoTopUpResponses,
  PatchAdminWalletCreditsData,
  PatchAdminWalletCreditsErrors,
  PatchAdminWalletCreditsResponses,
  PatchAdminWalletInvoicesByIdVoidData,
  PatchAdminWalletInvoicesByIdVoidErrors,
  PatchAdminWalletInvoicesByIdVoidResponses,
  PatchAdminWalletPaymentRetryData,
  PatchAdminWalletPaymentRetryErrors,
  PatchAdminWalletPaymentRetryResponses,
  PatchAdminWalletPlanCancelData,
  PatchAdminWalletPlanCancelErrors,
  PatchAdminWalletPlanCancelResponses,
  PatchAdminWalletPlanData,
  PatchAdminWalletPlanErrors,
  PatchAdminWalletPlanResponses,
  PatchAdminWebhookConfigsByIdData,
  PatchAdminWebhookConfigsByIdErrors,
  PatchAdminWebhookConfigsByIdResponses,
  PatchAdminWebhookConfigsByIdRotateSecretData,
  PatchAdminWebhookConfigsByIdRotateSecretErrors,
  PatchAdminWebhookConfigsByIdRotateSecretResponses,
  PatchAdminWholesaleAgreementsByIdData,
  PatchAdminWholesaleAgreementsByIdErrors,
  PatchAdminWholesaleAgreementsByIdResponses,
  PatchAdminWorkspaceAgentConfigsByIdData,
  PatchAdminWorkspaceAgentConfigsByIdErrors,
  PatchAdminWorkspaceAgentConfigsByIdResponses,
  PatchAdminWorkspaceFormConfigsByIdData,
  PatchAdminWorkspaceFormConfigsByIdErrors,
  PatchAdminWorkspaceFormConfigsByIdResponses,
  PatchAdminWorkspacesByIdAllocateData,
  PatchAdminWorkspacesByIdAllocateErrors,
  PatchAdminWorkspacesByIdAllocateResponses,
  PatchAdminWorkspacesByIdData,
  PatchAdminWorkspacesByIdErrors,
  PatchAdminWorkspacesByIdGoLiveData,
  PatchAdminWorkspacesByIdGoLiveErrors,
  PatchAdminWorkspacesByIdGoLiveResponses,
  PatchAdminWorkspacesByIdPopulateHashesData,
  PatchAdminWorkspacesByIdPopulateHashesErrors,
  PatchAdminWorkspacesByIdPopulateHashesResponses,
  PatchAdminWorkspacesByIdResponses,
  PatchAdminWorkspacesByIdStorageSettingsData,
  PatchAdminWorkspacesByIdStorageSettingsErrors,
  PatchAdminWorkspacesByIdStorageSettingsResponses,
  PatchAdminWorkspacesByIdTakeOfflineData,
  PatchAdminWorkspacesByIdTakeOfflineErrors,
  PatchAdminWorkspacesByIdTakeOfflineResponses,
  PostAdminAccessGrantsData,
  PostAdminAccessGrantsErrors,
  PostAdminAccessGrantsResponses,
  PostAdminAgentDeploymentsData,
  PostAdminAgentDeploymentsErrors,
  PostAdminAgentDeploymentsResponses,
  PostAdminAgentsByIdAnalyzeTrainingData,
  PostAdminAgentsByIdAnalyzeTrainingErrors,
  PostAdminAgentsByIdAnalyzeTrainingResponses,
  PostAdminAgentsByIdCloneData,
  PostAdminAgentsByIdCloneErrors,
  PostAdminAgentsByIdCloneResponses,
  PostAdminAgentsByIdExportData,
  PostAdminAgentsByIdExportErrors,
  PostAdminAgentsByIdExportResponses,
  PostAdminAgentsByIdPublishVersionData,
  PostAdminAgentsByIdPublishVersionErrors,
  PostAdminAgentsByIdPublishVersionResponses,
  PostAdminAgentsByIdRestoreVersionData,
  PostAdminAgentsByIdRestoreVersionErrors,
  PostAdminAgentsByIdRestoreVersionResponses,
  PostAdminAgentsByIdSchemaVersionsByVersionIdActivateData,
  PostAdminAgentsByIdSchemaVersionsByVersionIdActivateErrors,
  PostAdminAgentsByIdSchemaVersionsByVersionIdActivateResponses,
  PostAdminAgentsByIdSchemaVersionsData,
  PostAdminAgentsByIdSchemaVersionsErrors,
  PostAdminAgentsByIdSchemaVersionsResponses,
  PostAdminAgentsByIdTeachData,
  PostAdminAgentsByIdTeachErrors,
  PostAdminAgentsByIdTeachResponses,
  PostAdminAgentsByIdTestData,
  PostAdminAgentsByIdTestErrors,
  PostAdminAgentsByIdTestResponses,
  PostAdminAgentsByIdValidateData,
  PostAdminAgentsByIdValidateErrors,
  PostAdminAgentsByIdValidateResponses,
  PostAdminAgentsCloneForWorkspaceData,
  PostAdminAgentsCloneForWorkspaceErrors,
  PostAdminAgentsCloneForWorkspaceResponses,
  PostAdminAgentsData,
  PostAdminAgentsErrors,
  PostAdminAgentsImportData,
  PostAdminAgentsImportErrors,
  PostAdminAgentsImportResponses,
  PostAdminAgentSoulsData,
  PostAdminAgentSoulsErrors,
  PostAdminAgentSoulsResponses,
  PostAdminAgentsResponses,
  PostAdminAgentTestResultsData,
  PostAdminAgentTestResultsErrors,
  PostAdminAgentTestResultsResponses,
  PostAdminAgentVersionComparisonsData,
  PostAdminAgentVersionComparisonsErrors,
  PostAdminAgentVersionComparisonsResponses,
  PostAdminAgentVersionsByIdAddSystemFieldData,
  PostAdminAgentVersionsByIdAddSystemFieldErrors,
  PostAdminAgentVersionsByIdAddSystemFieldResponses,
  PostAdminAgentVersionsByIdRemoveSystemFieldData,
  PostAdminAgentVersionsByIdRemoveSystemFieldErrors,
  PostAdminAgentVersionsByIdRemoveSystemFieldResponses,
  PostAdminAgentVersionsByIdSetSystemFieldsData,
  PostAdminAgentVersionsByIdSetSystemFieldsErrors,
  PostAdminAgentVersionsByIdSetSystemFieldsResponses,
  PostAdminAgentVersionsData,
  PostAdminAgentVersionsErrors,
  PostAdminAgentVersionsResponses,
  PostAdminAiChunksSearchData,
  PostAdminAiChunksSearchErrors,
  PostAdminAiChunksSearchResponses,
  PostAdminAiConversationsData,
  PostAdminAiConversationsErrors,
  PostAdminAiConversationsResponses,
  PostAdminAiEmbedData,
  PostAdminAiEmbedErrors,
  PostAdminAiEmbedResponses,
  PostAdminAiGraphNodesData,
  PostAdminAiGraphNodesErrors,
  PostAdminAiGraphNodesResponses,
  PostAdminAiGraphRelationshipsData,
  PostAdminAiGraphRelationshipsDeleteData,
  PostAdminAiGraphRelationshipsDeleteErrors,
  PostAdminAiGraphRelationshipsDeleteResponses,
  PostAdminAiGraphRelationshipsErrors,
  PostAdminAiGraphRelationshipsResponses,
  PostAdminAiMessagesData,
  PostAdminAiMessagesErrors,
  PostAdminAiMessagesResponses,
  PostAdminAiSearchAdvancedData,
  PostAdminAiSearchAdvancedErrors,
  PostAdminAiSearchAdvancedResponses,
  PostAdminAiSearchData,
  PostAdminAiSearchErrors,
  PostAdminAiSearchResponses,
  PostAdminAmendmentRequestsData,
  PostAdminAmendmentRequestsErrors,
  PostAdminAmendmentRequestsResponses,
  PostAdminApiKeysData,
  PostAdminApiKeysErrors,
  PostAdminApiKeysResponses,
  PostAdminApplicationsByApplicationIdEmailTemplatesBySlugPreviewData,
  PostAdminApplicationsByApplicationIdEmailTemplatesBySlugPreviewErrors,
  PostAdminApplicationsByApplicationIdEmailTemplatesBySlugPreviewResponses,
  PostAdminApplicationsByApplicationIdEmailTemplatesBySlugTestData,
  PostAdminApplicationsByApplicationIdEmailTemplatesBySlugTestErrors,
  PostAdminApplicationsByApplicationIdEmailTemplatesBySlugTestResponses,
  PostAdminApplicationsByApplicationIdEmailTemplatesData,
  PostAdminApplicationsByApplicationIdEmailTemplatesErrors,
  PostAdminApplicationsByApplicationIdEmailTemplatesResponses,
  PostAdminApplicationsData,
  PostAdminApplicationsErrors,
  PostAdminApplicationsProvisionData,
  PostAdminApplicationsProvisionErrors,
  PostAdminApplicationsProvisionResponses,
  PostAdminApplicationsResponses,
  PostAdminAuditLogsExportData,
  PostAdminAuditLogsExportErrors,
  PostAdminAuditLogsExportResponses,
  PostAdminBillingCapabilityRevocationsPreviewCascadeData,
  PostAdminBillingCapabilityRevocationsPreviewCascadeErrors,
  PostAdminBillingCapabilityRevocationsPreviewCascadeResponses,
  PostAdminBrandIdentitiesData,
  PostAdminBrandIdentitiesErrors,
  PostAdminBrandIdentitiesResponses,
  PostAdminBreachIncidentsData,
  PostAdminBreachIncidentsErrors,
  PostAdminBreachIncidentsResponses,
  PostAdminBreachNotificationArtifactsData,
  PostAdminBreachNotificationArtifactsErrors,
  PostAdminBreachNotificationArtifactsResponses,
  PostAdminBucketsData,
  PostAdminBucketsErrors,
  PostAdminBucketsResponses,
  PostAdminBusinessAssociateAgreementsData,
  PostAdminBusinessAssociateAgreementsErrors,
  PostAdminBusinessAssociateAgreementsResponses,
  PostAdminCampaignsSequencesData,
  PostAdminCampaignsSequencesErrors,
  PostAdminCampaignsSequencesResponses,
  PostAdminCampaignsSequenceStepsData,
  PostAdminCampaignsSequenceStepsErrors,
  PostAdminCampaignsSequenceStepsResponses,
  PostAdminCaseDocumentLinksData,
  PostAdminCaseDocumentLinksErrors,
  PostAdminCaseDocumentLinksResponses,
  PostAdminCaseEntityLinksData,
  PostAdminCaseEntityLinksErrors,
  PostAdminCaseEntityLinksResponses,
  PostAdminCasesData,
  PostAdminCasesErrors,
  PostAdminCasesResponses,
  PostAdminCaseTypesData,
  PostAdminCaseTypesErrors,
  PostAdminCaseTypesResponses,
  PostAdminCatalogOptionTypesData,
  PostAdminCatalogOptionTypesErrors,
  PostAdminCatalogOptionTypesResponses,
  PostAdminCatalogOptionValuesData,
  PostAdminCatalogOptionValuesErrors,
  PostAdminCatalogOptionValuesResponses,
  PostAdminCatalogPriceListEntriesData,
  PostAdminCatalogPriceListEntriesErrors,
  PostAdminCatalogPriceListEntriesResponses,
  PostAdminCatalogPriceListsData,
  PostAdminCatalogPriceListsErrors,
  PostAdminCatalogPriceListsResponses,
  PostAdminCatalogProductClassificationsData,
  PostAdminCatalogProductClassificationsErrors,
  PostAdminCatalogProductClassificationsResponses,
  PostAdminCatalogProductsData,
  PostAdminCatalogProductsErrors,
  PostAdminCatalogProductsResponses,
  PostAdminCatalogProductVariantsData,
  PostAdminCatalogProductVariantsErrors,
  PostAdminCatalogProductVariantsResponses,
  PostAdminCatalogStockLocationsData,
  PostAdminCatalogStockLocationsErrors,
  PostAdminCatalogStockLocationsResponses,
  PostAdminCatalogTaxonomiesData,
  PostAdminCatalogTaxonomiesErrors,
  PostAdminCatalogTaxonomiesResponses,
  PostAdminCatalogTaxonomyNodesData,
  PostAdminCatalogTaxonomyNodesErrors,
  PostAdminCatalogTaxonomyNodesResponses,
  PostAdminCatalogVariantOptionValuesData,
  PostAdminCatalogVariantOptionValuesErrors,
  PostAdminCatalogVariantOptionValuesResponses,
  PostAdminCatalogViewOverridesData,
  PostAdminCatalogViewOverridesErrors,
  PostAdminCatalogViewOverridesResponses,
  PostAdminCatalogViewRulesData,
  PostAdminCatalogViewRulesErrors,
  PostAdminCatalogViewRulesResponses,
  PostAdminCatalogViewsData,
  PostAdminCatalogViewsErrors,
  PostAdminCatalogViewsResponses,
  PostAdminCdeScopeReportsData,
  PostAdminCdeScopeReportsErrors,
  PostAdminCdeScopeReportsResponses,
  PostAdminClaimedDomainsData,
  PostAdminClaimedDomainsErrors,
  PostAdminClaimedDomainsResponses,
  PostAdminClinicalClientGoalsData,
  PostAdminClinicalClientGoalsErrors,
  PostAdminClinicalClientGoalsFromTemplateData,
  PostAdminClinicalClientGoalsFromTemplateErrors,
  PostAdminClinicalClientGoalsFromTemplateResponses,
  PostAdminClinicalClientGoalsResponses,
  PostAdminClinicalClientMedicationsBulkData,
  PostAdminClinicalClientMedicationsBulkErrors,
  PostAdminClinicalClientMedicationsBulkResponses,
  PostAdminClinicalClientMedicationsData,
  PostAdminClinicalClientMedicationsErrors,
  PostAdminClinicalClientMedicationsResponses,
  PostAdminClinicalClientResourceAssignmentsData,
  PostAdminClinicalClientResourceAssignmentsErrors,
  PostAdminClinicalClientResourceAssignmentsResponses,
  PostAdminClinicalClientSupplementsBulkData,
  PostAdminClinicalClientSupplementsBulkErrors,
  PostAdminClinicalClientSupplementsBulkResponses,
  PostAdminClinicalClientSupplementsData,
  PostAdminClinicalClientSupplementsErrors,
  PostAdminClinicalClientSupplementsResponses,
  PostAdminClinicalDeliveriesData,
  PostAdminClinicalDeliveriesErrors,
  PostAdminClinicalDeliveriesResponses,
  PostAdminClinicalDocumentsData,
  PostAdminClinicalDocumentsErrors,
  PostAdminClinicalDocumentsResponses,
  PostAdminClinicalGoalAssociationsData,
  PostAdminClinicalGoalAssociationsErrors,
  PostAdminClinicalGoalAssociationsResponses,
  PostAdminClinicalGoalTemplateCollectionMembershipsData,
  PostAdminClinicalGoalTemplateCollectionMembershipsErrors,
  PostAdminClinicalGoalTemplateCollectionMembershipsResponses,
  PostAdminClinicalGoalTemplateCollectionsData,
  PostAdminClinicalGoalTemplateCollectionsErrors,
  PostAdminClinicalGoalTemplateCollectionsResponses,
  PostAdminClinicalGoalTemplatesCatalogData,
  PostAdminClinicalGoalTemplatesCatalogErrors,
  PostAdminClinicalGoalTemplatesCatalogResponses,
  PostAdminClinicalGoalTemplatesData,
  PostAdminClinicalGoalTemplatesErrors,
  PostAdminClinicalGoalTemplatesFromExistingData,
  PostAdminClinicalGoalTemplatesFromExistingErrors,
  PostAdminClinicalGoalTemplatesFromExistingResponses,
  PostAdminClinicalGoalTemplatesResponses,
  PostAdminClinicalHealthMetricsData,
  PostAdminClinicalHealthMetricsErrors,
  PostAdminClinicalHealthMetricsResponses,
  PostAdminClinicalInsuranceAuthorizationsData,
  PostAdminClinicalInsuranceAuthorizationsErrors,
  PostAdminClinicalInsuranceAuthorizationsResponses,
  PostAdminClinicalIntakeTargetsData,
  PostAdminClinicalIntakeTargetsErrors,
  PostAdminClinicalIntakeTargetsResponses,
  PostAdminClinicalMealPlansData,
  PostAdminClinicalMealPlansErrors,
  PostAdminClinicalMealPlansResponses,
  PostAdminClinicalNotesData,
  PostAdminClinicalNotesErrors,
  PostAdminClinicalNotesResponses,
  PostAdminClinicalNoteTemplatesCatalogData,
  PostAdminClinicalNoteTemplatesCatalogErrors,
  PostAdminClinicalNoteTemplatesCatalogResponses,
  PostAdminClinicalNoteTemplatesData,
  PostAdminClinicalNoteTemplatesErrors,
  PostAdminClinicalNoteTemplatesFromExistingData,
  PostAdminClinicalNoteTemplatesFromExistingErrors,
  PostAdminClinicalNoteTemplatesFromExistingResponses,
  PostAdminClinicalNoteTemplatesResponses,
  PostAdminClinicalPatientInsuranceData,
  PostAdminClinicalPatientInsuranceErrors,
  PostAdminClinicalPatientInsuranceResponses,
  PostAdminClinicalPatientsData,
  PostAdminClinicalPatientsErrors,
  PostAdminClinicalPatientsResponses,
  PostAdminClinicalPracticeResourcesCatalogData,
  PostAdminClinicalPracticeResourcesCatalogErrors,
  PostAdminClinicalPracticeResourcesCatalogResponses,
  PostAdminClinicalPracticeResourcesData,
  PostAdminClinicalPracticeResourcesErrors,
  PostAdminClinicalPracticeResourcesResponses,
  PostAdminClinicalPracticeToolsCatalogData,
  PostAdminClinicalPracticeToolsCatalogErrors,
  PostAdminClinicalPracticeToolsCatalogResponses,
  PostAdminClinicalPracticeToolsData,
  PostAdminClinicalPracticeToolsErrors,
  PostAdminClinicalPracticeToolsResponses,
  PostAdminClinicalSessionsData,
  PostAdminClinicalSessionsErrors,
  PostAdminClinicalSessionsResponses,
  PostAdminClinicalSupplementTemplateCollectionMembershipsData,
  PostAdminClinicalSupplementTemplateCollectionMembershipsErrors,
  PostAdminClinicalSupplementTemplateCollectionMembershipsResponses,
  PostAdminClinicalSupplementTemplateCollectionsData,
  PostAdminClinicalSupplementTemplateCollectionsErrors,
  PostAdminClinicalSupplementTemplateCollectionsResponses,
  PostAdminClinicalSupplementTemplatesCatalogData,
  PostAdminClinicalSupplementTemplatesCatalogErrors,
  PostAdminClinicalSupplementTemplatesCatalogResponses,
  PostAdminClinicalSupplementTemplatesData,
  PostAdminClinicalSupplementTemplatesErrors,
  PostAdminClinicalSupplementTemplatesFromExistingData,
  PostAdminClinicalSupplementTemplatesFromExistingErrors,
  PostAdminClinicalSupplementTemplatesFromExistingResponses,
  PostAdminClinicalSupplementTemplatesResponses,
  PostAdminComplianceDocumentTemplatesCloneData,
  PostAdminComplianceDocumentTemplatesCloneErrors,
  PostAdminComplianceDocumentTemplatesCloneResponses,
  PostAdminComplianceDocumentTemplatesData,
  PostAdminComplianceDocumentTemplatesErrors,
  PostAdminComplianceDocumentTemplatesResponses,
  PostAdminComplianceOfficerDesignationsData,
  PostAdminComplianceOfficerDesignationsErrors,
  PostAdminComplianceOfficerDesignationsResponses,
  PostAdminComplianceRequirementCompletionsData,
  PostAdminComplianceRequirementCompletionsErrors,
  PostAdminComplianceRequirementCompletionsResponses,
  PostAdminComplianceRequirementsData,
  PostAdminComplianceRequirementsErrors,
  PostAdminComplianceRequirementsResponses,
  PostAdminCompositeOperationsData,
  PostAdminCompositeOperationsErrors,
  PostAdminCompositeOperationsResponses,
  PostAdminConfigsData,
  PostAdminConfigsErrors,
  PostAdminConfigsResponses,
  PostAdminConnectorsByIdEdamamRecipesGetData,
  PostAdminConnectorsByIdEdamamRecipesGetErrors,
  PostAdminConnectorsByIdEdamamRecipesGetResponses,
  PostAdminConnectorsByIdEdamamRecipesSearchData,
  PostAdminConnectorsByIdEdamamRecipesSearchErrors,
  PostAdminConnectorsByIdEdamamRecipesSearchResponses,
  PostAdminConnectorsByIdHealthieAppointmentsListData,
  PostAdminConnectorsByIdHealthieAppointmentsListErrors,
  PostAdminConnectorsByIdHealthieAppointmentsListResponses,
  PostAdminConnectorsByIdHealthieAppointmentsSyncData,
  PostAdminConnectorsByIdHealthieAppointmentsSyncErrors,
  PostAdminConnectorsByIdHealthieAppointmentsSyncResponses,
  PostAdminConnectorsByIdHealthiePatientsListData,
  PostAdminConnectorsByIdHealthiePatientsListErrors,
  PostAdminConnectorsByIdHealthiePatientsListResponses,
  PostAdminConnectorsByIdHealthiePatientsSyncData,
  PostAdminConnectorsByIdHealthiePatientsSyncErrors,
  PostAdminConnectorsByIdHealthiePatientsSyncResponses,
  PostAdminConnectorsByIdHealthieSyncAllData,
  PostAdminConnectorsByIdHealthieSyncAllErrors,
  PostAdminConnectorsByIdHealthieSyncAllResponses,
  PostAdminConnectorsByIdPracticeBetterPushNoteData,
  PostAdminConnectorsByIdPracticeBetterPushNoteErrors,
  PostAdminConnectorsByIdPracticeBetterPushNoteResponses,
  PostAdminConnectorsByIdSyncData,
  PostAdminConnectorsByIdSyncErrors,
  PostAdminConnectorsByIdSyncResponses,
  PostAdminConnectorsCredentialsByIdRefreshData,
  PostAdminConnectorsCredentialsByIdRefreshErrors,
  PostAdminConnectorsCredentialsByIdRefreshResponses,
  PostAdminConnectorsCredentialsDeleteByTypeData,
  PostAdminConnectorsCredentialsDeleteByTypeErrors,
  PostAdminConnectorsCredentialsDeleteByTypeResponses,
  PostAdminConnectorsCredentialsUpsertData,
  PostAdminConnectorsCredentialsUpsertErrors,
  PostAdminConnectorsCredentialsUpsertResponses,
  PostAdminConnectorsData,
  PostAdminConnectorsErrors,
  PostAdminConnectorsFullscriptCheckPatientData,
  PostAdminConnectorsFullscriptCheckPatientErrors,
  PostAdminConnectorsFullscriptCheckPatientResponses,
  PostAdminConnectorsFullscriptCreatePatientData,
  PostAdminConnectorsFullscriptCreatePatientErrors,
  PostAdminConnectorsFullscriptCreatePatientResponses,
  PostAdminConnectorsFullscriptOrdersGetData,
  PostAdminConnectorsFullscriptOrdersGetErrors,
  PostAdminConnectorsFullscriptOrdersGetResponses,
  PostAdminConnectorsFullscriptOrdersListData,
  PostAdminConnectorsFullscriptOrdersListErrors,
  PostAdminConnectorsFullscriptOrdersListResponses,
  PostAdminConnectorsFullscriptProductsGetData,
  PostAdminConnectorsFullscriptProductsGetErrors,
  PostAdminConnectorsFullscriptProductsGetResponses,
  PostAdminConnectorsFullscriptProductsMatchData,
  PostAdminConnectorsFullscriptProductsMatchErrors,
  PostAdminConnectorsFullscriptProductsMatchResponses,
  PostAdminConnectorsFullscriptProductsSearchData,
  PostAdminConnectorsFullscriptProductsSearchErrors,
  PostAdminConnectorsFullscriptProductsSearchResponses,
  PostAdminConnectorsFullscriptProductsSimilarData,
  PostAdminConnectorsFullscriptProductsSimilarErrors,
  PostAdminConnectorsFullscriptProductsSimilarResponses,
  PostAdminConnectorsFullscriptSessionGrantData,
  PostAdminConnectorsFullscriptSessionGrantErrors,
  PostAdminConnectorsFullscriptSessionGrantResponses,
  PostAdminConnectorsFullscriptTreatmentPlansCancelData,
  PostAdminConnectorsFullscriptTreatmentPlansCancelErrors,
  PostAdminConnectorsFullscriptTreatmentPlansCancelResponses,
  PostAdminConnectorsFullscriptTreatmentPlansCreateData,
  PostAdminConnectorsFullscriptTreatmentPlansCreateErrors,
  PostAdminConnectorsFullscriptTreatmentPlansCreateResponses,
  PostAdminConnectorsFullscriptTreatmentPlansGetData,
  PostAdminConnectorsFullscriptTreatmentPlansGetErrors,
  PostAdminConnectorsFullscriptTreatmentPlansGetResponses,
  PostAdminConnectorsFullscriptTreatmentPlansListData,
  PostAdminConnectorsFullscriptTreatmentPlansListErrors,
  PostAdminConnectorsFullscriptTreatmentPlansListResponses,
  PostAdminConnectorsOauthAppConfigsData,
  PostAdminConnectorsOauthAppConfigsErrors,
  PostAdminConnectorsOauthAppConfigsResponses,
  PostAdminConnectorsOauthCallbackData,
  PostAdminConnectorsOauthCallbackErrors,
  PostAdminConnectorsOauthCallbackResponses,
  PostAdminConnectorsOauthInitiateData,
  PostAdminConnectorsOauthInitiateErrors,
  PostAdminConnectorsOauthInitiateResponses,
  PostAdminConnectorsResponses,
  PostAdminConsentRecordsData,
  PostAdminConsentRecordsErrors,
  PostAdminConsentRecordsResponses,
  PostAdminContentEditImageData,
  PostAdminContentEditImageErrors,
  PostAdminContentEditImageResponses,
  PostAdminContentGenerateHashtagsData,
  PostAdminContentGenerateHashtagsErrors,
  PostAdminContentGenerateHashtagsResponses,
  PostAdminContentGenerateImageData,
  PostAdminContentGenerateImageErrors,
  PostAdminContentGenerateImagePromptData,
  PostAdminContentGenerateImagePromptErrors,
  PostAdminContentGenerateImagePromptResponses,
  PostAdminContentGenerateImageResponses,
  PostAdminContentGenerateTextData,
  PostAdminContentGenerateTextErrors,
  PostAdminContentGenerateTextResponses,
  PostAdminContentRefineData,
  PostAdminContentRefineErrors,
  PostAdminContentRefineResponses,
  PostAdminContentRewriteToneData,
  PostAdminContentRewriteToneErrors,
  PostAdminContentRewriteToneResponses,
  PostAdminContentSeoEnrichData,
  PostAdminContentSeoEnrichErrors,
  PostAdminContentSeoEnrichResponses,
  PostAdminContentShortenData,
  PostAdminContentShortenErrors,
  PostAdminContentShortenResponses,
  PostAdminContentSuggestTopicsData,
  PostAdminContentSuggestTopicsErrors,
  PostAdminContentSuggestTopicsResponses,
  PostAdminContractsData,
  PostAdminContractsErrors,
  PostAdminContractsResponses,
  PostAdminCrawlerBrowserSessionsData,
  PostAdminCrawlerBrowserSessionsErrors,
  PostAdminCrawlerBrowserSessionsResponses,
  PostAdminCrawlerJobsData,
  PostAdminCrawlerJobsErrors,
  PostAdminCrawlerJobsResponses,
  PostAdminCrawlerNewsMonitorsData,
  PostAdminCrawlerNewsMonitorsErrors,
  PostAdminCrawlerNewsMonitorsResponses,
  PostAdminCrawlerSchedulesData,
  PostAdminCrawlerSchedulesErrors,
  PostAdminCrawlerSchedulesResponses,
  PostAdminCrawlerSiteConfigsData,
  PostAdminCrawlerSiteConfigsErrors,
  PostAdminCrawlerSiteConfigsResponses,
  PostAdminCreditPackagesData,
  PostAdminCreditPackagesErrors,
  PostAdminCreditPackagesResponses,
  PostAdminCrmActivitiesData,
  PostAdminCrmActivitiesErrors,
  PostAdminCrmActivitiesResponses,
  PostAdminCrmAddressesData,
  PostAdminCrmAddressesErrors,
  PostAdminCrmAddressesResponses,
  PostAdminCrmCompaniesData,
  PostAdminCrmCompaniesErrors,
  PostAdminCrmCompaniesResponses,
  PostAdminCrmContactsByIdUnarchiveData,
  PostAdminCrmContactsByIdUnarchiveErrors,
  PostAdminCrmContactsByIdUnarchiveResponses,
  PostAdminCrmContactsData,
  PostAdminCrmContactsErrors,
  PostAdminCrmContactsResponses,
  PostAdminCrmCustomEntitiesData,
  PostAdminCrmCustomEntitiesErrors,
  PostAdminCrmCustomEntitiesResponses,
  PostAdminCrmDealProductsData,
  PostAdminCrmDealProductsErrors,
  PostAdminCrmDealProductsResponses,
  PostAdminCrmDealsData,
  PostAdminCrmDealsErrors,
  PostAdminCrmDealsResponses,
  PostAdminCrmEmailAddressesData,
  PostAdminCrmEmailAddressesErrors,
  PostAdminCrmEmailAddressesResponses,
  PostAdminCrmExportsData,
  PostAdminCrmExportsErrors,
  PostAdminCrmExportsResponses,
  PostAdminCrmFieldDefinitionsData,
  PostAdminCrmFieldDefinitionsErrors,
  PostAdminCrmFieldDefinitionsResponses,
  PostAdminCrmPhoneNumbersData,
  PostAdminCrmPhoneNumbersErrors,
  PostAdminCrmPhoneNumbersResponses,
  PostAdminCrmPipelinesData,
  PostAdminCrmPipelinesErrors,
  PostAdminCrmPipelinesResponses,
  PostAdminCrmPipelineStagesData,
  PostAdminCrmPipelineStagesErrors,
  PostAdminCrmPipelineStagesResponses,
  PostAdminCrmRelationshipsData,
  PostAdminCrmRelationshipsErrors,
  PostAdminCrmRelationshipsResponses,
  PostAdminCrmRelationshipTypesData,
  PostAdminCrmRelationshipTypesErrors,
  PostAdminCrmRelationshipTypesResponses,
  PostAdminCrmSocialProfilesData,
  PostAdminCrmSocialProfilesErrors,
  PostAdminCrmSocialProfilesResponses,
  PostAdminCrmSyncConfigsData,
  PostAdminCrmSyncConfigsErrors,
  PostAdminCrmSyncConfigsResponses,
  PostAdminCrmWebsitesData,
  PostAdminCrmWebsitesErrors,
  PostAdminCrmWebsitesResponses,
  PostAdminCustomersData,
  PostAdminCustomersErrors,
  PostAdminCustomersResponses,
  PostAdminDataSubjectRequestsData,
  PostAdminDataSubjectRequestsErrors,
  PostAdminDataSubjectRequestsResponses,
  PostAdminDataTransferRecordsData,
  PostAdminDataTransferRecordsErrors,
  PostAdminDataTransferRecordsResponses,
  PostAdminDisclosureLogsData,
  PostAdminDisclosureLogsErrors,
  PostAdminDisclosureLogsResponses,
  PostAdminDocumentsBulkDeleteData,
  PostAdminDocumentsBulkDeleteErrors,
  PostAdminDocumentsBulkDeleteResponses,
  PostAdminDocumentsPresignedUploadData,
  PostAdminDocumentsPresignedUploadErrors,
  PostAdminDocumentsPresignedUploadResponses,
  PostAdminEmailInboundAddressesData,
  PostAdminEmailInboundAddressesErrors,
  PostAdminEmailInboundAddressesResponses,
  PostAdminEmailInclusionsData,
  PostAdminEmailInclusionsErrors,
  PostAdminEmailInclusionsResponses,
  PostAdminEmailMarketingCampaignsByIdAnalyzeData,
  PostAdminEmailMarketingCampaignsByIdAnalyzeErrors,
  PostAdminEmailMarketingCampaignsByIdAnalyzeResponses,
  PostAdminEmailMarketingCampaignsByIdCreateFollowupData,
  PostAdminEmailMarketingCampaignsByIdCreateFollowupErrors,
  PostAdminEmailMarketingCampaignsByIdCreateFollowupResponses,
  PostAdminEmailMarketingCampaignsByIdExportData,
  PostAdminEmailMarketingCampaignsByIdExportErrors,
  PostAdminEmailMarketingCampaignsByIdExportResponses,
  PostAdminEmailMarketingCampaignsByIdGenerateEmailsData,
  PostAdminEmailMarketingCampaignsByIdGenerateEmailsErrors,
  PostAdminEmailMarketingCampaignsByIdGenerateEmailsResponses,
  PostAdminEmailMarketingCampaignsByIdImportRecipientsData,
  PostAdminEmailMarketingCampaignsByIdImportRecipientsErrors,
  PostAdminEmailMarketingCampaignsByIdImportRecipientsResponses,
  PostAdminEmailMarketingCampaignsByIdOptimizeSendTimesData,
  PostAdminEmailMarketingCampaignsByIdOptimizeSendTimesErrors,
  PostAdminEmailMarketingCampaignsByIdOptimizeSendTimesResponses,
  PostAdminEmailMarketingCampaignsByIdOptimizeSubjectsData,
  PostAdminEmailMarketingCampaignsByIdOptimizeSubjectsErrors,
  PostAdminEmailMarketingCampaignsByIdOptimizeSubjectsResponses,
  PostAdminEmailMarketingCampaignsByIdSendData,
  PostAdminEmailMarketingCampaignsByIdSendErrors,
  PostAdminEmailMarketingCampaignsByIdSendResponses,
  PostAdminEmailMarketingCampaignsData,
  PostAdminEmailMarketingCampaignsErrors,
  PostAdminEmailMarketingCampaignsResponses,
  PostAdminEmailMarketingSenderProfilesData,
  PostAdminEmailMarketingSenderProfilesErrors,
  PostAdminEmailMarketingSenderProfilesResponses,
  PostAdminEmailMarketingTemplatesCompileData,
  PostAdminEmailMarketingTemplatesCompileErrors,
  PostAdminEmailMarketingTemplatesCompileResponses,
  PostAdminEmailMarketingTemplatesData,
  PostAdminEmailMarketingTemplatesErrors,
  PostAdminEmailMarketingTemplatesResponses,
  PostAdminEmailOutboundEmailsComposeWithAiData,
  PostAdminEmailOutboundEmailsComposeWithAiErrors,
  PostAdminEmailOutboundEmailsComposeWithAiResponses,
  PostAdminEmailOutboundEmailsData,
  PostAdminEmailOutboundEmailsErrors,
  PostAdminEmailOutboundEmailsResponses,
  PostAdminEmailRecipientsData,
  PostAdminEmailRecipientsErrors,
  PostAdminEmailRecipientsResponses,
  PostAdminEphiAssetsData,
  PostAdminEphiAssetsErrors,
  PostAdminEphiAssetsResponses,
  PostAdminEphiDataFlowsData,
  PostAdminEphiDataFlowsErrors,
  PostAdminEphiDataFlowsResponses,
  PostAdminExtractionAgentsPredictData,
  PostAdminExtractionAgentsPredictErrors,
  PostAdminExtractionAgentsPredictResponses,
  PostAdminExtractionBatchesByIdFinishAllData,
  PostAdminExtractionBatchesByIdFinishAllErrors,
  PostAdminExtractionBatchesByIdFinishAllResponses,
  PostAdminExtractionBatchesData,
  PostAdminExtractionBatchesErrors,
  PostAdminExtractionBatchesResponses,
  PostAdminExtractionConfigEnumsData,
  PostAdminExtractionConfigEnumsErrors,
  PostAdminExtractionConfigEnumsResponses,
  PostAdminExtractionDocumentsBeginUploadData,
  PostAdminExtractionDocumentsBeginUploadErrors,
  PostAdminExtractionDocumentsBeginUploadResponses,
  PostAdminExtractionDocumentsBulkReprocessData,
  PostAdminExtractionDocumentsBulkReprocessErrors,
  PostAdminExtractionDocumentsBulkReprocessResponses,
  PostAdminExtractionDocumentsFindOrBeginUploadData,
  PostAdminExtractionDocumentsFindOrBeginUploadErrors,
  PostAdminExtractionDocumentsFindOrBeginUploadResponses,
  PostAdminExtractionDocumentsUploadData,
  PostAdminExtractionDocumentsUploadErrors,
  PostAdminExtractionDocumentsUploadResponses,
  PostAdminExtractionSchemaDiscoveriesBootstrapData,
  PostAdminExtractionSchemaDiscoveriesBootstrapErrors,
  PostAdminExtractionSchemaDiscoveriesBootstrapResponses,
  PostAdminExtractionSchemaDiscoveriesData,
  PostAdminExtractionSchemaDiscoveriesErrors,
  PostAdminExtractionSchemaDiscoveriesResponses,
  PostAdminExtractionShadowComparisonsData,
  PostAdminExtractionShadowComparisonsErrors,
  PostAdminExtractionShadowComparisonsResponses,
  PostAdminExtractionWorkflowsData,
  PostAdminExtractionWorkflowsErrors,
  PostAdminExtractionWorkflowsResponses,
  PostAdminFeatureDefinitionsData,
  PostAdminFeatureDefinitionsErrors,
  PostAdminFeatureDefinitionsResponses,
  PostAdminFeatureUsagesIncrementData,
  PostAdminFeatureUsagesIncrementErrors,
  PostAdminFeatureUsagesIncrementResponses,
  PostAdminFieldTemplatesData,
  PostAdminFieldTemplatesErrors,
  PostAdminFieldTemplatesResponses,
  PostAdminFormDeploymentsData,
  PostAdminFormDeploymentsErrors,
  PostAdminFormDeploymentsResponses,
  PostAdminFormGenerationsData,
  PostAdminFormGenerationsErrors,
  PostAdminFormGenerationsResponses,
  PostAdminFormVersionsByIdProposeRuleData,
  PostAdminFormVersionsByIdProposeRuleErrors,
  PostAdminFormVersionsByIdProposeRuleResponses,
  PostAdminFormVersionsData,
  PostAdminFormVersionsErrors,
  PostAdminFormVersionsResponses,
  PostAdminImpactAssessmentsData,
  PostAdminImpactAssessmentsErrors,
  PostAdminImpactAssessmentsResponses,
  PostAdminInvitationsAcceptByTokenData,
  PostAdminInvitationsAcceptByTokenErrors,
  PostAdminInvitationsAcceptByTokenResponses,
  PostAdminInvitationsData,
  PostAdminInvitationsErrors,
  PostAdminInvitationsResponses,
  PostAdminInvoicesContactsData,
  PostAdminInvoicesContactsErrors,
  PostAdminInvoicesContactsResponses,
  PostAdminInvoicesData,
  PostAdminInvoicesErrors,
  PostAdminInvoicesLinesData,
  PostAdminInvoicesLinesErrors,
  PostAdminInvoicesLinesResponses,
  PostAdminInvoicesPaymentsData,
  PostAdminInvoicesPaymentsErrors,
  PostAdminInvoicesPaymentsResponses,
  PostAdminInvoicesRecurringSchedulesData,
  PostAdminInvoicesRecurringSchedulesErrors,
  PostAdminInvoicesRecurringSchedulesResponses,
  PostAdminInvoicesResponses,
  PostAdminInvoicesRulesData,
  PostAdminInvoicesRulesErrors,
  PostAdminInvoicesRulesResponses,
  PostAdminInvoicesTemplatesData,
  PostAdminInvoicesTemplatesErrors,
  PostAdminInvoicesTemplatesResponses,
  PostAdminIsvCrmChannelCaptureConfigData,
  PostAdminIsvCrmChannelCaptureConfigErrors,
  PostAdminIsvCrmChannelCaptureConfigResponses,
  PostAdminIsvCrmEntityTypesData,
  PostAdminIsvCrmEntityTypesErrors,
  PostAdminIsvCrmEntityTypesResponses,
  PostAdminIsvPricingOverridesData,
  PostAdminIsvPricingOverridesErrors,
  PostAdminIsvPricingOverridesResponses,
  PostAdminIsvRevenueData,
  PostAdminIsvRevenueErrors,
  PostAdminIsvRevenueResponses,
  PostAdminLegalDocumentsData,
  PostAdminLegalDocumentsErrors,
  PostAdminLegalDocumentsResponses,
  PostAdminLlmAnalyticsData,
  PostAdminLlmAnalyticsErrors,
  PostAdminLlmAnalyticsResponses,
  PostAdminMeetingsData,
  PostAdminMeetingsErrors,
  PostAdminMeetingsResponses,
  PostAdminMessageFeedbackData,
  PostAdminMessageFeedbackErrors,
  PostAdminMessageFeedbackResponses,
  PostAdminMessagesData,
  PostAdminMessagesErrors,
  PostAdminMessagesResponses,
  PostAdminNotificationMethodsData,
  PostAdminNotificationMethodsErrors,
  PostAdminNotificationMethodsResponses,
  PostAdminNotificationPreferencesData,
  PostAdminNotificationPreferencesErrors,
  PostAdminNotificationPreferencesResponses,
  PostAdminPaymentMethodsData,
  PostAdminPaymentMethodsErrors,
  PostAdminPaymentMethodsResponses,
  PostAdminPaymentMethodsTokenizeData,
  PostAdminPaymentMethodsTokenizeErrors,
  PostAdminPaymentMethodsTokenizeResponses,
  PostAdminPaymentsData,
  PostAdminPaymentsErrors,
  PostAdminPaymentsResponses,
  PostAdminPipelineNodesData,
  PostAdminPipelineNodesErrors,
  PostAdminPipelineNodesResponses,
  PostAdminPipelinesData,
  PostAdminPipelinesErrors,
  PostAdminPipelinesResponses,
  PostAdminPlanBundlesPreviewEconomicsData,
  PostAdminPlanBundlesPreviewEconomicsErrors,
  PostAdminPlanBundlesPreviewEconomicsResponses,
  PostAdminPlanBundlesPublishData,
  PostAdminPlanBundlesPublishErrors,
  PostAdminPlanBundlesPublishResponses,
  PostAdminPlanFeatureAllocationsData,
  PostAdminPlanFeatureAllocationsErrors,
  PostAdminPlanFeatureAllocationsResponses,
  PostAdminPlansData,
  PostAdminPlansErrors,
  PostAdminPlansResponses,
  PostAdminPlatformPricingConfigsData,
  PostAdminPlatformPricingConfigsErrors,
  PostAdminPlatformPricingConfigsResponses,
  PostAdminPlatformTonesData,
  PostAdminPlatformTonesErrors,
  PostAdminPlatformTonesResponses,
  PostAdminPolicyReviewSchedulesData,
  PostAdminPolicyReviewSchedulesErrors,
  PostAdminPolicyReviewSchedulesResponses,
  PostAdminPortalInvitationsData,
  PostAdminPortalInvitationsErrors,
  PostAdminPortalInvitationsResponses,
  PostAdminPostProcessingHooksData,
  PostAdminPostProcessingHooksErrors,
  PostAdminPostProcessingHooksResponses,
  PostAdminPreferencesUpsertData,
  PostAdminPreferencesUpsertErrors,
  PostAdminPreferencesUpsertResponses,
  PostAdminPricingStrategiesData,
  PostAdminPricingStrategiesErrors,
  PostAdminPricingStrategiesResponses,
  PostAdminProcessingActivitiesData,
  PostAdminProcessingActivitiesErrors,
  PostAdminProcessingActivitiesResponses,
  PostAdminQuoteRequestsData,
  PostAdminQuoteRequestsErrors,
  PostAdminQuoteRequestsResponses,
  PostAdminRecipesBulkImportData,
  PostAdminRecipesBulkImportErrors,
  PostAdminRecipesBulkImportResponses,
  PostAdminRecipesCollectionRecipesData,
  PostAdminRecipesCollectionRecipesErrors,
  PostAdminRecipesCollectionRecipesResponses,
  PostAdminRecipesCollectionsData,
  PostAdminRecipesCollectionsErrors,
  PostAdminRecipesCollectionsResponses,
  PostAdminRecipesData,
  PostAdminRecipesErrors,
  PostAdminRecipesFavoritesData,
  PostAdminRecipesFavoritesErrors,
  PostAdminRecipesFavoritesResponses,
  PostAdminRecipesFoodItemsData,
  PostAdminRecipesFoodItemsErrors,
  PostAdminRecipesFoodItemsResponses,
  PostAdminRecipesImportData,
  PostAdminRecipesImportErrors,
  PostAdminRecipesImportResponses,
  PostAdminRecipesIngredientsData,
  PostAdminRecipesIngredientsErrors,
  PostAdminRecipesIngredientsResponses,
  PostAdminRecipesMealSchedulesData,
  PostAdminRecipesMealSchedulesErrors,
  PostAdminRecipesMealSchedulesResponses,
  PostAdminRecipesRecipeNutritionsData,
  PostAdminRecipesRecipeNutritionsErrors,
  PostAdminRecipesRecipeNutritionsResponses,
  PostAdminRecipesRecipeTagsData,
  PostAdminRecipesRecipeTagsErrors,
  PostAdminRecipesRecipeTagsResponses,
  PostAdminRecipesResponses,
  PostAdminRecipesScheduledMealsData,
  PostAdminRecipesScheduledMealsErrors,
  PostAdminRecipesScheduledMealsResponses,
  PostAdminRecipesShoppingListItemsData,
  PostAdminRecipesShoppingListItemsErrors,
  PostAdminRecipesShoppingListItemsResponses,
  PostAdminRecipesShoppingListsData,
  PostAdminRecipesShoppingListsErrors,
  PostAdminRecipesShoppingListsGenerateData,
  PostAdminRecipesShoppingListsGenerateErrors,
  PostAdminRecipesShoppingListsGenerateResponses,
  PostAdminRecipesShoppingListsRegenerateData,
  PostAdminRecipesShoppingListsRegenerateErrors,
  PostAdminRecipesShoppingListsRegenerateResponses,
  PostAdminRecipesShoppingListsResponses,
  PostAdminRecipesTagsData,
  PostAdminRecipesTagsErrors,
  PostAdminRecipesTagsResponses,
  PostAdminRetentionPoliciesData,
  PostAdminRetentionPoliciesErrors,
  PostAdminRetentionPoliciesResponses,
  PostAdminReviewQueueMembershipsData,
  PostAdminReviewQueueMembershipsErrors,
  PostAdminReviewQueueMembershipsResponses,
  PostAdminReviewQueuesData,
  PostAdminReviewQueuesErrors,
  PostAdminReviewQueuesResponses,
  PostAdminRiskAssessmentsData,
  PostAdminRiskAssessmentsErrors,
  PostAdminRiskAssessmentsResponses,
  PostAdminRolesData,
  PostAdminRolesErrors,
  PostAdminRolesResponses,
  PostAdminSchedulingAvailabilityRulesData,
  PostAdminSchedulingAvailabilityRulesErrors,
  PostAdminSchedulingAvailabilityRulesResponses,
  PostAdminSchedulingBookingsData,
  PostAdminSchedulingBookingsErrors,
  PostAdminSchedulingBookingsResponses,
  PostAdminSchedulingCalendarSyncsData,
  PostAdminSchedulingCalendarSyncsErrors,
  PostAdminSchedulingCalendarSyncsResponses,
  PostAdminSchedulingEventsData,
  PostAdminSchedulingEventsErrors,
  PostAdminSchedulingEventsResponses,
  PostAdminSchedulingEventTypesData,
  PostAdminSchedulingEventTypesErrors,
  PostAdminSchedulingEventTypesResponses,
  PostAdminSchedulingLocationsData,
  PostAdminSchedulingLocationsErrors,
  PostAdminSchedulingLocationsResponses,
  PostAdminSchedulingParticipantsData,
  PostAdminSchedulingParticipantsErrors,
  PostAdminSchedulingParticipantsResponses,
  PostAdminSchedulingRemindersData,
  PostAdminSchedulingRemindersErrors,
  PostAdminSchedulingRemindersResponses,
  PostAdminSearchBatchData,
  PostAdminSearchBatchErrors,
  PostAdminSearchBatchResponses,
  PostAdminSearchReindexData,
  PostAdminSearchReindexErrors,
  PostAdminSearchReindexResponses,
  PostAdminSearchSavedByIdRunData,
  PostAdminSearchSavedByIdRunErrors,
  PostAdminSearchSavedByIdRunResponses,
  PostAdminSearchSavedData,
  PostAdminSearchSavedErrors,
  PostAdminSearchSavedResponses,
  PostAdminSettlementsData,
  PostAdminSettlementsErrors,
  PostAdminSettlementsResponses,
  PostAdminSocialAccountsData,
  PostAdminSocialAccountsErrors,
  PostAdminSocialAccountsResponses,
  PostAdminSocialCampaignsByIdAdaptForPlatformsData,
  PostAdminSocialCampaignsByIdAdaptForPlatformsErrors,
  PostAdminSocialCampaignsByIdAdaptForPlatformsResponses,
  PostAdminSocialCampaignsByIdGenerateMasterCopyData,
  PostAdminSocialCampaignsByIdGenerateMasterCopyErrors,
  PostAdminSocialCampaignsByIdGenerateMasterCopyResponses,
  PostAdminSocialCampaignsByIdPreviewAdaptationsData,
  PostAdminSocialCampaignsByIdPreviewAdaptationsErrors,
  PostAdminSocialCampaignsByIdPreviewAdaptationsResponses,
  PostAdminSocialCampaignsData,
  PostAdminSocialCampaignsErrors,
  PostAdminSocialCampaignsResponses,
  PostAdminSocialPostsData,
  PostAdminSocialPostsErrors,
  PostAdminSocialPostsResponses,
  PostAdminSocialTrendingHistoryData,
  PostAdminSocialTrendingHistoryErrors,
  PostAdminSocialTrendingHistoryResponses,
  PostAdminSocialTrendingWatchesData,
  PostAdminSocialTrendingWatchesErrors,
  PostAdminSocialTrendingWatchesResponses,
  PostAdminStorageFilesByIdDownloadUrlData,
  PostAdminStorageFilesByIdDownloadUrlErrors,
  PostAdminStorageFilesByIdDownloadUrlResponses,
  PostAdminStorageFilesData,
  PostAdminStorageFilesErrors,
  PostAdminStorageFilesResponses,
  PostAdminSubscriptionsData,
  PostAdminSubscriptionsErrors,
  PostAdminSubscriptionsResponses,
  PostAdminSupportAiConfigsData,
  PostAdminSupportAiConfigsErrors,
  PostAdminSupportAiConfigsResponses,
  PostAdminSupportCannedResponsesData,
  PostAdminSupportCannedResponsesErrors,
  PostAdminSupportCannedResponsesResponses,
  PostAdminSupportChannelCaptureConfigsData,
  PostAdminSupportChannelCaptureConfigsErrors,
  PostAdminSupportChannelCaptureConfigsResponses,
  PostAdminSupportQueueMembersData,
  PostAdminSupportQueueMembersErrors,
  PostAdminSupportQueueMembersResponses,
  PostAdminSupportQueuesData,
  PostAdminSupportQueuesErrors,
  PostAdminSupportQueuesResponses,
  PostAdminSupportRoutingRulesData,
  PostAdminSupportRoutingRulesErrors,
  PostAdminSupportRoutingRulesResponses,
  PostAdminSupportSlaPoliciesData,
  PostAdminSupportSlaPoliciesErrors,
  PostAdminSupportSlaPoliciesResponses,
  PostAdminSupportSyncConfigsData,
  PostAdminSupportSyncConfigsErrors,
  PostAdminSupportSyncConfigsResponses,
  PostAdminSupportTagsData,
  PostAdminSupportTagsErrors,
  PostAdminSupportTagsResponses,
  PostAdminSupportTicketAttachmentsData,
  PostAdminSupportTicketAttachmentsErrors,
  PostAdminSupportTicketAttachmentsResponses,
  PostAdminSupportTicketMessagesData,
  PostAdminSupportTicketMessagesErrors,
  PostAdminSupportTicketMessagesResponses,
  PostAdminSupportTicketRatingsData,
  PostAdminSupportTicketRatingsErrors,
  PostAdminSupportTicketRatingsResponses,
  PostAdminSupportTicketsData,
  PostAdminSupportTicketsErrors,
  PostAdminSupportTicketsResponses,
  PostAdminSysAiConfigData,
  PostAdminSysAiConfigErrors,
  PostAdminSysAiConfigResponses,
  PostAdminSysSemanticCacheClearData,
  PostAdminSysSemanticCacheClearErrors,
  PostAdminSysSemanticCacheClearResponses,
  PostAdminSystemMessagesData,
  PostAdminSystemMessagesErrors,
  PostAdminSystemMessagesResponses,
  PostAdminTenantPricingOverridesData,
  PostAdminTenantPricingOverridesErrors,
  PostAdminTenantPricingOverridesResponses,
  PostAdminTenantsByIdCreditData,
  PostAdminTenantsByIdCreditErrors,
  PostAdminTenantsByIdCreditResponses,
  PostAdminTenantsByIdSchedulePurgeData,
  PostAdminTenantsByIdSchedulePurgeErrors,
  PostAdminTenantsByIdSchedulePurgeResponses,
  PostAdminTenantsData,
  PostAdminTenantsErrors,
  PostAdminTenantsIsvData,
  PostAdminTenantsIsvErrors,
  PostAdminTenantsIsvResponses,
  PostAdminTenantsOrgData,
  PostAdminTenantsOrgErrors,
  PostAdminTenantsOrgResponses,
  PostAdminTenantsPersonalData,
  PostAdminTenantsPersonalErrors,
  PostAdminTenantsPersonalResponses,
  PostAdminTenantsResponses,
  PostAdminThreadsActiveData,
  PostAdminThreadsActiveErrors,
  PostAdminThreadsActiveResponses,
  PostAdminThreadsByIdCompleteData,
  PostAdminThreadsByIdCompleteErrors,
  PostAdminThreadsByIdCompleteResponses,
  PostAdminThreadsByIdExportData,
  PostAdminThreadsByIdExportErrors,
  PostAdminThreadsByIdExportResponses,
  PostAdminThreadsByIdForkData,
  PostAdminThreadsByIdForkErrors,
  PostAdminThreadsByIdForkResponses,
  PostAdminThreadsByIdMessagesData,
  PostAdminThreadsByIdMessagesErrors,
  PostAdminThreadsByIdMessagesResponses,
  PostAdminThreadsByIdSummarizeData,
  PostAdminThreadsByIdSummarizeErrors,
  PostAdminThreadsByIdSummarizeResponses,
  PostAdminThreadsData,
  PostAdminThreadsErrors,
  PostAdminThreadsResponses,
  PostAdminTokensData,
  PostAdminTokensErrors,
  PostAdminTokensResponses,
  PostAdminTrainingExamplesBulkData,
  PostAdminTrainingExamplesBulkDeleteData,
  PostAdminTrainingExamplesBulkDeleteErrors,
  PostAdminTrainingExamplesBulkDeleteResponses,
  PostAdminTrainingExamplesBulkErrors,
  PostAdminTrainingExamplesBulkResponses,
  PostAdminTrainingExamplesData,
  PostAdminTrainingExamplesErrors,
  PostAdminTrainingExamplesResponses,
  PostAdminTrainingExamplesSearchData,
  PostAdminTrainingExamplesSearchErrors,
  PostAdminTrainingExamplesSearchResponses,
  PostAdminTrainingSessionsData,
  PostAdminTrainingSessionsErrors,
  PostAdminTrainingSessionsResponses,
  PostAdminTransactionsByIdVoidData,
  PostAdminTransactionsByIdVoidErrors,
  PostAdminTransactionsByIdVoidResponses,
  PostAdminUserProfilesData,
  PostAdminUserProfilesErrors,
  PostAdminUserProfilesResponses,
  PostAdminUsersAuthConfirmData,
  PostAdminUsersAuthConfirmErrors,
  PostAdminUsersAuthConfirmResponses,
  PostAdminUsersAuthLoginData,
  PostAdminUsersAuthLoginErrors,
  PostAdminUsersAuthLoginResponses,
  PostAdminUsersAuthMagicLinkLoginData,
  PostAdminUsersAuthMagicLinkLoginErrors,
  PostAdminUsersAuthMagicLinkLoginResponses,
  PostAdminUsersAuthPasswordResetRequestData,
  PostAdminUsersAuthPasswordResetRequestErrors,
  PostAdminUsersAuthPasswordResetRequestResponses,
  PostAdminUsersAuthRegisterData,
  PostAdminUsersAuthRegisterErrors,
  PostAdminUsersAuthRegisterResponses,
  PostAdminUsersAuthRegisterViaInvitationData,
  PostAdminUsersAuthRegisterViaInvitationErrors,
  PostAdminUsersAuthRegisterViaInvitationResponses,
  PostAdminUsersAuthRegisterWithOidcData,
  PostAdminUsersAuthRegisterWithOidcErrors,
  PostAdminUsersAuthRegisterWithOidcResponses,
  PostAdminUsersAuthResendConfirmationData,
  PostAdminUsersAuthResendConfirmationErrors,
  PostAdminUsersAuthResendConfirmationResponses,
  PostAdminUsersRegisterIsvData,
  PostAdminUsersRegisterIsvErrors,
  PostAdminUsersRegisterIsvResponses,
  PostAdminVoiceSessionsData,
  PostAdminVoiceSessionsErrors,
  PostAdminVoiceSessionsResponses,
  PostAdminVoiceTranscriptionJobsData,
  PostAdminVoiceTranscriptionJobsErrors,
  PostAdminVoiceTranscriptionJobsResponses,
  PostAdminVoiceTranscriptionResultsData,
  PostAdminVoiceTranscriptionResultsErrors,
  PostAdminVoiceTranscriptionResultsResponses,
  PostAdminWebhookConfigsBulkDisableData,
  PostAdminWebhookConfigsBulkDisableErrors,
  PostAdminWebhookConfigsBulkDisableResponses,
  PostAdminWebhookConfigsBulkEnableData,
  PostAdminWebhookConfigsBulkEnableErrors,
  PostAdminWebhookConfigsBulkEnableResponses,
  PostAdminWebhookConfigsByIdReplayData,
  PostAdminWebhookConfigsByIdReplayErrors,
  PostAdminWebhookConfigsByIdReplayResponses,
  PostAdminWebhookConfigsByIdTestData,
  PostAdminWebhookConfigsByIdTestErrors,
  PostAdminWebhookConfigsByIdTestResponses,
  PostAdminWebhookConfigsData,
  PostAdminWebhookConfigsErrors,
  PostAdminWebhookConfigsResponses,
  PostAdminWebhookDeliveriesBulkRetryData,
  PostAdminWebhookDeliveriesBulkRetryErrors,
  PostAdminWebhookDeliveriesBulkRetryResponses,
  PostAdminWebhookDeliveriesByIdRetryData,
  PostAdminWebhookDeliveriesByIdRetryErrors,
  PostAdminWebhookDeliveriesByIdRetryResponses,
  PostAdminWholesaleAgreementsByIdGrantSignupCreditsData,
  PostAdminWholesaleAgreementsByIdGrantSignupCreditsErrors,
  PostAdminWholesaleAgreementsByIdGrantSignupCreditsResponses,
  PostAdminWholesaleAgreementsData,
  PostAdminWholesaleAgreementsErrors,
  PostAdminWholesaleAgreementsResponses,
  PostAdminWorkspaceAgentConfigsData,
  PostAdminWorkspaceAgentConfigsErrors,
  PostAdminWorkspaceAgentConfigsResponses,
  PostAdminWorkspaceFormConfigsData,
  PostAdminWorkspaceFormConfigsErrors,
  PostAdminWorkspaceFormConfigsResponses,
  PostAdminWorkspacePreferencesUpsertData,
  PostAdminWorkspacePreferencesUpsertErrors,
  PostAdminWorkspacePreferencesUpsertResponses,
  PostAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMappingData,
  PostAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMappingErrors,
  PostAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMappingResponses,
  PostAdminWorkspacesByWorkspaceIdExtractionDocumentsDismissAllTrainedData,
  PostAdminWorkspacesByWorkspaceIdExtractionDocumentsDismissAllTrainedErrors,
  PostAdminWorkspacesByWorkspaceIdExtractionDocumentsDismissAllTrainedResponses,
  PostAdminWorkspacesByWorkspaceIdExtractionExportsData,
  PostAdminWorkspacesByWorkspaceIdExtractionExportsErrors,
  PostAdminWorkspacesByWorkspaceIdExtractionExportsResponses,
  PostAdminWorkspacesData,
  PostAdminWorkspacesErrors,
  PostAdminWorkspacesResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * /email/template-versions/template/:template_id operation on email-template-version resource
 *
 * /email/template-versions/template/:template_id operation on email-template-version resource
 */
export const getAdminEmailTemplateVersionsTemplateByTemplateId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailTemplateVersionsTemplateByTemplateIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailTemplateVersionsTemplateByTemplateIdResponses,
    GetAdminEmailTemplateVersionsTemplateByTemplateIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/template-versions/template/{template_id}",
    ...options,
  });

/**
 * /recipes/:id/archive operation on recipes-recipe resource
 *
 * /recipes/:id/archive operation on recipes-recipe resource
 */
export const patchAdminRecipesByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRecipesByIdArchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesByIdArchiveResponses,
    PatchAdminRecipesByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Returns the subscriptions that would be affected by disabling a capability
 * on an Application, without applying any changes
 *
 * Returns the subscriptions that would be affected by disabling a capability
 * on an Application, without applying any changes.
 *
 * Delegates to `CapabilityRevocationCascade.cascade/3` with `dry_run: true`.
 *
 * ## Arguments
 *
 * - `application_id` — UUID of the ISV Application whose capability is being
 * considered for disablement.
 * - `capability` — The capability atom name (as a string, e.g. `"meeting_intelligence"`).
 *
 * ## Response shape
 *
 * {
 * "affected_count": 3,
 * "subscription_ids": ["sub-uuid-1", "sub-uuid-2", "sub-uuid-3"],
 * "dry_run": true
 * }
 *
 */
export const postAdminBillingCapabilityRevocationsPreviewCascade = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminBillingCapabilityRevocationsPreviewCascadeData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminBillingCapabilityRevocationsPreviewCascadeResponses,
    PostAdminBillingCapabilityRevocationsPreviewCascadeErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/billing/capability-revocations/preview-cascade",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get nutrition data for a recipe
 *
 * Get nutrition data for a recipe
 */
export const getAdminRecipesRecipeNutritionsRecipeByRecipeId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesRecipeNutritionsRecipeByRecipeIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesRecipeNutritionsRecipeByRecipeIdResponses,
    GetAdminRecipesRecipeNutritionsRecipeByRecipeIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/recipe-nutritions/recipe/{recipe_id}",
    ...options,
  });

/**
 * List all social profiles for a specific entity (contact or company).
 *
 * List all social profiles for a specific entity (contact or company).
 */
export const getAdminCrmSocialProfilesEntityByEntityTypeByEntityId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmSocialProfilesEntityByEntityTypeByEntityIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmSocialProfilesEntityByEntityTypeByEntityIdResponses,
    GetAdminCrmSocialProfilesEntityByEntityTypeByEntityIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/social-profiles/entity/{entity_type}/{entity_id}",
    ...options,
  });

/**
 * List workspaces visible to the actor
 *
 * List workspaces visible to the actor. By default excludes archived (soft-deleted)
 * workspaces; pass include_archived: true to include them. Returns workspaces where
 * the actor has a direct workspace membership or is a tenant admin/owner. Use :mine
 * for a user-scoped list, or :read_shared for cross-org shared workspaces.
 *
 */
export const getAdminWorkspaces = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminWorkspacesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWorkspacesResponses,
    GetAdminWorkspacesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces",
    ...options,
  });

/**
 * Create a new workspace under a tenant
 *
 * Create a new workspace under a tenant. Infers application_id from the
 * x-application-key header context if not explicitly provided. After creation:
 * adds the creating actor as a workspace admin member (if not a system actor),
 * creates a billing liability account, and optionally allocates initial_credits
 * from the tenant's wallet. Records a workspace_created activity event.
 *
 * Returns the created workspace record.
 *
 */
export const postAdminWorkspaces = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminWorkspacesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminWorkspacesResponses,
    PostAdminWorkspacesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /audit-chain-entries operation on audit-chain-entry resource
 *
 * /audit-chain-entries operation on audit-chain-entry resource
 */
export const getAdminAuditChainEntries = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAuditChainEntriesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAuditChainEntriesResponses,
    GetAdminAuditChainEntriesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/audit-chain-entries",
    ...options,
  });

/**
 * /portal-invitations/:id operation on portal-invitation resource
 *
 * /portal-invitations/:id operation on portal-invitation resource
 */
export const deleteAdminPortalInvitationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminPortalInvitationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminPortalInvitationsByIdResponses,
    DeleteAdminPortalInvitationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/portal-invitations/{id}",
    ...options,
  });

/**
 * /crm/phone-numbers/:id/set-primary operation on crm-phone-number resource
 *
 * /crm/phone-numbers/:id/set-primary operation on crm-phone-number resource
 */
export const patchAdminCrmPhoneNumbersByIdSetPrimary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmPhoneNumbersByIdSetPrimaryData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmPhoneNumbersByIdSetPrimaryResponses,
    PatchAdminCrmPhoneNumbersByIdSetPrimaryErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/phone-numbers/{id}/set-primary",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /voice/transcription-jobs/:id operation on transcription-job resource
 *
 * /voice/transcription-jobs/:id operation on transcription-job resource
 */
export const deleteAdminVoiceTranscriptionJobsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminVoiceTranscriptionJobsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminVoiceTranscriptionJobsByIdResponses,
    DeleteAdminVoiceTranscriptionJobsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/transcription-jobs/{id}",
    ...options,
  });

/**
 * /voice/transcription-jobs/:id operation on transcription-job resource
 *
 * /voice/transcription-jobs/:id operation on transcription-job resource
 */
export const getAdminVoiceTranscriptionJobsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminVoiceTranscriptionJobsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminVoiceTranscriptionJobsByIdResponses,
    GetAdminVoiceTranscriptionJobsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/transcription-jobs/{id}",
    ...options,
  });

/**
 * Reads the wallet for the current tenant
 *
 * Reads the wallet for the current tenant
 */
export const getAdminWallet = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminWalletData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWalletResponses,
    GetAdminWalletErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet",
    ...options,
  });

/**
 * Dismiss welcome message - merges with existing preferences
 *
 * Dismiss welcome message - merges with existing preferences
 */
export const patchAdminUserProfilesByIdDismissWelcome = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminUserProfilesByIdDismissWelcomeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminUserProfilesByIdDismissWelcomeResponses,
    PatchAdminUserProfilesByIdDismissWelcomeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/user-profiles/{id}/dismiss-welcome",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get notification log statistics scoped to the caller's application
 *
 * Get notification log statistics scoped to the caller's application. Platform admins and internal callers see platform-wide totals.
 */
export const getAdminNotificationLogsStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminNotificationLogsStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminNotificationLogsStatsResponses,
    GetAdminNotificationLogsStatsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-logs/stats",
    ...options,
  });

/**
 * /extraction/batches/:id operation on extraction-batch resource
 *
 * /extraction/batches/:id operation on extraction-batch resource
 */
export const deleteAdminExtractionBatchesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminExtractionBatchesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminExtractionBatchesByIdResponses,
    DeleteAdminExtractionBatchesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/batches/{id}",
    ...options,
  });

/**
 * /extraction/batches/:id operation on extraction-batch resource
 *
 * /extraction/batches/:id operation on extraction-batch resource
 */
export const getAdminExtractionBatchesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionBatchesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionBatchesByIdResponses,
    GetAdminExtractionBatchesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/batches/{id}",
    ...options,
  });

/**
 * Fetch aggregate statistics for the semantic cache (platform admin only)
 *
 * Fetch aggregate statistics for the semantic cache (platform admin only). Returns a single summary record.
 */
export const getAdminSysSemanticCacheStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSysSemanticCacheStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSysSemanticCacheStatsResponses,
    GetAdminSysSemanticCacheStatsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/sys/semantic-cache/stats",
    ...options,
  });

/**
 * List all price suggestions for a workspace (all statuses)
 *
 * List all price suggestions for a workspace (all statuses). Returns a paginated list.
 */
export const getAdminCatalogPriceSuggestionsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogPriceSuggestionsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogPriceSuggestionsWorkspaceByWorkspaceIdResponses,
    GetAdminCatalogPriceSuggestionsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/price-suggestions/workspace/{workspace_id}",
    ...options,
  });

/**
 * /clinical/meal-plans/:id/restore operation on clinical-meal-plan resource
 *
 * /clinical/meal-plans/:id/restore operation on clinical-meal-plan resource
 */
export const patchAdminClinicalMealPlansByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalMealPlansByIdRestoreData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalMealPlansByIdRestoreResponses,
    PatchAdminClinicalMealPlansByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/meal-plans/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a specific option value (e.g., 'Large', 'Red') within an option type
 *
 * Create a specific option value (e.g., 'Large', 'Red') within an option type. Returns the created option value.
 */
export const postAdminCatalogOptionValues = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCatalogOptionValuesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogOptionValuesResponses,
    PostAdminCatalogOptionValuesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/option-values",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/send-limits/workspace/:workspace_id operation on email-send-limit resource
 *
 * /email/send-limits/workspace/:workspace_id operation on email-send-limit resource
 */
export const getAdminEmailSendLimitsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailSendLimitsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailSendLimitsWorkspaceByWorkspaceIdResponses,
    GetAdminEmailSendLimitsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/send-limits/workspace/{workspace_id}",
    ...options,
  });

/**
 * /social/posts operation on social-post resource
 *
 * /social/posts operation on social-post resource
 */
export const postAdminSocialPosts = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSocialPostsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSocialPostsResponses,
    PostAdminSocialPostsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/posts",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /form-versions/:id/classify-field operation on form-version resource
 *
 * /form-versions/:id/classify-field operation on form-version resource
 */
export const patchAdminFormVersionsByIdClassifyField = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminFormVersionsByIdClassifyFieldData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminFormVersionsByIdClassifyFieldResponses,
    PatchAdminFormVersionsByIdClassifyFieldErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-versions/{id}/classify-field",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/notes/:id operation on clinical-note resource
 *
 * /clinical/notes/:id operation on clinical-note resource
 */
export const getAdminClinicalNotesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminClinicalNotesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNotesByIdResponses,
    GetAdminClinicalNotesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes/{id}",
    ...options,
  });

/**
 * /clinical/notes/:id operation on clinical-note resource
 *
 * /clinical/notes/:id operation on clinical-note resource
 */
export const patchAdminClinicalNotesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalNotesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalNotesByIdResponses,
    PatchAdminClinicalNotesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /applications operation on application resource
 *
 * /applications operation on application resource
 */
export const getAdminApplications = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminApplicationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminApplicationsResponses,
    GetAdminApplicationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications",
    ...options,
  });

/**
 * Register a new ISV application on the platform
 *
 * Register a new ISV application on the platform. Auto-generates a unique slug
 * from name if not provided. Validates enabled_capabilities and their dependency
 * graph. After creation: creates a billing liability account, auto-generates a
 * default sk_app_ API key (returned once in generated_api_key), and creates system
 * email templates for the application. Restricted to platform admins or ISV tenant
 * owners.
 *
 * Returns the application with generated_api_key populated (only available once).
 *
 */
export const postAdminApplications = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminApplicationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminApplicationsResponses,
    PostAdminApplicationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Advance a data subject request through its lifecycle (pending → in_progress → completed / rejected / expired) and record notes or a completion timestamp.
 *
 * Advance a data subject request through its lifecycle (pending → in_progress → completed / rejected / expired) and record notes or a completion timestamp.
 */
export const patchAdminDataSubjectRequestsByIdStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminDataSubjectRequestsByIdStatusData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminDataSubjectRequestsByIdStatusResponses,
    PatchAdminDataSubjectRequestsByIdStatusErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/data-subject-requests/{id}/status",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Soft-delete a product by stamping deleted_at; excluded from all future reads
 *
 * Soft-delete a product by stamping deleted_at; excluded from all future reads. Use update with status :archived to preserve searchability.
 */
export const deleteAdminCatalogProductsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCatalogProductsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCatalogProductsByIdResponses,
    DeleteAdminCatalogProductsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/products/{id}",
    ...options,
  });

/**
 * /catalog/products/:id operation on catalog-product resource
 *
 * /catalog/products/:id operation on catalog-product resource
 */
export const getAdminCatalogProductsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCatalogProductsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCatalogProductsByIdResponses,
    GetAdminCatalogProductsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/products/{id}",
    ...options,
  });

/**
 * Update a product's attributes; triggers search re-indexing and embedding refresh
 *
 * Update a product's attributes; triggers search re-indexing and embedding refresh. Returns the updated product.
 */
export const patchAdminCatalogProductsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCatalogProductsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogProductsByIdResponses,
    PatchAdminCatalogProductsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/products/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Hard-delete a participant from an event
 *
 * Hard-delete a participant from an event. No side effects — reminders for this participant are not automatically cancelled.
 */
export const deleteAdminSchedulingParticipantsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSchedulingParticipantsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSchedulingParticipantsByIdResponses,
    DeleteAdminSchedulingParticipantsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/participants/{id}",
    ...options,
  });

/**
 * Fetch a single participant by ID
 *
 * Fetch a single participant by ID. Returns RSVP status, role, contact_id, and responded_at timestamp.
 */
export const getAdminSchedulingParticipantsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingParticipantsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingParticipantsByIdResponses,
    GetAdminSchedulingParticipantsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/participants/{id}",
    ...options,
  });

/**
 * Update participant metadata: name, phone, role, or custom metadata
 *
 * Update participant metadata: name, phone, role, or custom metadata. Use :respond to update RSVP status — status cannot be changed via :update.
 */
export const patchAdminSchedulingParticipantsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSchedulingParticipantsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingParticipantsByIdResponses,
    PatchAdminSchedulingParticipantsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/participants/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Close a resolved ticket, ending the ticket lifecycle
 *
 * Close a resolved ticket, ending the ticket lifecycle. Validated by ValidStatusTransition — ticket must be :resolved. No further state transitions are permitted after :closed.
 */
export const patchAdminSupportTicketsByIdClose = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSupportTicketsByIdCloseData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSupportTicketsByIdCloseResponses,
    PatchAdminSupportTicketsByIdCloseErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/tickets/{id}/close",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/sessions operation on clinical-session resource
 *
 * /clinical/sessions operation on clinical-session resource
 */
export const getAdminClinicalSessions = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminClinicalSessionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSessionsResponses,
    GetAdminClinicalSessionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/sessions",
    ...options,
  });

/**
 * /clinical/sessions operation on clinical-session resource
 *
 * /clinical/sessions operation on clinical-session resource
 */
export const postAdminClinicalSessions = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminClinicalSessionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalSessionsResponses,
    PostAdminClinicalSessionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/sessions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Soft-delete a ticket by setting deleted_at
 *
 * Soft-delete a ticket by setting deleted_at. Excluded from standard reads. Enqueues Meilisearch deletion to remove from search index. Messages and attachments are preserved.
 */
export const deleteAdminSupportTicketsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSupportTicketsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSupportTicketsByIdResponses,
    DeleteAdminSupportTicketsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/tickets/{id}",
    ...options,
  });

/**
 * Fetch a single active ticket by ID
 *
 * Fetch a single active ticket by ID. Excludes soft-deleted tickets.
 */
export const getAdminSupportTicketsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSupportTicketsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSupportTicketsByIdResponses,
    GetAdminSupportTicketsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/tickets/{id}",
    ...options,
  });

/**
 * Update ticket fields including status (validated by ValidStatusTransition), queue assignment, SLA, and AI classification fields
 *
 * Update ticket fields including status (validated by ValidStatusTransition), queue assignment, SLA, and AI classification fields. Re-indexes in Meilisearch. Use :assign/:resolve/:close/:reopen/:merge for specific lifecycle transitions.
 */
export const patchAdminSupportTicketsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSupportTicketsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSupportTicketsByIdResponses,
    PatchAdminSupportTicketsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/tickets/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /messages operation on chat-message resource
 *
 * /messages operation on chat-message resource
 */
export const getAdminMessages = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminMessagesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminMessagesResponses,
    GetAdminMessagesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/messages",
    ...options,
  });

/**
 * Add a new message turn to a thread
 *
 * Add a new message turn to a thread. Automatically runs PII compliance scan on the content and enqueues an async Oban job to generate a 1024-dim BGE-M3 embedding for semantic search. Use Thread.process_message instead if you want the AI reply in the same call.
 */
export const postAdminMessages = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminMessagesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminMessagesResponses,
    PostAdminMessagesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/messages",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Push an AI-generated clinical note to Practice Better for a linked contact
 *
 * Push an AI-generated clinical note to Practice Better for a linked contact.
 * Requires an active PB connector instance and a contact with an integration_link.
 *
 */
export const postAdminConnectorsByIdPracticeBetterPushNote = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsByIdPracticeBetterPushNoteData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsByIdPracticeBetterPushNoteResponses,
    PostAdminConnectorsByIdPracticeBetterPushNoteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/{id}/practice-better/push-note",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /access-logs operation on access-log resource
 *
 * /access-logs operation on access-log resource
 */
export const getAdminAccessLogs = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAccessLogsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAccessLogsResponses,
    GetAdminAccessLogsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/access-logs",
    ...options,
  });

/**
 * /clinical/meal-plans/:id/permanent operation on clinical-meal-plan resource
 *
 * /clinical/meal-plans/:id/permanent operation on clinical-meal-plan resource
 */
export const deleteAdminClinicalMealPlansByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminClinicalMealPlansByIdPermanentData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalMealPlansByIdPermanentResponses,
    DeleteAdminClinicalMealPlansByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/meal-plans/{id}/permanent",
    ...options,
  });

/**
 * /feature-definitions/:id operation on feature-definition resource
 *
 * /feature-definitions/:id operation on feature-definition resource
 */
export const deleteAdminFeatureDefinitionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminFeatureDefinitionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminFeatureDefinitionsByIdResponses,
    DeleteAdminFeatureDefinitionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/feature-definitions/{id}",
    ...options,
  });

/**
 * Fetch a single feature definition by ID.
 *
 * Fetch a single feature definition by ID.
 */
export const getAdminFeatureDefinitionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminFeatureDefinitionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFeatureDefinitionsByIdResponses,
    GetAdminFeatureDefinitionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/feature-definitions/{id}",
    ...options,
  });

/**
 * Update a feature definition's configuration.
 *
 * Update a feature definition's configuration.
 */
export const patchAdminFeatureDefinitionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminFeatureDefinitionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminFeatureDefinitionsByIdResponses,
    PatchAdminFeatureDefinitionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/feature-definitions/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /agent-deployments operation on agent-deployment resource
 *
 * /agent-deployments operation on agent-deployment resource
 */
export const getAdminAgentDeployments = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAgentDeploymentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentDeploymentsResponses,
    GetAdminAgentDeploymentsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-deployments",
    ...options,
  });

/**
 * /agent-deployments operation on agent-deployment resource
 *
 * /agent-deployments operation on agent-deployment resource
 */
export const postAdminAgentDeployments = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAgentDeploymentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentDeploymentsResponses,
    PostAdminAgentDeploymentsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-deployments",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/websites/:id operation on crm-website resource
 *
 * /crm/websites/:id operation on crm-website resource
 */
export const deleteAdminCrmWebsitesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmWebsitesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmWebsitesByIdResponses,
    DeleteAdminCrmWebsitesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/websites/{id}",
    ...options,
  });

/**
 * /crm/websites/:id operation on crm-website resource
 *
 * /crm/websites/:id operation on crm-website resource
 */
export const getAdminCrmWebsitesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCrmWebsitesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmWebsitesByIdResponses,
    GetAdminCrmWebsitesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/websites/{id}",
    ...options,
  });

/**
 * Update a website record
 *
 * Update a website record. URL is re-validated if changed.
 */
export const patchAdminCrmWebsitesById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminCrmWebsitesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmWebsitesByIdResponses,
    PatchAdminCrmWebsitesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/websites/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/metrics/campaign/:social_campaign_id operation on post-metric resource
 *
 * /social/metrics/campaign/:social_campaign_id operation on post-metric resource
 */
export const getAdminSocialMetricsCampaignBySocialCampaignId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSocialMetricsCampaignBySocialCampaignIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSocialMetricsCampaignBySocialCampaignIdResponses,
    GetAdminSocialMetricsCampaignBySocialCampaignIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/metrics/campaign/{social_campaign_id}",
    ...options,
  });

/**
 * /voice/transcription-jobs operation on transcription-job resource
 *
 * /voice/transcription-jobs operation on transcription-job resource
 */
export const getAdminVoiceTranscriptionJobs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminVoiceTranscriptionJobsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminVoiceTranscriptionJobsResponses,
    GetAdminVoiceTranscriptionJobsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/transcription-jobs",
    ...options,
  });

/**
 * /voice/transcription-jobs operation on transcription-job resource
 *
 * /voice/transcription-jobs operation on transcription-job resource
 */
export const postAdminVoiceTranscriptionJobs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminVoiceTranscriptionJobsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminVoiceTranscriptionJobsResponses,
    PostAdminVoiceTranscriptionJobsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/transcription-jobs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/news-monitors operation on news-monitor resource
 *
 * /crawler/news-monitors operation on news-monitor resource
 */
export const getAdminCrawlerNewsMonitors = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrawlerNewsMonitorsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerNewsMonitorsResponses,
    GetAdminCrawlerNewsMonitorsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/news-monitors",
    ...options,
  });

/**
 * Create a workspace-scoped NewsMonitor.
 *
 * Create a workspace-scoped NewsMonitor.
 */
export const postAdminCrawlerNewsMonitors = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCrawlerNewsMonitorsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrawlerNewsMonitorsResponses,
    PostAdminCrawlerNewsMonitorsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/news-monitors",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create or replace a user preference by context_key
 *
 * Create or replace a user preference by context_key
 */
export const postAdminPreferencesUpsert = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminPreferencesUpsertData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPreferencesUpsertResponses,
    PostAdminPreferencesUpsertErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/preferences/upsert",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /field-templates operation on field-template resource
 *
 * /field-templates operation on field-template resource
 */
export const getAdminFieldTemplates = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminFieldTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFieldTemplatesResponses,
    GetAdminFieldTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/field-templates",
    ...options,
  });

/**
 * /field-templates operation on field-template resource
 *
 * /field-templates operation on field-template resource
 */
export const postAdminFieldTemplates = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminFieldTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminFieldTemplatesResponses,
    PostAdminFieldTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/field-templates",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Install a new connector instance in a workspace
 *
 * Install a new connector instance in a workspace. Registers a connector adapter (e.g.,
 * Salesforce, HubSpot, Slack) with its configuration and sync interval. The connector type
 * must match a registered adapter in AdapterRegistry or the action fails. OAuth credentials
 * are stored separately via the Credential resource after completing the OAuth flow.
 *
 * Returns the created connector instance record with health_status: :unknown.
 *
 */
export const postAdminConnectors = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminConnectorsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsResponses,
    PostAdminConnectorsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Remove a product override from a view; the product reverts to standard rule-based inclusion/exclusion on next resolution.
 *
 * Remove a product override from a view; the product reverts to standard rule-based inclusion/exclusion on next resolution.
 */
export const deleteAdminCatalogViewOverridesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCatalogViewOverridesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCatalogViewOverridesByIdResponses,
    DeleteAdminCatalogViewOverridesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/view-overrides/{id}",
    ...options,
  });

/**
 * Update the action (pin/exclude), position, or display overrides for an existing view override
 *
 * Update the action (pin/exclude), position, or display overrides for an existing view override. Returns the updated override.
 */
export const patchAdminCatalogViewOverridesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCatalogViewOverridesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogViewOverridesByIdResponses,
    PatchAdminCatalogViewOverridesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/view-overrides/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /campaigns/sequences/:id operation on email-marketing-sequence resource
 *
 * /campaigns/sequences/:id operation on email-marketing-sequence resource
 */
export const deleteAdminCampaignsSequencesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCampaignsSequencesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCampaignsSequencesByIdResponses,
    DeleteAdminCampaignsSequencesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequences/{id}",
    ...options,
  });

/**
 * /campaigns/sequences/:id operation on email-marketing-sequence resource
 *
 * /campaigns/sequences/:id operation on email-marketing-sequence resource
 */
export const getAdminCampaignsSequencesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCampaignsSequencesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCampaignsSequencesByIdResponses,
    GetAdminCampaignsSequencesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequences/{id}",
    ...options,
  });

/**
 * /campaigns/sequences/:id operation on email-marketing-sequence resource
 *
 * /campaigns/sequences/:id operation on email-marketing-sequence resource
 */
export const patchAdminCampaignsSequencesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCampaignsSequencesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCampaignsSequencesByIdResponses,
    PatchAdminCampaignsSequencesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequences/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Pin or exclude a product in a specific view with optional display overrides (name, description, media)
 *
 * Pin or exclude a product in a specific view with optional display overrides (name, description, media). Returns the created override.
 */
export const postAdminCatalogViewOverrides = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCatalogViewOverridesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogViewOverridesResponses,
    PostAdminCatalogViewOverridesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/view-overrides",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/relationship-types/:id operation on crm-relationship-type resource
 *
 * /crm/relationship-types/:id operation on crm-relationship-type resource
 */
export const deleteAdminCrmRelationshipTypesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmRelationshipTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmRelationshipTypesByIdResponses,
    DeleteAdminCrmRelationshipTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/relationship-types/{id}",
    ...options,
  });

/**
 * /crm/relationship-types/:id operation on crm-relationship-type resource
 *
 * /crm/relationship-types/:id operation on crm-relationship-type resource
 */
export const getAdminCrmRelationshipTypesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrmRelationshipTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmRelationshipTypesByIdResponses,
    GetAdminCrmRelationshipTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/relationship-types/{id}",
    ...options,
  });

/**
 * Update a relationship type's display name, allowed entity types, or properties schema
 *
 * Update a relationship type's display name, allowed entity types, or properties schema. Slug cannot be changed after creation.
 */
export const patchAdminCrmRelationshipTypesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmRelationshipTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmRelationshipTypesByIdResponses,
    PatchAdminCrmRelationshipTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/relationship-types/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Generate text from a prompt, optionally informed by brand identity.
 *
 * Generate text from a prompt, optionally informed by brand identity.
 */
export const postAdminContentGenerateText = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminContentGenerateTextData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminContentGenerateTextResponses,
    PostAdminContentGenerateTextErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/content/generate-text",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/:id/submit-for-approval operation on invoices-invoice resource
 *
 * /invoices/:id/submit-for-approval operation on invoices-invoice resource
 */
export const patchAdminInvoicesByIdSubmitForApproval = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesByIdSubmitForApprovalData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesByIdSubmitForApprovalResponses,
    PatchAdminInvoicesByIdSubmitForApprovalErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}/submit-for-approval",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all feature definitions
 *
 * List all feature definitions. Filterable by application_id.
 */
export const getAdminFeatureDefinitions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminFeatureDefinitionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFeatureDefinitionsResponses,
    GetAdminFeatureDefinitionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/feature-definitions",
    ...options,
  });

/**
 * Create a new ISV-defined feature for an application
 *
 * Create a new ISV-defined feature for an application. Requires application_id
 * (inferred from x-application-key header when not provided).
 *
 */
export const postAdminFeatureDefinitions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminFeatureDefinitionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminFeatureDefinitionsResponses,
    PostAdminFeatureDefinitionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/feature-definitions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/recipe-tags operation on recipes-recipe-tag resource
 *
 * /recipes/recipe-tags operation on recipes-recipe-tag resource
 */
export const postAdminRecipesRecipeTags = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminRecipesRecipeTagsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesRecipeTagsResponses,
    PostAdminRecipesRecipeTagsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/recipe-tags",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/tags operation on recipes-tag resource
 *
 * /recipes/tags operation on recipes-tag resource
 */
export const postAdminRecipesTags = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminRecipesTagsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesTagsResponses,
    PostAdminRecipesTagsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/tags",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/recipients/email/:outbound_email_id operation on email-recipient resource
 *
 * /email/recipients/email/:outbound_email_id operation on email-recipient resource
 */
export const getAdminEmailRecipientsEmailByOutboundEmailId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailRecipientsEmailByOutboundEmailIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailRecipientsEmailByOutboundEmailIdResponses,
    GetAdminEmailRecipientsEmailByOutboundEmailIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/recipients/email/{outbound_email_id}",
    ...options,
  });

/**
 * Permanently delete a price list entry
 *
 * Permanently delete a price list entry. Removes the override — product falls back to base price resolution.
 */
export const deleteAdminCatalogPriceListEntriesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCatalogPriceListEntriesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCatalogPriceListEntriesByIdResponses,
    DeleteAdminCatalogPriceListEntriesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/price-list-entries/{id}",
    ...options,
  });

/**
 * Update the price, modifier, tiers, or floor price for an existing entry
 *
 * Update the price, modifier, tiers, or floor price for an existing entry. Returns the updated entry.
 */
export const patchAdminCatalogPriceListEntriesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCatalogPriceListEntriesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogPriceListEntriesByIdResponses,
    PatchAdminCatalogPriceListEntriesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/price-list-entries/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/social-profiles/:id operation on crm-social-profile resource
 *
 * /crm/social-profiles/:id operation on crm-social-profile resource
 */
export const deleteAdminCrmSocialProfilesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmSocialProfilesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmSocialProfilesByIdResponses,
    DeleteAdminCrmSocialProfilesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/social-profiles/{id}",
    ...options,
  });

/**
 * /crm/social-profiles/:id operation on crm-social-profile resource
 *
 * /crm/social-profiles/:id operation on crm-social-profile resource
 */
export const getAdminCrmSocialProfilesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrmSocialProfilesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmSocialProfilesByIdResponses,
    GetAdminCrmSocialProfilesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/social-profiles/{id}",
    ...options,
  });

/**
 * Update an existing social profile
 *
 * Update an existing social profile. Re-validates URL format if changed.
 */
export const patchAdminCrmSocialProfilesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmSocialProfilesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmSocialProfilesByIdResponses,
    PatchAdminCrmSocialProfilesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/social-profiles/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Exchange OAuth authorization code for credential.
 *
 * Exchange OAuth authorization code for credential.
 */
export const postAdminConnectorsOauthCallback = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminConnectorsOauthCallbackData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsOauthCallbackResponses,
    PostAdminConnectorsOauthCallbackErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/oauth/callback",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a catalog view (named product lens) in a workspace; enforces max_catalog_views quota
 *
 * Create a catalog view (named product lens) in a workspace; enforces max_catalog_views quota. Returns the created view.
 */
export const postAdminCatalogViews = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCatalogViewsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogViewsResponses,
    PostAdminCatalogViewsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/views",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Cancel a booking, recording cancellation_reason and cancelled_by (:booker/:organizer/:system)
 *
 * Cancel a booking, recording cancellation_reason and cancelled_by (:booker/:organizer/:system). Propagates cancellation to the linked Event. Publishes BookingCancelled event.
 */
export const patchAdminSchedulingBookingsByIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSchedulingBookingsByIdCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingBookingsByIdCancelResponses,
    PatchAdminSchedulingBookingsByIdCancelErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/bookings/{id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /access-grants/:id operation on access-grant resource
 *
 * /access-grants/:id operation on access-grant resource
 */
export const deleteAdminAccessGrantsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminAccessGrantsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminAccessGrantsByIdResponses,
    DeleteAdminAccessGrantsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/access-grants/{id}",
    ...options,
  });

/**
 * /access-grants/:id operation on access-grant resource
 *
 * /access-grants/:id operation on access-grant resource
 */
export const getAdminAccessGrantsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAccessGrantsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAccessGrantsByIdResponses,
    GetAdminAccessGrantsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/access-grants/{id}",
    ...options,
  });

/**
 * /access-grants/:id operation on access-grant resource
 *
 * /access-grants/:id operation on access-grant resource
 */
export const patchAdminAccessGrantsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminAccessGrantsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAccessGrantsByIdResponses,
    PatchAdminAccessGrantsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/access-grants/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/note-templates/catalog/:id operation on clinical-note-template resource
 *
 * /clinical/note-templates/catalog/:id operation on clinical-note-template resource
 */
export const getAdminClinicalNoteTemplatesCatalogById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalNoteTemplatesCatalogByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNoteTemplatesCatalogByIdResponses,
    GetAdminClinicalNoteTemplatesCatalogByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/catalog/{id}",
    ...options,
  });

/**
 * /clinical/note-templates/catalog/:id operation on clinical-note-template resource
 *
 * /clinical/note-templates/catalog/:id operation on clinical-note-template resource
 */
export const patchAdminClinicalNoteTemplatesCatalogById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalNoteTemplatesCatalogByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalNoteTemplatesCatalogByIdResponses,
    PatchAdminClinicalNoteTemplatesCatalogByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/catalog/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all agents accessible in the current workspace
 *
 * List all agents accessible in the current workspace. Supports JSON:API filtering by
 * name, vertical, agent_function, input_kind, output_kind, catalog_family, is_system,
 * and tags. Returns paginated results ordered by created_at descending by default.
 *
 * Use this to build agent pickers, dashboards, and discovery UIs. Include the :versions
 * relationship to fetch the active version's prompt template and schema fields alongside
 * the agent record. Agents with is_system: true are platform-provided templates; they
 * cannot be deleted, but can be cloned via the :clone action.
 *
 */
export const getAdminAgents = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAgentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentsResponses,
    GetAdminAgentsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents",
    ...options,
  });

/**
 * Create a new agent
 *
 * Create a new agent. Automatically resolves `tenant_id` from the provided `workspace_id`,
 * records an activity event, and creates an initial AgentVersion (v1) with a blank prompt
 * and empty schema via `CreateInitialVersion`.
 *
 * Use `:clone` to create an agent from an existing one's schema, or `:import` to create from
 * exported JSON. System agents (`is_system: true`) require special authorization.
 *
 * Returns the created agent with its initial version available via the `:versions` relationship.
 *
 */
export const postAdminAgents = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAgentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentsResponses,
    PostAdminAgentsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/goal-templates/mine operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/mine operation on clinical-goal-template resource
 */
export const getAdminClinicalGoalTemplatesMine = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalGoalTemplatesMineData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalTemplatesMineResponses,
    GetAdminClinicalGoalTemplatesMineErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/mine",
    ...options,
  });

/**
 * List nutrition summaries for a meal schedule
 *
 * List nutrition summaries for a meal schedule
 */
export const getAdminRecipesNutritionSummariesMealScheduleByMealScheduleId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesNutritionSummariesMealScheduleByMealScheduleIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesNutritionSummariesMealScheduleByMealScheduleIdResponses,
    GetAdminRecipesNutritionSummariesMealScheduleByMealScheduleIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/nutrition-summaries/meal-schedule/{meal_schedule_id}",
    ...options,
  });

/**
 * /settlement-statements/:id/mark-reconciled operation on settlement-statement resource
 *
 * /settlement-statements/:id/mark-reconciled operation on settlement-statement resource
 */
export const patchAdminSettlementStatementsByIdMarkReconciled = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminSettlementStatementsByIdMarkReconciledData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminSettlementStatementsByIdMarkReconciledResponses,
    PatchAdminSettlementStatementsByIdMarkReconciledErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlement-statements/{id}/mark-reconciled",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /brand-identities/:id operation on brand-identity resource
 *
 * /brand-identities/:id operation on brand-identity resource
 */
export const deleteAdminBrandIdentitiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminBrandIdentitiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminBrandIdentitiesByIdResponses,
    DeleteAdminBrandIdentitiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/brand-identities/{id}",
    ...options,
  });

/**
 * /brand-identities/:id operation on brand-identity resource
 *
 * /brand-identities/:id operation on brand-identity resource
 */
export const getAdminBrandIdentitiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminBrandIdentitiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBrandIdentitiesByIdResponses,
    GetAdminBrandIdentitiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/brand-identities/{id}",
    ...options,
  });

/**
 * /brand-identities/:id operation on brand-identity resource
 *
 * /brand-identities/:id operation on brand-identity resource
 */
export const patchAdminBrandIdentitiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminBrandIdentitiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminBrandIdentitiesByIdResponses,
    PatchAdminBrandIdentitiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/brand-identities/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/goal-templates/catalog/:id/archive operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/catalog/:id/archive operation on clinical-goal-template resource
 */
export const patchAdminClinicalGoalTemplatesCatalogByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalGoalTemplatesCatalogByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalGoalTemplatesCatalogByIdArchiveResponses,
    PatchAdminClinicalGoalTemplatesCatalogByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/catalog/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/inbound/received/address/:inbound_address_id operation on email-inbound-email resource
 *
 * /email/inbound/received/address/:inbound_address_id operation on email-inbound-email resource
 */
export const getAdminEmailInboundReceivedAddressByInboundAddressId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailInboundReceivedAddressByInboundAddressIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailInboundReceivedAddressByInboundAddressIdResponses,
    GetAdminEmailInboundReceivedAddressByInboundAddressIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inbound/received/address/{inbound_address_id}",
    ...options,
  });

/**
 * /clinical/patients/:id/medications operation on clinical-client-medication resource
 *
 * /clinical/patients/:id/medications operation on clinical-client-medication resource
 */
export const getAdminClinicalPatientsByIdMedications = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPatientsByIdMedicationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPatientsByIdMedicationsResponses,
    GetAdminClinicalPatientsByIdMedicationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patients/{id}/medications",
    ...options,
  });

/**
 * List recipes for a workspace, excluding archived
 *
 * List recipes for a workspace, excluding archived
 */
export const getAdminRecipesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesWorkspaceByWorkspaceIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesWorkspaceByWorkspaceIdResponses,
    GetAdminRecipesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/workspace/{workspace_id}",
    ...options,
  });

/**
 * /clinical/health-metrics/by-session operation on clinical-health-metric resource
 *
 * /clinical/health-metrics/by-session operation on clinical-health-metric resource
 */
export const getAdminClinicalHealthMetricsBySession = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalHealthMetricsBySessionData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalHealthMetricsBySessionResponses,
    GetAdminClinicalHealthMetricsBySessionErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/health-metrics/by-session",
    ...options,
  });

/**
 * Delete an AgentVersion
 *
 * Delete an AgentVersion. Blocked if `usage_count > 0` (the version has been used for
 * extraction) to preserve audit integrity — unless called with `cascade_from_agent: true`
 * in the changeset context (i.e., during agent deletion).
 *
 * Side effects: deletes all associated `AgentVersionRevision` records before destroying the
 * version. Cache invalidation for the persistent_term schema cache is handled asynchronously
 * via the `VersionDestroyed` event consumed by `Extraction.EventHandler`.
 *
 * Returns the deleted version struct.
 *
 */
export const deleteAdminAgentVersionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminAgentVersionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminAgentVersionsByIdResponses,
    DeleteAdminAgentVersionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-versions/{id}",
    ...options,
  });

/**
 * Fetch a single AgentVersion by ID
 *
 * Fetch a single AgentVersion by ID. Returns all public attributes including schema fields, prompt template, and usage count.
 */
export const getAdminAgentVersionsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAgentVersionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentVersionsByIdResponses,
    GetAdminAgentVersionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-versions/{id}",
    ...options,
  });

/**
 * Update an AgentVersion's prompt template or changes summary
 *
 * Update an AgentVersion's prompt template or changes summary. Automatically increments the
 * `revision` number and creates an `AgentVersionRevision` record via `TrackRevision` when
 * the prompt or schema changes.
 *
 * Also synchronously invalidates the persistent_term schema cache for this version.
 * Use this to edit a draft or active version in-place. Returns the updated version.
 *
 */
export const patchAdminAgentVersionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminAgentVersionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAgentVersionsByIdResponses,
    PatchAdminAgentVersionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-versions/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /ledger/by-account/:account_id operation on ledger resource
 *
 * /ledger/by-account/:account_id operation on ledger resource
 */
export const getAdminLedgerByAccountByAccountId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminLedgerByAccountByAccountIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLedgerByAccountByAccountIdResponses,
    GetAdminLedgerByAccountByAccountIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ledger/by-account/{account_id}",
    ...options,
  });

/**
 * Permanently remove a relationship edge (hard delete)
 *
 * Permanently remove a relationship edge (hard delete). Publishes a RelationshipRemoved event and removes the graph edge from Neo4j.
 */
export const deleteAdminCrmRelationshipsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmRelationshipsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmRelationshipsByIdResponses,
    DeleteAdminCrmRelationshipsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/relationships/{id}",
    ...options,
  });

/**
 * Fetch a single CRM relationship by ID
 *
 * Fetch a single CRM relationship by ID. Use :list_by_workspace to discover relationships for a workspace.
 */
export const getAdminCrmRelationshipsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrmRelationshipsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmRelationshipsByIdResponses,
    GetAdminCrmRelationshipsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/relationships/{id}",
    ...options,
  });

/**
 * /notification-methods/:id operation on notification-method resource
 *
 * /notification-methods/:id operation on notification-method resource
 */
export const deleteAdminNotificationMethodsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminNotificationMethodsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminNotificationMethodsByIdResponses,
    DeleteAdminNotificationMethodsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-methods/{id}",
    ...options,
  });

/**
 * /notification-methods/:id operation on notification-method resource
 *
 * /notification-methods/:id operation on notification-method resource
 */
export const getAdminNotificationMethodsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminNotificationMethodsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminNotificationMethodsByIdResponses,
    GetAdminNotificationMethodsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-methods/{id}",
    ...options,
  });

/**
 * Update the display name or connection config for an existing notification method
 *
 * Update the display name or connection config for an existing notification method. Use :send_verification and :verify after changing config to re-validate the endpoint.
 */
export const patchAdminNotificationMethodsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminNotificationMethodsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminNotificationMethodsByIdResponses,
    PatchAdminNotificationMethodsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-methods/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a re-engagement campaign for non-engaged recipients
 *
 * Create a re-engagement campaign for non-engaged recipients
 */
export const postAdminEmailMarketingCampaignsByIdCreateFollowup = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminEmailMarketingCampaignsByIdCreateFollowupData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminEmailMarketingCampaignsByIdCreateFollowupResponses,
    PostAdminEmailMarketingCampaignsByIdCreateFollowupErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/campaigns/{id}/create-followup",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all ExtractionResults for a document in reverse-chronological order (newest first)
 *
 * List all ExtractionResults for a document in reverse-chronological order (newest first).
 * Returns the full extraction history — useful when a document has been reprocessed or
 * regenerated multiple times. Hidden system fields are filtered. Paginated: default 20, max 100.
 *
 */
export const getAdminExtractionResultsDocumentByDocumentIdHistory = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionResultsDocumentByDocumentIdHistoryData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionResultsDocumentByDocumentIdHistoryResponses,
    GetAdminExtractionResultsDocumentByDocumentIdHistoryErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/results/document/{document_id}/history",
    ...options,
  });

/**
 * Create or update the channel capture configuration for a workspace (upsert — one config per workspace)
 *
 * Create or update the channel capture configuration for a workspace (upsert — one config per workspace). Controls which channel types create support tickets and the default queue for captured messages. Default (no config): capture disabled.
 */
export const postAdminSupportChannelCaptureConfigs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSupportChannelCaptureConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSupportChannelCaptureConfigsResponses,
    PostAdminSupportChannelCaptureConfigsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/channel-capture-configs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Mark an active file as pending_deletion; the S3 object is deleted by PendingDeletionWorker after the grace period
 *
 * Mark an active file as pending_deletion; the S3 object is deleted by PendingDeletionWorker after the grace period. Use Storage.delete_file/2 for archived files.
 */
export const patchAdminStorageFilesByIdSoftDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminStorageFilesByIdSoftDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminStorageFilesByIdSoftDeleteResponses,
    PatchAdminStorageFilesByIdSoftDeleteErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-files/{id}/soft-delete",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a new CRM deal and place it in a pipeline stage
 *
 * Create a new CRM deal and place it in a pipeline stage. Validates against
 * workspace deal quota and custom field definitions. Triggers Meilisearch indexing.
 * Returns the created Deal struct.
 *
 */
export const postAdminCrmDeals = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrmDealsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmDealsResponses,
    PostAdminCrmDealsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/deals",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/intake-targets/:id/archive operation on clinical-intake-target resource
 *
 * /clinical/intake-targets/:id/archive operation on clinical-intake-target resource
 */
export const patchAdminClinicalIntakeTargetsByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalIntakeTargetsByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalIntakeTargetsByIdArchiveResponses,
    PatchAdminClinicalIntakeTargetsByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/intake-targets/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all events in a workspace, newest first
 *
 * List all events in a workspace, newest first. Use :list_by_date_range for calendar views bounded by start/end time.
 */
export const getAdminSchedulingEvents = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSchedulingEventsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingEventsResponses,
    GetAdminSchedulingEventsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/events",
    ...options,
  });

/**
 * Create a scheduled event occurrence
 *
 * Create a scheduled event occurrence. Validates for time conflicts via ValidateNoConflict
 * (backed by PostgreSQL exclusion constraint). Auto-schedules reminders via ScheduleReminders.
 * Indexes in Meilisearch. Returns the created Event. Use :reschedule to change the time,
 * :cancel to cancel — do not update start_time/end_time directly via :update.
 *
 */
export const postAdminSchedulingEvents = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSchedulingEventsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSchedulingEventsResponses,
    PostAdminSchedulingEventsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/events",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-resources operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources operation on clinical-practice-resource resource
 */
export const getAdminClinicalPracticeResources = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPracticeResourcesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeResourcesResponses,
    GetAdminClinicalPracticeResourcesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources",
    ...options,
  });

/**
 * /clinical/practice-resources operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources operation on clinical-practice-resource resource
 */
export const postAdminClinicalPracticeResources = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalPracticeResourcesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalPracticeResourcesResponses,
    PostAdminClinicalPracticeResourcesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Accept a pending price suggestion; publishes PriceSuggestionAccepted and PriceChanged events, cascading to update the product's effective price.
 *
 * Accept a pending price suggestion; publishes PriceSuggestionAccepted and PriceChanged events, cascading to update the product's effective price.
 */
export const patchAdminCatalogPriceSuggestionsByIdAccept = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminCatalogPriceSuggestionsByIdAcceptData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogPriceSuggestionsByIdAcceptResponses,
    PatchAdminCatalogPriceSuggestionsByIdAcceptErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/price-suggestions/{id}/accept",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List search analytics with tenant-based filtering
 *
 * List search analytics with tenant-based filtering
 */
export const getAdminSearchAnalytics = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSearchAnalyticsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSearchAnalyticsResponses,
    GetAdminSearchAnalyticsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/analytics",
    ...options,
  });

/**
 * /form-generations/:id operation on form-generation-job resource
 *
 * /form-generations/:id operation on form-generation-job resource
 */
export const getAdminFormGenerationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminFormGenerationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFormGenerationsByIdResponses,
    GetAdminFormGenerationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-generations/{id}",
    ...options,
  });

/**
 * /campaigns/sequences/:id/activate operation on email-marketing-sequence resource
 *
 * /campaigns/sequences/:id/activate operation on email-marketing-sequence resource
 */
export const patchAdminCampaignsSequencesByIdActivate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCampaignsSequencesByIdActivateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCampaignsSequencesByIdActivateResponses,
    PatchAdminCampaignsSequencesByIdActivateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequences/{id}/activate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Sync appointments from Healthie connector to platform
 *
 * Sync appointments from Healthie connector to platform.
 *
 * Creates ClinicalSession records linked to Patients.
 * Returns sync summary with count and errors.
 *
 */
export const postAdminConnectorsByIdHealthieAppointmentsSync = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsByIdHealthieAppointmentsSyncData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsByIdHealthieAppointmentsSyncResponses,
    PostAdminConnectorsByIdHealthieAppointmentsSyncErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/{id}/healthie/appointments/sync",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Aggregate LLM usage and cost statistics optionally filtered by a date range; returns a single summary record.
 *
 * Aggregate LLM usage and cost statistics optionally filtered by a date range; returns a single summary record.
 */
export const getAdminLlmAnalyticsSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminLlmAnalyticsSummaryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLlmAnalyticsSummaryResponses,
    GetAdminLlmAnalyticsSummaryErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/llm-analytics/summary",
    ...options,
  });

/**
 * List documents that have been trained and not dismissed
 *
 * List documents that have been trained and not dismissed
 */
export const getAdminExtractionDocumentsWorkspaceByWorkspaceIdTrained = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdTrainedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdTrainedResponses,
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdTrainedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/workspace/{workspace_id}/trained",
    ...options,
  });

/**
 * Create a personal tenant for an authenticated user who has none (e.g
 *
 * Create a personal tenant for an authenticated user who has none (e.g. joined via invite).
 */
export const postAdminTenantsPersonal = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminTenantsPersonalData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTenantsPersonalResponses,
    PostAdminTenantsPersonalErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/personal",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/:id/mark-overdue operation on invoices-invoice resource
 *
 * /invoices/:id/mark-overdue operation on invoices-invoice resource
 */
export const patchAdminInvoicesByIdMarkOverdue = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesByIdMarkOverdueData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesByIdMarkOverdueResponses,
    PatchAdminInvoicesByIdMarkOverdueErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}/mark-overdue",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/lines operation on invoices-line resource
 *
 * /invoices/lines operation on invoices-line resource
 */
export const postAdminInvoicesLines = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminInvoicesLinesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminInvoicesLinesResponses,
    PostAdminInvoicesLinesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/lines",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-goals operation on clinical-client-goal resource
 *
 * /clinical/client-goals operation on clinical-client-goal resource
 */
export const getAdminClinicalClientGoals = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalClientGoalsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalClientGoalsResponses,
    GetAdminClinicalClientGoalsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-goals",
    ...options,
  });

/**
 * /clinical/client-goals operation on clinical-client-goal resource
 *
 * /clinical/client-goals operation on clinical-client-goal resource
 */
export const postAdminClinicalClientGoals = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalClientGoalsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalClientGoalsResponses,
    PostAdminClinicalClientGoalsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-goals",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /campaigns/sequences/:id/resume operation on email-marketing-sequence resource
 *
 * /campaigns/sequences/:id/resume operation on email-marketing-sequence resource
 */
export const patchAdminCampaignsSequencesByIdResume = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCampaignsSequencesByIdResumeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCampaignsSequencesByIdResumeResponses,
    PatchAdminCampaignsSequencesByIdResumeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequences/{id}/resume",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Configure the auto top-up billing rule for this tenant
 *
 * Configure the auto top-up billing rule for this tenant. When enabled and the
 * tenant's credit balance falls below threshold, the billing system automatically
 * purchases amount credits using the specified credit package. Set enabled: false
 * to disable auto top-up without clearing the other settings.
 *
 */
export const patchAdminTenantsByIdAutoTopUp = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminTenantsByIdAutoTopUpData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTenantsByIdAutoTopUpResponses,
    PatchAdminTenantsByIdAutoTopUpErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}/auto-top-up",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /extraction/analyses/:id operation on extraction-analysis resource
 *
 * /extraction/analyses/:id operation on extraction-analysis resource
 */
export const getAdminExtractionAnalysesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionAnalysesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionAnalysesByIdResponses,
    GetAdminExtractionAnalysesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/analyses/{id}",
    ...options,
  });

/**
 * Create a treatment plan in Fullscript with product recommendations
 *
 * Create a treatment plan in Fullscript with product recommendations
 */
export const postAdminConnectorsFullscriptTreatmentPlansCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsFullscriptTreatmentPlansCreateData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsFullscriptTreatmentPlansCreateResponses,
    PostAdminConnectorsFullscriptTreatmentPlansCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/fullscript/treatment-plans/create",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Generate scored hashtags for content.
 *
 * Generate scored hashtags for content.
 */
export const postAdminContentGenerateHashtags = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminContentGenerateHashtagsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminContentGenerateHashtagsResponses,
    PostAdminContentGenerateHashtagsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/content/generate-hashtags",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/note-templates/catalog/:id/restore operation on clinical-note-template resource
 *
 * /clinical/note-templates/catalog/:id/restore operation on clinical-note-template resource
 */
export const patchAdminClinicalNoteTemplatesCatalogByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalNoteTemplatesCatalogByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalNoteTemplatesCatalogByIdRestoreResponses,
    PatchAdminClinicalNoteTemplatesCatalogByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/catalog/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Return aggregated chat statistics for the actor's current workspace: total threads, total messages, activity counts for 24h and 7d windows, and message distribution by role
 *
 * Return aggregated chat statistics for the actor's current workspace: total threads, total messages, activity counts for 24h and 7d windows, and message distribution by role. Uses database-level GROUP BY for efficiency. Returns a single virtual record keyed by workspace_id.
 */
export const getAdminThreadsWorkspaceStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminThreadsWorkspaceStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminThreadsWorkspaceStatsResponses,
    GetAdminThreadsWorkspaceStatsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/workspace-stats",
    ...options,
  });

/**
 * Preview email template with sample data
 *
 * Preview email template with sample data
 */
export const postAdminApplicationsByApplicationIdEmailTemplatesBySlugPreview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminApplicationsByApplicationIdEmailTemplatesBySlugPreviewData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminApplicationsByApplicationIdEmailTemplatesBySlugPreviewResponses,
    PostAdminApplicationsByApplicationIdEmailTemplatesBySlugPreviewErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/{application_id}/email-templates/{slug}/preview",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all email addresses for a specific entity (contact or company).
 *
 * List all email addresses for a specific entity (contact or company).
 */
export const getAdminCrmEmailAddressesEntityByEntityTypeByEntityId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmEmailAddressesEntityByEntityTypeByEntityIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmEmailAddressesEntityByEntityTypeByEntityIdResponses,
    GetAdminCrmEmailAddressesEntityByEntityTypeByEntityIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/email-addresses/entity/{entity_type}/{entity_id}",
    ...options,
  });

/**
 * List only the calling user's threads within their current workspace
 *
 * List only the calling user's threads within their current workspace. Use this from the Client API to scope thread listings to the authenticated user.
 */
export const getAdminThreadsMine = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminThreadsMineData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminThreadsMineResponses,
    GetAdminThreadsMineErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/mine",
    ...options,
  });

/**
 * Convert a personal tenant to an organization
 *
 * Convert a personal tenant to an organization. Requires a new name. Provisions a default workspace if none exists.
 */
export const patchAdminTenantsByIdConvertToOrg = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminTenantsByIdConvertToOrgData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTenantsByIdConvertToOrgResponses,
    PatchAdminTenantsByIdConvertToOrgErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}/convert-to-org",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/health-metrics/:id operation on clinical-health-metric resource
 *
 * /clinical/health-metrics/:id operation on clinical-health-metric resource
 */
export const getAdminClinicalHealthMetricsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalHealthMetricsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalHealthMetricsByIdResponses,
    GetAdminClinicalHealthMetricsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/health-metrics/{id}",
    ...options,
  });

/**
 * /clinical/health-metrics/:id operation on clinical-health-metric resource
 *
 * /clinical/health-metrics/:id operation on clinical-health-metric resource
 */
export const patchAdminClinicalHealthMetricsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalHealthMetricsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalHealthMetricsByIdResponses,
    PatchAdminClinicalHealthMetricsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/health-metrics/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/addresses/entity/:entity_type/:entity_id operation on crm-address resource
 *
 * /crm/addresses/entity/:entity_type/:entity_id operation on crm-address resource
 */
export const getAdminCrmAddressesEntityByEntityTypeByEntityId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmAddressesEntityByEntityTypeByEntityIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmAddressesEntityByEntityTypeByEntityIdResponses,
    GetAdminCrmAddressesEntityByEntityTypeByEntityIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/addresses/entity/{entity_type}/{entity_id}",
    ...options,
  });

/**
 * Fetch a single feature usage record by ID.
 *
 * Fetch a single feature usage record by ID.
 */
export const getAdminFeatureUsagesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminFeatureUsagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFeatureUsagesByIdResponses,
    GetAdminFeatureUsagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/feature-usages/{id}",
    ...options,
  });

/**
 * /notification-preferences/:id operation on notification-preference resource
 *
 * /notification-preferences/:id operation on notification-preference resource
 */
export const deleteAdminNotificationPreferencesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminNotificationPreferencesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminNotificationPreferencesByIdResponses,
    DeleteAdminNotificationPreferencesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-preferences/{id}",
    ...options,
  });

/**
 * /notification-preferences/:id operation on notification-preference resource
 *
 * /notification-preferences/:id operation on notification-preference resource
 */
export const getAdminNotificationPreferencesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminNotificationPreferencesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminNotificationPreferencesByIdResponses,
    GetAdminNotificationPreferencesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-preferences/{id}",
    ...options,
  });

/**
 * Update a user's notification channel list or per-category preferences
 *
 * Update a user's notification channel list or per-category preferences. Use this when the user opts out of a notification category or adds a new delivery channel.
 */
export const patchAdminNotificationPreferencesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminNotificationPreferencesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminNotificationPreferencesByIdResponses,
    PatchAdminNotificationPreferencesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-preferences/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all calendar sync configurations for a specific user
 *
 * List all calendar sync configurations for a specific user. Used to show the user their connected calendars. Each record represents one external calendar connection.
 */
export const getAdminSchedulingCalendarSyncs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingCalendarSyncsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingCalendarSyncsResponses,
    GetAdminSchedulingCalendarSyncsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/calendar-syncs",
    ...options,
  });

/**
 * Link a user's external calendar for bi-directional sync
 *
 * Link a user's external calendar for bi-directional sync. Requires a connector_id (OAuth credential from Connectors domain). sync_direction controls push/pull/bidirectional behavior. Returns the created CalendarSync with :active status.
 */
export const postAdminSchedulingCalendarSyncs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSchedulingCalendarSyncsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSchedulingCalendarSyncsResponses,
    PostAdminSchedulingCalendarSyncsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/calendar-syncs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Run post-campaign AI analysis with insights and recommendations
 *
 * Run post-campaign AI analysis with insights and recommendations
 */
export const postAdminEmailMarketingCampaignsByIdAnalyze = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminEmailMarketingCampaignsByIdAnalyzeData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminEmailMarketingCampaignsByIdAnalyzeResponses,
    PostAdminEmailMarketingCampaignsByIdAnalyzeErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/campaigns/{id}/analyze",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /reviews/:id/assign operation on review resource
 *
 * /reviews/:id/assign operation on review resource
 */
export const patchAdminReviewsByIdAssign = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminReviewsByIdAssignData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminReviewsByIdAssignResponses,
    PatchAdminReviewsByIdAssignErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/reviews/{id}/assign",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create an instance of a custom entity type
 *
 * Create an instance of a custom entity type. Properties are validated against
 * the parent type's field_definitions. Returns the created CustomEntity struct.
 *
 */
export const postAdminCrmCustomEntities = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCrmCustomEntitiesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmCustomEntitiesResponses,
    PostAdminCrmCustomEntitiesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/custom-entities",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Delete credentials for a connector at a specific scope level
 *
 * Delete credentials for a connector at a specific scope level.
 * Looks up by connector_type + scope_level + workspace_id, then destroys.
 * Returns {:ok, %{deleted: true}} on success.
 *
 */
export const postAdminConnectorsCredentialsDeleteByType = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsCredentialsDeleteByTypeData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsCredentialsDeleteByTypeResponses,
    PostAdminConnectorsCredentialsDeleteByTypeErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/credentials/delete-by-type",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /accounts/:id/credit operation on account resource
 *
 * /accounts/:id/credit operation on account resource
 */
export const patchAdminAccountsByIdCredit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminAccountsByIdCreditData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAccountsByIdCreditResponses,
    PatchAdminAccountsByIdCreditErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/accounts/{id}/credit",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List non-deleted files whose parent_id matches the given ID
 *
 * List non-deleted files whose parent_id matches the given ID. Use for folder-like hierarchical file trees.
 */
export const getAdminStorageFilesChildren = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminStorageFilesChildrenData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminStorageFilesChildrenResponses,
    GetAdminStorageFilesChildrenErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-files/children",
    ...options,
  });

/**
 * /documents/presigned-upload operation on presigned-url resource
 *
 * /documents/presigned-upload operation on presigned-url resource
 */
export const postAdminDocumentsPresignedUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminDocumentsPresignedUploadData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminDocumentsPresignedUploadResponses,
    PostAdminDocumentsPresignedUploadErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/documents/presigned-upload",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Soft-delete a workspace by setting archived_at to the current timestamp
 *
 * Soft-delete a workspace by setting archived_at to the current timestamp. The
 * workspace record is retained in the database and can be retrieved by passing
 * include_archived: true to read actions. Records a workspace_deleted activity
 * event. Restricted to the tenant owner.
 *
 */
export const deleteAdminWorkspacesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminWorkspacesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminWorkspacesByIdResponses,
    DeleteAdminWorkspacesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{id}",
    ...options,
  });

/**
 * Fetch a single workspace by its primary key
 *
 * Fetch a single workspace by its primary key. Excludes archived workspaces by default; pass include_archived: true to also fetch archived records.
 */
export const getAdminWorkspacesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminWorkspacesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWorkspacesByIdResponses,
    GetAdminWorkspacesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{id}",
    ...options,
  });

/**
 * Update workspace metadata and settings
 *
 * Update workspace metadata and settings. Validates that deduplication is ready
 * before enabling it (all documents must have file_hash). Also validates unique
 * folder paths within the tenant. Records a workspace_updated activity event.
 * Use :update_storage_settings for a storage-only change (separate policy:
 * storage managers can use that action without full update access).
 *
 */
export const patchAdminWorkspacesById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminWorkspacesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWorkspacesByIdResponses,
    PatchAdminWorkspacesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /reviews/:id operation on review resource
 *
 * /reviews/:id operation on review resource
 */
export const getAdminReviewsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminReviewsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminReviewsByIdResponses,
    GetAdminReviewsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/reviews/{id}",
    ...options,
  });

/**
 * /clinical/intake-targets/by-workspace operation on clinical-intake-target resource
 *
 * /clinical/intake-targets/by-workspace operation on clinical-intake-target resource
 */
export const getAdminClinicalIntakeTargetsByWorkspace = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalIntakeTargetsByWorkspaceData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalIntakeTargetsByWorkspaceResponses,
    GetAdminClinicalIntakeTargetsByWorkspaceErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/intake-targets/by-workspace",
    ...options,
  });

/**
 * /invoices/lines/:id operation on invoices-line resource
 *
 * /invoices/lines/:id operation on invoices-line resource
 */
export const deleteAdminInvoicesLinesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminInvoicesLinesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminInvoicesLinesByIdResponses,
    DeleteAdminInvoicesLinesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/lines/{id}",
    ...options,
  });

/**
 * /invoices/lines/:id operation on invoices-line resource
 *
 * /invoices/lines/:id operation on invoices-line resource
 */
export const getAdminInvoicesLinesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminInvoicesLinesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminInvoicesLinesByIdResponses,
    GetAdminInvoicesLinesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/lines/{id}",
    ...options,
  });

/**
 * /invoices/lines/:id operation on invoices-line resource
 *
 * /invoices/lines/:id operation on invoices-line resource
 */
export const patchAdminInvoicesLinesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesLinesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesLinesByIdResponses,
    PatchAdminInvoicesLinesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/lines/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/:id/re-enrich operation on recipes-recipe resource
 *
 * /recipes/:id/re-enrich operation on recipes-recipe resource
 */
export const patchAdminRecipesByIdReEnrich = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRecipesByIdReEnrichData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesByIdReEnrichResponses,
    PatchAdminRecipesByIdReEnrichErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/{id}/re-enrich",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /isv/crm/entity-types/:id operation on crm-custom-entity-type resource
 *
 * /isv/crm/entity-types/:id operation on crm-custom-entity-type resource
 */
export const deleteAdminIsvCrmEntityTypesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminIsvCrmEntityTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminIsvCrmEntityTypesByIdResponses,
    DeleteAdminIsvCrmEntityTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv/crm/entity-types/{id}",
    ...options,
  });

/**
 * /isv/crm/entity-types/:id operation on crm-custom-entity-type resource
 *
 * /isv/crm/entity-types/:id operation on crm-custom-entity-type resource
 */
export const getAdminIsvCrmEntityTypesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminIsvCrmEntityTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminIsvCrmEntityTypesByIdResponses,
    GetAdminIsvCrmEntityTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv/crm/entity-types/{id}",
    ...options,
  });

/**
 * Update a custom entity type's display name, field schema, or capability flags
 *
 * Update a custom entity type's display name, field schema, or capability flags. Slug cannot be changed after creation.
 */
export const patchAdminIsvCrmEntityTypesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminIsvCrmEntityTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminIsvCrmEntityTypesByIdResponses,
    PatchAdminIsvCrmEntityTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv/crm/entity-types/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /review-queues operation on review-queue resource
 *
 * /review-queues operation on review-queue resource
 */
export const getAdminReviewQueues = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminReviewQueuesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminReviewQueuesResponses,
    GetAdminReviewQueuesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/review-queues",
    ...options,
  });

/**
 * /review-queues operation on review-queue resource
 *
 * /review-queues operation on review-queue resource
 */
export const postAdminReviewQueues = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminReviewQueuesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminReviewQueuesResponses,
    PostAdminReviewQueuesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/review-queues",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get training analytics for a specific workspace
 *
 * Get training analytics for a specific workspace
 */
export const getAdminWorkspacesByWorkspaceIdTrainingAnalytics = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminWorkspacesByWorkspaceIdTrainingAnalyticsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminWorkspacesByWorkspaceIdTrainingAnalyticsResponses,
    GetAdminWorkspacesByWorkspaceIdTrainingAnalyticsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{workspace_id}/training/analytics",
    ...options,
  });

/**
 * /recipes/meal-schedules operation on recipes-meal-schedule resource
 *
 * /recipes/meal-schedules operation on recipes-meal-schedule resource
 */
export const postAdminRecipesMealSchedules = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminRecipesMealSchedulesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesMealSchedulesResponses,
    PostAdminRecipesMealSchedulesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/meal-schedules",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/meal-plans/by-patient operation on clinical-meal-plan resource
 *
 * /clinical/meal-plans/by-patient operation on clinical-meal-plan resource
 */
export const getAdminClinicalMealPlansByPatient = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalMealPlansByPatientData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalMealPlansByPatientResponses,
    GetAdminClinicalMealPlansByPatientErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/meal-plans/by-patient",
    ...options,
  });

/**
 * /campaigns/sequence-steps operation on email-marketing-sequence-step resource
 *
 * /campaigns/sequence-steps operation on email-marketing-sequence-step resource
 */
export const postAdminCampaignsSequenceSteps = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCampaignsSequenceStepsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCampaignsSequenceStepsResponses,
    PostAdminCampaignsSequenceStepsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequence-steps",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Paginate Entity vertices for the caller's tenant; returns up to 50 nodes per page by default.
 *
 * Paginate Entity vertices for the caller's tenant; returns up to 50 nodes per page by default.
 */
export const getAdminAiGraphNodes = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAiGraphNodesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAiGraphNodesResponses,
    GetAdminAiGraphNodesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/graph/nodes",
    ...options,
  });

/**
 * Create an Entity vertex in the knowledge graph; tenant_id is always forced from the actor and cannot be supplied by the caller
 *
 * Create an Entity vertex in the knowledge graph; tenant_id is always forced from the actor and cannot be supplied by the caller. Returns the created node.
 */
export const postAdminAiGraphNodes = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAiGraphNodesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAiGraphNodesResponses,
    PostAdminAiGraphNodesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/graph/nodes",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/generated-emails/:id/reject operation on email-marketing-generated-email resource
 *
 * /email-marketing/generated-emails/:id/reject operation on email-marketing-generated-email resource
 */
export const patchAdminEmailMarketingGeneratedEmailsByIdReject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailMarketingGeneratedEmailsByIdRejectData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingGeneratedEmailsByIdRejectResponses,
    PatchAdminEmailMarketingGeneratedEmailsByIdRejectErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/generated-emails/{id}/reject",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all stages for a specific pipeline, ordered by position.
 *
 * List all stages for a specific pipeline, ordered by position.
 */
export const getAdminCrmPipelineStagesPipelineByPipelineId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmPipelineStagesPipelineByPipelineIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmPipelineStagesPipelineByPipelineIdResponses,
    GetAdminCrmPipelineStagesPipelineByPipelineIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/pipeline-stages/pipeline/{pipeline_id}",
    ...options,
  });

/**
 * Resend confirmation email to an unconfirmed user
 *
 * Resend confirmation email to an unconfirmed user
 */
export const postAdminUsersAuthResendConfirmation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminUsersAuthResendConfirmationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminUsersAuthResendConfirmationResponses,
    PostAdminUsersAuthResendConfirmationErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/auth/resend-confirmation",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /training-sessions/agents/:agent_id/sessions operation on training-session resource
 *
 * /training-sessions/agents/:agent_id/sessions operation on training-session resource
 */
export const getAdminTrainingSessionsAgentsByAgentIdSessions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminTrainingSessionsAgentsByAgentIdSessionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminTrainingSessionsAgentsByAgentIdSessionsResponses,
    GetAdminTrainingSessionsAgentsByAgentIdSessionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-sessions/agents/{agent_id}/sessions",
    ...options,
  });

/**
 * Cancel a processing document
 *
 * Cancel a processing document
 */
export const patchAdminExtractionDocumentsByIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminExtractionDocumentsByIdCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionDocumentsByIdCancelResponses,
    PatchAdminExtractionDocumentsByIdCancelErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /tenant-pricing-overrides operation on tenant-pricing-override resource
 *
 * /tenant-pricing-overrides operation on tenant-pricing-override resource
 */
export const getAdminTenantPricingOverrides = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminTenantPricingOverridesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTenantPricingOverridesResponses,
    GetAdminTenantPricingOverridesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenant-pricing-overrides",
    ...options,
  });

/**
 * /tenant-pricing-overrides operation on tenant-pricing-override resource
 *
 * /tenant-pricing-overrides operation on tenant-pricing-override resource
 */
export const postAdminTenantPricingOverrides = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminTenantPricingOverridesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTenantPricingOverridesResponses,
    PostAdminTenantPricingOverridesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenant-pricing-overrides",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Return the current status and tenant context for the search indexes
 *
 * Return the current status and tenant context for the search indexes. Use :health for Meilisearch server health and latency.
 */
export const getAdminSearchStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSearchStatusData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSearchStatusResponses,
    GetAdminSearchStatusErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/status",
    ...options,
  });

/**
 * Run an agent version against a document and return the test result
 *
 * Run an agent version against a document and return the test result
 */
export const postAdminAgentTestResults = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAgentTestResultsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentTestResultsResponses,
    PostAdminAgentTestResultsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-test-results",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Clears published_at — template reverts to draft state.
 *
 * Clears published_at — template reverts to draft state.
 */
export const patchAdminEmailMarketingTemplatesByIdUnpublish = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailMarketingTemplatesByIdUnpublishData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingTemplatesByIdUnpublishResponses,
    PatchAdminEmailMarketingTemplatesByIdUnpublishErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/templates/{id}/unpublish",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/documents/:id operation on clinical-document resource
 *
 * /clinical/documents/:id operation on clinical-document resource
 */
export const deleteAdminClinicalDocumentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminClinicalDocumentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalDocumentsByIdResponses,
    DeleteAdminClinicalDocumentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/documents/{id}",
    ...options,
  });

/**
 * /clinical/documents/:id operation on clinical-document resource
 *
 * /clinical/documents/:id operation on clinical-document resource
 */
export const getAdminClinicalDocumentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalDocumentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalDocumentsByIdResponses,
    GetAdminClinicalDocumentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/documents/{id}",
    ...options,
  });

/**
 * /clinical/documents/:id operation on clinical-document resource
 *
 * /clinical/documents/:id operation on clinical-document resource
 */
export const patchAdminClinicalDocumentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalDocumentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalDocumentsByIdResponses,
    PatchAdminClinicalDocumentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/documents/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Mark artifact as sent and publish BreachNotificationReadyToSend event for Communication domain dispatch.
 *
 * Mark artifact as sent and publish BreachNotificationReadyToSend event for Communication domain dispatch.
 */
export const patchAdminBreachNotificationArtifactsByIdSend = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminBreachNotificationArtifactsByIdSendData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminBreachNotificationArtifactsByIdSendResponses,
    PatchAdminBreachNotificationArtifactsByIdSendErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/breach-notification-artifacts/{id}/send",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a website record for a contact or company
 *
 * Create a website record for a contact or company. URL must be a valid http/https URL.
 */
export const postAdminCrmWebsites = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrmWebsitesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmWebsitesResponses,
    PostAdminCrmWebsitesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/websites",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Replay historical events to this webhook
 *
 * Replay historical events to this webhook
 */
export const postAdminWebhookConfigsByIdReplay = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminWebhookConfigsByIdReplayData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminWebhookConfigsByIdReplayResponses,
    PostAdminWebhookConfigsByIdReplayErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-configs/{id}/replay",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /claimed-domains/:id operation on claimed-domain resource
 *
 * /claimed-domains/:id operation on claimed-domain resource
 */
export const deleteAdminClaimedDomainsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminClaimedDomainsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminClaimedDomainsByIdResponses,
    DeleteAdminClaimedDomainsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/claimed-domains/{id}",
    ...options,
  });

/**
 * /claimed-domains/:id operation on claimed-domain resource
 *
 * /claimed-domains/:id operation on claimed-domain resource
 */
export const getAdminClaimedDomainsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClaimedDomainsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClaimedDomainsByIdResponses,
    GetAdminClaimedDomainsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/claimed-domains/{id}",
    ...options,
  });

/**
 * /claimed-domains/:id operation on claimed-domain resource
 *
 * /claimed-domains/:id operation on claimed-domain resource
 */
export const patchAdminClaimedDomainsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClaimedDomainsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClaimedDomainsByIdResponses,
    PatchAdminClaimedDomainsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/claimed-domains/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get the currently authenticated user
 *
 * Get the currently authenticated user
 */
export const getAdminUsersMe = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUsersMeData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUsersMeResponses,
    GetAdminUsersMeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/me",
    ...options,
  });

/**
 * /invoices/:id/dispute operation on invoices-invoice resource
 *
 * /invoices/:id/dispute operation on invoices-invoice resource
 */
export const patchAdminInvoicesByIdDispute = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesByIdDisputeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesByIdDisputeResponses,
    PatchAdminInvoicesByIdDisputeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}/dispute",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/posts/:id/schedule operation on social-post resource
 *
 * /social/posts/:id/schedule operation on social-post resource
 */
export const patchAdminSocialPostsByIdSchedule = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSocialPostsByIdScheduleData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialPostsByIdScheduleResponses,
    PatchAdminSocialPostsByIdScheduleErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/posts/{id}/schedule",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/browser-sessions/:id operation on browser-session resource
 *
 * /crawler/browser-sessions/:id operation on browser-session resource
 */
export const deleteAdminCrawlerBrowserSessionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrawlerBrowserSessionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrawlerBrowserSessionsByIdResponses,
    DeleteAdminCrawlerBrowserSessionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/browser-sessions/{id}",
    ...options,
  });

/**
 * /crawler/browser-sessions/:id operation on browser-session resource
 *
 * /crawler/browser-sessions/:id operation on browser-session resource
 */
export const getAdminCrawlerBrowserSessionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrawlerBrowserSessionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerBrowserSessionsByIdResponses,
    GetAdminCrawlerBrowserSessionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/browser-sessions/{id}",
    ...options,
  });

/**
 * /social/accounts/:id/disable-posting operation on social-account resource
 *
 * /social/accounts/:id/disable-posting operation on social-account resource
 */
export const patchAdminSocialAccountsByIdDisablePosting = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminSocialAccountsByIdDisablePostingData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialAccountsByIdDisablePostingResponses,
    PatchAdminSocialAccountsByIdDisablePostingErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/accounts/{id}/disable-posting",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Accept a pending classification suggestion; publishes ClassificationAccepted event and increments taxonomy node product_count.
 *
 * Accept a pending classification suggestion; publishes ClassificationAccepted event and increments taxonomy node product_count.
 */
export const patchAdminCatalogClassificationSuggestionsByIdAccept = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminCatalogClassificationSuggestionsByIdAcceptData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogClassificationSuggestionsByIdAcceptResponses,
    PatchAdminCatalogClassificationSuggestionsByIdAcceptErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/classification-suggestions/{id}/accept",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Set or remove credit budget for this API key
 *
 * Set or remove credit budget for this API key
 */
export const patchAdminApiKeysByIdSetBudget = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminApiKeysByIdSetBudgetData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminApiKeysByIdSetBudgetResponses,
    PatchAdminApiKeysByIdSetBudgetErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/api-keys/{id}/set-budget",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create an application-scoped support queue
 *
 * Create an application-scoped support queue. ai_mode controls automation behavior (:ai_first, :human_first, :ai_only). Assign sla_policy_id for SLA tracking. Name is unique per application.
 */
export const postAdminSupportQueues = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSupportQueuesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSupportQueuesResponses,
    PostAdminSupportQueuesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/queues",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/schedules/:id operation on crawler-schedule resource
 *
 * /crawler/schedules/:id operation on crawler-schedule resource
 */
export const deleteAdminCrawlerSchedulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrawlerSchedulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrawlerSchedulesByIdResponses,
    DeleteAdminCrawlerSchedulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/schedules/{id}",
    ...options,
  });

/**
 * /crawler/schedules/:id operation on crawler-schedule resource
 *
 * /crawler/schedules/:id operation on crawler-schedule resource
 */
export const getAdminCrawlerSchedulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrawlerSchedulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerSchedulesByIdResponses,
    GetAdminCrawlerSchedulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/schedules/{id}",
    ...options,
  });

/**
 * Update schedule configuration, URL, frequency, or notification settings
 *
 * Update schedule configuration, URL, frequency, or notification settings. Returns the updated schedule.
 */
export const patchAdminCrawlerSchedulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrawlerSchedulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrawlerSchedulesByIdResponses,
    PatchAdminCrawlerSchedulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/schedules/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /extraction/analyses operation on extraction-analysis resource
 *
 * /extraction/analyses operation on extraction-analysis resource
 */
export const getAdminExtractionAnalyses = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionAnalysesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionAnalysesResponses,
    GetAdminExtractionAnalysesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/analyses",
    ...options,
  });

/**
 * Workspaces where user has membership but NOT tenant membership (shared from external orgs)
 *
 * Workspaces where user has membership but NOT tenant membership (shared from external orgs)
 */
export const getAdminWorkspacesShared = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminWorkspacesSharedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWorkspacesSharedResponses,
    GetAdminWorkspacesSharedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/shared",
    ...options,
  });

/**
 * List all revisions for a specific AgentVersion, sorted by revision number descending
 *
 * List all revisions for a specific AgentVersion, sorted by revision number descending.
 * Revisions capture incremental prompt and field-description changes within a schema version.
 * Authorization is checked manually inside the action via `Ash.get` with `authorize?: true`.
 *
 * Returns a JSON:API-shaped map `%{data: [%{id, type, attributes: {...}}]}`.
 *
 */
export const getAdminAgentVersionsByIdRevisions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAgentVersionsByIdRevisionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentVersionsByIdRevisionsResponses,
    GetAdminAgentVersionsByIdRevisionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-versions/{id}/revisions",
    ...options,
  });

/**
 * /access-logs/:id operation on access-log resource
 *
 * /access-logs/:id operation on access-log resource
 */
export const getAdminAccessLogsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAccessLogsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAccessLogsByIdResponses,
    GetAdminAccessLogsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/access-logs/{id}",
    ...options,
  });

/**
 * /email-marketing/templates/:id/archive operation on email-marketing-template resource
 *
 * /email-marketing/templates/:id/archive operation on email-marketing-template resource
 */
export const patchAdminEmailMarketingTemplatesByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailMarketingTemplatesByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingTemplatesByIdArchiveResponses,
    PatchAdminEmailMarketingTemplatesByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/templates/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Move an event to a new time slot
 *
 * Move an event to a new time slot. Validates for conflicts via ValidateNoConflict. Preserves old times in metadata. Cancels existing reminders and schedules new ones. Publishes EventRescheduled event.
 */
export const patchAdminSchedulingEventsByIdReschedule = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSchedulingEventsByIdRescheduleData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingEventsByIdRescheduleResponses,
    PatchAdminSchedulingEventsByIdRescheduleErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/events/{id}/reschedule",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * CFO modeling for a plan bundle
 *
 * CFO modeling for a plan bundle. Computes per-tier expected wholesale
 * spend, retail revenue, blended margin, and sensitivity bands (20%/50%
 * upside + downside on cost basis and usage variance) without persisting
 * anything. Safe to call repeatedly.
 *
 * Phase 1 skeleton: returns a placeholder response. Real behavior lands in
 * Phase 3.
 *
 */
export const postAdminPlanBundlesPreviewEconomics = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminPlanBundlesPreviewEconomicsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPlanBundlesPreviewEconomicsResponses,
    PostAdminPlanBundlesPreviewEconomicsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plan-bundles/preview-economics",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /meetings/:id operation on meeting resource
 *
 * /meetings/:id operation on meeting resource
 */
export const deleteAdminMeetingsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminMeetingsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminMeetingsByIdResponses,
    DeleteAdminMeetingsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/meetings/{id}",
    ...options,
  });

/**
 * /meetings/:id operation on meeting resource
 *
 * /meetings/:id operation on meeting resource
 */
export const getAdminMeetingsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminMeetingsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminMeetingsByIdResponses,
    GetAdminMeetingsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/meetings/{id}",
    ...options,
  });

/**
 * /meetings/:id operation on meeting resource
 *
 * /meetings/:id operation on meeting resource
 */
export const patchAdminMeetingsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminMeetingsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminMeetingsByIdResponses,
    PatchAdminMeetingsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/meetings/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List usage events for a tenant within a date range, intended for summary/dashboard views
 *
 * List usage events for a tenant within a date range, intended for summary/dashboard views.
 * Returns all matching events — client-side aggregation by operation_type is expected.
 * Use for summary dashboards and cost attribution reports.
 *
 */
export const getAdminUsageEventsSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminUsageEventsSummaryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUsageEventsSummaryResponses,
    GetAdminUsageEventsSummaryErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/usage-events/summary",
    ...options,
  });

/**
 * /message-feedback operation on chat-message-feedback resource
 *
 * /message-feedback operation on chat-message-feedback resource
 */
export const getAdminMessageFeedback = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminMessageFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminMessageFeedbackResponses,
    GetAdminMessageFeedbackErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/message-feedback",
    ...options,
  });

/**
 * Submit or update thumbs up/down feedback on a message
 *
 * Submit or update thumbs up/down feedback on a message. Uses upsert — one feedback per message per workspace (identity :message_unique). Returns the created or updated MessageFeedback.
 */
export const postAdminMessageFeedback = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminMessageFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminMessageFeedbackResponses,
    PostAdminMessageFeedbackErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/message-feedback",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Execute an action on an external connector
 *
 * Execute an action on an external connector
 */
export const postAdminConnectorsByIdSync = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminConnectorsByIdSyncData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsByIdSyncResponses,
    PostAdminConnectorsByIdSyncErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/{id}/sync",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/note-templates/from-existing operation on clinical-note-template resource
 *
 * /clinical/note-templates/from-existing operation on clinical-note-template resource
 */
export const postAdminClinicalNoteTemplatesFromExisting = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminClinicalNoteTemplatesFromExistingData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminClinicalNoteTemplatesFromExistingResponses,
    PostAdminClinicalNoteTemplatesFromExistingErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/from-existing",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/posts/scheduled operation on social-post resource
 *
 * /social/posts/scheduled operation on social-post resource
 */
export const getAdminSocialPostsScheduled = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSocialPostsScheduledData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSocialPostsScheduledResponses,
    GetAdminSocialPostsScheduledErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/posts/scheduled",
    ...options,
  });

/**
 * Enable multiple webhook configs by ID in a single call
 *
 * Enable multiple webhook configs by ID in a single call. Only configs the actor is authorized to update are affected; returns `{success: true, count: N}` indicating how many were enabled.
 */
export const postAdminWebhookConfigsBulkEnable = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminWebhookConfigsBulkEnableData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminWebhookConfigsBulkEnableResponses,
    PostAdminWebhookConfigsBulkEnableErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-configs/bulk-enable",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Workspace-scoped throughput metrics and bucketed counts for the requested
 * window
 *
 * Workspace-scoped throughput metrics and bucketed counts for the requested
 * window. Wraps GptCore.Extraction.dashboard_doc_summary_for_workspaces/2
 * for metrics and computes completed-document buckets inline.
 *
 */
export const getAdminExtractionDocumentsWorkspaceThroughput = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionDocumentsWorkspaceThroughputData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionDocumentsWorkspaceThroughputResponses,
    GetAdminExtractionDocumentsWorkspaceThroughputErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/workspace-throughput",
    ...options,
  });

/**
 * Get prioritized review queue for active learning
 *
 * Get prioritized review queue for active learning
 */
export const getAdminExtractionDocumentsWorkspaceByWorkspaceIdReviewQueue = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdReviewQueueData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdReviewQueueResponses,
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdReviewQueueErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/workspace/{workspace_id}/review-queue",
    ...options,
  });

/**
 * /brand-identities operation on brand-identity resource
 *
 * /brand-identities operation on brand-identity resource
 */
export const getAdminBrandIdentities = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminBrandIdentitiesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBrandIdentitiesResponses,
    GetAdminBrandIdentitiesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/brand-identities",
    ...options,
  });

/**
 * /brand-identities operation on brand-identity resource
 *
 * /brand-identities operation on brand-identity resource
 */
export const postAdminBrandIdentities = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminBrandIdentitiesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminBrandIdentitiesResponses,
    PostAdminBrandIdentitiesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/brand-identities",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/goal-associations/:id operation on clinical-goal-association resource
 *
 * /clinical/goal-associations/:id operation on clinical-goal-association resource
 */
export const deleteAdminClinicalGoalAssociationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminClinicalGoalAssociationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalGoalAssociationsByIdResponses,
    DeleteAdminClinicalGoalAssociationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-associations/{id}",
    ...options,
  });

/**
 * /clinical/goal-associations/:id operation on clinical-goal-association resource
 *
 * /clinical/goal-associations/:id operation on clinical-goal-association resource
 */
export const getAdminClinicalGoalAssociationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalGoalAssociationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalAssociationsByIdResponses,
    GetAdminClinicalGoalAssociationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-associations/{id}",
    ...options,
  });

/**
 * List all stock locations in a workspace
 *
 * List all stock locations in a workspace. Returns a paginated list including virtual locations.
 */
export const getAdminCatalogStockLocationsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogStockLocationsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogStockLocationsWorkspaceByWorkspaceIdResponses,
    GetAdminCatalogStockLocationsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/stock-locations/workspace/{workspace_id}",
    ...options,
  });

/**
 * List all tags defined for a workspace
 *
 * List all tags defined for a workspace. Use to populate tag pickers in ticket management UIs.
 */
export const getAdminSupportTagsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSupportTagsWorkspaceByWorkspaceIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSupportTagsWorkspaceByWorkspaceIdResponses,
    GetAdminSupportTagsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/tags/workspace/{workspace_id}",
    ...options,
  });

/**
 * /data-subject-requests operation on data-subject-request resource
 *
 * /data-subject-requests operation on data-subject-request resource
 */
export const getAdminDataSubjectRequests = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminDataSubjectRequestsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminDataSubjectRequestsResponses,
    GetAdminDataSubjectRequestsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/data-subject-requests",
    ...options,
  });

/**
 * Open a new GDPR/CCPA data subject request (access, erasure, portability, rectification, or restriction)
 *
 * Open a new GDPR/CCPA data subject request (access, erasure, portability, rectification, or restriction). Automatically sets a 30-day response `deadline` from the current time. A DataSubjectRequestWorker Oban job is responsible for processing the request.
 */
export const postAdminDataSubjectRequests = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminDataSubjectRequestsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminDataSubjectRequestsResponses,
    PostAdminDataSubjectRequestsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/data-subject-requests",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Rewrite text in a different tone.
 *
 * Rewrite text in a different tone.
 */
export const postAdminContentRewriteTone = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminContentRewriteToneData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminContentRewriteToneResponses,
    PostAdminContentRewriteToneErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/content/rewrite-tone",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /transfers operation on transfer resource
 *
 * /transfers operation on transfer resource
 */
export const getAdminTransfers = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminTransfersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTransfersResponses,
    GetAdminTransfersErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/transfers",
    ...options,
  });

/**
 * List all entries in a price list
 *
 * List all entries in a price list. Returns a paginated list of product/variant overrides.
 */
export const getAdminCatalogPriceListEntriesPriceListByPriceListId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogPriceListEntriesPriceListByPriceListIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogPriceListEntriesPriceListByPriceListIdResponses,
    GetAdminCatalogPriceListEntriesPriceListByPriceListIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/price-list-entries/price-list/{price_list_id}",
    ...options,
  });

/**
 * Register a file attachment on a ticket message
 *
 * Register a file attachment on a ticket message. The file must already be uploaded via the Storage domain — storage_path is the GCS object path returned by the upload. Returns the created TicketAttachment with filename and size.
 */
export const postAdminSupportTicketAttachments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSupportTicketAttachmentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSupportTicketAttachmentsResponses,
    PostAdminSupportTicketAttachmentsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/ticket-attachments",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List patients from Healthie connector
 *
 * List patients from Healthie connector.
 *
 * Returns array of Healthie patient records with optional date filter.
 * Requires active Healthie connector instance with OAuth credential.
 *
 */
export const postAdminConnectorsByIdHealthiePatientsList = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsByIdHealthiePatientsListData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsByIdHealthiePatientsListResponses,
    PostAdminConnectorsByIdHealthiePatientsListErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/{id}/healthie/patients/list",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Clone a system agent for workspace-specific customization
 *
 * Clone a system agent for workspace-specific customization
 */
export const postAdminAgentsCloneForWorkspace = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminAgentsCloneForWorkspaceData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentsCloneForWorkspaceResponses,
    PostAdminAgentsCloneForWorkspaceErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/clone-for-workspace",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Advance a breach incident through its lifecycle (identified → investigating → notifying → resolved / false_positive) and record officer notification and remediation notes.
 *
 * Advance a breach incident through its lifecycle (identified → investigating → notifying → resolved / false_positive) and record officer notification and remediation notes.
 */
export const patchAdminBreachIncidentsByIdStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminBreachIncidentsByIdStatusData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminBreachIncidentsByIdStatusResponses,
    PatchAdminBreachIncidentsByIdStatusErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/breach-incidents/{id}/status",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /business-associate-agreements operation on business-associate-agreement resource
 *
 * /business-associate-agreements operation on business-associate-agreement resource
 */
export const getAdminBusinessAssociateAgreements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminBusinessAssociateAgreementsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBusinessAssociateAgreementsResponses,
    GetAdminBusinessAssociateAgreementsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/business-associate-agreements",
    ...options,
  });

/**
 * /business-associate-agreements operation on business-associate-agreement resource
 *
 * /business-associate-agreements operation on business-associate-agreement resource
 */
export const postAdminBusinessAssociateAgreements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminBusinessAssociateAgreementsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminBusinessAssociateAgreementsResponses,
    PostAdminBusinessAssociateAgreementsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/business-associate-agreements",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-goals/:id/permanent operation on clinical-client-goal resource
 *
 * /clinical/client-goals/:id/permanent operation on clinical-client-goal resource
 */
export const deleteAdminClinicalClientGoalsByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalClientGoalsByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalClientGoalsByIdPermanentResponses,
    DeleteAdminClinicalClientGoalsByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-goals/{id}/permanent",
    ...options,
  });

/**
 * /workspace-form-configs operation on workspace-form-config resource
 *
 * /workspace-form-configs operation on workspace-form-config resource
 */
export const getAdminWorkspaceFormConfigs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWorkspaceFormConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWorkspaceFormConfigsResponses,
    GetAdminWorkspaceFormConfigsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-form-configs",
    ...options,
  });

/**
 * /workspace-form-configs operation on workspace-form-config resource
 *
 * /workspace-form-configs operation on workspace-form-config resource
 */
export const postAdminWorkspaceFormConfigs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminWorkspaceFormConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminWorkspaceFormConfigsResponses,
    PostAdminWorkspaceFormConfigsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-form-configs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List recipes contributed by a specific contact
 *
 * List recipes contributed by a specific contact
 */
export const getAdminRecipesWorkspaceByWorkspaceIdContactByContactId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesWorkspaceByWorkspaceIdContactByContactIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesWorkspaceByWorkspaceIdContactByContactIdResponses,
    GetAdminRecipesWorkspaceByWorkspaceIdContactByContactIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/workspace/{workspace_id}/contact/{contact_id}",
    ...options,
  });

/**
 * Permanently delete an option type and all its values; cascades to variant_option_values
 *
 * Permanently delete an option type and all its values; cascades to variant_option_values. Use with caution.
 */
export const deleteAdminCatalogOptionTypesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCatalogOptionTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCatalogOptionTypesByIdResponses,
    DeleteAdminCatalogOptionTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/option-types/{id}",
    ...options,
  });

/**
 * /catalog/option-types/:id operation on catalog-option-type resource
 *
 * /catalog/option-types/:id operation on catalog-option-type resource
 */
export const getAdminCatalogOptionTypesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCatalogOptionTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCatalogOptionTypesByIdResponses,
    GetAdminCatalogOptionTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/option-types/{id}",
    ...options,
  });

/**
 * Update the name, slug, or display position of an option type
 *
 * Update the name, slug, or display position of an option type. Returns the updated option type.
 */
export const patchAdminCatalogOptionTypesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCatalogOptionTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogOptionTypesByIdResponses,
    PatchAdminCatalogOptionTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/option-types/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Allocate credits to the tenant's liability account
 *
 * Allocate credits to the tenant's liability account
 */
export const postAdminTenantsByIdCredit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminTenantsByIdCreditData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTenantsByIdCreditResponses,
    PostAdminTenantsByIdCreditErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}/credit",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/rules/:id/deactivate operation on invoices-rule resource
 *
 * /invoices/rules/:id/deactivate operation on invoices-rule resource
 */
export const patchAdminInvoicesRulesByIdDeactivate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesRulesByIdDeactivateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesRulesByIdDeactivateResponses,
    PatchAdminInvoicesRulesByIdDeactivateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/rules/{id}/deactivate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /extraction/chunk-entity-links/chunk/:document_chunk_id operation on chunk-entity-link resource
 *
 * /extraction/chunk-entity-links/chunk/:document_chunk_id operation on chunk-entity-link resource
 */
export const getAdminExtractionChunkEntityLinksChunkByDocumentChunkId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionChunkEntityLinksChunkByDocumentChunkIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionChunkEntityLinksChunkByDocumentChunkIdResponses,
    GetAdminExtractionChunkEntityLinksChunkByDocumentChunkIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/chunk-entity-links/chunk/{document_chunk_id}",
    ...options,
  });

/**
 * Reverse an exclusion: allow a previously excluded document to contribute training examples
 * again
 *
 * Reverse an exclusion: allow a previously excluded document to contribute training examples
 * again. Clears `excluded_from_training`, `excluded_at`, `excluded_by`, and
 * `training_metadata` so the document appears in normal training queries.
 *
 * Side effects: synchronously clears the `document_excluded` flag on all associated
 * `TrainingExample` records, making them eligible for semantic search and few-shot selection.
 *
 * This action is also registered under the `/restore` route as a semantic alias.
 *
 */
export const patchAdminExtractionDocumentsByIdInclude = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminExtractionDocumentsByIdIncludeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionDocumentsByIdIncludeResponses,
    PatchAdminExtractionDocumentsByIdIncludeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}/include",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /customers/:id operation on customer resource
 *
 * /customers/:id operation on customer resource
 */
export const deleteAdminCustomersById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminCustomersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCustomersByIdResponses,
    DeleteAdminCustomersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/customers/{id}",
    ...options,
  });

/**
 * /customers/:id operation on customer resource
 *
 * /customers/:id operation on customer resource
 */
export const getAdminCustomersById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCustomersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCustomersByIdResponses,
    GetAdminCustomersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/customers/{id}",
    ...options,
  });

/**
 * /customers/:id operation on customer resource
 *
 * /customers/:id operation on customer resource
 */
export const patchAdminCustomersById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminCustomersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCustomersByIdResponses,
    PatchAdminCustomersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/customers/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List active (non-deleted) documents in a workspace, sorted by creation date
 *
 * List active (non-deleted) documents in a workspace, sorted by creation date.
 * Optionally filters to a specific batch via `batch_id`. Use this instead of the primary `:read`
 * action when the workspace is known — it applies the workspace and soft-delete filters together.
 *
 */
export const getAdminExtractionDocumentsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdResponses,
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/workspace/{workspace_id}",
    ...options,
  });

/**
 * /clinical/note-templates/:id operation on clinical-note-template resource
 *
 * /clinical/note-templates/:id operation on clinical-note-template resource
 */
export const getAdminClinicalNoteTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalNoteTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNoteTemplatesByIdResponses,
    GetAdminClinicalNoteTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/{id}",
    ...options,
  });

/**
 * /clinical/note-templates/:id operation on clinical-note-template resource
 *
 * /clinical/note-templates/:id operation on clinical-note-template resource
 */
export const patchAdminClinicalNoteTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalNoteTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalNoteTemplatesByIdResponses,
    PatchAdminClinicalNoteTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/deal-products/:id operation on crm-deal-product resource
 *
 * /crm/deal-products/:id operation on crm-deal-product resource
 */
export const deleteAdminCrmDealProductsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmDealProductsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmDealProductsByIdResponses,
    DeleteAdminCrmDealProductsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/deal-products/{id}",
    ...options,
  });

/**
 * /crm/deal-products/:id operation on crm-deal-product resource
 *
 * /crm/deal-products/:id operation on crm-deal-product resource
 */
export const getAdminCrmDealProductsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrmDealProductsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmDealProductsByIdResponses,
    GetAdminCrmDealProductsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/deal-products/{id}",
    ...options,
  });

/**
 * Add a filter rule to a catalog view; rules in the same group are AND'd, multiple groups are OR'd
 *
 * Add a filter rule to a catalog view; rules in the same group are AND'd, multiple groups are OR'd. Returns the created rule.
 */
export const postAdminCatalogViewRules = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCatalogViewRulesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogViewRulesResponses,
    PostAdminCatalogViewRulesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/view-rules",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Owner hides a tenant from their account
 *
 * Owner hides a tenant from their account. Billing and data are unaffected. Reversible via :reactivate.
 */
export const patchAdminTenantsByIdDeactivate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminTenantsByIdDeactivateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTenantsByIdDeactivateResponses,
    PatchAdminTenantsByIdDeactivateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}/deactivate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Permanently delete an agent and cascade-destroy all associated data
 *
 * Permanently delete an agent and cascade-destroy all associated data. Deletes in order:
 * TrainingExamples, TrainingSessions, AgentVersions (which cascade to revisions). Extraction
 * results linked to the agent are cleaned up asynchronously via ON DELETE CASCADE on `agent_id`;
 * extraction documents have their `agent_id` set to NULL and are NOT deleted.
 *
 * This is an irreversible hard delete. Returns the deleted agent struct.
 *
 */
export const deleteAdminAgentsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminAgentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminAgentsByIdResponses,
    DeleteAdminAgentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}",
    ...options,
  });

/**
 * Fetch a single agent by ID
 *
 * Fetch a single agent by ID. Use this for the JSON:API GET route; prefer the primary `:read` for list queries.
 */
export const getAdminAgentsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAgentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentsByIdResponses,
    GetAdminAgentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}",
    ...options,
  });

/**
 * Update agent metadata such as name, description, vertical, tags, and instructions
 *
 * Update agent metadata such as name, description, vertical, tags, and instructions.
 * Does NOT update the schema (fields) or prompt/runtime settings — those live on AgentVersion. Use
 * `:update_schema_version` to modify the active version's schema or prompt.
 *
 * Side effects: records an `:agent_updated` activity event.
 *
 * Returns the updated agent struct.
 *
 */
export const patchAdminAgentsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminAgentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAgentsByIdResponses,
    PatchAdminAgentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Set workspace status to :active (bring live)
 *
 * Set workspace status to :active (bring live)
 */
export const patchAdminWorkspacesByIdGoLive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWorkspacesByIdGoLiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWorkspacesByIdGoLiveResponses,
    PatchAdminWorkspacesByIdGoLiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{id}/go-live",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/templates operation on invoices-template resource
 *
 * /invoices/templates operation on invoices-template resource
 */
export const postAdminInvoicesTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminInvoicesTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminInvoicesTemplatesResponses,
    PostAdminInvoicesTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/templates",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /form-deployments operation on form-deployment resource
 *
 * /form-deployments operation on form-deployment resource
 */
export const getAdminFormDeployments = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminFormDeploymentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFormDeploymentsResponses,
    GetAdminFormDeploymentsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-deployments",
    ...options,
  });

/**
 * /form-deployments operation on form-deployment resource
 *
 * /form-deployments operation on form-deployment resource
 */
export const postAdminFormDeployments = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminFormDeploymentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminFormDeploymentsResponses,
    PostAdminFormDeploymentsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-deployments",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /settlements operation on settlement resource
 *
 * /settlements operation on settlement resource
 */
export const getAdminSettlements = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSettlementsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSettlementsResponses,
    GetAdminSettlementsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlements",
    ...options,
  });

/**
 * /settlements operation on settlement resource
 *
 * /settlements operation on settlement resource
 */
export const postAdminSettlements = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSettlementsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSettlementsResponses,
    PostAdminSettlementsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlements",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /review-queues/:id operation on review-queue resource
 *
 * /review-queues/:id operation on review-queue resource
 */
export const deleteAdminReviewQueuesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminReviewQueuesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminReviewQueuesByIdResponses,
    DeleteAdminReviewQueuesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/review-queues/{id}",
    ...options,
  });

/**
 * /review-queues/:id operation on review-queue resource
 *
 * /review-queues/:id operation on review-queue resource
 */
export const getAdminReviewQueuesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminReviewQueuesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminReviewQueuesByIdResponses,
    GetAdminReviewQueuesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/review-queues/{id}",
    ...options,
  });

/**
 * /review-queues/:id operation on review-queue resource
 *
 * /review-queues/:id operation on review-queue resource
 */
export const patchAdminReviewQueuesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminReviewQueuesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminReviewQueuesByIdResponses,
    PatchAdminReviewQueuesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/review-queues/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/trending/watches/:id/mark-triggered operation on trending-watch resource
 *
 * /social/trending/watches/:id/mark-triggered operation on trending-watch resource
 */
export const patchAdminSocialTrendingWatchesByIdMarkTriggered = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminSocialTrendingWatchesByIdMarkTriggeredData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialTrendingWatchesByIdMarkTriggeredResponses,
    PatchAdminSocialTrendingWatchesByIdMarkTriggeredErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/trending/watches/{id}/mark-triggered",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/inclusions/email/:outbound_email_id operation on email-inclusion resource
 *
 * /email/inclusions/email/:outbound_email_id operation on email-inclusion resource
 */
export const getAdminEmailInclusionsEmailByOutboundEmailId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailInclusionsEmailByOutboundEmailIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailInclusionsEmailByOutboundEmailIdResponses,
    GetAdminEmailInclusionsEmailByOutboundEmailIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inclusions/email/{outbound_email_id}",
    ...options,
  });

/**
 * /connectors/credentials/:id operation on credential resource
 *
 * /connectors/credentials/:id operation on credential resource
 */
export const getAdminConnectorsCredentialsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminConnectorsCredentialsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminConnectorsCredentialsByIdResponses,
    GetAdminConnectorsCredentialsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/credentials/{id}",
    ...options,
  });

/**
 * /pipeline-executions/:id/note operation on pipeline-execution resource
 *
 * /pipeline-executions/:id/note operation on pipeline-execution resource
 */
export const patchAdminPipelineExecutionsByIdNote = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPipelineExecutionsByIdNoteData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPipelineExecutionsByIdNoteResponses,
    PatchAdminPipelineExecutionsByIdNoteErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-executions/{id}/note",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a new extraction batch to group related documents
 *
 * Create a new extraction batch to group related documents. After creating a batch, use
 * `:generate_upload_urls` to get presigned S3 PUT URLs for each file, then upload files
 * directly from the client and call `Document.begin_upload`/`finish_upload` with the
 * returned `batch_id` to associate documents.
 *
 * Returns the created batch with `status: :processing` (no documents yet, so all aggregates
 * are zero and calculated status resolves to `:completed` until documents are added).
 *
 */
export const postAdminExtractionBatches = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminExtractionBatchesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminExtractionBatchesResponses,
    PostAdminExtractionBatchesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/batches",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Refine text based on freeform instructions.
 *
 * Refine text based on freeform instructions.
 */
export const postAdminContentRefine = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminContentRefineData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminContentRefineResponses,
    PostAdminContentRefineErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/content/refine",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /compliance-officer-designations/:id/revoke operation on compliance-officer-designation resource
 *
 * /compliance-officer-designations/:id/revoke operation on compliance-officer-designation resource
 */
export const patchAdminComplianceOfficerDesignationsByIdRevoke = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminComplianceOfficerDesignationsByIdRevokeData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminComplianceOfficerDesignationsByIdRevokeResponses,
    PatchAdminComplianceOfficerDesignationsByIdRevokeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-officer-designations/{id}/revoke",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Clinician approves a draft or unreviewed goal
 *
 * Clinician approves a draft or unreviewed goal. Sets review_status: :approved.
 */
export const patchAdminClinicalClientGoalsByIdApprove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalClientGoalsByIdApproveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientGoalsByIdApproveResponses,
    PatchAdminClinicalClientGoalsByIdApproveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-goals/{id}/approve",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Re-extract document with current or specified schema version
 *
 * Re-extract document with current or specified schema version
 */
export const patchAdminExtractionDocumentsByIdReprocess = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminExtractionDocumentsByIdReprocessData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionDocumentsByIdReprocessResponses,
    PatchAdminExtractionDocumentsByIdReprocessErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}/reprocess",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-resources/categories/catalog operation on clinical-practice-resource-category resource
 *
 * /clinical/practice-resources/categories/catalog operation on clinical-practice-resource-category resource
 */
export const getAdminClinicalPracticeResourcesCategoriesCatalog = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalPracticeResourcesCategoriesCatalogData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeResourcesCategoriesCatalogResponses,
    GetAdminClinicalPracticeResourcesCategoriesCatalogErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/categories/catalog",
    ...options,
  });

/**
 * /clinical/goal-templates/archived operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/archived operation on clinical-goal-template resource
 */
export const getAdminClinicalGoalTemplatesArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalGoalTemplatesArchivedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalTemplatesArchivedResponses,
    GetAdminClinicalGoalTemplatesArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/archived",
    ...options,
  });

/**
 * /compliance-officer-designations operation on compliance-officer-designation resource
 *
 * /compliance-officer-designations operation on compliance-officer-designation resource
 */
export const getAdminComplianceOfficerDesignations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminComplianceOfficerDesignationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminComplianceOfficerDesignationsResponses,
    GetAdminComplianceOfficerDesignationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-officer-designations",
    ...options,
  });

/**
 * /compliance-officer-designations operation on compliance-officer-designation resource
 *
 * /compliance-officer-designations operation on compliance-officer-designation resource
 */
export const postAdminComplianceOfficerDesignations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminComplianceOfficerDesignationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminComplianceOfficerDesignationsResponses,
    PostAdminComplianceOfficerDesignationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-officer-designations",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /workspace-agent-configs/:id operation on workspace-agent-config resource
 *
 * /workspace-agent-configs/:id operation on workspace-agent-config resource
 */
export const deleteAdminWorkspaceAgentConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminWorkspaceAgentConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminWorkspaceAgentConfigsByIdResponses,
    DeleteAdminWorkspaceAgentConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-agent-configs/{id}",
    ...options,
  });

/**
 * /workspace-agent-configs/:id operation on workspace-agent-config resource
 *
 * /workspace-agent-configs/:id operation on workspace-agent-config resource
 */
export const getAdminWorkspaceAgentConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWorkspaceAgentConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWorkspaceAgentConfigsByIdResponses,
    GetAdminWorkspaceAgentConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-agent-configs/{id}",
    ...options,
  });

/**
 * /workspace-agent-configs/:id operation on workspace-agent-config resource
 *
 * /workspace-agent-configs/:id operation on workspace-agent-config resource
 */
export const patchAdminWorkspaceAgentConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWorkspaceAgentConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWorkspaceAgentConfigsByIdResponses,
    PatchAdminWorkspaceAgentConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-agent-configs/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a CRM sync configuration for a workspace+connector pair
 *
 * Create a CRM sync configuration for a workspace+connector pair. One config per
 * workspace+connector_instance_id. When absent, sync runs with default settings
 * (enabled, no PII scan, no auto-create contacts).
 *
 */
export const postAdminCrmSyncConfigs = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrmSyncConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmSyncConfigsResponses,
    PostAdminCrmSyncConfigsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/sync-configs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /claimed-domains/:id/verify operation on claimed-domain resource
 *
 * /claimed-domains/:id/verify operation on claimed-domain resource
 */
export const patchAdminClaimedDomainsByIdVerify = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClaimedDomainsByIdVerifyData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClaimedDomainsByIdVerifyResponses,
    PatchAdminClaimedDomainsByIdVerifyErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/claimed-domains/{id}/verify",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /reviews/:id/claim operation on review resource
 *
 * /reviews/:id/claim operation on review resource
 */
export const patchAdminReviewsByIdClaim = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminReviewsByIdClaimData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminReviewsByIdClaimResponses,
    PatchAdminReviewsByIdClaimErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/reviews/{id}/claim",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /storage-recommendations/:id/dismiss operation on storage-recommendation resource
 *
 * /storage-recommendations/:id/dismiss operation on storage-recommendation resource
 */
export const patchAdminStorageRecommendationsByIdDismiss = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminStorageRecommendationsByIdDismissData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminStorageRecommendationsByIdDismissResponses,
    PatchAdminStorageRecommendationsByIdDismissErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-recommendations/{id}/dismiss",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List active tickets for a workspace, optionally filtered by status, priority, queue, or agent
 *
 * List active tickets for a workspace, optionally filtered by status, priority, queue, or agent. Excludes soft-deleted tickets. Use for queue dashboards and agent ticket lists.
 */
export const getAdminSupportTicketsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSupportTicketsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSupportTicketsWorkspaceByWorkspaceIdResponses,
    GetAdminSupportTicketsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/tickets/workspace/{workspace_id}",
    ...options,
  });

/**
 * Export agent configuration and training examples
 *
 * Export agent configuration and training examples
 */
export const postAdminAgentsByIdExport = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAgentsByIdExportData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentsByIdExportResponses,
    PostAdminAgentsByIdExportErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/export",
    ...options,
  });

/**
 * /settlements/:id/mark-calculated operation on settlement resource
 *
 * /settlements/:id/mark-calculated operation on settlement resource
 */
export const patchAdminSettlementsByIdMarkCalculated = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSettlementsByIdMarkCalculatedData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSettlementsByIdMarkCalculatedResponses,
    PatchAdminSettlementsByIdMarkCalculatedErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlements/{id}/mark-calculated",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/metrics/post/:social_post_id operation on post-metric resource
 *
 * /social/metrics/post/:social_post_id operation on post-metric resource
 */
export const getAdminSocialMetricsPostBySocialPostId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSocialMetricsPostBySocialPostIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSocialMetricsPostBySocialPostIdResponses,
    GetAdminSocialMetricsPostBySocialPostIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/metrics/post/{social_post_id}",
    ...options,
  });

/**
 * /search/saved/:id operation on saved-search resource
 *
 * /search/saved/:id operation on saved-search resource
 */
export const deleteAdminSearchSavedById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSearchSavedByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSearchSavedByIdResponses,
    DeleteAdminSearchSavedByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/saved/{id}",
    ...options,
  });

/**
 * Modify the name, query string, search type, filters, or sharing status of an existing saved search
 *
 * Modify the name, query string, search type, filters, or sharing status of an existing saved search. Only the owning user can update their own saved searches. Validates the filters map for allowed keys (document_types, date_from, date_to, workspace_ids, tags). Returns the updated SavedSearch.
 */
export const patchAdminSearchSavedById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminSearchSavedByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSearchSavedByIdResponses,
    PatchAdminSearchSavedByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/saved/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Suggest content topics based on industry and audience.
 *
 * Suggest content topics based on industry and audience.
 */
export const postAdminContentSuggestTopics = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminContentSuggestTopicsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminContentSuggestTopicsResponses,
    PostAdminContentSuggestTopicsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/content/suggest-topics",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /pipeline-executions/:id operation on pipeline-execution resource
 *
 * /pipeline-executions/:id operation on pipeline-execution resource
 */
export const getAdminPipelineExecutionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPipelineExecutionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPipelineExecutionsByIdResponses,
    GetAdminPipelineExecutionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-executions/{id}",
    ...options,
  });

/**
 * Allocates promotional credits to a specific tenant on behalf of the application
 *
 * Allocates promotional credits to a specific tenant on behalf of the application
 */
export const patchAdminApplicationsByIdGrantCredits = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminApplicationsByIdGrantCreditsData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminApplicationsByIdGrantCreditsResponses,
    PatchAdminApplicationsByIdGrantCreditsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/{id}/grant-credits",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Transition a pending_upload file to active after the client has uploaded to the presigned URL; optionally stamps size_bytes and checksum.
 *
 * Transition a pending_upload file to active after the client has uploaded to the presigned URL; optionally stamps size_bytes and checksum.
 */
export const patchAdminStorageFilesByIdConfirmUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminStorageFilesByIdConfirmUploadData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminStorageFilesByIdConfirmUploadResponses,
    PatchAdminStorageFilesByIdConfirmUploadErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-files/{id}/confirm-upload",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /transfers/:id operation on transfer resource
 *
 * /transfers/:id operation on transfer resource
 */
export const getAdminTransfersById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminTransfersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTransfersByIdResponses,
    GetAdminTransfersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/transfers/{id}",
    ...options,
  });

/**
 * /form-versions/:id/protection-class operation on form-version resource
 *
 * /form-versions/:id/protection-class operation on form-version resource
 */
export const getAdminFormVersionsByIdProtectionClass = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminFormVersionsByIdProtectionClassData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFormVersionsByIdProtectionClassResponses,
    GetAdminFormVersionsByIdProtectionClassErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-versions/{id}/protection-class",
    ...options,
  });

/**
 * /platform-pricing-configs operation on platform-pricing-config resource
 *
 * /platform-pricing-configs operation on platform-pricing-config resource
 */
export const getAdminPlatformPricingConfigs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPlatformPricingConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPlatformPricingConfigsResponses,
    GetAdminPlatformPricingConfigsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/platform-pricing-configs",
    ...options,
  });

/**
 * /platform-pricing-configs operation on platform-pricing-config resource
 *
 * /platform-pricing-configs operation on platform-pricing-config resource
 */
export const postAdminPlatformPricingConfigs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminPlatformPricingConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPlatformPricingConfigsResponses,
    PostAdminPlatformPricingConfigsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/platform-pricing-configs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/goal-templates/catalog operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/catalog operation on clinical-goal-template resource
 */
export const getAdminClinicalGoalTemplatesCatalog = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalGoalTemplatesCatalogData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalTemplatesCatalogResponses,
    GetAdminClinicalGoalTemplatesCatalogErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/catalog",
    ...options,
  });

/**
 * /clinical/goal-templates/catalog operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/catalog operation on clinical-goal-template resource
 */
export const postAdminClinicalGoalTemplatesCatalog = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalGoalTemplatesCatalogData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalGoalTemplatesCatalogResponses,
    PostAdminClinicalGoalTemplatesCatalogErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/catalog",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /policy-review-schedules/:id/complete-review operation on policy-review-schedule resource
 *
 * /policy-review-schedules/:id/complete-review operation on policy-review-schedule resource
 */
export const patchAdminPolicyReviewSchedulesByIdCompleteReview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminPolicyReviewSchedulesByIdCompleteReviewData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminPolicyReviewSchedulesByIdCompleteReviewResponses,
    PatchAdminPolicyReviewSchedulesByIdCompleteReviewErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/policy-review-schedules/{id}/complete-review",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Cancel an active add-on subscription on the wallet
 *
 * Cancel an active add-on subscription on the wallet. Cancellation takes effect
 * immediately — the add-on is removed from the active add-ons list on return.
 * Any remaining credits associated with the add-on are not refunded.
 *
 * Use :buy_addon to purchase or top up an add-on. Returns the updated wallet
 * with the cancelled add-on removed from the addons list.
 *
 */
export const patchAdminWalletAddonsByAddonSlugCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWalletAddonsByAddonSlugCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWalletAddonsByAddonSlugCancelResponses,
    PatchAdminWalletAddonsByAddonSlugCancelErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/addons/{addon_slug}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /campaigns/sequences/workspace/:workspace_id operation on email-marketing-sequence resource
 *
 * /campaigns/sequences/workspace/:workspace_id operation on email-marketing-sequence resource
 */
export const getAdminCampaignsSequencesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCampaignsSequencesWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCampaignsSequencesWorkspaceByWorkspaceIdResponses,
    GetAdminCampaignsSequencesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequences/workspace/{workspace_id}",
    ...options,
  });

/**
 * /email/inbound-addresses operation on email-inbound-address resource
 *
 * /email/inbound-addresses operation on email-inbound-address resource
 */
export const postAdminEmailInboundAddresses = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminEmailInboundAddressesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminEmailInboundAddressesResponses,
    PostAdminEmailInboundAddressesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inbound-addresses",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch a single event by ID
 *
 * Fetch a single event by ID. Returns full event with location embed, recurrence data, and organizer info.
 */
export const getAdminSchedulingEventsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingEventsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingEventsByIdResponses,
    GetAdminSchedulingEventsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/events/{id}",
    ...options,
  });

/**
 * Update event metadata: title, description, timezone, location, notes, or custom metadata
 *
 * Update event metadata: title, description, timezone, location, notes, or custom metadata. Does not change time — use :reschedule for that. Re-indexes in Meilisearch.
 */
export const patchAdminSchedulingEventsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSchedulingEventsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingEventsByIdResponses,
    PatchAdminSchedulingEventsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/events/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Manually trigger a scheduled crawl immediately.
 *
 * Manually trigger a scheduled crawl immediately.
 */
export const patchAdminCrawlerSchedulesByIdTrigger = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrawlerSchedulesByIdTriggerData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrawlerSchedulesByIdTriggerResponses,
    PatchAdminCrawlerSchedulesByIdTriggerErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/schedules/{id}/trigger",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List LLM analytics records sorted by created_at descending; scoped to the caller's tenant.
 *
 * List LLM analytics records sorted by created_at descending; scoped to the caller's tenant.
 */
export const getAdminLlmAnalytics = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminLlmAnalyticsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLlmAnalyticsResponses,
    GetAdminLlmAnalyticsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/llm-analytics",
    ...options,
  });

/**
 * Append a single LLM call analytics record (model, tokens, latency, cost); called by the billing/analytics pipeline after each LLM invocation
 *
 * Append a single LLM call analytics record (model, tokens, latency, cost); called by the billing/analytics pipeline after each LLM invocation. Returns the created record.
 */
export const postAdminLlmAnalytics = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminLlmAnalyticsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminLlmAnalyticsResponses,
    PostAdminLlmAnalyticsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/llm-analytics",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List tags for an application
 *
 * List tags for an application
 */
export const getAdminRecipesTagsApplicationByApplicationId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesTagsApplicationByApplicationIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesTagsApplicationByApplicationIdResponses,
    GetAdminRecipesTagsApplicationByApplicationIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/tags/application/{application_id}",
    ...options,
  });

/**
 * /clinical/practice-tools/catalog/:id operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/catalog/:id operation on clinical-practice-tool resource
 */
export const getAdminClinicalPracticeToolsCatalogById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPracticeToolsCatalogByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeToolsCatalogByIdResponses,
    GetAdminClinicalPracticeToolsCatalogByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/catalog/{id}",
    ...options,
  });

/**
 * /clinical/practice-tools/catalog/:id operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/catalog/:id operation on clinical-practice-tool resource
 */
export const patchAdminClinicalPracticeToolsCatalogById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalPracticeToolsCatalogByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPracticeToolsCatalogByIdResponses,
    PatchAdminClinicalPracticeToolsCatalogByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/catalog/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a taxonomy node (category) at the given position in the tree; validates hierarchy depth
 *
 * Create a taxonomy node (category) at the given position in the tree; validates hierarchy depth. Returns the created node.
 */
export const postAdminCatalogTaxonomyNodes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCatalogTaxonomyNodesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogTaxonomyNodesResponses,
    PostAdminCatalogTaxonomyNodesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/taxonomy-nodes",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List events that include a specific participant by email, scoped to the workspace
 *
 * List events that include a specific participant by email, scoped to the workspace. Use to show a contact's meeting history.
 */
export const getAdminSchedulingEventsByParticipant = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingEventsByParticipantData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingEventsByParticipantResponses,
    GetAdminSchedulingEventsByParticipantErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/events/by_participant",
    ...options,
  });

/**
 * /settlements/:id operation on settlement resource
 *
 * /settlements/:id operation on settlement resource
 */
export const getAdminSettlementsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSettlementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSettlementsByIdResponses,
    GetAdminSettlementsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlements/{id}",
    ...options,
  });

/**
 * /settlements/:id operation on settlement resource
 *
 * /settlements/:id operation on settlement resource
 */
export const patchAdminSettlementsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminSettlementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSettlementsByIdResponses,
    PatchAdminSettlementsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlements/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Restore the agent to a previously used version by activating it
 *
 * Restore the agent to a previously used version by activating it. This deactivates the
 * currently active version and sets the target version as active. Use this to roll back after
 * a bad schema or prompt change. The restored version becomes the new active version used for
 * all subsequent document processing.
 *
 * Returns a map with the activated version data.
 *
 */
export const postAdminAgentsByIdRestoreVersion = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminAgentsByIdRestoreVersionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentsByIdRestoreVersionResponses,
    PostAdminAgentsByIdRestoreVersionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/restore-version",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/supplement-templates/from-existing operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/from-existing operation on clinical-supplement-template resource
 */
export const postAdminClinicalSupplementTemplatesFromExisting = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminClinicalSupplementTemplatesFromExistingData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminClinicalSupplementTemplatesFromExistingResponses,
    PostAdminClinicalSupplementTemplatesFromExistingErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/from-existing",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Full-text search threads by title or context summary within the actor's accessible workspace
 *
 * Full-text search threads by title or context summary within the actor's accessible workspace. Use Message.semantic_search for vector-based message content search.
 */
export const getAdminThreadsSearch = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminThreadsSearchData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminThreadsSearchResponses,
    GetAdminThreadsSearchErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/search",
    ...options,
  });

/**
 * /clinical/practice-resources/:id operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/:id operation on clinical-practice-resource resource
 */
export const getAdminClinicalPracticeResourcesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPracticeResourcesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeResourcesByIdResponses,
    GetAdminClinicalPracticeResourcesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/{id}",
    ...options,
  });

/**
 * /clinical/practice-resources/:id operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/:id operation on clinical-practice-resource resource
 */
export const patchAdminClinicalPracticeResourcesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalPracticeResourcesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPracticeResourcesByIdResponses,
    PatchAdminClinicalPracticeResourcesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List training examples for this agent
 *
 * List training examples for this agent
 */
export const getAdminAgentsByIdTrainingExamples = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAgentsByIdTrainingExamplesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentsByIdTrainingExamplesResponses,
    GetAdminAgentsByIdTrainingExamplesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/training-examples",
    ...options,
  });

/**
 * /recipes/scheduled-meals operation on recipes-scheduled-meal resource
 *
 * /recipes/scheduled-meals operation on recipes-scheduled-meal resource
 */
export const postAdminRecipesScheduledMeals = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminRecipesScheduledMealsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesScheduledMealsResponses,
    PostAdminRecipesScheduledMealsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/scheduled-meals",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List favorites for a workspace
 *
 * List favorites for a workspace
 */
export const getAdminRecipesFavoritesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesFavoritesWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesFavoritesWorkspaceByWorkspaceIdResponses,
    GetAdminRecipesFavoritesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/favorites/workspace/{workspace_id}",
    ...options,
  });

/**
 * Change password for authenticated user with current password verification
 *
 * Change password for authenticated user with current password verification. By default revokes other active sessions.
 */
export const patchAdminUsersAuthPasswordChange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminUsersAuthPasswordChangeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminUsersAuthPasswordChangeResponses,
    PatchAdminUsersAuthPasswordChangeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/auth/password/change",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Permanently delete a catalog view and its rules and overrides
 *
 * Permanently delete a catalog view and its rules and overrides. Prefer setting status to :archived to retain history.
 */
export const deleteAdminCatalogViewsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCatalogViewsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCatalogViewsByIdResponses,
    DeleteAdminCatalogViewsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/views/{id}",
    ...options,
  });

/**
 * /catalog/views/:id operation on catalog-view resource
 *
 * /catalog/views/:id operation on catalog-view resource
 */
export const getAdminCatalogViewsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCatalogViewsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCatalogViewsByIdResponses,
    GetAdminCatalogViewsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/views/{id}",
    ...options,
  });

/**
 * Update view metadata, filtering rules, or pricing association
 *
 * Update view metadata, filtering rules, or pricing association. Returns the updated view.
 */
export const patchAdminCatalogViewsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCatalogViewsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogViewsByIdResponses,
    PatchAdminCatalogViewsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/views/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Mark this website as primary and unset any other primary website for the same entity.
 *
 * Mark this website as primary and unset any other primary website for the same entity.
 */
export const patchAdminCrmWebsitesByIdSetPrimary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmWebsitesByIdSetPrimaryData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmWebsitesByIdSetPrimaryResponses,
    PatchAdminCrmWebsitesByIdSetPrimaryErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/websites/{id}/set-primary",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Soft-delete a variant by setting deleted_at; excluded from future reads
 *
 * Soft-delete a variant by setting deleted_at; excluded from future reads. Prefer archiving via status update to preserve audit history.
 */
export const deleteAdminCatalogProductVariantsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCatalogProductVariantsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCatalogProductVariantsByIdResponses,
    DeleteAdminCatalogProductVariantsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/product-variants/{id}",
    ...options,
  });

/**
 * /catalog/product-variants/:id operation on catalog-product-variant resource
 *
 * /catalog/product-variants/:id operation on catalog-product-variant resource
 */
export const getAdminCatalogProductVariantsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCatalogProductVariantsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCatalogProductVariantsByIdResponses,
    GetAdminCatalogProductVariantsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/product-variants/{id}",
    ...options,
  });

/**
 * Update a variant's SKU, pricing, properties, or media
 *
 * Update a variant's SKU, pricing, properties, or media. Returns the updated variant.
 */
export const patchAdminCatalogProductVariantsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCatalogProductVariantsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogProductVariantsByIdResponses,
    PatchAdminCatalogProductVariantsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/product-variants/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /tenant-pricing-overrides/:id operation on tenant-pricing-override resource
 *
 * /tenant-pricing-overrides/:id operation on tenant-pricing-override resource
 */
export const deleteAdminTenantPricingOverridesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminTenantPricingOverridesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminTenantPricingOverridesByIdResponses,
    DeleteAdminTenantPricingOverridesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenant-pricing-overrides/{id}",
    ...options,
  });

/**
 * /tenant-pricing-overrides/:id operation on tenant-pricing-override resource
 *
 * /tenant-pricing-overrides/:id operation on tenant-pricing-override resource
 */
export const getAdminTenantPricingOverridesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminTenantPricingOverridesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTenantPricingOverridesByIdResponses,
    GetAdminTenantPricingOverridesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenant-pricing-overrides/{id}",
    ...options,
  });

/**
 * /tenant-pricing-overrides/:id operation on tenant-pricing-override resource
 *
 * /tenant-pricing-overrides/:id operation on tenant-pricing-override resource
 */
export const patchAdminTenantPricingOverridesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminTenantPricingOverridesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTenantPricingOverridesByIdResponses,
    PatchAdminTenantPricingOverridesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenant-pricing-overrides/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/campaigns/:id operation on campaign resource
 *
 * /email-marketing/campaigns/:id operation on campaign resource
 */
export const deleteAdminEmailMarketingCampaignsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminEmailMarketingCampaignsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminEmailMarketingCampaignsByIdResponses,
    DeleteAdminEmailMarketingCampaignsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/campaigns/{id}",
    ...options,
  });

/**
 * /email-marketing/campaigns/:id operation on campaign resource
 *
 * /email-marketing/campaigns/:id operation on campaign resource
 */
export const getAdminEmailMarketingCampaignsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminEmailMarketingCampaignsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEmailMarketingCampaignsByIdResponses,
    GetAdminEmailMarketingCampaignsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/campaigns/{id}",
    ...options,
  });

/**
 * /email-marketing/campaigns/:id operation on campaign resource
 *
 * /email-marketing/campaigns/:id operation on campaign resource
 */
export const patchAdminEmailMarketingCampaignsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminEmailMarketingCampaignsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingCampaignsByIdResponses,
    PatchAdminEmailMarketingCampaignsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/campaigns/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all SLA policies for an application
 *
 * List all SLA policies for an application. Use to populate the SLA policy selector on Queue create/update and Ticket create.
 */
export const getAdminSupportSlaPoliciesApplicationByApplicationId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSupportSlaPoliciesApplicationByApplicationIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSupportSlaPoliciesApplicationByApplicationIdResponses,
    GetAdminSupportSlaPoliciesApplicationByApplicationIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/sla-policies/application/{application_id}",
    ...options,
  });

/**
 * /catalog/variant-option-values/:id operation on catalog-variant-option-value resource
 *
 * /catalog/variant-option-values/:id operation on catalog-variant-option-value resource
 */
export const deleteAdminCatalogVariantOptionValuesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCatalogVariantOptionValuesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCatalogVariantOptionValuesByIdResponses,
    DeleteAdminCatalogVariantOptionValuesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/variant-option-values/{id}",
    ...options,
  });

/**
 * /clinical/patient-insurance operation on clinical-patient-insurance resource
 *
 * /clinical/patient-insurance operation on clinical-patient-insurance resource
 */
export const getAdminClinicalPatientInsurance = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPatientInsuranceData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPatientInsuranceResponses,
    GetAdminClinicalPatientInsuranceErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patient-insurance",
    ...options,
  });

/**
 * /clinical/patient-insurance operation on clinical-patient-insurance resource
 *
 * /clinical/patient-insurance operation on clinical-patient-insurance resource
 */
export const postAdminClinicalPatientInsurance = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalPatientInsuranceData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalPatientInsuranceResponses,
    PostAdminClinicalPatientInsuranceErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patient-insurance",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Register a new user account with email and password
 *
 * Register a new user account with email and password. Validates password
 * confirmation and accepted legal documents. Creates a personal tenant, default
 * workspace, billing account, and user profile via HandleRegistrationContext.
 * Sends a confirmation email; the account cannot use scoped API actions until
 * confirmed (unless require_email_verification is false on the Application).
 *
 * Use :register_via_invitation when the user has an invitation token, or
 * :register_with_oidc for OAuth/SSO flows.
 *
 * Returns the created user with a JWT token in the token field if
 * sign_in_tokens_enabled? is true, otherwise token is nil.
 *
 */
export const postAdminUsersAuthRegister = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminUsersAuthRegisterData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminUsersAuthRegisterResponses,
    PostAdminUsersAuthRegisterErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/auth/register",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /webhook-deliveries/:id operation on webhook-delivery resource
 *
 * /webhook-deliveries/:id operation on webhook-delivery resource
 */
export const getAdminWebhookDeliveriesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWebhookDeliveriesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWebhookDeliveriesByIdResponses,
    GetAdminWebhookDeliveriesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-deliveries/{id}",
    ...options,
  });

/**
 * /clinical/practice-resources/:id/restore operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/:id/restore operation on clinical-practice-resource resource
 */
export const patchAdminClinicalPracticeResourcesByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalPracticeResourcesByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPracticeResourcesByIdRestoreResponses,
    PatchAdminClinicalPracticeResourcesByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a new social profile for a contact or company
 *
 * Create a new social profile for a contact or company. Validates URL format if provided. Only one profile per platform per entity (except :other).
 */
export const postAdminCrmSocialProfiles = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCrmSocialProfilesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmSocialProfilesResponses,
    PostAdminCrmSocialProfilesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/social-profiles",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/goal-templates operation on clinical-goal-template resource
 *
 * /clinical/goal-templates operation on clinical-goal-template resource
 */
export const getAdminClinicalGoalTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalGoalTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalTemplatesResponses,
    GetAdminClinicalGoalTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates",
    ...options,
  });

/**
 * /clinical/goal-templates operation on clinical-goal-template resource
 *
 * /clinical/goal-templates operation on clinical-goal-template resource
 */
export const postAdminClinicalGoalTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalGoalTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalGoalTemplatesResponses,
    PostAdminClinicalGoalTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Returns the current signup-grant state for the wholesale agreement
 *
 * Returns the current signup-grant state for the wholesale agreement.
 * Includes the most recent `PlatformUsageEvent` row matching
 * `operation_type == "signup_grant"` for the ISV-tenant, when present.
 *
 */
export const getAdminWholesaleAgreementsByIdSignupGrantStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminWholesaleAgreementsByIdSignupGrantStatusData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminWholesaleAgreementsByIdSignupGrantStatusResponses,
    GetAdminWholesaleAgreementsByIdSignupGrantStatusErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wholesale-agreements/{id}/signup-grant-status",
    ...options,
  });

/**
 * Restore an archived thread by clearing `archived_at`, making it visible in the default thread list again.
 *
 * Restore an archived thread by clearing `archived_at`, making it visible in the default thread list again.
 */
export const patchAdminThreadsByIdUnarchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminThreadsByIdUnarchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminThreadsByIdUnarchiveResponses,
    PatchAdminThreadsByIdUnarchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/{id}/unarchive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List treatment plans for a Fullscript patient
 *
 * List treatment plans for a Fullscript patient
 */
export const postAdminConnectorsFullscriptTreatmentPlansList = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsFullscriptTreatmentPlansListData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsFullscriptTreatmentPlansListResponses,
    PostAdminConnectorsFullscriptTreatmentPlansListErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/fullscript/treatment-plans/list",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Activate a specific schema version
 *
 * Activate a specific schema version
 */
export const postAdminAgentsByIdSchemaVersionsByVersionIdActivate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminAgentsByIdSchemaVersionsByVersionIdActivateData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminAgentsByIdSchemaVersionsByVersionIdActivateResponses,
    PostAdminAgentsByIdSchemaVersionsByVersionIdActivateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/schema-versions/{version_id}/activate",
    ...options,
  });

/**
 * List locations filtered by type (:venue, :room, :virtual, :resource)
 *
 * List locations filtered by type (:venue, :room, :virtual, :resource). Use to populate type-specific dropdowns in booking UIs or to find meeting rooms vs. virtual links.
 */
export const getAdminSchedulingLocationsByType = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingLocationsByTypeData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingLocationsByTypeResponses,
    GetAdminSchedulingLocationsByTypeErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/locations/by-type",
    ...options,
  });

/**
 * List all locations for a workspace (both active and inactive)
 *
 * List all locations for a workspace (both active and inactive). Use :list_by_type to filter by venue type.
 */
export const getAdminSchedulingLocations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingLocationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingLocationsResponses,
    GetAdminSchedulingLocationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/locations",
    ...options,
  });

/**
 * Create a reusable location record (venue, room, virtual link, or resource)
 *
 * Create a reusable location record (venue, room, virtual link, or resource). Location data is copied into LocationEmbed on Event/EventType via CopyLocationToEmbed change at write time. Returns the created Location.
 */
export const postAdminSchedulingLocations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSchedulingLocationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSchedulingLocationsResponses,
    PostAdminSchedulingLocationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/locations",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /contract-clauses/:id operation on contract-clause resource
 *
 * /contract-clauses/:id operation on contract-clause resource
 */
export const getAdminContractClausesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminContractClausesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminContractClausesByIdResponses,
    GetAdminContractClausesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/contract-clauses/{id}",
    ...options,
  });

/**
 * /clinical/note-templates/catalog/archived operation on clinical-note-template resource
 *
 * /clinical/note-templates/catalog/archived operation on clinical-note-template resource
 */
export const getAdminClinicalNoteTemplatesCatalogArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalNoteTemplatesCatalogArchivedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNoteTemplatesCatalogArchivedResponses,
    GetAdminClinicalNoteTemplatesCatalogArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/catalog/archived",
    ...options,
  });

/**
 * /recipes/meal-schedules/:id operation on recipes-meal-schedule resource
 *
 * /recipes/meal-schedules/:id operation on recipes-meal-schedule resource
 */
export const deleteAdminRecipesMealSchedulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminRecipesMealSchedulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRecipesMealSchedulesByIdResponses,
    DeleteAdminRecipesMealSchedulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/meal-schedules/{id}",
    ...options,
  });

/**
 * /recipes/meal-schedules/:id operation on recipes-meal-schedule resource
 *
 * /recipes/meal-schedules/:id operation on recipes-meal-schedule resource
 */
export const getAdminRecipesMealSchedulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesMealSchedulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesMealSchedulesByIdResponses,
    GetAdminRecipesMealSchedulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/meal-schedules/{id}",
    ...options,
  });

/**
 * /recipes/meal-schedules/:id operation on recipes-meal-schedule resource
 *
 * /recipes/meal-schedules/:id operation on recipes-meal-schedule resource
 */
export const patchAdminRecipesMealSchedulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRecipesMealSchedulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesMealSchedulesByIdResponses,
    PatchAdminRecipesMealSchedulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/meal-schedules/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /extraction/schema-discoveries/:id operation on schema-discovery resource
 *
 * /extraction/schema-discoveries/:id operation on schema-discovery resource
 */
export const getAdminExtractionSchemaDiscoveriesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionSchemaDiscoveriesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionSchemaDiscoveriesByIdResponses,
    GetAdminExtractionSchemaDiscoveriesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/schema-discoveries/{id}",
    ...options,
  });

/**
 * Hard-delete a calendar sync configuration, stopping all future sync runs for this calendar
 *
 * Hard-delete a calendar sync configuration, stopping all future sync runs for this calendar. Oban jobs for this sync will still complete their current run before stopping.
 */
export const deleteAdminSchedulingCalendarSyncsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSchedulingCalendarSyncsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSchedulingCalendarSyncsByIdResponses,
    DeleteAdminSchedulingCalendarSyncsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/calendar-syncs/{id}",
    ...options,
  });

/**
 * Fetch a single calendar sync configuration by ID
 *
 * Fetch a single calendar sync configuration by ID. sync_token is excluded (sensitive? true) — never returned in API responses.
 */
export const getAdminSchedulingCalendarSyncsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingCalendarSyncsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingCalendarSyncsByIdResponses,
    GetAdminSchedulingCalendarSyncsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/calendar-syncs/{id}",
    ...options,
  });

/**
 * Update calendar sync settings: name, direction, role, sync_method, poll interval, or custom metadata
 *
 * Update calendar sync settings: name, direction, role, sync_method, poll interval, or custom metadata. Use :pause/:resume to control sync_status — sync_status cannot be changed via :update.
 */
export const patchAdminSchedulingCalendarSyncsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSchedulingCalendarSyncsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingCalendarSyncsByIdResponses,
    PatchAdminSchedulingCalendarSyncsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/calendar-syncs/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/:id/schedule-payment operation on invoices-invoice resource
 *
 * /invoices/:id/schedule-payment operation on invoices-invoice resource
 */
export const patchAdminInvoicesByIdSchedulePayment = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesByIdSchedulePaymentData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesByIdSchedulePaymentResponses,
    PatchAdminInvoicesByIdSchedulePaymentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}/schedule-payment",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /case-document-links operation on case-document-link resource
 *
 * /case-document-links operation on case-document-link resource
 */
export const getAdminCaseDocumentLinks = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCaseDocumentLinksData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCaseDocumentLinksResponses,
    GetAdminCaseDocumentLinksErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-document-links",
    ...options,
  });

/**
 * /case-document-links operation on case-document-link resource
 *
 * /case-document-links operation on case-document-link resource
 */
export const postAdminCaseDocumentLinks = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCaseDocumentLinksData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCaseDocumentLinksResponses,
    PostAdminCaseDocumentLinksErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-document-links",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List disclosures for a specific data subject (HIPAA accounting of disclosures).
 *
 * List disclosures for a specific data subject (HIPAA accounting of disclosures).
 */
export const getAdminDisclosureLogsBySubject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminDisclosureLogsBySubjectData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminDisclosureLogsBySubjectResponses,
    GetAdminDisclosureLogsBySubjectErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/disclosure-logs/by-subject",
    ...options,
  });

/**
 * /crawler/results operation on crawler-result resource
 *
 * /crawler/results operation on crawler-result resource
 */
export const getAdminCrawlerResults = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCrawlerResultsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerResultsResponses,
    GetAdminCrawlerResultsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/results",
    ...options,
  });

/**
 * List all registered permissions from the PermissionRegistry, optionally filtered by app, context, or category
 *
 * List all registered permissions from the PermissionRegistry, optionally filtered by app, context, or category. Returns permission structs for use in role builder and permission picker UIs.
 */
export const getAdminPermissions = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPermissionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPermissionsResponses,
    GetAdminPermissionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/permissions",
    ...options,
  });

/**
 * Restore an archived file back to active status so it becomes accessible again.
 *
 * Restore an archived file back to active status so it becomes accessible again.
 */
export const patchAdminStorageFilesByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminStorageFilesByIdRestoreData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminStorageFilesByIdRestoreResponses,
    PatchAdminStorageFilesByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-files/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/notes/by-patient operation on clinical-note resource
 *
 * /clinical/notes/by-patient operation on clinical-note resource
 */
export const getAdminClinicalNotesByPatient = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalNotesByPatientData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNotesByPatientResponses,
    GetAdminClinicalNotesByPatientErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes/by-patient",
    ...options,
  });

/**
 * /email/send-limits/:id operation on email-send-limit resource
 *
 * /email/send-limits/:id operation on email-send-limit resource
 */
export const getAdminEmailSendLimitsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminEmailSendLimitsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEmailSendLimitsByIdResponses,
    GetAdminEmailSendLimitsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/send-limits/{id}",
    ...options,
  });

/**
 * Disable a schedule to pause automatic crawling without deleting the configuration.
 *
 * Disable a schedule to pause automatic crawling without deleting the configuration.
 */
export const patchAdminCrawlerSchedulesByIdDisable = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrawlerSchedulesByIdDisableData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrawlerSchedulesByIdDisableResponses,
    PatchAdminCrawlerSchedulesByIdDisableErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/schedules/{id}/disable",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/supplement-templates/:id/restore operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/:id/restore operation on clinical-supplement-template resource
 */
export const patchAdminClinicalSupplementTemplatesByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalSupplementTemplatesByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalSupplementTemplatesByIdRestoreResponses,
    PatchAdminClinicalSupplementTemplatesByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-supplements/:id/restore operation on clinical-client-supplement resource
 *
 * /clinical/client-supplements/:id/restore operation on clinical-client-supplement resource
 */
export const patchAdminClinicalClientSupplementsByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalClientSupplementsByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientSupplementsByIdRestoreResponses,
    PatchAdminClinicalClientSupplementsByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-supplements/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-tools/:id/restore operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/:id/restore operation on clinical-practice-tool resource
 */
export const patchAdminClinicalPracticeToolsByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalPracticeToolsByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPracticeToolsByIdRestoreResponses,
    PatchAdminClinicalPracticeToolsByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Permanently delete an API key record
 *
 * Permanently delete an API key record. Invalidates the Redis auth cache entry.
 * Use :revoke instead when you want to deactivate a key while preserving the audit
 * trail and reclaiming unused credits back to the tenant wallet.
 *
 */
export const deleteAdminApiKeysById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminApiKeysByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminApiKeysByIdResponses,
    DeleteAdminApiKeysByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/api-keys/{id}",
    ...options,
  });

/**
 * List or fetch API keys
 *
 * List or fetch API keys. Supports keyset and offset pagination. Returns keys
 * scoped to the actor — users see only their own keys, ISV owners see keys for
 * their application. Use :active to restrict to non-revoked keys, or :usage_stats
 * for tenant-scoped usage analytics.
 *
 */
export const getAdminApiKeysById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminApiKeysByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminApiKeysByIdResponses,
    GetAdminApiKeysByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/api-keys/{id}",
    ...options,
  });

/**
 * Update mutable API key properties: name, scopes, rate limit, and credit limit
 *
 * Update mutable API key properties: name, scopes, rate limit, and credit limit.
 * Server keys require at least one scope; application keys always receive all
 * available scopes regardless of the provided value. Invalidates the Redis auth
 * cache on success.
 *
 */
export const patchAdminApiKeysById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminApiKeysByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminApiKeysByIdResponses,
    PatchAdminApiKeysByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/api-keys/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Restore an archived contact (clears deleted_at)
 *
 * Restore an archived contact (clears deleted_at)
 */
export const postAdminCrmContactsByIdUnarchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCrmContactsByIdUnarchiveData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmContactsByIdUnarchiveResponses,
    PostAdminCrmContactsByIdUnarchiveErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/contacts/{id}/unarchive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /ephi-data-flows/:id operation on ephi-data-flow resource
 *
 * /ephi-data-flows/:id operation on ephi-data-flow resource
 */
export const getAdminEphiDataFlowsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminEphiDataFlowsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEphiDataFlowsByIdResponses,
    GetAdminEphiDataFlowsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ephi-data-flows/{id}",
    ...options,
  });

/**
 * /ephi-data-flows/:id operation on ephi-data-flow resource
 *
 * /ephi-data-flows/:id operation on ephi-data-flow resource
 */
export const patchAdminEphiDataFlowsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminEphiDataFlowsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminEphiDataFlowsByIdResponses,
    PatchAdminEphiDataFlowsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ephi-data-flows/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-tools/archived operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/archived operation on clinical-practice-tool resource
 */
export const getAdminClinicalPracticeToolsArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPracticeToolsArchivedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeToolsArchivedResponses,
    GetAdminClinicalPracticeToolsArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/archived",
    ...options,
  });

/**
 * Advance a risk assessment through its lifecycle (draft → in_review → approved → expired) and record the reviewer and approval timestamp.
 *
 * Advance a risk assessment through its lifecycle (draft → in_review → approved → expired) and record the reviewer and approval timestamp.
 */
export const patchAdminRiskAssessmentsByIdStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRiskAssessmentsByIdStatusData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRiskAssessmentsByIdStatusResponses,
    PatchAdminRiskAssessmentsByIdStatusErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/risk-assessments/{id}/status",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/shopping-list-items/:id operation on recipes-shopping-list-item resource
 *
 * /recipes/shopping-list-items/:id operation on recipes-shopping-list-item resource
 */
export const deleteAdminRecipesShoppingListItemsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminRecipesShoppingListItemsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRecipesShoppingListItemsByIdResponses,
    DeleteAdminRecipesShoppingListItemsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/shopping-list-items/{id}",
    ...options,
  });

/**
 * /recipes/shopping-list-items/:id operation on recipes-shopping-list-item resource
 *
 * /recipes/shopping-list-items/:id operation on recipes-shopping-list-item resource
 */
export const getAdminRecipesShoppingListItemsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesShoppingListItemsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesShoppingListItemsByIdResponses,
    GetAdminRecipesShoppingListItemsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/shopping-list-items/{id}",
    ...options,
  });

/**
 * /recipes/shopping-list-items/:id operation on recipes-shopping-list-item resource
 *
 * /recipes/shopping-list-items/:id operation on recipes-shopping-list-item resource
 */
export const patchAdminRecipesShoppingListItemsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRecipesShoppingListItemsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesShoppingListItemsByIdResponses,
    PatchAdminRecipesShoppingListItemsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/shopping-list-items/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Delete a role; emits a RoleDeleted audit event
 *
 * Delete a role; emits a RoleDeleted audit event. Existing AccessGrants that reference this role retain their snapshotted permissions.
 */
export const deleteAdminRolesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminRolesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRolesByIdResponses,
    DeleteAdminRolesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/roles/{id}",
    ...options,
  });

/**
 * /roles/:id operation on role resource
 *
 * /roles/:id operation on role resource
 */
export const getAdminRolesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminRolesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRolesByIdResponses,
    GetAdminRolesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/roles/{id}",
    ...options,
  });

/**
 * Update a role's name, description, or permission list; does NOT retroactively update existing AccessGrants
 *
 * Update a role's name, description, or permission list; does NOT retroactively update existing AccessGrants. Emits a RoleUpdated audit event.
 */
export const patchAdminRolesById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminRolesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRolesByIdResponses,
    PatchAdminRolesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/roles/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-tools/catalog/archived operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/catalog/archived operation on clinical-practice-tool resource
 */
export const getAdminClinicalPracticeToolsCatalogArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalPracticeToolsCatalogArchivedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeToolsCatalogArchivedResponses,
    GetAdminClinicalPracticeToolsCatalogArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/catalog/archived",
    ...options,
  });

/**
 * /post-processing-hooks/:id operation on post-processing-hook resource
 *
 * /post-processing-hooks/:id operation on post-processing-hook resource
 */
export const deleteAdminPostProcessingHooksById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminPostProcessingHooksByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminPostProcessingHooksByIdResponses,
    DeleteAdminPostProcessingHooksByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/post-processing-hooks/{id}",
    ...options,
  });

/**
 * /post-processing-hooks/:id operation on post-processing-hook resource
 *
 * /post-processing-hooks/:id operation on post-processing-hook resource
 */
export const getAdminPostProcessingHooksById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPostProcessingHooksByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPostProcessingHooksByIdResponses,
    GetAdminPostProcessingHooksByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/post-processing-hooks/{id}",
    ...options,
  });

/**
 * /post-processing-hooks/:id operation on post-processing-hook resource
 *
 * /post-processing-hooks/:id operation on post-processing-hook resource
 */
export const patchAdminPostProcessingHooksById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPostProcessingHooksByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPostProcessingHooksByIdResponses,
    PatchAdminPostProcessingHooksByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/post-processing-hooks/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Re-execute a saved search by ID and return the saved search metadata enriched with an `executed_at` ISO-8601 timestamp
 *
 * Re-execute a saved search by ID and return the saved search metadata enriched with an `executed_at` ISO-8601 timestamp. Authorization is delegated to the standard :read policy — only the owner or shared searches are accessible. Use this instead of :search when the query is already stored and you want a re-run audit trail.
 */
export const postAdminSearchSavedByIdRun = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSearchSavedByIdRunData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSearchSavedByIdRunResponses,
    PostAdminSearchSavedByIdRunErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/saved/{id}/run",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List recordings for a specific voice session
 *
 * List recordings for a specific voice session
 */
export const getAdminVoiceRecordingsSessionBySessionId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminVoiceRecordingsSessionBySessionIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminVoiceRecordingsSessionBySessionIdResponses,
    GetAdminVoiceRecordingsSessionBySessionIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/recordings/session/{session_id}",
    ...options,
  });

/**
 * List invitations visible to the actor
 *
 * List invitations visible to the actor. Returns invitations where the actor is the inviter, the tenant owner, or the recipient (matched by email).
 */
export const getAdminInvitations = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminInvitationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminInvitationsResponses,
    GetAdminInvitationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invitations",
    ...options,
  });

/**
 * Send an invitation to a user to join a tenant or workspace
 *
 * Send an invitation to a user to join a tenant or workspace. Applies rate limiting
 * per inviter, prevents self-invitation, enforces the tenant's member limit (based
 * on plan_tier), and validates custom permissions against the target scope. Generates
 * a signed token (valid 7 days), persists the invitation, and enqueues
 * SendInvitationEmail to deliver the invite email asynchronously. Logs an audit event.
 *
 * Returns the invitation with the raw_token in metadata (one-time only).
 *
 */
export const postAdminInvitations = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminInvitationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminInvitationsResponses,
    PostAdminInvitationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invitations",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/tracking-events/workspace/:workspace_id operation on email-tracking-event resource
 *
 * /email/tracking-events/workspace/:workspace_id operation on email-tracking-event resource
 */
export const getAdminEmailTrackingEventsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailTrackingEventsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailTrackingEventsWorkspaceByWorkspaceIdResponses,
    GetAdminEmailTrackingEventsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/tracking-events/workspace/{workspace_id}",
    ...options,
  });

/**
 * Create a relationship (edge) between two graph nodes
 *
 * Create a relationship (edge) between two graph nodes
 */
export const postAdminAiGraphRelationships = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminAiGraphRelationshipsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAiGraphRelationshipsResponses,
    PostAdminAiGraphRelationshipsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/graph/relationships",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/recipe-nutritions/:id operation on recipes-recipe-nutrition resource
 *
 * /recipes/recipe-nutritions/:id operation on recipes-recipe-nutrition resource
 */
export const getAdminRecipesRecipeNutritionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesRecipeNutritionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesRecipeNutritionsByIdResponses,
    GetAdminRecipesRecipeNutritionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/recipe-nutritions/{id}",
    ...options,
  });

/**
 * /recipes/recipe-nutritions/:id operation on recipes-recipe-nutrition resource
 *
 * /recipes/recipe-nutritions/:id operation on recipes-recipe-nutrition resource
 */
export const patchAdminRecipesRecipeNutritionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRecipesRecipeNutritionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesRecipeNutritionsByIdResponses,
    PatchAdminRecipesRecipeNutritionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/recipe-nutritions/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /catalog/classification-suggestions/:id operation on catalog-classification-suggestion resource
 *
 * /catalog/classification-suggestions/:id operation on catalog-classification-suggestion resource
 */
export const getAdminCatalogClassificationSuggestionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogClassificationSuggestionsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogClassificationSuggestionsByIdResponses,
    GetAdminCatalogClassificationSuggestionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/classification-suggestions/{id}",
    ...options,
  });

/**
 * Get storage breakdown by workspace
 *
 * Get storage breakdown by workspace
 */
export const getAdminWalletStorageBreakdown = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWalletStorageBreakdownData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWalletStorageBreakdownResponses,
    GetAdminWalletStorageBreakdownErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/storage-breakdown",
    ...options,
  });

/**
 * /case-entity-links/:id operation on case-entity-link resource
 *
 * /case-entity-links/:id operation on case-entity-link resource
 */
export const deleteAdminCaseEntityLinksById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCaseEntityLinksByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCaseEntityLinksByIdResponses,
    DeleteAdminCaseEntityLinksByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-entity-links/{id}",
    ...options,
  });

/**
 * /case-entity-links/:id operation on case-entity-link resource
 *
 * /case-entity-links/:id operation on case-entity-link resource
 */
export const getAdminCaseEntityLinksById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCaseEntityLinksByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCaseEntityLinksByIdResponses,
    GetAdminCaseEntityLinksByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-entity-links/{id}",
    ...options,
  });

/**
 * Merge new_metadata into the existing metadata map (shallow merge)
 *
 * Merge new_metadata into the existing metadata map (shallow merge). Returns the updated file.
 */
export const patchAdminStorageFilesByIdUpdateMetadata = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminStorageFilesByIdUpdateMetadataData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminStorageFilesByIdUpdateMetadataResponses,
    PatchAdminStorageFilesByIdUpdateMetadataErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-files/{id}/update-metadata",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/deliveries operation on clinical-delivery resource
 *
 * /clinical/deliveries operation on clinical-delivery resource
 */
export const getAdminClinicalDeliveries = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalDeliveriesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalDeliveriesResponses,
    GetAdminClinicalDeliveriesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/deliveries",
    ...options,
  });

/**
 * /clinical/deliveries operation on clinical-delivery resource
 *
 * /clinical/deliveries operation on clinical-delivery resource
 */
export const postAdminClinicalDeliveries = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalDeliveriesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalDeliveriesResponses,
    PostAdminClinicalDeliveriesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/deliveries",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/patient-insurance/by-workspace operation on clinical-patient-insurance resource
 *
 * /clinical/patient-insurance/by-workspace operation on clinical-patient-insurance resource
 */
export const getAdminClinicalPatientInsuranceByWorkspace = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalPatientInsuranceByWorkspaceData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPatientInsuranceByWorkspaceResponses,
    GetAdminClinicalPatientInsuranceByWorkspaceErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patient-insurance/by-workspace",
    ...options,
  });

/**
 * /threads/:id/messages operation on chat-message resource
 *
 * /threads/:id/messages operation on chat-message resource
 */
export const getAdminThreadsByIdMessages = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminThreadsByIdMessagesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminThreadsByIdMessagesResponses,
    GetAdminThreadsByIdMessagesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/{id}/messages",
    ...options,
  });

/**
 * Submit a user message to a thread and receive the AI response synchronously
 *
 * Submit a user message to a thread and receive the AI response synchronously. Saves the
 * user message, runs the full RAG pipeline via ChatService (intent classification, vector
 * search, graph lookup, LLM synthesis, billing charge), saves the assistant reply, and
 * returns the updated Thread. Use this instead of :create on Message when you want the
 * full AI response in one call.
 *
 */
export const postAdminThreadsByIdMessages = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminThreadsByIdMessagesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminThreadsByIdMessagesResponses,
    PostAdminThreadsByIdMessagesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/{id}/messages",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/trending/history/range operation on trending-snapshot resource
 *
 * /social/trending/history/range operation on trending-snapshot resource
 */
export const getAdminSocialTrendingHistoryRange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSocialTrendingHistoryRangeData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSocialTrendingHistoryRangeResponses,
    GetAdminSocialTrendingHistoryRangeErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/trending/history/range",
    ...options,
  });

/**
 * Atomic provisioning surface for ISV onboarding
 *
 * Atomic provisioning surface for ISV onboarding. Creates an Application
 * (idempotent on `slug`) and, in the same transaction, optionally creates
 * a tenant-scoped BrandIdentity, applies ISV-specific overrides to system
 * email templates, and creates an initial WholesaleAgreement.
 *
 * The existing `Application.:create` after-actions still run on first
 * provision — meaning the Application gets its billing liability account,
 * a default `sk_app_` API key, system email templates, and system legal
 * documents automatically.
 *
 * Idempotency: re-running with the same `slug` returns the existing
 * Application + its dependent entity ids without creating new
 * BrandIdentity / EmailTemplate / WholesaleAgreement rows.
 *
 * Used by the ISV onboarding SDK flow and the Application Builder Agent's
 * terminal step.
 *
 */
export const postAdminApplicationsProvision = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminApplicationsProvisionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminApplicationsProvisionResponses,
    PostAdminApplicationsProvisionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/provision",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all participants for a specific event, including organizer and attendees
 *
 * List all participants for a specific event, including organizer and attendees. Use to render RSVP lists or build reminder recipient lists.
 */
export const getAdminSchedulingParticipants = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingParticipantsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingParticipantsResponses,
    GetAdminSchedulingParticipantsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/participants",
    ...options,
  });

/**
 * Add a participant to an event
 *
 * Add a participant to an event. Unique per (event_id, email) — duplicate adds are rejected. Auto-called during booking creation for the booker. Returns the created Participant.
 */
export const postAdminSchedulingParticipants = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSchedulingParticipantsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSchedulingParticipantsResponses,
    PostAdminSchedulingParticipantsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/participants",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Hard-delete a tag
 *
 * Hard-delete a tag. Does not remove the tag string from existing Ticket.tags arrays — callers should clean up existing tickets separately.
 */
export const deleteAdminSupportTagsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSupportTagsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSupportTagsByIdResponses,
    DeleteAdminSupportTagsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/tags/{id}",
    ...options,
  });

/**
 * /tenants operation on tenant resource
 *
 * /tenants operation on tenant resource
 */
export const getAdminTenants = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminTenantsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTenantsResponses,
    GetAdminTenantsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants",
    ...options,
  });

/**
 * Create a new tenant organization
 *
 * Create a new tenant organization. Auto-generates a unique slug from name if
 * not provided. After creation: provisions storage buckets synchronously, creates
 * a default workspace (if application_id is set), adds the owner as a workspace
 * admin member, and ensures the tenant's billing liability account exists.
 *
 * Use :create_isv for ISV tenants that need an initial credit allocation.
 *
 * Returns the created tenant record.
 *
 */
export const postAdminTenants = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminTenantsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTenantsResponses,
    PostAdminTenantsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Soft-delete a taxonomy node by stamping deleted_at; child nodes are not auto-deleted
 *
 * Soft-delete a taxonomy node by stamping deleted_at; child nodes are not auto-deleted. Remove children before deleting a parent.
 */
export const deleteAdminCatalogTaxonomyNodesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCatalogTaxonomyNodesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCatalogTaxonomyNodesByIdResponses,
    DeleteAdminCatalogTaxonomyNodesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/taxonomy-nodes/{id}",
    ...options,
  });

/**
 * /catalog/taxonomy-nodes/:id operation on catalog-taxonomy-node resource
 *
 * /catalog/taxonomy-nodes/:id operation on catalog-taxonomy-node resource
 */
export const getAdminCatalogTaxonomyNodesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCatalogTaxonomyNodesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCatalogTaxonomyNodesByIdResponses,
    GetAdminCatalogTaxonomyNodesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/taxonomy-nodes/{id}",
    ...options,
  });

/**
 * Update a node's name, slug, position, or parent; re-validates tree depth
 *
 * Update a node's name, slug, position, or parent; re-validates tree depth. Returns the updated node.
 */
export const patchAdminCatalogTaxonomyNodesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCatalogTaxonomyNodesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogTaxonomyNodesByIdResponses,
    PatchAdminCatalogTaxonomyNodesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/taxonomy-nodes/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /training-examples/:id operation on training-example resource
 *
 * /training-examples/:id operation on training-example resource
 */
export const deleteAdminTrainingExamplesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminTrainingExamplesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminTrainingExamplesByIdResponses,
    DeleteAdminTrainingExamplesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-examples/{id}",
    ...options,
  });

/**
 * Fetch a single TrainingExample by ID.
 *
 * Fetch a single TrainingExample by ID.
 */
export const getAdminTrainingExamplesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminTrainingExamplesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTrainingExamplesByIdResponses,
    GetAdminTrainingExamplesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-examples/{id}",
    ...options,
  });

/**
 * Update an existing training example's input text, expected output JSON, notes,
 * correction reasons, or image reference
 *
 * Update an existing training example's input text, expected output JSON, notes,
 * correction reasons, or image reference. Updating `input_text` will trigger re-vectorization
 * via AshAi, replacing the stored embedding with the new text's representation.
 *
 */
export const patchAdminTrainingExamplesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminTrainingExamplesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTrainingExamplesByIdResponses,
    PatchAdminTrainingExamplesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-examples/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a new CRM contact
 *
 * Create a new CRM contact. Validates against workspace contact quota and any
 * custom field definitions. Triggers Meilisearch indexing as a side effect.
 * Returns the created Contact struct.
 *
 */
export const postAdminCrmContacts = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrmContactsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmContactsResponses,
    PostAdminCrmContactsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/contacts",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a channel capture configuration for a workspace
 *
 * Create a channel capture configuration for a workspace. One config per workspace —
 * use :update if a config already exists. When absent, defaults apply: all channel types
 * captured, no PII scanning, indefinite retention.
 *
 */
export const postAdminIsvCrmChannelCaptureConfig = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminIsvCrmChannelCaptureConfigData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminIsvCrmChannelCaptureConfigResponses,
    PostAdminIsvCrmChannelCaptureConfigErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv/crm/channel-capture-config",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List pipelines available to a workspace — includes both workspace-specific pipelines and application-level templates (workspace_id IS NULL).
 *
 * List pipelines available to a workspace — includes both workspace-specific pipelines and application-level templates (workspace_id IS NULL).
 */
export const getAdminCrmPipelinesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmPipelinesWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmPipelinesWorkspaceByWorkspaceIdResponses,
    GetAdminCrmPipelinesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/pipelines/workspace/{workspace_id}",
    ...options,
  });

/**
 * /contract-renewal-alerts/:id operation on contract-renewal-alert resource
 *
 * /contract-renewal-alerts/:id operation on contract-renewal-alert resource
 */
export const getAdminContractRenewalAlertsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminContractRenewalAlertsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminContractRenewalAlertsByIdResponses,
    GetAdminContractRenewalAlertsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/contract-renewal-alerts/{id}",
    ...options,
  });

/**
 * Delete an ExtractionResult record
 *
 * Delete an ExtractionResult record. Use only when cleaning up failed or superseded results.
 */
export const deleteAdminExtractionResultsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminExtractionResultsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminExtractionResultsByIdResponses,
    DeleteAdminExtractionResultsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/results/{id}",
    ...options,
  });

/**
 * Fetch a single ExtractionResult by ID
 *
 * Fetch a single ExtractionResult by ID. Filters hidden system fields from the response.
 */
export const getAdminExtractionResultsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionResultsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionResultsByIdResponses,
    GetAdminExtractionResultsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/results/{id}",
    ...options,
  });

/**
 * General-purpose update for an ExtractionResult
 *
 * General-purpose update for an ExtractionResult. Accepts status, credits, processing time,
 * extracted fields, and classification metadata. Used internally by workers to mark results
 * as `:completed` or `:failed`. For user-initiated field corrections, use `:save_corrections`
 * which also updates document confidence and recalculates summary statistics.
 *
 */
export const patchAdminExtractionResultsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminExtractionResultsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionResultsByIdResponses,
    PatchAdminExtractionResultsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/results/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Set a location to inactive (is_active: false)
 *
 * Set a location to inactive (is_active: false). Inactive locations are excluded from :list but remain linked to historical Events via the LocationEmbed. Use instead of deleting.
 */
export const patchAdminSchedulingLocationsByIdDeactivate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminSchedulingLocationsByIdDeactivateData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingLocationsByIdDeactivateResponses,
    PatchAdminSchedulingLocationsByIdDeactivateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/locations/{id}/deactivate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/jobs operation on crawler-job resource
 *
 * /crawler/jobs operation on crawler-job resource
 */
export const getAdminCrawlerJobs = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCrawlerJobsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerJobsResponses,
    GetAdminCrawlerJobsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/jobs",
    ...options,
  });

/**
 * Create a crawl job for a URL with the specified mode and strategy; performs a credit pre-check and enqueues execution
 *
 * Create a crawl job for a URL with the specified mode and strategy; performs a credit pre-check and enqueues execution. Returns the created job.
 */
export const postAdminCrawlerJobs = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrawlerJobsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrawlerJobsResponses,
    PostAdminCrawlerJobsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/jobs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /pipelines operation on pipeline resource
 *
 * /pipelines operation on pipeline resource
 */
export const getAdminPipelines = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPipelinesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPipelinesResponses,
    GetAdminPipelinesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipelines",
    ...options,
  });

/**
 * Create a new agent pipeline.
 *
 * Create a new agent pipeline.
 */
export const postAdminPipelines = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminPipelinesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPipelinesResponses,
    PostAdminPipelinesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipelines",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /brand-identities/default/tenant/:tenant_id operation on brand-identity resource
 *
 * /brand-identities/default/tenant/:tenant_id operation on brand-identity resource
 */
export const getAdminBrandIdentitiesDefaultTenantByTenantId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminBrandIdentitiesDefaultTenantByTenantIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminBrandIdentitiesDefaultTenantByTenantIdResponses,
    GetAdminBrandIdentitiesDefaultTenantByTenantIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/brand-identities/default/tenant/{tenant_id}",
    ...options,
  });

/**
 * Soft-delete a contact by setting deleted_at
 *
 * Soft-delete a contact by setting deleted_at. The record remains in the database
 * for audit purposes but is excluded from all standard reads. Enqueues a Meilisearch
 * deletion job as a side effect. Use :archive instead to preserve the record visibly.
 *
 */
export const deleteAdminCrmContactsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmContactsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmContactsByIdResponses,
    DeleteAdminCrmContactsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/contacts/{id}",
    ...options,
  });

/**
 * Fetch a single active contact by ID; excludes soft-deleted records.
 *
 * Fetch a single active contact by ID; excludes soft-deleted records.
 */
export const getAdminCrmContactsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCrmContactsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmContactsByIdResponses,
    GetAdminCrmContactsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/contacts/{id}",
    ...options,
  });

/**
 * Update mutable fields on an existing contact
 *
 * Update mutable fields on an existing contact. Validates custom field definitions
 * and re-indexes the record in Meilisearch. Use instead of :create when the contact
 * already exists. Returns the updated Contact struct.
 *
 */
export const patchAdminCrmContactsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminCrmContactsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmContactsByIdResponses,
    PatchAdminCrmContactsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/contacts/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Confirm a user's email address using a confirmation token
 *
 * Confirm a user's email address using a confirmation token
 */
export const postAdminUsersAuthConfirm = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminUsersAuthConfirmData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminUsersAuthConfirmResponses,
    PostAdminUsersAuthConfirmErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/auth/confirm",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a workspace-scoped ticket tag
 *
 * Create a workspace-scoped ticket tag. Name is unique per workspace. Tags are stored as strings on Ticket.tags array — use this to manage the tag registry.
 */
export const postAdminSupportTags = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSupportTagsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSupportTagsResponses,
    PostAdminSupportTagsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/tags",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/notes/by-workspace operation on clinical-note resource
 *
 * /clinical/notes/by-workspace operation on clinical-note resource
 */
export const getAdminClinicalNotesByWorkspace = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalNotesByWorkspaceData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNotesByWorkspaceResponses,
    GetAdminClinicalNotesByWorkspaceErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes/by-workspace",
    ...options,
  });

/**
 * /clinical/client-medications operation on clinical-client-medication resource
 *
 * /clinical/client-medications operation on clinical-client-medication resource
 */
export const getAdminClinicalClientMedications = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalClientMedicationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalClientMedicationsResponses,
    GetAdminClinicalClientMedicationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-medications",
    ...options,
  });

/**
 * /clinical/client-medications operation on clinical-client-medication resource
 *
 * /clinical/client-medications operation on clinical-client-medication resource
 */
export const postAdminClinicalClientMedications = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalClientMedicationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalClientMedicationsResponses,
    PostAdminClinicalClientMedicationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-medications",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Enqueue a bulk export job for audit logs
 *
 * Enqueue a bulk export job for audit logs. Returns job_id and enqueued status. Requires audit:write scope.
 */
export const postAdminAuditLogsExport = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAuditLogsExportData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAuditLogsExportResponses,
    PostAdminAuditLogsExportErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/audit-logs/export",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Soft-delete a custom entity by setting deleted_at
 *
 * Soft-delete a custom entity by setting deleted_at. Excluded from standard reads after deletion. Version history is preserved.
 */
export const deleteAdminCrmCustomEntitiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmCustomEntitiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmCustomEntitiesByIdResponses,
    DeleteAdminCrmCustomEntitiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/custom-entities/{id}",
    ...options,
  });

/**
 * Fetch a single active custom entity by ID; excludes soft-deleted records.
 *
 * Fetch a single active custom entity by ID; excludes soft-deleted records.
 */
export const getAdminCrmCustomEntitiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrmCustomEntitiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmCustomEntitiesByIdResponses,
    GetAdminCrmCustomEntitiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/custom-entities/{id}",
    ...options,
  });

/**
 * Update a custom entity's properties and pipeline assignment
 *
 * Update a custom entity's properties and pipeline assignment. Validates properties
 * against the type schema. Automatically creates a version snapshot via CreateEntityVersion
 * before persisting changes. Use :restore_version to roll back to a prior snapshot.
 *
 */
export const patchAdminCrmCustomEntitiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmCustomEntitiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmCustomEntitiesByIdResponses,
    PatchAdminCrmCustomEntitiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/custom-entities/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/shopping-lists operation on recipes-shopping-list resource
 *
 * /recipes/shopping-lists operation on recipes-shopping-list resource
 */
export const postAdminRecipesShoppingLists = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminRecipesShoppingListsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesShoppingListsResponses,
    PostAdminRecipesShoppingListsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/shopping-lists",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Increment usage for a feature by key
 *
 * Increment usage for a feature by key. Checks feature gate, enforces limits,
 * charges credits for credit_cost features, and records usage. Returns the
 * updated usage count and remaining allowance.
 *
 */
export const postAdminFeatureUsagesIncrement = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminFeatureUsagesIncrementData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminFeatureUsagesIncrementResponses,
    PostAdminFeatureUsagesIncrementErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/feature-usages/increment",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /notification-preferences operation on notification-preference resource
 *
 * /notification-preferences operation on notification-preference resource
 */
export const getAdminNotificationPreferences = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminNotificationPreferencesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminNotificationPreferencesResponses,
    GetAdminNotificationPreferencesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-preferences",
    ...options,
  });

/**
 * Create notification preferences for a user, specifying which delivery channels are enabled (e.g., email, SMS) and category-level opt-in/out settings
 *
 * Create notification preferences for a user, specifying which delivery channels are enabled (e.g., email, SMS) and category-level opt-in/out settings. Each user has at most one preference record (enforced by unique identity).
 */
export const postAdminNotificationPreferences = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminNotificationPreferencesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminNotificationPreferencesResponses,
    PostAdminNotificationPreferencesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-preferences",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /business-associate-agreements/:id operation on business-associate-agreement resource
 *
 * /business-associate-agreements/:id operation on business-associate-agreement resource
 */
export const getAdminBusinessAssociateAgreementsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminBusinessAssociateAgreementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBusinessAssociateAgreementsByIdResponses,
    GetAdminBusinessAssociateAgreementsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/business-associate-agreements/{id}",
    ...options,
  });

/**
 * /business-associate-agreements/:id operation on business-associate-agreement resource
 *
 * /business-associate-agreements/:id operation on business-associate-agreement resource
 */
export const patchAdminBusinessAssociateAgreementsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminBusinessAssociateAgreementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminBusinessAssociateAgreementsByIdResponses,
    PatchAdminBusinessAssociateAgreementsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/business-associate-agreements/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Delete multiple training examples by ID in a single transaction
 *
 * Delete multiple training examples by ID in a single transaction. Filters by both `ids` and
 * `agent_id` to prevent cross-agent deletions. All deletes use SystemActor after the
 * action-level policy has already verified the caller has `extract:agent:train:all` permission.
 *
 * Returns `%{success: true}` on success.
 *
 */
export const postAdminTrainingExamplesBulkDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminTrainingExamplesBulkDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTrainingExamplesBulkDeleteResponses,
    PostAdminTrainingExamplesBulkDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-examples/bulk-delete",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Platform-wide analytics summary (platform admin only)
 *
 * Platform-wide analytics summary (platform admin only)
 */
export const getAdminLlmAnalyticsPlatform = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminLlmAnalyticsPlatformData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLlmAnalyticsPlatformResponses,
    GetAdminLlmAnalyticsPlatformErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/llm-analytics/platform",
    ...options,
  });

/**
 * /credit-packages/:id operation on credit-package resource
 *
 * /credit-packages/:id operation on credit-package resource
 */
export const deleteAdminCreditPackagesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCreditPackagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCreditPackagesByIdResponses,
    DeleteAdminCreditPackagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/credit-packages/{id}",
    ...options,
  });

/**
 * Fetch a single credit package by its UUID
 *
 * Fetch a single credit package by its UUID. Use when you already know the package ID
 * (e.g., after the user selects a package in the UI). Use read_by_slug when looking up
 * by human-readable identifier. Returns the full package record including price and credit amount.
 *
 */
export const getAdminCreditPackagesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCreditPackagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCreditPackagesByIdResponses,
    GetAdminCreditPackagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/credit-packages/{id}",
    ...options,
  });

/**
 * Update an existing credit package's name, price, or credit amount
 *
 * Update an existing credit package's name, price, or credit amount. Use when repricing a
 * bundle or correcting a catalog entry. Changes take effect for future purchases immediately;
 * past transactions are not affected.
 *
 * Requires Platform Admin role. The slug is immutable after creation.
 *
 */
export const patchAdminCreditPackagesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCreditPackagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCreditPackagesByIdResponses,
    PatchAdminCreditPackagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/credit-packages/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/collection-recipes operation on recipes-collection-recipe resource
 *
 * /recipes/collection-recipes operation on recipes-collection-recipe resource
 */
export const postAdminRecipesCollectionRecipes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminRecipesCollectionRecipesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesCollectionRecipesResponses,
    PostAdminRecipesCollectionRecipesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/collection-recipes",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-supplements/:id/permanent operation on clinical-client-supplement resource
 *
 * /clinical/client-supplements/:id/permanent operation on clinical-client-supplement resource
 */
export const deleteAdminClinicalClientSupplementsByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalClientSupplementsByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalClientSupplementsByIdPermanentResponses,
    DeleteAdminClinicalClientSupplementsByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-supplements/{id}/permanent",
    ...options,
  });

/**
 * /extraction-workflows/:id operation on extraction-workflow resource
 *
 * /extraction-workflows/:id operation on extraction-workflow resource
 */
export const deleteAdminExtractionWorkflowsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminExtractionWorkflowsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminExtractionWorkflowsByIdResponses,
    DeleteAdminExtractionWorkflowsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction-workflows/{id}",
    ...options,
  });

/**
 * /extraction-workflows/:id operation on extraction-workflow resource
 *
 * /extraction-workflows/:id operation on extraction-workflow resource
 */
export const getAdminExtractionWorkflowsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionWorkflowsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionWorkflowsByIdResponses,
    GetAdminExtractionWorkflowsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction-workflows/{id}",
    ...options,
  });

/**
 * /extraction-workflows/:id operation on extraction-workflow resource
 *
 * /extraction-workflows/:id operation on extraction-workflow resource
 */
export const patchAdminExtractionWorkflowsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminExtractionWorkflowsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionWorkflowsByIdResponses,
    PatchAdminExtractionWorkflowsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction-workflows/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /extraction/schema-discoveries operation on schema-discovery resource
 *
 * /extraction/schema-discoveries operation on schema-discovery resource
 */
export const postAdminExtractionSchemaDiscoveries = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminExtractionSchemaDiscoveriesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminExtractionSchemaDiscoveriesResponses,
    PostAdminExtractionSchemaDiscoveriesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/schema-discoveries",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /compliance-document-templates operation on compliance-document-template resource
 *
 * /compliance-document-templates operation on compliance-document-template resource
 */
export const getAdminComplianceDocumentTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminComplianceDocumentTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminComplianceDocumentTemplatesResponses,
    GetAdminComplianceDocumentTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-document-templates",
    ...options,
  });

/**
 * /compliance-document-templates operation on compliance-document-template resource
 *
 * /compliance-document-templates operation on compliance-document-template resource
 */
export const postAdminComplianceDocumentTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminComplianceDocumentTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminComplianceDocumentTemplatesResponses,
    PostAdminComplianceDocumentTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-document-templates",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-tools/catalog/:id/restore operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/catalog/:id/restore operation on clinical-practice-tool resource
 */
export const patchAdminClinicalPracticeToolsCatalogByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalPracticeToolsCatalogByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPracticeToolsCatalogByIdRestoreResponses,
    PatchAdminClinicalPracticeToolsCatalogByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/catalog/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Assign a product to a taxonomy node with source tracking (manual, ai_suggested, or ai_auto)
 *
 * Assign a product to a taxonomy node with source tracking (manual, ai_suggested, or ai_auto). Returns the created classification.
 */
export const postAdminCatalogProductClassifications = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCatalogProductClassificationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogProductClassificationsResponses,
    PostAdminCatalogProductClassificationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/product-classifications",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /campaigns/sequences/:id/pause operation on email-marketing-sequence resource
 *
 * /campaigns/sequences/:id/pause operation on email-marketing-sequence resource
 */
export const patchAdminCampaignsSequencesByIdPause = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCampaignsSequencesByIdPauseData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCampaignsSequencesByIdPauseResponses,
    PatchAdminCampaignsSequencesByIdPauseErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequences/{id}/pause",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /voice/sessions operation on voice-session resource
 *
 * /voice/sessions operation on voice-session resource
 */
export const getAdminVoiceSessions = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminVoiceSessionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminVoiceSessionsResponses,
    GetAdminVoiceSessionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/sessions",
    ...options,
  });

/**
 * Start a new voice session with LiveKit room provisioning
 *
 * Start a new voice session with LiveKit room provisioning
 */
export const postAdminVoiceSessions = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminVoiceSessionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminVoiceSessionsResponses,
    PostAdminVoiceSessionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/sessions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/:id/mark-paid operation on invoices-invoice resource
 *
 * /invoices/:id/mark-paid operation on invoices-invoice resource
 */
export const patchAdminInvoicesByIdMarkPaid = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesByIdMarkPaidData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesByIdMarkPaidResponses,
    PatchAdminInvoicesByIdMarkPaidErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}/mark-paid",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/notes/:id/archive operation on clinical-note resource
 *
 * /clinical/notes/:id/archive operation on clinical-note resource
 */
export const patchAdminClinicalNotesByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalNotesByIdArchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalNotesByIdArchiveResponses,
    PatchAdminClinicalNotesByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch all chunks for a document sorted by chunk_index ascending; equivalent to read_by_document — use for JSON:API access via /ai/chunks/document/:document_id.
 *
 * Fetch all chunks for a document sorted by chunk_index ascending; equivalent to read_by_document — use for JSON:API access via /ai/chunks/document/:document_id.
 */
export const getAdminAiChunksDocumentByDocumentId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAiChunksDocumentByDocumentIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAiChunksDocumentByDocumentIdResponses,
    GetAdminAiChunksDocumentByDocumentIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/chunks/document/{document_id}",
    ...options,
  });

/**
 * /clinical/note-templates/archived operation on clinical-note-template resource
 *
 * /clinical/note-templates/archived operation on clinical-note-template resource
 */
export const getAdminClinicalNoteTemplatesArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalNoteTemplatesArchivedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNoteTemplatesArchivedResponses,
    GetAdminClinicalNoteTemplatesArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/archived",
    ...options,
  });

/**
 * /invoices/:id/mark-viewed operation on invoices-invoice resource
 *
 * /invoices/:id/mark-viewed operation on invoices-invoice resource
 */
export const patchAdminInvoicesByIdMarkViewed = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesByIdMarkViewedData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesByIdMarkViewedResponses,
    PatchAdminInvoicesByIdMarkViewedErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}/mark-viewed",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/note-templates/catalog/:id/permanent operation on clinical-note-template resource
 *
 * /clinical/note-templates/catalog/:id/permanent operation on clinical-note-template resource
 */
export const deleteAdminClinicalNoteTemplatesCatalogByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalNoteTemplatesCatalogByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalNoteTemplatesCatalogByIdPermanentResponses,
    DeleteAdminClinicalNoteTemplatesCatalogByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/catalog/{id}/permanent",
    ...options,
  });

/**
 * Activate a system message so it is visible to all authenticated users
 *
 * Activate a system message so it is visible to all authenticated users. Sets `is_active: true` and records `published_at` on first publish (preserved on subsequent re-activations).
 */
export const patchAdminSystemMessagesByIdPublish = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSystemMessagesByIdPublishData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSystemMessagesByIdPublishResponses,
    PatchAdminSystemMessagesByIdPublishErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/system-messages/{id}/publish",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Generate A/B test subject line variants using AI
 *
 * Generate A/B test subject line variants using AI
 */
export const postAdminEmailMarketingCampaignsByIdOptimizeSubjects = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminEmailMarketingCampaignsByIdOptimizeSubjectsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminEmailMarketingCampaignsByIdOptimizeSubjectsResponses,
    PostAdminEmailMarketingCampaignsByIdOptimizeSubjectsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/campaigns/{id}/optimize-subjects",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List active activities in a workspace with offset pagination
 *
 * List active activities in a workspace with offset pagination. Use instead of :read for workspace-scoped paginated listings.
 */
export const getAdminCrmActivitiesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmActivitiesWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmActivitiesWorkspaceByWorkspaceIdResponses,
    GetAdminCrmActivitiesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/activities/workspace/{workspace_id}",
    ...options,
  });

/**
 * Create an organization tenant (is_personal: false)
 *
 * Create an organization tenant (is_personal: false). Requires allow_org_creation on the Application.
 */
export const postAdminTenantsOrg = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminTenantsOrgData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTenantsOrgResponses,
    PostAdminTenantsOrgErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/org",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /brand-identities/:id/unset-default operation on brand-identity resource
 *
 * /brand-identities/:id/unset-default operation on brand-identity resource
 */
export const patchAdminBrandIdentitiesByIdUnsetDefault = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminBrandIdentitiesByIdUnsetDefaultData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminBrandIdentitiesByIdUnsetDefaultResponses,
    PatchAdminBrandIdentitiesByIdUnsetDefaultErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/brand-identities/{id}/unset-default",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get webhook configuration statistics scoped to the caller's application
 *
 * Get webhook configuration statistics scoped to the caller's application. Platform admins and internal callers see platform-wide totals.
 */
export const getAdminWebhookConfigsStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWebhookConfigsStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWebhookConfigsStatsResponses,
    GetAdminWebhookConfigsStatsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-configs/stats",
    ...options,
  });

/**
 * /clinical/goal-templates/:id/permanent operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/:id/permanent operation on clinical-goal-template resource
 */
export const deleteAdminClinicalGoalTemplatesByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalGoalTemplatesByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalGoalTemplatesByIdPermanentResponses,
    DeleteAdminClinicalGoalTemplatesByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/{id}/permanent",
    ...options,
  });

/**
 * /email/recipients/:id operation on email-recipient resource
 *
 * /email/recipients/:id operation on email-recipient resource
 */
export const deleteAdminEmailRecipientsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminEmailRecipientsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminEmailRecipientsByIdResponses,
    DeleteAdminEmailRecipientsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/recipients/{id}",
    ...options,
  });

/**
 * /email/recipients/:id operation on email-recipient resource
 *
 * /email/recipients/:id operation on email-recipient resource
 */
export const getAdminEmailRecipientsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminEmailRecipientsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEmailRecipientsByIdResponses,
    GetAdminEmailRecipientsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/recipients/{id}",
    ...options,
  });

/**
 * List transcription results for a voice session
 *
 * List transcription results for a voice session
 */
export const getAdminVoiceTranscriptionResultsSessionBySessionId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminVoiceTranscriptionResultsSessionBySessionIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminVoiceTranscriptionResultsSessionBySessionIdResponses,
    GetAdminVoiceTranscriptionResultsSessionBySessionIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/transcription-results/session/{session_id}",
    ...options,
  });

/**
 * Fetch all permissions and apply any query filters supplied by the caller; use :by_id for single-record lookup by permission ID string.
 *
 * Fetch all permissions and apply any query filters supplied by the caller; use :by_id for single-record lookup by permission ID string.
 */
export const getAdminPermissionsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPermissionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPermissionsByIdResponses,
    GetAdminPermissionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/permissions/{id}",
    ...options,
  });

/**
 * Reopen a resolved or closed ticket, setting status back to :open
 *
 * Reopen a resolved or closed ticket, setting status back to :open. Validated by ValidStatusTransition. Use when a customer reports the issue recurs after resolution.
 */
export const patchAdminSupportTicketsByIdReopen = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSupportTicketsByIdReopenData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSupportTicketsByIdReopenResponses,
    PatchAdminSupportTicketsByIdReopenErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/tickets/{id}/reopen",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /brand-identities/default/workspace/:workspace_id operation on brand-identity resource
 *
 * /brand-identities/default/workspace/:workspace_id operation on brand-identity resource
 */
export const getAdminBrandIdentitiesDefaultWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminBrandIdentitiesDefaultWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminBrandIdentitiesDefaultWorkspaceByWorkspaceIdResponses,
    GetAdminBrandIdentitiesDefaultWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/brand-identities/default/workspace/{workspace_id}",
    ...options,
  });

/**
 * /portal-change-requests operation on portal-change-request resource
 *
 * /portal-change-requests operation on portal-change-request resource
 */
export const getAdminPortalChangeRequests = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPortalChangeRequestsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPortalChangeRequestsResponses,
    GetAdminPortalChangeRequestsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/portal-change-requests",
    ...options,
  });

/**
 * /isv/crm/channel-capture-config/:id operation on crm-channel-capture-config resource
 *
 * /isv/crm/channel-capture-config/:id operation on crm-channel-capture-config resource
 */
export const getAdminIsvCrmChannelCaptureConfigById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminIsvCrmChannelCaptureConfigByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminIsvCrmChannelCaptureConfigByIdResponses,
    GetAdminIsvCrmChannelCaptureConfigByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv/crm/channel-capture-config/{id}",
    ...options,
  });

/**
 * Update channel capture settings for a workspace
 *
 * Update channel capture settings for a workspace. Invalidates the 60-second CRM cache after the update so CaptureInteractionWorker picks up the new config.
 */
export const patchAdminIsvCrmChannelCaptureConfigById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminIsvCrmChannelCaptureConfigByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminIsvCrmChannelCaptureConfigByIdResponses,
    PatchAdminIsvCrmChannelCaptureConfigByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv/crm/channel-capture-config/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch both legs of a double-entry transaction by transaction_id
 *
 * Fetch both legs of a double-entry transaction by transaction_id. Returns the paired movements.
 */
export const getAdminCatalogStockMovementsTransactionByTransactionId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogStockMovementsTransactionByTransactionIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogStockMovementsTransactionByTransactionIdResponses,
    GetAdminCatalogStockMovementsTransactionByTransactionIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/stock-movements/transaction/{transaction_id}",
    ...options,
  });

/**
 * Verify a notification method by submitting the 6-digit code received via :send_verification
 *
 * Verify a notification method by submitting the 6-digit code received via :send_verification. The token must match and not be expired.
 */
export const patchAdminNotificationMethodsByIdVerify = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminNotificationMethodsByIdVerifyData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminNotificationMethodsByIdVerifyResponses,
    PatchAdminNotificationMethodsByIdVerifyErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-methods/{id}/verify",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /users operation on user resource
 *
 * /users operation on user resource
 */
export const getAdminUsers = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUsersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUsersResponses,
    GetAdminUsersErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users",
    ...options,
  });

/**
 * Export thread with messages to JSON, Markdown, or plain text format
 *
 * Export thread with messages to JSON, Markdown, or plain text format
 */
export const postAdminThreadsByIdExport = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminThreadsByIdExportData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminThreadsByIdExportResponses,
    PostAdminThreadsByIdExportErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/{id}/export",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Archive a thread by setting `archived_at` to the current timestamp
 *
 * Archive a thread by setting `archived_at` to the current timestamp. Archived threads are hidden from the default list but remain readable. Use :unarchive to restore.
 */
export const patchAdminThreadsByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminThreadsByIdArchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminThreadsByIdArchiveResponses,
    PatchAdminThreadsByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Vector similarity search across document chunks using a generated embedding of the query
 *
 * Vector similarity search across document chunks using a generated embedding of the query. Results are ranked by cosine similarity. Use this for natural-language queries; use :search for keyword-based lookups.
 */
export const getAdminSearchSemantic = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSearchSemanticData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSearchSemanticResponses,
    GetAdminSearchSemanticErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/semantic",
    ...options,
  });

/**
 * /invoices/recurring-schedules/:id/pause operation on invoices-recurring-schedule resource
 *
 * /invoices/recurring-schedules/:id/pause operation on invoices-recurring-schedule resource
 */
export const patchAdminInvoicesRecurringSchedulesByIdPause = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminInvoicesRecurringSchedulesByIdPauseData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesRecurringSchedulesByIdPauseResponses,
    PatchAdminInvoicesRecurringSchedulesByIdPauseErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/recurring-schedules/{id}/pause",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List templates in a collection
 *
 * List templates in a collection
 */
export const getAdminClinicalGoalTemplateCollectionMembershipsCollectionByCollectionId =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAdminClinicalGoalTemplateCollectionMembershipsCollectionByCollectionIdData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetAdminClinicalGoalTemplateCollectionMembershipsCollectionByCollectionIdResponses,
      GetAdminClinicalGoalTemplateCollectionMembershipsCollectionByCollectionIdErrors,
      ThrowOnError
    >({
      querySerializer: {
        parameters: {
          filter: { object: { style: "form" } },
          page: { object: { style: "form" } },
          fields: { object: { style: "form" } },
        },
      },
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/clinical/goal-template-collection-memberships/collection/{collection_id}",
      ...options,
    });

/**
 * /email/inbound/received/:id operation on email-inbound-email resource
 *
 * /email/inbound/received/:id operation on email-inbound-email resource
 */
export const getAdminEmailInboundReceivedById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminEmailInboundReceivedByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEmailInboundReceivedByIdResponses,
    GetAdminEmailInboundReceivedByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inbound/received/{id}",
    ...options,
  });

/**
 * List all transactions belonging to the current tenant, filtered to the actor's tenant
 * context
 *
 * List all transactions belonging to the current tenant, filtered to the actor's tenant
 * context. Use this for a tenant's transaction history page (subscriptions, top-ups, refunds).
 * Returns transactions in reverse-chronological order with status, amount, and operation type.
 * Requires Tenant Owner role.
 *
 */
export const getAdminTransactions = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminTransactionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTransactionsResponses,
    GetAdminTransactionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/transactions",
    ...options,
  });

/**
 * Get usage breakdown by workspace
 *
 * Get usage breakdown by workspace
 */
export const getAdminWalletUsageBreakdown = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWalletUsageBreakdownData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWalletUsageBreakdownResponses,
    GetAdminWalletUsageBreakdownErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/usage-breakdown",
    ...options,
  });

/**
 * Get dashboard data for the user's tenant context
 *
 * Get dashboard data for the user's tenant context
 */
export const getAdminUsersMeDashboard = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUsersMeDashboardData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUsersMeDashboardResponses,
    GetAdminUsersMeDashboardErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/me/dashboard",
    ...options,
  });

/**
 * /business-associate-agreements/:id/terminate operation on business-associate-agreement resource
 *
 * /business-associate-agreements/:id/terminate operation on business-associate-agreement resource
 */
export const patchAdminBusinessAssociateAgreementsByIdTerminate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminBusinessAssociateAgreementsByIdTerminateData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminBusinessAssociateAgreementsByIdTerminateResponses,
    PatchAdminBusinessAssociateAgreementsByIdTerminateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/business-associate-agreements/{id}/terminate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get performance metrics for this version
 *
 * Get performance metrics for this version
 */
export const getAdminAgentVersionsByIdMetrics = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAgentVersionsByIdMetricsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentVersionsByIdMetricsResponses,
    GetAdminAgentVersionsByIdMetricsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-versions/{id}/metrics",
    ...options,
  });

/**
 * Reject a pending classification suggestion; sets status to :rejected with no cascading effects.
 *
 * Reject a pending classification suggestion; sets status to :rejected with no cascading effects.
 */
export const patchAdminCatalogClassificationSuggestionsByIdReject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminCatalogClassificationSuggestionsByIdRejectData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogClassificationSuggestionsByIdRejectResponses,
    PatchAdminCatalogClassificationSuggestionsByIdRejectErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/classification-suggestions/{id}/reject",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Set which system fields are included in this version's output_schema (batch operation)
 *
 * Set which system fields are included in this version's output_schema (batch operation)
 */
export const postAdminAgentVersionsByIdSetSystemFields = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminAgentVersionsByIdSetSystemFieldsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentVersionsByIdSetSystemFieldsResponses,
    PostAdminAgentVersionsByIdSetSystemFieldsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-versions/{id}/set-system-fields",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/supplement-templates/catalog/archived operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/catalog/archived operation on clinical-supplement-template resource
 */
export const getAdminClinicalSupplementTemplatesCatalogArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalSupplementTemplatesCatalogArchivedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSupplementTemplatesCatalogArchivedResponses,
    GetAdminClinicalSupplementTemplatesCatalogArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/catalog/archived",
    ...options,
  });

/**
 * /compliance-requirements operation on compliance-requirement resource
 *
 * /compliance-requirements operation on compliance-requirement resource
 */
export const getAdminComplianceRequirements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminComplianceRequirementsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminComplianceRequirementsResponses,
    GetAdminComplianceRequirementsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-requirements",
    ...options,
  });

/**
 * /compliance-requirements operation on compliance-requirement resource
 *
 * /compliance-requirements operation on compliance-requirement resource
 */
export const postAdminComplianceRequirements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminComplianceRequirementsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminComplianceRequirementsResponses,
    PostAdminComplianceRequirementsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-requirements",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/accounts/:id/enable-posting operation on social-account resource
 *
 * /social/accounts/:id/enable-posting operation on social-account resource
 */
export const patchAdminSocialAccountsByIdEnablePosting = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSocialAccountsByIdEnablePostingData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialAccountsByIdEnablePostingResponses,
    PatchAdminSocialAccountsByIdEnablePostingErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/accounts/{id}/enable-posting",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /consent-records operation on consent-record resource
 *
 * /consent-records operation on consent-record resource
 */
export const getAdminConsentRecords = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminConsentRecordsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminConsentRecordsResponses,
    GetAdminConsentRecordsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/consent-records",
    ...options,
  });

/**
 * Record a new consent grant for a specific processing purpose (AI document processing, analytics, marketing, or third-party sharing)
 *
 * Record a new consent grant for a specific processing purpose (AI document processing, analytics, marketing, or third-party sharing). Sets status to `:granted` with the current timestamp. Use :withdraw when the user revokes consent.
 */
export const postAdminConsentRecords = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminConsentRecordsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConsentRecordsResponses,
    PostAdminConsentRecordsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/consent-records",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/campaigns operation on campaign resource
 *
 * /email-marketing/campaigns operation on campaign resource
 */
export const postAdminEmailMarketingCampaigns = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminEmailMarketingCampaignsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminEmailMarketingCampaignsResponses,
    PostAdminEmailMarketingCampaignsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/campaigns",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /reviews/:id/approve operation on review resource
 *
 * /reviews/:id/approve operation on review resource
 */
export const patchAdminReviewsByIdApprove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminReviewsByIdApproveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminReviewsByIdApproveResponses,
    PatchAdminReviewsByIdApproveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/reviews/{id}/approve",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch a single version by ID, scoped to a specific entity (IDOR-safe)
 *
 * Fetch a single version by ID, scoped to a specific entity (IDOR-safe)
 */
export const getAdminCrmCustomEntitiesByEntityIdVersionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmCustomEntitiesByEntityIdVersionsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmCustomEntitiesByEntityIdVersionsByIdResponses,
    GetAdminCrmCustomEntitiesByEntityIdVersionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/custom-entities/{entity_id}/versions/{id}",
    ...options,
  });

/**
 * Archive an orphan or inactive tenant
 *
 * Archive an orphan or inactive tenant. Preserves data but marks as archived.
 */
export const patchAdminTenantsByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminTenantsByIdArchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTenantsByIdArchiveResponses,
    PatchAdminTenantsByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all queue members across all queues for an application
 *
 * List all queue members across all queues for an application. Use for application-wide agent roster views or bulk availability updates.
 */
export const getAdminSupportQueueMembersApplicationByApplicationId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSupportQueueMembersApplicationByApplicationIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSupportQueueMembersApplicationByApplicationIdResponses,
    GetAdminSupportQueueMembersApplicationByApplicationIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/queue-members/application/{application_id}",
    ...options,
  });

/**
 * /email/inbound-addresses/:id operation on email-inbound-address resource
 *
 * /email/inbound-addresses/:id operation on email-inbound-address resource
 */
export const deleteAdminEmailInboundAddressesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminEmailInboundAddressesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminEmailInboundAddressesByIdResponses,
    DeleteAdminEmailInboundAddressesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inbound-addresses/{id}",
    ...options,
  });

/**
 * /email/inbound-addresses/:id operation on email-inbound-address resource
 *
 * /email/inbound-addresses/:id operation on email-inbound-address resource
 */
export const getAdminEmailInboundAddressesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminEmailInboundAddressesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEmailInboundAddressesByIdResponses,
    GetAdminEmailInboundAddressesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inbound-addresses/{id}",
    ...options,
  });

/**
 * /email/inbound-addresses/:id operation on email-inbound-address resource
 *
 * /email/inbound-addresses/:id operation on email-inbound-address resource
 */
export const patchAdminEmailInboundAddressesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminEmailInboundAddressesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailInboundAddressesByIdResponses,
    PatchAdminEmailInboundAddressesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inbound-addresses/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Vector similarity search across messages using a generated embedding of the query string
 *
 * Vector similarity search across messages using a generated embedding of the query string. Optionally filter to a single thread via :thread_id. Returns up to `limit` messages ranked by cosine similarity (threshold > 0.6).
 */
export const getAdminMessagesSemanticSearch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminMessagesSemanticSearchData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminMessagesSemanticSearchResponses,
    GetAdminMessagesSemanticSearchErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/messages/semantic-search",
    ...options,
  });

/**
 * /clinical/health-metrics/:id/restore operation on clinical-health-metric resource
 *
 * /clinical/health-metrics/:id/restore operation on clinical-health-metric resource
 */
export const patchAdminClinicalHealthMetricsByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalHealthMetricsByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalHealthMetricsByIdRestoreResponses,
    PatchAdminClinicalHealthMetricsByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/health-metrics/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /settlement-statements operation on settlement-statement resource
 *
 * /settlement-statements operation on settlement-statement resource
 */
export const getAdminSettlementStatements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSettlementStatementsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSettlementStatementsResponses,
    GetAdminSettlementStatementsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlement-statements",
    ...options,
  });

/**
 * /connectors/oauth-app-configs operation on oauth-app-config resource
 *
 * /connectors/oauth-app-configs operation on oauth-app-config resource
 */
export const getAdminConnectorsOauthAppConfigs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminConnectorsOauthAppConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminConnectorsOauthAppConfigsResponses,
    GetAdminConnectorsOauthAppConfigsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/oauth-app-configs",
    ...options,
  });

/**
 * /connectors/oauth-app-configs operation on oauth-app-config resource
 *
 * /connectors/oauth-app-configs operation on oauth-app-config resource
 */
export const postAdminConnectorsOauthAppConfigs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminConnectorsOauthAppConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsOauthAppConfigsResponses,
    PostAdminConnectorsOauthAppConfigsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/oauth-app-configs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /campaigns/sequence-steps/sequence/:sequence_id operation on email-marketing-sequence-step resource
 *
 * /campaigns/sequence-steps/sequence/:sequence_id operation on email-marketing-sequence-step resource
 */
export const getAdminCampaignsSequenceStepsSequenceBySequenceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCampaignsSequenceStepsSequenceBySequenceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCampaignsSequenceStepsSequenceBySequenceIdResponses,
    GetAdminCampaignsSequenceStepsSequenceBySequenceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequence-steps/sequence/{sequence_id}",
    ...options,
  });

/**
 * /clinical/practice-resources/:id/permanent operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/:id/permanent operation on clinical-practice-resource resource
 */
export const deleteAdminClinicalPracticeResourcesByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalPracticeResourcesByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalPracticeResourcesByIdPermanentResponses,
    DeleteAdminClinicalPracticeResourcesByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/{id}/permanent",
    ...options,
  });

/**
 * /clinical/sessions/:id operation on clinical-session resource
 *
 * /clinical/sessions/:id operation on clinical-session resource
 */
export const deleteAdminClinicalSessionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminClinicalSessionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalSessionsByIdResponses,
    DeleteAdminClinicalSessionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/sessions/{id}",
    ...options,
  });

/**
 * /clinical/sessions/:id operation on clinical-session resource
 *
 * /clinical/sessions/:id operation on clinical-session resource
 */
export const getAdminClinicalSessionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalSessionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSessionsByIdResponses,
    GetAdminClinicalSessionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/sessions/{id}",
    ...options,
  });

/**
 * /clinical/sessions/:id operation on clinical-session resource
 *
 * /clinical/sessions/:id operation on clinical-session resource
 */
export const patchAdminClinicalSessionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalSessionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalSessionsByIdResponses,
    PatchAdminClinicalSessionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/sessions/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Return Meilisearch database size and per-index document counts
 *
 * Return Meilisearch database size and per-index document counts. Useful for capacity planning and verifying indexing completeness.
 */
export const getAdminSearchStats = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSearchStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSearchStatsResponses,
    GetAdminSearchStatsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/stats",
    ...options,
  });

/**
 * List all preferences for the current user in the current workspace
 *
 * List all preferences for the current user in the current workspace
 */
export const getAdminPreferences = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPreferencesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPreferencesResponses,
    GetAdminPreferencesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/preferences",
    ...options,
  });

/**
 * List all currently granted (non-withdrawn) consents for a given user
 *
 * List all currently granted (non-withdrawn) consents for a given user. Use this to determine which processing activities the user has authorized before performing them.
 */
export const getAdminConsentRecordsActive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminConsentRecordsActiveData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminConsentRecordsActiveResponses,
    GetAdminConsentRecordsActiveErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/consent-records/active",
    ...options,
  });

/**
 * /connectors/sync-logs operation on sync-log resource
 *
 * /connectors/sync-logs operation on sync-log resource
 */
export const getAdminConnectorsSyncLogs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminConnectorsSyncLogsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminConnectorsSyncLogsResponses,
    GetAdminConnectorsSyncLogsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/sync-logs",
    ...options,
  });

/**
 * /platform-tones/:id operation on platform-tone resource
 *
 * /platform-tones/:id operation on platform-tone resource
 */
export const deleteAdminPlatformTonesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminPlatformTonesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminPlatformTonesByIdResponses,
    DeleteAdminPlatformTonesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/platform-tones/{id}",
    ...options,
  });

/**
 * /platform-tones/:id operation on platform-tone resource
 *
 * /platform-tones/:id operation on platform-tone resource
 */
export const getAdminPlatformTonesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPlatformTonesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPlatformTonesByIdResponses,
    GetAdminPlatformTonesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/platform-tones/{id}",
    ...options,
  });

/**
 * /platform-tones/:id operation on platform-tone resource
 *
 * /platform-tones/:id operation on platform-tone resource
 */
export const patchAdminPlatformTonesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPlatformTonesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPlatformTonesByIdResponses,
    PatchAdminPlatformTonesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/platform-tones/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a new email address for a contact or company
 *
 * Create a new email address for a contact or company. Validates email format and enforces workspace-level uniqueness.
 */
export const postAdminCrmEmailAddresses = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCrmEmailAddressesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmEmailAddressesResponses,
    PostAdminCrmEmailAddressesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/email-addresses",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Add a stage to a pipeline with an explicit sort order, optional win probability, and forecast category
 *
 * Add a stage to a pipeline with an explicit sort order, optional win probability, and forecast category. Order must be unique within the pipeline.
 */
export const postAdminCrmPipelineStages = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCrmPipelineStagesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmPipelineStagesResponses,
    PostAdminCrmPipelineStagesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/pipeline-stages",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Add a predefined system field to this version's output_schema
 *
 * Add a predefined system field to this version's output_schema
 */
export const postAdminAgentVersionsByIdAddSystemField = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminAgentVersionsByIdAddSystemFieldData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentVersionsByIdAddSystemFieldResponses,
    PostAdminAgentVersionsByIdAddSystemFieldErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-versions/{id}/add-system-field",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all workspaces where the authenticated user has a direct workspace membership
 *
 * List all workspaces where the authenticated user has a direct workspace membership. Excludes archived workspaces and workspaces belonging to deactivated tenants. Use :read_shared for workspaces from external organizations.
 */
export const getAdminWorkspacesMine = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminWorkspacesMineData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWorkspacesMineResponses,
    GetAdminWorkspacesMineErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/mine",
    ...options,
  });

/**
 * /social/trending/items/:id operation on trending-snapshot-item resource
 *
 * /social/trending/items/:id operation on trending-snapshot-item resource
 */
export const getAdminSocialTrendingItemsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSocialTrendingItemsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSocialTrendingItemsByIdResponses,
    GetAdminSocialTrendingItemsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/trending/items/{id}",
    ...options,
  });

/**
 * /field-templates/:id operation on field-template resource
 *
 * /field-templates/:id operation on field-template resource
 */
export const deleteAdminFieldTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminFieldTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminFieldTemplatesByIdResponses,
    DeleteAdminFieldTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/field-templates/{id}",
    ...options,
  });

/**
 * /field-templates/:id operation on field-template resource
 *
 * /field-templates/:id operation on field-template resource
 */
export const getAdminFieldTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminFieldTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFieldTemplatesByIdResponses,
    GetAdminFieldTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/field-templates/{id}",
    ...options,
  });

/**
 * Hard-delete an availability rule
 *
 * Hard-delete an availability rule. Use :remove_date_override to remove only a specific date override from an existing rule. No side effects.
 */
export const deleteAdminSchedulingAvailabilityRulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminSchedulingAvailabilityRulesByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminSchedulingAvailabilityRulesByIdResponses,
    DeleteAdminSchedulingAvailabilityRulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/availability-rules/{id}",
    ...options,
  });

/**
 * Fetch a single availability rule by ID
 *
 * Fetch a single availability rule by ID. Returns full rule with weekly_schedule and date_overrides embeds.
 */
export const getAdminSchedulingAvailabilityRulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingAvailabilityRulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingAvailabilityRulesByIdResponses,
    GetAdminSchedulingAvailabilityRulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/availability-rules/{id}",
    ...options,
  });

/**
 * Update an availability rule's schedule, date overrides, or active period
 *
 * Update an availability rule's schedule, date overrides, or active period. Use :set_weekly_hours/:add_date_override/:remove_date_override for structured schedule management via AI tools.
 */
export const patchAdminSchedulingAvailabilityRulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSchedulingAvailabilityRulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingAvailabilityRulesByIdResponses,
    PatchAdminSchedulingAvailabilityRulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/availability-rules/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all subscription plans and add-ons available in the system
 *
 * List all subscription plans and add-ons available in the system. Use this to display a
 * plan selection UI or to enumerate all plans for management. Returns both base plans
 * (is_addon: false) and add-ons (is_addon: true), scoped to the calling application.
 *
 * Supports keyset and offset pagination. Readable by anyone (unauthenticated).
 *
 */
export const getAdminPlans = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPlansData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPlansResponses,
    GetAdminPlansErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plans",
    ...options,
  });

/**
 * Create a new subscription plan or add-on for an application
 *
 * Create a new subscription plan or add-on for an application. Sets pricing, monthly credit
 * allocation, storage limits, and billing interval. Use this during ISV onboarding or when
 * launching a new pricing tier. Scoped to an application via application_id (inferred from
 * the x-application-key header when not provided).
 *
 * Requires Platform Admin or Application Owner role. Returns the created plan record.
 *
 */
export const postAdminPlans = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminPlansData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPlansResponses,
    PostAdminPlansErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plans",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/intake-targets/archived operation on clinical-intake-target resource
 *
 * /clinical/intake-targets/archived operation on clinical-intake-target resource
 */
export const getAdminClinicalIntakeTargetsArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalIntakeTargetsArchivedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalIntakeTargetsArchivedResponses,
    GetAdminClinicalIntakeTargetsArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/intake-targets/archived",
    ...options,
  });

/**
 * /clinical/note-templates/:id/archive operation on clinical-note-template resource
 *
 * /clinical/note-templates/:id/archive operation on clinical-note-template resource
 */
export const patchAdminClinicalNoteTemplatesByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalNoteTemplatesByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalNoteTemplatesByIdArchiveResponses,
    PatchAdminClinicalNoteTemplatesByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Step 1 of 2 in the two-step upload flow
 *
 * Step 1 of 2 in the two-step upload flow. Reserves a presigned S3 PUT URL for the client to
 * upload the file directly to object storage. Credits are checked at this point (Layer 1 of
 * the three-layer credit defense). Hash validation normalizes the `file_hash` to prefixed
 * format (e.g., `blake3:...` or `sha256:...`).
 *
 * Call `:finish_upload` after the client has PUT the file to the returned URL to enqueue
 * processing. For deduplication, prefer `:find_or_begin_upload` which returns an existing
 * document instead of creating a new one if the content hash already exists.
 *
 * Side effects: creates a StorageFile record in the processing bucket, captures actor and
 * request context (IP, UA, request ID) for the audit trail.
 *
 * Returns the document struct with `status: :queued` and an `upload_url` calculation populated.
 *
 */
export const postAdminExtractionDocumentsBeginUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminExtractionDocumentsBeginUploadData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminExtractionDocumentsBeginUploadResponses,
    PostAdminExtractionDocumentsBeginUploadErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/begin-upload",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/rules operation on invoices-rule resource
 *
 * /invoices/rules operation on invoices-rule resource
 */
export const postAdminInvoicesRules = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminInvoicesRulesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminInvoicesRulesResponses,
    PostAdminInvoicesRulesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/rules",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/sessions/:id/session_notes operation on clinical-note resource
 *
 * /clinical/sessions/:id/session_notes operation on clinical-note resource
 */
export const getAdminClinicalSessionsByIdSessionNotes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalSessionsByIdSessionNotesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSessionsByIdSessionNotesResponses,
    GetAdminClinicalSessionsByIdSessionNotesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/sessions/{id}/session_notes",
    ...options,
  });

/**
 * Initiate OAuth flow for a connector type
 *
 * Initiate OAuth flow for a connector type. Returns auth_url and state.
 */
export const postAdminConnectorsOauthInitiate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminConnectorsOauthInitiateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsOauthInitiateResponses,
    PostAdminConnectorsOauthInitiateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/oauth/initiate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /campaigns/recipients/:id operation on email-marketing-recipient resource
 *
 * /campaigns/recipients/:id operation on email-marketing-recipient resource
 */
export const getAdminCampaignsRecipientsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCampaignsRecipientsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCampaignsRecipientsByIdResponses,
    GetAdminCampaignsRecipientsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/recipients/{id}",
    ...options,
  });

/**
 * /connectors/sync-logs/:id operation on sync-log resource
 *
 * /connectors/sync-logs/:id operation on sync-log resource
 */
export const getAdminConnectorsSyncLogsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminConnectorsSyncLogsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminConnectorsSyncLogsByIdResponses,
    GetAdminConnectorsSyncLogsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/sync-logs/{id}",
    ...options,
  });

/**
 * /voice/sessions/:id operation on voice-session resource
 *
 * /voice/sessions/:id operation on voice-session resource
 */
export const deleteAdminVoiceSessionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminVoiceSessionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminVoiceSessionsByIdResponses,
    DeleteAdminVoiceSessionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/sessions/{id}",
    ...options,
  });

/**
 * /voice/sessions/:id operation on voice-session resource
 *
 * /voice/sessions/:id operation on voice-session resource
 */
export const getAdminVoiceSessionsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminVoiceSessionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminVoiceSessionsByIdResponses,
    GetAdminVoiceSessionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/sessions/{id}",
    ...options,
  });

/**
 * /clinical/client-medications/:id/restore operation on clinical-client-medication resource
 *
 * /clinical/client-medications/:id/restore operation on clinical-client-medication resource
 */
export const patchAdminClinicalClientMedicationsByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalClientMedicationsByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientMedicationsByIdRestoreResponses,
    PatchAdminClinicalClientMedicationsByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-medications/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Trigger a Meilisearch reindex for all or a specific subset of indexes (users, tenants, documents)
 *
 * Trigger a Meilisearch reindex for all or a specific subset of indexes (users, tenants, documents). Platform admin access only. No-op in test environment. Returns a status acknowledgement.
 */
export const postAdminSearchReindex = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSearchReindexData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSearchReindexResponses,
    PostAdminSearchReindexErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/reindex",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/:id/approve operation on invoices-invoice resource
 *
 * /invoices/:id/approve operation on invoices-invoice resource
 */
export const patchAdminInvoicesByIdApprove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesByIdApproveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesByIdApproveResponses,
    PatchAdminInvoicesByIdApproveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}/approve",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /webhook-configs/:id operation on webhook-config resource
 *
 * /webhook-configs/:id operation on webhook-config resource
 */
export const deleteAdminWebhookConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminWebhookConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminWebhookConfigsByIdResponses,
    DeleteAdminWebhookConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-configs/{id}",
    ...options,
  });

/**
 * /webhook-configs/:id operation on webhook-config resource
 *
 * /webhook-configs/:id operation on webhook-config resource
 */
export const getAdminWebhookConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWebhookConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWebhookConfigsByIdResponses,
    GetAdminWebhookConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-configs/{id}",
    ...options,
  });

/**
 * Update webhook endpoint settings such as URL, subscribed events, and enabled state
 *
 * Update webhook endpoint settings such as URL, subscribed events, and enabled state. Use :rotate_secret instead to change the HMAC signing secret.
 */
export const patchAdminWebhookConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWebhookConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWebhookConfigsByIdResponses,
    PatchAdminWebhookConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-configs/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /support/sync-configs/:id operation on support-sync-config resource
 *
 * /support/sync-configs/:id operation on support-sync-config resource
 */
export const deleteAdminSupportSyncConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSupportSyncConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSupportSyncConfigsByIdResponses,
    DeleteAdminSupportSyncConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/sync-configs/{id}",
    ...options,
  });

/**
 * Update sync configuration: toggle enabled, change direction, update status mapping, or adjust interval
 *
 * Update sync configuration: toggle enabled, change direction, update status mapping, or adjust interval. TicketSyncWorker reads this config before each sync run.
 */
export const patchAdminSupportSyncConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSupportSyncConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSupportSyncConfigsByIdResponses,
    PatchAdminSupportSyncConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/sync-configs/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List node executions for a pipeline execution, ordered by started_at.
 *
 * List node executions for a pipeline execution, ordered by started_at.
 */
export const getAdminPipelineNodeExecutionsByExecutionByPipelineExecutionId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminPipelineNodeExecutionsByExecutionByPipelineExecutionIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminPipelineNodeExecutionsByExecutionByPipelineExecutionIdResponses,
    GetAdminPipelineNodeExecutionsByExecutionByPipelineExecutionIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-node-executions/by-execution/{pipeline_execution_id}",
    ...options,
  });

/**
 * Link a product variant to an option value (e.g., assign 'Red' to a specific variant)
 *
 * Link a product variant to an option value (e.g., assign 'Red' to a specific variant). Returns the created join record.
 */
export const postAdminCatalogVariantOptionValues = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCatalogVariantOptionValuesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogVariantOptionValuesResponses,
    PostAdminCatalogVariantOptionValuesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/variant-option-values",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Destroy every refresh token for the current user
 *
 * Destroy every refresh token for the current user. Used by the
 * "sign out of all devices" UI. Emits a single aggregated
 * identity.session.logout with a count field (O2).
 *
 */
export const patchAdminUsersAuthSessionsRevokeAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminUsersAuthSessionsRevokeAllData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminUsersAuthSessionsRevokeAllResponses,
    PatchAdminUsersAuthSessionsRevokeAllErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/auth/sessions/revoke-all",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List reminders for a workspace
 *
 * List reminders for a workspace. Supports filtering by event_id or status.
 */
export const getAdminSchedulingReminders = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingRemindersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingRemindersResponses,
    GetAdminSchedulingRemindersErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/reminders",
    ...options,
  });

/**
 * Create a scheduled reminder for an event participant
 *
 * Create a scheduled reminder for an event participant. scheduled_at must be precomputed (event.start_time - minutes_before). Auto-called by ScheduleReminders change on Event create. Returns the created Reminder with :pending status.
 */
export const postAdminSchedulingReminders = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSchedulingRemindersData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSchedulingRemindersResponses,
    PostAdminSchedulingRemindersErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/reminders",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Admin-only email update
 *
 * Admin-only email update
 */
export const patchAdminUsersByIdAdminEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminUsersByIdAdminEmailData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminUsersByIdAdminEmailResponses,
    PatchAdminUsersByIdAdminEmailErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/{id}/admin/email",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * ISV-friendly semantic search over training examples
 *
 * ISV-friendly semantic search over training examples. Accepts a string `query`, embeds it
 * server-side via `GptCore.Embeddings.generate/1`, then delegates to `:search_by_vector`.
 *
 * Use this from public API surfaces; use `:search_by_vector` directly only when the caller
 * already has a precomputed embedding (e.g., the extraction pipeline reusing an embedding).
 *
 */
export const postAdminTrainingExamplesSearch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminTrainingExamplesSearchData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTrainingExamplesSearchResponses,
    PostAdminTrainingExamplesSearchErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-examples/search",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/:id/resolve-dispute operation on invoices-invoice resource
 *
 * /invoices/:id/resolve-dispute operation on invoices-invoice resource
 */
export const patchAdminInvoicesByIdResolveDispute = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesByIdResolveDisputeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesByIdResolveDisputeResponses,
    PatchAdminInvoicesByIdResolveDisputeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}/resolve-dispute",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/meal-plans/by-workspace operation on clinical-meal-plan resource
 *
 * /clinical/meal-plans/by-workspace operation on clinical-meal-plan resource
 */
export const getAdminClinicalMealPlansByWorkspace = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalMealPlansByWorkspaceData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalMealPlansByWorkspaceResponses,
    GetAdminClinicalMealPlansByWorkspaceErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/meal-plans/by-workspace",
    ...options,
  });

/**
 * /accounts/:id/debit operation on account resource
 *
 * /accounts/:id/debit operation on account resource
 */
export const patchAdminAccountsByIdDebit = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminAccountsByIdDebitData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAccountsByIdDebitResponses,
    PatchAdminAccountsByIdDebitErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/accounts/{id}/debit",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /catalog/price-suggestions/:id operation on catalog-price-suggestion resource
 *
 * /catalog/price-suggestions/:id operation on catalog-price-suggestion resource
 */
export const getAdminCatalogPriceSuggestionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCatalogPriceSuggestionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCatalogPriceSuggestionsByIdResponses,
    GetAdminCatalogPriceSuggestionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/price-suggestions/{id}",
    ...options,
  });

/**
 * /payment-methods/:id operation on payment-method resource
 *
 * /payment-methods/:id operation on payment-method resource
 */
export const deleteAdminPaymentMethodsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminPaymentMethodsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminPaymentMethodsByIdResponses,
    DeleteAdminPaymentMethodsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/payment-methods/{id}",
    ...options,
  });

/**
 * /payment-methods/:id operation on payment-method resource
 *
 * /payment-methods/:id operation on payment-method resource
 */
export const getAdminPaymentMethodsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPaymentMethodsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPaymentMethodsByIdResponses,
    GetAdminPaymentMethodsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/payment-methods/{id}",
    ...options,
  });

/**
 * Update a saved payment method's nickname or default status
 *
 * Update a saved payment method's nickname or default status. Use this to rename a card
 * (e.g., "Personal Visa") or to mark it as the default payment method. When is_default is
 * set to true, all other payment methods for the same customer are automatically unset.
 *
 * Requires Tenant Owner role. Returns the updated payment method record.
 *
 */
export const patchAdminPaymentMethodsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPaymentMethodsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPaymentMethodsByIdResponses,
    PatchAdminPaymentMethodsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/payment-methods/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/insurance-authorizations/by-workspace operation on clinical-insurance-authorization resource
 *
 * /clinical/insurance-authorizations/by-workspace operation on clinical-insurance-authorization resource
 */
export const getAdminClinicalInsuranceAuthorizationsByWorkspace = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalInsuranceAuthorizationsByWorkspaceData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalInsuranceAuthorizationsByWorkspaceResponses,
    GetAdminClinicalInsuranceAuthorizationsByWorkspaceErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/insurance-authorizations/by-workspace",
    ...options,
  });

/**
 * /clinical/practice-resources/catalog operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/catalog operation on clinical-practice-resource resource
 */
export const getAdminClinicalPracticeResourcesCatalog = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPracticeResourcesCatalogData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeResourcesCatalogResponses,
    GetAdminClinicalPracticeResourcesCatalogErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/catalog",
    ...options,
  });

/**
 * /clinical/practice-resources/catalog operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/catalog operation on clinical-practice-resource resource
 */
export const postAdminClinicalPracticeResourcesCatalog = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalPracticeResourcesCatalogData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalPracticeResourcesCatalogResponses,
    PostAdminClinicalPracticeResourcesCatalogErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/catalog",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /amendment-requests operation on amendment-request resource
 *
 * /amendment-requests operation on amendment-request resource
 */
export const getAdminAmendmentRequests = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAmendmentRequestsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAmendmentRequestsResponses,
    GetAdminAmendmentRequestsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/amendment-requests",
    ...options,
  });

/**
 * /amendment-requests operation on amendment-request resource
 *
 * /amendment-requests operation on amendment-request resource
 */
export const postAdminAmendmentRequests = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminAmendmentRequestsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAmendmentRequestsResponses,
    PostAdminAmendmentRequestsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/amendment-requests",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-tools/:id/archive operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/:id/archive operation on clinical-practice-tool resource
 */
export const patchAdminClinicalPracticeToolsByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalPracticeToolsByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPracticeToolsByIdArchiveResponses,
    PatchAdminClinicalPracticeToolsByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Void a transaction
 *
 * Void a transaction
 */
export const postAdminTransactionsByIdVoid = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminTransactionsByIdVoidData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTransactionsByIdVoidResponses,
    PostAdminTransactionsByIdVoidErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/transactions/{id}/void",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create an option type (e.g., Size, Color) for an application; shared across all tenants
 *
 * Create an option type (e.g., Size, Color) for an application; shared across all tenants. Returns the created option type.
 */
export const postAdminCatalogOptionTypes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCatalogOptionTypesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogOptionTypesResponses,
    PostAdminCatalogOptionTypesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/option-types",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /meeting-action-items/:id operation on meeting-action-item resource
 *
 * /meeting-action-items/:id operation on meeting-action-item resource
 */
export const getAdminMeetingActionItemsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminMeetingActionItemsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminMeetingActionItemsByIdResponses,
    GetAdminMeetingActionItemsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/meeting-action-items/{id}",
    ...options,
  });

/**
 * /recipes/enrichment-jobs/:id operation on recipes-enrichment-job resource
 *
 * /recipes/enrichment-jobs/:id operation on recipes-enrichment-job resource
 */
export const getAdminRecipesEnrichmentJobsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesEnrichmentJobsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesEnrichmentJobsByIdResponses,
    GetAdminRecipesEnrichmentJobsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/enrichment-jobs/{id}",
    ...options,
  });

/**
 * /recipes/scheduled-meals/:id operation on recipes-scheduled-meal resource
 *
 * /recipes/scheduled-meals/:id operation on recipes-scheduled-meal resource
 */
export const deleteAdminRecipesScheduledMealsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminRecipesScheduledMealsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRecipesScheduledMealsByIdResponses,
    DeleteAdminRecipesScheduledMealsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/scheduled-meals/{id}",
    ...options,
  });

/**
 * /recipes/scheduled-meals/:id operation on recipes-scheduled-meal resource
 *
 * /recipes/scheduled-meals/:id operation on recipes-scheduled-meal resource
 */
export const getAdminRecipesScheduledMealsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesScheduledMealsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesScheduledMealsByIdResponses,
    GetAdminRecipesScheduledMealsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/scheduled-meals/{id}",
    ...options,
  });

/**
 * /recipes/scheduled-meals/:id operation on recipes-scheduled-meal resource
 *
 * /recipes/scheduled-meals/:id operation on recipes-scheduled-meal resource
 */
export const patchAdminRecipesScheduledMealsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRecipesScheduledMealsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesScheduledMealsByIdResponses,
    PatchAdminRecipesScheduledMealsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/scheduled-meals/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /subscriptions/:id operation on subscription resource
 *
 * /subscriptions/:id operation on subscription resource
 */
export const getAdminSubscriptionsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSubscriptionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSubscriptionsByIdResponses,
    GetAdminSubscriptionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/subscriptions/{id}",
    ...options,
  });

/**
 * /subscriptions/:id operation on subscription resource
 *
 * /subscriptions/:id operation on subscription resource
 */
export const patchAdminSubscriptionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSubscriptionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSubscriptionsByIdResponses,
    PatchAdminSubscriptionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/subscriptions/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/documents/patients/:id/documents operation on clinical-document resource
 *
 * /clinical/documents/patients/:id/documents operation on clinical-document resource
 */
export const getAdminClinicalDocumentsPatientsByIdDocuments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalDocumentsPatientsByIdDocumentsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalDocumentsPatientsByIdDocumentsResponses,
    GetAdminClinicalDocumentsPatientsByIdDocumentsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/documents/patients/{id}/documents",
    ...options,
  });

/**
 * /user-profiles/:id operation on user-profile resource
 *
 * /user-profiles/:id operation on user-profile resource
 */
export const deleteAdminUserProfilesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminUserProfilesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminUserProfilesByIdResponses,
    DeleteAdminUserProfilesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/user-profiles/{id}",
    ...options,
  });

/**
 * /user-profiles/:id operation on user-profile resource
 *
 * /user-profiles/:id operation on user-profile resource
 */
export const getAdminUserProfilesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUserProfilesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUserProfilesByIdResponses,
    GetAdminUserProfilesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/user-profiles/{id}",
    ...options,
  });

/**
 * Update the user's display profile fields: name, avatar, bio, social links, and
 * raw preferences map
 *
 * Update the user's display profile fields: name, avatar, bio, social links, and
 * raw preferences map. Users can only update their own profile. Does not handle
 * legal-document acceptance, welcome dismissal, or announcement dismissal — use the
 * dedicated :accept_legal_document, :dismiss_welcome, and :dismiss_announcement
 * actions for those.
 *
 * Returns the updated UserProfile record.
 *
 */
export const patchAdminUserProfilesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminUserProfilesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminUserProfilesByIdResponses,
    PatchAdminUserProfilesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/user-profiles/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get full details for a single recipe by Edamam recipe ID
 *
 * Get full details for a single recipe by Edamam recipe ID
 */
export const postAdminConnectorsByIdEdamamRecipesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminConnectorsByIdEdamamRecipesGetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsByIdEdamamRecipesGetResponses,
    PostAdminConnectorsByIdEdamamRecipesGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/{id}/edamam/recipes/get",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /workspace-form-configs/:id operation on workspace-form-config resource
 *
 * /workspace-form-configs/:id operation on workspace-form-config resource
 */
export const deleteAdminWorkspaceFormConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminWorkspaceFormConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminWorkspaceFormConfigsByIdResponses,
    DeleteAdminWorkspaceFormConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-form-configs/{id}",
    ...options,
  });

/**
 * /workspace-form-configs/:id operation on workspace-form-config resource
 *
 * /workspace-form-configs/:id operation on workspace-form-config resource
 */
export const getAdminWorkspaceFormConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWorkspaceFormConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWorkspaceFormConfigsByIdResponses,
    GetAdminWorkspaceFormConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-form-configs/{id}",
    ...options,
  });

/**
 * /workspace-form-configs/:id operation on workspace-form-config resource
 *
 * /workspace-form-configs/:id operation on workspace-form-config resource
 */
export const patchAdminWorkspaceFormConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWorkspaceFormConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWorkspaceFormConfigsByIdResponses,
    PatchAdminWorkspaceFormConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-form-configs/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /case-types/:id operation on case-type resource
 *
 * /case-types/:id operation on case-type resource
 */
export const deleteAdminCaseTypesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminCaseTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCaseTypesByIdResponses,
    DeleteAdminCaseTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-types/{id}",
    ...options,
  });

/**
 * /case-types/:id operation on case-type resource
 *
 * /case-types/:id operation on case-type resource
 */
export const getAdminCaseTypesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCaseTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCaseTypesByIdResponses,
    GetAdminCaseTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-types/{id}",
    ...options,
  });

/**
 * /case-types/:id operation on case-type resource
 *
 * /case-types/:id operation on case-type resource
 */
export const patchAdminCaseTypesById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminCaseTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCaseTypesByIdResponses,
    PatchAdminCaseTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-types/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Preview the cost and effective date of a plan change
 *
 * Preview the cost and effective date of a plan change
 */
export const getAdminWalletPlanPreview = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminWalletPlanPreviewData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWalletPlanPreviewResponses,
    GetAdminWalletPlanPreviewErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/plan/preview",
    ...options,
  });

/**
 * /voice/transcription-results/:id operation on voice-transcription-result resource
 *
 * /voice/transcription-results/:id operation on voice-transcription-result resource
 */
export const deleteAdminVoiceTranscriptionResultsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminVoiceTranscriptionResultsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminVoiceTranscriptionResultsByIdResponses,
    DeleteAdminVoiceTranscriptionResultsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/transcription-results/{id}",
    ...options,
  });

/**
 * /voice/transcription-results/:id operation on voice-transcription-result resource
 *
 * /voice/transcription-results/:id operation on voice-transcription-result resource
 */
export const getAdminVoiceTranscriptionResultsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminVoiceTranscriptionResultsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminVoiceTranscriptionResultsByIdResponses,
    GetAdminVoiceTranscriptionResultsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/transcription-results/{id}",
    ...options,
  });

/**
 * Correct or annotate a transcript's text, segments, or metadata.
 *
 * Correct or annotate a transcript's text, segments, or metadata.
 */
export const patchAdminVoiceTranscriptionResultsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminVoiceTranscriptionResultsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminVoiceTranscriptionResultsByIdResponses,
    PatchAdminVoiceTranscriptionResultsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/transcription-results/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /pricing-strategies operation on pricing-strategy resource
 *
 * /pricing-strategies operation on pricing-strategy resource
 */
export const getAdminPricingStrategies = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPricingStrategiesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPricingStrategiesResponses,
    GetAdminPricingStrategiesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pricing-strategies",
    ...options,
  });

/**
 * /pricing-strategies operation on pricing-strategy resource
 *
 * /pricing-strategies operation on pricing-strategy resource
 */
export const postAdminPricingStrategies = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminPricingStrategiesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPricingStrategiesResponses,
    PostAdminPricingStrategiesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pricing-strategies",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/goal-templates/categories operation on clinical-goal-template-category resource
 *
 * /clinical/goal-templates/categories operation on clinical-goal-template-category resource
 */
export const getAdminClinicalGoalTemplatesCategories = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalGoalTemplatesCategoriesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalTemplatesCategoriesResponses,
    GetAdminClinicalGoalTemplatesCategoriesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/categories",
    ...options,
  });

/**
 * Get a document with its presigned view URL
 *
 * Get a document with its presigned view URL
 */
export const getAdminExtractionDocumentsByIdView = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionDocumentsByIdViewData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionDocumentsByIdViewResponses,
    GetAdminExtractionDocumentsByIdViewErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}/view",
    ...options,
  });

/**
 * /settlements/:id/mark-paid operation on settlement resource
 *
 * /settlements/:id/mark-paid operation on settlement resource
 */
export const patchAdminSettlementsByIdMarkPaid = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSettlementsByIdMarkPaidData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSettlementsByIdMarkPaidResponses,
    PatchAdminSettlementsByIdMarkPaidErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlements/{id}/mark-paid",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /extraction/chunk-entity-links/:id operation on chunk-entity-link resource
 *
 * /extraction/chunk-entity-links/:id operation on chunk-entity-link resource
 */
export const getAdminExtractionChunkEntityLinksById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionChunkEntityLinksByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionChunkEntityLinksByIdResponses,
    GetAdminExtractionChunkEntityLinksByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/chunk-entity-links/{id}",
    ...options,
  });

/**
 * List or fetch API keys
 *
 * List or fetch API keys. Supports keyset and offset pagination. Returns keys
 * scoped to the actor — users see only their own keys, ISV owners see keys for
 * their application. Use :active to restrict to non-revoked keys, or :usage_stats
 * for tenant-scoped usage analytics.
 *
 */
export const getAdminApiKeys = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminApiKeysData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminApiKeysResponses,
    GetAdminApiKeysErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/api-keys",
    ...options,
  });

/**
 * Create a new API key for the authenticated actor
 *
 * Create a new API key for the authenticated actor. The raw token value is returned
 * once in the generated_api_key calculation and never retrievable again. Key type
 * determines the prefix: :user → sk_tenant_, :server → sk_srv_, :application →
 * sk_app_, :system → sk_sys_. Application keys automatically receive all available
 * scopes. Server keys require at least one explicit scope and validate that the
 * creator can only delegate scopes they possess (scope delegation rule). A billing
 * liability account is created for the key after_action. Requires a valid
 * application context (x-application-key header or explicit application_id).
 *
 */
export const postAdminApiKeys = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminApiKeysData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminApiKeysResponses,
    PostAdminApiKeysErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/api-keys",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Return typeahead suggestions for a query prefix
 *
 * Return typeahead suggestions for a query prefix. Requires at least 2 characters; returns an empty list for shorter inputs. Scoped to the current tenant.
 */
export const getAdminSearchSuggest = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSearchSuggestData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSearchSuggestResponses,
    GetAdminSearchSuggestErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/suggest",
    ...options,
  });

/**
 * /extraction/config-enums/:id operation on config-enum resource
 *
 * /extraction/config-enums/:id operation on config-enum resource
 */
export const getAdminExtractionConfigEnumsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionConfigEnumsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionConfigEnumsByIdResponses,
    GetAdminExtractionConfigEnumsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/config-enums/{id}",
    ...options,
  });

/**
 * /extraction/config-enums/:id operation on config-enum resource
 *
 * /extraction/config-enums/:id operation on config-enum resource
 */
export const patchAdminExtractionConfigEnumsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminExtractionConfigEnumsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionConfigEnumsByIdResponses,
    PatchAdminExtractionConfigEnumsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/config-enums/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Soft-delete a document and enqueue storage cleanup
 *
 * Soft-delete a document and enqueue storage cleanup. Sets `deleted_at` rather than removing
 * the database row, so the document is hidden from all standard reads but preserves the audit
 * trail. Use `:read_trashed` to query soft-deleted documents.
 *
 * Side effects: enqueues `CleanupDocument` Oban job to remove files from object storage
 * (queue/active/output/errors paths). Also marks any associated ingestion watcher claim as
 * `document_deleted` so the same file can be re-uploaded without a duplicate-claim error.
 *
 * Returns the soft-deleted document struct with `deleted_at` set.
 *
 */
export const deleteAdminExtractionDocumentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminExtractionDocumentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminExtractionDocumentsByIdResponses,
    DeleteAdminExtractionDocumentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}",
    ...options,
  });

/**
 * Primary read for active (non-deleted) documents
 *
 * Primary read for active (non-deleted) documents. Excludes soft-deleted documents.
 * Use `:read_trashed` to list deleted documents, or `:list_by_workspace` for a workspace-scoped
 * listing with optional batch filtering.
 *
 */
export const getAdminExtractionDocumentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionDocumentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionDocumentsByIdResponses,
    GetAdminExtractionDocumentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}",
    ...options,
  });

/**
 * /catalog/product-classifications/:id operation on catalog-product-classification resource
 *
 * /catalog/product-classifications/:id operation on catalog-product-classification resource
 */
export const deleteAdminCatalogProductClassificationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminCatalogProductClassificationsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminCatalogProductClassificationsByIdResponses,
    DeleteAdminCatalogProductClassificationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/product-classifications/{id}",
    ...options,
  });

/**
 * /policy-review-schedules operation on policy-review-schedule resource
 *
 * /policy-review-schedules operation on policy-review-schedule resource
 */
export const getAdminPolicyReviewSchedules = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPolicyReviewSchedulesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPolicyReviewSchedulesResponses,
    GetAdminPolicyReviewSchedulesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/policy-review-schedules",
    ...options,
  });

/**
 * /policy-review-schedules operation on policy-review-schedule resource
 *
 * /policy-review-schedules operation on policy-review-schedule resource
 */
export const postAdminPolicyReviewSchedules = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminPolicyReviewSchedulesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPolicyReviewSchedulesResponses,
    PostAdminPolicyReviewSchedulesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/policy-review-schedules",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-supplements/archived operation on clinical-client-supplement resource
 *
 * /clinical/client-supplements/archived operation on clinical-client-supplement resource
 */
export const getAdminClinicalClientSupplementsArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalClientSupplementsArchivedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalClientSupplementsArchivedResponses,
    GetAdminClinicalClientSupplementsArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-supplements/archived",
    ...options,
  });

/**
 * Purchase credits (Top-up)
 *
 * Purchase credits (Top-up)
 */
export const patchAdminWalletCredits = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminWalletCreditsData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWalletCreditsResponses,
    PatchAdminWalletCreditsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/credits",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List legal documents scoped to the current application context, including platform-level documents (null application_id) and application-specific overrides
 *
 * List legal documents scoped to the current application context, including platform-level documents (null application_id) and application-specific overrides. Use this action to show an ISV's custom legal documents alongside platform defaults.
 */
export const getAdminLegalDocumentsForApplication = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminLegalDocumentsForApplicationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLegalDocumentsForApplicationResponses,
    GetAdminLegalDocumentsForApplicationErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/legal-documents/for-application",
    ...options,
  });

/**
 * /clinical/meal-plans/archived operation on clinical-meal-plan resource
 *
 * /clinical/meal-plans/archived operation on clinical-meal-plan resource
 */
export const getAdminClinicalMealPlansArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalMealPlansArchivedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalMealPlansArchivedResponses,
    GetAdminClinicalMealPlansArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/meal-plans/archived",
    ...options,
  });

/**
 * /recipes/favorites/:id operation on recipes-recipe-favorite resource
 *
 * /recipes/favorites/:id operation on recipes-recipe-favorite resource
 */
export const deleteAdminRecipesFavoritesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminRecipesFavoritesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRecipesFavoritesByIdResponses,
    DeleteAdminRecipesFavoritesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/favorites/{id}",
    ...options,
  });

/**
 * /recipes/favorites/:id operation on recipes-recipe-favorite resource
 *
 * /recipes/favorites/:id operation on recipes-recipe-favorite resource
 */
export const getAdminRecipesFavoritesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesFavoritesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesFavoritesByIdResponses,
    GetAdminRecipesFavoritesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/favorites/{id}",
    ...options,
  });

/**
 * /recipes/favorites/:id operation on recipes-recipe-favorite resource
 *
 * /recipes/favorites/:id operation on recipes-recipe-favorite resource
 */
export const patchAdminRecipesFavoritesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRecipesFavoritesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesFavoritesByIdResponses,
    PatchAdminRecipesFavoritesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/favorites/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Look up a credit package by its unique slug within an application (e.g., "starter-100",
 * "pro-500")
 *
 * Look up a credit package by its unique slug within an application (e.g., "starter-100",
 * "pro-500"). Use this for direct deep-linking into a purchase flow. Use read_one when
 * you have the UUID. Returns a single package or an error if the slug is not found.
 *
 */
export const getAdminCreditPackagesSlugBySlug = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCreditPackagesSlugBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCreditPackagesSlugBySlugResponses,
    GetAdminCreditPackagesSlugBySlugErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/credit-packages/slug/{slug}",
    ...options,
  });

/**
 * /accounts operation on account resource
 *
 * /accounts operation on account resource
 */
export const getAdminAccounts = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAccountsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAccountsResponses,
    GetAdminAccountsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/accounts",
    ...options,
  });

/**
 * Register a new user via invitation — skips personal tenant creation
 *
 * Register a new user via invitation — skips personal tenant creation
 */
export const postAdminUsersAuthRegisterViaInvitation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminUsersAuthRegisterViaInvitationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminUsersAuthRegisterViaInvitationResponses,
    PostAdminUsersAuthRegisterViaInvitationErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/auth/register-via-invitation",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get platform-wide storage statistics
 *
 * Get platform-wide storage statistics
 */
export const getAdminStorageStats = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminStorageStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminStorageStatsResponses,
    GetAdminStorageStatsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage/stats",
    ...options,
  });

/**
 * Cancel a pending or running job; sets status to :cancelled with completed_at timestamp
 *
 * Cancel a pending or running job; sets status to :cancelled with completed_at timestamp. No content is collected after cancellation.
 */
export const patchAdminCrawlerJobsByIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrawlerJobsByIdCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrawlerJobsByIdCancelResponses,
    PatchAdminCrawlerJobsByIdCancelErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/jobs/{id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/supplement-templates/catalog/:id/permanent operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/catalog/:id/permanent operation on clinical-supplement-template resource
 */
export const deleteAdminClinicalSupplementTemplatesCatalogByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalSupplementTemplatesCatalogByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalSupplementTemplatesCatalogByIdPermanentResponses,
    DeleteAdminClinicalSupplementTemplatesCatalogByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/catalog/{id}/permanent",
    ...options,
  });

/**
 * List connector instances in a workspace
 *
 * List connector instances in a workspace
 */
export const getAdminConnectorsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminConnectorsWorkspaceByWorkspaceIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminConnectorsWorkspaceByWorkspaceIdResponses,
    GetAdminConnectorsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/workspace/{workspace_id}",
    ...options,
  });

/**
 * /campaigns/sequences/:id/complete operation on email-marketing-sequence resource
 *
 * /campaigns/sequences/:id/complete operation on email-marketing-sequence resource
 */
export const patchAdminCampaignsSequencesByIdComplete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCampaignsSequencesByIdCompleteData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCampaignsSequencesByIdCompleteResponses,
    PatchAdminCampaignsSequencesByIdCompleteErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequences/{id}/complete",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get the latest extraction result for a document including partial (in-progress) results with per-field status
 *
 * Get the latest extraction result for a document including partial (in-progress) results with per-field status. Unlike get_by_document, this action skips FilterHiddenFields and always includes field_status and extraction metadata for progress tracking.
 */
export const getAdminExtractionResultsDocumentByDocumentIdPartial = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionResultsDocumentByDocumentIdPartialData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionResultsDocumentByDocumentIdPartialResponses,
    GetAdminExtractionResultsDocumentByDocumentIdPartialErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/results/document/{document_id}/partial",
    ...options,
  });

/**
 * Generate an image from a text prompt.
 *
 * Generate an image from a text prompt.
 */
export const postAdminContentGenerateImage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminContentGenerateImageData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminContentGenerateImageResponses,
    PostAdminContentGenerateImageErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/content/generate-image",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /breach-incidents/:id operation on breach-incident resource
 *
 * /breach-incidents/:id operation on breach-incident resource
 */
export const getAdminBreachIncidentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminBreachIncidentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBreachIncidentsByIdResponses,
    GetAdminBreachIncidentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/breach-incidents/{id}",
    ...options,
  });

/**
 * List active deals in a workspace with offset pagination
 *
 * List active deals in a workspace with offset pagination. Use instead of :read for workspace-scoped paginated listings.
 */
export const getAdminCrmDealsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrmDealsWorkspaceByWorkspaceIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmDealsWorkspaceByWorkspaceIdResponses,
    GetAdminCrmDealsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/deals/workspace/{workspace_id}",
    ...options,
  });

/**
 * List all custom field definitions for a given application and entity type
 *
 * List all custom field definitions for a given application and entity type. Use to build dynamic UI forms or validate entity properties.
 */
export const getAdminCrmFieldDefinitionsEntityTypeByEntityType = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmFieldDefinitionsEntityTypeByEntityTypeData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmFieldDefinitionsEntityTypeByEntityTypeResponses,
    GetAdminCrmFieldDefinitionsEntityTypeByEntityTypeErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/field-definitions/entity-type/{entity_type}",
    ...options,
  });

/**
 * /ownership-transfers operation on ownership-transfer resource
 *
 * /ownership-transfers operation on ownership-transfer resource
 */
export const getAdminOwnershipTransfers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminOwnershipTransfersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminOwnershipTransfersResponses,
    GetAdminOwnershipTransfersErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ownership-transfers",
    ...options,
  });

/**
 * Fetch a single event type by ID
 *
 * Fetch a single event type by ID. Returns full configuration including location embed, buffer times, capacity, and intake form schema.
 */
export const getAdminSchedulingEventTypesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingEventTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingEventTypesByIdResponses,
    GetAdminSchedulingEventTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/event-types/{id}",
    ...options,
  });

/**
 * Update event type configuration including duration, buffers, location, capacity, and intake form
 *
 * Update event type configuration including duration, buffers, location, capacity, and intake form. Location data is denormalized into LocationEmbed on write. Re-indexes in Meilisearch.
 */
export const patchAdminSchedulingEventTypesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSchedulingEventTypesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingEventTypesByIdResponses,
    PatchAdminSchedulingEventTypesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/event-types/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all price lists for an application, ordered by priority
 *
 * List all price lists for an application, ordered by priority. Returns a paginated list.
 */
export const getAdminCatalogPriceListsApplicationByApplicationId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogPriceListsApplicationByApplicationIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogPriceListsApplicationByApplicationIdResponses,
    GetAdminCatalogPriceListsApplicationByApplicationIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/price-lists/application/{application_id}",
    ...options,
  });

/**
 * Returns the four starter plan-bundle templates (seat-based, metered,
 * freemium-with-overage, developer-tier-prosumer)
 *
 * Returns the four starter plan-bundle templates (seat-based, metered,
 * freemium-with-overage, developer-tier-prosumer). Every price field in
 * the returned templates is `"placeholder_unset"` — the ISV MUST replace
 * every placeholder before calling `publish_bundle` (`publish_bundle`
 * refuses with 422 `:placeholder_unset` otherwise).
 *
 * Phase 1 skeleton: returns an empty list. Real templates land in Phase 4.
 *
 */
export const getAdminPlanBundlesTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPlanBundlesTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPlanBundlesTemplatesResponses,
    GetAdminPlanBundlesTemplatesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plan-bundles/templates",
    ...options,
  });

/**
 * /agents/:id/stats operation on agent-stats resource
 *
 * /agents/:id/stats operation on agent-stats resource
 */
export const getAdminAgentsByIdStats = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAgentsByIdStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentsByIdStatsResponses,
    GetAdminAgentsByIdStatsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/stats",
    ...options,
  });

/**
 * /cases operation on case resource
 *
 * /cases operation on case resource
 */
export const getAdminCases = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCasesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCasesResponses,
    GetAdminCasesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cases",
    ...options,
  });

/**
 * /cases operation on case resource
 *
 * /cases operation on case resource
 */
export const postAdminCases = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCasesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCasesResponses,
    PostAdminCasesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cases",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List soft-deleted (trashed) documents
 *
 * List soft-deleted (trashed) documents
 */
export const getAdminExtractionDocumentsWorkspaceByWorkspaceIdTrashed = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdTrashedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdTrashedResponses,
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdTrashedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/workspace/{workspace_id}/trashed",
    ...options,
  });

/**
 * /clinical/goal-templates/categories/catalog operation on clinical-goal-template-category resource
 *
 * /clinical/goal-templates/categories/catalog operation on clinical-goal-template-category resource
 */
export const getAdminClinicalGoalTemplatesCategoriesCatalog = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalGoalTemplatesCategoriesCatalogData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalTemplatesCategoriesCatalogResponses,
    GetAdminClinicalGoalTemplatesCategoriesCatalogErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/categories/catalog",
    ...options,
  });

/**
 * List active availability rules scoped to a specific event type
 *
 * List active availability rules scoped to a specific event type. Used by AvailabilityEngine when computing slots for a typed event (e.g., 30-min consultation).
 */
export const getAdminSchedulingAvailabilityRulesByEventType = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSchedulingAvailabilityRulesByEventTypeData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingAvailabilityRulesByEventTypeResponses,
    GetAdminSchedulingAvailabilityRulesByEventTypeErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/availability-rules/by-event-type",
    ...options,
  });

/**
 * Semantic search for entities by label similarity using embeddings
 *
 * Semantic search for entities by label similarity using embeddings.
 * Generates an embedding for the query and compares against entity labels.
 * Performance note: generates an embedding per entity label — capped at 200
 * entities. For larger graphs, use keyword search instead.
 *
 */
export const getAdminAiGraphNodesSemantic = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAiGraphNodesSemanticData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAiGraphNodesSemanticResponses,
    GetAdminAiGraphNodesSemanticErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/graph/nodes/semantic",
    ...options,
  });

/**
 * /clinical/notes/:id/restore operation on clinical-note resource
 *
 * /clinical/notes/:id/restore operation on clinical-note resource
 */
export const patchAdminClinicalNotesByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalNotesByIdRestoreData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalNotesByIdRestoreResponses,
    PatchAdminClinicalNotesByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /portal-change-requests/:id/approve operation on portal-change-request resource
 *
 * /portal-change-requests/:id/approve operation on portal-change-request resource
 */
export const patchAdminPortalChangeRequestsByIdApprove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPortalChangeRequestsByIdApproveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPortalChangeRequestsByIdApproveResponses,
    PatchAdminPortalChangeRequestsByIdApproveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/portal-change-requests/{id}/approve",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /brand-identities/:id/set-default operation on brand-identity resource
 *
 * /brand-identities/:id/set-default operation on brand-identity resource
 */
export const patchAdminBrandIdentitiesByIdSetDefault = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminBrandIdentitiesByIdSetDefaultData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminBrandIdentitiesByIdSetDefaultResponses,
    PatchAdminBrandIdentitiesByIdSetDefaultErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/brand-identities/{id}/set-default",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Admin manually confirms user's email
 *
 * Admin manually confirms user's email
 */
export const patchAdminUsersByIdConfirmEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminUsersByIdConfirmEmailData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminUsersByIdConfirmEmailResponses,
    PatchAdminUsersByIdConfirmEmailErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/{id}/confirm-email",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/note-templates/:id/restore operation on clinical-note-template resource
 *
 * /clinical/note-templates/:id/restore operation on clinical-note-template resource
 */
export const patchAdminClinicalNoteTemplatesByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalNoteTemplatesByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalNoteTemplatesByIdRestoreResponses,
    PatchAdminClinicalNoteTemplatesByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List available events that can be subscribed to
 *
 * List available events that can be subscribed to
 */
export const getAdminWebhookConfigsByIdEvents = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWebhookConfigsByIdEventsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWebhookConfigsByIdEventsResponses,
    GetAdminWebhookConfigsByIdEventsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-configs/{id}/events",
    ...options,
  });

/**
 * /email-marketing/templates operation on email-marketing-template resource
 *
 * /email-marketing/templates operation on email-marketing-template resource
 */
export const postAdminEmailMarketingTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminEmailMarketingTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminEmailMarketingTemplatesResponses,
    PostAdminEmailMarketingTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/templates",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all ExtractionResults in a workspace, sorted newest first
 *
 * List all ExtractionResults in a workspace, sorted newest first. Useful for building a
 * workspace-level results dashboard. Hidden system fields are filtered.
 * Paginated: default 20, max 100 per page.
 *
 */
export const getAdminExtractionResultsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionResultsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionResultsWorkspaceByWorkspaceIdResponses,
    GetAdminExtractionResultsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/results/workspace/{workspace_id}",
    ...options,
  });

/**
 * Soft-delete an activity by setting deleted_at
 *
 * Soft-delete an activity by setting deleted_at. Excluded from standard reads after deletion. Publishes an ActivityDeleted event.
 */
export const deleteAdminCrmActivitiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmActivitiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmActivitiesByIdResponses,
    DeleteAdminCrmActivitiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/activities/{id}",
    ...options,
  });

/**
 * Fetch a single active activity by ID; excludes soft-deleted records.
 *
 * Fetch a single active activity by ID; excludes soft-deleted records.
 */
export const getAdminCrmActivitiesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCrmActivitiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmActivitiesByIdResponses,
    GetAdminCrmActivitiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/activities/{id}",
    ...options,
  });

/**
 * Update an activity's subject, body, sentiment, or AI-generated fields
 *
 * Update an activity's subject, body, sentiment, or AI-generated fields. Use :create for new activities; this action only modifies existing records.
 */
export const patchAdminCrmActivitiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmActivitiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmActivitiesByIdResponses,
    PatchAdminCrmActivitiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/activities/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create or replace a workspace preference by context_key
 *
 * Create or replace a workspace preference by context_key
 */
export const postAdminWorkspacePreferencesUpsert = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminWorkspacePreferencesUpsertData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminWorkspacePreferencesUpsertResponses,
    PostAdminWorkspacePreferencesUpsertErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-preferences/upsert",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /storage-recommendations/:id/accept operation on storage-recommendation resource
 *
 * /storage-recommendations/:id/accept operation on storage-recommendation resource
 */
export const patchAdminStorageRecommendationsByIdAccept = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminStorageRecommendationsByIdAcceptData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminStorageRecommendationsByIdAcceptResponses,
    PatchAdminStorageRecommendationsByIdAcceptErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-recommendations/{id}/accept",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/notes/:id/permanent operation on clinical-note resource
 *
 * /clinical/notes/:id/permanent operation on clinical-note resource
 */
export const deleteAdminClinicalNotesByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminClinicalNotesByIdPermanentData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalNotesByIdPermanentResponses,
    DeleteAdminClinicalNotesByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes/{id}/permanent",
    ...options,
  });

/**
 * Look up a pipeline by its system_slug scoped to an application
 *
 * Look up a pipeline by its system_slug scoped to an application. Use this for ISV-provisioned pipelines where the slug is a stable identifier that survives database resets.
 */
export const getAdminPipelinesBySlugBySlug = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPipelinesBySlugBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPipelinesBySlugBySlugResponses,
    GetAdminPipelinesBySlugBySlugErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipelines/by-slug/{slug}",
    ...options,
  });

/**
 * /storage-recommendations/pending operation on storage-recommendation resource
 *
 * /storage-recommendations/pending operation on storage-recommendation resource
 */
export const getAdminStorageRecommendationsPending = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminStorageRecommendationsPendingData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminStorageRecommendationsPendingResponses,
    GetAdminStorageRecommendationsPendingErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-recommendations/pending",
    ...options,
  });

/**
 * Update the human verification status of a completed document
 *
 * Update the human verification status of a completed document. Used after a reviewer
 * has confirmed or partially verified extracted fields. Sets `verification_status` to
 * `:partially_verified` or `:fully_verified`, records the verifying user, and updates
 * `avg_confidence` to reflect the post-correction confidence.
 *
 * Called internally by `ExtractionResult.save_corrections` after applying field corrections.
 *
 */
export const patchAdminExtractionDocumentsByIdVerification = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminExtractionDocumentsByIdVerificationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionDocumentsByIdVerificationResponses,
    PatchAdminExtractionDocumentsByIdVerificationErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}/verification",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Allocate credits to the account associated with this Application
 *
 * Allocate credits to the account associated with this Application
 */
export const patchAdminApplicationsByIdAllocateCredits = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminApplicationsByIdAllocateCreditsData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminApplicationsByIdAllocateCreditsResponses,
    PatchAdminApplicationsByIdAllocateCreditsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/{id}/allocate-credits",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /form-versions/:id operation on form-version resource
 *
 * /form-versions/:id operation on form-version resource
 */
export const deleteAdminFormVersionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminFormVersionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminFormVersionsByIdResponses,
    DeleteAdminFormVersionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-versions/{id}",
    ...options,
  });

/**
 * /form-versions/:id operation on form-version resource
 *
 * /form-versions/:id operation on form-version resource
 */
export const getAdminFormVersionsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminFormVersionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFormVersionsByIdResponses,
    GetAdminFormVersionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-versions/{id}",
    ...options,
  });

/**
 * /form-versions/:id operation on form-version resource
 *
 * /form-versions/:id operation on form-version resource
 */
export const patchAdminFormVersionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminFormVersionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminFormVersionsByIdResponses,
    PatchAdminFormVersionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-versions/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Accept a pending invitation as the authenticated recipient
 *
 * Accept a pending invitation as the authenticated recipient. The actor's
 * verified email is the identity proof — no token argument is required.
 * Use :accept for token-based acceptance from a fresh email link, or
 * :accept_by_token for unauthenticated token-only flows, or
 * :accept_by_user for sk_srv_ admin-side acceptance on behalf of a user.
 *
 * This action is intentionally User-only: SystemActor and Application
 * actors are rejected at the validation layer because the auth model
 * depends on a verified user email. Server-side flows must use
 * :accept_by_user.
 *
 */
export const patchAdminInvitationsByIdAcceptById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvitationsByIdAcceptByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvitationsByIdAcceptByIdResponses,
    PatchAdminInvitationsByIdAcceptByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invitations/{id}/accept-by-id",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Record a participant's RSVP: :accepted, :declined, or :tentative
 *
 * Record a participant's RSVP: :accepted, :declined, or :tentative. Sets responded_at timestamp. Use instead of :update when updating RSVP status.
 */
export const patchAdminSchedulingParticipantsByIdRespond = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminSchedulingParticipantsByIdRespondData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingParticipantsByIdRespondResponses,
    PatchAdminSchedulingParticipantsByIdRespondErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/participants/{id}/respond",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/goal-templates/catalog/archived operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/catalog/archived operation on clinical-goal-template resource
 */
export const getAdminClinicalGoalTemplatesCatalogArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalGoalTemplatesCatalogArchivedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalTemplatesCatalogArchivedResponses,
    GetAdminClinicalGoalTemplatesCatalogArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/catalog/archived",
    ...options,
  });

/**
 * /retention-policies/:id operation on retention-policy resource
 *
 * /retention-policies/:id operation on retention-policy resource
 */
export const deleteAdminRetentionPoliciesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminRetentionPoliciesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRetentionPoliciesByIdResponses,
    DeleteAdminRetentionPoliciesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/retention-policies/{id}",
    ...options,
  });

/**
 * /retention-policies/:id operation on retention-policy resource
 *
 * /retention-policies/:id operation on retention-policy resource
 */
export const getAdminRetentionPoliciesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRetentionPoliciesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRetentionPoliciesByIdResponses,
    GetAdminRetentionPoliciesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/retention-policies/{id}",
    ...options,
  });

/**
 * Modify the retention period, expiry action, or enabled state of an existing policy
 *
 * Modify the retention period, expiry action, or enabled state of an existing policy. Changes take effect on the next daily enforcement run.
 */
export const patchAdminRetentionPoliciesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRetentionPoliciesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRetentionPoliciesByIdResponses,
    PatchAdminRetentionPoliciesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/retention-policies/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/sender-profiles/workspace/:workspace_id operation on email-marketing-sender-profile resource
 *
 * /email-marketing/sender-profiles/workspace/:workspace_id operation on email-marketing-sender-profile resource
 */
export const getAdminEmailMarketingSenderProfilesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailMarketingSenderProfilesWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailMarketingSenderProfilesWorkspaceByWorkspaceIdResponses,
    GetAdminEmailMarketingSenderProfilesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/sender-profiles/workspace/{workspace_id}",
    ...options,
  });

/**
 * List contacts that have been soft-archived (deleted_at is set) in a workspace.
 *
 * List contacts that have been soft-archived (deleted_at is set) in a workspace.
 */
export const getAdminCrmContactsWorkspaceByWorkspaceIdArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmContactsWorkspaceByWorkspaceIdArchivedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmContactsWorkspaceByWorkspaceIdArchivedResponses,
    GetAdminCrmContactsWorkspaceByWorkspaceIdArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/contacts/workspace/{workspace_id}/archived",
    ...options,
  });

/**
 * /clinical/practice-tools operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools operation on clinical-practice-tool resource
 */
export const getAdminClinicalPracticeTools = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPracticeToolsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeToolsResponses,
    GetAdminClinicalPracticeToolsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools",
    ...options,
  });

/**
 * /clinical/practice-tools operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools operation on clinical-practice-tool resource
 */
export const postAdminClinicalPracticeTools = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalPracticeToolsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalPracticeToolsResponses,
    PostAdminClinicalPracticeToolsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/posts/:id/retry operation on social-post resource
 *
 * /social/posts/:id/retry operation on social-post resource
 */
export const patchAdminSocialPostsByIdRetry = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSocialPostsByIdRetryData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialPostsByIdRetryResponses,
    PatchAdminSocialPostsByIdRetryErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/posts/{id}/retry",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/supplement-rec-cache operation on clinical-supplement-rec-cache resource
 *
 * /clinical/supplement-rec-cache operation on clinical-supplement-rec-cache resource
 */
export const getAdminClinicalSupplementRecCache = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalSupplementRecCacheData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSupplementRecCacheResponses,
    GetAdminClinicalSupplementRecCacheErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-rec-cache",
    ...options,
  });

/**
 * /email-marketing/campaigns/workspace/:workspace_id operation on campaign resource
 *
 * /email-marketing/campaigns/workspace/:workspace_id operation on campaign resource
 */
export const getAdminEmailMarketingCampaignsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailMarketingCampaignsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailMarketingCampaignsWorkspaceByWorkspaceIdResponses,
    GetAdminEmailMarketingCampaignsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/campaigns/workspace/{workspace_id}",
    ...options,
  });

/**
 * /access-grants operation on access-grant resource
 *
 * /access-grants operation on access-grant resource
 */
export const getAdminAccessGrants = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAccessGrantsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAccessGrantsResponses,
    GetAdminAccessGrantsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/access-grants",
    ...options,
  });

/**
 * /access-grants operation on access-grant resource
 *
 * /access-grants operation on access-grant resource
 */
export const postAdminAccessGrants = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAccessGrantsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAccessGrantsResponses,
    PostAdminAccessGrantsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/access-grants",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Accept an invitation on behalf of a specific user (by user_id)
 *
 * Accept an invitation on behalf of a specific user (by user_id). Verifies that
 * the user's email matches the invitation email and the invitation is still pending
 * and not expired. Creates or upgrades tenant/workspace memberships using
 * highest-privilege-wins semantics. Logs an invitation_accepted audit event.
 * Use :accept for token-based acceptance by the authenticated actor, or
 * :accept_by_token for token-only flows (registration redirect).
 *
 */
export const patchAdminInvitationsByIdAcceptByUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvitationsByIdAcceptByUserData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvitationsByIdAcceptByUserResponses,
    PatchAdminInvitationsByIdAcceptByUserErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invitations/{id}/accept-by-user",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Deactivate a system message, removing it from the live feed without deleting it
 *
 * Deactivate a system message, removing it from the live feed without deleting it. Use :publish to re-activate.
 */
export const patchAdminSystemMessagesByIdUnpublish = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSystemMessagesByIdUnpublishData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSystemMessagesByIdUnpublishResponses,
    PatchAdminSystemMessagesByIdUnpublishErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/system-messages/{id}/unpublish",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Filter documents by workspace_id and processing status
 *
 * Filter documents by workspace_id and processing status
 */
export const getAdminExtractionDocumentsWorkspaceByWorkspaceIdByStatusByStatus =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAdminExtractionDocumentsWorkspaceByWorkspaceIdByStatusByStatusData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetAdminExtractionDocumentsWorkspaceByWorkspaceIdByStatusByStatusResponses,
      GetAdminExtractionDocumentsWorkspaceByWorkspaceIdByStatusByStatusErrors,
      ThrowOnError
    >({
      querySerializer: {
        parameters: {
          filter: { object: { style: "form" } },
          page: { object: { style: "form" } },
          fields: { object: { style: "form" } },
        },
      },
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/extraction/documents/workspace/{workspace_id}/by-status/{status}",
      ...options,
    });

/**
 * /threads operation on chat-thread resource
 *
 * /threads operation on chat-thread resource
 */
export const getAdminThreads = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminThreadsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminThreadsResponses,
    GetAdminThreadsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads",
    ...options,
  });

/**
 * Create a new conversation thread scoped to a tenant, workspace, and user
 *
 * Create a new conversation thread scoped to a tenant, workspace, and user. Optionally set `previous_thread_id` to link to an expired thread for context carryover. Returns the new Thread resource.
 */
export const postAdminThreads = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminThreadsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminThreadsResponses,
    PostAdminThreadsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create or update credentials for a connector at a specific scope level
 *
 * Create or update credentials for a connector at a specific scope level.
 * If credentials already exist for the given connector_type + scope_level + workspace,
 * they are updated. Otherwise, new credentials are created. Returns the credential.
 *
 */
export const postAdminConnectorsCredentialsUpsert = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminConnectorsCredentialsUpsertData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsCredentialsUpsertResponses,
    PostAdminConnectorsCredentialsUpsertErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/credentials/upsert",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List recipes in a collection
 *
 * List recipes in a collection
 */
export const getAdminRecipesCollectionRecipesCollectionByCollectionId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesCollectionRecipesCollectionByCollectionIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesCollectionRecipesCollectionByCollectionIdResponses,
    GetAdminRecipesCollectionRecipesCollectionByCollectionIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/collection-recipes/collection/{collection_id}",
    ...options,
  });

/**
 * List all custom entity types defined for an application
 *
 * List all custom entity types defined for an application. Use to discover available entity schemas for dynamic UI rendering.
 */
export const getAdminIsvCrmEntityTypesApplicationByApplicationId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminIsvCrmEntityTypesApplicationByApplicationIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminIsvCrmEntityTypesApplicationByApplicationIdResponses,
    GetAdminIsvCrmEntityTypesApplicationByApplicationIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv/crm/entity-types/application/{application_id}",
    ...options,
  });

/**
 * List similar products from Fullscript
 *
 * List similar products from Fullscript
 */
export const postAdminConnectorsFullscriptProductsSimilar = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsFullscriptProductsSimilarData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsFullscriptProductsSimilarResponses,
    PostAdminConnectorsFullscriptProductsSimilarErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/fullscript/products/similar",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /compliance-document-templates/:id operation on compliance-document-template resource
 *
 * /compliance-document-templates/:id operation on compliance-document-template resource
 */
export const getAdminComplianceDocumentTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminComplianceDocumentTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminComplianceDocumentTemplatesByIdResponses,
    GetAdminComplianceDocumentTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-document-templates/{id}",
    ...options,
  });

/**
 * /compliance-document-templates/:id operation on compliance-document-template resource
 *
 * /compliance-document-templates/:id operation on compliance-document-template resource
 */
export const patchAdminComplianceDocumentTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminComplianceDocumentTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminComplianceDocumentTemplatesByIdResponses,
    PatchAdminComplianceDocumentTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-document-templates/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get activity feed for the user's tenant context
 *
 * Get activity feed for the user's tenant context
 */
export const getAdminUsersMeActivity = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUsersMeActivityData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUsersMeActivityResponses,
    GetAdminUsersMeActivityErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/me/activity",
    ...options,
  });

/**
 * /accounts/:id operation on account resource
 *
 * /accounts/:id operation on account resource
 */
export const getAdminAccountsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAccountsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAccountsByIdResponses,
    GetAdminAccountsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/accounts/{id}",
    ...options,
  });

/**
 * /extraction/shadow-comparisons/:id operation on shadow-comparison resource
 *
 * /extraction/shadow-comparisons/:id operation on shadow-comparison resource
 */
export const deleteAdminExtractionShadowComparisonsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminExtractionShadowComparisonsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminExtractionShadowComparisonsByIdResponses,
    DeleteAdminExtractionShadowComparisonsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/shadow-comparisons/{id}",
    ...options,
  });

/**
 * /extraction/shadow-comparisons/:id operation on shadow-comparison resource
 *
 * /extraction/shadow-comparisons/:id operation on shadow-comparison resource
 */
export const getAdminExtractionShadowComparisonsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionShadowComparisonsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionShadowComparisonsByIdResponses,
    GetAdminExtractionShadowComparisonsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/shadow-comparisons/{id}",
    ...options,
  });

/**
 * /email-marketing/templates/workspace/:workspace_id operation on email-marketing-template resource
 *
 * /email-marketing/templates/workspace/:workspace_id operation on email-marketing-template resource
 */
export const getAdminEmailMarketingTemplatesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailMarketingTemplatesWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailMarketingTemplatesWorkspaceByWorkspaceIdResponses,
    GetAdminEmailMarketingTemplatesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/templates/workspace/{workspace_id}",
    ...options,
  });

/**
 * /ai/messages operation on chat-ai-message resource
 *
 * /ai/messages operation on chat-ai-message resource
 */
export const getAdminAiMessages = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAiMessagesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAiMessagesResponses,
    GetAdminAiMessagesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/messages",
    ...options,
  });

/**
 * Append a new message turn (system, user, or assistant) to a Conversation
 *
 * Append a new message turn (system, user, or assistant) to a Conversation. Requires that the actor owns the parent conversation. Returns the created AiMessage.
 */
export const postAdminAiMessages = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAiMessagesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAiMessagesResponses,
    PostAdminAiMessagesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/messages",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/activities/:id operation on invoices-activity resource
 *
 * /invoices/activities/:id operation on invoices-activity resource
 */
export const getAdminInvoicesActivitiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminInvoicesActivitiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminInvoicesActivitiesByIdResponses,
    GetAdminInvoicesActivitiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/activities/{id}",
    ...options,
  });

/**
 * Create a payment method via direct proxy tokenization (S2S)
 *
 * Create a payment method via direct proxy tokenization (S2S)
 */
export const postAdminPaymentMethodsTokenize = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminPaymentMethodsTokenizeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPaymentMethodsTokenizeResponses,
    PostAdminPaymentMethodsTokenizeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/payment-methods/tokenize",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Predicts the best agents for a given input
 *
 * Predicts the best agents for a given input
 */
export const postAdminExtractionAgentsPredict = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminExtractionAgentsPredictData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminExtractionAgentsPredictResponses,
    PostAdminExtractionAgentsPredictErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/agents/predict",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Generate master copy from content brief using AI
 *
 * Generate master copy from content brief using AI. Transitions to :review on success.
 */
export const postAdminSocialCampaignsByIdGenerateMasterCopy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminSocialCampaignsByIdGenerateMasterCopyData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminSocialCampaignsByIdGenerateMasterCopyResponses,
    PostAdminSocialCampaignsByIdGenerateMasterCopyErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/campaigns/{id}/generate-master-copy",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Retrieve shadow comparison results for analysis
 *
 * Retrieve shadow comparison results for analysis
 */
export const getAdminExtractionShadowComparisonsAnalysis = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionShadowComparisonsAnalysisData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionShadowComparisonsAnalysisResponses,
    GetAdminExtractionShadowComparisonsAnalysisErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/shadow-comparisons/analysis",
    ...options,
  });

/**
 * Assign a ticket to an agent, setting status to :open
 *
 * Assign a ticket to an agent, setting status to :open. Stores the previous agent_id in __metadata__ for the Notifier to emit TicketAssigned event with reassignment context.
 */
export const patchAdminSupportTicketsByIdAssign = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSupportTicketsByIdAssignData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSupportTicketsByIdAssignResponses,
    PatchAdminSupportTicketsByIdAssignErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/tickets/{id}/assign",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /pipeline-executions/:id/reject operation on pipeline-execution resource
 *
 * /pipeline-executions/:id/reject operation on pipeline-execution resource
 */
export const patchAdminPipelineExecutionsByIdReject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPipelineExecutionsByIdRejectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPipelineExecutionsByIdRejectResponses,
    PatchAdminPipelineExecutionsByIdRejectErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-executions/{id}/reject",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /compliance-requirement-completions operation on compliance-requirement-completion resource
 *
 * /compliance-requirement-completions operation on compliance-requirement-completion resource
 */
export const getAdminComplianceRequirementCompletions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminComplianceRequirementCompletionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminComplianceRequirementCompletionsResponses,
    GetAdminComplianceRequirementCompletionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-requirement-completions",
    ...options,
  });

/**
 * /compliance-requirement-completions operation on compliance-requirement-completion resource
 *
 * /compliance-requirement-completions operation on compliance-requirement-completion resource
 */
export const postAdminComplianceRequirementCompletions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminComplianceRequirementCompletionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminComplianceRequirementCompletionsResponses,
    PostAdminComplianceRequirementCompletionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-requirement-completions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /sys/ai-config/:id operation on ai-config resource
 *
 * /sys/ai-config/:id operation on ai-config resource
 */
export const getAdminSysAiConfigById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSysAiConfigByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSysAiConfigByIdResponses,
    GetAdminSysAiConfigByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/sys/ai-config/{id}",
    ...options,
  });

/**
 * Update platform or application-level LLM provider config (default model, embedding model, domain overrides, fallback chains, pricing floor); validates fallback chain structure
 *
 * Update platform or application-level LLM provider config (default model, embedding model, domain overrides, fallback chains, pricing floor); validates fallback chain structure. Returns the updated config.
 */
export const patchAdminSysAiConfigById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminSysAiConfigByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSysAiConfigByIdResponses,
    PatchAdminSysAiConfigByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/sys/ai-config/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/shopping-list-items operation on recipes-shopping-list-item resource
 *
 * /recipes/shopping-list-items operation on recipes-shopping-list-item resource
 */
export const postAdminRecipesShoppingListItems = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminRecipesShoppingListItemsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesShoppingListItemsResponses,
    PostAdminRecipesShoppingListItemsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/shopping-list-items",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Transfer org ownership to an existing admin member
 *
 * Transfer org ownership to an existing admin member. Previous owner retains admin role.
 */
export const patchAdminTenantsByIdTransferOwnership = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminTenantsByIdTransferOwnershipData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTenantsByIdTransferOwnershipResponses,
    PatchAdminTenantsByIdTransferOwnershipErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}/transfer-ownership",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/notes/:note_id/versions/:id operation on clinical-note-version resource
 *
 * /clinical/notes/:note_id/versions/:id operation on clinical-note-version resource
 */
export const getAdminClinicalNotesByNoteIdVersionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalNotesByNoteIdVersionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNotesByNoteIdVersionsByIdResponses,
    GetAdminClinicalNotesByNoteIdVersionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes/{note_id}/versions/{id}",
    ...options,
  });

/**
 * /clinical/practice-resources/catalog/:id/restore operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/catalog/:id/restore operation on clinical-practice-resource resource
 */
export const patchAdminClinicalPracticeResourcesCatalogByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalPracticeResourcesCatalogByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPracticeResourcesCatalogByIdRestoreResponses,
    PatchAdminClinicalPracticeResourcesCatalogByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/catalog/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Mark the CaseType as inactive.
 *
 * Mark the CaseType as inactive.
 */
export const patchAdminCaseTypesByIdDeactivate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCaseTypesByIdDeactivateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCaseTypesByIdDeactivateResponses,
    PatchAdminCaseTypesByIdDeactivateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-types/{id}/deactivate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch a scoped, paginated activity feed for a tenant; optionally filter by workspace_id, activity_type, date range, or actor
 *
 * Fetch a scoped, paginated activity feed for a tenant; optionally filter by workspace_id, activity_type, date range, or actor. Sorted by created_at descending.
 */
export const getAdminAuditLogsActivity = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAuditLogsActivityData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAuditLogsActivityResponses,
    GetAdminAuditLogsActivityErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/audit-logs/activity",
    ...options,
  });

/**
 * /recipes/shopping-lists/:id operation on recipes-shopping-list resource
 *
 * /recipes/shopping-lists/:id operation on recipes-shopping-list resource
 */
export const deleteAdminRecipesShoppingListsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminRecipesShoppingListsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRecipesShoppingListsByIdResponses,
    DeleteAdminRecipesShoppingListsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/shopping-lists/{id}",
    ...options,
  });

/**
 * /recipes/shopping-lists/:id operation on recipes-shopping-list resource
 *
 * /recipes/shopping-lists/:id operation on recipes-shopping-list resource
 */
export const getAdminRecipesShoppingListsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesShoppingListsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesShoppingListsByIdResponses,
    GetAdminRecipesShoppingListsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/shopping-lists/{id}",
    ...options,
  });

/**
 * /recipes/shopping-lists/:id operation on recipes-shopping-list resource
 *
 * /recipes/shopping-lists/:id operation on recipes-shopping-list resource
 */
export const patchAdminRecipesShoppingListsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRecipesShoppingListsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesShoppingListsByIdResponses,
    PatchAdminRecipesShoppingListsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/shopping-lists/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/templates/:id/restore operation on email-marketing-template resource
 *
 * /email-marketing/templates/:id/restore operation on email-marketing-template resource
 */
export const patchAdminEmailMarketingTemplatesByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailMarketingTemplatesByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingTemplatesByIdRestoreResponses,
    PatchAdminEmailMarketingTemplatesByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/templates/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Change the main plan for the wallet
 *
 * Change the main plan for the wallet
 */
export const patchAdminWalletPlan = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminWalletPlanData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWalletPlanResponses,
    PatchAdminWalletPlanErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/plan",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get stats for the user's tenant context
 *
 * Get stats for the user's tenant context
 */
export const getAdminUsersMeStats = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUsersMeStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUsersMeStatsResponses,
    GetAdminUsersMeStatsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/me/stats",
    ...options,
  });

/**
 * Cancel a pending invitation by setting its status to :revoked
 *
 * Cancel a pending invitation by setting its status to :revoked. Only the original
 * inviter or the tenant owner can revoke. Logs an invitation_revoked audit event.
 * The token becomes invalid immediately. Use :expire for system-driven expiration.
 *
 */
export const patchAdminInvitationsByIdRevoke = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvitationsByIdRevokeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvitationsByIdRevokeResponses,
    PatchAdminInvitationsByIdRevokeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invitations/{id}/revoke",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/recipients operation on email-recipient resource
 *
 * /email/recipients operation on email-recipient resource
 */
export const postAdminEmailRecipients = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminEmailRecipientsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminEmailRecipientsResponses,
    PostAdminEmailRecipientsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/recipients",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Permanently delete a user account
 *
 * Permanently delete a user account. Cascades destruction of: owned tenants (which
 * in turn destroy their workspaces, applications, API keys, and billing accounts),
 * the user profile, user-owned API keys, all tenant memberships, all tokens, all
 * workspace memberships, notification preferences, and audit logs where the user was
 * the actor. Finally deletes the user row. Restricted to platform admins only.
 *
 */
export const deleteAdminUsersById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminUsersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminUsersByIdResponses,
    DeleteAdminUsersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/{id}",
    ...options,
  });

/**
 * /users/:id operation on user resource
 *
 * /users/:id operation on user resource
 */
export const getAdminUsersById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUsersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUsersByIdResponses,
    GetAdminUsersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/{id}",
    ...options,
  });

/**
 * Update user preferences (currently theme_preference)
 *
 * Update user preferences (currently theme_preference). Authenticated users can only update their own record.
 */
export const patchAdminUsersById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminUsersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminUsersByIdResponses,
    PatchAdminUsersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-resource-assignments/:id/permanent operation on clinical-client-resource-assignment resource
 *
 * /clinical/client-resource-assignments/:id/permanent operation on clinical-client-resource-assignment resource
 */
export const deleteAdminClinicalClientResourceAssignmentsByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalClientResourceAssignmentsByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalClientResourceAssignmentsByIdPermanentResponses,
    DeleteAdminClinicalClientResourceAssignmentsByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-resource-assignments/{id}/permanent",
    ...options,
  });

/**
 * /clinical/goal-template-collections/:id operation on clinical-goal-template-collection resource
 *
 * /clinical/goal-template-collections/:id operation on clinical-goal-template-collection resource
 */
export const deleteAdminClinicalGoalTemplateCollectionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalGoalTemplateCollectionsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalGoalTemplateCollectionsByIdResponses,
    DeleteAdminClinicalGoalTemplateCollectionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-template-collections/{id}",
    ...options,
  });

/**
 * /clinical/goal-template-collections/:id operation on clinical-goal-template-collection resource
 *
 * /clinical/goal-template-collections/:id operation on clinical-goal-template-collection resource
 */
export const getAdminClinicalGoalTemplateCollectionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalGoalTemplateCollectionsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalTemplateCollectionsByIdResponses,
    GetAdminClinicalGoalTemplateCollectionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-template-collections/{id}",
    ...options,
  });

/**
 * /clinical/goal-template-collections/:id operation on clinical-goal-template-collection resource
 *
 * /clinical/goal-template-collections/:id operation on clinical-goal-template-collection resource
 */
export const patchAdminClinicalGoalTemplateCollectionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalGoalTemplateCollectionsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalGoalTemplateCollectionsByIdResponses,
    PatchAdminClinicalGoalTemplateCollectionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-template-collections/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /settlement-statements/:id/mark-disputed operation on settlement-statement resource
 *
 * /settlement-statements/:id/mark-disputed operation on settlement-statement resource
 */
export const patchAdminSettlementStatementsByIdMarkDisputed = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminSettlementStatementsByIdMarkDisputedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminSettlementStatementsByIdMarkDisputedResponses,
    PatchAdminSettlementStatementsByIdMarkDisputedErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlement-statements/{id}/mark-disputed",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/goal-template-collection-memberships operation on clinical-goal-template-collection-membership resource
 *
 * /clinical/goal-template-collection-memberships operation on clinical-goal-template-collection-membership resource
 */
export const postAdminClinicalGoalTemplateCollectionMemberships = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminClinicalGoalTemplateCollectionMembershipsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminClinicalGoalTemplateCollectionMembershipsResponses,
    PostAdminClinicalGoalTemplateCollectionMembershipsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-template-collection-memberships",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Disable multiple webhook configs by ID in a single call
 *
 * Disable multiple webhook configs by ID in a single call. Only configs the actor is authorized to update are affected; returns `{success: true, count: N}` indicating how many were disabled.
 */
export const postAdminWebhookConfigsBulkDisable = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminWebhookConfigsBulkDisableData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminWebhookConfigsBulkDisableResponses,
    PostAdminWebhookConfigsBulkDisableErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-configs/bulk-disable",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /breach-notifications/:id operation on breach-notification resource
 *
 * /breach-notifications/:id operation on breach-notification resource
 */
export const getAdminBreachNotificationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminBreachNotificationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBreachNotificationsByIdResponses,
    GetAdminBreachNotificationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/breach-notifications/{id}",
    ...options,
  });

/**
 * /legal-documents operation on legal-document resource
 *
 * /legal-documents operation on legal-document resource
 */
export const getAdminLegalDocuments = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminLegalDocumentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLegalDocumentsResponses,
    GetAdminLegalDocumentsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/legal-documents",
    ...options,
  });

/**
 * Create a new versioned legal document (Terms of Service, Privacy Policy, BAA, DPA, or SCC)
 *
 * Create a new versioned legal document (Terms of Service, Privacy Policy, BAA, DPA, or SCC).
 * Setting `is_active: true` at creation time automatically records `published_at`. Use :publish
 * after drafting to activate with side effects (cache invalidation, user notification job).
 *
 */
export const postAdminLegalDocuments = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminLegalDocumentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminLegalDocumentsResponses,
    PostAdminLegalDocumentsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/legal-documents",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /agents/:id/usage operation on agent-usage resource
 *
 * /agents/:id/usage operation on agent-usage resource
 */
export const getAdminAgentsByIdUsage = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAgentsByIdUsageData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentsByIdUsageResponses,
    GetAdminAgentsByIdUsageErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/usage",
    ...options,
  });

/**
 * /email-marketing/generated-emails/:id/schedule operation on email-marketing-generated-email resource
 *
 * /email-marketing/generated-emails/:id/schedule operation on email-marketing-generated-email resource
 */
export const patchAdminEmailMarketingGeneratedEmailsByIdSchedule = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailMarketingGeneratedEmailsByIdScheduleData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingGeneratedEmailsByIdScheduleResponses,
    PatchAdminEmailMarketingGeneratedEmailsByIdScheduleErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/generated-emails/{id}/schedule",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/supplement-template-collection-memberships/:id operation on clinical-supplement-template-collection-membership resource
 *
 * /clinical/supplement-template-collection-memberships/:id operation on clinical-supplement-template-collection-membership resource
 */
export const deleteAdminClinicalSupplementTemplateCollectionMembershipsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalSupplementTemplateCollectionMembershipsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalSupplementTemplateCollectionMembershipsByIdResponses,
    DeleteAdminClinicalSupplementTemplateCollectionMembershipsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-template-collection-memberships/{id}",
    ...options,
  });

/**
 * /clinical/supplement-template-collection-memberships/:id operation on clinical-supplement-template-collection-membership resource
 *
 * /clinical/supplement-template-collection-memberships/:id operation on clinical-supplement-template-collection-membership resource
 */
export const getAdminClinicalSupplementTemplateCollectionMembershipsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalSupplementTemplateCollectionMembershipsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSupplementTemplateCollectionMembershipsByIdResponses,
    GetAdminClinicalSupplementTemplateCollectionMembershipsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-template-collection-memberships/{id}",
    ...options,
  });

/**
 * /clinical/supplement-template-collection-memberships/:id operation on clinical-supplement-template-collection-membership resource
 *
 * /clinical/supplement-template-collection-memberships/:id operation on clinical-supplement-template-collection-membership resource
 */
export const patchAdminClinicalSupplementTemplateCollectionMembershipsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalSupplementTemplateCollectionMembershipsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalSupplementTemplateCollectionMembershipsByIdResponses,
    PatchAdminClinicalSupplementTemplateCollectionMembershipsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-template-collection-memberships/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /catalog/stock-locations/:id operation on catalog-stock-location resource
 *
 * /catalog/stock-locations/:id operation on catalog-stock-location resource
 */
export const getAdminCatalogStockLocationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCatalogStockLocationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCatalogStockLocationsByIdResponses,
    GetAdminCatalogStockLocationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/stock-locations/{id}",
    ...options,
  });

/**
 * Update a location's name, address, default flag, status, or valuation method
 *
 * Update a location's name, address, default flag, status, or valuation method. Returns the updated location.
 */
export const patchAdminCatalogStockLocationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCatalogStockLocationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogStockLocationsByIdResponses,
    PatchAdminCatalogStockLocationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/stock-locations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/tracking-events/:id operation on email-tracking-event resource
 *
 * /email/tracking-events/:id operation on email-tracking-event resource
 */
export const getAdminEmailTrackingEventsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminEmailTrackingEventsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEmailTrackingEventsByIdResponses,
    GetAdminEmailTrackingEventsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/tracking-events/{id}",
    ...options,
  });

/**
 * /recipes/ingredients/:id operation on recipes-ingredient resource
 *
 * /recipes/ingredients/:id operation on recipes-ingredient resource
 */
export const deleteAdminRecipesIngredientsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminRecipesIngredientsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRecipesIngredientsByIdResponses,
    DeleteAdminRecipesIngredientsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/ingredients/{id}",
    ...options,
  });

/**
 * /recipes/ingredients/:id operation on recipes-ingredient resource
 *
 * /recipes/ingredients/:id operation on recipes-ingredient resource
 */
export const getAdminRecipesIngredientsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesIngredientsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesIngredientsByIdResponses,
    GetAdminRecipesIngredientsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/ingredients/{id}",
    ...options,
  });

/**
 * /recipes/ingredients/:id operation on recipes-ingredient resource
 *
 * /recipes/ingredients/:id operation on recipes-ingredient resource
 */
export const patchAdminRecipesIngredientsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRecipesIngredientsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesIngredientsByIdResponses,
    PatchAdminRecipesIngredientsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/ingredients/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/patients/:id/resource_assignments operation on clinical-client-resource-assignment resource
 *
 * /clinical/patients/:id/resource_assignments operation on clinical-client-resource-assignment resource
 */
export const getAdminClinicalPatientsByIdResourceAssignments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalPatientsByIdResourceAssignmentsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPatientsByIdResourceAssignmentsResponses,
    GetAdminClinicalPatientsByIdResourceAssignmentsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patients/{id}/resource_assignments",
    ...options,
  });

/**
 * Mark the CaseType as active.
 *
 * Mark the CaseType as active.
 */
export const patchAdminCaseTypesByIdActivate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCaseTypesByIdActivateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCaseTypesByIdActivateResponses,
    PatchAdminCaseTypesByIdActivateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-types/{id}/activate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/sender-profiles/:id operation on email-marketing-sender-profile resource
 *
 * /email-marketing/sender-profiles/:id operation on email-marketing-sender-profile resource
 */
export const deleteAdminEmailMarketingSenderProfilesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminEmailMarketingSenderProfilesByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminEmailMarketingSenderProfilesByIdResponses,
    DeleteAdminEmailMarketingSenderProfilesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/sender-profiles/{id}",
    ...options,
  });

/**
 * /email-marketing/sender-profiles/:id operation on email-marketing-sender-profile resource
 *
 * /email-marketing/sender-profiles/:id operation on email-marketing-sender-profile resource
 */
export const getAdminEmailMarketingSenderProfilesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminEmailMarketingSenderProfilesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEmailMarketingSenderProfilesByIdResponses,
    GetAdminEmailMarketingSenderProfilesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/sender-profiles/{id}",
    ...options,
  });

/**
 * /email-marketing/sender-profiles/:id operation on email-marketing-sender-profile resource
 *
 * /email-marketing/sender-profiles/:id operation on email-marketing-sender-profile resource
 */
export const patchAdminEmailMarketingSenderProfilesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailMarketingSenderProfilesByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingSenderProfilesByIdResponses,
    PatchAdminEmailMarketingSenderProfilesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/sender-profiles/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get the current application based on x-application-key header context
 *
 * Get the current application based on x-application-key header context
 */
export const getAdminApplicationsMe = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminApplicationsMeData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminApplicationsMeResponses,
    GetAdminApplicationsMeErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/me",
    ...options,
  });

/**
 * /catalog/stock-records/:id operation on catalog-stock-record resource
 *
 * /catalog/stock-records/:id operation on catalog-stock-record resource
 */
export const getAdminCatalogStockRecordsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCatalogStockRecordsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCatalogStockRecordsByIdResponses,
    GetAdminCatalogStockRecordsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/stock-records/{id}",
    ...options,
  });

/**
 * /reviews/:id/reject operation on review resource
 *
 * /reviews/:id/reject operation on review resource
 */
export const patchAdminReviewsByIdReject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminReviewsByIdRejectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminReviewsByIdRejectResponses,
    PatchAdminReviewsByIdRejectErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/reviews/{id}/reject",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Deactivate a legal document without deleting it
 *
 * Deactivate a legal document without deleting it. Invalidates the RequireLegalAcceptance cache so the plug re-evaluates which document users must accept.
 */
export const patchAdminLegalDocumentsByIdUnpublish = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminLegalDocumentsByIdUnpublishData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminLegalDocumentsByIdUnpublishResponses,
    PatchAdminLegalDocumentsByIdUnpublishErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/legal-documents/{id}/unpublish",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /legal-acceptances/:id operation on legal-acceptance resource
 *
 * /legal-acceptances/:id operation on legal-acceptance resource
 */
export const getAdminLegalAcceptancesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminLegalAcceptancesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLegalAcceptancesByIdResponses,
    GetAdminLegalAcceptancesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/legal-acceptances/{id}",
    ...options,
  });

/**
 * /extraction/agents operation on extraction-agent resource
 *
 * /extraction/agents operation on extraction-agent resource
 */
export const getAdminExtractionAgents = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminExtractionAgentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionAgentsResponses,
    GetAdminExtractionAgentsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/agents",
    ...options,
  });

/**
 * Get a Fullscript embed session grant token for the prescribing widget
 *
 * Get a Fullscript embed session grant token for the prescribing widget
 */
export const postAdminConnectorsFullscriptSessionGrant = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminConnectorsFullscriptSessionGrantData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsFullscriptSessionGrantResponses,
    PostAdminConnectorsFullscriptSessionGrantErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/fullscript/session-grant",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/note-templates operation on clinical-note-template resource
 *
 * /clinical/note-templates operation on clinical-note-template resource
 */
export const getAdminClinicalNoteTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalNoteTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNoteTemplatesResponses,
    GetAdminClinicalNoteTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates",
    ...options,
  });

/**
 * /clinical/note-templates operation on clinical-note-template resource
 *
 * /clinical/note-templates operation on clinical-note-template resource
 */
export const postAdminClinicalNoteTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalNoteTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalNoteTemplatesResponses,
    PostAdminClinicalNoteTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get daily credit usage history
 *
 * Get daily credit usage history
 */
export const getAdminWalletUsage = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminWalletUsageData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWalletUsageResponses,
    GetAdminWalletUsageErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/usage",
    ...options,
  });

/**
 * /email/inclusions operation on email-inclusion resource
 *
 * /email/inclusions operation on email-inclusion resource
 */
export const postAdminEmailInclusions = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminEmailInclusionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminEmailInclusionsResponses,
    PostAdminEmailInclusionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inclusions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /support/sla-policies/:id operation on support-sla-policy resource
 *
 * /support/sla-policies/:id operation on support-sla-policy resource
 */
export const deleteAdminSupportSlaPoliciesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSupportSlaPoliciesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSupportSlaPoliciesByIdResponses,
    DeleteAdminSupportSlaPoliciesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/sla-policies/{id}",
    ...options,
  });

/**
 * /support/sla-policies/:id operation on support-sla-policy resource
 *
 * /support/sla-policies/:id operation on support-sla-policy resource
 */
export const getAdminSupportSlaPoliciesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSupportSlaPoliciesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSupportSlaPoliciesByIdResponses,
    GetAdminSupportSlaPoliciesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/sla-policies/{id}",
    ...options,
  });

/**
 * Update SLA policy targets or business hours setting
 *
 * Update SLA policy targets or business hours setting. Changes apply to new SLA_due_at calculations — existing tickets already have sla_due_at set and are unaffected.
 */
export const patchAdminSupportSlaPoliciesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSupportSlaPoliciesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSupportSlaPoliciesByIdResponses,
    PatchAdminSupportSlaPoliciesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/sla-policies/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/metrics/:id operation on post-metric resource
 *
 * /social/metrics/:id operation on post-metric resource
 */
export const getAdminSocialMetricsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSocialMetricsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSocialMetricsByIdResponses,
    GetAdminSocialMetricsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/metrics/{id}",
    ...options,
  });

/**
 * /applications/:application_id/email-templates/:slug operation on email-template resource
 *
 * /applications/:application_id/email-templates/:slug operation on email-template resource
 */
export const deleteAdminApplicationsByApplicationIdEmailTemplatesBySlug = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminApplicationsByApplicationIdEmailTemplatesBySlugData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminApplicationsByApplicationIdEmailTemplatesBySlugResponses,
    DeleteAdminApplicationsByApplicationIdEmailTemplatesBySlugErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/{application_id}/email-templates/{slug}",
    ...options,
  });

/**
 * Fetch a single email template by its slug within the given application
 *
 * Fetch a single email template by its slug within the given application. Returns the template for rendering or editing; use :preview to render it with sample data.
 */
export const getAdminApplicationsByApplicationIdEmailTemplatesBySlug = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminApplicationsByApplicationIdEmailTemplatesBySlugData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminApplicationsByApplicationIdEmailTemplatesBySlugResponses,
    GetAdminApplicationsByApplicationIdEmailTemplatesBySlugErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/{application_id}/email-templates/{slug}",
    ...options,
  });

/**
 * Update the display name, subject, body, branding color, or enabled state of an existing template
 *
 * Update the display name, subject, body, branding color, or enabled state of an existing template. Works for both system and custom templates; the slug cannot be changed after creation.
 */
export const patchAdminApplicationsByApplicationIdEmailTemplatesBySlug = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminApplicationsByApplicationIdEmailTemplatesBySlugData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminApplicationsByApplicationIdEmailTemplatesBySlugResponses,
    PatchAdminApplicationsByApplicationIdEmailTemplatesBySlugErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/{application_id}/email-templates/{slug}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /support/routing-rules/:id operation on support-routing-rule resource
 *
 * /support/routing-rules/:id operation on support-routing-rule resource
 */
export const deleteAdminSupportRoutingRulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSupportRoutingRulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSupportRoutingRulesByIdResponses,
    DeleteAdminSupportRoutingRulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/routing-rules/{id}",
    ...options,
  });

/**
 * /support/routing-rules/:id operation on support-routing-rule resource
 *
 * /support/routing-rules/:id operation on support-routing-rule resource
 */
export const getAdminSupportRoutingRulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSupportRoutingRulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSupportRoutingRulesByIdResponses,
    GetAdminSupportRoutingRulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/routing-rules/{id}",
    ...options,
  });

/**
 * Update a routing rule's conditions, action, parameters, or priority order
 *
 * Update a routing rule's conditions, action, parameters, or priority order. Changes take effect on the next ticket creation — existing tickets are not re-evaluated.
 */
export const patchAdminSupportRoutingRulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSupportRoutingRulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSupportRoutingRulesByIdResponses,
    PatchAdminSupportRoutingRulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/routing-rules/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Run a filtered semantic search with additional constraints on document type, date range, or specific workspace IDs; use when basic search results need to be scoped to a subset of the tenant's content.
 *
 * Run a filtered semantic search with additional constraints on document type, date range, or specific workspace IDs; use when basic search results need to be scoped to a subset of the tenant's content.
 */
export const postAdminAiSearchAdvanced = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAiSearchAdvancedData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAiSearchAdvancedResponses,
    PostAdminAiSearchAdvancedErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/search/advanced",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get workspace preference by context_key
 *
 * Get workspace preference by context_key
 */
export const getAdminWorkspacePreferencesByKey = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWorkspacePreferencesByKeyData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWorkspacePreferencesByKeyResponses,
    GetAdminWorkspacePreferencesByKeyErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-preferences/by_key",
    ...options,
  });

/**
 * List all nodes for a pipeline, ordered by order field.
 *
 * List all nodes for a pipeline, ordered by order field.
 */
export const getAdminPipelineNodesByPipelineByPipelineId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminPipelineNodesByPipelineByPipelineIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminPipelineNodesByPipelineByPipelineIdResponses,
    GetAdminPipelineNodesByPipelineByPipelineIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-nodes/by-pipeline/{pipeline_id}",
    ...options,
  });

/**
 * Return a per-action count for a tenant's audit logs
 *
 * Return a per-action count for a tenant's audit logs. Optionally scoped to a workspace.
 */
export const getAdminAuditLogsCountByAction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAuditLogsCountByActionData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAuditLogsCountByActionResponses,
    GetAdminAuditLogsCountByActionErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/audit-logs/count-by-action",
    ...options,
  });

/**
 * Update workspace storage settings - tenant admin/owner only
 *
 * Update workspace storage settings - tenant admin/owner only
 */
export const patchAdminWorkspacesByIdStorageSettings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWorkspacesByIdStorageSettingsData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWorkspacesByIdStorageSettingsResponses,
    PatchAdminWorkspacesByIdStorageSettingsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{id}/storage-settings",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch non-deleted files matching a given checksum
 *
 * Fetch non-deleted files matching a given checksum. Use for deduplication before uploading.
 */
export const getAdminStorageFilesByChecksum = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminStorageFilesByChecksumData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminStorageFilesByChecksumResponses,
    GetAdminStorageFilesByChecksumErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-files/by-checksum",
    ...options,
  });

/**
 * Make a legal document live
 *
 * Make a legal document live. Sets `is_active: true`, records `published_at` and `published_by_user_id`, invalidates the RequireLegalAcceptance cache, and enqueues a NotifyTosUpdate Oban job to notify affected users.
 */
export const patchAdminLegalDocumentsByIdPublish = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminLegalDocumentsByIdPublishData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminLegalDocumentsByIdPublishResponses,
    PatchAdminLegalDocumentsByIdPublishErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/legal-documents/{id}/publish",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Begin reviewing an amendment request.
 *
 * Begin reviewing an amendment request.
 */
export const patchAdminAmendmentRequestsByIdReview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminAmendmentRequestsByIdReviewData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAmendmentRequestsByIdReviewResponses,
    PatchAdminAmendmentRequestsByIdReviewErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/amendment-requests/{id}/review",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Execute multiple search queries in a single request and return the combined results
 *
 * Execute multiple search queries in a single request and return the combined results. Useful for populating dashboard sections with different query terms simultaneously.
 */
export const postAdminSearchBatch = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSearchBatchData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSearchBatchResponses,
    PostAdminSearchBatchErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/batch",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/favorites operation on recipes-recipe-favorite resource
 *
 * /recipes/favorites operation on recipes-recipe-favorite resource
 */
export const postAdminRecipesFavorites = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminRecipesFavoritesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesFavoritesResponses,
    PostAdminRecipesFavoritesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/favorites",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a stock location (warehouse, store, drop-ship, etc.) in a workspace; enforces max_stock_locations quota
 *
 * Create a stock location (warehouse, store, drop-ship, etc.) in a workspace; enforces max_stock_locations quota. Returns the created location.
 */
export const postAdminCatalogStockLocations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCatalogStockLocationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogStockLocationsResponses,
    PostAdminCatalogStockLocationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/stock-locations",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all batches for a workspace, unfiltered and unpaginated
 *
 * List all batches for a workspace, unfiltered and unpaginated. Use this to populate a batch picker or dashboard.
 */
export const getAdminExtractionBatchesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionBatchesWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionBatchesWorkspaceByWorkspaceIdResponses,
    GetAdminExtractionBatchesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/batches/workspace/{workspace_id}",
    ...options,
  });

/**
 * /clinical/client-goals/archived operation on clinical-client-goal resource
 *
 * /clinical/client-goals/archived operation on clinical-client-goal resource
 */
export const getAdminClinicalClientGoalsArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalClientGoalsArchivedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalClientGoalsArchivedResponses,
    GetAdminClinicalClientGoalsArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-goals/archived",
    ...options,
  });

/**
 * Publish a plan bundle atomically
 *
 * Publish a plan bundle atomically. Composes Plan + FeatureDefinitions +
 * PlanFeatureAllocations + CompositeOperations + CreditPackages +
 * PricingStrategies in one transaction. Runs the §4.9 pre-publish
 * checklist (capability refs, permitted tiers, Schedule A op IDs,
 * blended-margin floor) before persisting. Below-floor publishes are
 * hard-blocked unless `ack_below_floor: true` and `reason` are provided —
 * acknowledged below-floor publishes write an `audit:plan_published_below_floor`
 * audit row.
 *
 * Phase 1 skeleton: returns a placeholder response. Real behavior lands in
 * Phase 2.
 *
 */
export const postAdminPlanBundlesPublish = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminPlanBundlesPublishData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPlanBundlesPublishResponses,
    PostAdminPlanBundlesPublishErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plan-bundles/publish",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /settlements/:id/mark-failed operation on settlement resource
 *
 * /settlements/:id/mark-failed operation on settlement resource
 */
export const patchAdminSettlementsByIdMarkFailed = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSettlementsByIdMarkFailedData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSettlementsByIdMarkFailedResponses,
    PatchAdminSettlementsByIdMarkFailedErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlements/{id}/mark-failed",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/insurance-authorizations/expiring operation on clinical-insurance-authorization resource
 *
 * /clinical/insurance-authorizations/expiring operation on clinical-insurance-authorization resource
 */
export const getAdminClinicalInsuranceAuthorizationsExpiring = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalInsuranceAuthorizationsExpiringData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalInsuranceAuthorizationsExpiringResponses,
    GetAdminClinicalInsuranceAuthorizationsExpiringErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/insurance-authorizations/expiring",
    ...options,
  });

/**
 * /platform-tones/by-brand/:brand_identity_id operation on platform-tone resource
 *
 * /platform-tones/by-brand/:brand_identity_id operation on platform-tone resource
 */
export const getAdminPlatformTonesByBrandByBrandIdentityId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminPlatformTonesByBrandByBrandIdentityIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminPlatformTonesByBrandByBrandIdentityIdResponses,
    GetAdminPlatformTonesByBrandByBrandIdentityIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/platform-tones/by-brand/{brand_identity_id}",
    ...options,
  });

/**
 * /clinical/intake-targets/:id operation on clinical-intake-target resource
 *
 * /clinical/intake-targets/:id operation on clinical-intake-target resource
 */
export const getAdminClinicalIntakeTargetsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalIntakeTargetsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalIntakeTargetsByIdResponses,
    GetAdminClinicalIntakeTargetsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/intake-targets/{id}",
    ...options,
  });

/**
 * /clinical/intake-targets/:id operation on clinical-intake-target resource
 *
 * /clinical/intake-targets/:id operation on clinical-intake-target resource
 */
export const patchAdminClinicalIntakeTargetsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalIntakeTargetsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalIntakeTargetsByIdResponses,
    PatchAdminClinicalIntakeTargetsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/intake-targets/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/rules/:id operation on invoices-rule resource
 *
 * /invoices/rules/:id operation on invoices-rule resource
 */
export const deleteAdminInvoicesRulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminInvoicesRulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminInvoicesRulesByIdResponses,
    DeleteAdminInvoicesRulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/rules/{id}",
    ...options,
  });

/**
 * /invoices/rules/:id operation on invoices-rule resource
 *
 * /invoices/rules/:id operation on invoices-rule resource
 */
export const getAdminInvoicesRulesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminInvoicesRulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminInvoicesRulesByIdResponses,
    GetAdminInvoicesRulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/rules/{id}",
    ...options,
  });

/**
 * /invoices/rules/:id operation on invoices-rule resource
 *
 * /invoices/rules/:id operation on invoices-rule resource
 */
export const patchAdminInvoicesRulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesRulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesRulesByIdResponses,
    PatchAdminInvoicesRulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/rules/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fork a thread by cloning it with all its messages
 *
 * Fork a thread by cloning it with all its messages
 */
export const postAdminThreadsByIdFork = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminThreadsByIdForkData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminThreadsByIdForkResponses,
    PostAdminThreadsByIdForkErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/{id}/fork",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-goals/:id/restore operation on clinical-client-goal resource
 *
 * /clinical/client-goals/:id/restore operation on clinical-client-goal resource
 */
export const patchAdminClinicalClientGoalsByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalClientGoalsByIdRestoreData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientGoalsByIdRestoreResponses,
    PatchAdminClinicalClientGoalsByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-goals/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/generated-emails/:id operation on email-marketing-generated-email resource
 *
 * /email-marketing/generated-emails/:id operation on email-marketing-generated-email resource
 */
export const getAdminEmailMarketingGeneratedEmailsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminEmailMarketingGeneratedEmailsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEmailMarketingGeneratedEmailsByIdResponses,
    GetAdminEmailMarketingGeneratedEmailsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/generated-emails/{id}",
    ...options,
  });

/**
 * /email-marketing/generated-emails/:id operation on email-marketing-generated-email resource
 *
 * /email-marketing/generated-emails/:id operation on email-marketing-generated-email resource
 */
export const patchAdminEmailMarketingGeneratedEmailsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailMarketingGeneratedEmailsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingGeneratedEmailsByIdResponses,
    PatchAdminEmailMarketingGeneratedEmailsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/generated-emails/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all workspace preferences, optionally filtered by prefix
 *
 * List all workspace preferences, optionally filtered by prefix
 */
export const getAdminWorkspacePreferences = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWorkspacePreferencesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWorkspacePreferencesResponses,
    GetAdminWorkspacePreferencesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-preferences",
    ...options,
  });

/**
 * List all pending invitations addressed to the authenticated actor's email
 *
 * List all pending invitations addressed to the authenticated actor's email.
 * Always uses the actor's identity for scoping regardless of user_id argument
 * to prevent data leakage. Returns an empty list if the actor is not found or
 * has no pending invitations.
 *
 */
export const getAdminInvitationsMe = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminInvitationsMeData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminInvitationsMeResponses,
    GetAdminInvitationsMeErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invitations/me",
    ...options,
  });

/**
 * /scan-results operation on scan-result resource
 *
 * /scan-results operation on scan-result resource
 */
export const getAdminScanResults = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminScanResultsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminScanResultsResponses,
    GetAdminScanResultsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scan-results",
    ...options,
  });

/**
 * /data-transfer-records/:id operation on data-transfer-record resource
 *
 * /data-transfer-records/:id operation on data-transfer-record resource
 */
export const deleteAdminDataTransferRecordsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminDataTransferRecordsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminDataTransferRecordsByIdResponses,
    DeleteAdminDataTransferRecordsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/data-transfer-records/{id}",
    ...options,
  });

/**
 * /data-transfer-records/:id operation on data-transfer-record resource
 *
 * /data-transfer-records/:id operation on data-transfer-record resource
 */
export const getAdminDataTransferRecordsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminDataTransferRecordsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminDataTransferRecordsByIdResponses,
    GetAdminDataTransferRecordsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/data-transfer-records/{id}",
    ...options,
  });

/**
 * /connectors/credentials operation on credential resource
 *
 * /connectors/credentials operation on credential resource
 */
export const getAdminConnectorsCredentials = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminConnectorsCredentialsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminConnectorsCredentialsResponses,
    GetAdminConnectorsCredentialsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/credentials",
    ...options,
  });

/**
 * Set per-subscription rate-limit overrides
 *
 * Set per-subscription rate-limit overrides. Restricted to Platform Admin
 * and Application Owner (the tenant that owns the Application this
 * subscription's plan belongs to). NOT exposed to tenant owners — overrides
 * are platform/ISV concessions and would be an abuse vector if writable by
 * the customer who is subject to the limit.
 *
 * Pass any of `rate_limit_requests_override`, `rate_limit_period_seconds_override`,
 * or `concurrent_operations_limit_override`. `nil` clears an existing
 * override (falls back to plan-level limit).
 *
 */
export const patchAdminSubscriptionsByIdSetRateLimitOverrides = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminSubscriptionsByIdSetRateLimitOverridesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminSubscriptionsByIdSetRateLimitOverridesResponses,
    PatchAdminSubscriptionsByIdSetRateLimitOverridesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/subscriptions/{id}/set-rate-limit-overrides",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /notification-logs operation on notification-log resource
 *
 * /notification-logs operation on notification-log resource
 */
export const getAdminNotificationLogs = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminNotificationLogsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminNotificationLogsResponses,
    GetAdminNotificationLogsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-logs",
    ...options,
  });

/**
 * List all option types for an application ordered by position
 *
 * List all option types for an application ordered by position. Returns a paginated list.
 */
export const getAdminCatalogOptionTypesApplicationByApplicationId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogOptionTypesApplicationByApplicationIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogOptionTypesApplicationByApplicationIdResponses,
    GetAdminCatalogOptionTypesApplicationByApplicationIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/option-types/application/{application_id}",
    ...options,
  });

/**
 * /clinical/goal-templates/:id/restore operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/:id/restore operation on clinical-goal-template resource
 */
export const patchAdminClinicalGoalTemplatesByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalGoalTemplatesByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalGoalTemplatesByIdRestoreResponses,
    PatchAdminClinicalGoalTemplatesByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/meal-plans/by-meal-schedule operation on clinical-meal-plan resource
 *
 * /clinical/meal-plans/by-meal-schedule operation on clinical-meal-plan resource
 */
export const getAdminClinicalMealPlansByMealSchedule = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalMealPlansByMealScheduleData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalMealPlansByMealScheduleResponses,
    GetAdminClinicalMealPlansByMealScheduleErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/meal-plans/by-meal-schedule",
    ...options,
  });

/**
 * List invoices for a workspace with optional filters
 *
 * List invoices for a workspace with optional filters
 */
export const getAdminInvoicesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminInvoicesWorkspaceByWorkspaceIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminInvoicesWorkspaceByWorkspaceIdResponses,
    GetAdminInvoicesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/workspace/{workspace_id}",
    ...options,
  });

/**
 * List templates in a supplement collection
 *
 * List templates in a supplement collection
 */
export const getAdminClinicalSupplementTemplateCollectionMembershipsCollectionByCollectionId =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAdminClinicalSupplementTemplateCollectionMembershipsCollectionByCollectionIdData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetAdminClinicalSupplementTemplateCollectionMembershipsCollectionByCollectionIdResponses,
      GetAdminClinicalSupplementTemplateCollectionMembershipsCollectionByCollectionIdErrors,
      ThrowOnError
    >({
      querySerializer: {
        parameters: {
          filter: { object: { style: "form" } },
          page: { object: { style: "form" } },
          fields: { object: { style: "form" } },
        },
      },
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/clinical/supplement-template-collection-memberships/collection/{collection_id}",
      ...options,
    });

/**
 * List AgentVersions, optionally filtered to a specific agent
 *
 * List AgentVersions, optionally filtered to a specific agent. Includes all versions regardless of active or draft status.
 */
export const getAdminAgentVersions = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAgentVersionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentVersionsResponses,
    GetAdminAgentVersionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-versions",
    ...options,
  });

/**
 * Create a new AgentVersion snapshot
 *
 * Create a new AgentVersion snapshot. Accepts the schema fields, prompt template, version
 * number, and optional parent version for lineage tracking. New versions are created with
 * `is_active: false` — call `:activate` (via `AgentVersion.activate`) or
 * `Agent.activate_schema_version` to make this version live.
 *
 * Draft versions can be created with `is_draft: true` (used by `Agent.get_or_create_draft`).
 * Cache invalidation for the schema cache is handled via the `VersionMutated` event.
 *
 * Returns the created version with `is_active: false`.
 *
 */
export const postAdminAgentVersions = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAgentVersionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentVersionsResponses,
    PostAdminAgentVersionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-versions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all voice sessions in a workspace (ISV admin)
 *
 * List all voice sessions in a workspace (ISV admin)
 */
export const getAdminVoiceSessionsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminVoiceSessionsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminVoiceSessionsWorkspaceByWorkspaceIdResponses,
    GetAdminVoiceSessionsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/sessions/workspace/{workspace_id}",
    ...options,
  });

/**
 * /clinical/meal-plans/:id/approve operation on clinical-meal-plan resource
 *
 * /clinical/meal-plans/:id/approve operation on clinical-meal-plan resource
 */
export const patchAdminClinicalMealPlansByIdApprove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalMealPlansByIdApproveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalMealPlansByIdApproveResponses,
    PatchAdminClinicalMealPlansByIdApproveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/meal-plans/{id}/approve",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Approve an amendment request.
 *
 * Approve an amendment request.
 */
export const patchAdminAmendmentRequestsByIdApprove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminAmendmentRequestsByIdApproveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAmendmentRequestsByIdApproveResponses,
    PatchAdminAmendmentRequestsByIdApproveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/amendment-requests/{id}/approve",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /pipeline-executions/by-pipeline/:pipeline_id operation on pipeline-execution resource
 *
 * /pipeline-executions/by-pipeline/:pipeline_id operation on pipeline-execution resource
 */
export const getAdminPipelineExecutionsByPipelineByPipelineId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminPipelineExecutionsByPipelineByPipelineIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminPipelineExecutionsByPipelineByPipelineIdResponses,
    GetAdminPipelineExecutionsByPipelineByPipelineIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-executions/by-pipeline/{pipeline_id}",
    ...options,
  });

/**
 * /campaigns/recipients/campaign/:campaign_id operation on email-marketing-recipient resource
 *
 * /campaigns/recipients/campaign/:campaign_id operation on email-marketing-recipient resource
 */
export const getAdminCampaignsRecipientsCampaignByCampaignId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCampaignsRecipientsCampaignByCampaignIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCampaignsRecipientsCampaignByCampaignIdResponses,
    GetAdminCampaignsRecipientsCampaignByCampaignIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/recipients/campaign/{campaign_id}",
    ...options,
  });

/**
 * Look up a pending, non-expired invitation by its raw token
 *
 * Look up a pending, non-expired invitation by its raw token. Hashes the token
 * before querying so the raw value is never stored. Returns nil if the token is
 * invalid, already used, or expired. Used by invitation acceptance flows to display
 * invitation details before the user commits.
 *
 */
export const getAdminInvitationsConsumeByToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminInvitationsConsumeByTokenData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminInvitationsConsumeByTokenResponses,
    GetAdminInvitationsConsumeByTokenErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invitations/consume/{token}",
    ...options,
  });

/**
 * Full-text keyword search via Meilisearch across users, tenants, and documents
 *
 * Full-text keyword search via Meilisearch across users, tenants, and documents. Non-admin actors are silently restricted to tenant scope regardless of the `scope` argument. Returns a single result struct with `users`, `tenants`, and `documents` arrays.
 */
export const getAdminSearch = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSearchData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSearchResponses,
    GetAdminSearchErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search",
    ...options,
  });

/**
 * /recipes/collections operation on recipes-recipe-collection resource
 *
 * /recipes/collections operation on recipes-recipe-collection resource
 */
export const postAdminRecipesCollections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminRecipesCollectionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesCollectionsResponses,
    PostAdminRecipesCollectionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/collections",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Move a deal to a different pipeline stage
 *
 * Move a deal to a different pipeline stage. Records the previous stage ID in
 * metadata so the DealStageChanged event can be published downstream. Use instead
 * of :update when only the stage needs to change — avoids triggering all update validators.
 *
 */
export const patchAdminCrmDealsByIdMoveStage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmDealsByIdMoveStageData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmDealsByIdMoveStageResponses,
    PatchAdminCrmDealsByIdMoveStageErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/deals/{id}/move-stage",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /balances operation on balance resource
 *
 * /balances operation on balance resource
 */
export const getAdminBalances = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminBalancesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBalancesResponses,
    GetAdminBalancesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/balances",
    ...options,
  });

/**
 * List all queues for an application
 *
 * List all queues for an application. Use to populate queue assignment dropdowns on ticket create/update and to configure routing rules.
 */
export const getAdminSupportQueuesApplicationByApplicationId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSupportQueuesApplicationByApplicationIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSupportQueuesApplicationByApplicationIdResponses,
    GetAdminSupportQueuesApplicationByApplicationIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/queues/application/{application_id}",
    ...options,
  });

/**
 * /clinical/supplement-templates/catalog/:id/archive operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/catalog/:id/archive operation on clinical-supplement-template resource
 */
export const patchAdminClinicalSupplementTemplatesCatalogByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalSupplementTemplatesCatalogByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalSupplementTemplatesCatalogByIdArchiveResponses,
    PatchAdminClinicalSupplementTemplatesCatalogByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/catalog/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /workspace-agent-configs operation on workspace-agent-config resource
 *
 * /workspace-agent-configs operation on workspace-agent-config resource
 */
export const getAdminWorkspaceAgentConfigs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWorkspaceAgentConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWorkspaceAgentConfigsResponses,
    GetAdminWorkspaceAgentConfigsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-agent-configs",
    ...options,
  });

/**
 * /workspace-agent-configs operation on workspace-agent-config resource
 *
 * /workspace-agent-configs operation on workspace-agent-config resource
 */
export const postAdminWorkspaceAgentConfigs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminWorkspaceAgentConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminWorkspaceAgentConfigsResponses,
    PostAdminWorkspaceAgentConfigsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-agent-configs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/unsubscribers/:id operation on email-unsubscriber resource
 *
 * /email-marketing/unsubscribers/:id operation on email-unsubscriber resource
 */
export const getAdminEmailMarketingUnsubscribersById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminEmailMarketingUnsubscribersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEmailMarketingUnsubscribersByIdResponses,
    GetAdminEmailMarketingUnsubscribersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/unsubscribers/{id}",
    ...options,
  });

/**
 * /notification-logs/:id operation on notification-log resource
 *
 * /notification-logs/:id operation on notification-log resource
 */
export const getAdminNotificationLogsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminNotificationLogsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminNotificationLogsByIdResponses,
    GetAdminNotificationLogsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-logs/{id}",
    ...options,
  });

/**
 * /ledger/:id operation on ledger resource
 *
 * /ledger/:id operation on ledger resource
 */
export const getAdminLedgerById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminLedgerByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLedgerByIdResponses,
    GetAdminLedgerByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ledger/{id}",
    ...options,
  });

/**
 * /email/template-versions/:template_id/versions/:version_number operation on email-template-version resource
 *
 * /email/template-versions/:template_id/versions/:version_number operation on email-template-version resource
 */
export const getAdminEmailTemplateVersionsByTemplateIdVersionsByVersionNumber =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAdminEmailTemplateVersionsByTemplateIdVersionsByVersionNumberData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetAdminEmailTemplateVersionsByTemplateIdVersionsByVersionNumberResponses,
      GetAdminEmailTemplateVersionsByTemplateIdVersionsByVersionNumberErrors,
      ThrowOnError
    >({
      querySerializer: {
        parameters: { fields: { object: { style: "form" } } },
      },
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/email/template-versions/{template_id}/versions/{version_number}",
      ...options,
    });

/**
 * Predict optimal send times per recipient using AI
 *
 * Predict optimal send times per recipient using AI
 */
export const postAdminEmailMarketingCampaignsByIdOptimizeSendTimes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminEmailMarketingCampaignsByIdOptimizeSendTimesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminEmailMarketingCampaignsByIdOptimizeSendTimesResponses,
    PostAdminEmailMarketingCampaignsByIdOptimizeSendTimesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/campaigns/{id}/optimize-send-times",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /voice/transcription-jobs/workspace/:workspace_id operation on transcription-job resource
 *
 * /voice/transcription-jobs/workspace/:workspace_id operation on transcription-job resource
 */
export const getAdminVoiceTranscriptionJobsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminVoiceTranscriptionJobsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminVoiceTranscriptionJobsWorkspaceByWorkspaceIdResponses,
    GetAdminVoiceTranscriptionJobsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/transcription-jobs/workspace/{workspace_id}",
    ...options,
  });

/**
 * /social/metrics/post/:social_post_id/latest operation on post-metric resource
 *
 * /social/metrics/post/:social_post_id/latest operation on post-metric resource
 */
export const getAdminSocialMetricsPostBySocialPostIdLatest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSocialMetricsPostBySocialPostIdLatestData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSocialMetricsPostBySocialPostIdLatestResponses,
    GetAdminSocialMetricsPostBySocialPostIdLatestErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/metrics/post/{social_post_id}/latest",
    ...options,
  });

/**
 * /clinical/sessions/:id/meal_plans operation on clinical-meal-plan resource
 *
 * /clinical/sessions/:id/meal_plans operation on clinical-meal-plan resource
 */
export const getAdminClinicalSessionsByIdMealPlans = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalSessionsByIdMealPlansData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSessionsByIdMealPlansResponses,
    GetAdminClinicalSessionsByIdMealPlansErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/sessions/{id}/meal_plans",
    ...options,
  });

/**
 * Create multiple medications in a single request (e.g., from an EHR import)
 *
 * Create multiple medications in a single request (e.g., from an EHR import)
 */
export const postAdminClinicalClientMedicationsBulk = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalClientMedicationsBulkData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalClientMedicationsBulkResponses,
    PostAdminClinicalClientMedicationsBulkErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-medications/bulk",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /claimed-domains/:id/revoke operation on claimed-domain resource
 *
 * /claimed-domains/:id/revoke operation on claimed-domain resource
 */
export const patchAdminClaimedDomainsByIdRevoke = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClaimedDomainsByIdRevokeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClaimedDomainsByIdRevokeResponses,
    PatchAdminClaimedDomainsByIdRevokeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/claimed-domains/{id}/revoke",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Platform Admin action to register a new ISV (User + Tenant + App)
 *
 * Platform Admin action to register a new ISV (User + Tenant + App)
 */
export const postAdminUsersRegisterIsv = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminUsersRegisterIsvData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminUsersRegisterIsvResponses,
    PostAdminUsersRegisterIsvErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/register-isv",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-resource-assignments/archived operation on clinical-client-resource-assignment resource
 *
 * /clinical/client-resource-assignments/archived operation on clinical-client-resource-assignment resource
 */
export const getAdminClinicalClientResourceAssignmentsArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalClientResourceAssignmentsArchivedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalClientResourceAssignmentsArchivedResponses,
    GetAdminClinicalClientResourceAssignmentsArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-resource-assignments/archived",
    ...options,
  });

/**
 * Reject a pending price suggestion; sets status to :rejected with no cascading effects.
 *
 * Reject a pending price suggestion; sets status to :rejected with no cascading effects.
 */
export const patchAdminCatalogPriceSuggestionsByIdReject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminCatalogPriceSuggestionsByIdRejectData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogPriceSuggestionsByIdRejectResponses,
    PatchAdminCatalogPriceSuggestionsByIdRejectErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/price-suggestions/{id}/reject",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List appointments from Healthie connector
 *
 * List appointments from Healthie connector.
 *
 * Returns array of Healthie appointment records with optional date filter.
 *
 */
export const postAdminConnectorsByIdHealthieAppointmentsList = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsByIdHealthieAppointmentsListData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsByIdHealthieAppointmentsListResponses,
    PostAdminConnectorsByIdHealthieAppointmentsListErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/{id}/healthie/appointments/list",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all sync configurations for a workspace, one per connector instance
 *
 * List all sync configurations for a workspace, one per connector instance. Use to audit which connectors have custom sync settings configured.
 */
export const getAdminCrmSyncConfigsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmSyncConfigsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmSyncConfigsWorkspaceByWorkspaceIdResponses,
    GetAdminCrmSyncConfigsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/sync-configs/workspace/{workspace_id}",
    ...options,
  });

/**
 * /accounts/by-tenant/:tenant_id operation on account resource
 *
 * /accounts/by-tenant/:tenant_id operation on account resource
 */
export const getAdminAccountsByTenantByTenantId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAccountsByTenantByTenantIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAccountsByTenantByTenantIdResponses,
    GetAdminAccountsByTenantByTenantIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/accounts/by-tenant/{tenant_id}",
    ...options,
  });

/**
 * Create a named price list for an application with a strategy (fixed, percentage_discount, or tiered)
 *
 * Create a named price list for an application with a strategy (fixed, percentage_discount, or tiered). Returns the created price list.
 */
export const postAdminCatalogPriceLists = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCatalogPriceListsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogPriceListsResponses,
    PostAdminCatalogPriceListsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/price-lists",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Restore a suspended tenant to active status.
 *
 * Restore a suspended tenant to active status.
 */
export const patchAdminTenantsByIdUnsuspend = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminTenantsByIdUnsuspendData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTenantsByIdUnsuspendResponses,
    PatchAdminTenantsByIdUnsuspendErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}/unsuspend",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/supplement-templates/mine operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/mine operation on clinical-supplement-template resource
 */
export const getAdminClinicalSupplementTemplatesMine = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalSupplementTemplatesMineData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSupplementTemplatesMineResponses,
    GetAdminClinicalSupplementTemplatesMineErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/mine",
    ...options,
  });

/**
 * /pipeline-nodes/:id operation on pipeline-node resource
 *
 * /pipeline-nodes/:id operation on pipeline-node resource
 */
export const deleteAdminPipelineNodesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminPipelineNodesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminPipelineNodesByIdResponses,
    DeleteAdminPipelineNodesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-nodes/{id}",
    ...options,
  });

/**
 * /pipeline-nodes/:id operation on pipeline-node resource
 *
 * /pipeline-nodes/:id operation on pipeline-node resource
 */
export const getAdminPipelineNodesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPipelineNodesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPipelineNodesByIdResponses,
    GetAdminPipelineNodesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-nodes/{id}",
    ...options,
  });

/**
 * Update a pipeline node.
 *
 * Update a pipeline node.
 */
export const patchAdminPipelineNodesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPipelineNodesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPipelineNodesByIdResponses,
    PatchAdminPipelineNodesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-nodes/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/outbound-emails operation on email-outbound-email resource
 *
 * /email/outbound-emails operation on email-outbound-email resource
 */
export const postAdminEmailOutboundEmails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminEmailOutboundEmailsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminEmailOutboundEmailsResponses,
    PostAdminEmailOutboundEmailsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/outbound-emails",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Permanently cancel a tenant.
 *
 * Permanently cancel a tenant.
 */
export const patchAdminTenantsByIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminTenantsByIdCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTenantsByIdCancelResponses,
    PatchAdminTenantsByIdCancelErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /workspaces/:workspace_id/extraction/:document_id/mapping operation on field-mapping-result resource
 *
 * /workspaces/:workspace_id/extraction/:document_id/mapping operation on field-mapping-result resource
 */
export const getAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMapping = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMappingData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMappingResponses,
    GetAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMappingErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{workspace_id}/extraction/{document_id}/mapping",
    ...options,
  });

/**
 * /workspaces/:workspace_id/extraction/:document_id/mapping operation on field-mapping-confirmation resource
 *
 * /workspaces/:workspace_id/extraction/:document_id/mapping operation on field-mapping-confirmation resource
 */
export const postAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMapping = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMappingData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMappingResponses,
    PostAdminWorkspacesByWorkspaceIdExtractionByDocumentIdMappingErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{workspace_id}/extraction/{document_id}/mapping",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/collection-recipes/:id operation on recipes-collection-recipe resource
 *
 * /recipes/collection-recipes/:id operation on recipes-collection-recipe resource
 */
export const deleteAdminRecipesCollectionRecipesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminRecipesCollectionRecipesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRecipesCollectionRecipesByIdResponses,
    DeleteAdminRecipesCollectionRecipesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/collection-recipes/{id}",
    ...options,
  });

/**
 * /recipes/collection-recipes/:id operation on recipes-collection-recipe resource
 *
 * /recipes/collection-recipes/:id operation on recipes-collection-recipe resource
 */
export const getAdminRecipesCollectionRecipesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesCollectionRecipesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesCollectionRecipesByIdResponses,
    GetAdminRecipesCollectionRecipesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/collection-recipes/{id}",
    ...options,
  });

/**
 * /recipes/collection-recipes/:id operation on recipes-collection-recipe resource
 *
 * /recipes/collection-recipes/:id operation on recipes-collection-recipe resource
 */
export const patchAdminRecipesCollectionRecipesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRecipesCollectionRecipesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesCollectionRecipesByIdResponses,
    PatchAdminRecipesCollectionRecipesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/collection-recipes/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/intake-targets operation on clinical-intake-target resource
 *
 * /clinical/intake-targets operation on clinical-intake-target resource
 */
export const getAdminClinicalIntakeTargets = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalIntakeTargetsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalIntakeTargetsResponses,
    GetAdminClinicalIntakeTargetsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/intake-targets",
    ...options,
  });

/**
 * /clinical/intake-targets operation on clinical-intake-target resource
 *
 * /clinical/intake-targets operation on clinical-intake-target resource
 */
export const postAdminClinicalIntakeTargets = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalIntakeTargetsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalIntakeTargetsResponses,
    PostAdminClinicalIntakeTargetsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/intake-targets",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /pipeline-nodes operation on pipeline-node resource
 *
 * /pipeline-nodes operation on pipeline-node resource
 */
export const getAdminPipelineNodes = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPipelineNodesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPipelineNodesResponses,
    GetAdminPipelineNodesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-nodes",
    ...options,
  });

/**
 * Create a new pipeline node.
 *
 * Create a new pipeline node.
 */
export const postAdminPipelineNodes = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminPipelineNodesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPipelineNodesResponses,
    PostAdminPipelineNodesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-nodes",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List quote requests for a workspace, optionally filtered by status.
 *
 * List quote requests for a workspace, optionally filtered by status.
 */
export const getAdminQuoteRequestsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminQuoteRequestsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminQuoteRequestsWorkspaceByWorkspaceIdResponses,
    GetAdminQuoteRequestsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/quote-requests/workspace/{workspace_id}",
    ...options,
  });

/**
 * List all feature usage records.
 *
 * List all feature usage records.
 */
export const getAdminFeatureUsages = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminFeatureUsagesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFeatureUsagesResponses,
    GetAdminFeatureUsagesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/feature-usages",
    ...options,
  });

/**
 * Permanently delete a recipe
 *
 * Permanently delete a recipe. Irreversible.
 */
export const deleteAdminRecipesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminRecipesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRecipesByIdResponses,
    DeleteAdminRecipesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/{id}",
    ...options,
  });

/**
 * /recipes/:id operation on recipes-recipe resource
 *
 * /recipes/:id operation on recipes-recipe resource
 */
export const getAdminRecipesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminRecipesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesByIdResponses,
    GetAdminRecipesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/{id}",
    ...options,
  });

/**
 * /recipes/:id operation on recipes-recipe resource
 *
 * /recipes/:id operation on recipes-recipe resource
 */
export const patchAdminRecipesById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminRecipesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesByIdResponses,
    PatchAdminRecipesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List ingredients for a recipe
 *
 * List ingredients for a recipe
 */
export const getAdminRecipesIngredientsRecipeByRecipeId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesIngredientsRecipeByRecipeIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesIngredientsRecipeByRecipeIdResponses,
    GetAdminRecipesIngredientsRecipeByRecipeIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/ingredients/recipe/{recipe_id}",
    ...options,
  });

/**
 * Delete a preference by context_key for the current user
 *
 * Delete a preference by context_key for the current user
 */
export const deleteAdminPreferencesByKey = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminPreferencesByKeyData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminPreferencesByKeyResponses,
    DeleteAdminPreferencesByKeyErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/preferences/by_key",
    ...options,
  });

/**
 * Get preference by context_key for the current user
 *
 * Get preference by context_key for the current user
 */
export const getAdminPreferencesByKey = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPreferencesByKeyData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPreferencesByKeyResponses,
    GetAdminPreferencesByKeyErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/preferences/by_key",
    ...options,
  });

/**
 * Look up an agent by its system_slug
 *
 * Look up an agent by its system_slug. Use this for ISV-provisioned agents where the slug is a stable identifier that survives database resets. Returns a single agent or not-found error.
 */
export const getAdminAgentsBySlugBySlug = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAgentsBySlugBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentsBySlugBySlugResponses,
    GetAdminAgentsBySlugBySlugErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/by-slug/{slug}",
    ...options,
  });

/**
 * /tenants/:tenant_id/document_stats operation on tenant-document-stats resource
 *
 * /tenants/:tenant_id/document_stats operation on tenant-document-stats resource
 */
export const getAdminTenantsByTenantIdDocumentStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminTenantsByTenantIdDocumentStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTenantsByTenantIdDocumentStatsResponses,
    GetAdminTenantsByTenantIdDocumentStatsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{tenant_id}/document_stats",
    ...options,
  });

/**
 * /crm/addresses/:id operation on crm-address resource
 *
 * /crm/addresses/:id operation on crm-address resource
 */
export const deleteAdminCrmAddressesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmAddressesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmAddressesByIdResponses,
    DeleteAdminCrmAddressesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/addresses/{id}",
    ...options,
  });

/**
 * /crm/addresses/:id operation on crm-address resource
 *
 * /crm/addresses/:id operation on crm-address resource
 */
export const getAdminCrmAddressesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCrmAddressesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmAddressesByIdResponses,
    GetAdminCrmAddressesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/addresses/{id}",
    ...options,
  });

/**
 * /crm/addresses/:id operation on crm-address resource
 *
 * /crm/addresses/:id operation on crm-address resource
 */
export const patchAdminCrmAddressesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmAddressesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmAddressesByIdResponses,
    PatchAdminCrmAddressesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/addresses/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all stock records at a location
 *
 * List all stock records at a location. Returns a paginated list with quantity_available calculation.
 */
export const getAdminCatalogStockRecordsLocationByStockLocationId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogStockRecordsLocationByStockLocationIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogStockRecordsLocationByStockLocationIdResponses,
    GetAdminCatalogStockRecordsLocationByStockLocationIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/stock-records/location/{stock_location_id}",
    ...options,
  });

/**
 * /social/posts/:id/seo operation on social-post resource
 *
 * /social/posts/:id/seo operation on social-post resource
 */
export const patchAdminSocialPostsByIdSeo = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSocialPostsByIdSeoData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialPostsByIdSeoResponses,
    PatchAdminSocialPostsByIdSeoErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/posts/{id}/seo",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List orders for a Fullscript patient
 *
 * List orders for a Fullscript patient
 */
export const postAdminConnectorsFullscriptOrdersList = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminConnectorsFullscriptOrdersListData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsFullscriptOrdersListResponses,
    PostAdminConnectorsFullscriptOrdersListErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/fullscript/orders/list",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/deliveries/by-session operation on clinical-delivery resource
 *
 * /clinical/deliveries/by-session operation on clinical-delivery resource
 */
export const getAdminClinicalDeliveriesBySession = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalDeliveriesBySessionData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalDeliveriesBySessionResponses,
    GetAdminClinicalDeliveriesBySessionErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/deliveries/by-session",
    ...options,
  });

/**
 * /agent-souls/:id operation on agent-soul resource
 *
 * /agent-souls/:id operation on agent-soul resource
 */
export const deleteAdminAgentSoulsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminAgentSoulsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminAgentSoulsByIdResponses,
    DeleteAdminAgentSoulsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-souls/{id}",
    ...options,
  });

/**
 * /agent-souls/:id operation on agent-soul resource
 *
 * /agent-souls/:id operation on agent-soul resource
 */
export const getAdminAgentSoulsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAgentSoulsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentSoulsByIdResponses,
    GetAdminAgentSoulsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-souls/{id}",
    ...options,
  });

/**
 * /agent-souls/:id operation on agent-soul resource
 *
 * /agent-souls/:id operation on agent-soul resource
 */
export const patchAdminAgentSoulsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminAgentSoulsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAgentSoulsByIdResponses,
    PatchAdminAgentSoulsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-souls/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /extraction/documents/bulk-reprocess operation on bulk-reprocess-result resource
 *
 * /extraction/documents/bulk-reprocess operation on bulk-reprocess-result resource
 */
export const postAdminExtractionDocumentsBulkReprocess = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminExtractionDocumentsBulkReprocessData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminExtractionDocumentsBulkReprocessResponses,
    PostAdminExtractionDocumentsBulkReprocessErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/bulk-reprocess",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/inbound-addresses/:id/rotate-token operation on email-inbound-address resource
 *
 * /email/inbound-addresses/:id/rotate-token operation on email-inbound-address resource
 */
export const patchAdminEmailInboundAddressesByIdRotateToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailInboundAddressesByIdRotateTokenData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailInboundAddressesByIdRotateTokenResponses,
    PatchAdminEmailInboundAddressesByIdRotateTokenErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inbound-addresses/{id}/rotate-token",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/campaigns/:id/generate-emails operation on campaign resource
 *
 * /email-marketing/campaigns/:id/generate-emails operation on campaign resource
 */
export const postAdminEmailMarketingCampaignsByIdGenerateEmails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminEmailMarketingCampaignsByIdGenerateEmailsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminEmailMarketingCampaignsByIdGenerateEmailsResponses,
    PostAdminEmailMarketingCampaignsByIdGenerateEmailsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/campaigns/{id}/generate-emails",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /wallet/invoices/:id operation on invoice resource
 *
 * /wallet/invoices/:id operation on invoice resource
 */
export const getAdminWalletInvoicesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWalletInvoicesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWalletInvoicesByIdResponses,
    GetAdminWalletInvoicesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/invoices/{id}",
    ...options,
  });

/**
 * /cde-scope-reports/:id operation on cde-scope-report resource
 *
 * /cde-scope-reports/:id operation on cde-scope-report resource
 */
export const deleteAdminCdeScopeReportsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCdeScopeReportsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCdeScopeReportsByIdResponses,
    DeleteAdminCdeScopeReportsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cde-scope-reports/{id}",
    ...options,
  });

/**
 * /cde-scope-reports/:id operation on cde-scope-report resource
 *
 * /cde-scope-reports/:id operation on cde-scope-report resource
 */
export const getAdminCdeScopeReportsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCdeScopeReportsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCdeScopeReportsByIdResponses,
    GetAdminCdeScopeReportsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cde-scope-reports/{id}",
    ...options,
  });

/**
 * Edit an existing image using natural language instructions.
 *
 * Edit an existing image using natural language instructions.
 */
export const postAdminContentEditImage = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminContentEditImageData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminContentEditImageResponses,
    PostAdminContentEditImageErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/content/edit-image",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices operation on invoices-invoice resource
 *
 * /invoices operation on invoices-invoice resource
 */
export const postAdminInvoices = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminInvoicesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminInvoicesResponses,
    PostAdminInvoicesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/patients/:id/health_metrics operation on clinical-health-metric resource
 *
 * /clinical/patients/:id/health_metrics operation on clinical-health-metric resource
 */
export const getAdminClinicalPatientsByIdHealthMetrics = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPatientsByIdHealthMetricsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPatientsByIdHealthMetricsResponses,
    GetAdminClinicalPatientsByIdHealthMetricsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patients/{id}/health_metrics",
    ...options,
  });

/**
 * /case-document-links/:id operation on case-document-link resource
 *
 * /case-document-links/:id operation on case-document-link resource
 */
export const deleteAdminCaseDocumentLinksById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCaseDocumentLinksByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCaseDocumentLinksByIdResponses,
    DeleteAdminCaseDocumentLinksByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-document-links/{id}",
    ...options,
  });

/**
 * /case-document-links/:id operation on case-document-link resource
 *
 * /case-document-links/:id operation on case-document-link resource
 */
export const getAdminCaseDocumentLinksById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCaseDocumentLinksByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCaseDocumentLinksByIdResponses,
    GetAdminCaseDocumentLinksByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-document-links/{id}",
    ...options,
  });

/**
 * /email/outbound-emails/workspace/:workspace_id operation on email-outbound-email resource
 *
 * /email/outbound-emails/workspace/:workspace_id operation on email-outbound-email resource
 */
export const getAdminEmailOutboundEmailsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailOutboundEmailsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailOutboundEmailsWorkspaceByWorkspaceIdResponses,
    GetAdminEmailOutboundEmailsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/outbound-emails/workspace/{workspace_id}",
    ...options,
  });

/**
 * Fetch a single bucket with the storage_used calculation (total bytes across all workspace files in this bucket).
 *
 * Fetch a single bucket with the storage_used calculation (total bytes across all workspace files in this bucket).
 */
export const getAdminBucketsByIdStats = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminBucketsByIdStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBucketsByIdStatsResponses,
    GetAdminBucketsByIdStatsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/buckets/{id}/stats",
    ...options,
  });

/**
 * /clinical/supplement-templates/:id operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/:id operation on clinical-supplement-template resource
 */
export const getAdminClinicalSupplementTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalSupplementTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSupplementTemplatesByIdResponses,
    GetAdminClinicalSupplementTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/{id}",
    ...options,
  });

/**
 * /clinical/supplement-templates/:id operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/:id operation on clinical-supplement-template resource
 */
export const patchAdminClinicalSupplementTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalSupplementTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalSupplementTemplatesByIdResponses,
    PatchAdminClinicalSupplementTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /case-pipeline-links/:id operation on case-pipeline-link resource
 *
 * /case-pipeline-links/:id operation on case-pipeline-link resource
 */
export const getAdminCasePipelineLinksById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCasePipelineLinksByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCasePipelineLinksByIdResponses,
    GetAdminCasePipelineLinksByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-pipeline-links/{id}",
    ...options,
  });

/**
 * /clinical/client-resource-assignments/:id operation on clinical-client-resource-assignment resource
 *
 * /clinical/client-resource-assignments/:id operation on clinical-client-resource-assignment resource
 */
export const getAdminClinicalClientResourceAssignmentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalClientResourceAssignmentsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalClientResourceAssignmentsByIdResponses,
    GetAdminClinicalClientResourceAssignmentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-resource-assignments/{id}",
    ...options,
  });

/**
 * /clinical/client-resource-assignments/:id operation on clinical-client-resource-assignment resource
 *
 * /clinical/client-resource-assignments/:id operation on clinical-client-resource-assignment resource
 */
export const patchAdminClinicalClientResourceAssignmentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalClientResourceAssignmentsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientResourceAssignmentsByIdResponses,
    PatchAdminClinicalClientResourceAssignmentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-resource-assignments/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Look up a single user by their email address (case-insensitive)
 *
 * Look up a single user by their email address (case-insensitive). Restricted to
 * platform admins — use :me for authenticated self-lookup. Returns a single user
 * or nil; never raises on not-found.
 *
 */
export const getAdminUsersByEmail = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUsersByEmailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUsersByEmailResponses,
    GetAdminUsersByEmailErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/by-email",
    ...options,
  });

/**
 * List meal schedules for a workspace
 *
 * List meal schedules for a workspace
 */
export const getAdminRecipesMealSchedulesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesMealSchedulesWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesMealSchedulesWorkspaceByWorkspaceIdResponses,
    GetAdminRecipesMealSchedulesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/meal-schedules/workspace/{workspace_id}",
    ...options,
  });

/**
 * /breach-notification-artifacts/:id operation on breach-notification-artifact resource
 *
 * /breach-notification-artifacts/:id operation on breach-notification-artifact resource
 */
export const getAdminBreachNotificationArtifactsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminBreachNotificationArtifactsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBreachNotificationArtifactsByIdResponses,
    GetAdminBreachNotificationArtifactsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/breach-notification-artifacts/{id}",
    ...options,
  });

/**
 * /breach-notification-artifacts/:id operation on breach-notification-artifact resource
 *
 * /breach-notification-artifacts/:id operation on breach-notification-artifact resource
 */
export const patchAdminBreachNotificationArtifactsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminBreachNotificationArtifactsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminBreachNotificationArtifactsByIdResponses,
    PatchAdminBreachNotificationArtifactsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/breach-notification-artifacts/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/news-summaries/:id operation on news-summary resource
 *
 * /crawler/news-summaries/:id operation on news-summary resource
 */
export const getAdminCrawlerNewsSummariesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrawlerNewsSummariesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerNewsSummariesByIdResponses,
    GetAdminCrawlerNewsSummariesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/news-summaries/{id}",
    ...options,
  });

/**
 * /clinical/practice-tools/catalog/:id/permanent operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/catalog/:id/permanent operation on clinical-practice-tool resource
 */
export const deleteAdminClinicalPracticeToolsCatalogByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalPracticeToolsCatalogByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalPracticeToolsCatalogByIdPermanentResponses,
    DeleteAdminClinicalPracticeToolsCatalogByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/catalog/{id}/permanent",
    ...options,
  });

/**
 * /support/queues/:id operation on support-queue resource
 *
 * /support/queues/:id operation on support-queue resource
 */
export const deleteAdminSupportQueuesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSupportQueuesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSupportQueuesByIdResponses,
    DeleteAdminSupportQueuesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/queues/{id}",
    ...options,
  });

/**
 * /support/queues/:id operation on support-queue resource
 *
 * /support/queues/:id operation on support-queue resource
 */
export const getAdminSupportQueuesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSupportQueuesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSupportQueuesByIdResponses,
    GetAdminSupportQueuesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/queues/{id}",
    ...options,
  });

/**
 * Update queue settings including ai_mode, SLA policy, priority boost, and business hours
 *
 * Update queue settings including ai_mode, SLA policy, priority boost, and business hours. Changes to ai_mode take effect on next ticket assignment — existing tickets retain their current handling mode.
 */
export const patchAdminSupportQueuesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSupportQueuesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSupportQueuesByIdResponses,
    PatchAdminSupportQueuesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/queues/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Return the names of all configured Meilisearch indexes
 *
 * Return the names of all configured Meilisearch indexes. Platform admin access only.
 */
export const getAdminSearchIndexes = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSearchIndexesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSearchIndexesResponses,
    GetAdminSearchIndexesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/indexes",
    ...options,
  });

/**
 * List feature definitions for a specific application.
 *
 * List feature definitions for a specific application.
 */
export const getAdminFeatureDefinitionsByApplicationByApplicationId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminFeatureDefinitionsByApplicationByApplicationIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminFeatureDefinitionsByApplicationByApplicationIdResponses,
    GetAdminFeatureDefinitionsByApplicationByApplicationIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/feature-definitions/by-application/{application_id}",
    ...options,
  });

/**
 * Create a support ticket
 *
 * Create a support ticket. Auto-generates a workspace-scoped ticket number (TKT-YYYY-NNNNN),
 * validates quota and queue assignment. Indexes in Meilisearch. Enqueues ClassifyTicketWorker
 * if auto_classify enabled (AiConfig). Returns the created Ticket with :new status.
 *
 */
export const postAdminSupportTickets = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSupportTicketsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSupportTicketsResponses,
    PostAdminSupportTicketsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/tickets",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/results/:id operation on crawler-result resource
 *
 * /crawler/results/:id operation on crawler-result resource
 */
export const getAdminCrawlerResultsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrawlerResultsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerResultsByIdResponses,
    GetAdminCrawlerResultsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/results/{id}",
    ...options,
  });

/**
 * End a voice session and release the LiveKit room
 *
 * End a voice session and release the LiveKit room
 */
export const patchAdminVoiceSessionsByIdStop = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminVoiceSessionsByIdStopData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminVoiceSessionsByIdStopResponses,
    PatchAdminVoiceSessionsByIdStopErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/sessions/{id}/stop",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /reviews/:id/escalate operation on review resource
 *
 * /reviews/:id/escalate operation on review resource
 */
export const patchAdminReviewsByIdEscalate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminReviewsByIdEscalateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminReviewsByIdEscalateResponses,
    PatchAdminReviewsByIdEscalateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/reviews/{id}/escalate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Import a recipe from an external connector source
 *
 * Import a recipe from an external connector source
 */
export const postAdminRecipesImport = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminRecipesImportData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesImportResponses,
    PostAdminRecipesImportErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/import",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/sender-profiles/:id/set-default operation on email-marketing-sender-profile resource
 *
 * /email-marketing/sender-profiles/:id/set-default operation on email-marketing-sender-profile resource
 */
export const patchAdminEmailMarketingSenderProfilesByIdSetDefault = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailMarketingSenderProfilesByIdSetDefaultData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingSenderProfilesByIdSetDefaultResponses,
    PatchAdminEmailMarketingSenderProfilesByIdSetDefaultErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/sender-profiles/{id}/set-default",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Delete a training example belonging to this agent
 *
 * Delete a training example belonging to this agent
 */
export const deleteAdminAgentsByIdTrainingExamplesByExampleId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminAgentsByIdTrainingExamplesByExampleIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminAgentsByIdTrainingExamplesByExampleIdResponses,
    DeleteAdminAgentsByIdTrainingExamplesByExampleIdErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/training-examples/{example_id}",
    ...options,
  });

/**
 * Import an agent from a JSON payload produced by `:export`
 *
 * Import an agent from a JSON payload produced by `:export`. Creates the agent record with
 * name, description, vertical, and workspace from the payload, then bulk-creates all embedded
 * training examples. Uses the `:create` action internally (including `CreateInitialVersion`),
 * then overwrites the schema from the exported `schema_definition`.
 *
 * Use `:export` to produce the importable payload. Returns the created agent struct.
 *
 */
export const postAdminAgentsImport = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAgentsImportData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentsImportResponses,
    PostAdminAgentsImportErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/import",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Primary read for extraction results
 *
 * Primary read for extraction results. Filters hidden system fields (e.g., `_ip_address`,
 * `_llm_model`) from the response via `FilterHiddenFields`. Use `:read_one` for single-record
 * JSON:API GET, `:get_by_document` to fetch the latest result for a document, or
 * `:list_by_document` for full history.
 *
 */
export const getAdminExtractionResults = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminExtractionResultsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionResultsResponses,
    GetAdminExtractionResultsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/results",
    ...options,
  });

/**
 * Generate a new `whsec_`-prefixed HMAC secret for this webhook, invalidating the previous secret immediately
 *
 * Generate a new `whsec_`-prefixed HMAC secret for this webhook, invalidating the previous secret immediately. Callers must update their signature verification logic with the new secret returned in the response.
 */
export const patchAdminWebhookConfigsByIdRotateSecret = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWebhookConfigsByIdRotateSecretData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWebhookConfigsByIdRotateSecretResponses,
    PatchAdminWebhookConfigsByIdRotateSecretErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-configs/{id}/rotate-secret",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /settlement-statements/:id operation on settlement-statement resource
 *
 * /settlement-statements/:id operation on settlement-statement resource
 */
export const getAdminSettlementStatementsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSettlementStatementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSettlementStatementsByIdResponses,
    GetAdminSettlementStatementsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlement-statements/{id}",
    ...options,
  });

/**
 * Re-run extraction on an existing result, optionally with user feedback or targeting specific
 * fields
 *
 * Re-run extraction on an existing result, optionally with user feedback or targeting specific
 * fields. Use this when the initial extraction was incorrect and you want the AI to try again
 * with additional context. Supports partial re-extraction: `fields_to_retry` limits which
 * fields are re-extracted, and `schema_version_id` pins a specific agent version.
 *
 * Side effects: synchronously sets the parent Document status to `:queued` (progress 0),
 * then enqueues a `RegenerateExtraction` Oban job with the feedback and field targets.
 * The job transitions the document to `:processing` when it starts.
 *
 * Returns the ExtractionResult as-is (extraction output is updated asynchronously by the job).
 *
 */
export const patchAdminExtractionResultsByIdRegenerate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminExtractionResultsByIdRegenerateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionResultsByIdRegenerateResponses,
    PatchAdminExtractionResultsByIdRegenerateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/results/{id}/regenerate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/news-monitors/:id/resume operation on news-monitor resource
 *
 * /crawler/news-monitors/:id/resume operation on news-monitor resource
 */
export const patchAdminCrawlerNewsMonitorsByIdResume = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrawlerNewsMonitorsByIdResumeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrawlerNewsMonitorsByIdResumeResponses,
    PatchAdminCrawlerNewsMonitorsByIdResumeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/news-monitors/{id}/resume",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Renders published_body_html with variable substitutions for preview
 *
 * Renders published_body_html with variable substitutions for preview. Does not save.
 */
export const patchAdminEmailMarketingTemplatesByIdPreview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailMarketingTemplatesByIdPreviewData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingTemplatesByIdPreviewResponses,
    PatchAdminEmailMarketingTemplatesByIdPreviewErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/templates/{id}/preview",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /workspaces/:workspace_id/extraction/documents/dismiss-all-trained operation on bulk-dismissal-result resource
 *
 * /workspaces/:workspace_id/extraction/documents/dismiss-all-trained operation on bulk-dismissal-result resource
 */
export const postAdminWorkspacesByWorkspaceIdExtractionDocumentsDismissAllTrained =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PostAdminWorkspacesByWorkspaceIdExtractionDocumentsDismissAllTrainedData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      PostAdminWorkspacesByWorkspaceIdExtractionDocumentsDismissAllTrainedResponses,
      PostAdminWorkspacesByWorkspaceIdExtractionDocumentsDismissAllTrainedErrors,
      ThrowOnError
    >({
      querySerializer: {
        parameters: { fields: { object: { style: "form" } } },
      },
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/workspaces/{workspace_id}/extraction/documents/dismiss-all-trained",
      ...options,
      headers: {
        "Content-Type": "application/vnd.api+json",
        ...options.headers,
      },
    });

/**
 * /impact-assessments operation on data-protection-impact-assessment resource
 *
 * /impact-assessments operation on data-protection-impact-assessment resource
 */
export const getAdminImpactAssessments = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminImpactAssessmentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminImpactAssessmentsResponses,
    GetAdminImpactAssessmentsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/impact-assessments",
    ...options,
  });

/**
 * Open a new GDPR Article 35 Data Protection Impact Assessment for a high-risk processing activity
 *
 * Open a new GDPR Article 35 Data Protection Impact Assessment for a high-risk processing activity. The DPIA starts in `:draft` status and must be approved via :approve before it is considered complete.
 */
export const postAdminImpactAssessments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminImpactAssessmentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminImpactAssessmentsResponses,
    PostAdminImpactAssessmentsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/impact-assessments",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/note-templates/:id/permanent operation on clinical-note-template resource
 *
 * /clinical/note-templates/:id/permanent operation on clinical-note-template resource
 */
export const deleteAdminClinicalNoteTemplatesByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalNoteTemplatesByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalNoteTemplatesByIdPermanentResponses,
    DeleteAdminClinicalNoteTemplatesByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/{id}/permanent",
    ...options,
  });

/**
 * /agent-deployments/:id operation on agent-deployment resource
 *
 * /agent-deployments/:id operation on agent-deployment resource
 */
export const deleteAdminAgentDeploymentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminAgentDeploymentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminAgentDeploymentsByIdResponses,
    DeleteAdminAgentDeploymentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-deployments/{id}",
    ...options,
  });

/**
 * /agent-deployments/:id operation on agent-deployment resource
 *
 * /agent-deployments/:id operation on agent-deployment resource
 */
export const getAdminAgentDeploymentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAgentDeploymentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentDeploymentsByIdResponses,
    GetAdminAgentDeploymentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-deployments/{id}",
    ...options,
  });

/**
 * /agent-deployments/:id operation on agent-deployment resource
 *
 * /agent-deployments/:id operation on agent-deployment resource
 */
export const patchAdminAgentDeploymentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminAgentDeploymentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAgentDeploymentsByIdResponses,
    PatchAdminAgentDeploymentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-deployments/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Four-gate resolver answering "can this capability be enabled for this
 * Application (and optionally this Plan)?"
 *
 * Four-gate resolver answering "can this capability be enabled for this
 * Application (and optionally this Plan)?". Returns a per-gate breakdown
 * so dashboards do not have to reproduce the gating chain manually.
 *
 * Phase 1 skeleton: returns `allowed: false` with an empty checks list.
 * Real behavior lands in Phase 5.
 *
 */
export const getAdminPlanBundlesCanEnable = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPlanBundlesCanEnableData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPlanBundlesCanEnableResponses,
    GetAdminPlanBundlesCanEnableErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plan-bundles/can-enable",
    ...options,
  });

/**
 * /invoices/payments/:id operation on invoices-payment resource
 *
 * /invoices/payments/:id operation on invoices-payment resource
 */
export const deleteAdminInvoicesPaymentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminInvoicesPaymentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminInvoicesPaymentsByIdResponses,
    DeleteAdminInvoicesPaymentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/payments/{id}",
    ...options,
  });

/**
 * /invoices/payments/:id operation on invoices-payment resource
 *
 * /invoices/payments/:id operation on invoices-payment resource
 */
export const getAdminInvoicesPaymentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminInvoicesPaymentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminInvoicesPaymentsByIdResponses,
    GetAdminInvoicesPaymentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/payments/{id}",
    ...options,
  });

/**
 * /clinical/supplement-rec-cache/:id operation on clinical-supplement-rec-cache resource
 *
 * /clinical/supplement-rec-cache/:id operation on clinical-supplement-rec-cache resource
 */
export const getAdminClinicalSupplementRecCacheById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalSupplementRecCacheByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSupplementRecCacheByIdResponses,
    GetAdminClinicalSupplementRecCacheByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-rec-cache/{id}",
    ...options,
  });

/**
 * /clinical/supplement-rec-cache/:id operation on clinical-supplement-rec-cache resource
 *
 * /clinical/supplement-rec-cache/:id operation on clinical-supplement-rec-cache resource
 */
export const patchAdminClinicalSupplementRecCacheById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalSupplementRecCacheByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalSupplementRecCacheByIdResponses,
    PatchAdminClinicalSupplementRecCacheByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-rec-cache/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/note-templates/catalog/:id/archive operation on clinical-note-template resource
 *
 * /clinical/note-templates/catalog/:id/archive operation on clinical-note-template resource
 */
export const patchAdminClinicalNoteTemplatesCatalogByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalNoteTemplatesCatalogByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalNoteTemplatesCatalogByIdArchiveResponses,
    PatchAdminClinicalNoteTemplatesCatalogByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/catalog/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/site-configs operation on crawler-site-config resource
 *
 * /crawler/site-configs operation on crawler-site-config resource
 */
export const getAdminCrawlerSiteConfigs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrawlerSiteConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerSiteConfigsResponses,
    GetAdminCrawlerSiteConfigsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/site-configs",
    ...options,
  });

/**
 * Create per-domain crawl settings (rate limit, strategy, custom headers, robots.txt preference) for a workspace
 *
 * Create per-domain crawl settings (rate limit, strategy, custom headers, robots.txt preference) for a workspace. Returns the created config.
 */
export const postAdminCrawlerSiteConfigs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCrawlerSiteConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrawlerSiteConfigsResponses,
    PostAdminCrawlerSiteConfigsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/site-configs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /amendment-requests/:id operation on amendment-request resource
 *
 * /amendment-requests/:id operation on amendment-request resource
 */
export const getAdminAmendmentRequestsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAmendmentRequestsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAmendmentRequestsByIdResponses,
    GetAdminAmendmentRequestsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/amendment-requests/{id}",
    ...options,
  });

/**
 * /clinical/practice-tools/:id/permanent operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/:id/permanent operation on clinical-practice-tool resource
 */
export const deleteAdminClinicalPracticeToolsByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalPracticeToolsByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalPracticeToolsByIdPermanentResponses,
    DeleteAdminClinicalPracticeToolsByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/{id}/permanent",
    ...options,
  });

/**
 * /contracts/:id operation on contract resource
 *
 * /contracts/:id operation on contract resource
 */
export const deleteAdminContractsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminContractsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminContractsByIdResponses,
    DeleteAdminContractsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/contracts/{id}",
    ...options,
  });

/**
 * /contracts/:id operation on contract resource
 *
 * /contracts/:id operation on contract resource
 */
export const getAdminContractsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminContractsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminContractsByIdResponses,
    GetAdminContractsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/contracts/{id}",
    ...options,
  });

/**
 * /contracts/:id operation on contract resource
 *
 * /contracts/:id operation on contract resource
 */
export const patchAdminContractsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminContractsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminContractsByIdResponses,
    PatchAdminContractsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/contracts/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List active contacts in a workspace with optional lifecycle_stage, tag, and
 * property filters applied Elixir-side
 *
 * List active contacts in a workspace with optional lifecycle_stage, tag, and
 * property filters applied Elixir-side. Use instead of :read when you need
 * workspace-scoped paginated results or attribute-level filtering.
 *
 */
export const getAdminCrmContactsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrmContactsWorkspaceByWorkspaceIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmContactsWorkspaceByWorkspaceIdResponses,
    GetAdminCrmContactsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/contacts/workspace/{workspace_id}",
    ...options,
  });

/**
 * Mark a booking as :no_show when the booker did not attend
 *
 * Mark a booking as :no_show when the booker did not attend. Used by CompletionWorker or manual ISV action. No linked Event status change.
 */
export const patchAdminSchedulingBookingsByIdMarkNoShow = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminSchedulingBookingsByIdMarkNoShowData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingBookingsByIdMarkNoShowResponses,
    PatchAdminSchedulingBookingsByIdMarkNoShowErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/bookings/{id}/mark-no-show",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch the latest ExtractionResult for a given document
 *
 * Fetch the latest ExtractionResult for a given document. Returns the most recently created
 * result (sorted by `inserted_at` descending, limit 1). Hidden system fields are filtered.
 * Use `:get_partial_by_document` if you need per-field `field_status` for in-progress tracking.
 *
 */
export const getAdminExtractionResultsDocumentByDocumentId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionResultsDocumentByDocumentIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionResultsDocumentByDocumentIdResponses,
    GetAdminExtractionResultsDocumentByDocumentIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/results/document/{document_id}",
    ...options,
  });

/**
 * /clinical/practice-resources/catalog/:id/archive operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/catalog/:id/archive operation on clinical-practice-resource resource
 */
export const patchAdminClinicalPracticeResourcesCatalogByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalPracticeResourcesCatalogByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPracticeResourcesCatalogByIdArchiveResponses,
    PatchAdminClinicalPracticeResourcesCatalogByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/catalog/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch a single metadata record describing the permission system — schema version, available apps, scopes, categories, and suggested client cache TTL
 *
 * Fetch a single metadata record describing the permission system — schema version, available apps, scopes, categories, and suggested client cache TTL. Use to seed permission-picker UI configuration.
 */
export const getAdminPermissionsMeta = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPermissionsMetaData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPermissionsMetaResponses,
    GetAdminPermissionsMetaErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/permissions/meta",
    ...options,
  });

/**
 * List supplement template collections for a workspace
 *
 * List supplement template collections for a workspace
 */
export const getAdminClinicalSupplementTemplateCollections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalSupplementTemplateCollectionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSupplementTemplateCollectionsResponses,
    GetAdminClinicalSupplementTemplateCollectionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-template-collections",
    ...options,
  });

/**
 * /clinical/supplement-template-collections operation on clinical-supplement-template-collection resource
 *
 * /clinical/supplement-template-collections operation on clinical-supplement-template-collection resource
 */
export const postAdminClinicalSupplementTemplateCollections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminClinicalSupplementTemplateCollectionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminClinicalSupplementTemplateCollectionsResponses,
    PostAdminClinicalSupplementTemplateCollectionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-template-collections",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Deliver this email immediately via connected account.
 *
 * Deliver this email immediately via connected account.
 */
export const patchAdminEmailOutboundEmailsByIdSend = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminEmailOutboundEmailsByIdSendData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailOutboundEmailsByIdSendResponses,
    PatchAdminEmailOutboundEmailsByIdSendErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/outbound-emails/{id}/send",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /compliance-requirement-completions/:id operation on compliance-requirement-completion resource
 *
 * /compliance-requirement-completions/:id operation on compliance-requirement-completion resource
 */
export const getAdminComplianceRequirementCompletionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminComplianceRequirementCompletionsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminComplianceRequirementCompletionsByIdResponses,
    GetAdminComplianceRequirementCompletionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-requirement-completions/{id}",
    ...options,
  });

/**
 * Create a new immutable version from current agent state
 *
 * Create a new immutable version from current agent state
 */
export const postAdminAgentsByIdPublishVersion = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminAgentsByIdPublishVersionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentsByIdPublishVersionResponses,
    PostAdminAgentsByIdPublishVersionErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/publish-version",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Accept an available version update
 *
 * Accept an available version update
 */
export const patchAdminAgentDeploymentsByIdAcceptUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminAgentDeploymentsByIdAcceptUpdateData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminAgentDeploymentsByIdAcceptUpdateResponses,
    PatchAdminAgentDeploymentsByIdAcceptUpdateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-deployments/{id}/accept-update",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/supplement-templates/catalog operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/catalog operation on clinical-supplement-template resource
 */
export const getAdminClinicalSupplementTemplatesCatalog = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalSupplementTemplatesCatalogData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSupplementTemplatesCatalogResponses,
    GetAdminClinicalSupplementTemplatesCatalogErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/catalog",
    ...options,
  });

/**
 * /clinical/supplement-templates/catalog operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/catalog operation on clinical-supplement-template resource
 */
export const postAdminClinicalSupplementTemplatesCatalog = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminClinicalSupplementTemplatesCatalogData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminClinicalSupplementTemplatesCatalogResponses,
    PostAdminClinicalSupplementTemplatesCatalogErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/catalog",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Run a semantic similarity search against vectorized document chunks for the caller's tenant; embeds the query text and returns the top-k most relevant chunks ranked by cosine similarity.
 *
 * Run a semantic similarity search against vectorized document chunks for the caller's tenant; embeds the query text and returns the top-k most relevant chunks ranked by cosine similarity.
 */
export const postAdminAiSearch = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAiSearchData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAiSearchResponses,
    PostAdminAiSearchErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/search",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Generate a short-lived presigned download URL for a file
 *
 * Generate a short-lived presigned download URL for a file. Returns the URL and its expiry timestamp.
 */
export const postAdminStorageFilesByIdDownloadUrl = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminStorageFilesByIdDownloadUrlData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminStorageFilesByIdDownloadUrlResponses,
    PostAdminStorageFilesByIdDownloadUrlErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-files/{id}/download-url",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all credit packages available for purchase in the calling application
 *
 * List all credit packages available for purchase in the calling application. Use this to
 * populate a top-up UI showing available bundle options (e.g., "1,000 credits for $10").
 * Returns packages scoped to the application inferred from the request context.
 *
 * Supports keyset and offset pagination. Readable by anyone (unauthenticated).
 *
 */
export const getAdminCreditPackages = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCreditPackagesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCreditPackagesResponses,
    GetAdminCreditPackagesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/credit-packages",
    ...options,
  });

/**
 * Create a new credit package (purchasable top-up bundle) for an application
 *
 * Create a new credit package (purchasable top-up bundle) for an application. Defines the
 * package name, slug, price, and how many credits are granted upon purchase. Use this when
 * setting up or expanding the top-up catalog for an ISV application.
 *
 * Scoped to an application via application_id (inferred from the x-application-key header when
 * not provided). Requires Platform Admin role. Returns the created credit package record.
 *
 */
export const postAdminCreditPackages = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCreditPackagesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCreditPackagesResponses,
    PostAdminCreditPackagesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/credit-packages",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Finish upload for all documents in this batch that are awaiting processing
 *
 * Finish upload for all documents in this batch that are awaiting processing.
 * Calls :finish_upload on each document that is still in :queued status.
 * Returns a map with processed count and per-document results.
 *
 */
export const postAdminExtractionBatchesByIdFinishAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminExtractionBatchesByIdFinishAllData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminExtractionBatchesByIdFinishAllResponses,
    PostAdminExtractionBatchesByIdFinishAllErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/batches/{id}/finish-all",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List saved searches accessible to the current actor: the actor's own searches and any searches marked `is_shared` within the same tenant.
 *
 * List saved searches accessible to the current actor: the actor's own searches and any searches marked `is_shared` within the same tenant.
 */
export const getAdminSearchSaved = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSearchSavedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSearchSavedResponses,
    GetAdminSearchSavedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/saved",
    ...options,
  });

/**
 * Persist a named search query for reuse
 *
 * Persist a named search query for reuse. The `user_id` and `tenant_id` are set from the actor and request context. Set `is_shared: true` to make the search visible to all tenant members.
 */
export const postAdminSearchSaved = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSearchSavedData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSearchSavedResponses,
    PostAdminSearchSavedErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/saved",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Explicitly link an OAuth provider to an existing user
 *
 * Explicitly link an OAuth provider to an existing user. Upserts a row in the
 * `GptCore.Identity.UserIdentity` table keyed on (user_id, uid, strategy) —
 * `uid` is extracted from `user_info["sub"|"uid"|"id"]` by
 * `AshAuthentication.UserIdentity.UpsertIdentityChange`. Emits
 * `identity.oauth.linked` only if the row write succeeded.
 *
 */
export const patchAdminUsersAuthOauthLink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminUsersAuthOauthLinkData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminUsersAuthOauthLinkResponses,
    PatchAdminUsersAuthOauthLinkErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/auth/oauth/link",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/templates/:id operation on email-marketing-template resource
 *
 * /email-marketing/templates/:id operation on email-marketing-template resource
 */
export const deleteAdminEmailMarketingTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminEmailMarketingTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminEmailMarketingTemplatesByIdResponses,
    DeleteAdminEmailMarketingTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/templates/{id}",
    ...options,
  });

/**
 * /email-marketing/templates/:id operation on email-marketing-template resource
 *
 * /email-marketing/templates/:id operation on email-marketing-template resource
 */
export const getAdminEmailMarketingTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminEmailMarketingTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEmailMarketingTemplatesByIdResponses,
    GetAdminEmailMarketingTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/templates/{id}",
    ...options,
  });

/**
 * /email-marketing/templates/:id operation on email-marketing-template resource
 *
 * /email-marketing/templates/:id operation on email-marketing-template resource
 */
export const patchAdminEmailMarketingTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminEmailMarketingTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingTemplatesByIdResponses,
    PatchAdminEmailMarketingTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/templates/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /documents/stats operation on document-stats resource
 *
 * /documents/stats operation on document-stats resource
 */
export const getAdminDocumentsStats = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminDocumentsStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminDocumentsStatsResponses,
    GetAdminDocumentsStatsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/documents/stats",
    ...options,
  });

/**
 * Delete a relationship (edge) by matching from/to nodes and type
 *
 * Delete a relationship (edge) by matching from/to nodes and type
 */
export const postAdminAiGraphRelationshipsDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminAiGraphRelationshipsDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAiGraphRelationshipsDeleteResponses,
    PostAdminAiGraphRelationshipsDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/graph/relationships/delete",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Workspace-scoped summary of non-archived review queues
 *
 * Workspace-scoped summary of non-archived review queues. Returns a list
 * of %{queue_id, slug, name, pending_count, sla_overdue_count}.
 *
 */
export const getAdminReviewQueuesSummaries = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminReviewQueuesSummariesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminReviewQueuesSummariesResponses,
    GetAdminReviewQueuesSummariesErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/review-queues/summaries",
    ...options,
  });

/**
 * /crawler/browser-sessions operation on browser-session resource
 *
 * /crawler/browser-sessions operation on browser-session resource
 */
export const getAdminCrawlerBrowserSessions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrawlerBrowserSessionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerBrowserSessionsResponses,
    GetAdminCrawlerBrowserSessionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/browser-sessions",
    ...options,
  });

/**
 * /crawler/browser-sessions operation on browser-session resource
 *
 * /crawler/browser-sessions operation on browser-session resource
 */
export const postAdminCrawlerBrowserSessions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCrawlerBrowserSessionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrawlerBrowserSessionsResponses,
    PostAdminCrawlerBrowserSessionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/browser-sessions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /webhook-deliveries operation on webhook-delivery resource
 *
 * /webhook-deliveries operation on webhook-delivery resource
 */
export const getAdminWebhookDeliveries = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminWebhookDeliveriesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWebhookDeliveriesResponses,
    GetAdminWebhookDeliveriesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-deliveries",
    ...options,
  });

/**
 * /clinical/insurance-authorizations operation on clinical-insurance-authorization resource
 *
 * /clinical/insurance-authorizations operation on clinical-insurance-authorization resource
 */
export const getAdminClinicalInsuranceAuthorizations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalInsuranceAuthorizationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalInsuranceAuthorizationsResponses,
    GetAdminClinicalInsuranceAuthorizationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/insurance-authorizations",
    ...options,
  });

/**
 * /clinical/insurance-authorizations operation on clinical-insurance-authorization resource
 *
 * /clinical/insurance-authorizations operation on clinical-insurance-authorization resource
 */
export const postAdminClinicalInsuranceAuthorizations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalInsuranceAuthorizationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalInsuranceAuthorizationsResponses,
    PostAdminClinicalInsuranceAuthorizationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/insurance-authorizations",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /pipeline-executions/:id/approve operation on pipeline-execution resource
 *
 * /pipeline-executions/:id/approve operation on pipeline-execution resource
 */
export const patchAdminPipelineExecutionsByIdApprove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPipelineExecutionsByIdApproveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPipelineExecutionsByIdApproveResponses,
    PatchAdminPipelineExecutionsByIdApproveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-executions/{id}/approve",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Primary read for active (non-deleted) documents
 *
 * Primary read for active (non-deleted) documents. Excludes soft-deleted documents.
 * Use `:read_trashed` to list deleted documents, or `:list_by_workspace` for a workspace-scoped
 * listing with optional batch filtering.
 *
 */
export const getAdminExtractionDocuments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionDocumentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionDocumentsResponses,
    GetAdminExtractionDocumentsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents",
    ...options,
  });

/**
 * /agent-version-revisions/:id operation on agent-version-revision resource
 *
 * /agent-version-revisions/:id operation on agent-version-revision resource
 */
export const getAdminAgentVersionRevisionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAgentVersionRevisionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentVersionRevisionsByIdResponses,
    GetAdminAgentVersionRevisionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-version-revisions/{id}",
    ...options,
  });

/**
 * /crawler/news-summaries operation on news-summary resource
 *
 * /crawler/news-summaries operation on news-summary resource
 */
export const getAdminCrawlerNewsSummaries = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrawlerNewsSummariesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerNewsSummariesResponses,
    GetAdminCrawlerNewsSummariesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/news-summaries",
    ...options,
  });

/**
 * /contracts operation on contract resource
 *
 * /contracts operation on contract resource
 */
export const getAdminContracts = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminContractsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminContractsResponses,
    GetAdminContractsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/contracts",
    ...options,
  });

/**
 * /contracts operation on contract resource
 *
 * /contracts operation on contract resource
 */
export const postAdminContracts = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminContractsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminContractsResponses,
    PostAdminContractsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/contracts",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /extraction/agents/:id operation on extraction-agent resource
 *
 * /extraction/agents/:id operation on extraction-agent resource
 */
export const getAdminExtractionAgentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionAgentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionAgentsByIdResponses,
    GetAdminExtractionAgentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/agents/{id}",
    ...options,
  });

/**
 * List events in a workspace that overlap a given time window (start_time < end, end_time > start)
 *
 * List events in a workspace that overlap a given time window (start_time < end, end_time > start). Use for calendar week/month views. Returns events of all statuses including cancelled.
 */
export const getAdminSchedulingEventsByDateRange = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingEventsByDateRangeData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingEventsByDateRangeResponses,
    GetAdminSchedulingEventsByDateRangeErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/events/by_date_range",
    ...options,
  });

/**
 * List all email templates for the application, including both system and custom templates
 *
 * List all email templates for the application, including both system and custom templates. Use :get_by_slug to fetch a specific template by its slug identifier.
 */
export const getAdminApplicationsByApplicationIdEmailTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminApplicationsByApplicationIdEmailTemplatesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminApplicationsByApplicationIdEmailTemplatesResponses,
    GetAdminApplicationsByApplicationIdEmailTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/{application_id}/email-templates",
    ...options,
  });

/**
 * Create a new custom email template for the application
 *
 * Create a new custom email template for the application. Slugs matching system-reserved names are rejected; use :update on ISV-customizable system templates instead.
 */
export const postAdminApplicationsByApplicationIdEmailTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminApplicationsByApplicationIdEmailTemplatesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminApplicationsByApplicationIdEmailTemplatesResponses,
    PostAdminApplicationsByApplicationIdEmailTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/{application_id}/email-templates",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/shopping-lists/generate operation on recipes-shopping-list resource
 *
 * /recipes/shopping-lists/generate operation on recipes-shopping-list resource
 */
export const postAdminRecipesShoppingListsGenerate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminRecipesShoppingListsGenerateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesShoppingListsGenerateResponses,
    PostAdminRecipesShoppingListsGenerateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/shopping-lists/generate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /impact-assessments/:id operation on data-protection-impact-assessment resource
 *
 * /impact-assessments/:id operation on data-protection-impact-assessment resource
 */
export const getAdminImpactAssessmentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminImpactAssessmentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminImpactAssessmentsByIdResponses,
    GetAdminImpactAssessmentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/impact-assessments/{id}",
    ...options,
  });

/**
 * Update the DPIA's title, description, risk level, findings, or mitigations while it is in draft or in_review status
 *
 * Update the DPIA's title, description, risk level, findings, or mitigations while it is in draft or in_review status. Use :approve to finalize the assessment.
 */
export const patchAdminImpactAssessmentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminImpactAssessmentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminImpactAssessmentsByIdResponses,
    PatchAdminImpactAssessmentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/impact-assessments/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List pending AI classification suggestions for a workspace awaiting ISV review
 *
 * List pending AI classification suggestions for a workspace awaiting ISV review. Returns a paginated list.
 */
export const getAdminCatalogClassificationSuggestionsWorkspaceByWorkspaceIdPending =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAdminCatalogClassificationSuggestionsWorkspaceByWorkspaceIdPendingData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetAdminCatalogClassificationSuggestionsWorkspaceByWorkspaceIdPendingResponses,
      GetAdminCatalogClassificationSuggestionsWorkspaceByWorkspaceIdPendingErrors,
      ThrowOnError
    >({
      querySerializer: {
        parameters: {
          filter: { object: { style: "form" } },
          page: { object: { style: "form" } },
          fields: { object: { style: "form" } },
        },
      },
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/catalog/classification-suggestions/workspace/{workspace_id}/pending",
      ...options,
    });

/**
 * Fetch LLM analytics scoped to a single workspace; use for per-workspace usage dashboards and cost attribution.
 *
 * Fetch LLM analytics scoped to a single workspace; use for per-workspace usage dashboards and cost attribution.
 */
export const getAdminLlmAnalyticsWorkspace = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminLlmAnalyticsWorkspaceData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLlmAnalyticsWorkspaceResponses,
    GetAdminLlmAnalyticsWorkspaceErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/llm-analytics/workspace",
    ...options,
  });

/**
 * /clinical/health-metrics/:id/permanent operation on clinical-health-metric resource
 *
 * /clinical/health-metrics/:id/permanent operation on clinical-health-metric resource
 */
export const deleteAdminClinicalHealthMetricsByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalHealthMetricsByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalHealthMetricsByIdPermanentResponses,
    DeleteAdminClinicalHealthMetricsByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/health-metrics/{id}/permanent",
    ...options,
  });

/**
 * Return the current user's active thread for their workspace, creating a new one if none exists or the existing thread has expired (>24h inactive)
 *
 * Return the current user's active thread for their workspace, creating a new one if none exists or the existing thread has expired (>24h inactive). The new thread inherits context from the expired one via `previous_thread_id`.
 */
export const postAdminThreadsActive = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminThreadsActiveData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminThreadsActiveResponses,
    PostAdminThreadsActiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/active",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Look up a plan by its unique slug within an application (e.g., "pro", "business", "free")
 *
 * Look up a plan by its unique slug within an application (e.g., "pro", "business", "free").
 * Use this for plan selection flows where the slug is known from config or the UI.
 * Use read_one when you have the UUID. Returns a single plan or an error if the slug is not found.
 *
 */
export const getAdminPlansSlugBySlug = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPlansSlugBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPlansSlugBySlugResponses,
    GetAdminPlansSlugBySlugErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plans/slug/{slug}",
    ...options,
  });

/**
 * /crm/phone-numbers/entity/:entity_type/:entity_id operation on crm-phone-number resource
 *
 * /crm/phone-numbers/entity/:entity_type/:entity_id operation on crm-phone-number resource
 */
export const getAdminCrmPhoneNumbersEntityByEntityTypeByEntityId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmPhoneNumbersEntityByEntityTypeByEntityIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmPhoneNumbersEntityByEntityTypeByEntityIdResponses,
    GetAdminCrmPhoneNumbersEntityByEntityTypeByEntityIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/phone-numbers/entity/{entity_type}/{entity_id}",
    ...options,
  });

/**
 * /agent-version-revisions operation on agent-version-revision resource
 *
 * /agent-version-revisions operation on agent-version-revision resource
 */
export const getAdminAgentVersionRevisions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAgentVersionRevisionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentVersionRevisionsResponses,
    GetAdminAgentVersionRevisionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-version-revisions",
    ...options,
  });

/**
 * /isv-revenue/:id operation on isv-revenue resource
 *
 * /isv-revenue/:id operation on isv-revenue resource
 */
export const getAdminIsvRevenueById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminIsvRevenueByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminIsvRevenueByIdResponses,
    GetAdminIsvRevenueByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv-revenue/{id}",
    ...options,
  });

/**
 * /clinical/client-medications/:id/permanent operation on clinical-client-medication resource
 *
 * /clinical/client-medications/:id/permanent operation on clinical-client-medication resource
 */
export const deleteAdminClinicalClientMedicationsByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalClientMedicationsByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalClientMedicationsByIdPermanentResponses,
    DeleteAdminClinicalClientMedicationsByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-medications/{id}/permanent",
    ...options,
  });

/**
 * /invoices/recurring-schedules/:id operation on invoices-recurring-schedule resource
 *
 * /invoices/recurring-schedules/:id operation on invoices-recurring-schedule resource
 */
export const deleteAdminInvoicesRecurringSchedulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminInvoicesRecurringSchedulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminInvoicesRecurringSchedulesByIdResponses,
    DeleteAdminInvoicesRecurringSchedulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/recurring-schedules/{id}",
    ...options,
  });

/**
 * /invoices/recurring-schedules/:id operation on invoices-recurring-schedule resource
 *
 * /invoices/recurring-schedules/:id operation on invoices-recurring-schedule resource
 */
export const getAdminInvoicesRecurringSchedulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminInvoicesRecurringSchedulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminInvoicesRecurringSchedulesByIdResponses,
    GetAdminInvoicesRecurringSchedulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/recurring-schedules/{id}",
    ...options,
  });

/**
 * /invoices/recurring-schedules/:id operation on invoices-recurring-schedule resource
 *
 * /invoices/recurring-schedules/:id operation on invoices-recurring-schedule resource
 */
export const patchAdminInvoicesRecurringSchedulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesRecurringSchedulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesRecurringSchedulesByIdResponses,
    PatchAdminInvoicesRecurringSchedulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/recurring-schedules/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all active variants for a given product, sorted by position
 *
 * List all active variants for a given product, sorted by position. Returns a paginated list.
 */
export const getAdminCatalogProductVariantsProductByProductId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogProductVariantsProductByProductIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogProductVariantsProductByProductIdResponses,
    GetAdminCatalogProductVariantsProductByProductIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/product-variants/product/{product_id}",
    ...options,
  });

/**
 * Permanently delete an option value; removes associated variant_option_values
 *
 * Permanently delete an option value; removes associated variant_option_values. Ensure no active variants reference this value.
 */
export const deleteAdminCatalogOptionValuesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCatalogOptionValuesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCatalogOptionValuesByIdResponses,
    DeleteAdminCatalogOptionValuesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/option-values/{id}",
    ...options,
  });

/**
 * /catalog/option-values/:id operation on catalog-option-value resource
 *
 * /catalog/option-values/:id operation on catalog-option-value resource
 */
export const getAdminCatalogOptionValuesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCatalogOptionValuesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCatalogOptionValuesByIdResponses,
    GetAdminCatalogOptionValuesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/option-values/{id}",
    ...options,
  });

/**
 * Update the name, slug, position, or metadata of an option value
 *
 * Update the name, slug, position, or metadata of an option value. Returns the updated option value.
 */
export const patchAdminCatalogOptionValuesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCatalogOptionValuesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogOptionValuesByIdResponses,
    PatchAdminCatalogOptionValuesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/option-values/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /agent-tools operation on agent-tool resource
 *
 * /agent-tools operation on agent-tool resource
 */
export const getAdminAgentTools = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAgentToolsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentToolsResponses,
    GetAdminAgentToolsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-tools",
    ...options,
  });

/**
 * Schedule an Oban job to purge all storage objects for the given tenant
 *
 * Schedule an Oban job to purge all storage objects for the given tenant. Used
 * by platform admins to queue asynchronous data purges after account termination.
 * The actual file deletion runs in the background via Storage facade workers.
 *
 * Returns the tenant record.
 *
 */
export const postAdminTenantsByIdSchedulePurge = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminTenantsByIdSchedulePurgeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTenantsByIdSchedulePurgeResponses,
    PostAdminTenantsByIdSchedulePurgeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}/schedule-purge",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/news-monitors/:id/archive operation on news-monitor resource
 *
 * /crawler/news-monitors/:id/archive operation on news-monitor resource
 */
export const patchAdminCrawlerNewsMonitorsByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrawlerNewsMonitorsByIdArchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrawlerNewsMonitorsByIdArchiveResponses,
    PatchAdminCrawlerNewsMonitorsByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/news-monitors/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /documents/bulk-delete operation on operation-success resource
 *
 * /documents/bulk-delete operation on operation-success resource
 */
export const postAdminDocumentsBulkDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminDocumentsBulkDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminDocumentsBulkDeleteResponses,
    PostAdminDocumentsBulkDeleteErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/documents/bulk-delete",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /meeting-transcripts/:id operation on meeting-transcript resource
 *
 * /meeting-transcripts/:id operation on meeting-transcript resource
 */
export const getAdminMeetingTranscriptsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminMeetingTranscriptsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminMeetingTranscriptsByIdResponses,
    GetAdminMeetingTranscriptsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/meeting-transcripts/{id}",
    ...options,
  });

/**
 * Generate an image generation prompt from marketing copy.
 *
 * Generate an image generation prompt from marketing copy.
 */
export const postAdminContentGenerateImagePrompt = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminContentGenerateImagePromptData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminContentGenerateImagePromptResponses,
    PostAdminContentGenerateImagePromptErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/content/generate-image-prompt",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Suspend a tenant, preventing billing charges and access.
 *
 * Suspend a tenant, preventing billing charges and access.
 */
export const patchAdminTenantsByIdSuspend = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminTenantsByIdSuspendData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTenantsByIdSuspendResponses,
    PatchAdminTenantsByIdSuspendErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}/suspend",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/goal-templates/catalog/:id/restore operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/catalog/:id/restore operation on clinical-goal-template resource
 */
export const patchAdminClinicalGoalTemplatesCatalogByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalGoalTemplatesCatalogByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalGoalTemplatesCatalogByIdRestoreResponses,
    PatchAdminClinicalGoalTemplatesCatalogByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/catalog/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Workspace-scoped read of open Cases ordered for attention
 *
 * Workspace-scoped read of open Cases ordered for attention. Filters
 * is_open == true. Sorted by sla_due_at asc nulls last, priority desc,
 * opened_at asc. Capped at limit <= 25.
 *
 */
export const getAdminCasesAttention = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCasesAttentionData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCasesAttentionResponses,
    GetAdminCasesAttentionErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cases/attention",
    ...options,
  });

/**
 * Transfer credits from the tenant's liability account to this workspace's
 * liability account
 *
 * Transfer credits from the tenant's liability account to this workspace's
 * liability account. Capped at 100,000 credits per call. Restricted to tenant
 * admins and workspace billing managers. Use for manual credit allocation;
 * automatic allocation happens at workspace creation via initial_credits.
 *
 * Returns the workspace record after allocation.
 *
 */
export const patchAdminWorkspacesByIdAllocate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWorkspacesByIdAllocateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWorkspacesByIdAllocateResponses,
    PatchAdminWorkspacesByIdAllocateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{id}/allocate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-resources/categories operation on clinical-practice-resource-category resource
 *
 * /clinical/practice-resources/categories operation on clinical-practice-resource-category resource
 */
export const getAdminClinicalPracticeResourcesCategories = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalPracticeResourcesCategoriesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeResourcesCategoriesResponses,
    GetAdminClinicalPracticeResourcesCategoriesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/categories",
    ...options,
  });

/**
 * Bootstrap schema discovery without an agent
 *
 * Bootstrap schema discovery without an agent
 */
export const postAdminExtractionSchemaDiscoveriesBootstrap = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminExtractionSchemaDiscoveriesBootstrapData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminExtractionSchemaDiscoveriesBootstrapResponses,
    PostAdminExtractionSchemaDiscoveriesBootstrapErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/schema-discoveries/bootstrap",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/phone-numbers operation on crm-phone-number resource
 *
 * /crm/phone-numbers operation on crm-phone-number resource
 */
export const postAdminCrmPhoneNumbers = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrmPhoneNumbersData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmPhoneNumbersResponses,
    PostAdminCrmPhoneNumbersErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/phone-numbers",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/accounts operation on social-account resource
 *
 * /social/accounts operation on social-account resource
 */
export const postAdminSocialAccounts = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSocialAccountsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSocialAccountsResponses,
    PostAdminSocialAccountsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/accounts",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /pipeline-node-executions/:id operation on pipeline-node-execution resource
 *
 * /pipeline-node-executions/:id operation on pipeline-node-execution resource
 */
export const getAdminPipelineNodeExecutionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPipelineNodeExecutionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPipelineNodeExecutionsByIdResponses,
    GetAdminPipelineNodeExecutionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-node-executions/{id}",
    ...options,
  });

/**
 * Deny an amendment request with a reason.
 *
 * Deny an amendment request with a reason.
 */
export const patchAdminAmendmentRequestsByIdDeny = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminAmendmentRequestsByIdDenyData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAmendmentRequestsByIdDenyResponses,
    PatchAdminAmendmentRequestsByIdDenyErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/amendment-requests/{id}/deny",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /ephi-assets/:id operation on ephi-asset resource
 *
 * /ephi-assets/:id operation on ephi-asset resource
 */
export const getAdminEphiAssetsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminEphiAssetsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEphiAssetsByIdResponses,
    GetAdminEphiAssetsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ephi-assets/{id}",
    ...options,
  });

/**
 * /ephi-assets/:id operation on ephi-asset resource
 *
 * /ephi-assets/:id operation on ephi-asset resource
 */
export const patchAdminEphiAssetsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminEphiAssetsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminEphiAssetsByIdResponses,
    PatchAdminEphiAssetsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ephi-assets/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Mark a document as excluded from agent training
 *
 * Mark a document as excluded from agent training. Prevents its associated extraction results
 * from being used as few-shot training examples. Sets `excluded_from_training: true`,
 * records the timestamp and the actor who performed the exclusion.
 *
 * Side effects: synchronously updates the `document_excluded` denormalized flag on all
 * associated `TrainingExample` records so they are filtered out of semantic search.
 *
 * Use `:include_in_training` to reverse this. See the `:excluded` read action to list
 * currently excluded documents.
 *
 */
export const patchAdminExtractionDocumentsByIdExclude = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminExtractionDocumentsByIdExcludeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionDocumentsByIdExcludeResponses,
    PatchAdminExtractionDocumentsByIdExcludeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}/exclude",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Update the compliance tags for an application (GDPR, HIPAA, SOC2, PCI-DSS, etc.)
 *
 * Update the compliance tags for an application (GDPR, HIPAA, SOC2, PCI-DSS, etc.).
 * Validates tags against the platform allowlist and checks that compliance
 * configuration is compatible with the selected tags (e.g. HIPAA session timeout
 * settings). Logs a compliance_tags_changed audit event. Restricted
 * to platform admins only.
 *
 */
export const patchAdminApplicationsByIdComplianceTags = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminApplicationsByIdComplianceTagsData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminApplicationsByIdComplianceTagsResponses,
    PatchAdminApplicationsByIdComplianceTagsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/{id}/compliance-tags",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/contacts operation on invoices-contact resource
 *
 * /invoices/contacts operation on invoices-contact resource
 */
export const postAdminInvoicesContacts = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminInvoicesContactsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminInvoicesContactsResponses,
    PostAdminInvoicesContactsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/contacts",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Resend an invitation email using the originally-resolved email method
 *
 * Resend an invitation email using the originally-resolved email method. Link
 * mode preserves existing behavior by refreshing the long token and 7-day expiry.
 * Code mode also rotates the short code and 15-minute expiry.
 *
 */
export const patchAdminInvitationsByIdResend = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvitationsByIdResendData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvitationsByIdResendResponses,
    PatchAdminInvitationsByIdResendErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invitations/{id}/resend",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /processing-activities/:id operation on processing-activity resource
 *
 * /processing-activities/:id operation on processing-activity resource
 */
export const deleteAdminProcessingActivitiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminProcessingActivitiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminProcessingActivitiesByIdResponses,
    DeleteAdminProcessingActivitiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/processing-activities/{id}",
    ...options,
  });

/**
 * /processing-activities/:id operation on processing-activity resource
 *
 * /processing-activities/:id operation on processing-activity resource
 */
export const getAdminProcessingActivitiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminProcessingActivitiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminProcessingActivitiesByIdResponses,
    GetAdminProcessingActivitiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/processing-activities/{id}",
    ...options,
  });

/**
 * List collections for a workspace
 *
 * List collections for a workspace
 */
export const getAdminRecipesCollectionsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesCollectionsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesCollectionsWorkspaceByWorkspaceIdResponses,
    GetAdminRecipesCollectionsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/collections/workspace/{workspace_id}",
    ...options,
  });

/**
 * /policy-review-schedules/:id operation on policy-review-schedule resource
 *
 * /policy-review-schedules/:id operation on policy-review-schedule resource
 */
export const getAdminPolicyReviewSchedulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPolicyReviewSchedulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPolicyReviewSchedulesByIdResponses,
    GetAdminPolicyReviewSchedulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/policy-review-schedules/{id}",
    ...options,
  });

/**
 * List all attachments for a specific ticket message
 *
 * List all attachments for a specific ticket message. Use to render attachment download links alongside the message body.
 */
export const getAdminSupportTicketAttachmentsMessageByTicketMessageId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSupportTicketAttachmentsMessageByTicketMessageIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSupportTicketAttachmentsMessageByTicketMessageIdResponses,
    GetAdminSupportTicketAttachmentsMessageByTicketMessageIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/ticket-attachments/message/{ticket_message_id}",
    ...options,
  });

/**
 * /reviews operation on review resource
 *
 * /reviews operation on review resource
 */
export const getAdminReviews = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminReviewsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminReviewsResponses,
    GetAdminReviewsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/reviews",
    ...options,
  });

/**
 * /webhook-configs operation on webhook-config resource
 *
 * /webhook-configs operation on webhook-config resource
 */
export const getAdminWebhookConfigs = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminWebhookConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWebhookConfigsResponses,
    GetAdminWebhookConfigsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-configs",
    ...options,
  });

/**
 * Register a new webhook endpoint to receive platform events
 *
 * Register a new webhook endpoint to receive platform events. Use this instead of :update
 * when you need to set the application scope — the application_id is inferred from the API key
 * or supplied explicitly. Generates a `whsec_`-prefixed HMAC secret automatically if not
 * provided. Returns the created WebhookConfig including the secret (shown only once).
 *
 */
export const postAdminWebhookConfigs = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminWebhookConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminWebhookConfigsResponses,
    PostAdminWebhookConfigsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-configs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Retry a failed subscription payment
 *
 * Retry a failed subscription payment
 */
export const patchAdminWalletPaymentRetry = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWalletPaymentRetryData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWalletPaymentRetryResponses,
    PatchAdminWalletPaymentRetryErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/payment/retry",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch a single transaction by its UUID
 *
 * Fetch a single transaction by its UUID. Use for transaction detail views or to verify
 * payment status after a sale. The result is not tenant-scoped at the query level;
 * the caller must ensure the actor has access to this transaction's tenant.
 *
 * Returns the full transaction record including status, amount, provider_reference, and credits.
 *
 */
export const getAdminTransactionsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminTransactionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTransactionsByIdResponses,
    GetAdminTransactionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/transactions/{id}",
    ...options,
  });

/**
 * Search for recipes using the Edamam Recipe API
 *
 * Search for recipes using the Edamam Recipe API
 */
export const postAdminConnectorsByIdEdamamRecipesSearch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsByIdEdamamRecipesSearchData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsByIdEdamamRecipesSearchResponses,
    PostAdminConnectorsByIdEdamamRecipesSearchErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/{id}/edamam/recipes/search",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/insurance-authorizations/:id operation on clinical-insurance-authorization resource
 *
 * /clinical/insurance-authorizations/:id operation on clinical-insurance-authorization resource
 */
export const deleteAdminClinicalInsuranceAuthorizationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalInsuranceAuthorizationsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalInsuranceAuthorizationsByIdResponses,
    DeleteAdminClinicalInsuranceAuthorizationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/insurance-authorizations/{id}",
    ...options,
  });

/**
 * /clinical/insurance-authorizations/:id operation on clinical-insurance-authorization resource
 *
 * /clinical/insurance-authorizations/:id operation on clinical-insurance-authorization resource
 */
export const getAdminClinicalInsuranceAuthorizationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalInsuranceAuthorizationsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalInsuranceAuthorizationsByIdResponses,
    GetAdminClinicalInsuranceAuthorizationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/insurance-authorizations/{id}",
    ...options,
  });

/**
 * /clinical/insurance-authorizations/:id operation on clinical-insurance-authorization resource
 *
 * /clinical/insurance-authorizations/:id operation on clinical-insurance-authorization resource
 */
export const patchAdminClinicalInsuranceAuthorizationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalInsuranceAuthorizationsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalInsuranceAuthorizationsByIdResponses,
    PatchAdminClinicalInsuranceAuthorizationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/insurance-authorizations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes operation on recipes-recipe resource
 *
 * /recipes operation on recipes-recipe resource
 */
export const postAdminRecipes = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminRecipesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesResponses,
    PostAdminRecipesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get training analytics for multiple workspaces in a single request (max 50)
 *
 * Get training analytics for multiple workspaces in a single request (max 50)
 */
export const getAdminWorkspacesAnalyticsBatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWorkspacesAnalyticsBatchData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWorkspacesAnalyticsBatchResponses,
    GetAdminWorkspacesAnalyticsBatchErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/analytics-batch",
    ...options,
  });

/**
 * Add a pricing entry to a price list for a product or variant; supply a fixed price, modifier, or tiered structure
 *
 * Add a pricing entry to a price list for a product or variant; supply a fixed price, modifier, or tiered structure. Returns the created entry.
 */
export const postAdminCatalogPriceListEntries = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCatalogPriceListEntriesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogPriceListEntriesResponses,
    PostAdminCatalogPriceListEntriesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/price-list-entries",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /form-deployments/:id operation on form-deployment resource
 *
 * /form-deployments/:id operation on form-deployment resource
 */
export const deleteAdminFormDeploymentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminFormDeploymentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminFormDeploymentsByIdResponses,
    DeleteAdminFormDeploymentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-deployments/{id}",
    ...options,
  });

/**
 * /form-deployments/:id operation on form-deployment resource
 *
 * /form-deployments/:id operation on form-deployment resource
 */
export const getAdminFormDeploymentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminFormDeploymentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFormDeploymentsByIdResponses,
    GetAdminFormDeploymentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-deployments/{id}",
    ...options,
  });

/**
 * /form-deployments/:id operation on form-deployment resource
 *
 * /form-deployments/:id operation on form-deployment resource
 */
export const patchAdminFormDeploymentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminFormDeploymentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminFormDeploymentsByIdResponses,
    PatchAdminFormDeploymentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-deployments/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /extraction/config-enums operation on config-enum resource
 *
 * /extraction/config-enums operation on config-enum resource
 */
export const getAdminExtractionConfigEnums = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionConfigEnumsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionConfigEnumsResponses,
    GetAdminExtractionConfigEnumsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/config-enums",
    ...options,
  });

/**
 * /extraction/config-enums operation on config-enum resource
 *
 * /extraction/config-enums operation on config-enum resource
 */
export const postAdminExtractionConfigEnums = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminExtractionConfigEnumsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminExtractionConfigEnumsResponses,
    PostAdminExtractionConfigEnumsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/config-enums",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Set workspace status to :suspended (take offline)
 *
 * Set workspace status to :suspended (take offline)
 */
export const patchAdminWorkspacesByIdTakeOffline = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWorkspacesByIdTakeOfflineData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWorkspacesByIdTakeOfflineResponses,
    PatchAdminWorkspacesByIdTakeOfflineErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{id}/take-offline",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /composite-operations/:id operation on composite-operation resource
 *
 * /composite-operations/:id operation on composite-operation resource
 */
export const deleteAdminCompositeOperationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCompositeOperationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCompositeOperationsByIdResponses,
    DeleteAdminCompositeOperationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/composite-operations/{id}",
    ...options,
  });

/**
 * /composite-operations/:id operation on composite-operation resource
 *
 * /composite-operations/:id operation on composite-operation resource
 */
export const getAdminCompositeOperationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCompositeOperationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCompositeOperationsByIdResponses,
    GetAdminCompositeOperationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/composite-operations/{id}",
    ...options,
  });

/**
 * /composite-operations/:id operation on composite-operation resource
 *
 * /composite-operations/:id operation on composite-operation resource
 */
export const patchAdminCompositeOperationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCompositeOperationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCompositeOperationsByIdResponses,
    PatchAdminCompositeOperationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/composite-operations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /audit-chain-entries/:id operation on audit-chain-entry resource
 *
 * /audit-chain-entries/:id operation on audit-chain-entry resource
 */
export const getAdminAuditChainEntriesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAuditChainEntriesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAuditChainEntriesByIdResponses,
    GetAdminAuditChainEntriesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/audit-chain-entries/{id}",
    ...options,
  });

/**
 * /training-sessions/:id operation on training-session resource
 *
 * /training-sessions/:id operation on training-session resource
 */
export const deleteAdminTrainingSessionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminTrainingSessionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminTrainingSessionsByIdResponses,
    DeleteAdminTrainingSessionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-sessions/{id}",
    ...options,
  });

/**
 * /training-sessions/:id operation on training-session resource
 *
 * /training-sessions/:id operation on training-session resource
 */
export const getAdminTrainingSessionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminTrainingSessionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTrainingSessionsByIdResponses,
    GetAdminTrainingSessionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-sessions/{id}",
    ...options,
  });

/**
 * Create a connector sync configuration for a workspace+connector pair
 *
 * Create a connector sync configuration for a workspace+connector pair. One config per workspace+connector_instance_id (identity :workspace_connector_unique). Controls sync direction, status field mapping, and polling interval.
 */
export const postAdminSupportSyncConfigs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSupportSyncConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSupportSyncConfigsResponses,
    PostAdminSupportSyncConfigsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/sync-configs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Cancel an active Fullscript treatment plan
 *
 * Cancel an active Fullscript treatment plan
 */
export const postAdminConnectorsFullscriptTreatmentPlansCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsFullscriptTreatmentPlansCancelData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsFullscriptTreatmentPlansCancelResponses,
    PostAdminConnectorsFullscriptTreatmentPlansCancelErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/fullscript/treatment-plans/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /ai/conversations/:id operation on chat-conversation resource
 *
 * /ai/conversations/:id operation on chat-conversation resource
 */
export const deleteAdminAiConversationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminAiConversationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminAiConversationsByIdResponses,
    DeleteAdminAiConversationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/conversations/{id}",
    ...options,
  });

/**
 * /ai/conversations/:id operation on chat-conversation resource
 *
 * /ai/conversations/:id operation on chat-conversation resource
 */
export const getAdminAiConversationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAiConversationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAiConversationsByIdResponses,
    GetAdminAiConversationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/conversations/{id}",
    ...options,
  });

/**
 * Update the conversation title or replace the context data map
 *
 * Update the conversation title or replace the context data map. Use this to attach updated prediction results or structured context before the next AI turn.
 */
export const patchAdminAiConversationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminAiConversationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAiConversationsByIdResponses,
    PatchAdminAiConversationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/conversations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /payment-methods operation on payment-method resource
 *
 * /payment-methods operation on payment-method resource
 */
export const getAdminPaymentMethods = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPaymentMethodsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPaymentMethodsResponses,
    GetAdminPaymentMethodsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/payment-methods",
    ...options,
  });

/**
 * Save a payment method that has already been tokenized by the platform
 *
 * Save a payment method that has already been tokenized by the platform.
 *
 * `provider_token` MUST be an opaque token previously returned by the platform's
 * tokenization endpoint (POST /payment-methods/tokenize or the equivalent S2S route).
 * The platform brokers all gateway traffic — browsers never call payment gateways
 * directly, no gateway-hosted iframe is ever embedded, and the underlying gateway
 * (QorPay, Stripe, or whatever this Application has configured) is an implementation
 * detail that does not appear in client code.
 *
 * The customer is resolved from the actor's context or an explicit customer_id.
 * If this is the first payment method, it is automatically set as the default.
 *
 * No side effects beyond database persistence. Returns the saved payment method record.
 *
 */
export const postAdminPaymentMethods = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminPaymentMethodsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPaymentMethodsResponses,
    PostAdminPaymentMethodsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/payment-methods",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /risk-assessments/:id operation on risk-assessment resource
 *
 * /risk-assessments/:id operation on risk-assessment resource
 */
export const deleteAdminRiskAssessmentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminRiskAssessmentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRiskAssessmentsByIdResponses,
    DeleteAdminRiskAssessmentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/risk-assessments/{id}",
    ...options,
  });

/**
 * /risk-assessments/:id operation on risk-assessment resource
 *
 * /risk-assessments/:id operation on risk-assessment resource
 */
export const getAdminRiskAssessmentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRiskAssessmentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRiskAssessmentsByIdResponses,
    GetAdminRiskAssessmentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/risk-assessments/{id}",
    ...options,
  });

/**
 * List all export jobs for a workspace, sorted newest first
 *
 * List all export jobs for a workspace, sorted newest first. Use to show export history or find a recent job by entity type and format.
 */
export const getAdminCrmExportsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrmExportsWorkspaceByWorkspaceIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmExportsWorkspaceByWorkspaceIdResponses,
    GetAdminCrmExportsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/exports/workspace/{workspace_id}",
    ...options,
  });

/**
 * Owner restores a previously deactivated tenant
 *
 * Owner restores a previously deactivated tenant. Reverses :deactivate.
 */
export const patchAdminTenantsByIdReactivate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminTenantsByIdReactivateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTenantsByIdReactivateResponses,
    PatchAdminTenantsByIdReactivateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}/reactivate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List items for a shopping list
 *
 * List items for a shopping list
 */
export const getAdminRecipesShoppingListItemsShoppingListByShoppingListId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesShoppingListItemsShoppingListByShoppingListIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesShoppingListItemsShoppingListByShoppingListIdResponses,
    GetAdminRecipesShoppingListItemsShoppingListByShoppingListIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/shopping-list-items/shopping-list/{shopping_list_id}",
    ...options,
  });

/**
 * /email-marketing/campaigns/:id/import-recipients operation on campaign resource
 *
 * /email-marketing/campaigns/:id/import-recipients operation on campaign resource
 */
export const postAdminEmailMarketingCampaignsByIdImportRecipients = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminEmailMarketingCampaignsByIdImportRecipientsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminEmailMarketingCampaignsByIdImportRecipientsResponses,
    PostAdminEmailMarketingCampaignsByIdImportRecipientsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/campaigns/{id}/import-recipients",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all messages on a ticket in chronological order
 *
 * List all messages on a ticket in chronological order. Returns both public messages and internal notes — callers should filter is_internal_note if needed for customer-facing views.
 */
export const getAdminSupportTicketMessagesTicketByTicketId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSupportTicketMessagesTicketByTicketIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSupportTicketMessagesTicketByTicketIdResponses,
    GetAdminSupportTicketMessagesTicketByTicketIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/ticket-messages/ticket/{ticket_id}",
    ...options,
  });

/**
 * /recipes/bulk-import operation on recipes-recipe resource
 *
 * /recipes/bulk-import operation on recipes-recipe resource
 */
export const postAdminRecipesBulkImport = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminRecipesBulkImportData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesBulkImportResponses,
    PostAdminRecipesBulkImportErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/bulk-import",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Alias for `:dismiss_training`
 *
 * Alias for `:dismiss_training`. Sets `training_metadata["dismissed_at"]` on the document.
 * Exposed as the `/dismiss` route; functionally identical to `:dismiss_training`.
 *
 */
export const patchAdminExtractionDocumentsByIdDismiss = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminExtractionDocumentsByIdDismissData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionDocumentsByIdDismissResponses,
    PatchAdminExtractionDocumentsByIdDismissErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}/dismiss",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /compliance-requirements/:id operation on compliance-requirement resource
 *
 * /compliance-requirements/:id operation on compliance-requirement resource
 */
export const deleteAdminComplianceRequirementsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminComplianceRequirementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminComplianceRequirementsByIdResponses,
    DeleteAdminComplianceRequirementsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-requirements/{id}",
    ...options,
  });

/**
 * /compliance-requirements/:id operation on compliance-requirement resource
 *
 * /compliance-requirements/:id operation on compliance-requirement resource
 */
export const getAdminComplianceRequirementsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminComplianceRequirementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminComplianceRequirementsByIdResponses,
    GetAdminComplianceRequirementsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-requirements/{id}",
    ...options,
  });

/**
 * /compliance-requirements/:id operation on compliance-requirement resource
 *
 * /compliance-requirements/:id operation on compliance-requirement resource
 */
export const patchAdminComplianceRequirementsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminComplianceRequirementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminComplianceRequirementsByIdResponses,
    PatchAdminComplianceRequirementsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-requirements/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /workspaces/:workspace_id/extraction/exports/:id operation on extraction-export resource
 *
 * /workspaces/:workspace_id/extraction/exports/:id operation on extraction-export resource
 */
export const getAdminWorkspacesByWorkspaceIdExtractionExportsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminWorkspacesByWorkspaceIdExtractionExportsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminWorkspacesByWorkspaceIdExtractionExportsByIdResponses,
    GetAdminWorkspacesByWorkspaceIdExtractionExportsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{workspace_id}/extraction/exports/{id}",
    ...options,
  });

/**
 * /email-marketing/generated-emails/campaign/:campaign_id operation on email-marketing-generated-email resource
 *
 * /email-marketing/generated-emails/campaign/:campaign_id operation on email-marketing-generated-email resource
 */
export const getAdminEmailMarketingGeneratedEmailsCampaignByCampaignId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailMarketingGeneratedEmailsCampaignByCampaignIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailMarketingGeneratedEmailsCampaignByCampaignIdResponses,
    GetAdminEmailMarketingGeneratedEmailsCampaignByCampaignIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/generated-emails/campaign/{campaign_id}",
    ...options,
  });

/**
 * Create a pre-written response template for agent use
 *
 * Create a pre-written response template for agent use. Shortcut enables slash-command access in the ticket composer. Category groups templates in the picker UI. Returns the created CannedResponse.
 */
export const postAdminSupportCannedResponses = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSupportCannedResponsesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSupportCannedResponsesResponses,
    PostAdminSupportCannedResponsesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/canned-responses",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Attempt to sign in using a username and password.
 *
 * Attempt to sign in using a username and password.
 */
export const postAdminUsersAuthLogin = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminUsersAuthLoginData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminUsersAuthLoginResponses,
    PostAdminUsersAuthLoginErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/auth/login",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Permanently delete a view rule; the view is re-evaluated without this rule on next resolution.
 *
 * Permanently delete a view rule; the view is re-evaluated without this rule on next resolution.
 */
export const deleteAdminCatalogViewRulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCatalogViewRulesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCatalogViewRulesByIdResponses,
    DeleteAdminCatalogViewRulesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/view-rules/{id}",
    ...options,
  });

/**
 * /social/accounts/:id operation on social-account resource
 *
 * /social/accounts/:id operation on social-account resource
 */
export const deleteAdminSocialAccountsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSocialAccountsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSocialAccountsByIdResponses,
    DeleteAdminSocialAccountsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/accounts/{id}",
    ...options,
  });

/**
 * /social/accounts/:id operation on social-account resource
 *
 * /social/accounts/:id operation on social-account resource
 */
export const getAdminSocialAccountsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSocialAccountsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSocialAccountsByIdResponses,
    GetAdminSocialAccountsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/accounts/{id}",
    ...options,
  });

/**
 * /social/accounts/:id operation on social-account resource
 *
 * /social/accounts/:id operation on social-account resource
 */
export const patchAdminSocialAccountsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSocialAccountsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialAccountsByIdResponses,
    PatchAdminSocialAccountsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/accounts/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Admin-only user management (platform admins) - promotes/demotes admin status
 *
 * Admin-only user management (platform admins) - promotes/demotes admin status
 */
export const patchAdminUsersByIdAdmin = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminUsersByIdAdminData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminUsersByIdAdminResponses,
    PatchAdminUsersByIdAdminErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/{id}/admin",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Submit or update a CSAT rating (1-5) for a resolved ticket
 *
 * Submit or update a CSAT rating (1-5) for a resolved ticket. Uses upsert — one rating per ticket (identity :ticket_unique). Publishes TicketRated event for CSAT metric aggregation. Returns the created or updated TicketRating.
 */
export const postAdminSupportTicketRatings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSupportTicketRatingsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSupportTicketRatingsResponses,
    PostAdminSupportTicketRatingsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/ticket-ratings",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get storage stats for a specific tenant
 *
 * Get storage stats for a specific tenant
 */
export const getAdminStorageStatsTenantByTenantId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminStorageStatsTenantByTenantIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminStorageStatsTenantByTenantIdResponses,
    GetAdminStorageStatsTenantByTenantIdErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage/stats/tenant/{tenant_id}",
    ...options,
  });

/**
 * /campaigns/sequences operation on email-marketing-sequence resource
 *
 * /campaigns/sequences operation on email-marketing-sequence resource
 */
export const postAdminCampaignsSequences = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCampaignsSequencesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCampaignsSequencesResponses,
    PostAdminCampaignsSequencesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequences",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Log a CRM activity (call, email, meeting, note, etc.) linked to the workspace
 *
 * Log a CRM activity (call, email, meeting, note, etc.) linked to the workspace.
 * Validates custom properties and indexes the activity body into the Memory domain
 * for semantic search. Publishes an ActivityLogged event as a side effect.
 *
 */
export const postAdminCrmActivities = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrmActivitiesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmActivitiesResponses,
    PostAdminCrmActivitiesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/activities",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List audit log entries
 *
 * List audit log entries. Supports keyset and offset pagination. Default limit: 50.
 */
export const getAdminAuditLogs = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAuditLogsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAuditLogsResponses,
    GetAdminAuditLogsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/audit-logs",
    ...options,
  });

/**
 * Approve a pending booking, setting status to :confirmed and confirmed_at timestamp
 *
 * Approve a pending booking, setting status to :confirmed and confirmed_at timestamp. Propagates confirmation to the linked Event. Requires scheduling:manage scope. Publishes BookingApproved event.
 */
export const patchAdminSchedulingBookingsByIdConfirm = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSchedulingBookingsByIdConfirmData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingBookingsByIdConfirmResponses,
    PatchAdminSchedulingBookingsByIdConfirmErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/bookings/{id}/confirm",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /wholesale-agreements/:id operation on wholesale-agreement resource
 *
 * /wholesale-agreements/:id operation on wholesale-agreement resource
 */
export const getAdminWholesaleAgreementsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWholesaleAgreementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWholesaleAgreementsByIdResponses,
    GetAdminWholesaleAgreementsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wholesale-agreements/{id}",
    ...options,
  });

/**
 * /wholesale-agreements/:id operation on wholesale-agreement resource
 *
 * /wholesale-agreements/:id operation on wholesale-agreement resource
 */
export const patchAdminWholesaleAgreementsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWholesaleAgreementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWholesaleAgreementsByIdResponses,
    PatchAdminWholesaleAgreementsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wholesale-agreements/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /pricing-strategies/:id operation on pricing-strategy resource
 *
 * /pricing-strategies/:id operation on pricing-strategy resource
 */
export const getAdminPricingStrategiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPricingStrategiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPricingStrategiesByIdResponses,
    GetAdminPricingStrategiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pricing-strategies/{id}",
    ...options,
  });

/**
 * /pricing-strategies/:id operation on pricing-strategy resource
 *
 * /pricing-strategies/:id operation on pricing-strategy resource
 */
export const patchAdminPricingStrategiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPricingStrategiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPricingStrategiesByIdResponses,
    PatchAdminPricingStrategiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pricing-strategies/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/outbound-emails/workspace/:workspace_id/contact/:contact_ref_id operation on email-outbound-email resource
 *
 * /email/outbound-emails/workspace/:workspace_id/contact/:contact_ref_id operation on email-outbound-email resource
 */
export const getAdminEmailOutboundEmailsWorkspaceByWorkspaceIdContactByContactRefId =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAdminEmailOutboundEmailsWorkspaceByWorkspaceIdContactByContactRefIdData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetAdminEmailOutboundEmailsWorkspaceByWorkspaceIdContactByContactRefIdResponses,
      GetAdminEmailOutboundEmailsWorkspaceByWorkspaceIdContactByContactRefIdErrors,
      ThrowOnError
    >({
      querySerializer: {
        parameters: {
          filter: { object: { style: "form" } },
          fields: { object: { style: "form" } },
        },
      },
      security: [{ scheme: "bearer", type: "http" }],
      url: "/admin/email/outbound-emails/workspace/{workspace_id}/contact/{contact_ref_id}",
      ...options,
    });

/**
 * Dismiss announcement - merges with existing preferences
 *
 * Dismiss announcement - merges with existing preferences
 */
export const patchAdminUserProfilesByIdDismissAnnouncement = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminUserProfilesByIdDismissAnnouncementData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminUserProfilesByIdDismissAnnouncementResponses,
    PatchAdminUserProfilesByIdDismissAnnouncementErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/user-profiles/{id}/dismiss-announcement",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all active nodes in a taxonomy
 *
 * List all active nodes in a taxonomy. Use roots_by_taxonomy to get only top-level nodes for tree rendering.
 */
export const getAdminCatalogTaxonomyNodesTaxonomyByTaxonomyId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogTaxonomyNodesTaxonomyByTaxonomyIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogTaxonomyNodesTaxonomyByTaxonomyIdResponses,
    GetAdminCatalogTaxonomyNodesTaxonomyByTaxonomyIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/taxonomy-nodes/taxonomy/{taxonomy_id}",
    ...options,
  });

/**
 * Export campaign data (recipients, results, or tracking) as CSV
 *
 * Export campaign data (recipients, results, or tracking) as CSV. Returns job ID.
 */
export const postAdminEmailMarketingCampaignsByIdExport = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminEmailMarketingCampaignsByIdExportData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminEmailMarketingCampaignsByIdExportResponses,
    PostAdminEmailMarketingCampaignsByIdExportErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/campaigns/{id}/export",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Mark this notification method as the primary channel for its type
 *
 * Mark this notification method as the primary channel for its type. Automatically unsets `is_primary` on all other methods of the same type for the same user.
 */
export const patchAdminNotificationMethodsByIdSetPrimary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminNotificationMethodsByIdSetPrimaryData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminNotificationMethodsByIdSetPrimaryResponses,
    PatchAdminNotificationMethodsByIdSetPrimaryErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-methods/{id}/set-primary",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all relationship edges in a workspace
 *
 * List all relationship edges in a workspace. Use to traverse connections between CRM entities or seed graph traversal queries.
 */
export const getAdminCrmRelationshipsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmRelationshipsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmRelationshipsWorkspaceByWorkspaceIdResponses,
    GetAdminCrmRelationshipsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/relationships/workspace/{workspace_id}",
    ...options,
  });

/**
 * List exports for a workspace, filtered by status
 *
 * List exports for a workspace, filtered by status
 */
export const getAdminWorkspacesByWorkspaceIdExtractionExports = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminWorkspacesByWorkspaceIdExtractionExportsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminWorkspacesByWorkspaceIdExtractionExportsResponses,
    GetAdminWorkspacesByWorkspaceIdExtractionExportsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{workspace_id}/extraction/exports",
    ...options,
  });

/**
 * /workspaces/:workspace_id/extraction/exports operation on extraction-export resource
 *
 * /workspaces/:workspace_id/extraction/exports operation on extraction-export resource
 */
export const postAdminWorkspacesByWorkspaceIdExtractionExports = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminWorkspacesByWorkspaceIdExtractionExportsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminWorkspacesByWorkspaceIdExtractionExportsResponses,
    PostAdminWorkspacesByWorkspaceIdExtractionExportsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{workspace_id}/extraction/exports",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Reschedule a booking by moving its linked Event to new_start_time/new_end_time
 *
 * Reschedule a booking by moving its linked Event to new_start_time/new_end_time. Propagates rescheduling to the Event (which validates for conflicts). Publishes EventRescheduled event.
 */
export const patchAdminSchedulingBookingsByIdReschedule = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminSchedulingBookingsByIdRescheduleData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingBookingsByIdRescheduleResponses,
    PatchAdminSchedulingBookingsByIdRescheduleErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/bookings/{id}/reschedule",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/food-items/:id operation on recipes-food-item resource
 *
 * /recipes/food-items/:id operation on recipes-food-item resource
 */
export const deleteAdminRecipesFoodItemsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminRecipesFoodItemsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRecipesFoodItemsByIdResponses,
    DeleteAdminRecipesFoodItemsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/food-items/{id}",
    ...options,
  });

/**
 * /recipes/food-items/:id operation on recipes-food-item resource
 *
 * /recipes/food-items/:id operation on recipes-food-item resource
 */
export const getAdminRecipesFoodItemsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesFoodItemsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesFoodItemsByIdResponses,
    GetAdminRecipesFoodItemsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/food-items/{id}",
    ...options,
  });

/**
 * /recipes/food-items/:id operation on recipes-food-item resource
 *
 * /recipes/food-items/:id operation on recipes-food-item resource
 */
export const patchAdminRecipesFoodItemsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRecipesFoodItemsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesFoodItemsByIdResponses,
    PatchAdminRecipesFoodItemsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/food-items/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Transition an `:active` plan to `:deprecated`
 *
 * Transition an `:active` plan to `:deprecated`. Deprecated plans are hidden
 * from public catalogs and reject new subscriptions, but existing subscribers
 * continue renewing on this plan. Use this before scheduling a sunset.
 *
 * Requires Platform Admin or Application Owner role. The transition is
 * rejected if the plan is not currently `:active`.
 *
 */
export const patchAdminPlansByIdDeprecate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPlansByIdDeprecateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPlansByIdDeprecateResponses,
    PatchAdminPlansByIdDeprecateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plans/{id}/deprecate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /agent-executions/:id/cancel operation on agent-execution resource
 *
 * /agent-executions/:id/cancel operation on agent-execution resource
 */
export const patchAdminAgentExecutionsByIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminAgentExecutionsByIdCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAgentExecutionsByIdCancelResponses,
    PatchAdminAgentExecutionsByIdCancelErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-executions/{id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get the current application based on x-application-key header context
 *
 * Get the current application based on x-application-key header context
 */
export const getAdminApplicationsCurrent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminApplicationsCurrentData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminApplicationsCurrentResponses,
    GetAdminApplicationsCurrentErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/current",
    ...options,
  });

/**
 * /agents/:id/training-stats operation on agent-training-stats resource
 *
 * /agents/:id/training-stats operation on agent-training-stats resource
 */
export const getAdminAgentsByIdTrainingStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAgentsByIdTrainingStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentsByIdTrainingStatsResponses,
    GetAdminAgentsByIdTrainingStatsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/training-stats",
    ...options,
  });

/**
 * Soft-archive a contact (sets deleted_at)
 *
 * Soft-archive a contact (sets deleted_at)
 */
export const patchAdminCrmContactsByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmContactsByIdArchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmContactsByIdArchiveResponses,
    PatchAdminCrmContactsByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/contacts/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /contract-clauses operation on contract-clause resource
 *
 * /contract-clauses operation on contract-clause resource
 */
export const getAdminContractClauses = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminContractClausesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminContractClausesResponses,
    GetAdminContractClausesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/contract-clauses",
    ...options,
  });

/**
 * /wallet/invoices/:id/void operation on invoice resource
 *
 * /wallet/invoices/:id/void operation on invoice resource
 */
export const patchAdminWalletInvoicesByIdVoid = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWalletInvoicesByIdVoidData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWalletInvoicesByIdVoidResponses,
    PatchAdminWalletInvoicesByIdVoidErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/invoices/{id}/void",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/goal-templates/:id operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/:id operation on clinical-goal-template resource
 */
export const getAdminClinicalGoalTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalGoalTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalTemplatesByIdResponses,
    GetAdminClinicalGoalTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/{id}",
    ...options,
  });

/**
 * /clinical/goal-templates/:id operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/:id operation on clinical-goal-template resource
 */
export const patchAdminClinicalGoalTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalGoalTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalGoalTemplatesByIdResponses,
    PatchAdminClinicalGoalTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /tenants/:tenant_id/workspace_stats operation on workspace-document-stats resource
 *
 * /tenants/:tenant_id/workspace_stats operation on workspace-document-stats resource
 */
export const getAdminTenantsByTenantIdWorkspaceStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminTenantsByTenantIdWorkspaceStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTenantsByTenantIdWorkspaceStatsResponses,
    GetAdminTenantsByTenantIdWorkspaceStatsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{tenant_id}/workspace_stats",
    ...options,
  });

/**
 * RD approves the clinical note
 *
 * RD approves the clinical note. Creates an immutable NoteVersion snapshot.
 */
export const patchAdminClinicalNotesByIdApprove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalNotesByIdApproveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalNotesByIdApproveResponses,
    PatchAdminClinicalNotesByIdApproveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes/{id}/approve",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get treatment plan details from Fullscript
 *
 * Get treatment plan details from Fullscript
 */
export const postAdminConnectorsFullscriptTreatmentPlansGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsFullscriptTreatmentPlansGetData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsFullscriptTreatmentPlansGetResponses,
    PostAdminConnectorsFullscriptTreatmentPlansGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/fullscript/treatment-plans/get",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Return aggregate delivery counts by status (total, delivered, failed, retrying)
 *
 * Return aggregate delivery counts by status (total, delivered, failed, retrying). Useful for monitoring dashboards; no side effects.
 */
export const getAdminWebhookDeliveriesStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWebhookDeliveriesStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWebhookDeliveriesStatsResponses,
    GetAdminWebhookDeliveriesStatsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-deliveries/stats",
    ...options,
  });

/**
 * Approve a completed DPIA by recording the approver's name and setting `approved_at` to the current timestamp
 *
 * Approve a completed DPIA by recording the approver's name and setting `approved_at` to the current timestamp. Changes status to `:approved`; use :update to add additional findings after the fact.
 */
export const patchAdminImpactAssessmentsByIdApprove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminImpactAssessmentsByIdApproveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminImpactAssessmentsByIdApproveResponses,
    PatchAdminImpactAssessmentsByIdApproveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/impact-assessments/{id}/approve",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get seat billing info for the current tenant
 *
 * Get seat billing info for the current tenant
 */
export const getAdminWalletSeats = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminWalletSeatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWalletSeatsResponses,
    GetAdminWalletSeatsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/seats",
    ...options,
  });

/**
 * Run the agent against sample input
 *
 * Run the agent against sample input
 */
export const postAdminAgentsByIdTest = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAgentsByIdTestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentsByIdTestResponses,
    PostAdminAgentsByIdTestErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/test",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Revoke an existing consent grant
 *
 * Revoke an existing consent grant. Sets status to `:withdrawn` and records `withdrawn_at`. Returns an error if the record is already withdrawn. The record is preserved for audit trail purposes.
 */
export const patchAdminConsentRecordsByIdWithdraw = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminConsentRecordsByIdWithdrawData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminConsentRecordsByIdWithdrawResponses,
    PatchAdminConsentRecordsByIdWithdrawErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/consent-records/{id}/withdraw",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Cancel a pending reminder, preventing delivery
 *
 * Cancel a pending reminder, preventing delivery. Called by EventHandler on EventCancelled/EventRescheduled per loaded record. No Oban job cancellation — ReminderWorker checks status before delivering.
 */
export const patchAdminSchedulingRemindersByIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSchedulingRemindersByIdCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingRemindersByIdCancelResponses,
    PatchAdminSchedulingRemindersByIdCancelErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/reminders/{id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/outbound-emails/:id/cancel-schedule operation on email-outbound-email resource
 *
 * /email/outbound-emails/:id/cancel-schedule operation on email-outbound-email resource
 */
export const patchAdminEmailOutboundEmailsByIdCancelSchedule = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailOutboundEmailsByIdCancelScheduleData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailOutboundEmailsByIdCancelScheduleResponses,
    PatchAdminEmailOutboundEmailsByIdCancelScheduleErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/outbound-emails/{id}/cancel-schedule",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch a single location by ID
 *
 * Fetch a single location by ID. Note: location data is denormalized into LocationEmbed on Event/EventType at write time — reads typically use the embed, not this action.
 */
export const getAdminSchedulingLocationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingLocationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingLocationsByIdResponses,
    GetAdminSchedulingLocationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/locations/{id}",
    ...options,
  });

/**
 * Update location details
 *
 * Update location details. Changes here do NOT retroactively update LocationEmbed in Events/EventTypes — those were denormalized at write time. Use :deactivate to retire a location.
 */
export const patchAdminSchedulingLocationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSchedulingLocationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingLocationsByIdResponses,
    PatchAdminSchedulingLocationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/locations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/notes/:note_id/versions operation on clinical-note-version resource
 *
 * /clinical/notes/:note_id/versions operation on clinical-note-version resource
 */
export const getAdminClinicalNotesByNoteIdVersions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalNotesByNoteIdVersionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNotesByNoteIdVersionsResponses,
    GetAdminClinicalNotesByNoteIdVersionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes/{note_id}/versions",
    ...options,
  });

/**
 * /invoices/:id/send operation on invoices-invoice resource
 *
 * /invoices/:id/send operation on invoices-invoice resource
 */
export const patchAdminInvoicesByIdSend = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesByIdSendData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesByIdSendResponses,
    PatchAdminInvoicesByIdSendErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}/send",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/recurring-schedules/:id/resume operation on invoices-recurring-schedule resource
 *
 * /invoices/recurring-schedules/:id/resume operation on invoices-recurring-schedule resource
 */
export const patchAdminInvoicesRecurringSchedulesByIdResume = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminInvoicesRecurringSchedulesByIdResumeData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesRecurringSchedulesByIdResumeResponses,
    PatchAdminInvoicesRecurringSchedulesByIdResumeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/recurring-schedules/{id}/resume",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Enqueue an async CRM data export job
 *
 * Enqueue an async CRM data export job. Validates include keys and entity_type compatibility,
 * then enqueues DataExportWorker via Oban. Returns a pending DataExportJob — poll :get until
 * status is :complete or :failed. Publishes DataExportJobCreated event. Costs 5 credits.
 *
 */
export const postAdminCrmExports = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrmExportsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmExportsResponses,
    PostAdminCrmExportsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/exports",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List recipe tags for a recipe
 *
 * List recipe tags for a recipe
 */
export const getAdminRecipesRecipeTagsRecipeByRecipeId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesRecipeTagsRecipeByRecipeIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesRecipeTagsRecipeByRecipeIdResponses,
    GetAdminRecipesRecipeTagsRecipeByRecipeIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/recipe-tags/recipe/{recipe_id}",
    ...options,
  });

/**
 * /agent-souls operation on agent-soul resource
 *
 * /agent-souls operation on agent-soul resource
 */
export const getAdminAgentSouls = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAgentSoulsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentSoulsResponses,
    GetAdminAgentSoulsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-souls",
    ...options,
  });

/**
 * /agent-souls operation on agent-soul resource
 *
 * /agent-souls operation on agent-soul resource
 */
export const postAdminAgentSouls = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAgentSoulsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentSoulsResponses,
    PostAdminAgentSoulsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-souls",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /ai/messages/:id operation on chat-ai-message resource
 *
 * /ai/messages/:id operation on chat-ai-message resource
 */
export const deleteAdminAiMessagesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminAiMessagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminAiMessagesByIdResponses,
    DeleteAdminAiMessagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/messages/{id}",
    ...options,
  });

/**
 * /ai/messages/:id operation on chat-ai-message resource
 *
 * /ai/messages/:id operation on chat-ai-message resource
 */
export const getAdminAiMessagesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAiMessagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAiMessagesByIdResponses,
    GetAdminAiMessagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/messages/{id}",
    ...options,
  });

/**
 * /clinical/supplement-templates/:id/archive operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/:id/archive operation on clinical-supplement-template resource
 */
export const patchAdminClinicalSupplementTemplatesByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalSupplementTemplatesByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalSupplementTemplatesByIdArchiveResponses,
    PatchAdminClinicalSupplementTemplatesByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-resources/catalog/:id/permanent operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/catalog/:id/permanent operation on clinical-practice-resource resource
 */
export const deleteAdminClinicalPracticeResourcesCatalogByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalPracticeResourcesCatalogByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalPracticeResourcesCatalogByIdPermanentResponses,
    DeleteAdminClinicalPracticeResourcesCatalogByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/catalog/{id}/permanent",
    ...options,
  });

/**
 * Adapt master copy for each target platform
 *
 * Adapt master copy for each target platform. Creates SocialPost drafts.
 */
export const postAdminSocialCampaignsByIdAdaptForPlatforms = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminSocialCampaignsByIdAdaptForPlatformsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminSocialCampaignsByIdAdaptForPlatformsResponses,
    PostAdminSocialCampaignsByIdAdaptForPlatformsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/campaigns/{id}/adapt-for-platforms",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/posts/:id/cancel operation on social-post resource
 *
 * /social/posts/:id/cancel operation on social-post resource
 */
export const patchAdminSocialPostsByIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSocialPostsByIdCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialPostsByIdCancelResponses,
    PatchAdminSocialPostsByIdCancelErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/posts/{id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /risk-assessments operation on risk-assessment resource
 *
 * /risk-assessments operation on risk-assessment resource
 */
export const getAdminRiskAssessments = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminRiskAssessmentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRiskAssessmentsResponses,
    GetAdminRiskAssessmentsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/risk-assessments",
    ...options,
  });

/**
 * Record a new compliance risk assessment (security, privacy, operational, or compliance type) for a workspace
 *
 * Record a new compliance risk assessment (security, privacy, operational, or compliance type) for a workspace. The assessment starts in `:draft` status. The RiskExpiryWorker marks approved assessments as `:expired` when `expires_at` passes.
 */
export const postAdminRiskAssessments = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminRiskAssessmentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRiskAssessmentsResponses,
    PostAdminRiskAssessmentsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/risk-assessments",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /agent-executions/:id/resume operation on agent-execution resource
 *
 * /agent-executions/:id/resume operation on agent-execution resource
 */
export const patchAdminAgentExecutionsByIdResume = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminAgentExecutionsByIdResumeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAgentExecutionsByIdResumeResponses,
    PatchAdminAgentExecutionsByIdResumeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-executions/{id}/resume",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/food-items operation on recipes-food-item resource
 *
 * /recipes/food-items operation on recipes-food-item resource
 */
export const postAdminRecipesFoodItems = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminRecipesFoodItemsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesFoodItemsResponses,
    PostAdminRecipesFoodItemsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/food-items",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a new catalog product in a workspace; triggers search indexing and enqueues embedding generation
 *
 * Create a new catalog product in a workspace; triggers search indexing and enqueues embedding generation. Returns the created product.
 */
export const postAdminCatalogProducts = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCatalogProductsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogProductsResponses,
    PostAdminCatalogProductsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/products",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /disclosure-logs/:id operation on disclosure-log resource
 *
 * /disclosure-logs/:id operation on disclosure-log resource
 */
export const getAdminDisclosureLogsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminDisclosureLogsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminDisclosureLogsByIdResponses,
    GetAdminDisclosureLogsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/disclosure-logs/{id}",
    ...options,
  });

/**
 * Create a patient in Fullscript
 *
 * Create a patient in Fullscript
 */
export const postAdminConnectorsFullscriptCreatePatient = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsFullscriptCreatePatientData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsFullscriptCreatePatientResponses,
    PostAdminConnectorsFullscriptCreatePatientErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/fullscript/create-patient",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /contract-renewal-alerts operation on contract-renewal-alert resource
 *
 * /contract-renewal-alerts operation on contract-renewal-alert resource
 */
export const getAdminContractRenewalAlerts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminContractRenewalAlertsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminContractRenewalAlertsResponses,
    GetAdminContractRenewalAlertsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/contract-renewal-alerts",
    ...options,
  });

/**
 * List all bookings for a workspace
 *
 * List all bookings for a workspace. Use to view pending approvals or booking history. Filter by status in the caller.
 */
export const getAdminSchedulingBookings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingBookingsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingBookingsResponses,
    GetAdminSchedulingBookingsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/bookings",
    ...options,
  });

/**
 * Create a booking for an external party claiming a time slot
 *
 * Create a booking for an external party claiming a time slot. Validates honeypot field,
 * booking cooldown, and event type capacity. Atomically creates a linked Event and Participant
 * in before_action. Status is :confirmed if EventType.requires_approval is false, else
 * :pending_approval. Publishes BookingCreated event.
 *
 */
export const postAdminSchedulingBookings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSchedulingBookingsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSchedulingBookingsResponses,
    PostAdminSchedulingBookingsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/bookings",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Resume a paused or errored calendar sync
 *
 * Resume a paused or errored calendar sync. Resets error_count to 0 and error_message to nil, setting sync_status to :active. Use after resolving the underlying connection issue.
 */
export const patchAdminSchedulingCalendarSyncsByIdResume = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminSchedulingCalendarSyncsByIdResumeData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingCalendarSyncsByIdResumeResponses,
    PatchAdminSchedulingCalendarSyncsByIdResumeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/calendar-syncs/{id}/resume",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Reverse an exclusion: allow a previously excluded document to contribute training examples
 * again
 *
 * Reverse an exclusion: allow a previously excluded document to contribute training examples
 * again. Clears `excluded_from_training`, `excluded_at`, `excluded_by`, and
 * `training_metadata` so the document appears in normal training queries.
 *
 * Side effects: synchronously clears the `document_excluded` flag on all associated
 * `TrainingExample` records, making them eligible for semantic search and few-shot selection.
 *
 * This action is also registered under the `/restore` route as a semantic alias.
 *
 */
export const patchAdminExtractionDocumentsByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminExtractionDocumentsByIdRestoreData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionDocumentsByIdRestoreResponses,
    PatchAdminExtractionDocumentsByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /balances/:id operation on balance resource
 *
 * /balances/:id operation on balance resource
 */
export const getAdminBalancesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminBalancesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBalancesByIdResponses,
    GetAdminBalancesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/balances/{id}",
    ...options,
  });

/**
 * /business-associate-agreements/:id/sign operation on business-associate-agreement resource
 *
 * /business-associate-agreements/:id/sign operation on business-associate-agreement resource
 */
export const patchAdminBusinessAssociateAgreementsByIdSign = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminBusinessAssociateAgreementsByIdSignData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminBusinessAssociateAgreementsByIdSignResponses,
    PatchAdminBusinessAssociateAgreementsByIdSignErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/business-associate-agreements/{id}/sign",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/trending/history/workspace/:workspace_id operation on trending-snapshot resource
 *
 * /social/trending/history/workspace/:workspace_id operation on trending-snapshot resource
 */
export const getAdminSocialTrendingHistoryWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSocialTrendingHistoryWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSocialTrendingHistoryWorkspaceByWorkspaceIdResponses,
    GetAdminSocialTrendingHistoryWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/trending/history/workspace/{workspace_id}",
    ...options,
  });

/**
 * /clinical/goal-templates/:id/archive operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/:id/archive operation on clinical-goal-template resource
 */
export const patchAdminClinicalGoalTemplatesByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalGoalTemplatesByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalGoalTemplatesByIdArchiveResponses,
    PatchAdminClinicalGoalTemplatesByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Legacy single-step upload: create a document record and immediately enqueue processing
 *
 * Legacy single-step upload: create a document record and immediately enqueue processing.
 * Use this when the file is already stored at `storage_path` (e.g., from the Ingestion domain).
 * For new client-initiated uploads, prefer `:begin_upload` + `:finish_upload` which provides
 * deduplication, presigned URL generation, and defense-in-depth credit checks.
 *
 * Side effects: enqueues `ProcessDocument` (or `ProcessAudio` for audio files) Oban job.
 * Captures actor and request context (IP, UA) for audit trail.
 *
 * Returns the created document with status `:queued`.
 *
 */
export const postAdminExtractionDocumentsUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminExtractionDocumentsUploadData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminExtractionDocumentsUploadResponses,
    PostAdminExtractionDocumentsUploadErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/upload",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /extraction/chunk-entity-links/document/:document_id operation on chunk-entity-link resource
 *
 * /extraction/chunk-entity-links/document/:document_id operation on chunk-entity-link resource
 */
export const getAdminExtractionChunkEntityLinksDocumentByDocumentId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionChunkEntityLinksDocumentByDocumentIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionChunkEntityLinksDocumentByDocumentIdResponses,
    GetAdminExtractionChunkEntityLinksDocumentByDocumentIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/chunk-entity-links/document/{document_id}",
    ...options,
  });

/**
 * /system-messages/:id operation on system-message resource
 *
 * /system-messages/:id operation on system-message resource
 */
export const deleteAdminSystemMessagesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSystemMessagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSystemMessagesByIdResponses,
    DeleteAdminSystemMessagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/system-messages/{id}",
    ...options,
  });

/**
 * /system-messages/:id operation on system-message resource
 *
 * /system-messages/:id operation on system-message resource
 */
export const getAdminSystemMessagesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSystemMessagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSystemMessagesByIdResponses,
    GetAdminSystemMessagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/system-messages/{id}",
    ...options,
  });

/**
 * Edit a system message's content, title, or version
 *
 * Edit a system message's content, title, or version. Use :publish / :unpublish for lifecycle transitions rather than toggling `is_active` via this action.
 */
export const patchAdminSystemMessagesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSystemMessagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSystemMessagesByIdResponses,
    PatchAdminSystemMessagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/system-messages/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-supplements/:id operation on clinical-client-supplement resource
 *
 * /clinical/client-supplements/:id operation on clinical-client-supplement resource
 */
export const getAdminClinicalClientSupplementsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalClientSupplementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalClientSupplementsByIdResponses,
    GetAdminClinicalClientSupplementsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-supplements/{id}",
    ...options,
  });

/**
 * /clinical/client-supplements/:id operation on clinical-client-supplement resource
 *
 * /clinical/client-supplements/:id operation on clinical-client-supplement resource
 */
export const patchAdminClinicalClientSupplementsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalClientSupplementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientSupplementsByIdResponses,
    PatchAdminClinicalClientSupplementsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-supplements/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/inbound-addresses/:id/enable operation on email-inbound-address resource
 *
 * /email/inbound-addresses/:id/enable operation on email-inbound-address resource
 */
export const patchAdminEmailInboundAddressesByIdEnable = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminEmailInboundAddressesByIdEnableData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailInboundAddressesByIdEnableResponses,
    PatchAdminEmailInboundAddressesByIdEnableErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inbound-addresses/{id}/enable",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a pipeline scoped to an application (template) or a specific workspace
 *
 * Create a pipeline scoped to an application (template) or a specific workspace. Returns the created Pipeline with its ordered stages.
 */
export const postAdminCrmPipelines = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrmPipelinesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmPipelinesResponses,
    PostAdminCrmPipelinesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/pipelines",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Return token usage summary analytics for the caller's tenant; useful for quota monitoring and capacity planning.
 *
 * Return token usage summary analytics for the caller's tenant; useful for quota monitoring and capacity planning.
 */
export const getAdminLlmAnalyticsUsage = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminLlmAnalyticsUsageData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLlmAnalyticsUsageResponses,
    GetAdminLlmAnalyticsUsageErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/llm-analytics/usage",
    ...options,
  });

/**
 * /catalog/stock-movements/:id operation on catalog-stock-movement resource
 *
 * /catalog/stock-movements/:id operation on catalog-stock-movement resource
 */
export const getAdminCatalogStockMovementsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCatalogStockMovementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCatalogStockMovementsByIdResponses,
    GetAdminCatalogStockMovementsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/stock-movements/{id}",
    ...options,
  });

/**
 * Sync all Healthie data (patients + appointments)
 *
 * Sync all Healthie data (patients + appointments).
 *
 * Returns combined sync summary with both patient and appointment counts.
 *
 */
export const postAdminConnectorsByIdHealthieSyncAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminConnectorsByIdHealthieSyncAllData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsByIdHealthieSyncAllResponses,
    PostAdminConnectorsByIdHealthieSyncAllErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/{id}/healthie/sync-all",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/recipe-tags/:id operation on recipes-recipe-tag resource
 *
 * /recipes/recipe-tags/:id operation on recipes-recipe-tag resource
 */
export const deleteAdminRecipesRecipeTagsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminRecipesRecipeTagsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRecipesRecipeTagsByIdResponses,
    DeleteAdminRecipesRecipeTagsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/recipe-tags/{id}",
    ...options,
  });

/**
 * /recipes/recipe-tags/:id operation on recipes-recipe-tag resource
 *
 * /recipes/recipe-tags/:id operation on recipes-recipe-tag resource
 */
export const getAdminRecipesRecipeTagsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesRecipeTagsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesRecipeTagsByIdResponses,
    GetAdminRecipesRecipeTagsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/recipe-tags/{id}",
    ...options,
  });

/**
 * /crawler/site-configs/:id operation on crawler-site-config resource
 *
 * /crawler/site-configs/:id operation on crawler-site-config resource
 */
export const deleteAdminCrawlerSiteConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrawlerSiteConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrawlerSiteConfigsByIdResponses,
    DeleteAdminCrawlerSiteConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/site-configs/{id}",
    ...options,
  });

/**
 * /crawler/site-configs/:id operation on crawler-site-config resource
 *
 * /crawler/site-configs/:id operation on crawler-site-config resource
 */
export const getAdminCrawlerSiteConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrawlerSiteConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerSiteConfigsByIdResponses,
    GetAdminCrawlerSiteConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/site-configs/{id}",
    ...options,
  });

/**
 * Update rate limits, strategy preference, JS requirement, or headers for an existing site config
 *
 * Update rate limits, strategy preference, JS requirement, or headers for an existing site config. Returns the updated config.
 */
export const patchAdminCrawlerSiteConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrawlerSiteConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrawlerSiteConfigsByIdResponses,
    PatchAdminCrawlerSiteConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/site-configs/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/relationship-types operation on crm-relationship-type resource
 *
 * /crm/relationship-types operation on crm-relationship-type resource
 */
export const getAdminCrmRelationshipTypes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrmRelationshipTypesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmRelationshipTypesResponses,
    GetAdminCrmRelationshipTypesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/relationship-types",
    ...options,
  });

/**
 * Define a named relationship category for an application
 *
 * Define a named relationship category for an application. Slug must be unique per
 * application and will be used as the Neo4j edge label (uppercased). System types
 * are created automatically when the :crm capability is enabled.
 *
 */
export const postAdminCrmRelationshipTypes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCrmRelationshipTypesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmRelationshipTypesResponses,
    PostAdminCrmRelationshipTypesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/relationship-types",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/recurring-schedules operation on invoices-recurring-schedule resource
 *
 * /invoices/recurring-schedules operation on invoices-recurring-schedule resource
 */
export const postAdminInvoicesRecurringSchedules = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminInvoicesRecurringSchedulesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminInvoicesRecurringSchedulesResponses,
    PostAdminInvoicesRecurringSchedulesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/recurring-schedules",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-tools/categories operation on clinical-practice-tool-category resource
 *
 * /clinical/practice-tools/categories operation on clinical-practice-tool-category resource
 */
export const getAdminClinicalPracticeToolsCategories = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPracticeToolsCategoriesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeToolsCategoriesResponses,
    GetAdminClinicalPracticeToolsCategoriesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/categories",
    ...options,
  });

/**
 * /clinical/goal-templates/from-existing operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/from-existing operation on clinical-goal-template resource
 */
export const postAdminClinicalGoalTemplatesFromExisting = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminClinicalGoalTemplatesFromExistingData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminClinicalGoalTemplatesFromExistingResponses,
    PostAdminClinicalGoalTemplatesFromExistingErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/from-existing",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-medications/:id operation on clinical-client-medication resource
 *
 * /clinical/client-medications/:id operation on clinical-client-medication resource
 */
export const getAdminClinicalClientMedicationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalClientMedicationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalClientMedicationsByIdResponses,
    GetAdminClinicalClientMedicationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-medications/{id}",
    ...options,
  });

/**
 * /clinical/client-medications/:id operation on clinical-client-medication resource
 *
 * /clinical/client-medications/:id operation on clinical-client-medication resource
 */
export const patchAdminClinicalClientMedicationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalClientMedicationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientMedicationsByIdResponses,
    PatchAdminClinicalClientMedicationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-medications/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Return platform-wide chat statistics including total threads, total messages, threads active in the last 24h and 7d, message distribution by role, and top 10 workspaces by thread count
 *
 * Return platform-wide chat statistics including total threads, total messages, threads active in the last 24h and 7d, message distribution by role, and top 10 workspaces by thread count. Platform admin access only; returns the single virtual 'platform' record.
 */
export const getAdminThreadsStats = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminThreadsStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminThreadsStatsResponses,
    GetAdminThreadsStatsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/stats",
    ...options,
  });

/**
 * Cancel the current subscription plan
 *
 * Cancel the current subscription plan
 */
export const patchAdminWalletPlanCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWalletPlanCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWalletPlanCancelResponses,
    PatchAdminWalletPlanCancelErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/plan/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a payment token
 *
 * Create a payment token
 */
export const postAdminTokens = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminTokensData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTokensResponses,
    PostAdminTokensErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tokens",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /portal-invitations operation on portal-invitation resource
 *
 * /portal-invitations operation on portal-invitation resource
 */
export const getAdminPortalInvitations = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPortalInvitationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPortalInvitationsResponses,
    GetAdminPortalInvitationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/portal-invitations",
    ...options,
  });

/**
 * /portal-invitations operation on portal-invitation resource
 *
 * /portal-invitations operation on portal-invitation resource
 */
export const postAdminPortalInvitations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminPortalInvitationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPortalInvitationsResponses,
    PostAdminPortalInvitationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/portal-invitations",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all relationships for a given node
 *
 * List all relationships for a given node
 */
export const getAdminAiGraphNodesByNodeIdRelationships = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAiGraphNodesByNodeIdRelationshipsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAiGraphNodesByNodeIdRelationshipsResponses,
    GetAdminAiGraphNodesByNodeIdRelationshipsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/graph/nodes/{node_id}/relationships",
    ...options,
  });

/**
 * Promote available_version_id to effective_version_id when an update has been notified.
 *
 * Promote available_version_id to effective_version_id when an update has been notified.
 */
export const patchAdminFormDeploymentsByIdAcceptUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminFormDeploymentsByIdAcceptUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminFormDeploymentsByIdAcceptUpdateResponses,
    PatchAdminFormDeploymentsByIdAcceptUpdateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-deployments/{id}/accept-update",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all permission presets (pre-defined role bundles) from the PermissionRegistry, optionally filtered by context and app
 *
 * List all permission presets (pre-defined role bundles) from the PermissionRegistry, optionally filtered by context and app. Use to populate preset selectors in role management UIs.
 */
export const getAdminPermissionsPresets = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPermissionsPresetsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPermissionsPresetsResponses,
    GetAdminPermissionsPresetsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/permissions/presets",
    ...options,
  });

/**
 * Platform-Admin-only manual signup-grant
 *
 * Platform-Admin-only manual signup-grant. Forces the grant through
 * `IsvSignupGrantProvisioner` with `override: true`, bypassing
 * proof-of-life, setting `proof_of_life_path: :admin_manual` regardless
 * of agreement source, using the explicit `credits` argument, and
 * persisting `reason` on the `PlatformUsageEvent.metadata`. Re-running
 * this action is NOT idempotent — every call fires a fresh grant. Use
 * sparingly; the auto-grant path should cover normal onboarding.
 *
 */
export const postAdminWholesaleAgreementsByIdGrantSignupCredits = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminWholesaleAgreementsByIdGrantSignupCreditsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminWholesaleAgreementsByIdGrantSignupCreditsResponses,
    PostAdminWholesaleAgreementsByIdGrantSignupCreditsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wholesale-agreements/{id}/grant-signup-credits",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/supplement-templates/:id/permanent operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/:id/permanent operation on clinical-supplement-template resource
 */
export const deleteAdminClinicalSupplementTemplatesByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalSupplementTemplatesByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalSupplementTemplatesByIdPermanentResponses,
    DeleteAdminClinicalSupplementTemplatesByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/{id}/permanent",
    ...options,
  });

/**
 * /extraction/chunk-entity-links/entity/:graph_node_id operation on chunk-entity-link resource
 *
 * /extraction/chunk-entity-links/entity/:graph_node_id operation on chunk-entity-link resource
 */
export const getAdminExtractionChunkEntityLinksEntityByGraphNodeId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionChunkEntityLinksEntityByGraphNodeIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionChunkEntityLinksEntityByGraphNodeIdResponses,
    GetAdminExtractionChunkEntityLinksEntityByGraphNodeIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/chunk-entity-links/entity/{graph_node_id}",
    ...options,
  });

/**
 * Create an ISV tenant with initial credits
 *
 * Create an ISV tenant with initial credits
 */
export const postAdminTenantsIsv = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminTenantsIsvData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTenantsIsvResponses,
    PostAdminTenantsIsvErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/isv",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Update auto-top-up settings
 *
 * Update auto-top-up settings
 */
export const patchAdminWalletAutoTopUp = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminWalletAutoTopUpData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWalletAutoTopUpResponses,
    PatchAdminWalletAutoTopUpErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/auto-top-up",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a new taxonomy (classification axis) for an application; enforces max_taxonomies quota
 *
 * Create a new taxonomy (classification axis) for an application; enforces max_taxonomies quota. Returns the created taxonomy.
 */
export const postAdminCatalogTaxonomies = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCatalogTaxonomiesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogTaxonomiesResponses,
    PostAdminCatalogTaxonomiesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/taxonomies",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/intake-targets/:id/restore operation on clinical-intake-target resource
 *
 * /clinical/intake-targets/:id/restore operation on clinical-intake-target resource
 */
export const patchAdminClinicalIntakeTargetsByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalIntakeTargetsByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalIntakeTargetsByIdRestoreResponses,
    PatchAdminClinicalIntakeTargetsByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/intake-targets/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /extraction/shadow-comparisons operation on shadow-comparison resource
 *
 * /extraction/shadow-comparisons operation on shadow-comparison resource
 */
export const getAdminExtractionShadowComparisons = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionShadowComparisonsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionShadowComparisonsResponses,
    GetAdminExtractionShadowComparisonsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/shadow-comparisons",
    ...options,
  });

/**
 * /extraction/shadow-comparisons operation on shadow-comparison resource
 *
 * /extraction/shadow-comparisons operation on shadow-comparison resource
 */
export const postAdminExtractionShadowComparisons = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminExtractionShadowComparisonsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminExtractionShadowComparisonsResponses,
    PostAdminExtractionShadowComparisonsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/shadow-comparisons",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /breach-notifications operation on breach-notification resource
 *
 * /breach-notifications operation on breach-notification resource
 */
export const getAdminBreachNotifications = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminBreachNotificationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBreachNotificationsResponses,
    GetAdminBreachNotificationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/breach-notifications",
    ...options,
  });

/**
 * Credit usage forecast — burn rate and projected exhaustion date
 *
 * Credit usage forecast — burn rate and projected exhaustion date
 */
export const getAdminWalletForecast = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminWalletForecastData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWalletForecastResponses,
    GetAdminWalletForecastErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/forecast",
    ...options,
  });

/**
 * /wallet/invoices operation on invoice resource
 *
 * /wallet/invoices operation on invoice resource
 */
export const getAdminWalletInvoices = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminWalletInvoicesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWalletInvoicesResponses,
    GetAdminWalletInvoicesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/invoices",
    ...options,
  });

/**
 * /clinical/supplement-template-collection-memberships operation on clinical-supplement-template-collection-membership resource
 *
 * /clinical/supplement-template-collection-memberships operation on clinical-supplement-template-collection-membership resource
 */
export const postAdminClinicalSupplementTemplateCollectionMemberships = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminClinicalSupplementTemplateCollectionMembershipsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminClinicalSupplementTemplateCollectionMembershipsResponses,
    PostAdminClinicalSupplementTemplateCollectionMembershipsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-template-collection-memberships",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Close a case (terminal state).
 *
 * Close a case (terminal state).
 */
export const patchAdminCasesByIdClose = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminCasesByIdCloseData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCasesByIdCloseResponses,
    PatchAdminCasesByIdCloseErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cases/{id}/close",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List feature allocations for a specific plan.
 *
 * List feature allocations for a specific plan.
 */
export const getAdminPlanFeatureAllocationsByPlanByPlanId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminPlanFeatureAllocationsByPlanByPlanIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminPlanFeatureAllocationsByPlanByPlanIdResponses,
    GetAdminPlanFeatureAllocationsByPlanByPlanIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plan-feature-allocations/by-plan/{plan_id}",
    ...options,
  });

/**
 * /clinical/note-templates/mine operation on clinical-note-template resource
 *
 * /clinical/note-templates/mine operation on clinical-note-template resource
 */
export const getAdminClinicalNoteTemplatesMine = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalNoteTemplatesMineData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNoteTemplatesMineResponses,
    GetAdminClinicalNoteTemplatesMineErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/mine",
    ...options,
  });

/**
 * /clinical/supplement-template-collections/:id operation on clinical-supplement-template-collection resource
 *
 * /clinical/supplement-template-collections/:id operation on clinical-supplement-template-collection resource
 */
export const deleteAdminClinicalSupplementTemplateCollectionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalSupplementTemplateCollectionsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalSupplementTemplateCollectionsByIdResponses,
    DeleteAdminClinicalSupplementTemplateCollectionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-template-collections/{id}",
    ...options,
  });

/**
 * /clinical/supplement-template-collections/:id operation on clinical-supplement-template-collection resource
 *
 * /clinical/supplement-template-collections/:id operation on clinical-supplement-template-collection resource
 */
export const getAdminClinicalSupplementTemplateCollectionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalSupplementTemplateCollectionsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSupplementTemplateCollectionsByIdResponses,
    GetAdminClinicalSupplementTemplateCollectionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-template-collections/{id}",
    ...options,
  });

/**
 * /clinical/supplement-template-collections/:id operation on clinical-supplement-template-collection resource
 *
 * /clinical/supplement-template-collections/:id operation on clinical-supplement-template-collection resource
 */
export const patchAdminClinicalSupplementTemplateCollectionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalSupplementTemplateCollectionsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalSupplementTemplateCollectionsByIdResponses,
    PatchAdminClinicalSupplementTemplateCollectionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-template-collections/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-resources/catalog/archived operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/catalog/archived operation on clinical-practice-resource resource
 */
export const getAdminClinicalPracticeResourcesCatalogArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalPracticeResourcesCatalogArchivedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeResourcesCatalogArchivedResponses,
    GetAdminClinicalPracticeResourcesCatalogArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/catalog/archived",
    ...options,
  });

/**
 * /agent-executions operation on agent-execution resource
 *
 * /agent-executions operation on agent-execution resource
 */
export const getAdminAgentExecutions = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAgentExecutionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentExecutionsResponses,
    GetAdminAgentExecutionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-executions",
    ...options,
  });

/**
 * Dispatch accumulated transcript to the blueprint/chat pipeline
 *
 * Dispatch accumulated transcript to the blueprint/chat pipeline
 */
export const patchAdminVoiceSessionsByIdFinalize = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminVoiceSessionsByIdFinalizeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminVoiceSessionsByIdFinalizeResponses,
    PatchAdminVoiceSessionsByIdFinalizeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/sessions/{id}/finalize",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Full-text search messages by substring match on content
 *
 * Full-text search messages by substring match on content. Optionally filter to a single thread via :thread_id. For AI-powered similarity search, use :semantic_search instead.
 */
export const getAdminMessagesSearch = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminMessagesSearchData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminMessagesSearchResponses,
    GetAdminMessagesSearchErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/messages/search",
    ...options,
  });

/**
 * Reset budget period (for testing or manual reset)
 *
 * Reset budget period (for testing or manual reset)
 */
export const patchAdminApiKeysByIdResetPeriod = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminApiKeysByIdResetPeriodData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminApiKeysByIdResetPeriodResponses,
    PatchAdminApiKeysByIdResetPeriodErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/api-keys/{id}/reset-period",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /voice/transcription-results operation on voice-transcription-result resource
 *
 * /voice/transcription-results operation on voice-transcription-result resource
 */
export const getAdminVoiceTranscriptionResults = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminVoiceTranscriptionResultsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminVoiceTranscriptionResultsResponses,
    GetAdminVoiceTranscriptionResultsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/transcription-results",
    ...options,
  });

/**
 * /voice/transcription-results operation on voice-transcription-result resource
 *
 * /voice/transcription-results operation on voice-transcription-result resource
 */
export const postAdminVoiceTranscriptionResults = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminVoiceTranscriptionResultsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminVoiceTranscriptionResultsResponses,
    PostAdminVoiceTranscriptionResultsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/transcription-results",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Archive an active file; soft-hides it from default views while preserving the S3 object
 *
 * Archive an active file; soft-hides it from default views while preserving the S3 object. Use restore to return to active.
 */
export const patchAdminStorageFilesByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminStorageFilesByIdArchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminStorageFilesByIdArchiveResponses,
    PatchAdminStorageFilesByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-files/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /storage-files/:id operation on storage-file resource
 *
 * /storage-files/:id operation on storage-file resource
 */
export const getAdminStorageFilesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminStorageFilesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminStorageFilesByIdResponses,
    GetAdminStorageFilesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-files/{id}",
    ...options,
  });

/**
 * Update file metadata, tags, visibility, key, namespace, or status
 *
 * Update file metadata, tags, visibility, key, namespace, or status. Returns the updated file.
 */
export const patchAdminStorageFilesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminStorageFilesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminStorageFilesByIdResponses,
    PatchAdminStorageFilesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-files/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Dedup-aware upload: returns existing document if file_hash matches, otherwise creates new document
 *
 * Dedup-aware upload: returns existing document if file_hash matches, otherwise creates new document
 */
export const postAdminExtractionDocumentsFindOrBeginUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminExtractionDocumentsFindOrBeginUploadData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminExtractionDocumentsFindOrBeginUploadResponses,
    PostAdminExtractionDocumentsFindOrBeginUploadErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/find-or-begin-upload",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Clinician rejects a draft or unreviewed goal
 *
 * Clinician rejects a draft or unreviewed goal. Sets review_status: :rejected and lifecycle status: :discontinued.
 */
export const patchAdminClinicalClientGoalsByIdReject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalClientGoalsByIdRejectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientGoalsByIdRejectResponses,
    PatchAdminClinicalClientGoalsByIdRejectErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-goals/{id}/reject",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /workspace-preferences/:id operation on workspace-preference resource
 *
 * /workspace-preferences/:id operation on workspace-preference resource
 */
export const deleteAdminWorkspacePreferencesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminWorkspacePreferencesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminWorkspacePreferencesByIdResponses,
    DeleteAdminWorkspacePreferencesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspace-preferences/{id}",
    ...options,
  });

/**
 * /llm-analytics/:id operation on llm-analytics resource
 *
 * /llm-analytics/:id operation on llm-analytics resource
 */
export const getAdminLlmAnalyticsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminLlmAnalyticsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLlmAnalyticsByIdResponses,
    GetAdminLlmAnalyticsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/llm-analytics/{id}",
    ...options,
  });

/**
 * /clinical/goal-templates/catalog/:id operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/catalog/:id operation on clinical-goal-template resource
 */
export const getAdminClinicalGoalTemplatesCatalogById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalGoalTemplatesCatalogByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalTemplatesCatalogByIdResponses,
    GetAdminClinicalGoalTemplatesCatalogByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/catalog/{id}",
    ...options,
  });

/**
 * /clinical/goal-templates/catalog/:id operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/catalog/:id operation on clinical-goal-template resource
 */
export const patchAdminClinicalGoalTemplatesCatalogById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalGoalTemplatesCatalogByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalGoalTemplatesCatalogByIdResponses,
    PatchAdminClinicalGoalTemplatesCatalogByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/catalog/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/posts/campaign/:social_campaign_id operation on social-post resource
 *
 * /social/posts/campaign/:social_campaign_id operation on social-post resource
 */
export const getAdminSocialPostsCampaignBySocialCampaignId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSocialPostsCampaignBySocialCampaignIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSocialPostsCampaignBySocialCampaignIdResponses,
    GetAdminSocialPostsCampaignBySocialCampaignIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/posts/campaign/{social_campaign_id}",
    ...options,
  });

/**
 * Remove a system field from this version's output_schema
 *
 * Remove a system field from this version's output_schema
 */
export const postAdminAgentVersionsByIdRemoveSystemField = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminAgentVersionsByIdRemoveSystemFieldData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminAgentVersionsByIdRemoveSystemFieldResponses,
    PostAdminAgentVersionsByIdRemoveSystemFieldErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-versions/{id}/remove-system-field",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all values for an option type ordered by position
 *
 * List all values for an option type ordered by position. Returns a paginated list.
 */
export const getAdminCatalogOptionValuesOptionTypeByOptionTypeId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogOptionValuesOptionTypeByOptionTypeIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogOptionValuesOptionTypeByOptionTypeIdResponses,
    GetAdminCatalogOptionValuesOptionTypeByOptionTypeIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/option-values/option-type/{option_type_id}",
    ...options,
  });

/**
 * Define a custom field for a core CRM entity type (contact, company, deal, activity)
 *
 * Define a custom field for a core CRM entity type (contact, company, deal, activity).
 * Field values are stored in the entity's properties JSONB column. Name must be
 * lowercase alphanumeric (no underscore prefix) and unique per application+entity_type.
 *
 */
export const postAdminCrmFieldDefinitions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCrmFieldDefinitionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmFieldDefinitionsResponses,
    PostAdminCrmFieldDefinitionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/field-definitions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get API keys with usage statistics for a tenant
 *
 * Get API keys with usage statistics for a tenant
 */
export const getAdminApiKeysStats = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminApiKeysStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminApiKeysStatsResponses,
    GetAdminApiKeysStatsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/api-keys/stats",
    ...options,
  });

/**
 * List all active event types for a workspace
 *
 * List all active event types for a workspace. Excludes archived types. Use :by_slug for public booking page resolution.
 */
export const getAdminSchedulingEventTypes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingEventTypesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingEventTypesResponses,
    GetAdminSchedulingEventTypesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/event-types",
    ...options,
  });

/**
 * Create an event type template for a workspace
 *
 * Create an event type template for a workspace. Sets slug (unique per workspace), duration,
 * buffer times, location, approval requirements, and intake form. Indexes in Meilisearch for
 * search. Returns the created EventType. Use :update to change it later — slug cannot be changed.
 *
 */
export const postAdminSchedulingEventTypes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSchedulingEventTypesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSchedulingEventTypesResponses,
    PostAdminSchedulingEventTypesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/event-types",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/supplement-templates/archived operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/archived operation on clinical-supplement-template resource
 */
export const getAdminClinicalSupplementTemplatesArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalSupplementTemplatesArchivedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSupplementTemplatesArchivedResponses,
    GetAdminClinicalSupplementTemplatesArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/archived",
    ...options,
  });

/**
 * Create a ticket routing rule for an application
 *
 * Create a ticket routing rule for an application. Rules are evaluated top-down by priority (lower number = higher priority). conditions is a map of ticket attributes to match; action_params holds the rule's output (queue_id, priority_override, tag).
 */
export const postAdminSupportRoutingRules = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSupportRoutingRulesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSupportRoutingRulesResponses,
    PostAdminSupportRoutingRulesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/routing-rules",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * AI-draft an email from a prompt and context map.
 *
 * AI-draft an email from a prompt and context map.
 */
export const postAdminEmailOutboundEmailsComposeWithAi = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminEmailOutboundEmailsComposeWithAiData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminEmailOutboundEmailsComposeWithAiResponses,
    PostAdminEmailOutboundEmailsComposeWithAiErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/outbound-emails/compose-with-ai",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /brand-identities/by-workspace/:workspace_id operation on brand-identity resource
 *
 * /brand-identities/by-workspace/:workspace_id operation on brand-identity resource
 */
export const getAdminBrandIdentitiesByWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminBrandIdentitiesByWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminBrandIdentitiesByWorkspaceByWorkspaceIdResponses,
    GetAdminBrandIdentitiesByWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/brand-identities/by-workspace/{workspace_id}",
    ...options,
  });

/**
 * /clinical/supplement-templates/catalog/:id/restore operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/catalog/:id/restore operation on clinical-supplement-template resource
 */
export const patchAdminClinicalSupplementTemplatesCatalogByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalSupplementTemplatesCatalogByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalSupplementTemplatesCatalogByIdRestoreResponses,
    PatchAdminClinicalSupplementTemplatesCatalogByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/catalog/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/posts/workspace/:workspace_id operation on social-post resource
 *
 * /social/posts/workspace/:workspace_id operation on social-post resource
 */
export const getAdminSocialPostsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSocialPostsWorkspaceByWorkspaceIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSocialPostsWorkspaceByWorkspaceIdResponses,
    GetAdminSocialPostsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/posts/workspace/{workspace_id}",
    ...options,
  });

/**
 * /claimed-domains operation on claimed-domain resource
 *
 * /claimed-domains operation on claimed-domain resource
 */
export const getAdminClaimedDomains = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminClaimedDomainsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClaimedDomainsResponses,
    GetAdminClaimedDomainsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/claimed-domains",
    ...options,
  });

/**
 * /claimed-domains operation on claimed-domain resource
 *
 * /claimed-domains operation on claimed-domain resource
 */
export const postAdminClaimedDomains = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminClaimedDomainsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClaimedDomainsResponses,
    PostAdminClaimedDomainsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/claimed-domains",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List current user's voice sessions
 *
 * List current user's voice sessions
 */
export const getAdminVoiceSessionsMine = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminVoiceSessionsMineData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminVoiceSessionsMineResponses,
    GetAdminVoiceSessionsMineErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/sessions/mine",
    ...options,
  });

/**
 * /breach-incidents operation on breach-incident resource
 *
 * /breach-incidents operation on breach-incident resource
 */
export const getAdminBreachIncidents = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminBreachIncidentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBreachIncidentsResponses,
    GetAdminBreachIncidentsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/breach-incidents",
    ...options,
  });

/**
 * Report a new data breach or security incident
 *
 * Report a new data breach or security incident. Automatically calculates the 72-hour GDPR notification deadline from `discovery_date`. Returns the created incident with the computed deadline.
 */
export const postAdminBreachIncidents = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminBreachIncidentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminBreachIncidentsResponses,
    PostAdminBreachIncidentsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/breach-incidents",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch a single reminder by ID
 *
 * Fetch a single reminder by ID. Returns channel, status, scheduled_at, and recipient_participant_id.
 */
export const getAdminSchedulingRemindersById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingRemindersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingRemindersByIdResponses,
    GetAdminSchedulingRemindersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/reminders/{id}",
    ...options,
  });

/**
 * Returns a workspace-scoped count summary:
 * %{open, sla_overdue, sla_within_24h, sla_within_7d}
 *
 * Returns a workspace-scoped count summary:
 * %{open, sla_overdue, sla_within_24h, sla_within_7d}.
 * All counts are filtered to is_open == true.
 *
 */
export const getAdminCasesAttentionSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCasesAttentionSummaryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCasesAttentionSummaryResponses,
    GetAdminCasesAttentionSummaryErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cases/attention-summary",
    ...options,
  });

/**
 * Update the value, description, or sensitivity flag for an existing config entry; automatically invalidates the FetchConfig cache for the key
 *
 * Update the value, description, or sensitivity flag for an existing config entry; automatically invalidates the FetchConfig cache for the key. Returns the updated config.
 */
export const patchAdminConfigsByKey = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminConfigsByKeyData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminConfigsByKeyResponses,
    PatchAdminConfigsByKeyErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/configs/{key}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all bookings made by a specific email address across the workspace
 *
 * List all bookings made by a specific email address across the workspace. Use to show a booker their booking history or check for cooldown violations.
 */
export const getAdminSchedulingBookingsByBooker = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingBookingsByBookerData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingBookingsByBookerResponses,
    GetAdminSchedulingBookingsByBookerErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/bookings/by-booker",
    ...options,
  });

/**
 * /clinical/patients/:id operation on clinical-patient resource
 *
 * /clinical/patients/:id operation on clinical-patient resource
 */
export const deleteAdminClinicalPatientsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminClinicalPatientsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalPatientsByIdResponses,
    DeleteAdminClinicalPatientsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patients/{id}",
    ...options,
  });

/**
 * /clinical/patients/:id operation on clinical-patient resource
 *
 * /clinical/patients/:id operation on clinical-patient resource
 */
export const getAdminClinicalPatientsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPatientsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPatientsByIdResponses,
    GetAdminClinicalPatientsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patients/{id}",
    ...options,
  });

/**
 * /clinical/patients/:id operation on clinical-patient resource
 *
 * /clinical/patients/:id operation on clinical-patient resource
 */
export const patchAdminClinicalPatientsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalPatientsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPatientsByIdResponses,
    PatchAdminClinicalPatientsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patients/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /isv-revenue operation on isv-revenue resource
 *
 * /isv-revenue operation on isv-revenue resource
 */
export const getAdminIsvRevenue = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminIsvRevenueData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminIsvRevenueResponses,
    GetAdminIsvRevenueErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv-revenue",
    ...options,
  });

/**
 * /isv-revenue operation on isv-revenue resource
 *
 * /isv-revenue operation on isv-revenue resource
 */
export const postAdminIsvRevenue = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminIsvRevenueData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminIsvRevenueResponses,
    PostAdminIsvRevenueErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv-revenue",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all plan feature allocations.
 *
 * List all plan feature allocations.
 */
export const getAdminPlanFeatureAllocations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPlanFeatureAllocationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPlanFeatureAllocationsResponses,
    GetAdminPlanFeatureAllocationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plan-feature-allocations",
    ...options,
  });

/**
 * Create a plan-level override for a feature definition
 *
 * Create a plan-level override for a feature definition. Links a feature to a plan
 * with optional limit, credit cost, and activation cost overrides.
 *
 */
export const postAdminPlanFeatureAllocations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminPlanFeatureAllocationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPlanFeatureAllocationsResponses,
    PostAdminPlanFeatureAllocationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plan-feature-allocations",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/templates/:id operation on invoices-template resource
 *
 * /invoices/templates/:id operation on invoices-template resource
 */
export const deleteAdminInvoicesTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminInvoicesTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminInvoicesTemplatesByIdResponses,
    DeleteAdminInvoicesTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/templates/{id}",
    ...options,
  });

/**
 * /invoices/templates/:id operation on invoices-template resource
 *
 * /invoices/templates/:id operation on invoices-template resource
 */
export const getAdminInvoicesTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminInvoicesTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminInvoicesTemplatesByIdResponses,
    GetAdminInvoicesTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/templates/{id}",
    ...options,
  });

/**
 * /invoices/templates/:id operation on invoices-template resource
 *
 * /invoices/templates/:id operation on invoices-template resource
 */
export const patchAdminInvoicesTemplatesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesTemplatesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesTemplatesByIdResponses,
    PatchAdminInvoicesTemplatesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/templates/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get product details from Fullscript
 *
 * Get product details from Fullscript
 */
export const postAdminConnectorsFullscriptProductsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminConnectorsFullscriptProductsGetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsFullscriptProductsGetResponses,
    PostAdminConnectorsFullscriptProductsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/fullscript/products/get",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /extraction-workflows operation on extraction-workflow resource
 *
 * /extraction-workflows operation on extraction-workflow resource
 */
export const getAdminExtractionWorkflows = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionWorkflowsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionWorkflowsResponses,
    GetAdminExtractionWorkflowsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction-workflows",
    ...options,
  });

/**
 * /extraction-workflows operation on extraction-workflow resource
 *
 * /extraction-workflows operation on extraction-workflow resource
 */
export const postAdminExtractionWorkflows = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminExtractionWorkflowsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminExtractionWorkflowsResponses,
    PostAdminExtractionWorkflowsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction-workflows",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Submit human corrections to improve agent training
 *
 * Submit human corrections to improve agent training. Delegates to the registered training
 * handler (provided by the Extraction domain at boot via `RegistryCoordinator`). The handler
 * creates a `TrainingSession`, applies corrections to the `ExtractionResult` via
 * `:save_corrections`, and creates `TrainingExample` records for few-shot learning.
 *
 * Cannot be called on system agents (`is_system: true`). The `verify_remaining` flag (default
 * `true`) implicitly marks untouched fields as verified.
 *
 * Returns the agent struct with updated training metadata.
 *
 */
export const postAdminAgentsByIdTeach = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAgentsByIdTeachData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentsByIdTeachResponses,
    PostAdminAgentsByIdTeachErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/teach",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/collections/:id operation on recipes-recipe-collection resource
 *
 * /recipes/collections/:id operation on recipes-recipe-collection resource
 */
export const deleteAdminRecipesCollectionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminRecipesCollectionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRecipesCollectionsByIdResponses,
    DeleteAdminRecipesCollectionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/collections/{id}",
    ...options,
  });

/**
 * /recipes/collections/:id operation on recipes-recipe-collection resource
 *
 * /recipes/collections/:id operation on recipes-recipe-collection resource
 */
export const getAdminRecipesCollectionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesCollectionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesCollectionsByIdResponses,
    GetAdminRecipesCollectionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/collections/{id}",
    ...options,
  });

/**
 * /recipes/collections/:id operation on recipes-recipe-collection resource
 *
 * /recipes/collections/:id operation on recipes-recipe-collection resource
 */
export const patchAdminRecipesCollectionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRecipesCollectionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesCollectionsByIdResponses,
    PatchAdminRecipesCollectionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/collections/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Lightweight poll endpoint: fetches only `id`, `status`, `progress`, and `error_message` for
 * a single document
 *
 * Lightweight poll endpoint: fetches only `id`, `status`, `progress`, and `error_message` for
 * a single document. Use this to check processing progress without loading the full record.
 * For real-time updates, subscribe to the `extraction:document` PubSub topic instead.
 *
 */
export const getAdminExtractionDocumentsByIdStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionDocumentsByIdStatusData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionDocumentsByIdStatusResponses,
    GetAdminExtractionDocumentsByIdStatusErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}/status",
    ...options,
  });

/**
 * Internal-facing status update used by the web layer and API to set processing state
 *
 * Internal-facing status update used by the web layer and API to set processing state.
 * Accepts a broad set of fields including status, progress, classification results, and
 * agent tracking metadata. Broadcasts a document status update to the workspace WebSocket
 * channel after every change so connected clients receive live progress updates.
 *
 * Use `:report_progress` for worker-internal progress reporting (same fields, no broadcast).
 *
 */
export const patchAdminExtractionDocumentsByIdStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminExtractionDocumentsByIdStatusData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionDocumentsByIdStatusResponses,
    PatchAdminExtractionDocumentsByIdStatusErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}/status",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /reviews/:id/correct operation on review resource
 *
 * /reviews/:id/correct operation on review resource
 */
export const patchAdminReviewsByIdCorrect = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminReviewsByIdCorrectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminReviewsByIdCorrectResponses,
    PatchAdminReviewsByIdCorrectErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/reviews/{id}/correct",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List food items for an application
 *
 * List food items for an application
 */
export const getAdminRecipesFoodItemsApplicationByApplicationId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesFoodItemsApplicationByApplicationIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesFoodItemsApplicationByApplicationIdResponses,
    GetAdminRecipesFoodItemsApplicationByApplicationIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/food-items/application/{application_id}",
    ...options,
  });

/**
 * /social/posts/:id/publish operation on social-post resource
 *
 * /social/posts/:id/publish operation on social-post resource
 */
export const patchAdminSocialPostsByIdPublish = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSocialPostsByIdPublishData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialPostsByIdPublishResponses,
    PatchAdminSocialPostsByIdPublishErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/posts/{id}/publish",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/campaigns/:id/cancel operation on social-campaign resource
 *
 * /social/campaigns/:id/cancel operation on social-campaign resource
 */
export const patchAdminSocialCampaignsByIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSocialCampaignsByIdCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialCampaignsByIdCancelResponses,
    PatchAdminSocialCampaignsByIdCancelErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/campaigns/{id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all active availability rules for a workspace
 *
 * List all active availability rules for a workspace. Excludes deactivated rules. Use :list_by_user or :list_by_event_type to narrow by owner.
 */
export const getAdminSchedulingAvailabilityRules = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingAvailabilityRulesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingAvailabilityRulesResponses,
    GetAdminSchedulingAvailabilityRulesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/availability-rules",
    ...options,
  });

/**
 * Create an availability rule for a user or event type
 *
 * Create an availability rule for a user or event type. Type :recurring defines weekly windows; type :override modifies a specific date. Use :set_weekly_hours/:add_date_override for AI tool access to this action.
 */
export const postAdminSchedulingAvailabilityRules = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSchedulingAvailabilityRulesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSchedulingAvailabilityRulesResponses,
    PostAdminSchedulingAvailabilityRulesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/availability-rules",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/addresses operation on crm-address resource
 *
 * /crm/addresses operation on crm-address resource
 */
export const postAdminCrmAddresses = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrmAddressesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmAddressesResponses,
    PostAdminCrmAddressesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/addresses",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /wholesale-agreements operation on wholesale-agreement resource
 *
 * /wholesale-agreements operation on wholesale-agreement resource
 */
export const getAdminWholesaleAgreements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminWholesaleAgreementsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWholesaleAgreementsResponses,
    GetAdminWholesaleAgreementsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wholesale-agreements",
    ...options,
  });

/**
 * /wholesale-agreements operation on wholesale-agreement resource
 *
 * /wholesale-agreements operation on wholesale-agreement resource
 */
export const postAdminWholesaleAgreements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminWholesaleAgreementsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminWholesaleAgreementsResponses,
    PostAdminWholesaleAgreementsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wholesale-agreements",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-goals/:id operation on clinical-client-goal resource
 *
 * /clinical/client-goals/:id operation on clinical-client-goal resource
 */
export const getAdminClinicalClientGoalsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalClientGoalsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalClientGoalsByIdResponses,
    GetAdminClinicalClientGoalsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-goals/{id}",
    ...options,
  });

/**
 * /clinical/client-goals/:id operation on clinical-client-goal resource
 *
 * /clinical/client-goals/:id operation on clinical-client-goal resource
 */
export const patchAdminClinicalClientGoalsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalClientGoalsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientGoalsByIdResponses,
    PatchAdminClinicalClientGoalsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-goals/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all active (non-deleted) products in a workspace
 *
 * List all active (non-deleted) products in a workspace. Use search for full-text or semantic filtering.
 */
export const getAdminCatalogProductsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogProductsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogProductsWorkspaceByWorkspaceIdResponses,
    GetAdminCatalogProductsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/products/workspace/{workspace_id}",
    ...options,
  });

/**
 * Get all features with their plan allocations and current usage
 *
 * Get all features with their plan allocations and current usage
 */
export const getAdminWalletFeatures = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminWalletFeaturesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminWalletFeaturesResponses,
    GetAdminWalletFeaturesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/features",
    ...options,
  });

/**
 * /clinical/client-goals/from-template operation on clinical-client-goal resource
 *
 * /clinical/client-goals/from-template operation on clinical-client-goal resource
 */
export const postAdminClinicalClientGoalsFromTemplate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalClientGoalsFromTemplateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalClientGoalsFromTemplateResponses,
    PostAdminClinicalClientGoalsFromTemplateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-goals/from-template",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/trending/history/:id operation on trending-snapshot resource
 *
 * /social/trending/history/:id operation on trending-snapshot resource
 */
export const deleteAdminSocialTrendingHistoryById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSocialTrendingHistoryByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSocialTrendingHistoryByIdResponses,
    DeleteAdminSocialTrendingHistoryByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/trending/history/{id}",
    ...options,
  });

/**
 * /social/trending/history/:id operation on trending-snapshot resource
 *
 * /social/trending/history/:id operation on trending-snapshot resource
 */
export const getAdminSocialTrendingHistoryById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSocialTrendingHistoryByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSocialTrendingHistoryByIdResponses,
    GetAdminSocialTrendingHistoryByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/trending/history/{id}",
    ...options,
  });

/**
 * /portal-change-requests/:id/reject operation on portal-change-request resource
 *
 * /portal-change-requests/:id/reject operation on portal-change-request resource
 */
export const patchAdminPortalChangeRequestsByIdReject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPortalChangeRequestsByIdRejectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPortalChangeRequestsByIdRejectResponses,
    PatchAdminPortalChangeRequestsByIdRejectErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/portal-change-requests/{id}/reject",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/pipeline-stages/:id operation on crm-pipeline-stage resource
 *
 * /crm/pipeline-stages/:id operation on crm-pipeline-stage resource
 */
export const deleteAdminCrmPipelineStagesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmPipelineStagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmPipelineStagesByIdResponses,
    DeleteAdminCrmPipelineStagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/pipeline-stages/{id}",
    ...options,
  });

/**
 * /crm/pipeline-stages/:id operation on crm-pipeline-stage resource
 *
 * /crm/pipeline-stages/:id operation on crm-pipeline-stage resource
 */
export const getAdminCrmPipelineStagesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrmPipelineStagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmPipelineStagesByIdResponses,
    GetAdminCrmPipelineStagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/pipeline-stages/{id}",
    ...options,
  });

/**
 * Update a pipeline stage's name, order, probability, or closed flag
 *
 * Update a pipeline stage's name, order, probability, or closed flag. Re-ordering requires ensuring uniqueness across sibling stages.
 */
export const patchAdminCrmPipelineStagesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmPipelineStagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmPipelineStagesByIdResponses,
    PatchAdminCrmPipelineStagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/pipeline-stages/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/inbound-addresses/:id/disable operation on email-inbound-address resource
 *
 * /email/inbound-addresses/:id/disable operation on email-inbound-address resource
 */
export const patchAdminEmailInboundAddressesByIdDisable = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailInboundAddressesByIdDisableData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailInboundAddressesByIdDisableResponses,
    PatchAdminEmailInboundAddressesByIdDisableErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inbound-addresses/{id}/disable",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/goal-associations operation on clinical-goal-association resource
 *
 * /clinical/goal-associations operation on clinical-goal-association resource
 */
export const getAdminClinicalGoalAssociations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalGoalAssociationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalAssociationsResponses,
    GetAdminClinicalGoalAssociationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-associations",
    ...options,
  });

/**
 * /clinical/goal-associations operation on clinical-goal-association resource
 *
 * /clinical/goal-associations operation on clinical-goal-association resource
 */
export const postAdminClinicalGoalAssociations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalGoalAssociationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalGoalAssociationsResponses,
    PostAdminClinicalGoalAssociationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-associations",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-resources/archived operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/archived operation on clinical-practice-resource resource
 */
export const getAdminClinicalPracticeResourcesArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPracticeResourcesArchivedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeResourcesArchivedResponses,
    GetAdminClinicalPracticeResourcesArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/archived",
    ...options,
  });

/**
 * /meetings operation on meeting resource
 *
 * /meetings operation on meeting resource
 */
export const getAdminMeetings = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminMeetingsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminMeetingsResponses,
    GetAdminMeetingsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/meetings",
    ...options,
  });

/**
 * /meetings operation on meeting resource
 *
 * /meetings operation on meeting resource
 */
export const postAdminMeetings = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminMeetingsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminMeetingsResponses,
    PostAdminMeetingsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/meetings",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Generate a 2-3 sentence LLM summary of the thread's message history and persist it as `context_summary`
 *
 * Generate a 2-3 sentence LLM summary of the thread's message history and persist it as `context_summary`. Returns the updated Thread. If LLM fails, returns the thread unchanged without erroring.
 */
export const postAdminThreadsByIdSummarize = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminThreadsByIdSummarizeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminThreadsByIdSummarizeResponses,
    PostAdminThreadsByIdSummarizeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/{id}/summarize",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Record a decision on the Case
 *
 * Record a decision on the Case. Transitions state to `"decided"` and stamps
 * `decided_at`. If the matched `DecisionOutcome` has `is_terminal: true`,
 * `CascadeCloseOnTerminalDecision` cascades to `:close` inside the same
 * transaction — final state ends as `"closed"` with both `decided_at` and
 * `closed_at` populated. Terminal outcomes therefore require the CaseType's
 * state machine to permit a `decided → closed` transition, and its states
 * list to include `"closed"`.
 *
 */
export const patchAdminCasesByIdDecide = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminCasesByIdDecideData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCasesByIdDecideResponses,
    PatchAdminCasesByIdDecideErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cases/{id}/decide",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create or update the AI configuration for a workspace (upsert — one config per workspace)
 *
 * Create or update the AI configuration for a workspace (upsert — one config per workspace). Controls auto_classify, auto_draft, model selection, confidence_threshold, and CRM contact auto-creation. When no config exists, defaults apply: both enabled, threshold 0.7.
 */
export const postAdminSupportAiConfigs = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSupportAiConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSupportAiConfigsResponses,
    PostAdminSupportAiConfigsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/ai-configs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /extraction/chunk-entity-links operation on chunk-entity-link resource
 *
 * /extraction/chunk-entity-links operation on chunk-entity-link resource
 */
export const getAdminExtractionChunkEntityLinks = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionChunkEntityLinksData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionChunkEntityLinksResponses,
    GetAdminExtractionChunkEntityLinksErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/chunk-entity-links",
    ...options,
  });

/**
 * Update a schema version without creating a new version
 *
 * Update a schema version without creating a new version
 */
export const patchAdminAgentsByIdSchemaVersionsByVersionId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminAgentsByIdSchemaVersionsByVersionIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminAgentsByIdSchemaVersionsByVersionIdResponses,
    PatchAdminAgentsByIdSchemaVersionsByVersionIdErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/schema-versions/{version_id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Record that a document has been used for agent training
 *
 * Record that a document has been used for agent training. Sets `training_metadata["trained_at"]`
 * and `training_metadata["trained_by_user_id"]` and clears any prior `dismissed_at` so the
 * document reappears in the `:list_trained` view.
 *
 * Use this to manually mark a document as trained when the automatic training flow (via
 * `save_corrections`) was not used.
 *
 */
export const patchAdminExtractionDocumentsByIdMarkTrained = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminExtractionDocumentsByIdMarkTrainedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionDocumentsByIdMarkTrainedResponses,
    PatchAdminExtractionDocumentsByIdMarkTrainedErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}/mark-trained",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/campaigns/:id operation on social-campaign resource
 *
 * /social/campaigns/:id operation on social-campaign resource
 */
export const deleteAdminSocialCampaignsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSocialCampaignsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSocialCampaignsByIdResponses,
    DeleteAdminSocialCampaignsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/campaigns/{id}",
    ...options,
  });

/**
 * /social/campaigns/:id operation on social-campaign resource
 *
 * /social/campaigns/:id operation on social-campaign resource
 */
export const getAdminSocialCampaignsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSocialCampaignsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSocialCampaignsByIdResponses,
    GetAdminSocialCampaignsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/campaigns/{id}",
    ...options,
  });

/**
 * /social/campaigns/:id operation on social-campaign resource
 *
 * /social/campaigns/:id operation on social-campaign resource
 */
export const patchAdminSocialCampaignsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSocialCampaignsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialCampaignsByIdResponses,
    PatchAdminSocialCampaignsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/campaigns/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List template collections for a workspace
 *
 * List template collections for a workspace
 */
export const getAdminClinicalGoalTemplateCollections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalGoalTemplateCollectionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalTemplateCollectionsResponses,
    GetAdminClinicalGoalTemplateCollectionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-template-collections",
    ...options,
  });

/**
 * /clinical/goal-template-collections operation on clinical-goal-template-collection resource
 *
 * /clinical/goal-template-collections operation on clinical-goal-template-collection resource
 */
export const postAdminClinicalGoalTemplateCollections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalGoalTemplateCollectionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalGoalTemplateCollectionsResponses,
    PostAdminClinicalGoalTemplateCollectionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-template-collections",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /voice/recordings/:id operation on voice-recording resource
 *
 * /voice/recordings/:id operation on voice-recording resource
 */
export const getAdminVoiceRecordingsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminVoiceRecordingsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminVoiceRecordingsByIdResponses,
    GetAdminVoiceRecordingsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/recordings/{id}",
    ...options,
  });

/**
 * /invoices/:id/apply-ai-suggestions operation on invoices-invoice resource
 *
 * /invoices/:id/apply-ai-suggestions operation on invoices-invoice resource
 */
export const patchAdminInvoicesByIdApplyAiSuggestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesByIdApplyAiSuggestionsData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesByIdApplyAiSuggestionsResponses,
    PatchAdminInvoicesByIdApplyAiSuggestionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}/apply-ai-suggestions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/generated-emails/:id/approve operation on email-marketing-generated-email resource
 *
 * /email-marketing/generated-emails/:id/approve operation on email-marketing-generated-email resource
 */
export const patchAdminEmailMarketingGeneratedEmailsByIdApprove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailMarketingGeneratedEmailsByIdApproveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingGeneratedEmailsByIdApproveResponses,
    PatchAdminEmailMarketingGeneratedEmailsByIdApproveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/generated-emails/{id}/approve",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/meal-plans/:id/archive operation on clinical-meal-plan resource
 *
 * /clinical/meal-plans/:id/archive operation on clinical-meal-plan resource
 */
export const patchAdminClinicalMealPlansByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalMealPlansByIdArchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalMealPlansByIdArchiveResponses,
    PatchAdminClinicalMealPlansByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/meal-plans/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /policy-review-schedules/:id/mark-overdue operation on policy-review-schedule resource
 *
 * /policy-review-schedules/:id/mark-overdue operation on policy-review-schedule resource
 */
export const patchAdminPolicyReviewSchedulesByIdMarkOverdue = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminPolicyReviewSchedulesByIdMarkOverdueData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminPolicyReviewSchedulesByIdMarkOverdueResponses,
    PatchAdminPolicyReviewSchedulesByIdMarkOverdueErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/policy-review-schedules/{id}/mark-overdue",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Soft-delete a taxonomy by setting deleted_at; cascades to exclude nodes from future reads
 *
 * Soft-delete a taxonomy by setting deleted_at; cascades to exclude nodes from future reads. Irreversible via API.
 */
export const deleteAdminCatalogTaxonomiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCatalogTaxonomiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCatalogTaxonomiesByIdResponses,
    DeleteAdminCatalogTaxonomiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/taxonomies/{id}",
    ...options,
  });

/**
 * /catalog/taxonomies/:id operation on catalog-taxonomy resource
 *
 * /catalog/taxonomies/:id operation on catalog-taxonomy resource
 */
export const getAdminCatalogTaxonomiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCatalogTaxonomiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCatalogTaxonomiesByIdResponses,
    GetAdminCatalogTaxonomiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/taxonomies/{id}",
    ...options,
  });

/**
 * Update taxonomy metadata (name, slug, hierarchy settings)
 *
 * Update taxonomy metadata (name, slug, hierarchy settings). Returns the updated taxonomy.
 */
export const patchAdminCatalogTaxonomiesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCatalogTaxonomiesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogTaxonomiesByIdResponses,
    PatchAdminCatalogTaxonomiesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/taxonomies/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Cancel a subscription
 *
 * Cancel a subscription.
 *
 * - `immediate: true` (default) — cancels immediately, sets status to `:canceled`
 * - `immediate: false` — schedules cancellation at period end, sets status to `:pending_cancellation`
 *
 * The renewal worker processes `:pending_cancellation` at `current_period_end`
 * and transitions the subscription to `:canceled`.
 *
 */
export const patchAdminSubscriptionsByIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSubscriptionsByIdCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSubscriptionsByIdCancelResponses,
    PatchAdminSubscriptionsByIdCancelErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/subscriptions/{id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Owner-only action to update tenant branding
 *
 * Owner-only action to update tenant branding
 */
export const patchAdminTenantsByIdBranding = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminTenantsByIdBrandingData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTenantsByIdBrandingResponses,
    PatchAdminTenantsByIdBrandingErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}/branding",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Revoke an API key, setting its status to :revoked and recording the revocation
 * timestamp
 *
 * Revoke an API key, setting its status to :revoked and recording the revocation
 * timestamp. Triggers smart credit reclaim: any unspent credits allocated to this
 * key are returned to the App Treasury or Tenant Wallet. Invalidates the Redis
 * auth cache. Revoked keys cannot be re-activated; rotate to issue a replacement.
 *
 */
export const patchAdminApiKeysByIdRevoke = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminApiKeysByIdRevokeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminApiKeysByIdRevokeResponses,
    PatchAdminApiKeysByIdRevokeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/api-keys/{id}/revoke",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Transition extraction_status (used by worker and admin).
 *
 * Transition extraction_status (used by worker and admin).
 */
export const patchAdminClinicalDocumentsByIdTransitionStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalDocumentsByIdTransitionStatusData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalDocumentsByIdTransitionStatusResponses,
    PatchAdminClinicalDocumentsByIdTransitionStatusErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/documents/{id}/transition-status",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-resources/catalog/:id operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/catalog/:id operation on clinical-practice-resource resource
 */
export const getAdminClinicalPracticeResourcesCatalogById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalPracticeResourcesCatalogByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeResourcesCatalogByIdResponses,
    GetAdminClinicalPracticeResourcesCatalogByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/catalog/{id}",
    ...options,
  });

/**
 * /clinical/practice-resources/catalog/:id operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/catalog/:id operation on clinical-practice-resource resource
 */
export const patchAdminClinicalPracticeResourcesCatalogById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalPracticeResourcesCatalogByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPracticeResourcesCatalogByIdResponses,
    PatchAdminClinicalPracticeResourcesCatalogByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/catalog/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/notes operation on clinical-note resource
 *
 * /clinical/notes operation on clinical-note resource
 */
export const getAdminClinicalNotes = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminClinicalNotesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNotesResponses,
    GetAdminClinicalNotesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes",
    ...options,
  });

/**
 * /clinical/notes operation on clinical-note resource
 *
 * /clinical/notes operation on clinical-note resource
 */
export const postAdminClinicalNotes = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminClinicalNotesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalNotesResponses,
    PostAdminClinicalNotesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /review-queue-memberships/:id operation on review-queue-membership resource
 *
 * /review-queue-memberships/:id operation on review-queue-membership resource
 */
export const deleteAdminReviewQueueMembershipsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminReviewQueueMembershipsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminReviewQueueMembershipsByIdResponses,
    DeleteAdminReviewQueueMembershipsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/review-queue-memberships/{id}",
    ...options,
  });

/**
 * /review-queue-memberships/:id operation on review-queue-membership resource
 *
 * /review-queue-memberships/:id operation on review-queue-membership resource
 */
export const getAdminReviewQueueMembershipsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminReviewQueueMembershipsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminReviewQueueMembershipsByIdResponses,
    GetAdminReviewQueueMembershipsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/review-queue-memberships/{id}",
    ...options,
  });

/**
 * /campaigns/sequence-steps/:id operation on email-marketing-sequence-step resource
 *
 * /campaigns/sequence-steps/:id operation on email-marketing-sequence-step resource
 */
export const deleteAdminCampaignsSequenceStepsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCampaignsSequenceStepsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCampaignsSequenceStepsByIdResponses,
    DeleteAdminCampaignsSequenceStepsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequence-steps/{id}",
    ...options,
  });

/**
 * /campaigns/sequence-steps/:id operation on email-marketing-sequence-step resource
 *
 * /campaigns/sequence-steps/:id operation on email-marketing-sequence-step resource
 */
export const getAdminCampaignsSequenceStepsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCampaignsSequenceStepsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCampaignsSequenceStepsByIdResponses,
    GetAdminCampaignsSequenceStepsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequence-steps/{id}",
    ...options,
  });

/**
 * /campaigns/sequence-steps/:id operation on email-marketing-sequence-step resource
 *
 * /campaigns/sequence-steps/:id operation on email-marketing-sequence-step resource
 */
export const patchAdminCampaignsSequenceStepsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCampaignsSequenceStepsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCampaignsSequenceStepsByIdResponses,
    PatchAdminCampaignsSequenceStepsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/campaigns/sequence-steps/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Find all Entity vertices with an exact label match; use to look up a specific named entity in the knowledge graph.
 *
 * Find all Entity vertices with an exact label match; use to look up a specific named entity in the knowledge graph.
 */
export const getAdminAiGraphNodesLabelByLabel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAiGraphNodesLabelByLabelData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAiGraphNodesLabelByLabelResponses,
    GetAdminAiGraphNodesLabelByLabelErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/graph/nodes/label/{label}",
    ...options,
  });

/**
 * /clinical/patients/:id/goals operation on clinical-client-goal resource
 *
 * /clinical/patients/:id/goals operation on clinical-client-goal resource
 */
export const getAdminClinicalPatientsByIdGoals = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPatientsByIdGoalsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPatientsByIdGoalsResponses,
    GetAdminClinicalPatientsByIdGoalsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patients/{id}/goals",
    ...options,
  });

/**
 * /recipes/:id/restore operation on recipes-recipe resource
 *
 * /recipes/:id/restore operation on recipes-recipe resource
 */
export const patchAdminRecipesByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminRecipesByIdRestoreData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesByIdRestoreResponses,
    PatchAdminRecipesByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/news-monitors/:id/pause operation on news-monitor resource
 *
 * /crawler/news-monitors/:id/pause operation on news-monitor resource
 */
export const patchAdminCrawlerNewsMonitorsByIdPause = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrawlerNewsMonitorsByIdPauseData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrawlerNewsMonitorsByIdPauseResponses,
    PatchAdminCrawlerNewsMonitorsByIdPauseErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/news-monitors/{id}/pause",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /sys/ai-config operation on ai-config resource
 *
 * /sys/ai-config operation on ai-config resource
 */
export const getAdminSysAiConfig = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSysAiConfigData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSysAiConfigResponses,
    GetAdminSysAiConfigErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/sys/ai-config",
    ...options,
  });

/**
 * Upsert a provider config record; if a record with the same id already exists, its fields are updated
 *
 * Upsert a provider config record; if a record with the same id already exists, its fields are updated. Use id='global' for platform defaults or id='app:<application_id>' for per-application overrides.
 */
export const postAdminSysAiConfig = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSysAiConfigData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSysAiConfigResponses,
    PostAdminSysAiConfigErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/sys/ai-config",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /ledger operation on ledger resource
 *
 * /ledger operation on ledger resource
 */
export const getAdminLedger = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminLedgerData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLedgerResponses,
    GetAdminLedgerErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ledger",
    ...options,
  });

/**
 * Get the current user's profile
 *
 * Get the current user's profile
 */
export const getAdminUserProfilesMe = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUserProfilesMeData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUserProfilesMeResponses,
    GetAdminUserProfilesMeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/user-profiles/me",
    ...options,
  });

/**
 * /invoices/payments operation on invoices-payment resource
 *
 * /invoices/payments operation on invoices-payment resource
 */
export const postAdminInvoicesPayments = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminInvoicesPaymentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminInvoicesPaymentsResponses,
    PostAdminInvoicesPaymentsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/payments",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/contacts/workspace/:workspace_id operation on invoices-contact resource
 *
 * /invoices/contacts/workspace/:workspace_id operation on invoices-contact resource
 */
export const getAdminInvoicesContactsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminInvoicesContactsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminInvoicesContactsWorkspaceByWorkspaceIdResponses,
    GetAdminInvoicesContactsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/contacts/workspace/{workspace_id}",
    ...options,
  });

/**
 * /form-generations operation on form-generation-job resource
 *
 * /form-generations operation on form-generation-job resource
 */
export const getAdminFormGenerations = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminFormGenerationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFormGenerationsResponses,
    GetAdminFormGenerationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-generations",
    ...options,
  });

/**
 * /form-generations operation on form-generation-job resource
 *
 * /form-generations operation on form-generation-job resource
 */
export const postAdminFormGenerations = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminFormGenerationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminFormGenerationsResponses,
    PostAdminFormGenerationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-generations",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List active taxonomies for an application
 *
 * List active taxonomies for an application. Returns a paginated list of classification axes.
 */
export const getAdminCatalogTaxonomiesApplicationByApplicationId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogTaxonomiesApplicationByApplicationIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogTaxonomiesApplicationByApplicationIdResponses,
    GetAdminCatalogTaxonomiesApplicationByApplicationIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/taxonomies/application/{application_id}",
    ...options,
  });

/**
 * /system-messages operation on system-message resource
 *
 * /system-messages operation on system-message resource
 */
export const getAdminSystemMessages = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSystemMessagesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSystemMessagesResponses,
    GetAdminSystemMessagesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/system-messages",
    ...options,
  });

/**
 * Create a new platform-wide system message (ToS, privacy policy, welcome, or announcement)
 *
 * Create a new platform-wide system message (ToS, privacy policy, welcome, or announcement). If `is_active` is true at creation time, `published_at` is automatically set. Only platform admins can successfully create records; all other actors are denied by policy.
 */
export const postAdminSystemMessages = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSystemMessagesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSystemMessagesResponses,
    PostAdminSystemMessagesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/system-messages",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/:id operation on invoices-invoice resource
 *
 * /invoices/:id operation on invoices-invoice resource
 */
export const deleteAdminInvoicesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminInvoicesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminInvoicesByIdResponses,
    DeleteAdminInvoicesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}",
    ...options,
  });

/**
 * /invoices/:id operation on invoices-invoice resource
 *
 * /invoices/:id operation on invoices-invoice resource
 */
export const getAdminInvoicesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminInvoicesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminInvoicesByIdResponses,
    GetAdminInvoicesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}",
    ...options,
  });

/**
 * /invoices/:id operation on invoices-invoice resource
 *
 * /invoices/:id operation on invoices-invoice resource
 */
export const patchAdminInvoicesById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminInvoicesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesByIdResponses,
    PatchAdminInvoicesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/inbound-addresses/workspace/:workspace_id operation on email-inbound-address resource
 *
 * /email/inbound-addresses/workspace/:workspace_id operation on email-inbound-address resource
 */
export const getAdminEmailInboundAddressesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailInboundAddressesWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailInboundAddressesWorkspaceByWorkspaceIdResponses,
    GetAdminEmailInboundAddressesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inbound-addresses/workspace/{workspace_id}",
    ...options,
  });

/**
 * Unlink an OAuth provider from a user
 *
 * Unlink an OAuth provider from a user. Destroys all
 * `GptCore.Identity.UserIdentity` rows matching (user_id, strategy). Emits
 * `identity.oauth.unlinked` only if the row destroy succeeded.
 *
 */
export const patchAdminUsersAuthOauthUnlink = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminUsersAuthOauthUnlinkData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminUsersAuthOauthUnlinkResponses,
    PatchAdminUsersAuthOauthUnlinkErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/auth/oauth/unlink",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /disclosure-logs operation on disclosure-log resource
 *
 * /disclosure-logs operation on disclosure-log resource
 */
export const getAdminDisclosureLogs = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminDisclosureLogsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminDisclosureLogsResponses,
    GetAdminDisclosureLogsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/disclosure-logs",
    ...options,
  });

/**
 * /disclosure-logs operation on disclosure-log resource
 *
 * /disclosure-logs operation on disclosure-log resource
 */
export const postAdminDisclosureLogs = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminDisclosureLogsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminDisclosureLogsResponses,
    PostAdminDisclosureLogsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/disclosure-logs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/intake-targets/:id/permanent operation on clinical-intake-target resource
 *
 * /clinical/intake-targets/:id/permanent operation on clinical-intake-target resource
 */
export const deleteAdminClinicalIntakeTargetsByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalIntakeTargetsByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalIntakeTargetsByIdPermanentResponses,
    DeleteAdminClinicalIntakeTargetsByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/intake-targets/{id}/permanent",
    ...options,
  });

/**
 * Add a message to a ticket thread
 *
 * Add a message to a ticket thread. sender_type distinguishes :customer, :agent, :ai (AI draft), and :system (automated) messages. is_internal_note: true creates an agent-only note not shown to the customer. Publishes MessageReceived event — triggers DraftReplyWorker for :customer messages in human_first queues.
 */
export const postAdminSupportTicketMessages = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSupportTicketMessagesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSupportTicketMessagesResponses,
    PostAdminSupportTicketMessagesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/ticket-messages",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/phone-numbers/:id operation on crm-phone-number resource
 *
 * /crm/phone-numbers/:id operation on crm-phone-number resource
 */
export const deleteAdminCrmPhoneNumbersById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmPhoneNumbersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmPhoneNumbersByIdResponses,
    DeleteAdminCrmPhoneNumbersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/phone-numbers/{id}",
    ...options,
  });

/**
 * /crm/phone-numbers/:id operation on crm-phone-number resource
 *
 * /crm/phone-numbers/:id operation on crm-phone-number resource
 */
export const getAdminCrmPhoneNumbersById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrmPhoneNumbersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmPhoneNumbersByIdResponses,
    GetAdminCrmPhoneNumbersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/phone-numbers/{id}",
    ...options,
  });

/**
 * /crm/phone-numbers/:id operation on crm-phone-number resource
 *
 * /crm/phone-numbers/:id operation on crm-phone-number resource
 */
export const patchAdminCrmPhoneNumbersById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmPhoneNumbersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmPhoneNumbersByIdResponses,
    PatchAdminCrmPhoneNumbersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/phone-numbers/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Reopen a decided case back to under_review.
 *
 * Reopen a decided case back to under_review.
 */
export const patchAdminCasesByIdReopen = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminCasesByIdReopenData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCasesByIdReopenResponses,
    PatchAdminCasesByIdReopenErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cases/{id}/reopen",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List or fetch buckets; excludes processing-type buckets by default
 *
 * List or fetch buckets; excludes processing-type buckets by default. Use read_all to include system buckets.
 */
export const getAdminBuckets = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminBucketsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBucketsResponses,
    GetAdminBucketsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/buckets",
    ...options,
  });

/**
 * Create a bucket record and provision it in object storage (GCS in prod, MinIO in dev); sets lifecycle rules and public policy if type is :public
 *
 * Create a bucket record and provision it in object storage (GCS in prod, MinIO in dev); sets lifecycle rules and public policy if type is :public. Returns the created bucket.
 */
export const postAdminBuckets = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminBucketsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminBucketsResponses,
    PostAdminBucketsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/buckets",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /form-versions/:id/propose-rule operation on form-version resource
 *
 * /form-versions/:id/propose-rule operation on form-version resource
 */
export const postAdminFormVersionsByIdProposeRule = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminFormVersionsByIdProposeRuleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminFormVersionsByIdProposeRuleResponses,
    PostAdminFormVersionsByIdProposeRuleErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-versions/{id}/propose-rule",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /data-subject-requests/:id operation on data-subject-request resource
 *
 * /data-subject-requests/:id operation on data-subject-request resource
 */
export const getAdminDataSubjectRequestsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminDataSubjectRequestsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminDataSubjectRequestsByIdResponses,
    GetAdminDataSubjectRequestsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/data-subject-requests/{id}",
    ...options,
  });

/**
 * Check Meilisearch server health, returning status and latency
 *
 * Check Meilisearch server health, returning status and latency. Use this for monitoring and readiness checks; returns `{status: 'available', latency_ms: N}` on success.
 */
export const getAdminSearchHealth = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSearchHealthData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSearchHealthResponses,
    GetAdminSearchHealthErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/health",
    ...options,
  });

/**
 * /data-transfer-records operation on data-transfer-record resource
 *
 * /data-transfer-records operation on data-transfer-record resource
 */
export const getAdminDataTransferRecords = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminDataTransferRecordsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminDataTransferRecordsResponses,
    GetAdminDataTransferRecordsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/data-transfer-records",
    ...options,
  });

/**
 * Log a cross-border personal data transfer per GDPR Chapter V, specifying the source and destination ISO country codes, the legal transfer mechanism (SCC, BCR, adequacy decision, derogation, or consent), and the data categories involved.
 *
 * Log a cross-border personal data transfer per GDPR Chapter V, specifying the source and destination ISO country codes, the legal transfer mechanism (SCC, BCR, adequacy decision, derogation, or consent), and the data categories involved.
 */
export const postAdminDataTransferRecords = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminDataTransferRecordsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminDataTransferRecordsResponses,
    PostAdminDataTransferRecordsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/data-transfer-records",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-resource-assignments/:id/archive operation on clinical-client-resource-assignment resource
 *
 * /clinical/client-resource-assignments/:id/archive operation on clinical-client-resource-assignment resource
 */
export const patchAdminClinicalClientResourceAssignmentsByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalClientResourceAssignmentsByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientResourceAssignmentsByIdArchiveResponses,
    PatchAdminClinicalClientResourceAssignmentsByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-resource-assignments/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /invoices/:id/void operation on invoices-invoice resource
 *
 * /invoices/:id/void operation on invoices-invoice resource
 */
export const patchAdminInvoicesByIdVoid = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesByIdVoidData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesByIdVoidResponses,
    PatchAdminInvoicesByIdVoidErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/{id}/void",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all routing rules for an application, sorted by priority ascending (lower first)
 *
 * List all routing rules for an application, sorted by priority ascending (lower first). Use to display and manage the routing rule evaluation order.
 */
export const getAdminSupportRoutingRulesApplicationByApplicationId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSupportRoutingRulesApplicationByApplicationIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSupportRoutingRulesApplicationByApplicationIdResponses,
    GetAdminSupportRoutingRulesApplicationByApplicationIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/routing-rules/application/{application_id}",
    ...options,
  });

/**
 * Search the Fullscript product catalog
 *
 * Search the Fullscript product catalog
 */
export const postAdminConnectorsFullscriptProductsSearch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsFullscriptProductsSearchData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsFullscriptProductsSearchResponses,
    PostAdminConnectorsFullscriptProductsSearchErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/fullscript/products/search",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Stateless MJML → HTML compilation
 *
 * Stateless MJML → HTML compilation. Does not save. Returns %{html, variables, errors}.
 */
export const postAdminEmailMarketingTemplatesCompile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminEmailMarketingTemplatesCompileData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminEmailMarketingTemplatesCompileResponses,
    PostAdminEmailMarketingTemplatesCompileErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/templates/compile",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Preview adapted copy per platform without creating SocialPost records.
 *
 * Preview adapted copy per platform without creating SocialPost records.
 */
export const postAdminSocialCampaignsByIdPreviewAdaptations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminSocialCampaignsByIdPreviewAdaptationsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminSocialCampaignsByIdPreviewAdaptationsResponses,
    PostAdminSocialCampaignsByIdPreviewAdaptationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/campaigns/{id}/preview-adaptations",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/notes/archived operation on clinical-note resource
 *
 * /clinical/notes/archived operation on clinical-note resource
 */
export const getAdminClinicalNotesArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalNotesArchivedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNotesArchivedResponses,
    GetAdminClinicalNotesArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes/archived",
    ...options,
  });

/**
 * /case-entity-links operation on case-entity-link resource
 *
 * /case-entity-links operation on case-entity-link resource
 */
export const getAdminCaseEntityLinks = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCaseEntityLinksData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCaseEntityLinksResponses,
    GetAdminCaseEntityLinksErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-entity-links",
    ...options,
  });

/**
 * /case-entity-links operation on case-entity-link resource
 *
 * /case-entity-links operation on case-entity-link resource
 */
export const postAdminCaseEntityLinks = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCaseEntityLinksData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCaseEntityLinksResponses,
    PostAdminCaseEntityLinksErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-entity-links",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-tools/catalog operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/catalog operation on clinical-practice-tool resource
 */
export const getAdminClinicalPracticeToolsCatalog = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPracticeToolsCatalogData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeToolsCatalogResponses,
    GetAdminClinicalPracticeToolsCatalogErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/catalog",
    ...options,
  });

/**
 * /clinical/practice-tools/catalog operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/catalog operation on clinical-practice-tool resource
 */
export const postAdminClinicalPracticeToolsCatalog = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalPracticeToolsCatalogData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalPracticeToolsCatalogResponses,
    PostAdminClinicalPracticeToolsCatalogErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/catalog",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Assign a case owner.
 *
 * Assign a case owner.
 */
export const patchAdminCasesByIdAssignOwner = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCasesByIdAssignOwnerData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCasesByIdAssignOwnerResponses,
    PatchAdminCasesByIdAssignOwnerErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cases/{id}/assign-owner",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get order details from Fullscript
 *
 * Get order details from Fullscript
 */
export const postAdminConnectorsFullscriptOrdersGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminConnectorsFullscriptOrdersGetData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsFullscriptOrdersGetResponses,
    PostAdminConnectorsFullscriptOrdersGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/fullscript/orders/get",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Accept an invitation using either the long token or short code
 *
 * Accept an invitation using either the long token or short code
 */
export const postAdminInvitationsAcceptByToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminInvitationsAcceptByTokenData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminInvitationsAcceptByTokenResponses,
    PostAdminInvitationsAcceptByTokenErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invitations/accept-by-token",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Generate a cryptographically secure 6-digit verification code, store it as `verification_token`, record `verification_sent_at`, and dispatch delivery to the configured channel.
 *
 * Generate a cryptographically secure 6-digit verification code, store it as `verification_token`, record `verification_sent_at`, and dispatch delivery to the configured channel.
 */
export const patchAdminNotificationMethodsByIdSendVerification = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminNotificationMethodsByIdSendVerificationData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminNotificationMethodsByIdSendVerificationResponses,
    PatchAdminNotificationMethodsByIdSendVerificationErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-methods/{id}/send-verification",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/jobs/:id operation on crawler-job resource
 *
 * /crawler/jobs/:id operation on crawler-job resource
 */
export const deleteAdminCrawlerJobsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrawlerJobsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrawlerJobsByIdResponses,
    DeleteAdminCrawlerJobsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/jobs/{id}",
    ...options,
  });

/**
 * /crawler/jobs/:id operation on crawler-job resource
 *
 * /crawler/jobs/:id operation on crawler-job resource
 */
export const getAdminCrawlerJobsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCrawlerJobsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerJobsByIdResponses,
    GetAdminCrawlerJobsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/jobs/{id}",
    ...options,
  });

/**
 * /support/queue-members/:id operation on support-queue-member resource
 *
 * /support/queue-members/:id operation on support-queue-member resource
 */
export const deleteAdminSupportQueueMembersById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSupportQueueMembersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSupportQueueMembersByIdResponses,
    DeleteAdminSupportQueueMembersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/queue-members/{id}",
    ...options,
  });

/**
 * Update a queue member's role, ticket capacity, or availability status
 *
 * Update a queue member's role, ticket capacity, or availability status. Use is_available: false to mark an agent as offline without removing them from the queue.
 */
export const patchAdminSupportQueueMembersById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSupportQueueMembersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSupportQueueMembersByIdResponses,
    PatchAdminSupportQueueMembersByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/queue-members/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Mark a confirmed event as completed
 *
 * Mark a confirmed event as completed. Called by CompletionWorker after event end time + buffer. Logs CRM activity for participants with contact_id (if CRM capability enabled). Publishes EventCompleted event.
 */
export const patchAdminSchedulingEventsByIdComplete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSchedulingEventsByIdCompleteData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingEventsByIdCompleteResponses,
    PatchAdminSchedulingEventsByIdCompleteErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/events/{id}/complete",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /connectors/:id operation on connector-instance resource
 *
 * /connectors/:id operation on connector-instance resource
 */
export const deleteAdminConnectorsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminConnectorsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminConnectorsByIdResponses,
    DeleteAdminConnectorsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/{id}",
    ...options,
  });

/**
 * /connectors/:id operation on connector-instance resource
 *
 * /connectors/:id operation on connector-instance resource
 */
export const getAdminConnectorsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminConnectorsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminConnectorsByIdResponses,
    GetAdminConnectorsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/{id}",
    ...options,
  });

/**
 * Update a connector instance's name, configuration, sync interval, health status, or metadata
 *
 * Update a connector instance's name, configuration, sync interval, health status, or metadata.
 * Use this to modify the connector's connection config after installation (e.g., changing sync
 * frequency or updating API base URL). Does not affect stored credentials or tool definitions.
 *
 * Returns the updated connector instance record.
 *
 */
export const patchAdminConnectorsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminConnectorsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminConnectorsByIdResponses,
    PatchAdminConnectorsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Shorten text to a target character count.
 *
 * Shorten text to a target character count.
 */
export const postAdminContentShorten = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminContentShortenData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminContentShortenResponses,
    PostAdminContentShortenErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/content/shorten",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /compliance-officer-designations/:id operation on compliance-officer-designation resource
 *
 * /compliance-officer-designations/:id operation on compliance-officer-designation resource
 */
export const getAdminComplianceOfficerDesignationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminComplianceOfficerDesignationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminComplianceOfficerDesignationsByIdResponses,
    GetAdminComplianceOfficerDesignationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-officer-designations/{id}",
    ...options,
  });

/**
 * /ephi-assets operation on ephi-asset resource
 *
 * /ephi-assets operation on ephi-asset resource
 */
export const getAdminEphiAssets = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminEphiAssetsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEphiAssetsResponses,
    GetAdminEphiAssetsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ephi-assets",
    ...options,
  });

/**
 * /ephi-assets operation on ephi-asset resource
 *
 * /ephi-assets operation on ephi-asset resource
 */
export const postAdminEphiAssets = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminEphiAssetsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminEphiAssetsResponses,
    PostAdminEphiAssetsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ephi-assets",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a quote request
 *
 * Create a quote request. Used directly by ISVs and by
 * `GptCore.Invoices.FormBindings` when a form submission carries
 * line-item shaped fields. Bindings rely on a read-then-create
 * pre-check (in the GenServer's serial mailbox) for idempotency
 * against re-broadcast `SubmissionCompleted` events; the unique
 * index on `submitted_via_submission_id` is the safety net.
 *
 */
export const postAdminQuoteRequests = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminQuoteRequestsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminQuoteRequestsResponses,
    PostAdminQuoteRequestsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/quote-requests",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List subscriptions in `:capability_revoked_grace` (awaiting period-end
 * cancellation) or `:canceled_capability_revoked` (already canceled due to
 * a revoked capability)
 *
 * List subscriptions in `:capability_revoked_grace` (awaiting period-end
 * cancellation) or `:canceled_capability_revoked` (already canceled due to
 * a revoked capability). Platform-admin only.
 *
 * Optional filters via query params:
 * - `filter[application_id]` — scope to subscriptions whose plan belongs to
 * a specific Application.
 * - `filter[revoked_capability]` — scope to a specific revoked capability.
 * - `filter[include_canceled]=true` — include `:canceled_capability_revoked`
 * subscriptions (default: grace-only).
 *
 */
export const getAdminSubscriptionsCapabilityRevoked = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSubscriptionsCapabilityRevokedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSubscriptionsCapabilityRevokedResponses,
    GetAdminSubscriptionsCapabilityRevokedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/subscriptions/capability-revoked",
    ...options,
  });

/**
 * /quote-requests/:id operation on invoices-quote-request resource
 *
 * /quote-requests/:id operation on invoices-quote-request resource
 */
export const deleteAdminQuoteRequestsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminQuoteRequestsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminQuoteRequestsByIdResponses,
    DeleteAdminQuoteRequestsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/quote-requests/{id}",
    ...options,
  });

/**
 * Fetch a single quote request by ID.
 *
 * Fetch a single quote request by ID.
 */
export const getAdminQuoteRequestsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminQuoteRequestsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminQuoteRequestsByIdResponses,
    GetAdminQuoteRequestsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/quote-requests/{id}",
    ...options,
  });

/**
 * Update an existing quote request
 *
 * Update an existing quote request. Status transitions are open
 * (no state machine in this slice — ISVs gate via their own UI).
 *
 */
export const patchAdminQuoteRequestsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminQuoteRequestsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminQuoteRequestsByIdResponses,
    PatchAdminQuoteRequestsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/quote-requests/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch the channel capture configuration for a workspace
 *
 * Fetch the channel capture configuration for a workspace. Returns nil if no config exists — IngestChannelMessageWorker treats absent config as capture disabled.
 */
export const getAdminSupportChannelCaptureConfigsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSupportChannelCaptureConfigsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSupportChannelCaptureConfigsWorkspaceByWorkspaceIdResponses,
    GetAdminSupportChannelCaptureConfigsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/channel-capture-configs/workspace/{workspace_id}",
    ...options,
  });

/**
 * Set multiple delivery records to `:retrying` status in bulk
 *
 * Set multiple delivery records to `:retrying` status in bulk. Authorization is actor-scoped — only deliveries the actor can update are affected. Returns `{success: true, count: N}`.
 */
export const postAdminWebhookDeliveriesBulkRetry = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminWebhookDeliveriesBulkRetryData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminWebhookDeliveriesBulkRetryResponses,
    PostAdminWebhookDeliveriesBulkRetryErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-deliveries/bulk-retry",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch the AI configuration for a specific workspace
 *
 * Fetch the AI configuration for a specific workspace. Returns nil if no config exists — workers fall back to defaults in that case.
 */
export const getAdminSupportAiConfigsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSupportAiConfigsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSupportAiConfigsWorkspaceByWorkspaceIdResponses,
    GetAdminSupportAiConfigsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/ai-configs/workspace/{workspace_id}",
    ...options,
  });

/**
 * Sync patients from Healthie connector to platform
 *
 * Sync patients from Healthie connector to platform.
 *
 * Creates/updates: Contact, DietaryProfile, HealthMetric, Patient records.
 * Returns sync summary with count and errors.
 *
 */
export const postAdminConnectorsByIdHealthiePatientsSync = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsByIdHealthiePatientsSyncData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsByIdHealthiePatientsSyncResponses,
    PostAdminConnectorsByIdHealthiePatientsSyncErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/{id}/healthie/patients/sync",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Dismiss a trained document from the active-learning training dashboard without excluding it
 * from future training
 *
 * Dismiss a trained document from the active-learning training dashboard without excluding it
 * from future training. Sets `training_metadata["dismissed_at"]` so the document no longer
 * appears in the `:list_trained` view, but it can still be found via `:read` or `:list_by_workspace`.
 *
 * Use `:mark_trained` to record that a document was trained, or `:exclude_from_training` to
 * prevent it from being used for training entirely.
 *
 */
export const patchAdminExtractionDocumentsByIdDismissTraining = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminExtractionDocumentsByIdDismissTrainingData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionDocumentsByIdDismissTrainingResponses,
    PatchAdminExtractionDocumentsByIdDismissTrainingErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}/dismiss-training",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-goals/:id/archive operation on clinical-client-goal resource
 *
 * /clinical/client-goals/:id/archive operation on clinical-client-goal resource
 */
export const patchAdminClinicalClientGoalsByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalClientGoalsByIdArchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientGoalsByIdArchiveResponses,
    PatchAdminClinicalClientGoalsByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-goals/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Bulk-destroy all semantic cache entries (platform admin only); requires confirm: true as a safety gate
 *
 * Bulk-destroy all semantic cache entries (platform admin only); requires confirm: true as a safety gate. Returns a dummy struct on success.
 */
export const postAdminSysSemanticCacheClear = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSysSemanticCacheClearData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSysSemanticCacheClearResponses,
    PostAdminSysSemanticCacheClearErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/sys/semantic-cache/clear",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Check if a patient exists in Fullscript by email
 *
 * Check if a patient exists in Fullscript by email
 */
export const postAdminConnectorsFullscriptCheckPatient = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminConnectorsFullscriptCheckPatientData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsFullscriptCheckPatientResponses,
    PostAdminConnectorsFullscriptCheckPatientErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/fullscript/check-patient",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Restores body_mjml from a previously published TemplateVersion snapshot.
 *
 * Restores body_mjml from a previously published TemplateVersion snapshot.
 */
export const patchAdminEmailMarketingTemplatesByIdRollback = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailMarketingTemplatesByIdRollbackData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingTemplatesByIdRollbackResponses,
    PatchAdminEmailMarketingTemplatesByIdRollbackErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/templates/{id}/rollback",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /notification-methods operation on notification-method resource
 *
 * /notification-methods operation on notification-method resource
 */
export const getAdminNotificationMethods = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminNotificationMethodsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminNotificationMethodsResponses,
    GetAdminNotificationMethodsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-methods",
    ...options,
  });

/**
 * Register a new notification delivery channel for a user (email address, phone number, Slack webhook, or generic webhook URL)
 *
 * Register a new notification delivery channel for a user (email address, phone number, Slack webhook, or generic webhook URL). The method starts unverified; call :send_verification then :verify to activate it.
 */
export const postAdminNotificationMethods = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminNotificationMethodsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminNotificationMethodsResponses,
    PostAdminNotificationMethodsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/notification-methods",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/trending/watches/workspace/:workspace_id operation on trending-watch resource
 *
 * /social/trending/watches/workspace/:workspace_id operation on trending-watch resource
 */
export const getAdminSocialTrendingWatchesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSocialTrendingWatchesWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSocialTrendingWatchesWorkspaceByWorkspaceIdResponses,
    GetAdminSocialTrendingWatchesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/trending/watches/workspace/{workspace_id}",
    ...options,
  });

/**
 * List all schema versions for this agent
 *
 * List all schema versions for this agent
 */
export const getAdminAgentsByIdSchemaVersions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAgentsByIdSchemaVersionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentsByIdSchemaVersionsResponses,
    GetAdminAgentsByIdSchemaVersionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/schema-versions",
    ...options,
  });

/**
 * Create a new schema version for this agent
 *
 * Create a new schema version for this agent
 */
export const postAdminAgentsByIdSchemaVersions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminAgentsByIdSchemaVersionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentsByIdSchemaVersionsResponses,
    PostAdminAgentsByIdSchemaVersionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/schema-versions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /plan-feature-allocations/:id operation on plan-feature-allocation resource
 *
 * /plan-feature-allocations/:id operation on plan-feature-allocation resource
 */
export const deleteAdminPlanFeatureAllocationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminPlanFeatureAllocationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminPlanFeatureAllocationsByIdResponses,
    DeleteAdminPlanFeatureAllocationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plan-feature-allocations/{id}",
    ...options,
  });

/**
 * Fetch a single plan feature allocation by ID.
 *
 * Fetch a single plan feature allocation by ID.
 */
export const getAdminPlanFeatureAllocationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPlanFeatureAllocationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPlanFeatureAllocationsByIdResponses,
    GetAdminPlanFeatureAllocationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plan-feature-allocations/{id}",
    ...options,
  });

/**
 * Update a plan feature allocation's overrides.
 *
 * Update a plan feature allocation's overrides.
 */
export const patchAdminPlanFeatureAllocationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPlanFeatureAllocationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPlanFeatureAllocationsByIdResponses,
    PatchAdminPlanFeatureAllocationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plan-feature-allocations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List excluded documents
 *
 * List excluded documents
 */
export const getAdminExtractionDocumentsWorkspaceByWorkspaceIdExcluded = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdExcludedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdExcludedResponses,
    GetAdminExtractionDocumentsWorkspaceByWorkspaceIdExcludedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/workspace/{workspace_id}/excluded",
    ...options,
  });

/**
 * /brand-identities/by-tenant/:tenant_id operation on brand-identity resource
 *
 * /brand-identities/by-tenant/:tenant_id operation on brand-identity resource
 */
export const getAdminBrandIdentitiesByTenantByTenantId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminBrandIdentitiesByTenantByTenantIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBrandIdentitiesByTenantByTenantIdResponses,
    GetAdminBrandIdentitiesByTenantByTenantIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/brand-identities/by-tenant/{tenant_id}",
    ...options,
  });

/**
 * /recipes/recipe-nutritions operation on recipes-recipe-nutrition resource
 *
 * /recipes/recipe-nutritions operation on recipes-recipe-nutrition resource
 */
export const postAdminRecipesRecipeNutritions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminRecipesRecipeNutritionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesRecipeNutritionsResponses,
    PostAdminRecipesRecipeNutritionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/recipe-nutritions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List active custom entities in a workspace, optionally filtered by type slug and
 * attribute-level property filters
 *
 * List active custom entities in a workspace, optionally filtered by type slug and
 * attribute-level property filters. Filters are applied Elixir-side on the properties
 * JSONB field after fetch.
 *
 */
export const getAdminCrmCustomEntitiesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmCustomEntitiesWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmCustomEntitiesWorkspaceByWorkspaceIdResponses,
    GetAdminCrmCustomEntitiesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/custom-entities/workspace/{workspace_id}",
    ...options,
  });

/**
 * /social/campaigns/:id/schedule operation on social-campaign resource
 *
 * /social/campaigns/:id/schedule operation on social-campaign resource
 */
export const patchAdminSocialCampaignsByIdSchedule = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSocialCampaignsByIdScheduleData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialCampaignsByIdScheduleResponses,
    PatchAdminSocialCampaignsByIdScheduleErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/campaigns/{id}/schedule",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/note-templates/catalog operation on clinical-note-template resource
 *
 * /clinical/note-templates/catalog operation on clinical-note-template resource
 */
export const getAdminClinicalNoteTemplatesCatalog = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalNoteTemplatesCatalogData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalNoteTemplatesCatalogResponses,
    GetAdminClinicalNoteTemplatesCatalogErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/catalog",
    ...options,
  });

/**
 * /clinical/note-templates/catalog operation on clinical-note-template resource
 *
 * /clinical/note-templates/catalog operation on clinical-note-template resource
 */
export const postAdminClinicalNoteTemplatesCatalog = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalNoteTemplatesCatalogData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalNoteTemplatesCatalogResponses,
    PostAdminClinicalNoteTemplatesCatalogErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/note-templates/catalog",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Rotate an API key by generating a new token while preserving the key's id,
 * metadata, and configuration
 *
 * Rotate an API key by generating a new token while preserving the key's id,
 * metadata, and configuration. The new raw token is returned once in the
 * generated_api_key calculation field and cannot be retrieved again. Preserves
 * the existing prefix type (sk_tenant_, sk_app_, etc.) and ensures application
 * keys retain all scopes. Invalidates the Redis auth cache for the old token.
 * Use :revoke if the key should be permanently deactivated instead.
 *
 */
export const patchAdminApiKeysByIdRotate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminApiKeysByIdRotateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminApiKeysByIdRotateResponses,
    PatchAdminApiKeysByIdRotateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/api-keys/{id}/rotate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/ingredients operation on recipes-ingredient resource
 *
 * /recipes/ingredients operation on recipes-ingredient resource
 */
export const postAdminRecipesIngredients = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminRecipesIngredientsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesIngredientsResponses,
    PostAdminRecipesIngredientsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/ingredients",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/health-metrics/:id/archive operation on clinical-health-metric resource
 *
 * /clinical/health-metrics/:id/archive operation on clinical-health-metric resource
 */
export const patchAdminClinicalHealthMetricsByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalHealthMetricsByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalHealthMetricsByIdArchiveResponses,
    PatchAdminClinicalHealthMetricsByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/health-metrics/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/inclusions/:id operation on email-inclusion resource
 *
 * /email/inclusions/:id operation on email-inclusion resource
 */
export const deleteAdminEmailInclusionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminEmailInclusionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminEmailInclusionsByIdResponses,
    DeleteAdminEmailInclusionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inclusions/{id}",
    ...options,
  });

/**
 * /email/inclusions/:id operation on email-inclusion resource
 *
 * /email/inclusions/:id operation on email-inclusion resource
 */
export const getAdminEmailInclusionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminEmailInclusionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEmailInclusionsByIdResponses,
    GetAdminEmailInclusionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inclusions/{id}",
    ...options,
  });

/**
 * /email/inclusions/:id operation on email-inclusion resource
 *
 * /email/inclusions/:id operation on email-inclusion resource
 */
export const patchAdminEmailInclusionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminEmailInclusionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailInclusionsByIdResponses,
    PatchAdminEmailInclusionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inclusions/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/patients operation on clinical-patient resource
 *
 * /clinical/patients operation on clinical-patient resource
 */
export const getAdminClinicalPatients = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminClinicalPatientsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPatientsResponses,
    GetAdminClinicalPatientsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patients",
    ...options,
  });

/**
 * /clinical/patients operation on clinical-patient resource
 *
 * /clinical/patients operation on clinical-patient resource
 */
export const postAdminClinicalPatients = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminClinicalPatientsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalPatientsResponses,
    PostAdminClinicalPatientsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patients",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /usage-events/:id operation on usage-event resource
 *
 * /usage-events/:id operation on usage-event resource
 */
export const getAdminUsageEventsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUsageEventsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUsageEventsByIdResponses,
    GetAdminUsageEventsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/usage-events/{id}",
    ...options,
  });

/**
 * /clinical/practice-tools/catalog/:id/archive operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/catalog/:id/archive operation on clinical-practice-tool resource
 */
export const patchAdminClinicalPracticeToolsCatalogByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalPracticeToolsCatalogByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPracticeToolsCatalogByIdArchiveResponses,
    PatchAdminClinicalPracticeToolsCatalogByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/catalog/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/accounts/workspace/:workspace_id operation on social-account resource
 *
 * /social/accounts/workspace/:workspace_id operation on social-account resource
 */
export const getAdminSocialAccountsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSocialAccountsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSocialAccountsWorkspaceByWorkspaceIdResponses,
    GetAdminSocialAccountsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/accounts/workspace/{workspace_id}",
    ...options,
  });

/**
 * /clinical/intake-targets/active/:patient_id operation on clinical-intake-target resource
 *
 * /clinical/intake-targets/active/:patient_id operation on clinical-intake-target resource
 */
export const getAdminClinicalIntakeTargetsActiveByPatientId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalIntakeTargetsActiveByPatientIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalIntakeTargetsActiveByPatientIdResponses,
    GetAdminClinicalIntakeTargetsActiveByPatientIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/intake-targets/active/{patient_id}",
    ...options,
  });

/**
 * /cases/:id operation on case resource
 *
 * /cases/:id operation on case resource
 */
export const deleteAdminCasesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminCasesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCasesByIdResponses,
    DeleteAdminCasesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cases/{id}",
    ...options,
  });

/**
 * /cases/:id operation on case resource
 *
 * /cases/:id operation on case resource
 */
export const getAdminCasesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCasesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCasesByIdResponses,
    GetAdminCasesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cases/{id}",
    ...options,
  });

/**
 * /cases/:id operation on case resource
 *
 * /cases/:id operation on case resource
 */
export const patchAdminCasesById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminCasesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCasesByIdResponses,
    PatchAdminCasesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cases/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/trending/items/snapshot/:snapshot_id operation on trending-snapshot-item resource
 *
 * /social/trending/items/snapshot/:snapshot_id operation on trending-snapshot-item resource
 */
export const getAdminSocialTrendingItemsSnapshotBySnapshotId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSocialTrendingItemsSnapshotBySnapshotIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSocialTrendingItemsSnapshotBySnapshotIdResponses,
    GetAdminSocialTrendingItemsSnapshotBySnapshotIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/trending/items/snapshot/{snapshot_id}",
    ...options,
  });

/**
 * /clinical/goal-template-collection-memberships/:id operation on clinical-goal-template-collection-membership resource
 *
 * /clinical/goal-template-collection-memberships/:id operation on clinical-goal-template-collection-membership resource
 */
export const deleteAdminClinicalGoalTemplateCollectionMembershipsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalGoalTemplateCollectionMembershipsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalGoalTemplateCollectionMembershipsByIdResponses,
    DeleteAdminClinicalGoalTemplateCollectionMembershipsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-template-collection-memberships/{id}",
    ...options,
  });

/**
 * /clinical/goal-template-collection-memberships/:id operation on clinical-goal-template-collection-membership resource
 *
 * /clinical/goal-template-collection-memberships/:id operation on clinical-goal-template-collection-membership resource
 */
export const getAdminClinicalGoalTemplateCollectionMembershipsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalGoalTemplateCollectionMembershipsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalGoalTemplateCollectionMembershipsByIdResponses,
    GetAdminClinicalGoalTemplateCollectionMembershipsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-template-collection-memberships/{id}",
    ...options,
  });

/**
 * /clinical/goal-template-collection-memberships/:id operation on clinical-goal-template-collection-membership resource
 *
 * /clinical/goal-template-collection-memberships/:id operation on clinical-goal-template-collection-membership resource
 */
export const patchAdminClinicalGoalTemplateCollectionMembershipsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalGoalTemplateCollectionMembershipsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalGoalTemplateCollectionMembershipsByIdResponses,
    PatchAdminClinicalGoalTemplateCollectionMembershipsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-template-collection-memberships/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/deal-products operation on crm-deal-product resource
 *
 * /crm/deal-products operation on crm-deal-product resource
 */
export const getAdminCrmDealProducts = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCrmDealProductsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmDealProductsResponses,
    GetAdminCrmDealProductsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/deal-products",
    ...options,
  });

/**
 * Link a catalog product to a deal with quantity and negotiated unit price
 *
 * Link a catalog product to a deal with quantity and negotiated unit price. product_id is a weak UUID reference (no FK constraint). Returns the created DealProduct record.
 */
export const postAdminCrmDealProducts = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrmDealProductsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmDealProductsResponses,
    PostAdminCrmDealProductsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/deal-products",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /ai/graph/nodes/:id operation on graph-node resource
 *
 * /ai/graph/nodes/:id operation on graph-node resource
 */
export const deleteAdminAiGraphNodesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminAiGraphNodesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminAiGraphNodesByIdResponses,
    DeleteAdminAiGraphNodesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/graph/nodes/{id}",
    ...options,
  });

/**
 * Delete a bucket from the database and attempt to remove it from object storage; fails if any StorageFile records still reference this bucket.
 *
 * Delete a bucket from the database and attempt to remove it from object storage; fails if any StorageFile records still reference this bucket.
 */
export const deleteAdminBucketsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminBucketsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminBucketsByIdResponses,
    DeleteAdminBucketsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/buckets/{id}",
    ...options,
  });

/**
 * List or fetch buckets; excludes processing-type buckets by default
 *
 * List or fetch buckets; excludes processing-type buckets by default. Use read_all to include system buckets.
 */
export const getAdminBucketsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminBucketsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBucketsByIdResponses,
    GetAdminBucketsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/buckets/{id}",
    ...options,
  });

/**
 * Update the region of an existing bucket
 *
 * Update the region of an existing bucket. Returns the updated bucket.
 */
export const patchAdminBucketsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminBucketsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminBucketsByIdResponses,
    PatchAdminBucketsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/buckets/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Get Healthie connector sync status
 *
 * Get Healthie connector sync status.
 *
 * Returns last sync time, record counts, and errors from most recent sync.
 *
 */
export const getAdminConnectorsByIdHealthieStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminConnectorsByIdHealthieStatusData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminConnectorsByIdHealthieStatusResponses,
    GetAdminConnectorsByIdHealthieStatusErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/{id}/healthie/status",
    ...options,
  });

/**
 * Close this ticket by merging it with another ticket
 *
 * Close this ticket by merging it with another ticket. Validates that merged_ticket_id belongs to the same workspace. Stores merged_ticket_id in __metadata__ for Notifier. The secondary ticket is NOT automatically closed — callers must close it separately.
 */
export const patchAdminSupportTicketsByIdMerge = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSupportTicketsByIdMergeData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSupportTicketsByIdMergeResponses,
    PatchAdminSupportTicketsByIdMergeErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/tickets/{id}/merge",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch the most recent acceptance record for a given user and document type
 *
 * Fetch the most recent acceptance record for a given user and document type. Use this to check whether a user has accepted the current version of a ToS or Privacy Policy before gating access.
 */
export const getAdminLegalAcceptancesLatest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminLegalAcceptancesLatestData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLegalAcceptancesLatestResponses,
    GetAdminLegalAcceptancesLatestErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/legal-acceptances/latest",
    ...options,
  });

/**
 * List usage events for a specific user within a date range
 *
 * List usage events for a specific user within a date range. Default: last 30 days.
 * Use for per-user usage breakdown within a tenant.
 *
 */
export const getAdminUsageEventsByUser = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUsageEventsByUserData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUsageEventsByUserResponses,
    GetAdminUsageEventsByUserErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/usage-events/by-user",
    ...options,
  });

/**
 * /configs operation on config resource
 *
 * /configs operation on config resource
 */
export const getAdminConfigs = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminConfigsResponses,
    GetAdminConfigsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/configs",
    ...options,
  });

/**
 * Create or upsert a platform config entry by key; if the key already exists its value, description, and sensitivity flag are updated
 *
 * Create or upsert a platform config entry by key; if the key already exists its value, description, and sensitivity flag are updated. Automatically invalidates the FetchConfig cache. Returns the record.
 */
export const postAdminConfigs = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminConfigsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConfigsResponses,
    PostAdminConfigsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/configs",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /agent-executions/:id operation on agent-execution resource
 *
 * /agent-executions/:id operation on agent-execution resource
 */
export const getAdminAgentExecutionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminAgentExecutionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentExecutionsByIdResponses,
    GetAdminAgentExecutionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-executions/{id}",
    ...options,
  });

/**
 * /clinical/client-resource-assignments/:id/restore operation on clinical-client-resource-assignment resource
 *
 * /clinical/client-resource-assignments/:id/restore operation on clinical-client-resource-assignment resource
 */
export const patchAdminClinicalClientResourceAssignmentsByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalClientResourceAssignmentsByIdRestoreData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientResourceAssignmentsByIdRestoreResponses,
    PatchAdminClinicalClientResourceAssignmentsByIdRestoreErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-resource-assignments/{id}/restore",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /threads/:id operation on chat-thread resource
 *
 * /threads/:id operation on chat-thread resource
 */
export const deleteAdminThreadsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminThreadsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminThreadsByIdResponses,
    DeleteAdminThreadsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/{id}",
    ...options,
  });

/**
 * /threads/:id operation on chat-thread resource
 *
 * /threads/:id operation on chat-thread resource
 */
export const getAdminThreadsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminThreadsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminThreadsByIdResponses,
    GetAdminThreadsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/{id}",
    ...options,
  });

/**
 * Update the thread's title or context summary
 *
 * Update the thread's title or context summary. Use :archive/:unarchive for lifecycle state changes and :process_message to add turns.
 */
export const patchAdminThreadsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminThreadsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminThreadsByIdResponses,
    PatchAdminThreadsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Define a new custom entity type for the application (e.g., 'client_goals', 'session')
 *
 * Define a new custom entity type for the application (e.g., 'client_goals', 'session').
 * Slug must not conflict with core types and is limited to 3-50 characters. Max 20 types
 * per application; max 100 field definitions per type. Returns the created CustomEntityType.
 *
 */
export const postAdminIsvCrmEntityTypes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminIsvCrmEntityTypesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminIsvCrmEntityTypesResponses,
    PostAdminIsvCrmEntityTypesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv/crm/entity-types",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/health-metrics operation on clinical-health-metric resource
 *
 * /clinical/health-metrics operation on clinical-health-metric resource
 */
export const getAdminClinicalHealthMetrics = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalHealthMetricsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalHealthMetricsResponses,
    GetAdminClinicalHealthMetricsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/health-metrics",
    ...options,
  });

/**
 * /clinical/health-metrics operation on clinical-health-metric resource
 *
 * /clinical/health-metrics operation on clinical-health-metric resource
 */
export const postAdminClinicalHealthMetrics = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalHealthMetricsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalHealthMetricsResponses,
    PostAdminClinicalHealthMetricsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/health-metrics",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/supplement-templates/catalog/:id operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/catalog/:id operation on clinical-supplement-template resource
 */
export const getAdminClinicalSupplementTemplatesCatalogById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalSupplementTemplatesCatalogByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSupplementTemplatesCatalogByIdResponses,
    GetAdminClinicalSupplementTemplatesCatalogByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/catalog/{id}",
    ...options,
  });

/**
 * /clinical/supplement-templates/catalog/:id operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates/catalog/:id operation on clinical-supplement-template resource
 */
export const patchAdminClinicalSupplementTemplatesCatalogById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalSupplementTemplatesCatalogByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalSupplementTemplatesCatalogByIdResponses,
    PatchAdminClinicalSupplementTemplatesCatalogByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates/catalog/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all members of a specific queue including their role, capacity, and availability
 *
 * List all members of a specific queue including their role, capacity, and availability. Use to find available agents for ticket assignment.
 */
export const getAdminSupportQueueMembersQueueByQueueId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSupportQueueMembersQueueByQueueIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSupportQueueMembersQueueByQueueIdResponses,
    GetAdminSupportQueueMembersQueueByQueueIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/queue-members/queue/{queue_id}",
    ...options,
  });

/**
 * /social/trending/watches/:id operation on trending-watch resource
 *
 * /social/trending/watches/:id operation on trending-watch resource
 */
export const deleteAdminSocialTrendingWatchesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSocialTrendingWatchesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSocialTrendingWatchesByIdResponses,
    DeleteAdminSocialTrendingWatchesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/trending/watches/{id}",
    ...options,
  });

/**
 * /social/trending/watches/:id operation on trending-watch resource
 *
 * /social/trending/watches/:id operation on trending-watch resource
 */
export const getAdminSocialTrendingWatchesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSocialTrendingWatchesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSocialTrendingWatchesByIdResponses,
    GetAdminSocialTrendingWatchesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/trending/watches/{id}",
    ...options,
  });

/**
 * /social/trending/watches/:id operation on trending-watch resource
 *
 * /social/trending/watches/:id operation on trending-watch resource
 */
export const patchAdminSocialTrendingWatchesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSocialTrendingWatchesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialTrendingWatchesByIdResponses,
    PatchAdminSocialTrendingWatchesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/trending/watches/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/email-addresses/:id operation on crm-email-address resource
 *
 * /crm/email-addresses/:id operation on crm-email-address resource
 */
export const deleteAdminCrmEmailAddressesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmEmailAddressesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmEmailAddressesByIdResponses,
    DeleteAdminCrmEmailAddressesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/email-addresses/{id}",
    ...options,
  });

/**
 * /crm/email-addresses/:id operation on crm-email-address resource
 *
 * /crm/email-addresses/:id operation on crm-email-address resource
 */
export const getAdminCrmEmailAddressesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrmEmailAddressesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmEmailAddressesByIdResponses,
    GetAdminCrmEmailAddressesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/email-addresses/{id}",
    ...options,
  });

/**
 * Update an existing email address
 *
 * Update an existing email address. Re-validates email format if changed.
 */
export const patchAdminCrmEmailAddressesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmEmailAddressesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmEmailAddressesByIdResponses,
    PatchAdminCrmEmailAddressesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/email-addresses/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /pipeline-executions/:id/refine operation on pipeline-execution resource
 *
 * /pipeline-executions/:id/refine operation on pipeline-execution resource
 */
export const patchAdminPipelineExecutionsByIdRefine = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPipelineExecutionsByIdRefineData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPipelineExecutionsByIdRefineResponses,
    PatchAdminPipelineExecutionsByIdRefineErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-executions/{id}/refine",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Purchase an add-on for the wallet
 *
 * Purchase an add-on for the wallet
 */
export const patchAdminWalletAddons = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminWalletAddonsData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWalletAddonsResponses,
    PatchAdminWalletAddonsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/wallet/addons",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /pipeline-executions operation on pipeline-execution resource
 *
 * /pipeline-executions operation on pipeline-execution resource
 */
export const getAdminPipelineExecutions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPipelineExecutionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPipelineExecutionsResponses,
    GetAdminPipelineExecutionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-executions",
    ...options,
  });

/**
 * Create a product variant (SKU, price override, option values); enforces max_variants_per_product quota
 *
 * Create a product variant (SKU, price override, option values); enforces max_variants_per_product quota. Returns the created variant.
 */
export const postAdminCatalogProductVariants = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCatalogProductVariantsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCatalogProductVariantsResponses,
    PostAdminCatalogProductVariantsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/product-variants",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Compiles MJML, snapshots to published_body_html, creates TemplateVersion, bumps current_version.
 *
 * Compiles MJML, snapshots to published_body_html, creates TemplateVersion, bumps current_version.
 */
export const patchAdminEmailMarketingTemplatesByIdPublish = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailMarketingTemplatesByIdPublishData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingTemplatesByIdPublishResponses,
    PatchAdminEmailMarketingTemplatesByIdPublishErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/templates/{id}/publish",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/metrics/account/:social_account_id operation on post-metric resource
 *
 * /social/metrics/account/:social_account_id operation on post-metric resource
 */
export const getAdminSocialMetricsAccountBySocialAccountId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSocialMetricsAccountBySocialAccountIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSocialMetricsAccountBySocialAccountIdResponses,
    GetAdminSocialMetricsAccountBySocialAccountIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/metrics/account/{social_account_id}",
    ...options,
  });

/**
 * /messages/:id operation on chat-message resource
 *
 * /messages/:id operation on chat-message resource
 */
export const deleteAdminMessagesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminMessagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminMessagesByIdResponses,
    DeleteAdminMessagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/messages/{id}",
    ...options,
  });

/**
 * /messages/:id operation on chat-message resource
 *
 * /messages/:id operation on chat-message resource
 */
export const getAdminMessagesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminMessagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminMessagesByIdResponses,
    GetAdminMessagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/messages/{id}",
    ...options,
  });

/**
 * Edit a message's content, role, or metadata
 *
 * Edit a message's content, role, or metadata. Re-enqueues vectorization so the embedding stays current with the new content.
 */
export const patchAdminMessagesById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminMessagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminMessagesByIdResponses,
    PatchAdminMessagesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/messages/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /platform-pricing-configs/:id operation on platform-pricing-config resource
 *
 * /platform-pricing-configs/:id operation on platform-pricing-config resource
 */
export const deleteAdminPlatformPricingConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminPlatformPricingConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminPlatformPricingConfigsByIdResponses,
    DeleteAdminPlatformPricingConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/platform-pricing-configs/{id}",
    ...options,
  });

/**
 * /platform-pricing-configs/:id operation on platform-pricing-config resource
 *
 * /platform-pricing-configs/:id operation on platform-pricing-config resource
 */
export const getAdminPlatformPricingConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPlatformPricingConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPlatformPricingConfigsByIdResponses,
    GetAdminPlatformPricingConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/platform-pricing-configs/{id}",
    ...options,
  });

/**
 * /platform-pricing-configs/:id operation on platform-pricing-config resource
 *
 * /platform-pricing-configs/:id operation on platform-pricing-config resource
 */
export const patchAdminPlatformPricingConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPlatformPricingConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPlatformPricingConfigsByIdResponses,
    PatchAdminPlatformPricingConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/platform-pricing-configs/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Permanently delete a tenant and all associated data
 *
 * Permanently delete a tenant and all associated data. Cascades destruction of:
 * storage buckets (including S3/GCS cleanup), workspace memberships, workspace
 * billing accounts, workspaces, applications (which destroy their API keys,
 * transactions, plans, credit packages, and billing accounts), tenant memberships,
 * and all tenant billing accounts. Finally deletes the tenant row. Restricted to
 * the tenant owner or platform admins.
 *
 */
export const deleteAdminTenantsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminTenantsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminTenantsByIdResponses,
    DeleteAdminTenantsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}",
    ...options,
  });

/**
 * Fetch a single tenant by its UUID
 *
 * Fetch a single tenant by its UUID. Returns nil if not found or the actor lacks read access.
 */
export const getAdminTenantsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminTenantsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTenantsByIdResponses,
    GetAdminTenantsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}",
    ...options,
  });

/**
 * Update general tenant settings: name, slug, kind, branding URLs, training price,
 * plan tier, vanity slug, and storage spending cap
 *
 * Update general tenant settings: name, slug, kind, branding URLs, training price,
 * plan tier, vanity slug, and storage spending cap. Re-indexes the tenant in search
 * after update. Use :update_branding for branding-only changes (owner-only policy),
 * :update_auto_top_up_config for billing auto top-up settings, or
 * :transfer_ownership to change the owner.
 *
 */
export const patchAdminTenantsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminTenantsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTenantsByIdResponses,
    PatchAdminTenantsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /case-types operation on case-type resource
 *
 * /case-types operation on case-type resource
 */
export const getAdminCaseTypes = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCaseTypesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCaseTypesResponses,
    GetAdminCaseTypesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-types",
    ...options,
  });

/**
 * /case-types operation on case-type resource
 *
 * /case-types operation on case-type resource
 */
export const postAdminCaseTypes = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCaseTypesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCaseTypesResponses,
    PostAdminCaseTypesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-types",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/field-definitions/:id operation on crm-custom-field-definition resource
 *
 * /crm/field-definitions/:id operation on crm-custom-field-definition resource
 */
export const deleteAdminCrmFieldDefinitionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmFieldDefinitionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmFieldDefinitionsByIdResponses,
    DeleteAdminCrmFieldDefinitionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/field-definitions/{id}",
    ...options,
  });

/**
 * /crm/field-definitions/:id operation on crm-custom-field-definition resource
 *
 * /crm/field-definitions/:id operation on crm-custom-field-definition resource
 */
export const getAdminCrmFieldDefinitionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrmFieldDefinitionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmFieldDefinitionsByIdResponses,
    GetAdminCrmFieldDefinitionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/field-definitions/{id}",
    ...options,
  });

/**
 * Update display metadata and validation rules for an existing custom field
 *
 * Update display metadata and validation rules for an existing custom field. Name and entity_type are immutable after creation.
 */
export const patchAdminCrmFieldDefinitionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmFieldDefinitionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmFieldDefinitionsByIdResponses,
    PatchAdminCrmFieldDefinitionsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/field-definitions/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List shopping lists for a workspace
 *
 * List shopping lists for a workspace
 */
export const getAdminRecipesShoppingListsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesShoppingListsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesShoppingListsWorkspaceByWorkspaceIdResponses,
    GetAdminRecipesShoppingListsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/shopping-lists/workspace/{workspace_id}",
    ...options,
  });

/**
 * /composite-operations operation on composite-operation resource
 *
 * /composite-operations operation on composite-operation resource
 */
export const getAdminCompositeOperations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCompositeOperationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCompositeOperationsResponses,
    GetAdminCompositeOperationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/composite-operations",
    ...options,
  });

/**
 * /composite-operations operation on composite-operation resource
 *
 * /composite-operations operation on composite-operation resource
 */
export const postAdminCompositeOperations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminCompositeOperationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCompositeOperationsResponses,
    PostAdminCompositeOperationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/composite-operations",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List active companies in a workspace with offset pagination
 *
 * List active companies in a workspace with offset pagination. Use instead of :read for workspace-scoped paginated listings.
 */
export const getAdminCrmCompaniesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmCompaniesWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmCompaniesWorkspaceByWorkspaceIdResponses,
    GetAdminCrmCompaniesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/companies/workspace/{workspace_id}",
    ...options,
  });

/**
 * /pipeline-executions/:id/checkpoint operation on pipeline-execution resource
 *
 * /pipeline-executions/:id/checkpoint operation on pipeline-execution resource
 */
export const patchAdminPipelineExecutionsByIdCheckpoint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminPipelineExecutionsByIdCheckpointData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminPipelineExecutionsByIdCheckpointResponses,
    PatchAdminPipelineExecutionsByIdCheckpointErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipeline-executions/{id}/checkpoint",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all websites for a given entity (contact or company).
 *
 * List all websites for a given entity (contact or company).
 */
export const getAdminCrmWebsitesEntityByEntityTypeByEntityId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmWebsitesEntityByEntityTypeByEntityIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmWebsitesEntityByEntityTypeByEntityIdResponses,
    GetAdminCrmWebsitesEntityByEntityTypeByEntityIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/websites/entity/{entity_type}/{entity_id}",
    ...options,
  });

/**
 * Run a similarity search and return matching chunks via the JSON:API endpoint (/ai/chunks/search); internally calls the :search read action and wraps results in a metadata envelope.
 *
 * Run a similarity search and return matching chunks via the JSON:API endpoint (/ai/chunks/search); internally calls the :search read action and wraps results in a metadata envelope.
 */
export const postAdminAiChunksSearch = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAiChunksSearchData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAiChunksSearchResponses,
    PostAdminAiChunksSearchErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/chunks/search",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /storage-files operation on storage-file resource
 *
 * /storage-files operation on storage-file resource
 */
export const getAdminStorageFiles = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminStorageFilesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminStorageFilesResponses,
    GetAdminStorageFilesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-files",
    ...options,
  });

/**
 * Create a StorageFile tracking record; use Storage.request_upload/5 via the facade for the full two-phase upload flow with presigned URLs.
 *
 * Create a StorageFile tracking record; use Storage.request_upload/5 via the facade for the full two-phase upload flow with presigned URLs.
 */
export const postAdminStorageFiles = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminStorageFilesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminStorageFilesResponses,
    PostAdminStorageFilesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-files",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/sessions/by-patient operation on clinical-session resource
 *
 * /clinical/sessions/by-patient operation on clinical-session resource
 */
export const getAdminClinicalSessionsByPatient = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalSessionsByPatientData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSessionsByPatientResponses,
    GetAdminClinicalSessionsByPatientErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/sessions/by-patient",
    ...options,
  });

/**
 * Fetch a single application by its unique slug
 *
 * Fetch a single application by its unique slug. Returns nil if not found. Use :read_current to get the application from the x-application-key header context.
 */
export const getAdminApplicationsBySlugBySlug = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminApplicationsBySlugBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminApplicationsBySlugBySlugResponses,
    GetAdminApplicationsBySlugBySlugErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/by-slug/{slug}",
    ...options,
  });

/**
 * /subscriptions/by-tenant/:tenant_id operation on subscription resource
 *
 * /subscriptions/by-tenant/:tenant_id operation on subscription resource
 */
export const getAdminSubscriptionsByTenantByTenantId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSubscriptionsByTenantByTenantIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSubscriptionsByTenantByTenantIdResponses,
    GetAdminSubscriptionsByTenantByTenantIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/subscriptions/by-tenant/{tenant_id}",
    ...options,
  });

/**
 * Read all buckets including system/processing buckets
 *
 * Read all buckets including system/processing buckets
 */
export const getAdminBucketsAll = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminBucketsAllData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBucketsAllResponses,
    GetAdminBucketsAllErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/buckets/all",
    ...options,
  });

/**
 * Cancel an event, recording an optional cancellation_reason
 *
 * Cancel an event, recording an optional cancellation_reason. Also cancels all pending reminders and propagates cancellation to the linked Booking if present. Publishes EventCancelled event.
 */
export const patchAdminSchedulingEventsByIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSchedulingEventsByIdCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingEventsByIdCancelResponses,
    PatchAdminSchedulingEventsByIdCancelErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/events/{id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /legal-documents/:id operation on legal-document resource
 *
 * /legal-documents/:id operation on legal-document resource
 */
export const deleteAdminLegalDocumentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminLegalDocumentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminLegalDocumentsByIdResponses,
    DeleteAdminLegalDocumentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/legal-documents/{id}",
    ...options,
  });

/**
 * /legal-documents/:id operation on legal-document resource
 *
 * /legal-documents/:id operation on legal-document resource
 */
export const getAdminLegalDocumentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminLegalDocumentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLegalDocumentsByIdResponses,
    GetAdminLegalDocumentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/legal-documents/{id}",
    ...options,
  });

/**
 * Edit draft document content, locale, region, or scheduling fields
 *
 * Edit draft document content, locale, region, or scheduling fields. Automatically sets `published_at` on first activation transition; use :publish / :unpublish for lifecycle transitions.
 */
export const patchAdminLegalDocumentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminLegalDocumentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminLegalDocumentsByIdResponses,
    PatchAdminLegalDocumentsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/legal-documents/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /plans/:id operation on plan resource
 *
 * /plans/:id operation on plan resource
 */
export const deleteAdminPlansById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminPlansByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminPlansByIdResponses,
    DeleteAdminPlansByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plans/{id}",
    ...options,
  });

/**
 * Fetch a single plan by its UUID
 *
 * Fetch a single plan by its UUID. Use when you already know the plan's ID (e.g., from a
 * wallet or subscription record). Use read_by_slug instead when looking up by human-readable
 * identifier. Returns the full plan record including pricing, credits, and storage limits.
 *
 */
export const getAdminPlansById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPlansByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPlansByIdResponses,
    GetAdminPlansByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plans/{id}",
    ...options,
  });

/**
 * Update an existing plan's pricing, credit allocation, or storage limits
 *
 * Update an existing plan's pricing, credit allocation, or storage limits. Use this to adjust
 * plan configuration after launch (e.g., changing monthly price or credit quantity). Changes
 * take effect for new subscriptions; existing subscribers are unaffected until their next renewal.
 *
 * Requires Platform Admin or Application Owner role. The slug and type are immutable after creation.
 *
 */
export const patchAdminPlansById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminPlansByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPlansByIdResponses,
    PatchAdminPlansByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plans/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Soft-archive an event type by setting status to :archived
 *
 * Soft-archive an event type by setting status to :archived. Archived types are excluded from :list. Use instead of deleting to preserve historical event associations.
 */
export const patchAdminSchedulingEventTypesByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSchedulingEventTypesByIdArchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingEventTypesByIdArchiveResponses,
    PatchAdminSchedulingEventTypesByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/event-types/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /legal-acceptances operation on legal-acceptance resource
 *
 * /legal-acceptances operation on legal-acceptance resource
 */
export const getAdminLegalAcceptances = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminLegalAcceptancesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLegalAcceptancesResponses,
    GetAdminLegalAcceptancesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/legal-acceptances",
    ...options,
  });

/**
 * /settlements/:id/mark-held operation on settlement resource
 *
 * /settlements/:id/mark-held operation on settlement resource
 */
export const patchAdminSettlementsByIdMarkHeld = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSettlementsByIdMarkHeldData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSettlementsByIdMarkHeldResponses,
    PatchAdminSettlementsByIdMarkHeldErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlements/{id}/mark-held",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /breach-notification-artifacts operation on breach-notification-artifact resource
 *
 * /breach-notification-artifacts operation on breach-notification-artifact resource
 */
export const getAdminBreachNotificationArtifacts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminBreachNotificationArtifactsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminBreachNotificationArtifactsResponses,
    GetAdminBreachNotificationArtifactsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/breach-notification-artifacts",
    ...options,
  });

/**
 * /breach-notification-artifacts operation on breach-notification-artifact resource
 *
 * /breach-notification-artifacts operation on breach-notification-artifact resource
 */
export const postAdminBreachNotificationArtifacts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminBreachNotificationArtifactsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminBreachNotificationArtifactsResponses,
    PostAdminBreachNotificationArtifactsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/breach-notification-artifacts",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Transition a `:sunset_pending` plan to `:archived`
 *
 * Transition a `:sunset_pending` plan to `:archived`. This is a terminal
 * state. Rejected if any active subscribers remain on the plan; typically
 * called by the sunset-completion worker (Phase 4) after force-migration.
 *
 * Requires Platform Admin or Application Owner role.
 *
 */
export const patchAdminPlansByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPlansByIdArchiveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPlansByIdArchiveResponses,
    PatchAdminPlansByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plans/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Admin triggers password reset email for user
 *
 * Admin triggers password reset email for user
 */
export const patchAdminUsersByIdResetPassword = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminUsersByIdResetPasswordData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminUsersByIdResetPasswordResponses,
    PatchAdminUsersByIdResetPasswordErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/{id}/reset-password",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /ephi-data-flows operation on ephi-data-flow resource
 *
 * /ephi-data-flows operation on ephi-data-flow resource
 */
export const getAdminEphiDataFlows = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminEphiDataFlowsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEphiDataFlowsResponses,
    GetAdminEphiDataFlowsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ephi-data-flows",
    ...options,
  });

/**
 * /ephi-data-flows operation on ephi-data-flow resource
 *
 * /ephi-data-flows operation on ephi-data-flow resource
 */
export const postAdminEphiDataFlows = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminEphiDataFlowsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminEphiDataFlowsResponses,
    PostAdminEphiDataFlowsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ephi-data-flows",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/news-monitors/:id operation on news-monitor resource
 *
 * /crawler/news-monitors/:id operation on news-monitor resource
 */
export const deleteAdminCrawlerNewsMonitorsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrawlerNewsMonitorsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrawlerNewsMonitorsByIdResponses,
    DeleteAdminCrawlerNewsMonitorsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/news-monitors/{id}",
    ...options,
  });

/**
 * /crawler/news-monitors/:id operation on news-monitor resource
 *
 * /crawler/news-monitors/:id operation on news-monitor resource
 */
export const getAdminCrawlerNewsMonitorsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCrawlerNewsMonitorsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerNewsMonitorsByIdResponses,
    GetAdminCrawlerNewsMonitorsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/news-monitors/{id}",
    ...options,
  });

/**
 * /crawler/news-monitors/:id operation on news-monitor resource
 *
 * /crawler/news-monitors/:id operation on news-monitor resource
 */
export const patchAdminCrawlerNewsMonitorsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrawlerNewsMonitorsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrawlerNewsMonitorsByIdResponses,
    PatchAdminCrawlerNewsMonitorsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/news-monitors/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /meeting-transcripts operation on meeting-transcript resource
 *
 * /meeting-transcripts operation on meeting-transcript resource
 */
export const getAdminMeetingTranscripts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminMeetingTranscriptsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminMeetingTranscriptsResponses,
    GetAdminMeetingTranscriptsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/meeting-transcripts",
    ...options,
  });

/**
 * /social/accounts/platform/:platform operation on social-account resource
 *
 * /social/accounts/platform/:platform operation on social-account resource
 */
export const getAdminSocialAccountsPlatformByPlatform = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSocialAccountsPlatformByPlatformData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSocialAccountsPlatformByPlatformResponses,
    GetAdminSocialAccountsPlatformByPlatformErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/accounts/platform/{platform}",
    ...options,
  });

/**
 * Accept a pending invitation using a token and the authenticated actor's identity
 *
 * Accept a pending invitation using a token and the authenticated actor's identity.
 * Validates the token hash and expiry. Creates or upgrades tenant/workspace
 * memberships (highest-privilege-wins). Enqueues SendInvitationAcceptedEmail to
 * notify the inviter asynchronously. Logs an invitation_accepted audit event.
 * Use :accept_by_token for unauthenticated token-only acceptance (e.g. after
 * registration redirect), or :accept_by_user for system-initiated acceptance.
 *
 */
export const patchAdminInvitationsByIdAccept = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvitationsByIdAcceptData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvitationsByIdAcceptResponses,
    PatchAdminInvitationsByIdAcceptErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invitations/{id}/accept",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List feature usage records for a specific tenant.
 *
 * List feature usage records for a specific tenant.
 */
export const getAdminFeatureUsagesByTenantByTenantId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminFeatureUsagesByTenantByTenantIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFeatureUsagesByTenantByTenantIdResponses,
    GetAdminFeatureUsagesByTenantByTenantIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/feature-usages/by-tenant/{tenant_id}",
    ...options,
  });

/**
 * Mark an approved amendment as applied.
 *
 * Mark an approved amendment as applied.
 */
export const patchAdminAmendmentRequestsByIdApply = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminAmendmentRequestsByIdApplyData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminAmendmentRequestsByIdApplyResponses,
    PatchAdminAmendmentRequestsByIdApplyErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/amendment-requests/{id}/apply",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Look up analysis by extraction_result_id
 *
 * Look up analysis by extraction_result_id
 */
export const getAdminExtractionAnalysesByResultByExtractionResultId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminExtractionAnalysesByResultByExtractionResultIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminExtractionAnalysesByResultByExtractionResultIdResponses,
    GetAdminExtractionAnalysesByResultByExtractionResultIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/analyses/by-result/{extraction_result_id}",
    ...options,
  });

/**
 * /consent-records/:id operation on consent-record resource
 *
 * /consent-records/:id operation on consent-record resource
 */
export const getAdminConsentRecordsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminConsentRecordsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminConsentRecordsByIdResponses,
    GetAdminConsentRecordsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/consent-records/{id}",
    ...options,
  });

/**
 * /social/trending/watches operation on trending-watch resource
 *
 * /social/trending/watches operation on trending-watch resource
 */
export const postAdminSocialTrendingWatches = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSocialTrendingWatchesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSocialTrendingWatchesResponses,
    PostAdminSocialTrendingWatchesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/trending/watches",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Pause calendar sync by setting sync_status to :paused
 *
 * Pause calendar sync by setting sync_status to :paused. SyncWorker and CalendarPollWorker skip paused syncs. Use :resume to re-enable.
 */
export const patchAdminSchedulingCalendarSyncsByIdPause = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminSchedulingCalendarSyncsByIdPauseData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminSchedulingCalendarSyncsByIdPauseResponses,
    PatchAdminSchedulingCalendarSyncsByIdPauseErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/calendar-syncs/{id}/pause",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Transition the case state along the state machine.
 *
 * Transition the case state along the state machine.
 */
export const patchAdminCasesByIdTransitionState = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCasesByIdTransitionStateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCasesByIdTransitionStateResponses,
    PatchAdminCasesByIdTransitionStateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cases/{id}/transition-state",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/outbound-emails/:id operation on email-outbound-email resource
 *
 * /email/outbound-emails/:id operation on email-outbound-email resource
 */
export const deleteAdminEmailOutboundEmailsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminEmailOutboundEmailsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminEmailOutboundEmailsByIdResponses,
    DeleteAdminEmailOutboundEmailsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/outbound-emails/{id}",
    ...options,
  });

/**
 * /email/outbound-emails/:id operation on email-outbound-email resource
 *
 * /email/outbound-emails/:id operation on email-outbound-email resource
 */
export const getAdminEmailOutboundEmailsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminEmailOutboundEmailsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminEmailOutboundEmailsByIdResponses,
    GetAdminEmailOutboundEmailsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/outbound-emails/{id}",
    ...options,
  });

/**
 * /email/outbound-emails/:id operation on email-outbound-email resource
 *
 * /email/outbound-emails/:id operation on email-outbound-email resource
 */
export const patchAdminEmailOutboundEmailsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminEmailOutboundEmailsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailOutboundEmailsByIdResponses,
    PatchAdminEmailOutboundEmailsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/outbound-emails/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List training examples with filtering support
 *
 * List training examples with filtering support
 */
export const getAdminTrainingExamples = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminTrainingExamplesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTrainingExamplesResponses,
    GetAdminTrainingExamplesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-examples",
    ...options,
  });

/**
 * Create a single training example (golden example for few-shot learning)
 *
 * Create a single training example (golden example for few-shot learning). The `input_text`
 * is automatically vectorized via AshAi after creation using the configured embedding model,
 * enabling semantic retrieval via `:semantic_search`. Validates that `input_image_ref` is a
 * valid S3 path if provided.
 *
 * Use `:bulk_create` for ingesting multiple examples at once. Returns the created record;
 * the embedding vector is populated asynchronously after the action commits.
 *
 */
export const postAdminTrainingExamples = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminTrainingExamplesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTrainingExamplesResponses,
    PostAdminTrainingExamplesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-examples",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/outbound-emails/:id/schedule operation on email-outbound-email resource
 *
 * /email/outbound-emails/:id/schedule operation on email-outbound-email resource
 */
export const patchAdminEmailOutboundEmailsByIdSchedule = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminEmailOutboundEmailsByIdScheduleData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailOutboundEmailsByIdScheduleResponses,
    PatchAdminEmailOutboundEmailsByIdScheduleErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/outbound-emails/{id}/schedule",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Permanently delete a price list and all its entries
 *
 * Permanently delete a price list and all its entries. Prefer setting status to :expired to preserve history.
 */
export const deleteAdminCatalogPriceListsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCatalogPriceListsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCatalogPriceListsByIdResponses,
    DeleteAdminCatalogPriceListsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/price-lists/{id}",
    ...options,
  });

/**
 * /catalog/price-lists/:id operation on catalog-price-list resource
 *
 * /catalog/price-lists/:id operation on catalog-price-list resource
 */
export const getAdminCatalogPriceListsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminCatalogPriceListsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCatalogPriceListsByIdResponses,
    GetAdminCatalogPriceListsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/price-lists/{id}",
    ...options,
  });

/**
 * Update price list metadata, strategy, or validity period
 *
 * Update price list metadata, strategy, or validity period. Returns the updated price list.
 */
export const patchAdminCatalogPriceListsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCatalogPriceListsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCatalogPriceListsByIdResponses,
    PatchAdminCatalogPriceListsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/price-lists/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /users/auth/magic-link/login operation on user resource
 *
 * /users/auth/magic-link/login operation on user resource
 */
export const postAdminUsersAuthMagicLinkLogin = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminUsersAuthMagicLinkLoginData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminUsersAuthMagicLinkLoginResponses,
    PostAdminUsersAuthMagicLinkLoginErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/auth/magic-link/login",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List only active API keys
 *
 * List only active API keys
 */
export const getAdminApiKeysActive = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminApiKeysActiveData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminApiKeysActiveResponses,
    GetAdminApiKeysActiveErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/api-keys/active",
    ...options,
  });

/**
 * /crm/custom-entities/:entity_id/versions operation on crm-custom-entity-version resource
 *
 * /crm/custom-entities/:entity_id/versions operation on crm-custom-entity-version resource
 */
export const getAdminCrmCustomEntitiesByEntityIdVersions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCrmCustomEntitiesByEntityIdVersionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCrmCustomEntitiesByEntityIdVersionsResponses,
    GetAdminCrmCustomEntitiesByEntityIdVersionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/custom-entities/{entity_id}/versions",
    ...options,
  });

/**
 * /clinical/client-supplements/:id/archive operation on clinical-client-supplement resource
 *
 * /clinical/client-supplements/:id/archive operation on clinical-client-supplement resource
 */
export const patchAdminClinicalClientSupplementsByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalClientSupplementsByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientSupplementsByIdArchiveResponses,
    PatchAdminClinicalClientSupplementsByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-supplements/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Regenerate the presigned download URL for a completed export job
 *
 * Regenerate the presigned download URL for a completed export job. Use when
 * the original URL has expired (1-hour TTL). Only works on jobs with status
 * :complete and a stored file_key. Returns the updated job with a fresh
 * file_url and url_expires_at.
 *
 */
export const patchAdminCrmExportsByIdRefreshUrl = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmExportsByIdRefreshUrlData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmExportsByIdRefreshUrlResponses,
    PatchAdminCrmExportsByIdRefreshUrlErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/exports/{id}/refresh-url",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Enable a disabled schedule so it resumes automatic crawling on its next_run_at.
 *
 * Enable a disabled schedule so it resumes automatic crawling on its next_run_at.
 */
export const patchAdminCrawlerSchedulesByIdEnable = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrawlerSchedulesByIdEnableData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrawlerSchedulesByIdEnableResponses,
    PatchAdminCrawlerSchedulesByIdEnableErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/schedules/{id}/enable",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /post-processing-hooks operation on post-processing-hook resource
 *
 * /post-processing-hooks operation on post-processing-hook resource
 */
export const getAdminPostProcessingHooks = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPostProcessingHooksData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPostProcessingHooksResponses,
    GetAdminPostProcessingHooksErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/post-processing-hooks",
    ...options,
  });

/**
 * /post-processing-hooks operation on post-processing-hook resource
 *
 * /post-processing-hooks operation on post-processing-hook resource
 */
export const postAdminPostProcessingHooks = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminPostProcessingHooksData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPostProcessingHooksResponses,
    PostAdminPostProcessingHooksErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/post-processing-hooks",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Analyze training examples for conflicts, coverage, and quality
 *
 * Analyze training examples for conflicts, coverage, and quality
 */
export const postAdminAgentsByIdAnalyzeTraining = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminAgentsByIdAnalyzeTrainingData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentsByIdAnalyzeTrainingResponses,
    PostAdminAgentsByIdAnalyzeTrainingErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/analyze-training",
    ...options,
  });

/**
 * /clinical/patient-insurance/:id operation on clinical-patient-insurance resource
 *
 * /clinical/patient-insurance/:id operation on clinical-patient-insurance resource
 */
export const deleteAdminClinicalPatientInsuranceById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminClinicalPatientInsuranceByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalPatientInsuranceByIdResponses,
    DeleteAdminClinicalPatientInsuranceByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patient-insurance/{id}",
    ...options,
  });

/**
 * /clinical/patient-insurance/:id operation on clinical-patient-insurance resource
 *
 * /clinical/patient-insurance/:id operation on clinical-patient-insurance resource
 */
export const getAdminClinicalPatientInsuranceById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPatientInsuranceByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPatientInsuranceByIdResponses,
    GetAdminClinicalPatientInsuranceByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patient-insurance/{id}",
    ...options,
  });

/**
 * /clinical/patient-insurance/:id operation on clinical-patient-insurance resource
 *
 * /clinical/patient-insurance/:id operation on clinical-patient-insurance resource
 */
export const patchAdminClinicalPatientInsuranceById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalPatientInsuranceByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPatientInsuranceByIdResponses,
    PatchAdminClinicalPatientInsuranceByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patient-insurance/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a typed relationship edge between two CRM entities
 *
 * Create a typed relationship edge between two CRM entities. Publishes a
 * RelationshipCreated event and enqueues graph projection to Neo4j as side effects.
 * Returns the created Relationship struct.
 *
 */
export const postAdminCrmRelationships = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrmRelationshipsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmRelationshipsResponses,
    PostAdminCrmRelationshipsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/relationships",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /policy-review-schedules/:id/mark-due operation on policy-review-schedule resource
 *
 * /policy-review-schedules/:id/mark-due operation on policy-review-schedule resource
 */
export const patchAdminPolicyReviewSchedulesByIdMarkDue = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminPolicyReviewSchedulesByIdMarkDueData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminPolicyReviewSchedulesByIdMarkDueResponses,
    PatchAdminPolicyReviewSchedulesByIdMarkDueErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/policy-review-schedules/{id}/mark-due",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Aggregated search analytics summary (platform admin only)
 *
 * Aggregated search analytics summary (platform admin only)
 */
export const getAdminSearchAnalyticsSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSearchAnalyticsSummaryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSearchAnalyticsSummaryResponses,
    GetAdminSearchAnalyticsSummaryErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/search/analytics/summary",
    ...options,
  });

/**
 * Create multiple training examples in a single transaction using `Ash.bulk_create`
 *
 * Create multiple training examples in a single transaction using `Ash.bulk_create`. Each
 * example requires `input_text` and `output_json`; `is_confirmed` defaults to false. Embeddings
 * are generated asynchronously by AshAi after each record is inserted.
 *
 * Returns `%{results: [%{id, input_text, output_json, agent_id}]}` on success,
 * or `{:error, errors}` if any record fails validation.
 *
 */
export const postAdminTrainingExamplesBulk = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminTrainingExamplesBulkData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTrainingExamplesBulkResponses,
    PostAdminTrainingExamplesBulkErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-examples/bulk",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Analyze content for SEO optimization against target keywords.
 *
 * Analyze content for SEO optimization against target keywords.
 */
export const postAdminContentSeoEnrich = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminContentSeoEnrichData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminContentSeoEnrichResponses,
    PostAdminContentSeoEnrichErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/content/seo-enrich",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Clone the agent to a new one with a new name
 *
 * Clone the agent to a new one with a new name
 */
export const postAdminAgentsByIdClone = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAgentsByIdCloneData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentsByIdCloneResponses,
    PostAdminAgentsByIdCloneErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/clone",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch a single export job by ID
 *
 * Fetch a single export job by ID. Use to poll job status after creating — returns :complete with file_url when ready, :failed with error message on failure.
 */
export const getAdminCrmExportsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCrmExportsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmExportsByIdResponses,
    GetAdminCrmExportsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/exports/{id}",
    ...options,
  });

/**
 * List usage events for a tenant within a date range
 *
 * List usage events for a tenant within a date range. Default: last 30 days.
 * Use for tenant usage dashboards and ISV cost visibility reports.
 *
 */
export const getAdminUsageEvents = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUsageEventsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUsageEventsResponses,
    GetAdminUsageEventsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/usage-events",
    ...options,
  });

/**
 * List scheduled meals for a meal schedule
 *
 * List scheduled meals for a meal schedule
 */
export const getAdminRecipesScheduledMealsMealScheduleByMealScheduleId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesScheduledMealsMealScheduleByMealScheduleIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesScheduledMealsMealScheduleByMealScheduleIdResponses,
    GetAdminRecipesScheduledMealsMealScheduleByMealScheduleIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/scheduled-meals/meal-schedule/{meal_schedule_id}",
    ...options,
  });

/**
 * /subscriptions operation on subscription resource
 *
 * /subscriptions operation on subscription resource
 */
export const getAdminSubscriptions = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSubscriptionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSubscriptionsResponses,
    GetAdminSubscriptionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/subscriptions",
    ...options,
  });

/**
 * /subscriptions operation on subscription resource
 *
 * /subscriptions operation on subscription resource
 */
export const postAdminSubscriptions = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSubscriptionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSubscriptionsResponses,
    PostAdminSubscriptionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/subscriptions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Send a realistic sample payload to the webhook URL to verify connectivity and signature verification
 *
 * Send a realistic sample payload to the webhook URL to verify connectivity and signature verification. Enqueues a WebhookSender Oban job tagged with `test: true`; returns the WebhookConfig on success.
 */
export const postAdminWebhookConfigsByIdTest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminWebhookConfigsByIdTestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminWebhookConfigsByIdTestResponses,
    PostAdminWebhookConfigsByIdTestErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-configs/{id}/test",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Soft-delete a company by setting deleted_at
 *
 * Soft-delete a company by setting deleted_at. Excluded from standard reads after
 * deletion. Enqueues a Meilisearch deletion job as a side effect.
 *
 */
export const deleteAdminCrmCompaniesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmCompaniesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmCompaniesByIdResponses,
    DeleteAdminCrmCompaniesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/companies/{id}",
    ...options,
  });

/**
 * Fetch a single active company by ID; excludes soft-deleted records.
 *
 * Fetch a single active company by ID; excludes soft-deleted records.
 */
export const getAdminCrmCompaniesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCrmCompaniesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmCompaniesByIdResponses,
    GetAdminCrmCompaniesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/companies/{id}",
    ...options,
  });

/**
 * Update mutable fields on an existing company
 *
 * Update mutable fields on an existing company. Validates custom field definitions
 * and re-indexes the record in Meilisearch. Returns the updated Company struct.
 *
 */
export const patchAdminCrmCompaniesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmCompaniesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmCompaniesByIdResponses,
    PatchAdminCrmCompaniesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/companies/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/browser-sessions/:id/refresh operation on browser-session resource
 *
 * /crawler/browser-sessions/:id/refresh operation on browser-session resource
 */
export const patchAdminCrawlerBrowserSessionsByIdRefresh = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminCrawlerBrowserSessionsByIdRefreshData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminCrawlerBrowserSessionsByIdRefreshResponses,
    PatchAdminCrawlerBrowserSessionsByIdRefreshErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/browser-sessions/{id}/refresh",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /support/canned-responses/:id operation on support-canned-response resource
 *
 * /support/canned-responses/:id operation on support-canned-response resource
 */
export const deleteAdminSupportCannedResponsesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSupportCannedResponsesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSupportCannedResponsesByIdResponses,
    DeleteAdminSupportCannedResponsesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/canned-responses/{id}",
    ...options,
  });

/**
 * Update a canned response's content, category, or shortcut
 *
 * Update a canned response's content, category, or shortcut. Changes take effect immediately for all agents in the workspace.
 */
export const patchAdminSupportCannedResponsesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSupportCannedResponsesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSupportCannedResponsesByIdResponses,
    PatchAdminSupportCannedResponsesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/canned-responses/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Compare two agent versions and return the differences
 *
 * Compare two agent versions and return the differences
 */
export const postAdminAgentVersionComparisons = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminAgentVersionComparisonsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentVersionComparisonsResponses,
    PostAdminAgentVersionComparisonsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agent-version-comparisons",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /storage-recommendations operation on storage-recommendation resource
 *
 * /storage-recommendations operation on storage-recommendation resource
 */
export const getAdminStorageRecommendations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminStorageRecommendationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminStorageRecommendationsResponses,
    GetAdminStorageRecommendationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-recommendations",
    ...options,
  });

/**
 * /clinical/patients/:id/insurance_records operation on clinical-patient-insurance resource
 *
 * /clinical/patients/:id/insurance_records operation on clinical-patient-insurance resource
 */
export const getAdminClinicalPatientsByIdInsuranceRecords = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalPatientsByIdInsuranceRecordsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPatientsByIdInsuranceRecordsResponses,
    GetAdminClinicalPatientsByIdInsuranceRecordsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patients/{id}/insurance_records",
    ...options,
  });

/**
 * /invoices/contacts/:id operation on invoices-contact resource
 *
 * /invoices/contacts/:id operation on invoices-contact resource
 */
export const deleteAdminInvoicesContactsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminInvoicesContactsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminInvoicesContactsByIdResponses,
    DeleteAdminInvoicesContactsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/contacts/{id}",
    ...options,
  });

/**
 * /invoices/contacts/:id operation on invoices-contact resource
 *
 * /invoices/contacts/:id operation on invoices-contact resource
 */
export const getAdminInvoicesContactsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminInvoicesContactsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminInvoicesContactsByIdResponses,
    GetAdminInvoicesContactsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/contacts/{id}",
    ...options,
  });

/**
 * /invoices/contacts/:id operation on invoices-contact resource
 *
 * /invoices/contacts/:id operation on invoices-contact resource
 */
export const patchAdminInvoicesContactsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvoicesContactsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvoicesContactsByIdResponses,
    PatchAdminInvoicesContactsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invoices/contacts/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-supplements operation on clinical-client-supplement resource
 *
 * /clinical/client-supplements operation on clinical-client-supplement resource
 */
export const getAdminClinicalClientSupplements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalClientSupplementsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalClientSupplementsResponses,
    GetAdminClinicalClientSupplementsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-supplements",
    ...options,
  });

/**
 * /clinical/client-supplements operation on clinical-client-supplement resource
 *
 * /clinical/client-supplements operation on clinical-client-supplement resource
 */
export const postAdminClinicalClientSupplements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalClientSupplementsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalClientSupplementsResponses,
    PostAdminClinicalClientSupplementsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-supplements",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Soft-delete a deal by setting deleted_at
 *
 * Soft-delete a deal by setting deleted_at. Excluded from standard reads after
 * deletion. Enqueues a Meilisearch deletion job as a side effect.
 *
 */
export const deleteAdminCrmDealsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminCrmDealsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmDealsByIdResponses,
    DeleteAdminCrmDealsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/deals/{id}",
    ...options,
  });

/**
 * Fetch a single active deal by ID; excludes soft-deleted records.
 *
 * Fetch a single active deal by ID; excludes soft-deleted records.
 */
export const getAdminCrmDealsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCrmDealsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmDealsByIdResponses,
    GetAdminCrmDealsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/deals/{id}",
    ...options,
  });

/**
 * Update deal fields including status, AI scores, and pipeline assignment
 *
 * Update deal fields including status, AI scores, and pipeline assignment. Records
 * changed fields in metadata for downstream event processing (DealWon/DealLost
 * detection). Re-indexes in Meilisearch. Use :move_stage to change pipeline stage atomically.
 *
 */
export const patchAdminCrmDealsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminCrmDealsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmDealsByIdResponses,
    PatchAdminCrmDealsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/deals/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/campaigns operation on social-campaign resource
 *
 * /social/campaigns operation on social-campaign resource
 */
export const getAdminSocialCampaigns = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSocialCampaignsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSocialCampaignsResponses,
    GetAdminSocialCampaignsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/campaigns",
    ...options,
  });

/**
 * /social/campaigns operation on social-campaign resource
 *
 * /social/campaigns operation on social-campaign resource
 */
export const postAdminSocialCampaigns = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminSocialCampaignsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSocialCampaignsResponses,
    PostAdminSocialCampaignsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/campaigns",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/unsubscribers/workspace/:workspace_id operation on email-unsubscriber resource
 *
 * /email-marketing/unsubscribers/workspace/:workspace_id operation on email-unsubscriber resource
 */
export const getAdminEmailMarketingUnsubscribersWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailMarketingUnsubscribersWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailMarketingUnsubscribersWorkspaceByWorkspaceIdResponses,
    GetAdminEmailMarketingUnsubscribersWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/unsubscribers/workspace/{workspace_id}",
    ...options,
  });

/**
 * Merge the provided metadata map into the thread's existing metadata (shallow merge via Map.merge/2)
 *
 * Merge the provided metadata map into the thread's existing metadata (shallow merge via Map.merge/2). Keys present in the input overwrite existing keys; keys not present are preserved. Use :update instead for full replacement.
 */
export const patchAdminThreadsByIdMetadata = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminThreadsByIdMetadataData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminThreadsByIdMetadataResponses,
    PatchAdminThreadsByIdMetadataErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/{id}/metadata",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Re-enqueue a failed or pending delivery for immediate re-dispatch
 *
 * Re-enqueue a failed or pending delivery for immediate re-dispatch. Sets the delivery status to `:retrying` and inserts a new WebhookSender Oban job. Returns the updated WebhookDelivery.
 */
export const postAdminWebhookDeliveriesByIdRetry = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminWebhookDeliveriesByIdRetryData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminWebhookDeliveriesByIdRetryResponses,
    PostAdminWebhookDeliveriesByIdRetryErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/webhook-deliveries/{id}/retry",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/sender-profiles/:id/validate-dns operation on email-marketing-sender-profile resource
 *
 * /email-marketing/sender-profiles/:id/validate-dns operation on email-marketing-sender-profile resource
 */
export const patchAdminEmailMarketingSenderProfilesByIdValidateDns = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminEmailMarketingSenderProfilesByIdValidateDnsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminEmailMarketingSenderProfilesByIdValidateDnsResponses,
    PatchAdminEmailMarketingSenderProfilesByIdValidateDnsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/sender-profiles/{id}/validate-dns",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all tenants the current user belongs to with their roles and permissions
 *
 * List all tenants the current user belongs to with their roles and permissions
 */
export const getAdminUsersMeTenants = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUsersMeTenantsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUsersMeTenantsResponses,
    GetAdminUsersMeTenantsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/me/tenants",
    ...options,
  });

/**
 * List pipelines by workflow type
 *
 * List pipelines by workflow type. Keyset-paginated.
 */
export const getAdminPipelinesByWorkflowType = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPipelinesByWorkflowTypeData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPipelinesByWorkflowTypeResponses,
    GetAdminPipelinesByWorkflowTypeErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipelines/by-workflow-type",
    ...options,
  });

/**
 * Increment used_units by a given amount
 *
 * Increment used_units by a given amount. Used by session completion.
 */
export const patchAdminClinicalInsuranceAuthorizationsByIdIncrement = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalInsuranceAuthorizationsByIdIncrementData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalInsuranceAuthorizationsByIdIncrementResponses,
    PatchAdminClinicalInsuranceAuthorizationsByIdIncrementErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/insurance-authorizations/{id}/increment",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/documents operation on clinical-document resource
 *
 * /clinical/documents operation on clinical-document resource
 */
export const getAdminClinicalDocuments = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminClinicalDocumentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalDocumentsResponses,
    GetAdminClinicalDocumentsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/documents",
    ...options,
  });

/**
 * /clinical/documents operation on clinical-document resource
 *
 * /clinical/documents operation on clinical-document resource
 */
export const postAdminClinicalDocuments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalDocumentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalDocumentsResponses,
    PostAdminClinicalDocumentsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/documents",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Process a payment (Auth + Capture)
 *
 * Process a payment (Auth + Capture)
 */
export const postAdminPayments = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminPaymentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPaymentsResponses,
    PostAdminPaymentsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/payments",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-resources/:id/archive operation on clinical-practice-resource resource
 *
 * /clinical/practice-resources/:id/archive operation on clinical-practice-resource resource
 */
export const patchAdminClinicalPracticeResourcesByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalPracticeResourcesByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPracticeResourcesByIdArchiveResponses,
    PatchAdminClinicalPracticeResourcesByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-resources/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all canned responses for a workspace
 *
 * List all canned responses for a workspace. Use to populate the ticket composer's response picker. Filter by category or shortcut in the caller.
 */
export const getAdminSupportCannedResponsesWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSupportCannedResponsesWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSupportCannedResponsesWorkspaceByWorkspaceIdResponses,
    GetAdminSupportCannedResponsesWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/canned-responses/workspace/{workspace_id}",
    ...options,
  });

/**
 * /recipes/shopping-lists/regenerate operation on recipes-shopping-list resource
 *
 * /recipes/shopping-lists/regenerate operation on recipes-shopping-list resource
 */
export const postAdminRecipesShoppingListsRegenerate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminRecipesShoppingListsRegenerateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRecipesShoppingListsRegenerateResponses,
    PostAdminRecipesShoppingListsRegenerateErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/shopping-lists/regenerate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/accounts/:id/deactivate operation on social-account resource
 *
 * /social/accounts/:id/deactivate operation on social-account resource
 */
export const patchAdminSocialAccountsByIdDeactivate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSocialAccountsByIdDeactivateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialAccountsByIdDeactivateResponses,
    PatchAdminSocialAccountsByIdDeactivateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/accounts/{id}/deactivate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/meal-plans/:id operation on clinical-meal-plan resource
 *
 * /clinical/meal-plans/:id operation on clinical-meal-plan resource
 */
export const getAdminClinicalMealPlansById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalMealPlansByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalMealPlansByIdResponses,
    GetAdminClinicalMealPlansByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/meal-plans/{id}",
    ...options,
  });

/**
 * /clinical/meal-plans/:id operation on clinical-meal-plan resource
 *
 * /clinical/meal-plans/:id operation on clinical-meal-plan resource
 */
export const patchAdminClinicalMealPlansById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalMealPlansByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalMealPlansByIdResponses,
    PatchAdminClinicalMealPlansByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/meal-plans/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /user-profiles operation on user-profile resource
 *
 * /user-profiles operation on user-profile resource
 */
export const getAdminUserProfiles = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminUserProfilesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminUserProfilesResponses,
    GetAdminUserProfilesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/user-profiles",
    ...options,
  });

/**
 * Create a user profile record linked to an existing user
 *
 * Create a user profile record linked to an existing user. Typically called
 * automatically during user registration via CreatePersonalTenant. Callers should
 * use :update for subsequent edits. user_id must correspond to the authenticated
 * actor's own account unless called via a system actor.
 *
 * Returns the created UserProfile record.
 *
 */
export const postAdminUserProfiles = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminUserProfilesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminUserProfilesResponses,
    PostAdminUserProfilesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/user-profiles",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create a new CRM company
 *
 * Create a new CRM company. Validates against workspace company quota and custom
 * field definitions. Triggers Meilisearch indexing as a side effect. Returns the
 * created Company struct.
 *
 */
export const postAdminCrmCompanies = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrmCompaniesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrmCompaniesResponses,
    PostAdminCrmCompaniesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/companies",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Match AI-generated supplement names to Fullscript products
 *
 * Match AI-generated supplement names to Fullscript products
 */
export const postAdminConnectorsFullscriptProductsMatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminConnectorsFullscriptProductsMatchData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsFullscriptProductsMatchResponses,
    PostAdminConnectorsFullscriptProductsMatchErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/fullscript/products/match",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch active legal documents filtered by locale and optional region, used to display the appropriate ToS or Privacy Policy to a user based on their location.
 *
 * Fetch active legal documents filtered by locale and optional region, used to display the appropriate ToS or Privacy Policy to a user based on their location.
 */
export const getAdminLegalDocumentsByLocale = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminLegalDocumentsByLocaleData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLegalDocumentsByLocaleResponses,
    GetAdminLegalDocumentsByLocaleErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/legal-documents/by-locale",
    ...options,
  });

/**
 * Fetch a single booking by ID
 *
 * Fetch a single booking by ID. Returns status, booker info, and linked event_id. Note: verification_token and sync_token are excluded (sensitive? true).
 */
export const getAdminSchedulingBookingsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingBookingsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingBookingsByIdResponses,
    GetAdminSchedulingBookingsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/bookings/{id}",
    ...options,
  });

/**
 * Trigger AI inference on an existing thread without providing new user message content
 *
 * Trigger AI inference on an existing thread without providing new user message content.
 * Uses the last user message as RAG context query. Runs the full pipeline:
 * VectorSearch + GraphLookup + SynthesizeResponse + ChargeTenant.
 * Saves the synthesized assistant reply as a Message and returns the updated Thread.
 * Use this to let the AI proactively continue a conversation.
 *
 */
export const postAdminThreadsByIdComplete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminThreadsByIdCompleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminThreadsByIdCompleteResponses,
    PostAdminThreadsByIdCompleteErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/threads/{id}/complete",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /voice/transcription-jobs/mine operation on transcription-job resource
 *
 * /voice/transcription-jobs/mine operation on transcription-job resource
 */
export const getAdminVoiceTranscriptionJobsMine = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminVoiceTranscriptionJobsMineData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminVoiceTranscriptionJobsMineResponses,
    GetAdminVoiceTranscriptionJobsMineErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/transcription-jobs/mine",
    ...options,
  });

/**
 * /customers operation on customer resource
 *
 * /customers operation on customer resource
 */
export const postAdminCustomers = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCustomersData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCustomersResponses,
    PostAdminCustomersErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/customers",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /connectors/oauth-app-configs/:id operation on oauth-app-config resource
 *
 * /connectors/oauth-app-configs/:id operation on oauth-app-config resource
 */
export const deleteAdminConnectorsOauthAppConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminConnectorsOauthAppConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminConnectorsOauthAppConfigsByIdResponses,
    DeleteAdminConnectorsOauthAppConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/oauth-app-configs/{id}",
    ...options,
  });

/**
 * /connectors/oauth-app-configs/:id operation on oauth-app-config resource
 *
 * /connectors/oauth-app-configs/:id operation on oauth-app-config resource
 */
export const getAdminConnectorsOauthAppConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminConnectorsOauthAppConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminConnectorsOauthAppConfigsByIdResponses,
    GetAdminConnectorsOauthAppConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/oauth-app-configs/{id}",
    ...options,
  });

/**
 * /connectors/oauth-app-configs/:id operation on oauth-app-config resource
 *
 * /connectors/oauth-app-configs/:id operation on oauth-app-config resource
 */
export const patchAdminConnectorsOauthAppConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminConnectorsOauthAppConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminConnectorsOauthAppConfigsByIdResponses,
    PatchAdminConnectorsOauthAppConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/oauth-app-configs/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List active availability rules for a specific user
 *
 * List active availability rules for a specific user. Returns both :recurring and :override type rules. Used by AvailabilityEngine when computing slots for a user.
 */
export const getAdminSchedulingAvailabilityRulesByUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingAvailabilityRulesByUserData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingAvailabilityRulesByUserResponses,
    GetAdminSchedulingAvailabilityRulesByUserErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/availability-rules/by-user",
    ...options,
  });

/**
 * List favorites for a recipe
 *
 * List favorites for a recipe
 */
export const getAdminRecipesFavoritesRecipeByRecipeId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesFavoritesRecipeByRecipeIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesFavoritesRecipeByRecipeIdResponses,
    GetAdminRecipesFavoritesRecipeByRecipeIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/favorites/recipe/{recipe_id}",
    ...options,
  });

/**
 * /clinical/client-resource-assignments operation on clinical-client-resource-assignment resource
 *
 * /clinical/client-resource-assignments operation on clinical-client-resource-assignment resource
 */
export const getAdminClinicalClientResourceAssignments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalClientResourceAssignmentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalClientResourceAssignmentsResponses,
    GetAdminClinicalClientResourceAssignmentsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-resource-assignments",
    ...options,
  });

/**
 * /clinical/client-resource-assignments operation on clinical-client-resource-assignment resource
 *
 * /clinical/client-resource-assignments operation on clinical-client-resource-assignment resource
 */
export const postAdminClinicalClientResourceAssignments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminClinicalClientResourceAssignmentsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminClinicalClientResourceAssignmentsResponses,
    PostAdminClinicalClientResourceAssignmentsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-resource-assignments",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Apply human corrections to extracted field values
 *
 * Apply human corrections to extracted field values. Each correction sets the field's
 * `confidence` to 1.0 and `_source` to `"user"`, overriding the AI-extracted value.
 * Recalculates the `summary` statistics after applying all corrections.
 *
 * Side effects: synchronously updates the parent Document's `verification_status` to
 * `:partially_verified` and `avg_confidence` to the recalculated value via
 * `:update_verification`. This action is the entry point for the active-learning feedback loop.
 *
 * Returns the updated ExtractionResult with corrected fields and recalculated summary.
 *
 */
export const patchAdminExtractionResultsByIdSaveCorrections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminExtractionResultsByIdSaveCorrectionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionResultsByIdSaveCorrectionsResponses,
    PatchAdminExtractionResultsByIdSaveCorrectionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/results/{id}/save-corrections",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crm/pipelines/:id operation on crm-pipeline resource
 *
 * /crm/pipelines/:id operation on crm-pipeline resource
 */
export const deleteAdminCrmPipelinesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmPipelinesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmPipelinesByIdResponses,
    DeleteAdminCrmPipelinesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/pipelines/{id}",
    ...options,
  });

/**
 * /crm/pipelines/:id operation on crm-pipeline resource
 *
 * /crm/pipelines/:id operation on crm-pipeline resource
 */
export const getAdminCrmPipelinesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCrmPipelinesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrmPipelinesByIdResponses,
    GetAdminCrmPipelinesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/pipelines/{id}",
    ...options,
  });

/**
 * Update a pipeline's name or default status
 *
 * Update a pipeline's name or default status. Returns the updated Pipeline struct.
 */
export const patchAdminCrmPipelinesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmPipelinesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmPipelinesByIdResponses,
    PatchAdminCrmPipelinesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/pipelines/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /training-sessions operation on training-session resource
 *
 * /training-sessions operation on training-session resource
 */
export const getAdminTrainingSessions = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminTrainingSessionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTrainingSessionsResponses,
    GetAdminTrainingSessionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-sessions",
    ...options,
  });

/**
 * /training-sessions operation on training-session resource
 *
 * /training-sessions operation on training-session resource
 */
export const postAdminTrainingSessions = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminTrainingSessionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminTrainingSessionsResponses,
    PostAdminTrainingSessionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-sessions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Refresh OAuth credential token.
 *
 * Refresh OAuth credential token.
 */
export const postAdminConnectorsCredentialsByIdRefresh = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminConnectorsCredentialsByIdRefreshData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminConnectorsCredentialsByIdRefreshResponses,
    PostAdminConnectorsCredentialsByIdRefreshErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/connectors/credentials/{id}/refresh",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Batch read usage for all accessible agents
 *
 * Batch read usage for all accessible agents
 */
export const getAdminAgentsUsage = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAgentsUsageData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAgentsUsageResponses,
    GetAdminAgentsUsageErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/usage",
    ...options,
  });

/**
 * /crm/addresses/:id/set-primary operation on crm-address resource
 *
 * /crm/addresses/:id/set-primary operation on crm-address resource
 */
export const patchAdminCrmAddressesByIdSetPrimary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmAddressesByIdSetPrimaryData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmAddressesByIdSetPrimaryResponses,
    PatchAdminCrmAddressesByIdSetPrimaryErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/addresses/{id}/set-primary",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Enqueue a background job to populate file hashes for documents missing them
 *
 * Enqueue a background job to populate file hashes for documents missing them
 */
export const patchAdminWorkspacesByIdPopulateHashes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminWorkspacesByIdPopulateHashesData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminWorkspacesByIdPopulateHashesResponses,
    PatchAdminWorkspacesByIdPopulateHashesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/workspaces/{id}/populate-hashes",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch a single permission preset by its composite ID (e.g., 'workspace:org:admin'); returns the preset with its full permission list or a not-found error.
 *
 * Fetch a single permission preset by its composite ID (e.g., 'workspace:org:admin'); returns the preset with its full permission list or a not-found error.
 */
export const getAdminPermissionsPresetsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminPermissionsPresetsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPermissionsPresetsByIdResponses,
    GetAdminPermissionsPresetsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/permissions/presets/{id}",
    ...options,
  });

/**
 * /social/trending/history operation on trending-snapshot resource
 *
 * /social/trending/history operation on trending-snapshot resource
 */
export const postAdminSocialTrendingHistory = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSocialTrendingHistoryData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSocialTrendingHistoryResponses,
    PostAdminSocialTrendingHistoryErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/trending/history",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /form-generations/:id/cancel operation on form-generation-job resource
 *
 * /form-generations/:id/cancel operation on form-generation-job resource
 */
export const patchAdminFormGenerationsByIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminFormGenerationsByIdCancelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminFormGenerationsByIdCancelResponses,
    PatchAdminFormGenerationsByIdCancelErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-generations/{id}/cancel",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create multiple supplements in a single request (e.g., from a treatment plan)
 *
 * Create multiple supplements in a single request (e.g., from a treatment plan)
 */
export const postAdminClinicalClientSupplementsBulk = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalClientSupplementsBulkData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalClientSupplementsBulkResponses,
    PostAdminClinicalClientSupplementsBulkErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-supplements/bulk",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Create an application-scoped SLA policy defining first_response and resolution targets in minutes
 *
 * Create an application-scoped SLA policy defining first_response and resolution targets in minutes. priority_filter optionally restricts the policy to specific ticket priorities. Name is unique per application.
 */
export const postAdminSupportSlaPolicies = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSupportSlaPoliciesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSupportSlaPoliciesResponses,
    PostAdminSupportSlaPoliciesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/sla-policies",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List published recipes only
 *
 * List published recipes only
 */
export const getAdminRecipesWorkspaceByWorkspaceIdPublished = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesWorkspaceByWorkspaceIdPublishedData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesWorkspaceByWorkspaceIdPublishedResponses,
    GetAdminRecipesWorkspaceByWorkspaceIdPublishedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/workspace/{workspace_id}/published",
    ...options,
  });

/**
 * Validate sample output against agent schema
 *
 * Validate sample output against agent schema
 */
export const postAdminAgentsByIdValidate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminAgentsByIdValidateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAgentsByIdValidateResponses,
    PostAdminAgentsByIdValidateErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/agents/{id}/validate",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Send a test email using this template
 *
 * Send a test email using this template
 */
export const postAdminApplicationsByApplicationIdEmailTemplatesBySlugTest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostAdminApplicationsByApplicationIdEmailTemplatesBySlugTestData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostAdminApplicationsByApplicationIdEmailTemplatesBySlugTestResponses,
    PostAdminApplicationsByApplicationIdEmailTemplatesBySlugTestErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/{application_id}/email-templates/{slug}/test",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/health-metrics/archived operation on clinical-health-metric resource
 *
 * /clinical/health-metrics/archived operation on clinical-health-metric resource
 */
export const getAdminClinicalHealthMetricsArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalHealthMetricsArchivedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalHealthMetricsArchivedResponses,
    GetAdminClinicalHealthMetricsArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/health-metrics/archived",
    ...options,
  });

/**
 * Schedule a plan for sunset
 *
 * Schedule a plan for sunset. At `sunset_at`, remaining subscribers will be
 * force-migrated to `replacement_plan_id` (Phase 4 worker). The plan must be
 * `:active` or `:deprecated`. `sunset_at` must be at least 1 hour in the
 * future. `replacement_plan_id`, when provided, must reference an `:active`
 * Plan in the same Application.
 *
 * Requires Platform Admin or Application Owner role.
 *
 */
export const patchAdminPlansByIdScheduleSunset = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPlansByIdScheduleSunsetData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPlansByIdScheduleSunsetResponses,
    PatchAdminPlansByIdScheduleSunsetErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/plans/{id}/schedule-sunset",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/meal-plans operation on clinical-meal-plan resource
 *
 * /clinical/meal-plans operation on clinical-meal-plan resource
 */
export const getAdminClinicalMealPlans = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminClinicalMealPlansData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalMealPlansResponses,
    GetAdminClinicalMealPlansErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/meal-plans",
    ...options,
  });

/**
 * /clinical/meal-plans operation on clinical-meal-plan resource
 *
 * /clinical/meal-plans operation on clinical-meal-plan resource
 */
export const postAdminClinicalMealPlans = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalMealPlansData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalMealPlansResponses,
    PostAdminClinicalMealPlansErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/meal-plans",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /pipelines/:id operation on pipeline resource
 *
 * /pipelines/:id operation on pipeline resource
 */
export const deleteAdminPipelinesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminPipelinesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminPipelinesByIdResponses,
    DeleteAdminPipelinesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipelines/{id}",
    ...options,
  });

/**
 * /pipelines/:id operation on pipeline resource
 *
 * /pipelines/:id operation on pipeline resource
 */
export const getAdminPipelinesById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPipelinesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPipelinesByIdResponses,
    GetAdminPipelinesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipelines/{id}",
    ...options,
  });

/**
 * Update pipeline metadata or node graph.
 *
 * Update pipeline metadata or node graph.
 */
export const patchAdminPipelinesById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminPipelinesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPipelinesByIdResponses,
    PatchAdminPipelinesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/pipelines/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/patients/:id/supplements operation on clinical-client-supplement resource
 *
 * /clinical/patients/:id/supplements operation on clinical-client-supplement resource
 */
export const getAdminClinicalPatientsByIdSupplements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPatientsByIdSupplementsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPatientsByIdSupplementsResponses,
    GetAdminClinicalPatientsByIdSupplementsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/patients/{id}/supplements",
    ...options,
  });

/**
 * Accept a legal document (Terms of Service, Privacy Policy, BAA, etc.) at
 * a given version
 *
 * Accept a legal document (Terms of Service, Privacy Policy, BAA, etc.) at
 * a given version. Generic over `document_type` — same shape for every legal
 * document the platform tracks. Records a `LegalAcceptance` row (source of
 * truth for SystemMessages) and, when `document_type == :terms_of_service`,
 * auto-grants the `:ai_document_processing` consent record. RFI-C5-R.
 *
 */
export const patchAdminUserProfilesByIdAcceptLegalDocument = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminUserProfilesByIdAcceptLegalDocumentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminUserProfilesByIdAcceptLegalDocumentResponses,
    PatchAdminUserProfilesByIdAcceptLegalDocumentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/user-profiles/{id}/accept-legal-document",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * RD rejects the clinical note.
 *
 * RD rejects the clinical note.
 */
export const patchAdminClinicalNotesByIdReject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalNotesByIdRejectData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalNotesByIdRejectResponses,
    PatchAdminClinicalNotesByIdRejectErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/notes/{id}/reject",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /training-sessions/:id/revert operation on training-session resource
 *
 * /training-sessions/:id/revert operation on training-session resource
 */
export const patchAdminTrainingSessionsByIdRevert = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminTrainingSessionsByIdRevertData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminTrainingSessionsByIdRevertResponses,
    PatchAdminTrainingSessionsByIdRevertErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/training-sessions/{id}/revert",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /isv-pricing-overrides/:id operation on isv-pricing-override resource
 *
 * /isv-pricing-overrides/:id operation on isv-pricing-override resource
 */
export const getAdminIsvPricingOverridesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminIsvPricingOverridesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminIsvPricingOverridesByIdResponses,
    GetAdminIsvPricingOverridesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv-pricing-overrides/{id}",
    ...options,
  });

/**
 * /isv-pricing-overrides/:id operation on isv-pricing-override resource
 *
 * /isv-pricing-overrides/:id operation on isv-pricing-override resource
 */
export const patchAdminIsvPricingOverridesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminIsvPricingOverridesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminIsvPricingOverridesByIdResponses,
    PatchAdminIsvPricingOverridesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv-pricing-overrides/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/posts/:id operation on social-post resource
 *
 * /social/posts/:id operation on social-post resource
 */
export const deleteAdminSocialPostsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminSocialPostsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminSocialPostsByIdResponses,
    DeleteAdminSocialPostsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/posts/{id}",
    ...options,
  });

/**
 * /social/posts/:id operation on social-post resource
 *
 * /social/posts/:id operation on social-post resource
 */
export const getAdminSocialPostsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminSocialPostsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSocialPostsByIdResponses,
    GetAdminSocialPostsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/posts/{id}",
    ...options,
  });

/**
 * /social/posts/:id operation on social-post resource
 *
 * /social/posts/:id operation on social-post resource
 */
export const patchAdminSocialPostsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminSocialPostsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSocialPostsByIdResponses,
    PatchAdminSocialPostsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/posts/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Permanently delete an application and all associated data
 *
 * Permanently delete an application and all associated data. Cascades bulk
 * destruction of: email templates, API keys, transactions, billing plans, credit
 * packages, legal documents, and the application billing account. Finally deletes the application
 * row. Restricted to platform admins or the application owner.
 *
 */
export const deleteAdminApplicationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminApplicationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminApplicationsByIdResponses,
    DeleteAdminApplicationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/{id}",
    ...options,
  });

/**
 * /applications/:id operation on application resource
 *
 * /applications/:id operation on application resource
 */
export const getAdminApplicationsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminApplicationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminApplicationsByIdResponses,
    GetAdminApplicationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/{id}",
    ...options,
  });

/**
 * Update application configuration including branding, email settings, capability
 * flags, workspace mode, execution limits, and compliance tags
 *
 * Update application configuration including branding, email settings, capability
 * flags, workspace mode, execution limits, and compliance tags. Validates
 * enabled_capabilities, their dependency graph, and compliance tag compatibility.
 * Use :allocate_credits for funding the application account.
 *
 */
export const patchAdminApplicationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminApplicationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminApplicationsByIdResponses,
    PatchAdminApplicationsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/applications/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Decline a pending invitation
 *
 * Decline a pending invitation. Only the recipient (authenticated user whose email
 * matches the invitation email) can decline. Sets status to :declined and logs an
 * audit event. A declined invitation cannot be re-accepted; the inviter must create
 * a new invitation if the recipient changes their mind.
 *
 */
export const patchAdminInvitationsByIdDecline = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminInvitationsByIdDeclineData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminInvitationsByIdDeclineResponses,
    PatchAdminInvitationsByIdDeclineErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/invitations/{id}/decline",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/health-metrics/by-type operation on clinical-health-metric resource
 *
 * /clinical/health-metrics/by-type operation on clinical-health-metric resource
 */
export const getAdminClinicalHealthMetricsByType = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalHealthMetricsByTypeData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalHealthMetricsByTypeResponses,
    GetAdminClinicalHealthMetricsByTypeErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/health-metrics/by-type",
    ...options,
  });

/**
 * Public action for users to request a password reset email
 *
 * Public action for users to request a password reset email
 */
export const postAdminUsersAuthPasswordResetRequest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminUsersAuthPasswordResetRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminUsersAuthPasswordResetRequestResponses,
    PostAdminUsersAuthPasswordResetRequestErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/auth/password-reset/request",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Fetch a single active event type by its URL-friendly slug
 *
 * Fetch a single active event type by its URL-friendly slug. Used for public booking page resolution where slug is in the URL. Returns nil if not found or archived.
 */
export const getAdminSchedulingEventTypesBySlug = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminSchedulingEventTypesBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminSchedulingEventTypesBySlugResponses,
    GetAdminSchedulingEventTypesBySlugErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scheduling/event-types/by-slug",
    ...options,
  });

/**
 * /clinical/goal-templates/catalog/:id/permanent operation on clinical-goal-template resource
 *
 * /clinical/goal-templates/catalog/:id/permanent operation on clinical-goal-template resource
 */
export const deleteAdminClinicalGoalTemplatesCatalogByIdPermanent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminClinicalGoalTemplatesCatalogByIdPermanentData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteAdminClinicalGoalTemplatesCatalogByIdPermanentResponses,
    DeleteAdminClinicalGoalTemplatesCatalogByIdPermanentErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/goal-templates/catalog/{id}/permanent",
    ...options,
  });

/**
 * Triggers batch sending for approved emails
 *
 * Triggers batch sending for approved emails
 */
export const postAdminEmailMarketingCampaignsByIdSend = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminEmailMarketingCampaignsByIdSendData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminEmailMarketingCampaignsByIdSendResponses,
    PostAdminEmailMarketingCampaignsByIdSendErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/campaigns/{id}/send",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /scan-results/:id operation on scan-result resource
 *
 * /scan-results/:id operation on scan-result resource
 */
export const getAdminScanResultsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminScanResultsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminScanResultsByIdResponses,
    GetAdminScanResultsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/scan-results/{id}",
    ...options,
  });

/**
 * /recipes/nutrition-summaries/:id operation on recipes-nutrition-summary resource
 *
 * /recipes/nutrition-summaries/:id operation on recipes-nutrition-summary resource
 */
export const getAdminRecipesNutritionSummariesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminRecipesNutritionSummariesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesNutritionSummariesByIdResponses,
    GetAdminRecipesNutritionSummariesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/nutrition-summaries/{id}",
    ...options,
  });

/**
 * Add an agent to a support queue with a role and capacity
 *
 * Add an agent to a support queue with a role and capacity. User is unique per queue (identity :queue_user_unique). Returns the created QueueMember.
 */
export const postAdminSupportQueueMembers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminSupportQueueMembersData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminSupportQueueMembersResponses,
    PostAdminSupportQueueMembersErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/queue-members",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /settlement-statements/:id/mark-paid operation on settlement-statement resource
 *
 * /settlement-statements/:id/mark-paid operation on settlement-statement resource
 */
export const patchAdminSettlementStatementsByIdMarkPaid = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminSettlementStatementsByIdMarkPaidData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminSettlementStatementsByIdMarkPaidResponses,
    PatchAdminSettlementStatementsByIdMarkPaidErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlement-statements/{id}/mark-paid",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /processing-activities operation on processing-activity resource
 *
 * /processing-activities operation on processing-activity resource
 */
export const getAdminProcessingActivities = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminProcessingActivitiesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminProcessingActivitiesResponses,
    GetAdminProcessingActivitiesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/processing-activities",
    ...options,
  });

/**
 * Add a new GDPR Article 30 Record of Processing Activities (ROPA) entry, documenting a processing purpose, the categories of personal data processed, data subjects, recipients, and legal basis for the workspace.
 *
 * Add a new GDPR Article 30 Record of Processing Activities (ROPA) entry, documenting a processing purpose, the categories of personal data processed, data subjects, recipients, and legal basis for the workspace.
 */
export const postAdminProcessingActivities = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminProcessingActivitiesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminProcessingActivitiesResponses,
    PostAdminProcessingActivitiesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/processing-activities",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email-marketing/sender-profiles operation on email-marketing-sender-profile resource
 *
 * /email-marketing/sender-profiles operation on email-marketing-sender-profile resource
 */
export const postAdminEmailMarketingSenderProfiles = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminEmailMarketingSenderProfilesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminEmailMarketingSenderProfilesResponses,
    PostAdminEmailMarketingSenderProfilesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email-marketing/sender-profiles",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /reviews/:id/unclaim operation on review resource
 *
 * /reviews/:id/unclaim operation on review resource
 */
export const patchAdminReviewsByIdUnclaim = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminReviewsByIdUnclaimData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminReviewsByIdUnclaimResponses,
    PatchAdminReviewsByIdUnclaimErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/reviews/{id}/unclaim",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Set this payment method as default for the customer
 *
 * Set this payment method as default for the customer
 */
export const patchAdminPaymentMethodsByIdDefault = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminPaymentMethodsByIdDefaultData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminPaymentMethodsByIdDefaultResponses,
    PatchAdminPaymentMethodsByIdDefaultErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/payment-methods/{id}/default",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Generate presigned URLs for batch document upload
 *
 * Generate presigned URLs for batch document upload
 */
export const getAdminExtractionBatchesByIdUploadUrls = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminExtractionBatchesByIdUploadUrlsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminExtractionBatchesByIdUploadUrlsResponses,
    GetAdminExtractionBatchesByIdUploadUrlsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/batches/{id}/upload-urls",
    ...options,
  });

/**
 * /isv-pricing-overrides operation on isv-pricing-override resource
 *
 * /isv-pricing-overrides operation on isv-pricing-override resource
 */
export const getAdminIsvPricingOverrides = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminIsvPricingOverridesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminIsvPricingOverridesResponses,
    GetAdminIsvPricingOverridesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv-pricing-overrides",
    ...options,
  });

/**
 * /isv-pricing-overrides operation on isv-pricing-override resource
 *
 * /isv-pricing-overrides operation on isv-pricing-override resource
 */
export const postAdminIsvPricingOverrides = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminIsvPricingOverridesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminIsvPricingOverridesResponses,
    PostAdminIsvPricingOverridesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/isv-pricing-overrides",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /compliance/posture operation on compliance-posture resource
 *
 * /compliance/posture operation on compliance-posture resource
 */
export const getAdminCompliancePosture = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCompliancePostureData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCompliancePostureResponses,
    GetAdminCompliancePostureErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance/posture",
    ...options,
  });

/**
 * /settlements/:id/release operation on settlement resource
 *
 * /settlements/:id/release operation on settlement resource
 */
export const patchAdminSettlementsByIdRelease = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSettlementsByIdReleaseData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSettlementsByIdReleaseResponses,
    PatchAdminSettlementsByIdReleaseErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/settlements/{id}/release",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /tenants/:tenant_id/stats operation on tenant-stats resource
 *
 * /tenants/:tenant_id/stats operation on tenant-stats resource
 */
export const getAdminTenantsByTenantIdStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminTenantsByTenantIdStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminTenantsByTenantIdStatsResponses,
    GetAdminTenantsByTenantIdStatsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/tenants/{tenant_id}/stats",
    ...options,
  });

/**
 * /case-pipeline-links operation on case-pipeline-link resource
 *
 * /case-pipeline-links operation on case-pipeline-link resource
 */
export const getAdminCasePipelineLinks = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCasePipelineLinksData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCasePipelineLinksResponses,
    GetAdminCasePipelineLinksErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/case-pipeline-links",
    ...options,
  });

/**
 * List enrichment jobs for a recipe
 *
 * List enrichment jobs for a recipe
 */
export const getAdminRecipesEnrichmentJobsRecipeByRecipeId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminRecipesEnrichmentJobsRecipeByRecipeIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminRecipesEnrichmentJobsRecipeByRecipeIdResponses,
    GetAdminRecipesEnrichmentJobsRecipeByRecipeIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/enrichment-jobs/recipe/{recipe_id}",
    ...options,
  });

/**
 * /crm/sync-configs/:id operation on crm-sync-config resource
 *
 * /crm/sync-configs/:id operation on crm-sync-config resource
 */
export const deleteAdminCrmSyncConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminCrmSyncConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminCrmSyncConfigsByIdResponses,
    DeleteAdminCrmSyncConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/sync-configs/{id}",
    ...options,
  });

/**
 * Update connector sync settings
 *
 * Update connector sync settings. Invalidates the sync config cache for the workspace+connector pair after the update.
 */
export const patchAdminCrmSyncConfigsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmSyncConfigsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmSyncConfigsByIdResponses,
    PatchAdminCrmSyncConfigsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/sync-configs/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/supplement-templates operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates operation on clinical-supplement-template resource
 */
export const getAdminClinicalSupplementTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalSupplementTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalSupplementTemplatesResponses,
    GetAdminClinicalSupplementTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates",
    ...options,
  });

/**
 * /clinical/supplement-templates operation on clinical-supplement-template resource
 *
 * /clinical/supplement-templates operation on clinical-supplement-template resource
 */
export const postAdminClinicalSupplementTemplates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminClinicalSupplementTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminClinicalSupplementTemplatesResponses,
    PostAdminClinicalSupplementTemplatesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/supplement-templates",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Retrieve cost-focused analytics records for the caller's tenant; use for billing reconciliation and cost analysis.
 *
 * Retrieve cost-focused analytics records for the caller's tenant; use for billing reconciliation and cost analysis.
 */
export const getAdminLlmAnalyticsCosts = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminLlmAnalyticsCostsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminLlmAnalyticsCostsResponses,
    GetAdminLlmAnalyticsCostsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/llm-analytics/costs",
    ...options,
  });

/**
 * /form-versions operation on form-version resource
 *
 * /form-versions operation on form-version resource
 */
export const getAdminFormVersions = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminFormVersionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminFormVersionsResponses,
    GetAdminFormVersionsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-versions",
    ...options,
  });

/**
 * /form-versions operation on form-version resource
 *
 * /form-versions operation on form-version resource
 */
export const postAdminFormVersions = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminFormVersionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminFormVersionsResponses,
    PostAdminFormVersionsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/form-versions",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Register or sign in a user via an OAuth/OIDC provider (Google, GitHub, Salesforce,
 * Microsoft)
 *
 * Register or sign in a user via an OAuth/OIDC provider (Google, GitHub, Salesforce,
 * Microsoft). Upserts on the unique_email identity, so existing accounts are updated
 * rather than duplicated. Automatically confirms the email (provider already verified
 * it), generates a random hashed password (OAuth users never use password login), and
 * creates a personal tenant via CreatePersonalTenant. Returns the user with a JWT token
 * in the token field.
 *
 */
export const postAdminUsersAuthRegisterWithOidc = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminUsersAuthRegisterWithOidcData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminUsersAuthRegisterWithOidcResponses,
    PostAdminUsersAuthRegisterWithOidcErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/users/auth/register-with-oidc",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Mark a ticket as resolved, recording resolved_at timestamp
 *
 * Mark a ticket as resolved, recording resolved_at timestamp. Validated by ValidStatusTransition — ticket must be :open or :pending. Triggers SatisfactionSurveyWorker (capability-gated). Publishes TicketResolved event.
 */
export const patchAdminSupportTicketsByIdResolve = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminSupportTicketsByIdResolveData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminSupportTicketsByIdResolveResponses,
    PatchAdminSupportTicketsByIdResolveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/tickets/{id}/resolve",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /cde-scope-reports operation on cde-scope-report resource
 *
 * /cde-scope-reports operation on cde-scope-report resource
 */
export const getAdminCdeScopeReports = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCdeScopeReportsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCdeScopeReportsResponses,
    GetAdminCdeScopeReportsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cde-scope-reports",
    ...options,
  });

/**
 * Generate a PCI-DSS Cardholder Data Environment scope report for a workspace, classifying it as in-scope, out-of-scope, or connected based on ScanResult data
 *
 * Generate a PCI-DSS Cardholder Data Environment scope report for a workspace, classifying it as in-scope, out-of-scope, or connected based on ScanResult data. Sets `generated_at` automatically.
 */
export const postAdminCdeScopeReports = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCdeScopeReportsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCdeScopeReportsResponses,
    PostAdminCdeScopeReportsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/cde-scope-reports",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all catalog views in a workspace
 *
 * List all catalog views in a workspace. Returns a paginated list including draft and active views.
 */
export const getAdminCatalogViewsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminCatalogViewsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminCatalogViewsWorkspaceByWorkspaceIdResponses,
    GetAdminCatalogViewsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/catalog/views/workspace/{workspace_id}",
    ...options,
  });

/**
 * Replace the tags list on a file
 *
 * Replace the tags list on a file. Returns the updated file.
 */
export const patchAdminStorageFilesByIdTag = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminStorageFilesByIdTagData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminStorageFilesByIdTagResponses,
    PatchAdminStorageFilesByIdTagErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/storage-files/{id}/tag",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Mark this email address as the primary for its entity, clearing any existing primary.
 *
 * Mark this email address as the primary for its entity, clearing any existing primary.
 */
export const patchAdminCrmEmailAddressesByIdSetPrimary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminCrmEmailAddressesByIdSetPrimaryData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminCrmEmailAddressesByIdSetPrimaryResponses,
    PatchAdminCrmEmailAddressesByIdSetPrimaryErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crm/email-addresses/{id}/set-primary",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /ai/conversations operation on chat-conversation resource
 *
 * /ai/conversations operation on chat-conversation resource
 */
export const getAdminAiConversations = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminAiConversationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminAiConversationsResponses,
    GetAdminAiConversationsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/conversations",
    ...options,
  });

/**
 * Start a new AI conversation session with optional structured context data (e.g., prediction results to discuss)
 *
 * Start a new AI conversation session with optional structured context data (e.g., prediction results to discuss). The `user_id`, `tenant_id`, and `workspace_id` are automatically set from the actor; any supplied values are overridden.
 */
export const postAdminAiConversations = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAiConversationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAiConversationsResponses,
    PostAdminAiConversationsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/conversations",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /recipes/tags/:id operation on recipes-tag resource
 *
 * /recipes/tags/:id operation on recipes-tag resource
 */
export const deleteAdminRecipesTagsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminRecipesTagsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteAdminRecipesTagsByIdResponses,
    DeleteAdminRecipesTagsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/tags/{id}",
    ...options,
  });

/**
 * /recipes/tags/:id operation on recipes-tag resource
 *
 * /recipes/tags/:id operation on recipes-tag resource
 */
export const getAdminRecipesTagsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminRecipesTagsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRecipesTagsByIdResponses,
    GetAdminRecipesTagsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/tags/{id}",
    ...options,
  });

/**
 * /recipes/tags/:id operation on recipes-tag resource
 *
 * /recipes/tags/:id operation on recipes-tag resource
 */
export const patchAdminRecipesTagsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdminRecipesTagsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminRecipesTagsByIdResponses,
    PatchAdminRecipesTagsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/recipes/tags/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * Step 2 of 2 in the two-step upload flow
 *
 * Step 2 of 2 in the two-step upload flow. Call this after the client has PUT the file to the
 * presigned URL returned by `:begin_upload`. Performs a second credit check (Layer 2 of the
 * three-layer credit defense) before enqueueing the processing job.
 *
 * Side effects: enqueues `ProcessDocument` (or `ProcessAudio` for audio files) Oban job.
 * If credits are insufficient at this point, the action fails — the document remains in
 * `:queued` status and no job is created.
 *
 * Returns the updated document struct.
 *
 */
export const patchAdminExtractionDocumentsByIdFinishUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminExtractionDocumentsByIdFinishUploadData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminExtractionDocumentsByIdFinishUploadResponses,
    PatchAdminExtractionDocumentsByIdFinishUploadErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/extraction/documents/{id}/finish-upload",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-tools/:id operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/:id operation on clinical-practice-tool resource
 */
export const getAdminClinicalPracticeToolsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalPracticeToolsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeToolsByIdResponses,
    GetAdminClinicalPracticeToolsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/{id}",
    ...options,
  });

/**
 * /clinical/practice-tools/:id operation on clinical-practice-tool resource
 *
 * /clinical/practice-tools/:id operation on clinical-practice-tool resource
 */
export const patchAdminClinicalPracticeToolsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalPracticeToolsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalPracticeToolsByIdResponses,
    PatchAdminClinicalPracticeToolsByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /meeting-action-items operation on meeting-action-item resource
 *
 * /meeting-action-items operation on meeting-action-item resource
 */
export const getAdminMeetingActionItems = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminMeetingActionItemsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminMeetingActionItemsResponses,
    GetAdminMeetingActionItemsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/meeting-action-items",
    ...options,
  });

/**
 * /clinical/deliveries/:id operation on clinical-delivery resource
 *
 * /clinical/deliveries/:id operation on clinical-delivery resource
 */
export const getAdminClinicalDeliveriesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalDeliveriesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalDeliveriesByIdResponses,
    GetAdminClinicalDeliveriesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/deliveries/{id}",
    ...options,
  });

/**
 * /clinical/deliveries/:id operation on clinical-delivery resource
 *
 * /clinical/deliveries/:id operation on clinical-delivery resource
 */
export const patchAdminClinicalDeliveriesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchAdminClinicalDeliveriesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalDeliveriesByIdResponses,
    PatchAdminClinicalDeliveriesByIdErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/deliveries/{id}",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * List all sync configurations for a workspace, one per connector instance
 *
 * List all sync configurations for a workspace, one per connector instance. Use to audit which connectors have sync enabled and their current status.
 */
export const getAdminSupportSyncConfigsWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSupportSyncConfigsWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSupportSyncConfigsWorkspaceByWorkspaceIdResponses,
    GetAdminSupportSyncConfigsWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/support/sync-configs/workspace/{workspace_id}",
    ...options,
  });

/**
 * /platform-tones operation on platform-tone resource
 *
 * /platform-tones operation on platform-tone resource
 */
export const getAdminPlatformTones = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminPlatformTonesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminPlatformTonesResponses,
    GetAdminPlatformTonesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/platform-tones",
    ...options,
  });

/**
 * /platform-tones operation on platform-tone resource
 *
 * /platform-tones operation on platform-tone resource
 */
export const postAdminPlatformTones = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminPlatformTonesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminPlatformTonesResponses,
    PostAdminPlatformTonesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/platform-tones",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /social/posts/account/:social_account_id operation on social-post resource
 *
 * /social/posts/account/:social_account_id operation on social-post resource
 */
export const getAdminSocialPostsAccountBySocialAccountId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminSocialPostsAccountBySocialAccountIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminSocialPostsAccountBySocialAccountIdResponses,
    GetAdminSocialPostsAccountBySocialAccountIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/social/posts/account/{social_account_id}",
    ...options,
  });

/**
 * /retention-policies operation on retention-policy resource
 *
 * /retention-policies operation on retention-policy resource
 */
export const getAdminRetentionPolicies = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminRetentionPoliciesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRetentionPoliciesResponses,
    GetAdminRetentionPoliciesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/retention-policies",
    ...options,
  });

/**
 * Define a data retention rule for a specific data category in a workspace
 *
 * Define a data retention rule for a specific data category in a workspace. Each workspace/data_type pair is unique — the RetentionEnforcementWorker runs daily to delete, archive, or anonymize data older than `retention_days`.
 */
export const postAdminRetentionPolicies = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminRetentionPoliciesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRetentionPoliciesResponses,
    PostAdminRetentionPoliciesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/retention-policies",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /crawler/schedules operation on crawler-schedule resource
 *
 * /crawler/schedules operation on crawler-schedule resource
 */
export const getAdminCrawlerSchedules = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminCrawlerSchedulesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminCrawlerSchedulesResponses,
    GetAdminCrawlerSchedulesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/schedules",
    ...options,
  });

/**
 * Create a recurring crawl schedule for a URL; sets frequency, cron expression, and notification preferences
 *
 * Create a recurring crawl schedule for a URL; sets frequency, cron expression, and notification preferences. Returns the created schedule.
 */
export const postAdminCrawlerSchedules = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminCrawlerSchedulesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminCrawlerSchedulesResponses,
    PostAdminCrawlerSchedulesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/crawler/schedules",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /email/inbound/received/workspace/:workspace_id operation on email-inbound-email resource
 *
 * /email/inbound/received/workspace/:workspace_id operation on email-inbound-email resource
 */
export const getAdminEmailInboundReceivedWorkspaceByWorkspaceId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminEmailInboundReceivedWorkspaceByWorkspaceIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminEmailInboundReceivedWorkspaceByWorkspaceIdResponses,
    GetAdminEmailInboundReceivedWorkspaceByWorkspaceIdErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/email/inbound/received/workspace/{workspace_id}",
    ...options,
  });

/**
 * Generate a 1024-dim vector embedding for the given text via the LlmTriage sidecar; validates workspace membership, estimates token cost, charges credits, and returns the embedding with usage stats.
 *
 * Generate a 1024-dim vector embedding for the given text via the LlmTriage sidecar; validates workspace membership, estimates token cost, charges credits, and returns the embedding with usage stats.
 */
export const postAdminAiEmbed = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminAiEmbedData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminAiEmbedResponses,
    PostAdminAiEmbedErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/ai/embed",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /review-queue-memberships operation on review-queue-membership resource
 *
 * /review-queue-memberships operation on review-queue-membership resource
 */
export const getAdminReviewQueueMemberships = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminReviewQueueMembershipsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminReviewQueueMembershipsResponses,
    GetAdminReviewQueueMembershipsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/review-queue-memberships",
    ...options,
  });

/**
 * /review-queue-memberships operation on review-queue-membership resource
 *
 * /review-queue-memberships operation on review-queue-membership resource
 */
export const postAdminReviewQueueMemberships = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminReviewQueueMembershipsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminReviewQueueMembershipsResponses,
    PostAdminReviewQueueMembershipsErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/review-queue-memberships",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/practice-tools/categories/catalog operation on clinical-practice-tool-category resource
 *
 * /clinical/practice-tools/categories/catalog operation on clinical-practice-tool-category resource
 */
export const getAdminClinicalPracticeToolsCategoriesCatalog = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAdminClinicalPracticeToolsCategoriesCatalogData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetAdminClinicalPracticeToolsCategoriesCatalogResponses,
    GetAdminClinicalPracticeToolsCategoriesCatalogErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/practice-tools/categories/catalog",
    ...options,
  });

/**
 * /clinical/client-medications/:id/archive operation on clinical-client-medication resource
 *
 * /clinical/client-medications/:id/archive operation on clinical-client-medication resource
 */
export const patchAdminClinicalClientMedicationsByIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchAdminClinicalClientMedicationsByIdArchiveData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).patch<
    PatchAdminClinicalClientMedicationsByIdArchiveResponses,
    PatchAdminClinicalClientMedicationsByIdArchiveErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-medications/{id}/archive",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /roles operation on role resource
 *
 * /roles operation on role resource
 */
export const getAdminRoles = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminRolesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminRolesResponses,
    GetAdminRolesErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/roles",
    ...options,
  });

/**
 * Create a new role (permission bundle); creates a system default if application_id is nil, or an ISV application role if application_id is supplied
 *
 * Create a new role (permission bundle); creates a system default if application_id is nil, or an ISV application role if application_id is supplied. Emits a RoleCreated audit event. Returns the created role.
 */
export const postAdminRoles = <ThrowOnError extends boolean = false>(
  options: Options<PostAdminRolesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminRolesResponses,
    PostAdminRolesErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/roles",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /clinical/client-medications/archived operation on clinical-client-medication resource
 *
 * /clinical/client-medications/archived operation on clinical-client-medication resource
 */
export const getAdminClinicalClientMedicationsArchived = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminClinicalClientMedicationsArchivedData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminClinicalClientMedicationsArchivedResponses,
    GetAdminClinicalClientMedicationsArchivedErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/clinical/client-medications/archived",
    ...options,
  });

/**
 * Clone a platform template for an application
 *
 * Clone a platform template for an application. Creates a new record with the same content, scoped to the target application. Original template is preserved.
 */
export const postAdminComplianceDocumentTemplatesClone = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostAdminComplianceDocumentTemplatesCloneData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostAdminComplianceDocumentTemplatesCloneResponses,
    PostAdminComplianceDocumentTemplatesCloneErrors,
    ThrowOnError
  >({
    querySerializer: { parameters: { fields: { object: { style: "form" } } } },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/compliance-document-templates/clone",
    ...options,
    headers: {
      "Content-Type": "application/vnd.api+json",
      ...options.headers,
    },
  });

/**
 * /voice/recordings operation on voice-recording resource
 *
 * /voice/recordings operation on voice-recording resource
 */
export const getAdminVoiceRecordings = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminVoiceRecordingsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAdminVoiceRecordingsResponses,
    GetAdminVoiceRecordingsErrors,
    ThrowOnError
  >({
    querySerializer: {
      parameters: {
        filter: { object: { style: "form" } },
        page: { object: { style: "form" } },
        fields: { object: { style: "form" } },
      },
    },
    security: [{ scheme: "bearer", type: "http" }],
    url: "/admin/voice/recordings",
    ...options,
  });
